function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9aa3"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9aa3"] = parcelRequire;
}
parcelRequire.register("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";
parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRequire.register("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRequire.register("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});



parcelRequire.register("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_createPortal", () => $0b2e6adb871a3b94$export$2577ef5d2565d52f, (v) => $0b2e6adb871a3b94$export$2577ef5d2565d52f = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$2577ef5d2565d52f;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error($0b2e6adb871a3b94$var$y(227));
var $0b2e6adb871a3b94$var$ba = new Set, $0b2e6adb871a3b94$var$ca = {};
function $0b2e6adb871a3b94$var$da(a, b) {
    $0b2e6adb871a3b94$var$ea(a, b);
    $0b2e6adb871a3b94$var$ea(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ea(a, b) {
    $0b2e6adb871a3b94$var$ca[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$ba.add(b[a]);
}
var $0b2e6adb871a3b94$var$fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$ia = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ja = {}, $0b2e6adb871a3b94$var$ka = {};
function $0b2e6adb871a3b94$var$la(a) {
    if ($0b2e6adb871a3b94$var$ia.call($0b2e6adb871a3b94$var$ka, a)) return !0;
    if ($0b2e6adb871a3b94$var$ia.call($0b2e6adb871a3b94$var$ja, a)) return !1;
    if ($0b2e6adb871a3b94$var$ha.test(a)) return $0b2e6adb871a3b94$var$ka[a] = !0;
    $0b2e6adb871a3b94$var$ja[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$oa = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$oa, $0b2e6adb871a3b94$var$pa);
    $0b2e6adb871a3b94$var$D[b] = new $0b2e6adb871a3b94$var$B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$D.xlinkHref = new $0b2e6adb871a3b94$var$B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$D[a] = new $0b2e6adb871a3b94$var$B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$D.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($0b2e6adb871a3b94$var$na(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var $0b2e6adb871a3b94$var$ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$sa = 60103, $0b2e6adb871a3b94$var$ta = 60106, $0b2e6adb871a3b94$var$ua = 60107, $0b2e6adb871a3b94$var$wa = 60108, $0b2e6adb871a3b94$var$xa = 60114, $0b2e6adb871a3b94$var$ya = 60109, $0b2e6adb871a3b94$var$za = 60110, $0b2e6adb871a3b94$var$Aa = 60112, $0b2e6adb871a3b94$var$Ba = 60113, $0b2e6adb871a3b94$var$Ca = 60120, $0b2e6adb871a3b94$var$Da = 60115, $0b2e6adb871a3b94$var$Ea = 60116, $0b2e6adb871a3b94$var$Fa = 60121, $0b2e6adb871a3b94$var$Ga = 60128, $0b2e6adb871a3b94$var$Ha = 60129, $0b2e6adb871a3b94$var$Ia = 60130, $0b2e6adb871a3b94$var$Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $0b2e6adb871a3b94$var$E = Symbol.for;
    $0b2e6adb871a3b94$var$sa = $0b2e6adb871a3b94$var$E("react.element");
    $0b2e6adb871a3b94$var$ta = $0b2e6adb871a3b94$var$E("react.portal");
    $0b2e6adb871a3b94$var$ua = $0b2e6adb871a3b94$var$E("react.fragment");
    $0b2e6adb871a3b94$var$wa = $0b2e6adb871a3b94$var$E("react.strict_mode");
    $0b2e6adb871a3b94$var$xa = $0b2e6adb871a3b94$var$E("react.profiler");
    $0b2e6adb871a3b94$var$ya = $0b2e6adb871a3b94$var$E("react.provider");
    $0b2e6adb871a3b94$var$za = $0b2e6adb871a3b94$var$E("react.context");
    $0b2e6adb871a3b94$var$Aa = $0b2e6adb871a3b94$var$E("react.forward_ref");
    $0b2e6adb871a3b94$var$Ba = $0b2e6adb871a3b94$var$E("react.suspense");
    $0b2e6adb871a3b94$var$Ca = $0b2e6adb871a3b94$var$E("react.suspense_list");
    $0b2e6adb871a3b94$var$Da = $0b2e6adb871a3b94$var$E("react.memo");
    $0b2e6adb871a3b94$var$Ea = $0b2e6adb871a3b94$var$E("react.lazy");
    $0b2e6adb871a3b94$var$Fa = $0b2e6adb871a3b94$var$E("react.block");
    $0b2e6adb871a3b94$var$E("react.scope");
    $0b2e6adb871a3b94$var$Ga = $0b2e6adb871a3b94$var$E("react.opaque.id");
    $0b2e6adb871a3b94$var$Ha = $0b2e6adb871a3b94$var$E("react.debug_trace_mode");
    $0b2e6adb871a3b94$var$Ia = $0b2e6adb871a3b94$var$E("react.offscreen");
    $0b2e6adb871a3b94$var$Ja = $0b2e6adb871a3b94$var$E("react.legacy_hidden");
}
var $0b2e6adb871a3b94$var$Ka = "function" === typeof Symbol && Symbol.iterator;
function $0b2e6adb871a3b94$var$La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ka && a[$0b2e6adb871a3b94$var$Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$Ma;
function $0b2e6adb871a3b94$var$Na(a) {
    if (void 0 === $0b2e6adb871a3b94$var$Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$Ma = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$Ma + a;
}
var $0b2e6adb871a3b94$var$Oa = !1;
function $0b2e6adb871a3b94$var$Pa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Oa) return "";
    $0b2e6adb871a3b94$var$Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Na(a) : "";
}
function $0b2e6adb871a3b94$var$Qa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Na(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Na("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Na("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Pa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Pa(a.type.render, !1), a;
        case 22:
            return a = $0b2e6adb871a3b94$var$Pa(a.type._render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Pa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ua:
            return "Fragment";
        case $0b2e6adb871a3b94$var$ta:
            return "Portal";
        case $0b2e6adb871a3b94$var$xa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$wa:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ba:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$za:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$ya:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $0b2e6adb871a3b94$var$Da:
            return $0b2e6adb871a3b94$var$Ra(a.type);
        case $0b2e6adb871a3b94$var$Fa:
            return $0b2e6adb871a3b94$var$Ra(a._render);
        case $0b2e6adb871a3b94$var$Ea:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$$a(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$qa(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    $0b2e6adb871a3b94$var$$a(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$bb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$bb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $0b2e6adb871a3b94$var$db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $0b2e6adb871a3b94$var$eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = $0b2e6adb871a3b94$var$db(b.children)) a.children = b;
    return a;
}
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error($0b2e6adb871a3b94$var$y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $0b2e6adb871a3b94$var$kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $0b2e6adb871a3b94$var$lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$nb, $0b2e6adb871a3b94$var$ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $0b2e6adb871a3b94$var$kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$nb = $0b2e6adb871a3b94$var$nb || document.createElement("div");
        $0b2e6adb871a3b94$var$nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$qb).forEach(function(a) {
    $0b2e6adb871a3b94$var$rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$qb[b] = $0b2e6adb871a3b94$var$qb[a];
    });
});
function $0b2e6adb871a3b94$var$sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$qb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$qb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$y(62));
    }
}
function $0b2e6adb871a3b94$var$wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$y(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function $0b2e6adb871a3b94$var$Ib() {}
var $0b2e6adb871a3b94$var$Jb = $0b2e6adb871a3b94$var$Gb, $0b2e6adb871a3b94$var$Kb = !1, $0b2e6adb871a3b94$var$Lb = !1;
function $0b2e6adb871a3b94$var$Mb() {
    if (null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Ib(), $0b2e6adb871a3b94$var$Fb();
}
function $0b2e6adb871a3b94$var$Nb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Lb) return a(b, c);
    $0b2e6adb871a3b94$var$Lb = !0;
    try {
        return $0b2e6adb871a3b94$var$Jb(a, b, c);
    } finally{
        $0b2e6adb871a3b94$var$Lb = !1, $0b2e6adb871a3b94$var$Mb();
    }
}
function $0b2e6adb871a3b94$var$Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$y(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Pb = !1;
if ($0b2e6adb871a3b94$var$fa) try {
    var $0b2e6adb871a3b94$var$Qb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Qb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Pb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Qb, $0b2e6adb871a3b94$var$Qb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Qb, $0b2e6adb871a3b94$var$Qb);
} catch (a) {
    $0b2e6adb871a3b94$var$Pb = !1;
}
function $0b2e6adb871a3b94$var$Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $0b2e6adb871a3b94$var$Sb = !1, $0b2e6adb871a3b94$var$Tb = null, $0b2e6adb871a3b94$var$Ub = !1, $0b2e6adb871a3b94$var$Vb = null, $0b2e6adb871a3b94$var$Wb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Sb = !0;
        $0b2e6adb871a3b94$var$Tb = a;
    }
};
function $0b2e6adb871a3b94$var$Xb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Sb = !1;
    $0b2e6adb871a3b94$var$Tb = null;
    $0b2e6adb871a3b94$var$Rb.apply($0b2e6adb871a3b94$var$Wb, arguments);
}
function $0b2e6adb871a3b94$var$Yb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Xb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Sb) {
        if ($0b2e6adb871a3b94$var$Sb) {
            var l = $0b2e6adb871a3b94$var$Tb;
            $0b2e6adb871a3b94$var$Sb = !1;
            $0b2e6adb871a3b94$var$Tb = null;
        } else throw Error($0b2e6adb871a3b94$var$y(198));
        $0b2e6adb871a3b94$var$Ub || ($0b2e6adb871a3b94$var$Ub = !0, $0b2e6adb871a3b94$var$Vb = l);
    }
}
function $0b2e6adb871a3b94$var$Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$ac(a) {
    if ($0b2e6adb871a3b94$var$Zb(a) !== a) throw Error($0b2e6adb871a3b94$var$y(188));
}
function $0b2e6adb871a3b94$var$bc(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Zb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$ac(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$ac(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$y(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$y(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$cc(a) {
    a = $0b2e6adb871a3b94$var$bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function $0b2e6adb871a3b94$var$dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var $0b2e6adb871a3b94$var$ec, $0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$gc, $0b2e6adb871a3b94$var$hc, $0b2e6adb871a3b94$var$ic = !1, $0b2e6adb871a3b94$var$jc = [], $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null, $0b2e6adb871a3b94$var$mc = null, $0b2e6adb871a3b94$var$nc = new Map, $0b2e6adb871a3b94$var$oc = new Map, $0b2e6adb871a3b94$var$pc = [], $0b2e6adb871a3b94$var$qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function $0b2e6adb871a3b94$var$sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$kc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$lc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$mc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$oc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = $0b2e6adb871a3b94$var$rc(b, c, d, e, f), null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$kc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$lc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$mc = $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$nc.set(f, $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$oc.set(f, $0b2e6adb871a3b94$var$tc($0b2e6adb871a3b94$var$oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$vc(a) {
    var b = $0b2e6adb871a3b94$var$wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$$b(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            $0b2e6adb871a3b94$var$gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$zc(a, b, c) {
    $0b2e6adb871a3b94$var$xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$Ac() {
    for($0b2e6adb871a3b94$var$ic = !1; 0 < $0b2e6adb871a3b94$var$jc.length;){
        var a = $0b2e6adb871a3b94$var$jc[0];
        if (null !== a.blockedOn) {
            a = $0b2e6adb871a3b94$var$Cb(a.blockedOn);
            null !== a && $0b2e6adb871a3b94$var$ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = $0b2e6adb871a3b94$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && $0b2e6adb871a3b94$var$jc.shift();
    }
    null !== $0b2e6adb871a3b94$var$kc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$kc) && ($0b2e6adb871a3b94$var$kc = null);
    null !== $0b2e6adb871a3b94$var$lc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$lc) && ($0b2e6adb871a3b94$var$lc = null);
    null !== $0b2e6adb871a3b94$var$mc && $0b2e6adb871a3b94$var$xc($0b2e6adb871a3b94$var$mc) && ($0b2e6adb871a3b94$var$mc = null);
    $0b2e6adb871a3b94$var$nc.forEach($0b2e6adb871a3b94$var$zc);
    $0b2e6adb871a3b94$var$oc.forEach($0b2e6adb871a3b94$var$zc);
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$ic || ($0b2e6adb871a3b94$var$ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$Ac)));
}
function $0b2e6adb871a3b94$var$Cc(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$Bc(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$jc.length) {
        $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$jc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$jc.length; c++){
            var d = $0b2e6adb871a3b94$var$jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$kc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$kc, a);
    null !== $0b2e6adb871a3b94$var$lc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$lc, a);
    null !== $0b2e6adb871a3b94$var$mc && $0b2e6adb871a3b94$var$Bc($0b2e6adb871a3b94$var$mc, a);
    $0b2e6adb871a3b94$var$nc.forEach(b);
    $0b2e6adb871a3b94$var$oc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$pc.length; c++)d = $0b2e6adb871a3b94$var$pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$pc.length && (c = $0b2e6adb871a3b94$var$pc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$pc.shift();
}
function $0b2e6adb871a3b94$var$Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$Ec = {
    animationend: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Dc("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Dc("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Fc = {}, $0b2e6adb871a3b94$var$Gc = {};
$0b2e6adb871a3b94$var$fa && ($0b2e6adb871a3b94$var$Gc = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$Ec.animationend.animation, delete $0b2e6adb871a3b94$var$Ec.animationiteration.animation, delete $0b2e6adb871a3b94$var$Ec.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$Ec.transitionend.transition);
function $0b2e6adb871a3b94$var$Hc(a) {
    if ($0b2e6adb871a3b94$var$Fc[a]) return $0b2e6adb871a3b94$var$Fc[a];
    if (!$0b2e6adb871a3b94$var$Ec[a]) return a;
    var b = $0b2e6adb871a3b94$var$Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Gc) return $0b2e6adb871a3b94$var$Fc[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$Ic = $0b2e6adb871a3b94$var$Hc("animationend"), $0b2e6adb871a3b94$var$Jc = $0b2e6adb871a3b94$var$Hc("animationiteration"), $0b2e6adb871a3b94$var$Kc = $0b2e6adb871a3b94$var$Hc("animationstart"), $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Hc("transitionend"), $0b2e6adb871a3b94$var$Mc = new Map, $0b2e6adb871a3b94$var$Nc = new Map, $0b2e6adb871a3b94$var$Oc = [
    "abort",
    "abort",
    $0b2e6adb871a3b94$var$Ic,
    "animationEnd",
    $0b2e6adb871a3b94$var$Jc,
    "animationIteration",
    $0b2e6adb871a3b94$var$Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $0b2e6adb871a3b94$var$Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function $0b2e6adb871a3b94$var$Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        $0b2e6adb871a3b94$var$Nc.set(d, b);
        $0b2e6adb871a3b94$var$Mc.set(d, e);
        $0b2e6adb871a3b94$var$da(e, [
            d
        ]);
    }
}
var $0b2e6adb871a3b94$var$Qc = $fO90s.unstable_now;
$0b2e6adb871a3b94$var$Qc();
var $0b2e6adb871a3b94$var$F = 8;
function $0b2e6adb871a3b94$var$Rc(a) {
    if (0 !== (1 & a)) return $0b2e6adb871a3b94$var$F = 15, 1;
    if (0 !== (2 & a)) return $0b2e6adb871a3b94$var$F = 14, 2;
    if (0 !== (4 & a)) return $0b2e6adb871a3b94$var$F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 12, b;
    if (0 !== (a & 32)) return $0b2e6adb871a3b94$var$F = 11, 32;
    b = 192 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 10, b;
    if (0 !== (a & 256)) return $0b2e6adb871a3b94$var$F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 8, b;
    if (0 !== (a & 4096)) return $0b2e6adb871a3b94$var$F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 5, b;
    if (a & 67108864) return $0b2e6adb871a3b94$var$F = 4, 67108864;
    if (0 !== (a & 134217728)) return $0b2e6adb871a3b94$var$F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return $0b2e6adb871a3b94$var$F = 2, b;
    if (0 !== (1073741824 & a)) return $0b2e6adb871a3b94$var$F = 1, 1073741824;
    $0b2e6adb871a3b94$var$F = 8;
    return a;
}
function $0b2e6adb871a3b94$var$Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function $0b2e6adb871a3b94$var$Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error($0b2e6adb871a3b94$var$y(358, a));
    }
}
function $0b2e6adb871a3b94$var$Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return $0b2e6adb871a3b94$var$F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = $0b2e6adb871a3b94$var$F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = $0b2e6adb871a3b94$var$Rc(k), e = $0b2e6adb871a3b94$var$F) : (h &= f, 0 !== h && (d = $0b2e6adb871a3b94$var$Rc(h), e = $0b2e6adb871a3b94$var$F));
    } else f = c & ~g, 0 !== f ? (d = $0b2e6adb871a3b94$var$Rc(f), e = $0b2e6adb871a3b94$var$F) : 0 !== h && (d = $0b2e6adb871a3b94$var$Rc(h), e = $0b2e6adb871a3b94$var$F);
    if (0 === d) return 0;
    d = 31 - $0b2e6adb871a3b94$var$Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        $0b2e6adb871a3b94$var$Rc(b);
        if (e <= $0b2e6adb871a3b94$var$F) return b;
        $0b2e6adb871a3b94$var$F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = $0b2e6adb871a3b94$var$Yc(24 & ~b), 0 === a ? $0b2e6adb871a3b94$var$Xc(10, b) : a;
        case 10:
            return a = $0b2e6adb871a3b94$var$Yc(192 & ~b), 0 === a ? $0b2e6adb871a3b94$var$Xc(8, b) : a;
        case 8:
            return a = $0b2e6adb871a3b94$var$Yc(3584 & ~b), 0 === a && (a = $0b2e6adb871a3b94$var$Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = $0b2e6adb871a3b94$var$Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error($0b2e6adb871a3b94$var$y(358, a));
}
function $0b2e6adb871a3b94$var$Yc(a) {
    return a & -a;
}
function $0b2e6adb871a3b94$var$Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$$c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$Vc(b);
    a[b] = c;
}
var $0b2e6adb871a3b94$var$Vc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$ad, $0b2e6adb871a3b94$var$bd = Math.log, $0b2e6adb871a3b94$var$cd = Math.LN2;
function $0b2e6adb871a3b94$var$ad(a) {
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$bd(a) / $0b2e6adb871a3b94$var$cd | 0) | 0;
}
var $0b2e6adb871a3b94$var$dd = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$ed = $fO90s.unstable_runWithPriority, $0b2e6adb871a3b94$var$fd = !0;
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    $0b2e6adb871a3b94$var$Kb || $0b2e6adb871a3b94$var$Ib();
    var e = $0b2e6adb871a3b94$var$hd, f = $0b2e6adb871a3b94$var$Kb;
    $0b2e6adb871a3b94$var$Kb = !0;
    try {
        $0b2e6adb871a3b94$var$Hb(e, a, b, c, d);
    } finally{
        ($0b2e6adb871a3b94$var$Kb = f) || $0b2e6adb871a3b94$var$Mb();
    }
}
function $0b2e6adb871a3b94$var$id(a, b, c, d) {
    $0b2e6adb871a3b94$var$ed($0b2e6adb871a3b94$var$dd, $0b2e6adb871a3b94$var$hd.bind(null, a, b, c, d));
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < $0b2e6adb871a3b94$var$jc.length && -1 < $0b2e6adb871a3b94$var$qc.indexOf(a)) a = $0b2e6adb871a3b94$var$rc(null, a, b, c, d), $0b2e6adb871a3b94$var$jc.push(a);
        else {
            var f = $0b2e6adb871a3b94$var$yc(a, b, c, d);
            if (null === f) e && $0b2e6adb871a3b94$var$sc(a, d);
            else {
                if (e) {
                    if (-1 < $0b2e6adb871a3b94$var$qc.indexOf(a)) {
                        a = $0b2e6adb871a3b94$var$rc(f, a, b, c, d);
                        $0b2e6adb871a3b94$var$jc.push(a);
                        return;
                    }
                    if ($0b2e6adb871a3b94$var$uc(f, a, b, c, d)) return;
                    $0b2e6adb871a3b94$var$sc(a, d);
                }
                $0b2e6adb871a3b94$var$jd(a, b, d, null, c);
            }
        }
    }
}
function $0b2e6adb871a3b94$var$yc(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$xb(d);
    e = $0b2e6adb871a3b94$var$wc(e);
    if (null !== e) {
        var f = $0b2e6adb871a3b94$var$Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $0b2e6adb871a3b94$var$$b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    $0b2e6adb871a3b94$var$jd(a, b, d, e, c);
    return null;
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $8coUR({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $8coUR({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $8coUR({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$fa && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$fa && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$fa && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$fa && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$fa) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$fa) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        a = $0b2e6adb871a3b94$var$re;
        if ($0b2e6adb871a3b94$var$Kb) a(b);
        else {
            $0b2e6adb871a3b94$var$Kb = !0;
            try {
                $0b2e6adb871a3b94$var$Gb(a, b);
            } finally{
                $0b2e6adb871a3b94$var$Kb = !1, $0b2e6adb871a3b94$var$Mb();
            }
        }
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge, $0b2e6adb871a3b94$var$Ie = Object.prototype.hasOwnProperty;
function $0b2e6adb871a3b94$var$Je(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$0b2e6adb871a3b94$var$Ie.call(b, c[d]) || !$0b2e6adb871a3b94$var$He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    var c = $0b2e6adb871a3b94$var$Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Ke(c);
    }
}
function $0b2e6adb871a3b94$var$Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Ne() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$fa && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Je($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
$0b2e6adb871a3b94$var$Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
$0b2e6adb871a3b94$var$Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
$0b2e6adb871a3b94$var$Pc($0b2e6adb871a3b94$var$Oc, 2);
for(var $0b2e6adb871a3b94$var$Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), $0b2e6adb871a3b94$var$We = 0; $0b2e6adb871a3b94$var$We < $0b2e6adb871a3b94$var$Ve.length; $0b2e6adb871a3b94$var$We++)$0b2e6adb871a3b94$var$Nc.set($0b2e6adb871a3b94$var$Ve[$0b2e6adb871a3b94$var$We], 0);
$0b2e6adb871a3b94$var$ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$Xe));
function $0b2e6adb871a3b94$var$Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$Ze(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Ub) throw a = $0b2e6adb871a3b94$var$Vb, $0b2e6adb871a3b94$var$Ub = !1, $0b2e6adb871a3b94$var$Vb = null, a;
}
function $0b2e6adb871a3b94$var$G(a, b) {
    var c = $0b2e6adb871a3b94$var$$e(b), d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$af(b, a, 2, !1), c.add(d));
}
var $0b2e6adb871a3b94$var$bf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$cf(a) {
    a[$0b2e6adb871a3b94$var$bf] || (a[$0b2e6adb871a3b94$var$bf] = !0, $0b2e6adb871a3b94$var$ba.forEach(function(b) {
        $0b2e6adb871a3b94$var$Ye.has(b) || $0b2e6adb871a3b94$var$df(b, !1, a, null);
        $0b2e6adb871a3b94$var$df(b, !0, a, null);
    }));
}
function $0b2e6adb871a3b94$var$df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && $0b2e6adb871a3b94$var$Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $0b2e6adb871a3b94$var$$e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), $0b2e6adb871a3b94$var$af(f, a, e, b), g.add(h));
}
function $0b2e6adb871a3b94$var$af(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        case 1:
            e = $0b2e6adb871a3b94$var$id;
            break;
        default:
            e = $0b2e6adb871a3b94$var$hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Nb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$Mc.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$Ic:
                    case $0b2e6adb871a3b94$var$Jc:
                    case $0b2e6adb871a3b94$var$Kc:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$Lc:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = $0b2e6adb871a3b94$var$Ob(t, u), null != v && w.push($0b2e6adb871a3b94$var$ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$wc(x) || x[$0b2e6adb871a3b94$var$ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? $0b2e6adb871a3b94$var$wc(x) : null, null !== x && (z = $0b2e6adb871a3b94$var$Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = $0b2e6adb871a3b94$var$Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $0b2e6adb871a3b94$var$Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        q = null == x ? h : $0b2e6adb871a3b94$var$ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        $0b2e6adb871a3b94$var$wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = $0b2e6adb871a3b94$var$gf(q))t++;
                            q = 0;
                            for(v = u; v; v = $0b2e6adb871a3b94$var$gf(v))q++;
                            for(; 0 < t - q;)w = $0b2e6adb871a3b94$var$gf(w), t--;
                            for(; 0 < q - t;)u = $0b2e6adb871a3b94$var$gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = $0b2e6adb871a3b94$var$gf(w);
                                u = $0b2e6adb871a3b94$var$gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $0b2e6adb871a3b94$var$hf(g, h, k, w, !1);
                        null !== x && null !== z && $0b2e6adb871a3b94$var$hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) J = $0b2e6adb871a3b94$var$Fe;
                    else {
                        J = $0b2e6adb871a3b94$var$De;
                        var K = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = $0b2e6adb871a3b94$var$Ee);
                if (J && (J = J(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && $0b2e6adb871a3b94$var$bb(h, "number", h.value);
            }
            K = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(K) || "true" === K.contentEditable) $0b2e6adb871a3b94$var$Qe = K, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var Q;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && $0b2e6adb871a3b94$var$ie && (Q = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), K = $0b2e6adb871a3b94$var$oe(d, L), 0 < K.length && (L = new $0b2e6adb871a3b94$var$Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = $0b2e6adb871a3b94$var$he(c), null !== Q && (L.data = Q))));
            if (Q = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Ob(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$ef(a, f, e)), f = $0b2e6adb871a3b94$var$Ob(a, b), null != f && d.push($0b2e6adb871a3b94$var$ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Ob(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$ef(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Ob(c, f), null != k && g.push($0b2e6adb871a3b94$var$ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function $0b2e6adb871a3b94$var$jf() {}
var $0b2e6adb871a3b94$var$kf = null, $0b2e6adb871a3b94$var$lf = null;
function $0b2e6adb871a3b94$var$mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$of = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $0b2e6adb871a3b94$var$qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function $0b2e6adb871a3b94$var$rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $0b2e6adb871a3b94$var$sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$tf = 0;
function $0b2e6adb871a3b94$var$uf(a) {
    return {
        $$typeof: $0b2e6adb871a3b94$var$Ga,
        toString: a,
        valueOf: a
    };
}
var $0b2e6adb871a3b94$var$vf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$wf = "__reactFiber$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$xf = "__reactProps$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$ff = "__reactContainer$" + $0b2e6adb871a3b94$var$vf, $0b2e6adb871a3b94$var$yf = "__reactEvents$" + $0b2e6adb871a3b94$var$vf;
function $0b2e6adb871a3b94$var$wc(a) {
    var b = a[$0b2e6adb871a3b94$var$wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$ff] || c[$0b2e6adb871a3b94$var$wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$sf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$wf]) return c;
                a = $0b2e6adb871a3b94$var$sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$wf] || a[$0b2e6adb871a3b94$var$ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$y(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$xf] || null;
}
function $0b2e6adb871a3b94$var$$e(a) {
    var b = a[$0b2e6adb871a3b94$var$yf];
    void 0 === b && (b = a[$0b2e6adb871a3b94$var$yf] = new Set);
    return b;
}
var $0b2e6adb871a3b94$var$zf = [], $0b2e6adb871a3b94$var$Af = -1;
function $0b2e6adb871a3b94$var$Bf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$H(a) {
    0 > $0b2e6adb871a3b94$var$Af || (a.current = $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af], $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af] = null, $0b2e6adb871a3b94$var$Af--);
}
function $0b2e6adb871a3b94$var$I(a, b) {
    $0b2e6adb871a3b94$var$Af++;
    $0b2e6adb871a3b94$var$zf[$0b2e6adb871a3b94$var$Af] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Cf = {}, $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$Cf), $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$Bf(!1), $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$Gf() {
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
}
function $0b2e6adb871a3b94$var$Hf(a, b, c) {
    if ($0b2e6adb871a3b94$var$M.current !== $0b2e6adb871a3b94$var$Cf) throw Error($0b2e6adb871a3b94$var$y(168));
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, b);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, c);
}
function $0b2e6adb871a3b94$var$If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($0b2e6adb871a3b94$var$y(108, $0b2e6adb871a3b94$var$Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function $0b2e6adb871a3b94$var$Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Cf;
    $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$M.current;
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, a);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, $0b2e6adb871a3b94$var$N.current);
    return !0;
}
function $0b2e6adb871a3b94$var$Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$y(169));
    c ? (a = $0b2e6adb871a3b94$var$If(a, b, $0b2e6adb871a3b94$var$Df), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N), $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M), $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$M, a)) : $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$N, c);
}
var $0b2e6adb871a3b94$var$Lf = null, $0b2e6adb871a3b94$var$Mf = null, $0b2e6adb871a3b94$var$Nf = $fO90s.unstable_runWithPriority, $0b2e6adb871a3b94$var$Of = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$Pf = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$Qf = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$Rf = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$Sf = $fO90s.unstable_now, $0b2e6adb871a3b94$var$Tf = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$Uf = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$Vf = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$Wf = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$Xf = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$Yf = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$Zf = {}, $0b2e6adb871a3b94$var$$f = void 0 !== $0b2e6adb871a3b94$var$Rf ? $0b2e6adb871a3b94$var$Rf : function() {}, $0b2e6adb871a3b94$var$ag = null, $0b2e6adb871a3b94$var$bg = null, $0b2e6adb871a3b94$var$cg = !1, $0b2e6adb871a3b94$var$dg = $0b2e6adb871a3b94$var$Sf(), $0b2e6adb871a3b94$var$O = 1E4 > $0b2e6adb871a3b94$var$dg ? $0b2e6adb871a3b94$var$Sf : function() {
    return $0b2e6adb871a3b94$var$Sf() - $0b2e6adb871a3b94$var$dg;
};
function $0b2e6adb871a3b94$var$eg() {
    switch($0b2e6adb871a3b94$var$Tf()){
        case $0b2e6adb871a3b94$var$Uf:
            return 99;
        case $0b2e6adb871a3b94$var$Vf:
            return 98;
        case $0b2e6adb871a3b94$var$Wf:
            return 97;
        case $0b2e6adb871a3b94$var$Xf:
            return 96;
        case $0b2e6adb871a3b94$var$Yf:
            return 95;
        default:
            throw Error($0b2e6adb871a3b94$var$y(332));
    }
}
function $0b2e6adb871a3b94$var$fg(a) {
    switch(a){
        case 99:
            return $0b2e6adb871a3b94$var$Uf;
        case 98:
            return $0b2e6adb871a3b94$var$Vf;
        case 97:
            return $0b2e6adb871a3b94$var$Wf;
        case 96:
            return $0b2e6adb871a3b94$var$Xf;
        case 95:
            return $0b2e6adb871a3b94$var$Yf;
        default:
            throw Error($0b2e6adb871a3b94$var$y(332));
    }
}
function $0b2e6adb871a3b94$var$gg(a, b) {
    a = $0b2e6adb871a3b94$var$fg(a);
    return $0b2e6adb871a3b94$var$Nf(a, b);
}
function $0b2e6adb871a3b94$var$hg(a, b, c) {
    a = $0b2e6adb871a3b94$var$fg(a);
    return $0b2e6adb871a3b94$var$Of(a, b, c);
}
function $0b2e6adb871a3b94$var$ig() {
    if (null !== $0b2e6adb871a3b94$var$bg) {
        var a = $0b2e6adb871a3b94$var$bg;
        $0b2e6adb871a3b94$var$bg = null;
        $0b2e6adb871a3b94$var$Pf(a);
    }
    $0b2e6adb871a3b94$var$jg();
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$cg && null !== $0b2e6adb871a3b94$var$ag) {
        $0b2e6adb871a3b94$var$cg = !0;
        var a = 0;
        try {
            var b = $0b2e6adb871a3b94$var$ag;
            $0b2e6adb871a3b94$var$gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $0b2e6adb871a3b94$var$ag = null;
        } catch (c) {
            throw null !== $0b2e6adb871a3b94$var$ag && ($0b2e6adb871a3b94$var$ag = $0b2e6adb871a3b94$var$ag.slice(a + 1)), $0b2e6adb871a3b94$var$Of($0b2e6adb871a3b94$var$Uf, $0b2e6adb871a3b94$var$ig), c;
        } finally{
            $0b2e6adb871a3b94$var$cg = !1;
        }
    }
}
var $0b2e6adb871a3b94$var$kg = $0b2e6adb871a3b94$var$ra.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$Bf(null), $0b2e6adb871a3b94$var$ng = null, $0b2e6adb871a3b94$var$og = null, $0b2e6adb871a3b94$var$pg = null;
function $0b2e6adb871a3b94$var$qg() {
    $0b2e6adb871a3b94$var$pg = $0b2e6adb871a3b94$var$og = $0b2e6adb871a3b94$var$ng = null;
}
function $0b2e6adb871a3b94$var$rg(a) {
    var b = $0b2e6adb871a3b94$var$mg.current;
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$mg);
    a.type._context._currentValue = b;
}
function $0b2e6adb871a3b94$var$sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$ng = a;
    $0b2e6adb871a3b94$var$pg = $0b2e6adb871a3b94$var$og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$vg(a, b) {
    if ($0b2e6adb871a3b94$var$pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $0b2e6adb871a3b94$var$pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $0b2e6adb871a3b94$var$og) {
            if (null === $0b2e6adb871a3b94$var$ng) throw Error($0b2e6adb871a3b94$var$y(308));
            $0b2e6adb871a3b94$var$og = b;
            $0b2e6adb871a3b94$var$ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else $0b2e6adb871a3b94$var$og = $0b2e6adb871a3b94$var$og.next = b;
    }
    return a._currentValue;
}
var $0b2e6adb871a3b94$var$wg = !1;
function $0b2e6adb871a3b94$var$xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function $0b2e6adb871a3b94$var$Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$Cg(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        $0b2e6adb871a3b94$var$Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function $0b2e6adb871a3b94$var$Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$y(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$Fg = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = $0b2e6adb871a3b94$var$zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $0b2e6adb871a3b94$var$Ag(a, f);
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = $0b2e6adb871a3b94$var$zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $0b2e6adb871a3b94$var$Ag(a, f);
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$Hg(), d = $0b2e6adb871a3b94$var$Ig(a), e = $0b2e6adb871a3b94$var$zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        $0b2e6adb871a3b94$var$Ag(a, e);
        $0b2e6adb871a3b94$var$Jg(a, d, c);
    }
};
function $0b2e6adb871a3b94$var$Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Je(c, d) || !$0b2e6adb871a3b94$var$Je(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Mg(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$vg(f) : (e = $0b2e6adb871a3b94$var$Ff(b) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Ef(a, e) : $0b2e6adb871a3b94$var$Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Kg.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$Fg;
    $0b2e6adb871a3b94$var$xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$vg(f) : (f = $0b2e6adb871a3b94$var$Ff(b) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, e.context = $0b2e6adb871a3b94$var$Ef(a, f));
    $0b2e6adb871a3b94$var$Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Kg.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var $0b2e6adb871a3b94$var$Pg = Array.isArray;
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $0b2e6adb871a3b94$var$Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$y(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$y(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Rg(a, b) {
    if ("textarea" !== a.type) throw Error($0b2e6adb871a3b94$var$y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function $0b2e6adb871a3b94$var$Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Qg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return c = $0b2e6adb871a3b94$var$Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Qg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$ta:
                    return b = $0b2e6adb871a3b94$var$Wg(b, a.mode, c), b.return = a, b;
            }
            if ($0b2e6adb871a3b94$var$Pg(b) || $0b2e6adb871a3b94$var$La(b)) return b = $0b2e6adb871a3b94$var$Xg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return c.key === e ? c.type === $0b2e6adb871a3b94$var$ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($0b2e6adb871a3b94$var$Pg(c) || $0b2e6adb871a3b94$var$La(c)) return null !== e ? null : n(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $0b2e6adb871a3b94$var$ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $0b2e6adb871a3b94$var$ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($0b2e6adb871a3b94$var$Pg(d) || $0b2e6adb871a3b94$var$La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$La(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$y(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $0b2e6adb871a3b94$var$sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === $0b2e6adb871a3b94$var$ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = $0b2e6adb871a3b94$var$Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $0b2e6adb871a3b94$var$ua ? (d = $0b2e6adb871a3b94$var$Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $0b2e6adb871a3b94$var$ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $0b2e6adb871a3b94$var$Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if ($0b2e6adb871a3b94$var$Pg(f)) return x(a, d, f, h);
        if ($0b2e6adb871a3b94$var$La(f)) return w(a, d, f, h);
        l && $0b2e6adb871a3b94$var$Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error($0b2e6adb871a3b94$var$y(152, $0b2e6adb871a3b94$var$Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Sg(!0), $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Sg(!1), $0b2e6adb871a3b94$var$$g = {}, $0b2e6adb871a3b94$var$ah = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g), $0b2e6adb871a3b94$var$bh = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g), $0b2e6adb871a3b94$var$ch = $0b2e6adb871a3b94$var$Bf($0b2e6adb871a3b94$var$$g);
function $0b2e6adb871a3b94$var$dh(a) {
    if (a === $0b2e6adb871a3b94$var$$g) throw Error($0b2e6adb871a3b94$var$y(174));
    return a;
}
function $0b2e6adb871a3b94$var$eh(a, b) {
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ch, b);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$bh, a);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, $0b2e6adb871a3b94$var$$g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$mb(b, a);
    }
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, b);
}
function $0b2e6adb871a3b94$var$fh() {
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$bh);
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ch);
}
function $0b2e6adb871a3b94$var$gh(a) {
    $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
    var b = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
    var c = $0b2e6adb871a3b94$var$mb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$bh, a), $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$ah, c));
}
function $0b2e6adb871a3b94$var$hh(a) {
    $0b2e6adb871a3b94$var$bh.current === a && ($0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$ah), $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$bh));
}
var $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$Bf(0);
function $0b2e6adb871a3b94$var$ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$jh = null, $0b2e6adb871a3b94$var$kh = null, $0b2e6adb871a3b94$var$lh = !1;
function $0b2e6adb871a3b94$var$mh(a, b) {
    var c = $0b2e6adb871a3b94$var$nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $0b2e6adb871a3b94$var$oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$ph(a) {
    if ($0b2e6adb871a3b94$var$lh) {
        var b = $0b2e6adb871a3b94$var$kh;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$oh(a, b)) {
                b = $0b2e6adb871a3b94$var$rf(c.nextSibling);
                if (!b || !$0b2e6adb871a3b94$var$oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    $0b2e6adb871a3b94$var$lh = !1;
                    $0b2e6adb871a3b94$var$jh = a;
                    return;
                }
                $0b2e6adb871a3b94$var$mh($0b2e6adb871a3b94$var$jh, c);
            }
            $0b2e6adb871a3b94$var$jh = a;
            $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, $0b2e6adb871a3b94$var$lh = !1, $0b2e6adb871a3b94$var$jh = a;
    }
}
function $0b2e6adb871a3b94$var$qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$jh = a;
}
function $0b2e6adb871a3b94$var$rh(a) {
    if (a !== $0b2e6adb871a3b94$var$jh) return !1;
    if (!$0b2e6adb871a3b94$var$lh) return $0b2e6adb871a3b94$var$qh(a), $0b2e6adb871a3b94$var$lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$nf(b, a.memoizedProps)) for(b = $0b2e6adb871a3b94$var$kh; b;)$0b2e6adb871a3b94$var$mh(a, b), b = $0b2e6adb871a3b94$var$rf(b.nextSibling);
    $0b2e6adb871a3b94$var$qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$kh = null;
        }
    } else $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$jh ? $0b2e6adb871a3b94$var$rf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$sh() {
    $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$jh = null;
    $0b2e6adb871a3b94$var$lh = !1;
}
var $0b2e6adb871a3b94$var$th = [];
function $0b2e6adb871a3b94$var$uh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$th.length; a++)$0b2e6adb871a3b94$var$th[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$th.length = 0;
}
var $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$ra.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$xh = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$S = null, $0b2e6adb871a3b94$var$T = null, $0b2e6adb871a3b94$var$yh = !1, $0b2e6adb871a3b94$var$zh = !1;
function $0b2e6adb871a3b94$var$Ah() {
    throw Error($0b2e6adb871a3b94$var$y(321));
}
function $0b2e6adb871a3b94$var$Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Ch(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$xh = f;
    $0b2e6adb871a3b94$var$R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$vh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Dh : $0b2e6adb871a3b94$var$Eh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$zh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$zh = !1;
            if (!(25 > f)) throw Error($0b2e6adb871a3b94$var$y(301));
            f += 1;
            $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Fh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$zh);
    }
    $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Gh;
    b = null !== $0b2e6adb871a3b94$var$S && null !== $0b2e6adb871a3b94$var$S.next;
    $0b2e6adb871a3b94$var$xh = 0;
    $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$yh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$y(300));
    return a;
}
function $0b2e6adb871a3b94$var$Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState = $0b2e6adb871a3b94$var$T = a : $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$T.next = a;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Ih() {
    if (null === $0b2e6adb871a3b94$var$S) {
        var a = $0b2e6adb871a3b94$var$R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$S.next;
    var b = null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState : $0b2e6adb871a3b94$var$T.next;
    if (null !== b) $0b2e6adb871a3b94$var$T = b, $0b2e6adb871a3b94$var$S = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$y(310));
        $0b2e6adb871a3b94$var$S = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$S.memoizedState,
            baseState: $0b2e6adb871a3b94$var$S.baseState,
            baseQueue: $0b2e6adb871a3b94$var$S.baseQueue,
            queue: $0b2e6adb871a3b94$var$S.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$T ? $0b2e6adb871a3b94$var$R.memoizedState = $0b2e6adb871a3b94$var$T = a : $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$T.next = a;
    }
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Kh(a) {
    var b = $0b2e6adb871a3b94$var$Ih(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$y(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if (($0b2e6adb871a3b94$var$xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                $0b2e6adb871a3b94$var$R.lanes |= l;
                $0b2e6adb871a3b94$var$Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Lh(a) {
    var b = $0b2e6adb871a3b94$var$Ih(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = ($0b2e6adb871a3b94$var$xh & a) === a) b._workInProgressVersionPrimary = d, $0b2e6adb871a3b94$var$th.push(b);
    if (a) return c(b._source);
    $0b2e6adb871a3b94$var$th.push(b);
    throw Error($0b2e6adb871a3b94$var$y(350));
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$U;
    if (null === e) throw Error($0b2e6adb871a3b94$var$y(349));
    var f = b._getVersion, g = f(b._source), h = $0b2e6adb871a3b94$var$vh.current, k = h.useState(function() {
        return $0b2e6adb871a3b94$var$Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = $0b2e6adb871a3b94$var$T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = $0b2e6adb871a3b94$var$R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!$0b2e6adb871a3b94$var$He(g, a)) {
            a = c(b._source);
            $0b2e6adb871a3b94$var$He(n, a) || (l(a), a = $0b2e6adb871a3b94$var$Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - $0b2e6adb871a3b94$var$Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = $0b2e6adb871a3b94$var$Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    $0b2e6adb871a3b94$var$He(C, c) && $0b2e6adb871a3b94$var$He(x, b) && $0b2e6adb871a3b94$var$He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Jh,
        lastRenderedState: n
    }, a.dispatch = l = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a), k.queue = a, k.baseQueue = null, n = $0b2e6adb871a3b94$var$Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function $0b2e6adb871a3b94$var$Ph(a, b, c) {
    var d = $0b2e6adb871a3b94$var$Ih();
    return $0b2e6adb871a3b94$var$Nh(d, a, b, c);
}
function $0b2e6adb871a3b94$var$Qh(a) {
    var b = $0b2e6adb871a3b94$var$Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Jh,
        lastRenderedState: a
    };
    a = a.dispatch = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, $0b2e6adb871a3b94$var$R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$Sh(a) {
    var b = $0b2e6adb871a3b94$var$Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function $0b2e6adb871a3b94$var$Th() {
    return $0b2e6adb871a3b94$var$Ih().memoizedState;
}
function $0b2e6adb871a3b94$var$Uh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Hh();
    $0b2e6adb871a3b94$var$R.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$Vh(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$S) {
        var g = $0b2e6adb871a3b94$var$S.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Bh(d, g.deps)) {
            $0b2e6adb871a3b94$var$Rh(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$R.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$Rh(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    return $0b2e6adb871a3b94$var$Uh(516, 4, a, b);
}
function $0b2e6adb871a3b94$var$Xh(a, b) {
    return $0b2e6adb871a3b94$var$Vh(516, 4, a, b);
}
function $0b2e6adb871a3b94$var$Yh(a, b) {
    return $0b2e6adb871a3b94$var$Vh(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$$h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$Vh(4, 2, $0b2e6adb871a3b94$var$Zh.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ai() {}
function $0b2e6adb871a3b94$var$bi(a, b) {
    var c = $0b2e6adb871a3b94$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ci(a, b) {
    var c = $0b2e6adb871a3b94$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$di(a, b) {
    var c = $0b2e6adb871a3b94$var$eg();
    $0b2e6adb871a3b94$var$gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    $0b2e6adb871a3b94$var$gg(97 < c ? 97 : c, function() {
        var c = $0b2e6adb871a3b94$var$wh.transition;
        $0b2e6adb871a3b94$var$wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            $0b2e6adb871a3b94$var$wh.transition = c;
        }
    });
}
function $0b2e6adb871a3b94$var$Oh(a, b, c) {
    var d = $0b2e6adb871a3b94$var$Hg(), e = $0b2e6adb871a3b94$var$Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === $0b2e6adb871a3b94$var$R || null !== g && g === $0b2e6adb871a3b94$var$R) $0b2e6adb871a3b94$var$zh = $0b2e6adb871a3b94$var$yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if ($0b2e6adb871a3b94$var$He(k, h)) return;
        } catch (l) {} finally{}
        $0b2e6adb871a3b94$var$Jg(a, e, d);
    }
}
var $0b2e6adb871a3b94$var$Gh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$Ah,
    useContext: $0b2e6adb871a3b94$var$Ah,
    useEffect: $0b2e6adb871a3b94$var$Ah,
    useImperativeHandle: $0b2e6adb871a3b94$var$Ah,
    useLayoutEffect: $0b2e6adb871a3b94$var$Ah,
    useMemo: $0b2e6adb871a3b94$var$Ah,
    useReducer: $0b2e6adb871a3b94$var$Ah,
    useRef: $0b2e6adb871a3b94$var$Ah,
    useState: $0b2e6adb871a3b94$var$Ah,
    useDebugValue: $0b2e6adb871a3b94$var$Ah,
    useDeferredValue: $0b2e6adb871a3b94$var$Ah,
    useTransition: $0b2e6adb871a3b94$var$Ah,
    useMutableSource: $0b2e6adb871a3b94$var$Ah,
    useOpaqueIdentifier: $0b2e6adb871a3b94$var$Ah,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Dh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$Uh(4, 2, $0b2e6adb871a3b94$var$Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $0b2e6adb871a3b94$var$Oh.bind(null, $0b2e6adb871a3b94$var$R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: $0b2e6adb871a3b94$var$Sh,
    useState: $0b2e6adb871a3b94$var$Qh,
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Qh(a), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Wh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Qh(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$di.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return $0b2e6adb871a3b94$var$Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if ($0b2e6adb871a3b94$var$lh) {
            var a = !1, b = $0b2e6adb871a3b94$var$uf(function() {
                a || (a = !0, c("r:" + ($0b2e6adb871a3b94$var$tf++).toString(36)));
                throw Error($0b2e6adb871a3b94$var$y(355));
            }), c = $0b2e6adb871a3b94$var$Qh(b)[1];
            0 === ($0b2e6adb871a3b94$var$R.mode & 2) && ($0b2e6adb871a3b94$var$R.flags |= 516, $0b2e6adb871a3b94$var$Rh(5, function() {
                c("r:" + ($0b2e6adb871a3b94$var$tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + ($0b2e6adb871a3b94$var$tf++).toString(36);
        $0b2e6adb871a3b94$var$Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Eh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$bi,
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Xh,
    useImperativeHandle: $0b2e6adb871a3b94$var$$h,
    useLayoutEffect: $0b2e6adb871a3b94$var$Yh,
    useMemo: $0b2e6adb871a3b94$var$ci,
    useReducer: $0b2e6adb871a3b94$var$Kh,
    useRef: $0b2e6adb871a3b94$var$Th,
    useState: function() {
        return $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Xh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh)[0];
        return [
            $0b2e6adb871a3b94$var$Th().current,
            a
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Ph,
    useOpaqueIdentifier: function() {
        return $0b2e6adb871a3b94$var$Kh($0b2e6adb871a3b94$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Fh = {
    readContext: $0b2e6adb871a3b94$var$vg,
    useCallback: $0b2e6adb871a3b94$var$bi,
    useContext: $0b2e6adb871a3b94$var$vg,
    useEffect: $0b2e6adb871a3b94$var$Xh,
    useImperativeHandle: $0b2e6adb871a3b94$var$$h,
    useLayoutEffect: $0b2e6adb871a3b94$var$Yh,
    useMemo: $0b2e6adb871a3b94$var$ci,
    useReducer: $0b2e6adb871a3b94$var$Lh,
    useRef: $0b2e6adb871a3b94$var$Th,
    useState: function() {
        return $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh), c = b[0], d = b[1];
        $0b2e6adb871a3b94$var$Xh(function() {
            var b = $0b2e6adb871a3b94$var$wh.transition;
            $0b2e6adb871a3b94$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $0b2e6adb871a3b94$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh)[0];
        return [
            $0b2e6adb871a3b94$var$Th().current,
            a
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Ph,
    useOpaqueIdentifier: function() {
        return $0b2e6adb871a3b94$var$Lh($0b2e6adb871a3b94$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$ei = $0b2e6adb871a3b94$var$ra.ReactCurrentOwner, $0b2e6adb871a3b94$var$ug = !1;
function $0b2e6adb871a3b94$var$fi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Zg(b, null, c, d) : $0b2e6adb871a3b94$var$Yg(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$tg(b, e);
    d = $0b2e6adb871a3b94$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$0b2e6adb871a3b94$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $0b2e6adb871a3b94$var$hi(a, b, e);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$fi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$0b2e6adb871a3b94$var$ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $0b2e6adb871a3b94$var$ki(a, b, g, d, e, f);
        a = $0b2e6adb871a3b94$var$Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $0b2e6adb871a3b94$var$Je, c(e, d) && a.ref === b.ref)) return $0b2e6adb871a3b94$var$hi(a, b, f);
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d, e, f) {
    if (null !== a && $0b2e6adb871a3b94$var$Je(a.memoizedProps, d) && a.ref === b.ref) {
        if ($0b2e6adb871a3b94$var$ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && ($0b2e6adb871a3b94$var$ug = !0);
        else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$hi(a, b, f);
    }
    return $0b2e6adb871a3b94$var$li(a, b, c, d, f);
}
function $0b2e6adb871a3b94$var$mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, $0b2e6adb871a3b94$var$ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, $0b2e6adb871a3b94$var$ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, $0b2e6adb871a3b94$var$ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$ni(b, d);
    $0b2e6adb871a3b94$var$fi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function $0b2e6adb871a3b94$var$li(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current;
    f = $0b2e6adb871a3b94$var$Ef(b, f);
    $0b2e6adb871a3b94$var$tg(b, e);
    c = $0b2e6adb871a3b94$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$0b2e6adb871a3b94$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $0b2e6adb871a3b94$var$hi(a, b, e);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$fi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$pi(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Ff(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$Jf(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), $0b2e6adb871a3b94$var$Mg(b, c, d), $0b2e6adb871a3b94$var$Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$vg(l) : (l = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, l = $0b2e6adb871a3b94$var$Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Ng(b, g, d, l);
        $0b2e6adb871a3b94$var$wg = !1;
        var p = b.memoizedState;
        g.state = p;
        $0b2e6adb871a3b94$var$Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || $0b2e6adb871a3b94$var$N.current || $0b2e6adb871a3b94$var$wg ? ("function" === typeof n && ($0b2e6adb871a3b94$var$Gg(b, c, n, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$wg || $0b2e6adb871a3b94$var$Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$vg(k) : (k = $0b2e6adb871a3b94$var$Ff(c) ? $0b2e6adb871a3b94$var$Df : $0b2e6adb871a3b94$var$M.current, k = $0b2e6adb871a3b94$var$Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && $0b2e6adb871a3b94$var$Ng(b, g, d, k);
        $0b2e6adb871a3b94$var$wg = !1;
        p = b.memoizedState;
        g.state = p;
        $0b2e6adb871a3b94$var$Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || $0b2e6adb871a3b94$var$N.current || $0b2e6adb871a3b94$var$wg ? ("function" === typeof C && ($0b2e6adb871a3b94$var$Gg(b, c, C, d), x = b.memoizedState), (l = $0b2e6adb871a3b94$var$wg || $0b2e6adb871a3b94$var$Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return $0b2e6adb871a3b94$var$qi(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$qi(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$Kf(b, c, !1), $0b2e6adb871a3b94$var$hi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Yg(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Yg(b, null, h, f)) : $0b2e6adb871a3b94$var$fi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$Kf(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$ri(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$Hf(a, b.context, !1);
    $0b2e6adb871a3b94$var$eh(a, b.containerInfo);
}
var $0b2e6adb871a3b94$var$si = {
    dehydrated: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$ti(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && $0b2e6adb871a3b94$var$ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = $0b2e6adb871a3b94$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $0b2e6adb871a3b94$var$si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = $0b2e6adb871a3b94$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $0b2e6adb871a3b94$var$si, b.lanes = 33554432, a;
        c = $0b2e6adb871a3b94$var$vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = $0b2e6adb871a3b94$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = $0b2e6adb871a3b94$var$si, d;
        c = $0b2e6adb871a3b94$var$xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = $0b2e6adb871a3b94$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = $0b2e6adb871a3b94$var$si, d;
    c = $0b2e6adb871a3b94$var$xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = $0b2e6adb871a3b94$var$vi(b, e, 0, null);
    c = $0b2e6adb871a3b94$var$Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function $0b2e6adb871a3b94$var$xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = $0b2e6adb871a3b94$var$Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function $0b2e6adb871a3b94$var$wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = $0b2e6adb871a3b94$var$Tg(g, h);
    null !== a ? d = $0b2e6adb871a3b94$var$Tg(a, d) : (d = $0b2e6adb871a3b94$var$Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    $0b2e6adb871a3b94$var$sg(a.return, b);
}
function $0b2e6adb871a3b94$var$zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function $0b2e6adb871a3b94$var$Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$fi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$yi(a, c);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $0b2e6adb871a3b94$var$zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$y(153));
        if (null !== b.child) {
            a = b.child;
            c = $0b2e6adb871a3b94$var$Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Bi, $0b2e6adb871a3b94$var$Ci, $0b2e6adb871a3b94$var$Di, $0b2e6adb871a3b94$var$Ei;
$0b2e6adb871a3b94$var$Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Ci = function() {};
$0b2e6adb871a3b94$var$Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "option":
                e = $0b2e6adb871a3b94$var$eb(a, e);
                d = $0b2e6adb871a3b94$var$eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$jf);
        }
        $0b2e6adb871a3b94$var$vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Fi(a, b) {
    if (!$0b2e6adb871a3b94$var$lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Gf(), null;
        case 3:
            $0b2e6adb871a3b94$var$fh();
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
            $0b2e6adb871a3b94$var$uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            $0b2e6adb871a3b94$var$Ci(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$hh(b);
            var e = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(166));
                    return null;
                }
                a = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
                if ($0b2e6adb871a3b94$var$rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$wf] = b;
                    d[$0b2e6adb871a3b94$var$xf] = f;
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$G("cancel", d);
                            $0b2e6adb871a3b94$var$G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $0b2e6adb871a3b94$var$Xe.length; a++)$0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Xe[a], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$G("error", d);
                            $0b2e6adb871a3b94$var$G("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$G("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$G("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$G("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : $0b2e6adb871a3b94$var$ca.hasOwnProperty(g) && null != e && "onScroll" === g && $0b2e6adb871a3b94$var$G("scroll", d));
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$cb(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === $0b2e6adb871a3b94$var$kb.html && (a = $0b2e6adb871a3b94$var$lb(c));
                    a === $0b2e6adb871a3b94$var$kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$wf] = b;
                    a[$0b2e6adb871a3b94$var$xf] = d;
                    $0b2e6adb871a3b94$var$Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = $0b2e6adb871a3b94$var$wb(c, d);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$G("cancel", a);
                            $0b2e6adb871a3b94$var$G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$Xe.length; e++)$0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$G("error", a);
                            $0b2e6adb871a3b94$var$G("load", a);
                            e = d;
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(a, d);
                            e = $0b2e6adb871a3b94$var$Ya(a, d);
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        case "option":
                            e = $0b2e6adb871a3b94$var$eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(a, d);
                            e = $0b2e6adb871a3b94$var$gb(a, d);
                            $0b2e6adb871a3b94$var$G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    $0b2e6adb871a3b94$var$vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? $0b2e6adb871a3b94$var$tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$pb(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ca.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$G("scroll", a) : null != k && $0b2e6adb871a3b94$var$qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(a);
                            $0b2e6adb871a3b94$var$cb(a, d, !1);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(a);
                            $0b2e6adb871a3b94$var$jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$jf);
                    }
                    $0b2e6adb871a3b94$var$mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(166));
                c = $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ch.current);
                $0b2e6adb871a3b94$var$dh($0b2e6adb871a3b94$var$ah.current);
                $0b2e6adb871a3b94$var$rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[$0b2e6adb871a3b94$var$wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $0b2e6adb871a3b94$var$rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($0b2e6adb871a3b94$var$P.current & 1)) 0 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 3);
                else {
                    if (0 === $0b2e6adb871a3b94$var$V || 3 === $0b2e6adb871a3b94$var$V) $0b2e6adb871a3b94$var$V = 4;
                    null === $0b2e6adb871a3b94$var$U || 0 === ($0b2e6adb871a3b94$var$Dg & 134217727) && 0 === ($0b2e6adb871a3b94$var$Hi & 134217727) || $0b2e6adb871a3b94$var$Ii($0b2e6adb871a3b94$var$U, $0b2e6adb871a3b94$var$W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$fh(), $0b2e6adb871a3b94$var$Ci(b), null === a && $0b2e6adb871a3b94$var$cf(b.stateNode.containerInfo), null;
        case 10:
            return $0b2e6adb871a3b94$var$rg(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Gf(), null;
        case 19:
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) $0b2e6adb871a3b94$var$Fi(d, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            $0b2e6adb871a3b94$var$Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && $0b2e6adb871a3b94$var$O() > $0b2e6adb871a3b94$var$Ji && (b.flags |= 64, f = !0, $0b2e6adb871a3b94$var$Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = $0b2e6adb871a3b94$var$ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $0b2e6adb871a3b94$var$O() - d.renderingStartTime > $0b2e6adb871a3b94$var$Ji && 1073741824 !== c && (b.flags |= 64, f = !0, $0b2e6adb871a3b94$var$Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $0b2e6adb871a3b94$var$O(), c.sibling = null, b = $0b2e6adb871a3b94$var$P.current, $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return $0b2e6adb871a3b94$var$Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error($0b2e6adb871a3b94$var$y(156, b.tag));
}
function $0b2e6adb871a3b94$var$Li(a) {
    switch(a.tag){
        case 1:
            $0b2e6adb871a3b94$var$Ff(a.type) && $0b2e6adb871a3b94$var$Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            $0b2e6adb871a3b94$var$fh();
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
            $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
            $0b2e6adb871a3b94$var$uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error($0b2e6adb871a3b94$var$y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return $0b2e6adb871a3b94$var$hh(a), null;
        case 13:
            return $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P), null;
        case 4:
            return $0b2e6adb871a3b94$var$fh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$rg(a), null;
        case 23:
        case 24:
            return $0b2e6adb871a3b94$var$Ki(), null;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function $0b2e6adb871a3b94$var$Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Oi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Pi(a, b, c) {
    c = $0b2e6adb871a3b94$var$zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Qi || ($0b2e6adb871a3b94$var$Qi = !0, $0b2e6adb871a3b94$var$Ri = d);
        $0b2e6adb871a3b94$var$Ni(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    c = $0b2e6adb871a3b94$var$zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $0b2e6adb871a3b94$var$Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ti ? $0b2e6adb871a3b94$var$Ti = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ti.add(this), $0b2e6adb871a3b94$var$Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $0b2e6adb871a3b94$var$Ui = "function" === typeof WeakSet ? WeakSet : Set;
function $0b2e6adb871a3b94$var$Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $0b2e6adb871a3b94$var$Wi(a, c);
        }
        else b.current = null;
    }
}
function $0b2e6adb871a3b94$var$Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $0b2e6adb871a3b94$var$lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && $0b2e6adb871a3b94$var$qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && ($0b2e6adb871a3b94$var$Zi(c, a), $0b2e6adb871a3b94$var$$i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : $0b2e6adb871a3b94$var$lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && $0b2e6adb871a3b94$var$Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                $0b2e6adb871a3b94$var$Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && $0b2e6adb871a3b94$var$mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && $0b2e6adb871a3b94$var$Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = $0b2e6adb871a3b94$var$sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $0b2e6adb871a3b94$var$bj(a, b) {
    if ($0b2e6adb871a3b94$var$Mf && "function" === typeof $0b2e6adb871a3b94$var$Mf.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$Mf.onCommitFiberUnmount($0b2e6adb871a3b94$var$Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) $0b2e6adb871a3b94$var$Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                $0b2e6adb871a3b94$var$Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                $0b2e6adb871a3b94$var$Wi(b, f);
            }
            break;
        case 5:
            $0b2e6adb871a3b94$var$Vi(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$cj(a, b);
    }
}
function $0b2e6adb871a3b94$var$dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($0b2e6adb871a3b94$var$ej(b)) break a;
            b = b.return;
        }
        throw Error($0b2e6adb871a3b94$var$y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$y(161));
    }
    c.flags & 16 && ($0b2e6adb871a3b94$var$pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $0b2e6adb871a3b94$var$ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? $0b2e6adb871a3b94$var$gj(a, c, b) : $0b2e6adb871a3b94$var$hj(a, c, b);
}
function $0b2e6adb871a3b94$var$gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$jf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$gj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$gj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$hj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$hj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error($0b2e6adb871a3b94$var$y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if ($0b2e6adb871a3b94$var$bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if ($0b2e6adb871a3b94$var$bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$0b2e6adb871a3b94$var$xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $0b2e6adb871a3b94$var$$a(c, d);
                    $0b2e6adb871a3b94$var$wb(a, e);
                    b = $0b2e6adb871a3b94$var$wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $0b2e6adb871a3b94$var$tb(c, h) : "dangerouslySetInnerHTML" === g ? $0b2e6adb871a3b94$var$ob(c, h) : "children" === g ? $0b2e6adb871a3b94$var$pb(c, h) : $0b2e6adb871a3b94$var$qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $0b2e6adb871a3b94$var$ab(c, d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? $0b2e6adb871a3b94$var$fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? $0b2e6adb871a3b94$var$fb(c, !!d.multiple, d.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, $0b2e6adb871a3b94$var$Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && ($0b2e6adb871a3b94$var$jj = $0b2e6adb871a3b94$var$O(), $0b2e6adb871a3b94$var$aj(b.child, !0));
            $0b2e6adb871a3b94$var$kj(b);
            return;
        case 19:
            $0b2e6adb871a3b94$var$kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            $0b2e6adb871a3b94$var$aj(b, null !== b.memoizedState);
            return;
    }
    throw Error($0b2e6adb871a3b94$var$y(163));
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Ui);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var $0b2e6adb871a3b94$var$nj = Math.ceil, $0b2e6adb871a3b94$var$oj = $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$pj = $0b2e6adb871a3b94$var$ra.ReactCurrentOwner, $0b2e6adb871a3b94$var$X = 0, $0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$W = 0, $0b2e6adb871a3b94$var$qj = 0, $0b2e6adb871a3b94$var$rj = $0b2e6adb871a3b94$var$Bf(0), $0b2e6adb871a3b94$var$V = 0, $0b2e6adb871a3b94$var$sj = null, $0b2e6adb871a3b94$var$tj = 0, $0b2e6adb871a3b94$var$Dg = 0, $0b2e6adb871a3b94$var$Hi = 0, $0b2e6adb871a3b94$var$uj = 0, $0b2e6adb871a3b94$var$vj = null, $0b2e6adb871a3b94$var$jj = 0, $0b2e6adb871a3b94$var$Ji = Infinity;
function $0b2e6adb871a3b94$var$wj() {
    $0b2e6adb871a3b94$var$Ji = $0b2e6adb871a3b94$var$O() + 500;
}
var $0b2e6adb871a3b94$var$Z = null, $0b2e6adb871a3b94$var$Qi = !1, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$Ti = null, $0b2e6adb871a3b94$var$xj = !1, $0b2e6adb871a3b94$var$yj = null, $0b2e6adb871a3b94$var$zj = 90, $0b2e6adb871a3b94$var$Aj = [], $0b2e6adb871a3b94$var$Bj = [], $0b2e6adb871a3b94$var$Cj = null, $0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = null, $0b2e6adb871a3b94$var$Fj = -1, $0b2e6adb871a3b94$var$Gj = 0, $0b2e6adb871a3b94$var$Hj = 0, $0b2e6adb871a3b94$var$Ij = null, $0b2e6adb871a3b94$var$Jj = !1;
function $0b2e6adb871a3b94$var$Hg() {
    return 0 !== ($0b2e6adb871a3b94$var$X & 48) ? $0b2e6adb871a3b94$var$O() : -1 !== $0b2e6adb871a3b94$var$Fj ? $0b2e6adb871a3b94$var$Fj : $0b2e6adb871a3b94$var$Fj = $0b2e6adb871a3b94$var$O();
}
function $0b2e6adb871a3b94$var$Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === $0b2e6adb871a3b94$var$eg() ? 1 : 2;
    0 === $0b2e6adb871a3b94$var$Gj && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$tj);
    if (0 !== $0b2e6adb871a3b94$var$kg.transition) {
        0 !== $0b2e6adb871a3b94$var$Hj && ($0b2e6adb871a3b94$var$Hj = null !== $0b2e6adb871a3b94$var$vj ? $0b2e6adb871a3b94$var$vj.pendingLanes : 0);
        a = $0b2e6adb871a3b94$var$Gj;
        var b = 4186112 & ~$0b2e6adb871a3b94$var$Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = $0b2e6adb871a3b94$var$eg();
    0 !== ($0b2e6adb871a3b94$var$X & 4) && 98 === a ? a = $0b2e6adb871a3b94$var$Xc(12, $0b2e6adb871a3b94$var$Gj) : (a = $0b2e6adb871a3b94$var$Sc(a), a = $0b2e6adb871a3b94$var$Xc(a, $0b2e6adb871a3b94$var$Gj));
    return a;
}
function $0b2e6adb871a3b94$var$Jg(a, b, c) {
    if (50 < $0b2e6adb871a3b94$var$Dj) throw $0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = null, Error($0b2e6adb871a3b94$var$y(185));
    a = $0b2e6adb871a3b94$var$Kj(a, b);
    if (null === a) return null;
    $0b2e6adb871a3b94$var$$c(a, b, c);
    a === $0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Hi |= b, 4 === $0b2e6adb871a3b94$var$V && $0b2e6adb871a3b94$var$Ii(a, $0b2e6adb871a3b94$var$W));
    var d = $0b2e6adb871a3b94$var$eg();
    1 === b ? 0 !== ($0b2e6adb871a3b94$var$X & 8) && 0 === ($0b2e6adb871a3b94$var$X & 48) ? $0b2e6adb871a3b94$var$Lj(a) : ($0b2e6adb871a3b94$var$Mj(a, c), 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig())) : (0 === ($0b2e6adb871a3b94$var$X & 4) || 98 !== d && 99 !== d || (null === $0b2e6adb871a3b94$var$Cj ? $0b2e6adb871a3b94$var$Cj = new Set([
        a
    ]) : $0b2e6adb871a3b94$var$Cj.add(a)), $0b2e6adb871a3b94$var$Mj(a, c));
    $0b2e6adb871a3b94$var$vj = a;
}
function $0b2e6adb871a3b94$var$Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function $0b2e6adb871a3b94$var$Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - $0b2e6adb871a3b94$var$Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                $0b2e6adb871a3b94$var$Rc(k);
                var n = $0b2e6adb871a3b94$var$F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = $0b2e6adb871a3b94$var$Uc(a, a === $0b2e6adb871a3b94$var$U ? $0b2e6adb871a3b94$var$W : 0);
    b = $0b2e6adb871a3b94$var$F;
    if (0 === d) null !== c && (c !== $0b2e6adb871a3b94$var$Zf && $0b2e6adb871a3b94$var$Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== $0b2e6adb871a3b94$var$Zf && $0b2e6adb871a3b94$var$Pf(c);
        }
        15 === b ? (c = $0b2e6adb871a3b94$var$Lj.bind(null, a), null === $0b2e6adb871a3b94$var$ag ? ($0b2e6adb871a3b94$var$ag = [
            c
        ], $0b2e6adb871a3b94$var$bg = $0b2e6adb871a3b94$var$Of($0b2e6adb871a3b94$var$Uf, $0b2e6adb871a3b94$var$jg)) : $0b2e6adb871a3b94$var$ag.push(c), c = $0b2e6adb871a3b94$var$Zf) : 14 === b ? c = $0b2e6adb871a3b94$var$hg(99, $0b2e6adb871a3b94$var$Lj.bind(null, a)) : (c = $0b2e6adb871a3b94$var$Tc(b), c = $0b2e6adb871a3b94$var$hg(c, $0b2e6adb871a3b94$var$Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Nj(a) {
    $0b2e6adb871a3b94$var$Fj = -1;
    $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$Gj = 0;
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    var b = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Oj() && a.callbackNode !== b) return null;
    var c = $0b2e6adb871a3b94$var$Uc(a, a === $0b2e6adb871a3b94$var$U ? $0b2e6adb871a3b94$var$W : 0);
    if (0 === c) return null;
    var d = c;
    var e = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 16;
    var f = $0b2e6adb871a3b94$var$Pj();
    if ($0b2e6adb871a3b94$var$U !== a || $0b2e6adb871a3b94$var$W !== d) $0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$Qj(a, d);
    for(;;)try {
        $0b2e6adb871a3b94$var$Rj();
        break;
    } catch (h) {
        $0b2e6adb871a3b94$var$Sj(a, h);
    }
    $0b2e6adb871a3b94$var$qg();
    $0b2e6adb871a3b94$var$oj.current = f;
    $0b2e6adb871a3b94$var$X = e;
    null !== $0b2e6adb871a3b94$var$Y ? d = 0 : ($0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$W = 0, d = $0b2e6adb871a3b94$var$V);
    if (0 !== ($0b2e6adb871a3b94$var$tj & $0b2e6adb871a3b94$var$Hi)) $0b2e6adb871a3b94$var$Qj(a, 0);
    else if (0 !== d) {
        2 === d && ($0b2e6adb871a3b94$var$X |= 64, a.hydrate && (a.hydrate = !1, $0b2e6adb871a3b94$var$qf(a.containerInfo)), c = $0b2e6adb871a3b94$var$Wc(a), 0 !== c && (d = $0b2e6adb871a3b94$var$Tj(a, c)));
        if (1 === d) throw b = $0b2e6adb871a3b94$var$sj, $0b2e6adb871a3b94$var$Qj(a, 0), $0b2e6adb871a3b94$var$Ii(a, c), $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error($0b2e6adb871a3b94$var$y(345));
            case 2:
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 3:
                $0b2e6adb871a3b94$var$Ii(a, c);
                if ((c & 62914560) === c && (d = $0b2e6adb871a3b94$var$jj + 500 - $0b2e6adb871a3b94$var$O(), 10 < d)) {
                    if (0 !== $0b2e6adb871a3b94$var$Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        $0b2e6adb871a3b94$var$Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = $0b2e6adb871a3b94$var$of($0b2e6adb871a3b94$var$Uj.bind(null, a), d);
                    break;
                }
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - $0b2e6adb871a3b94$var$Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = $0b2e6adb871a3b94$var$O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * $0b2e6adb871a3b94$var$nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = $0b2e6adb871a3b94$var$of($0b2e6adb871a3b94$var$Uj.bind(null, a), c);
                    break;
                }
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            case 5:
                $0b2e6adb871a3b94$var$Uj(a);
                break;
            default:
                throw Error($0b2e6adb871a3b94$var$y(329));
        }
    }
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    return a.callbackNode === b ? $0b2e6adb871a3b94$var$Nj.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    b &= ~$0b2e6adb871a3b94$var$uj;
    b &= ~$0b2e6adb871a3b94$var$Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Lj(a) {
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    $0b2e6adb871a3b94$var$Oj();
    if (a === $0b2e6adb871a3b94$var$U && 0 !== (a.expiredLanes & $0b2e6adb871a3b94$var$W)) {
        var b = $0b2e6adb871a3b94$var$W;
        var c = $0b2e6adb871a3b94$var$Tj(a, b);
        0 !== ($0b2e6adb871a3b94$var$tj & $0b2e6adb871a3b94$var$Hi) && (b = $0b2e6adb871a3b94$var$Uc(a, b), c = $0b2e6adb871a3b94$var$Tj(a, b));
    } else b = $0b2e6adb871a3b94$var$Uc(a, 0), c = $0b2e6adb871a3b94$var$Tj(a, b);
    0 !== a.tag && 2 === c && ($0b2e6adb871a3b94$var$X |= 64, a.hydrate && (a.hydrate = !1, $0b2e6adb871a3b94$var$qf(a.containerInfo)), b = $0b2e6adb871a3b94$var$Wc(a), 0 !== b && (c = $0b2e6adb871a3b94$var$Tj(a, b)));
    if (1 === c) throw c = $0b2e6adb871a3b94$var$sj, $0b2e6adb871a3b94$var$Qj(a, 0), $0b2e6adb871a3b94$var$Ii(a, b), $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Uj(a);
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    return null;
}
function $0b2e6adb871a3b94$var$Vj() {
    if (null !== $0b2e6adb871a3b94$var$Cj) {
        var a = $0b2e6adb871a3b94$var$Cj;
        $0b2e6adb871a3b94$var$Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
        });
    }
    $0b2e6adb871a3b94$var$ig();
}
function $0b2e6adb871a3b94$var$Wj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
}
function $0b2e6adb871a3b94$var$Xj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X &= -2;
    $0b2e6adb871a3b94$var$X |= 8;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$rj, $0b2e6adb871a3b94$var$qj);
    $0b2e6adb871a3b94$var$qj |= b;
    $0b2e6adb871a3b94$var$tj |= b;
}
function $0b2e6adb871a3b94$var$Ki() {
    $0b2e6adb871a3b94$var$qj = $0b2e6adb871a3b94$var$rj.current;
    $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$rj);
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$pf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$Gf();
                break;
            case 3:
                $0b2e6adb871a3b94$var$fh();
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$N);
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$M);
                $0b2e6adb871a3b94$var$uh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$hh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$fh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
                break;
            case 19:
                $0b2e6adb871a3b94$var$H($0b2e6adb871a3b94$var$P);
                break;
            case 10:
                $0b2e6adb871a3b94$var$rg(d);
                break;
            case 23:
            case 24:
                $0b2e6adb871a3b94$var$Ki();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$U = a;
    $0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Tg(a.current, null);
    $0b2e6adb871a3b94$var$W = $0b2e6adb871a3b94$var$qj = $0b2e6adb871a3b94$var$tj = b;
    $0b2e6adb871a3b94$var$V = 0;
    $0b2e6adb871a3b94$var$sj = null;
    $0b2e6adb871a3b94$var$uj = $0b2e6adb871a3b94$var$Hi = $0b2e6adb871a3b94$var$Dg = 0;
}
function $0b2e6adb871a3b94$var$Sj(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$qg();
            $0b2e6adb871a3b94$var$vh.current = $0b2e6adb871a3b94$var$Gh;
            if ($0b2e6adb871a3b94$var$yh) {
                for(var d = $0b2e6adb871a3b94$var$R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$yh = !1;
            }
            $0b2e6adb871a3b94$var$xh = 0;
            $0b2e6adb871a3b94$var$T = $0b2e6adb871a3b94$var$S = $0b2e6adb871a3b94$var$R = null;
            $0b2e6adb871a3b94$var$zh = !1;
            $0b2e6adb871a3b94$var$pj.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$V = 1;
                $0b2e6adb871a3b94$var$sj = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== ($0b2e6adb871a3b94$var$P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = $0b2e6adb871a3b94$var$zg(-1, 1);
                                        t.tag = 2;
                                        $0b2e6adb871a3b94$var$Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new $0b2e6adb871a3b94$var$Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = $0b2e6adb871a3b94$var$Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error(($0b2e6adb871a3b94$var$Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 2);
                k = $0b2e6adb871a3b94$var$Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = $0b2e6adb871a3b94$var$Pi(p, f, b);
                            $0b2e6adb871a3b94$var$Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = $0b2e6adb871a3b94$var$Si(p, f, b);
                                $0b2e6adb871a3b94$var$Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            $0b2e6adb871a3b94$var$Zj(c);
        } catch (va) {
            b = va;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Pj() {
    var a = $0b2e6adb871a3b94$var$oj.current;
    $0b2e6adb871a3b94$var$oj.current = $0b2e6adb871a3b94$var$Gh;
    return null === a ? $0b2e6adb871a3b94$var$Gh : a;
}
function $0b2e6adb871a3b94$var$Tj(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 16;
    var d = $0b2e6adb871a3b94$var$Pj();
    $0b2e6adb871a3b94$var$U === a && $0b2e6adb871a3b94$var$W === b || $0b2e6adb871a3b94$var$Qj(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$ak();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Sj(a, e);
    }
    $0b2e6adb871a3b94$var$qg();
    $0b2e6adb871a3b94$var$X = c;
    $0b2e6adb871a3b94$var$oj.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$y(261));
    $0b2e6adb871a3b94$var$U = null;
    $0b2e6adb871a3b94$var$W = 0;
    return $0b2e6adb871a3b94$var$V;
}
function $0b2e6adb871a3b94$var$ak() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$bk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Rj() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$Qf();)$0b2e6adb871a3b94$var$bk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = $0b2e6adb871a3b94$var$ck(a.alternate, a, $0b2e6adb871a3b94$var$qj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Zj(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$pj.current = null;
}
function $0b2e6adb871a3b94$var$Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = $0b2e6adb871a3b94$var$Gi(c, b, $0b2e6adb871a3b94$var$qj);
            if (null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== ($0b2e6adb871a3b94$var$qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = $0b2e6adb871a3b94$var$Li(b);
            if (null !== c) {
                c.flags &= 2047;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$V = 5);
}
function $0b2e6adb871a3b94$var$Uj(a) {
    var b = $0b2e6adb871a3b94$var$eg();
    $0b2e6adb871a3b94$var$gg(99, $0b2e6adb871a3b94$var$dk.bind(null, a, b));
    return null;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    do $0b2e6adb871a3b94$var$Oj();
    while (null !== $0b2e6adb871a3b94$var$yj);
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - $0b2e6adb871a3b94$var$Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== $0b2e6adb871a3b94$var$Cj && 0 === (d & 24) && $0b2e6adb871a3b94$var$Cj.has(a) && $0b2e6adb871a3b94$var$Cj.delete(a);
    a === $0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$U = null, $0b2e6adb871a3b94$var$W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = $0b2e6adb871a3b94$var$X;
        $0b2e6adb871a3b94$var$X |= 32;
        $0b2e6adb871a3b94$var$pj.current = null;
        $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$fd;
        g = $0b2e6adb871a3b94$var$Ne();
        if ($0b2e6adb871a3b94$var$Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $0b2e6adb871a3b94$var$lf = {
            focusedElem: g,
            selectionRange: h
        };
        $0b2e6adb871a3b94$var$fd = !1;
        $0b2e6adb871a3b94$var$Ij = null;
        $0b2e6adb871a3b94$var$Jj = !1;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            $0b2e6adb871a3b94$var$ek();
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        $0b2e6adb871a3b94$var$Ij = null;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            for(g = a; null !== $0b2e6adb871a3b94$var$Z;){
                var t = $0b2e6adb871a3b94$var$Z.flags;
                t & 16 && $0b2e6adb871a3b94$var$pb($0b2e6adb871a3b94$var$Z.stateNode, "");
                if (t & 128) {
                    var q = $0b2e6adb871a3b94$var$Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        $0b2e6adb871a3b94$var$fj($0b2e6adb871a3b94$var$Z);
                        $0b2e6adb871a3b94$var$Z.flags &= -3;
                        break;
                    case 6:
                        $0b2e6adb871a3b94$var$fj($0b2e6adb871a3b94$var$Z);
                        $0b2e6adb871a3b94$var$Z.flags &= -3;
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 1024:
                        $0b2e6adb871a3b94$var$Z.flags &= -1025;
                        break;
                    case 1028:
                        $0b2e6adb871a3b94$var$Z.flags &= -1025;
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 4:
                        $0b2e6adb871a3b94$var$ij($0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                        break;
                    case 8:
                        h = $0b2e6adb871a3b94$var$Z;
                        $0b2e6adb871a3b94$var$cj(g, h);
                        var J = h.alternate;
                        $0b2e6adb871a3b94$var$dj(h);
                        null !== J && $0b2e6adb871a3b94$var$dj(J);
                }
                $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        v = $0b2e6adb871a3b94$var$lf;
        q = $0b2e6adb871a3b94$var$Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && $0b2e6adb871a3b94$var$Me(t.ownerDocument.documentElement, t)) {
            null !== g && $0b2e6adb871a3b94$var$Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = $0b2e6adb871a3b94$var$Le(t, J), f = $0b2e6adb871a3b94$var$Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        $0b2e6adb871a3b94$var$fd = !!$0b2e6adb871a3b94$var$kf;
        $0b2e6adb871a3b94$var$lf = $0b2e6adb871a3b94$var$kf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$Z = d;
        do try {
            for(t = a; null !== $0b2e6adb871a3b94$var$Z;){
                var K = $0b2e6adb871a3b94$var$Z.flags;
                K & 36 && $0b2e6adb871a3b94$var$Yi(t, $0b2e6adb871a3b94$var$Z.alternate, $0b2e6adb871a3b94$var$Z);
                if (K & 128) {
                    q = void 0;
                    var Q = $0b2e6adb871a3b94$var$Z.ref;
                    if (null !== Q) {
                        var L = $0b2e6adb871a3b94$var$Z.stateNode;
                        switch($0b2e6adb871a3b94$var$Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $0b2e6adb871a3b94$var$Z) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi($0b2e6adb871a3b94$var$Z, va);
            $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
        }
        while (null !== $0b2e6adb871a3b94$var$Z);
        $0b2e6adb871a3b94$var$Z = null;
        $0b2e6adb871a3b94$var$$f();
        $0b2e6adb871a3b94$var$X = e;
    } else a.current = c;
    if ($0b2e6adb871a3b94$var$xj) $0b2e6adb871a3b94$var$xj = !1, $0b2e6adb871a3b94$var$yj = a, $0b2e6adb871a3b94$var$zj = b;
    else for($0b2e6adb871a3b94$var$Z = d; null !== $0b2e6adb871a3b94$var$Z;)b = $0b2e6adb871a3b94$var$Z.nextEffect, $0b2e6adb871a3b94$var$Z.nextEffect = null, $0b2e6adb871a3b94$var$Z.flags & 8 && (K = $0b2e6adb871a3b94$var$Z, K.sibling = null, K.stateNode = null), $0b2e6adb871a3b94$var$Z = b;
    d = a.pendingLanes;
    0 === d && ($0b2e6adb871a3b94$var$Ti = null);
    1 === d ? a === $0b2e6adb871a3b94$var$Ej ? $0b2e6adb871a3b94$var$Dj++ : ($0b2e6adb871a3b94$var$Dj = 0, $0b2e6adb871a3b94$var$Ej = a) : $0b2e6adb871a3b94$var$Dj = 0;
    c = c.stateNode;
    if ($0b2e6adb871a3b94$var$Mf && "function" === typeof $0b2e6adb871a3b94$var$Mf.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$Mf.onCommitFiberRoot($0b2e6adb871a3b94$var$Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    $0b2e6adb871a3b94$var$Mj(a, $0b2e6adb871a3b94$var$O());
    if ($0b2e6adb871a3b94$var$Qi) throw $0b2e6adb871a3b94$var$Qi = !1, a = $0b2e6adb871a3b94$var$Ri, $0b2e6adb871a3b94$var$Ri = null, a;
    if (0 !== ($0b2e6adb871a3b94$var$X & 8)) return null;
    $0b2e6adb871a3b94$var$ig();
    return null;
}
function $0b2e6adb871a3b94$var$ek() {
    for(; null !== $0b2e6adb871a3b94$var$Z;){
        var a = $0b2e6adb871a3b94$var$Z.alternate;
        $0b2e6adb871a3b94$var$Jj || null === $0b2e6adb871a3b94$var$Ij || (0 !== ($0b2e6adb871a3b94$var$Z.flags & 8) ? $0b2e6adb871a3b94$var$dc($0b2e6adb871a3b94$var$Z, $0b2e6adb871a3b94$var$Ij) && ($0b2e6adb871a3b94$var$Jj = !0) : 13 === $0b2e6adb871a3b94$var$Z.tag && $0b2e6adb871a3b94$var$mj(a, $0b2e6adb871a3b94$var$Z) && $0b2e6adb871a3b94$var$dc($0b2e6adb871a3b94$var$Z, $0b2e6adb871a3b94$var$Ij) && ($0b2e6adb871a3b94$var$Jj = !0));
        var b = $0b2e6adb871a3b94$var$Z.flags;
        0 !== (b & 256) && $0b2e6adb871a3b94$var$Xi(a, $0b2e6adb871a3b94$var$Z);
        0 === (b & 512) || $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
            $0b2e6adb871a3b94$var$Oj();
            return null;
        }));
        $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$Z.nextEffect;
    }
}
function $0b2e6adb871a3b94$var$Oj() {
    if (90 !== $0b2e6adb871a3b94$var$zj) {
        var a = 97 < $0b2e6adb871a3b94$var$zj ? 97 : $0b2e6adb871a3b94$var$zj;
        $0b2e6adb871a3b94$var$zj = 90;
        return $0b2e6adb871a3b94$var$gg(a, $0b2e6adb871a3b94$var$fk);
    }
    return !1;
}
function $0b2e6adb871a3b94$var$$i(a, b) {
    $0b2e6adb871a3b94$var$Aj.push(b, a);
    $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
        $0b2e6adb871a3b94$var$Oj();
        return null;
    }));
}
function $0b2e6adb871a3b94$var$Zi(a, b) {
    $0b2e6adb871a3b94$var$Bj.push(b, a);
    $0b2e6adb871a3b94$var$xj || ($0b2e6adb871a3b94$var$xj = !0, $0b2e6adb871a3b94$var$hg(97, function() {
        $0b2e6adb871a3b94$var$Oj();
        return null;
    }));
}
function $0b2e6adb871a3b94$var$fk() {
    if (null === $0b2e6adb871a3b94$var$yj) return !1;
    var a = $0b2e6adb871a3b94$var$yj;
    $0b2e6adb871a3b94$var$yj = null;
    if (0 !== ($0b2e6adb871a3b94$var$X & 48)) throw Error($0b2e6adb871a3b94$var$y(331));
    var b = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 32;
    var c = $0b2e6adb871a3b94$var$Bj;
    $0b2e6adb871a3b94$var$Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi(f, k);
        }
    }
    c = $0b2e6adb871a3b94$var$Aj;
    $0b2e6adb871a3b94$var$Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error($0b2e6adb871a3b94$var$y(330));
            $0b2e6adb871a3b94$var$Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    $0b2e6adb871a3b94$var$X = b;
    $0b2e6adb871a3b94$var$ig();
    return !0;
}
function $0b2e6adb871a3b94$var$gk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Mi(c, b);
    b = $0b2e6adb871a3b94$var$Pi(a, b, 1);
    $0b2e6adb871a3b94$var$Ag(a, b);
    b = $0b2e6adb871a3b94$var$Hg();
    a = $0b2e6adb871a3b94$var$Kj(a, 1);
    null !== a && ($0b2e6adb871a3b94$var$$c(a, 1, b), $0b2e6adb871a3b94$var$Mj(a, b));
}
function $0b2e6adb871a3b94$var$Wi(a, b) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $0b2e6adb871a3b94$var$gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(d))) {
                a = $0b2e6adb871a3b94$var$Mi(b, a);
                var e = $0b2e6adb871a3b94$var$Si(c, a, 1);
                $0b2e6adb871a3b94$var$Ag(c, e);
                e = $0b2e6adb871a3b94$var$Hg();
                c = $0b2e6adb871a3b94$var$Kj(c, 1);
                if (null !== c) $0b2e6adb871a3b94$var$$c(c, 1, e), $0b2e6adb871a3b94$var$Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ti || !$0b2e6adb871a3b94$var$Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$U === a && ($0b2e6adb871a3b94$var$W & c) === c && (4 === $0b2e6adb871a3b94$var$V || 3 === $0b2e6adb871a3b94$var$V && ($0b2e6adb871a3b94$var$W & 62914560) === $0b2e6adb871a3b94$var$W && 500 > $0b2e6adb871a3b94$var$O() - $0b2e6adb871a3b94$var$jj ? $0b2e6adb871a3b94$var$Qj(a, 0) : $0b2e6adb871a3b94$var$uj |= c);
    $0b2e6adb871a3b94$var$Mj(a, b);
}
function $0b2e6adb871a3b94$var$lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === $0b2e6adb871a3b94$var$eg() ? 1 : 2 : (0 === $0b2e6adb871a3b94$var$Gj && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$tj), b = $0b2e6adb871a3b94$var$Yc(62914560 & ~$0b2e6adb871a3b94$var$Gj), 0 === b && (b = 4194304)));
    c = $0b2e6adb871a3b94$var$Hg();
    a = $0b2e6adb871a3b94$var$Kj(a, b);
    null !== a && ($0b2e6adb871a3b94$var$$c(a, b, c), $0b2e6adb871a3b94$var$Mj(a, c));
}
var $0b2e6adb871a3b94$var$ck;
$0b2e6adb871a3b94$var$ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$N.current) $0b2e6adb871a3b94$var$ug = !0;
        else if (0 !== (c & d)) $0b2e6adb871a3b94$var$ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            $0b2e6adb871a3b94$var$ug = !1;
            switch(b.tag){
                case 3:
                    $0b2e6adb871a3b94$var$ri(b);
                    $0b2e6adb871a3b94$var$sh();
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$gh(b);
                    break;
                case 1:
                    $0b2e6adb871a3b94$var$Ff(b.type) && $0b2e6adb871a3b94$var$Jf(b);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$ti(a, b, c);
                        $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1);
                        b = $0b2e6adb871a3b94$var$hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return $0b2e6adb871a3b94$var$Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$P, $0b2e6adb871a3b94$var$P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, $0b2e6adb871a3b94$var$mi(a, b, c);
            }
            return $0b2e6adb871a3b94$var$hi(a, b, c);
        }
    } else $0b2e6adb871a3b94$var$ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = $0b2e6adb871a3b94$var$Ef(b, $0b2e6adb871a3b94$var$M.current);
            $0b2e6adb871a3b94$var$tg(b, c);
            e = $0b2e6adb871a3b94$var$Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if ($0b2e6adb871a3b94$var$Ff(d)) {
                    var f = !0;
                    $0b2e6adb871a3b94$var$Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                $0b2e6adb871a3b94$var$xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $0b2e6adb871a3b94$var$Gg(b, d, g, a);
                e.updater = $0b2e6adb871a3b94$var$Kg;
                b.stateNode = e;
                e._reactInternals = b;
                $0b2e6adb871a3b94$var$Og(b, d, a, c);
                b = $0b2e6adb871a3b94$var$qi(null, b, d, !0, f, c);
            } else b.tag = 0, $0b2e6adb871a3b94$var$fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = $0b2e6adb871a3b94$var$hk(e);
                a = $0b2e6adb871a3b94$var$lg(e, a);
                switch(f){
                    case 0:
                        b = $0b2e6adb871a3b94$var$li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$ii(null, b, e, $0b2e6adb871a3b94$var$lg(e.type, a), d, c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$pi(a, b, d, e, c);
        case 3:
            $0b2e6adb871a3b94$var$ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error($0b2e6adb871a3b94$var$y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $0b2e6adb871a3b94$var$yg(a, b);
            $0b2e6adb871a3b94$var$Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) $0b2e6adb871a3b94$var$sh(), b = $0b2e6adb871a3b94$var$hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) $0b2e6adb871a3b94$var$kh = $0b2e6adb871a3b94$var$rf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$jh = b, f = $0b2e6adb871a3b94$var$lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], $0b2e6adb871a3b94$var$th.push(f);
                    c = $0b2e6adb871a3b94$var$Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else $0b2e6adb871a3b94$var$fi(a, b, d, c), $0b2e6adb871a3b94$var$sh();
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$gh(b), null === a && $0b2e6adb871a3b94$var$ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$nf(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$nf(d, f) && (b.flags |= 16), $0b2e6adb871a3b94$var$oi(a, b), $0b2e6adb871a3b94$var$fi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$ph(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$ti(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Yg(b, null, d, c) : $0b2e6adb871a3b94$var$fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), $0b2e6adb871a3b94$var$gi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                $0b2e6adb871a3b94$var$I($0b2e6adb871a3b94$var$mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $0b2e6adb871a3b94$var$He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !$0b2e6adb871a3b94$var$N.current) {
                            b = $0b2e6adb871a3b94$var$hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $0b2e6adb871a3b94$var$zg(-1, c & -c), l.tag = 2, $0b2e6adb871a3b94$var$Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    $0b2e6adb871a3b94$var$sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $0b2e6adb871a3b94$var$fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $0b2e6adb871a3b94$var$tg(b, c), e = $0b2e6adb871a3b94$var$vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $0b2e6adb871a3b94$var$lg(e, b.pendingProps), f = $0b2e6adb871a3b94$var$lg(e.type, f), $0b2e6adb871a3b94$var$ii(a, b, e, f, d, c);
        case 15:
            return $0b2e6adb871a3b94$var$ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, $0b2e6adb871a3b94$var$Ff(d) ? (a = !0, $0b2e6adb871a3b94$var$Jf(b)) : a = !1, $0b2e6adb871a3b94$var$tg(b, c), $0b2e6adb871a3b94$var$Mg(b, d, e), $0b2e6adb871a3b94$var$Og(b, d, e, c), $0b2e6adb871a3b94$var$qi(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$Ai(a, b, c);
        case 23:
            return $0b2e6adb871a3b94$var$mi(a, b, c);
        case 24:
            return $0b2e6adb871a3b94$var$mi(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$y(156, b.tag));
};
function $0b2e6adb871a3b94$var$ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$nh(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$ik(a, b, c, d);
}
function $0b2e6adb871a3b94$var$ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$hk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Aa) return 11;
        if (a === $0b2e6adb871a3b94$var$Da) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ua:
            return $0b2e6adb871a3b94$var$Xg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$Ha:
            g = 8;
            e |= 16;
            break;
        case $0b2e6adb871a3b94$var$wa:
            g = 8;
            e |= 1;
            break;
        case $0b2e6adb871a3b94$var$xa:
            return a = $0b2e6adb871a3b94$var$nh(12, c, b, e | 8), a.elementType = $0b2e6adb871a3b94$var$xa, a.type = $0b2e6adb871a3b94$var$xa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ba:
            return a = $0b2e6adb871a3b94$var$nh(13, c, b, e), a.type = $0b2e6adb871a3b94$var$Ba, a.elementType = $0b2e6adb871a3b94$var$Ba, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ca:
            return a = $0b2e6adb871a3b94$var$nh(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ca, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$vi(c, e, f, b);
        case $0b2e6adb871a3b94$var$Ja:
            return a = $0b2e6adb871a3b94$var$nh(24, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$ya:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$za:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Aa:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ea:
                    g = 16;
                    d = null;
                    break a;
                case $0b2e6adb871a3b94$var$Fa:
                    g = 22;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$y(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Xg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$vi(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$nh(23, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Ug(a, b, c) {
    a = $0b2e6adb871a3b94$var$nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Wg(a, b, c) {
    b = $0b2e6adb871a3b94$var$nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$Zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$lk(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$Hg(), g = $0b2e6adb871a3b94$var$Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if ($0b2e6adb871a3b94$var$Zb(c) !== c || 1 !== c.tag) throw Error($0b2e6adb871a3b94$var$y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($0b2e6adb871a3b94$var$Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($0b2e6adb871a3b94$var$y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($0b2e6adb871a3b94$var$Ff(k)) {
                c = $0b2e6adb871a3b94$var$If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $0b2e6adb871a3b94$var$Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $0b2e6adb871a3b94$var$Ag(e, b);
    $0b2e6adb871a3b94$var$Jg(e, g, f);
    return g;
}
function $0b2e6adb871a3b94$var$mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$ok(a, b) {
    $0b2e6adb871a3b94$var$nk(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$nk(a, b);
}
function $0b2e6adb871a3b94$var$pk() {
    return null;
}
function $0b2e6adb871a3b94$var$qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new $0b2e6adb871a3b94$var$jk(a, b, null != c && !0 === c.hydrate);
    b = $0b2e6adb871a3b94$var$nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    $0b2e6adb871a3b94$var$xg(b);
    a[$0b2e6adb871a3b94$var$ff] = c.current;
    $0b2e6adb871a3b94$var$cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
$0b2e6adb871a3b94$var$qk.prototype.render = function(a) {
    $0b2e6adb871a3b94$var$lk(a, this._internalRoot, null, null);
};
$0b2e6adb871a3b94$var$qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    $0b2e6adb871a3b94$var$lk(null, a, null, function() {
        b[$0b2e6adb871a3b94$var$ff] = null;
    });
};
function $0b2e6adb871a3b94$var$rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $0b2e6adb871a3b94$var$qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $0b2e6adb871a3b94$var$tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$mk(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $0b2e6adb871a3b94$var$sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$mk(g);
                k.call(a);
            };
        }
        $0b2e6adb871a3b94$var$Xj(function() {
            $0b2e6adb871a3b94$var$lk(b, g, a, e);
        });
    }
    return $0b2e6adb871a3b94$var$mk(g);
}
$0b2e6adb871a3b94$var$ec = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg();
        $0b2e6adb871a3b94$var$Jg(a, 4, b);
        $0b2e6adb871a3b94$var$ok(a, 4);
    }
};
$0b2e6adb871a3b94$var$fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg();
        $0b2e6adb871a3b94$var$Jg(a, 67108864, b);
        $0b2e6adb871a3b94$var$ok(a, 67108864);
    }
};
$0b2e6adb871a3b94$var$gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Hg(), c = $0b2e6adb871a3b94$var$Ig(a);
        $0b2e6adb871a3b94$var$Jg(a, c, b);
        $0b2e6adb871a3b94$var$ok(a, c);
    }
};
$0b2e6adb871a3b94$var$hc = function(a, b) {
    return b();
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$y(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Wj;
$0b2e6adb871a3b94$var$Hb = function(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 4;
    try {
        return $0b2e6adb871a3b94$var$gg(98, a.bind(null, b, c, d, e));
    } finally{
        $0b2e6adb871a3b94$var$X = f, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
};
$0b2e6adb871a3b94$var$Ib = function() {
    0 === ($0b2e6adb871a3b94$var$X & 49) && ($0b2e6adb871a3b94$var$Vj(), $0b2e6adb871a3b94$var$Oj());
};
$0b2e6adb871a3b94$var$Jb = function(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    $0b2e6adb871a3b94$var$X |= 2;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$X = c, 0 === $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$wj(), $0b2e6adb871a3b94$var$ig());
    }
};
function $0b2e6adb871a3b94$var$uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$kk(a, b, null, c);
}
var $0b2e6adb871a3b94$var$vk = {
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Oj,
        {
            current: !1
        }
    ]
}, $0b2e6adb871a3b94$var$wk = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$xk = {
    bundleType: $0b2e6adb871a3b94$var$wk.bundleType,
    version: $0b2e6adb871a3b94$var$wk.version,
    rendererPackageName: $0b2e6adb871a3b94$var$wk.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$wk.findFiberByHostInstance || $0b2e6adb871a3b94$var$pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$yk.isDisabled && $0b2e6adb871a3b94$var$yk.supportsFiber) try {
        $0b2e6adb871a3b94$var$Lf = $0b2e6adb871a3b94$var$yk.inject($0b2e6adb871a3b94$var$xk), $0b2e6adb871a3b94$var$Mf = $0b2e6adb871a3b94$var$yk;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$vk;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = $0b2e6adb871a3b94$var$uk;
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$y(188));
        throw Error($0b2e6adb871a3b94$var$y(268, Object.keys(a)));
    }
    a = $0b2e6adb871a3b94$var$cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a, b) {
    var c = $0b2e6adb871a3b94$var$X;
    if (0 !== (c & 48)) return a(b);
    $0b2e6adb871a3b94$var$X |= 1;
    try {
        if (a) return $0b2e6adb871a3b94$var$gg(99, a.bind(null, b));
    } finally{
        $0b2e6adb871a3b94$var$X = c, $0b2e6adb871a3b94$var$ig();
    }
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$tk(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$rk(b)) throw Error($0b2e6adb871a3b94$var$y(200));
    return $0b2e6adb871a3b94$var$tk(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$rk(a)) throw Error($0b2e6adb871a3b94$var$y(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Xj(function() {
        $0b2e6adb871a3b94$var$tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$ff] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Wj;
$0b2e6adb871a3b94$export$2577ef5d2565d52f = function(a, b) {
    return $0b2e6adb871a3b94$var$uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$rk(c)) throw Error($0b2e6adb871a3b94$var$y(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$y(38));
    return $0b2e6adb871a3b94$var$tk(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "17.0.2";

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRequire.register("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});



parcelRequire.register("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRequire.register("bilNr", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $839248794b2aa02f$export$2b8d127b894957b9, (v) => $839248794b2aa02f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $839248794b2aa02f$export$cea3a54a6425200c, (v) => $839248794b2aa02f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $839248794b2aa02f$export$a7c73072b1a182ae, (v) => $839248794b2aa02f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $839248794b2aa02f$export$9f27bc3417b4524d, (v) => $839248794b2aa02f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $839248794b2aa02f$export$db77ccec0bb4ccac, (v) => $839248794b2aa02f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $839248794b2aa02f$export$8392c0c9d3dcbd35, (v) => $839248794b2aa02f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $839248794b2aa02f$export$ffb0004e005737fa, (v) => $839248794b2aa02f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $839248794b2aa02f$export$b624eff549462981, (v) => $839248794b2aa02f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $839248794b2aa02f$export$7897aa7841a5380c, (v) => $839248794b2aa02f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $839248794b2aa02f$export$602eac185826482c, (v) => $839248794b2aa02f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $839248794b2aa02f$export$e2c29f18771995cb, (v) => $839248794b2aa02f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $839248794b2aa02f$export$5f8d39834fd61797, (v) => $839248794b2aa02f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $839248794b2aa02f$export$74bf444e3cd11ea5, (v) => $839248794b2aa02f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $839248794b2aa02f$export$92387174baf9b227, (v) => $839248794b2aa02f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $839248794b2aa02f$export$ec112efeb987d9c6, (v) => $839248794b2aa02f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $839248794b2aa02f$export$b706b080d889d2c9, (v) => $839248794b2aa02f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $839248794b2aa02f$export$5be5a87408f70ddc, (v) => $839248794b2aa02f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $839248794b2aa02f$export$45a5e7f76e0caa8d, (v) => $839248794b2aa02f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $839248794b2aa02f$export$455c2e768291efa6, (v) => $839248794b2aa02f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $839248794b2aa02f$export$9522e17588c12572, (v) => $839248794b2aa02f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $839248794b2aa02f$export$2110ac352bb060b9, (v) => $839248794b2aa02f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $839248794b2aa02f$export$56885ab8b9c456ab, (v) => $839248794b2aa02f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $839248794b2aa02f$export$d927fcb6adf8f9de, (v) => $839248794b2aa02f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $839248794b2aa02f$export$b82d16f27459e05a, (v) => $839248794b2aa02f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $839248794b2aa02f$export$522c17b4f5e123e8, (v) => $839248794b2aa02f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $839248794b2aa02f$export$1aabd8a0274ecfd6, (v) => $839248794b2aa02f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $839248794b2aa02f$export$9b621391a187a31a, (v) => $839248794b2aa02f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $839248794b2aa02f$export$f5bbd400c2f4426f, (v) => $839248794b2aa02f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $839248794b2aa02f$export$2b8d127b894957b9;
var $839248794b2aa02f$export$cea3a54a6425200c;
var $839248794b2aa02f$export$a7c73072b1a182ae;
var $839248794b2aa02f$export$9f27bc3417b4524d;
var $839248794b2aa02f$export$db77ccec0bb4ccac;
var $839248794b2aa02f$export$8392c0c9d3dcbd35;
var $839248794b2aa02f$export$ffb0004e005737fa;
var $839248794b2aa02f$export$b624eff549462981;
var $839248794b2aa02f$export$7897aa7841a5380c;
var $839248794b2aa02f$export$602eac185826482c;
var $839248794b2aa02f$export$e2c29f18771995cb;
var $839248794b2aa02f$export$5f8d39834fd61797;
var $839248794b2aa02f$export$74bf444e3cd11ea5;
var $839248794b2aa02f$export$92387174baf9b227;
var $839248794b2aa02f$export$ec112efeb987d9c6;
var $839248794b2aa02f$export$b706b080d889d2c9;
var $839248794b2aa02f$export$5be5a87408f70ddc;
var $839248794b2aa02f$export$45a5e7f76e0caa8d;
var $839248794b2aa02f$export$455c2e768291efa6;
var $839248794b2aa02f$export$9522e17588c12572;
var $839248794b2aa02f$export$2110ac352bb060b9;
var $839248794b2aa02f$export$56885ab8b9c456ab;
var $839248794b2aa02f$export$d927fcb6adf8f9de;
var $839248794b2aa02f$export$b82d16f27459e05a;
var $839248794b2aa02f$export$522c17b4f5e123e8;
var $839248794b2aa02f$export$1aabd8a0274ecfd6;
var $839248794b2aa02f$export$9b621391a187a31a;
var $839248794b2aa02f$export$f5bbd400c2f4426f;
"use strict";
var $839248794b2aa02f$var$b = "function" === typeof Symbol && Symbol.for, $839248794b2aa02f$var$c = $839248794b2aa02f$var$b ? Symbol.for("react.element") : 60103, $839248794b2aa02f$var$d = $839248794b2aa02f$var$b ? Symbol.for("react.portal") : 60106, $839248794b2aa02f$var$e = $839248794b2aa02f$var$b ? Symbol.for("react.fragment") : 60107, $839248794b2aa02f$var$f = $839248794b2aa02f$var$b ? Symbol.for("react.strict_mode") : 60108, $839248794b2aa02f$var$g = $839248794b2aa02f$var$b ? Symbol.for("react.profiler") : 60114, $839248794b2aa02f$var$h = $839248794b2aa02f$var$b ? Symbol.for("react.provider") : 60109, $839248794b2aa02f$var$k = $839248794b2aa02f$var$b ? Symbol.for("react.context") : 60110, $839248794b2aa02f$var$l = $839248794b2aa02f$var$b ? Symbol.for("react.async_mode") : 60111, $839248794b2aa02f$var$m = $839248794b2aa02f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $839248794b2aa02f$var$n = $839248794b2aa02f$var$b ? Symbol.for("react.forward_ref") : 60112, $839248794b2aa02f$var$p = $839248794b2aa02f$var$b ? Symbol.for("react.suspense") : 60113, $839248794b2aa02f$var$q = $839248794b2aa02f$var$b ? Symbol.for("react.suspense_list") : 60120, $839248794b2aa02f$var$r = $839248794b2aa02f$var$b ? Symbol.for("react.memo") : 60115, $839248794b2aa02f$var$t = $839248794b2aa02f$var$b ? Symbol.for("react.lazy") : 60116, $839248794b2aa02f$var$v = $839248794b2aa02f$var$b ? Symbol.for("react.block") : 60121, $839248794b2aa02f$var$w = $839248794b2aa02f$var$b ? Symbol.for("react.fundamental") : 60117, $839248794b2aa02f$var$x = $839248794b2aa02f$var$b ? Symbol.for("react.responder") : 60118, $839248794b2aa02f$var$y = $839248794b2aa02f$var$b ? Symbol.for("react.scope") : 60119;
function $839248794b2aa02f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $839248794b2aa02f$var$c:
                switch(a = a.type, a){
                    case $839248794b2aa02f$var$l:
                    case $839248794b2aa02f$var$m:
                    case $839248794b2aa02f$var$e:
                    case $839248794b2aa02f$var$g:
                    case $839248794b2aa02f$var$f:
                    case $839248794b2aa02f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $839248794b2aa02f$var$k:
                            case $839248794b2aa02f$var$n:
                            case $839248794b2aa02f$var$t:
                            case $839248794b2aa02f$var$r:
                            case $839248794b2aa02f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $839248794b2aa02f$var$d:
                return u;
        }
    }
}
function $839248794b2aa02f$var$A(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$m;
}
$839248794b2aa02f$export$2b8d127b894957b9 = $839248794b2aa02f$var$l;
$839248794b2aa02f$export$cea3a54a6425200c = $839248794b2aa02f$var$m;
$839248794b2aa02f$export$a7c73072b1a182ae = $839248794b2aa02f$var$k;
$839248794b2aa02f$export$9f27bc3417b4524d = $839248794b2aa02f$var$h;
$839248794b2aa02f$export$db77ccec0bb4ccac = $839248794b2aa02f$var$c;
$839248794b2aa02f$export$8392c0c9d3dcbd35 = $839248794b2aa02f$var$n;
$839248794b2aa02f$export$ffb0004e005737fa = $839248794b2aa02f$var$e;
$839248794b2aa02f$export$b624eff549462981 = $839248794b2aa02f$var$t;
$839248794b2aa02f$export$7897aa7841a5380c = $839248794b2aa02f$var$r;
$839248794b2aa02f$export$602eac185826482c = $839248794b2aa02f$var$d;
$839248794b2aa02f$export$e2c29f18771995cb = $839248794b2aa02f$var$g;
$839248794b2aa02f$export$5f8d39834fd61797 = $839248794b2aa02f$var$f;
$839248794b2aa02f$export$74bf444e3cd11ea5 = $839248794b2aa02f$var$p;
$839248794b2aa02f$export$92387174baf9b227 = function(a) {
    return $839248794b2aa02f$var$A(a) || $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$l;
};
$839248794b2aa02f$export$ec112efeb987d9c6 = $839248794b2aa02f$var$A;
$839248794b2aa02f$export$b706b080d889d2c9 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$k;
};
$839248794b2aa02f$export$5be5a87408f70ddc = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$h;
};
$839248794b2aa02f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $839248794b2aa02f$var$c;
};
$839248794b2aa02f$export$455c2e768291efa6 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$n;
};
$839248794b2aa02f$export$9522e17588c12572 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$e;
};
$839248794b2aa02f$export$2110ac352bb060b9 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$t;
};
$839248794b2aa02f$export$56885ab8b9c456ab = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$r;
};
$839248794b2aa02f$export$d927fcb6adf8f9de = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$d;
};
$839248794b2aa02f$export$b82d16f27459e05a = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$g;
};
$839248794b2aa02f$export$522c17b4f5e123e8 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$f;
};
$839248794b2aa02f$export$1aabd8a0274ecfd6 = function(a) {
    return $839248794b2aa02f$var$z(a) === $839248794b2aa02f$var$p;
};
$839248794b2aa02f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $839248794b2aa02f$var$e || a === $839248794b2aa02f$var$m || a === $839248794b2aa02f$var$g || a === $839248794b2aa02f$var$f || a === $839248794b2aa02f$var$p || a === $839248794b2aa02f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $839248794b2aa02f$var$t || a.$$typeof === $839248794b2aa02f$var$r || a.$$typeof === $839248794b2aa02f$var$h || a.$$typeof === $839248794b2aa02f$var$k || a.$$typeof === $839248794b2aa02f$var$n || a.$$typeof === $839248794b2aa02f$var$w || a.$$typeof === $839248794b2aa02f$var$x || a.$$typeof === $839248794b2aa02f$var$y || a.$$typeof === $839248794b2aa02f$var$v);
};
$839248794b2aa02f$export$f5bbd400c2f4426f = $839248794b2aa02f$var$z;

});

parcelRequire.register("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
"use strict";
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});

parcelRequire.register("iAQWD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $dOKmX.default;
    }
});

var $dOKmX = parcelRequire("dOKmX");

});
parcelRequire.register("dOKmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f3e9d6a9c8d8fe$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8DzwJ = parcelRequire("8DzwJ");
function $a0f3e9d6a9c8d8fe$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8DzwJ.default), (0, $8nd05.default)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $8DzwJ.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(Component));
}

});
parcelRequire.register("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("8DzwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $649d8625f2bd4c7a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");

var $f9tk6 = parcelRequire("f9tk6");
var $649d8625f2bd4c7a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: "none",
            width: "1em",
            height: "1em",
            display: "inline-block",
            fill: "currentColor",
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create("fill", {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: "inherit"
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $649d8625f2bd4c7a$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "inherit" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "svg" : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? "medium" : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $f9tk6.default)(color))], fontSize !== "default" && fontSize !== "medium" && classes["fontSize".concat((0, $f9tk6.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $acw62.createElement("title", null, titleAccess) : null);
});
$649d8625f2bd4c7a$var$SvgIcon.muiName = "SvgIcon";
var $649d8625f2bd4c7a$export$2e2bcd8739ae039 = (0, $kQaj4.default)($649d8625f2bd4c7a$export$9dd6ff9ea0189349, {
    name: "MuiSvgIcon"
})($649d8625f2bd4c7a$var$SvgIcon);

});
parcelRequire.register("9X7IJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ef9ce1c41fc0c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $1En50.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRequire.register("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRequire.register("1SA7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e6d94060e5d8b6$export$2e2bcd8739ae039);
function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;

});

parcelRequire.register("kQaj4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2c0a8a0351a1ae8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $5MMTt = parcelRequire("5MMTt");

var $kpDC5 = parcelRequire("kpDC5");
function $f2c0a8a0351a1ae8$var$withStyles(stylesOrCreator, options) {
    return (0, $5MMTt.default)(stylesOrCreator, (0, $8nd05.default)({
        defaultTheme: (0, $kpDC5.default)
    }, options));
}
var $f2c0a8a0351a1ae8$export$2e2bcd8739ae039 = $f2c0a8a0351a1ae8$var$withStyles;

});
parcelRequire.register("5MMTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $43675cbaf8adb2d8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $9ORqK = parcelRequire("9ORqK");


var $cp2NC = parcelRequire("cp2NC");

var $kD2D5 = parcelRequire("kD2D5");

var $gkNc2 = parcelRequire("gkNc2");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $43675cbaf8adb2d8$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $9X7IJ.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $cp2NC.default)(stylesOrCreator, (0, $8nd05.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $9X7IJ.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $8nd05.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === "string" || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $gkNc2.default)() || defaultTheme;
                if (name) more = (0, $kD2D5.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(WithStyles, Component);
        return WithStyles;
    };
};
var $43675cbaf8adb2d8$export$2e2bcd8739ae039 = $43675cbaf8adb2d8$var$withStyles;

});
parcelRequire.register("9ORqK", function(module, exports) {
"use strict";

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRequire.register("2qzd6", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dNL7g"));

});


parcelRequire.register("cp2NC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9079fdbaeaed29d2$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $f88hq = parcelRequire("f88hq");

var $fuTKz = parcelRequire("fuTKz");

var $elV9Y = parcelRequire("elV9Y");

var $gkNc2 = parcelRequire("gkNc2");

var $3WzLW = parcelRequire("3WzLW");

var $edKwj = parcelRequire("edKwj");

var $77xio = parcelRequire("77xio");

var $ei4PC = parcelRequire("ei4PC");
function $9079fdbaeaed29d2$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $fuTKz.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $9079fdbaeaed29d2$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $elV9Y.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $elV9Y.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $8nd05.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $elV9Y.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $8nd05.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $elV9Y.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $f88hq.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $8nd05.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $fuTKz.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $9079fdbaeaed29d2$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $9079fdbaeaed29d2$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $elV9Y.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $elV9Y.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $9079fdbaeaed29d2$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $9079fdbaeaed29d2$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $ei4PC.default) : _options$defaultTheme, stylesOptions2 = (0, $9X7IJ.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $77xio.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $edKwj.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $gkNc2.default)() || defaultTheme;
        var stylesOptions = (0, $8nd05.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $3WzLW.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
        $9079fdbaeaed29d2$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $9079fdbaeaed29d2$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $9079fdbaeaed29d2$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
            if (shouldUpdate.current) $9079fdbaeaed29d2$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $9079fdbaeaed29d2$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRequire.register("f88hq", function(module, exports) {

$parcel$export(module.exports, "createRule", () => $b03e06a37d110f0d$export$56e87122f905fac0);
$parcel$export(module.exports, "toCssValue", () => $b03e06a37d110f0d$export$5ac341d5e3cf9273);
$parcel$export(module.exports, "RuleList", () => $b03e06a37d110f0d$export$d9da2a13178d3d68);
$parcel$export(module.exports, "create", () => $b03e06a37d110f0d$export$185802fd694ee1f5);
$parcel$export(module.exports, "hasCSSTOMSupport", () => $b03e06a37d110f0d$export$2305122a7d881dec);
$parcel$export(module.exports, "getDynamicStyles", () => $b03e06a37d110f0d$export$8558f2aefa046992);

var $8nd05 = parcelRequire("8nd05");

var $ja49S = parcelRequire("ja49S");

var $9RYKL = parcelRequire("9RYKL");

var $cHPF9 = parcelRequire("cHPF9");

var $g7ajw = parcelRequire("g7ajw");

var $hDpcU = parcelRequire("hDpcU");

var $1En50 = parcelRequire("1En50");
var $b03e06a37d110f0d$var$plainObjectConstrurctor = {}.constructor;
function $b03e06a37d110f0d$var$cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map($b03e06a37d110f0d$var$cloneStyle);
    if (style.constructor !== $b03e06a37d110f0d$var$plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = $b03e06a37d110f0d$var$cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function $b03e06a37d110f0d$export$56e87122f905fac0(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = $b03e06a37d110f0d$var$cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var $b03e06a37d110f0d$var$join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var $b03e06a37d110f0d$export$5ac341d5e3cf9273 = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += $b03e06a37d110f0d$var$join(value[i], " ");
    }
    else cssValue = $b03e06a37d110f0d$var$join(value, ", "); // Add !important, because it was ignored.
    if (value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
};
function $b03e06a37d110f0d$var$getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: "",
        space: ""
    };
    return {
        linebreak: "\n",
        space: " "
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function $b03e06a37d110f0d$var$indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function $b03e06a37d110f0d$var$toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += $b03e06a37d110f0d$var$indentStr(prop + ":" + space + $b03e06a37d110f0d$export$5ac341d5e3cf9273(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += $b03e06a37d110f0d$var$indentStr(_prop + ":" + space + $b03e06a37d110f0d$export$5ac341d5e3cf9273(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += linebreak;
            result += $b03e06a37d110f0d$var$indentStr(_prop2 + ":" + space + $b03e06a37d110f0d$export$5ac341d5e3cf9273(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return $b03e06a37d110f0d$var$indentStr("" + selector + space + "{" + result, indent) + $b03e06a37d110f0d$var$indentStr("}", indent);
}
var $b03e06a37d110f0d$var$escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var $b03e06a37d110f0d$var$nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var $b03e06a37d110f0d$var$escape = function(str) {
    return $b03e06a37d110f0d$var$nativeEscape ? $b03e06a37d110f0d$var$nativeEscape(str) : str.replace($b03e06a37d110f0d$var$escapeRegex, "\\$1");
};
var $b03e06a37d110f0d$var$BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var $b03e06a37d110f0d$var$StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $g7ajw.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $hDpcU.default)((0, $hDpcU.default)(_this)), sheet);
            _this.selectorText = "." + $b03e06a37d110f0d$var$escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = $b03e06a37d110f0d$export$5ac341d5e3cf9273(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $8nd05.default)({}, options, {
            allowEmpty: true
        }) : options;
        return $b03e06a37d110f0d$var$toCss(this.selectorText, this.style, opts);
    };
    (0, $cHPF9.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}($b03e06a37d110f0d$var$BaseStyleRule);
var $b03e06a37d110f0d$var$pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new $b03e06a37d110f0d$var$StyleRule(key, style, options);
    }
};
var $b03e06a37d110f0d$var$defaultToStringOptions = {
    indent: 1,
    children: true
};
var $b03e06a37d110f0d$var$atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var $b03e06a37d110f0d$var$ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match($b03e06a37d110f0d$var$atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown"; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new $b03e06a37d110f0d$export$d9da2a13178d3d68((0, $8nd05.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $b03e06a37d110f0d$var$defaultToStringOptions;
        var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = $b03e06a37d110f0d$var$defaultToStringOptions.indent;
        if (options.children == null) options.children = $b03e06a37d110f0d$var$defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
    };
    return ConditionalRule;
}();
var $b03e06a37d110f0d$var$keyRegExp = /@container|@media|@supports\s+/;
var $b03e06a37d110f0d$var$pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return $b03e06a37d110f0d$var$keyRegExp.test(key) ? new $b03e06a37d110f0d$var$ConditionalRule(key, styles, options) : null;
    }
};
var $b03e06a37d110f0d$var$defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var $b03e06a37d110f0d$var$nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var $b03e06a37d110f0d$var$KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.isProcessed = false;
        var nameMatch = key.match($b03e06a37d110f0d$var$nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : $b03e06a37d110f0d$var$escape(generateId(this, sheet));
        this.rules = new $b03e06a37d110f0d$export$d9da2a13178d3d68((0, $8nd05.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $8nd05.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $b03e06a37d110f0d$var$defaultToStringOptions$1;
        var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = $b03e06a37d110f0d$var$defaultToStringOptions$1.indent;
        if (options.children == null) options.children = $b03e06a37d110f0d$var$defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var $b03e06a37d110f0d$var$keyRegExp$1 = /@keyframes\s+/;
var $b03e06a37d110f0d$var$refRegExp = /\$([\w-]+)/g;
var $b03e06a37d110f0d$var$findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace($b03e06a37d110f0d$var$refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var $b03e06a37d110f0d$var$replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = $b03e06a37d110f0d$var$findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var $b03e06a37d110f0d$var$pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && $b03e06a37d110f0d$var$keyRegExp$1.test(key) ? new $b03e06a37d110f0d$var$KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) $b03e06a37d110f0d$var$replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) $b03e06a37d110f0d$var$replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return $b03e06a37d110f0d$var$findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return $b03e06a37d110f0d$var$findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var $b03e06a37d110f0d$var$KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $g7ajw.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $8nd05.default)({}, options, {
            allowEmpty: true
        }) : options;
        return $b03e06a37d110f0d$var$toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}($b03e06a37d110f0d$var$BaseStyleRule);
var $b03e06a37d110f0d$var$pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new $b03e06a37d110f0d$var$KeyframeRule(key, style, options);
        return null;
    }
};
var $b03e06a37d110f0d$var$FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += $b03e06a37d110f0d$var$toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return $b03e06a37d110f0d$var$toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var $b03e06a37d110f0d$var$keyRegExp$2 = /@font-face/;
var $b03e06a37d110f0d$var$pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return $b03e06a37d110f0d$var$keyRegExp$2.test(key) ? new $b03e06a37d110f0d$var$FontFaceRule(key, style, options) : null;
    }
};
var $b03e06a37d110f0d$var$ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return $b03e06a37d110f0d$var$toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var $b03e06a37d110f0d$var$pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new $b03e06a37d110f0d$var$ViewportRule(key, style, options) : null;
    }
};
var $b03e06a37d110f0d$var$SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var $b03e06a37d110f0d$var$keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var $b03e06a37d110f0d$var$pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in $b03e06a37d110f0d$var$keysMap ? new $b03e06a37d110f0d$var$SimpleRule(key, value, options) : null;
    }
};
var $b03e06a37d110f0d$var$plugins = [
    $b03e06a37d110f0d$var$pluginStyleRule,
    $b03e06a37d110f0d$var$pluginConditionalRule,
    $b03e06a37d110f0d$var$pluginKeyframesRule,
    $b03e06a37d110f0d$var$pluginKeyframeRule,
    $b03e06a37d110f0d$var$pluginFontFaceRule,
    $b03e06a37d110f0d$var$pluginViewportRule,
    $b03e06a37d110f0d$var$pluginSimpleRule
];
var $b03e06a37d110f0d$var$defaultUpdateOptions = {
    process: true
};
var $b03e06a37d110f0d$var$forceUpdateOptions = {
    force: true,
    process: true
};
var $b03e06a37d110f0d$export$d9da2a13178d3d68 = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $8nd05.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + $b03e06a37d110f0d$var$escape(this.classes[key]);
        var rule = $b03e06a37d110f0d$export$56e87122f905fac0(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $8nd05.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof $b03e06a37d110f0d$var$StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof $b03e06a37d110f0d$var$KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof $b03e06a37d110f0d$var$StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof $b03e06a37d110f0d$var$KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = $b03e06a37d110f0d$var$defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, $b03e06a37d110f0d$var$forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, $b03e06a37d110f0d$var$forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var $b03e06a37d110f0d$var$StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $8nd05.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new $b03e06a37d110f0d$export$d9da2a13178d3d68(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var $b03e06a37d110f0d$var$PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var $b03e06a37d110f0d$export$bcb2f1d96ff51db3 = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $1En50.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = $b03e06a37d110f0d$var$getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $cHPF9.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var $b03e06a37d110f0d$export$d1f2fc3a3d47c5af = new $b03e06a37d110f0d$export$bcb2f1d96ff51db3();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var $b03e06a37d110f0d$var$globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var $b03e06a37d110f0d$var$ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if ($b03e06a37d110f0d$var$globalThis$1[$b03e06a37d110f0d$var$ns] == null) $b03e06a37d110f0d$var$globalThis$1[$b03e06a37d110f0d$var$ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var $b03e06a37d110f0d$var$moduleId = $b03e06a37d110f0d$var$globalThis$1[$b03e06a37d110f0d$var$ns]++;
var $b03e06a37d110f0d$var$maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var $b03e06a37d110f0d$export$ddff9cce7c732c82 = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + $b03e06a37d110f0d$var$moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + $b03e06a37d110f0d$var$moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var $b03e06a37d110f0d$var$memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var $b03e06a37d110f0d$var$getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
};
/**
 * Set a style property.
 */ var $b03e06a37d110f0d$var$setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = $b03e06a37d110f0d$export$5ac341d5e3cf9273(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var $b03e06a37d110f0d$var$removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var $b03e06a37d110f0d$var$setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var $b03e06a37d110f0d$var$getHead = $b03e06a37d110f0d$var$memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function $b03e06a37d110f0d$var$findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function $b03e06a37d110f0d$var$findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function $b03e06a37d110f0d$var$findCommentNode(text) {
    var head = $b03e06a37d110f0d$var$getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function $b03e06a37d110f0d$var$findPrevNode(options) {
    var registry = $b03e06a37d110f0d$export$d1f2fc3a3d47c5af.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = $b03e06a37d110f0d$var$findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = $b03e06a37d110f0d$var$findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = $b03e06a37d110f0d$var$findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function $b03e06a37d110f0d$var$insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = $b03e06a37d110f0d$var$findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    $b03e06a37d110f0d$var$getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var $b03e06a37d110f0d$var$getNonce = $b03e06a37d110f0d$var$memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var $b03e06a37d110f0d$var$_insertRule = function insertRule(container, rule, index) {
    try {
        if ("insertRule" in container) container.insertRule(rule, index);
        else if ("appendRule" in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var $b03e06a37d110f0d$var$getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var $b03e06a37d110f0d$var$createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var $b03e06a37d110f0d$var$DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = $b03e06a37d110f0d$var$getPropertyValue;
        this.setProperty = $b03e06a37d110f0d$var$setProperty;
        this.removeProperty = $b03e06a37d110f0d$var$removeProperty;
        this.setSelector = $b03e06a37d110f0d$var$setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) $b03e06a37d110f0d$export$d1f2fc3a3d47c5af.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || $b03e06a37d110f0d$var$createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = $b03e06a37d110f0d$var$getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        $b03e06a37d110f0d$var$insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = "\n";
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                var _insertionIndex = $b03e06a37d110f0d$var$getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = $b03e06a37d110f0d$var$_insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = $b03e06a37d110f0d$var$getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = $b03e06a37d110f0d$var$_insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof $b03e06a37d110f0d$var$StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var $b03e06a37d110f0d$var$instanceCounter = 0;
var $b03e06a37d110f0d$var$Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = $b03e06a37d110f0d$var$instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new $b03e06a37d110f0d$var$PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: $b03e06a37d110f0d$export$ddff9cce7c732c82,
            Renderer: (0, $ja49S.default) ? $b03e06a37d110f0d$var$DomRenderer : null,
            plugins: []
        };
        this.generateId = $b03e06a37d110f0d$export$ddff9cce7c732c82({
            minify: false
        });
        for(var i = 0; i < $b03e06a37d110f0d$var$plugins.length; i++)this.plugins.use($b03e06a37d110f0d$var$plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $8nd05.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = $b03e06a37d110f0d$export$d1f2fc3a3d47c5af.index === 0 ? 0 : $b03e06a37d110f0d$export$d1f2fc3a3d47c5af.index + 1;
        var sheet = new $b03e06a37d110f0d$var$StyleSheet(styles, (0, $8nd05.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        $b03e06a37d110f0d$export$d1f2fc3a3d47c5af.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $8nd05.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = $b03e06a37d110f0d$export$56e87122f905fac0(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var $b03e06a37d110f0d$export$185802fd694ee1f5 = function createJss(options) {
    return new $b03e06a37d110f0d$var$Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var $b03e06a37d110f0d$export$c72bb5031d779271 = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $9RYKL.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $9RYKL.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $cHPF9.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var $b03e06a37d110f0d$export$2305122a7d881dec = typeof CSS === "object" && CSS != null && "number" in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function $b03e06a37d110f0d$export$8558f2aefa046992(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = $b03e06a37d110f0d$export$8558f2aefa046992(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var $b03e06a37d110f0d$var$index = $b03e06a37d110f0d$export$185802fd694ee1f5();
var $b03e06a37d110f0d$export$2e2bcd8739ae039 = $b03e06a37d110f0d$var$index;

});
parcelRequire.register("ja49S", function(module, exports) {

$parcel$export(module.exports, "default", () => $df322d3da36c941f$export$2e2bcd8739ae039);
var $df322d3da36c941f$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $df322d3da36c941f$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $df322d3da36c941f$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $df322d3da36c941f$var$_typeof(document)) === "object" && document.nodeType === 9;
var $df322d3da36c941f$export$2e2bcd8739ae039 = $df322d3da36c941f$export$4e09c449d6c407f7;

});

parcelRequire.register("9RYKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = true;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRequire.register("cHPF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94019358ecbcf36b$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $4ZreY.default)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRequire.register("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $cXkjo.default)(arg, "string");
    return (0, $fSwVM.default)(key) === "symbol" ? key : String(key);
}

});
parcelRequire.register("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(obj);
}

});

parcelRequire.register("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $fSwVM.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $fSwVM.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});



parcelRequire.register("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $VFVve.default)(subClass, superClass);
}

});
parcelRequire.register("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}

});


parcelRequire.register("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});


parcelRequire.register("fuTKz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b484e72b32d8ffe0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

function $b484e72b32d8ffe0$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $8nd05.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRequire.register("elV9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $a72f5da279949b47$export$2e2bcd8739ae039);
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $a72f5da279949b47$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $a72f5da279949b47$export$2e2bcd8739ae039 = $a72f5da279949b47$var$multiKeyStore;

});

parcelRequire.register("gkNc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $be44ac57ed98aab1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $k4AIz = parcelRequire("k4AIz");
function $be44ac57ed98aab1$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $k4AIz.default));
    return theme;
}

});
parcelRequire.register("k4AIz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9d0a9c2589c7bd2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $e9d0a9c2589c7bd2$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $e9d0a9c2589c7bd2$export$2e2bcd8739ae039 = $e9d0a9c2589c7bd2$var$ThemeContext;

});


parcelRequire.register("3WzLW", function(module, exports) {

$parcel$export(module.exports, "StylesContext", () => $2df2897c2ec768dd$export$f4de434b269fe487);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");



var $c1WaC = parcelRequire("c1WaC");

var $f88hq = parcelRequire("f88hq");

var $hKuvS = parcelRequire("hKuvS");
var $2df2897c2ec768dd$var$jss = (0, $f88hq.create)((0, $hKuvS.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $2df2897c2ec768dd$var$generateClassName = (0, $c1WaC.default)(); // Exported for test purposes
var $2df2897c2ec768dd$export$70a8aea9ff58d1cd = new Map();
var $2df2897c2ec768dd$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $2df2897c2ec768dd$var$generateClassName,
    jss: $2df2897c2ec768dd$var$jss,
    sheetsCache: null,
    sheetsManager: $2df2897c2ec768dd$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $2df2897c2ec768dd$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($2df2897c2ec768dd$var$defaultOptions);
var $2df2897c2ec768dd$var$injectFirstNode;
function $2df2897c2ec768dd$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $9X7IJ.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($2df2897c2ec768dd$export$f4de434b269fe487);
    var context = (0, $8nd05.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
        if (!$2df2897c2ec768dd$var$injectFirstNode) {
            var head = document.head;
            $2df2897c2ec768dd$var$injectFirstNode = document.createComment("mui-inject-first");
            head.insertBefore($2df2897c2ec768dd$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $f88hq.create)({
            plugins: (0, $hKuvS.default)().plugins,
            insertionPoint: $2df2897c2ec768dd$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2df2897c2ec768dd$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRequire.register("c1WaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c22b3722ab1cf60$export$2e2bcd8739ae039);

var $bh5Jy = parcelRequire("bh5Jy");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $8c22b3722ab1cf60$var$pseudoClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
]; // Returns a function which generates unique class names based on counters.
function $8c22b3722ab1cf60$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? "jss" : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? "" : _options$seed;
    var seedPrefix = seed === "" ? "" : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($8c22b3722ab1cf60$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $bh5Jy.default] || seed !== "") return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRequire.register("bh5Jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8355bad52e752880$export$2e2bcd8739ae039);
var $8355bad52e752880$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $8355bad52e752880$export$2e2bcd8739ae039 = $8355bad52e752880$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRequire.register("hKuvS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cebe66cb81fac901$export$2e2bcd8739ae039);

var $f6oht = parcelRequire("f6oht");

var $29zp1 = parcelRequire("29zp1");

var $dj0fa = parcelRequire("dj0fa");

var $87e0Y = parcelRequire("87e0Y");

var $75add = parcelRequire("75add");

var $81Rrl = parcelRequire("81Rrl");

var $3TmXG = parcelRequire("3TmXG");
function $cebe66cb81fac901$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $f6oht.default)(),
            (0, $29zp1.default)(),
            (0, $dj0fa.default)(),
            (0, $87e0Y.default)(),
            (0, $75add.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $81Rrl.default)(),
            (0, $3TmXG.default)()
        ]
    };
}

});
parcelRequire.register("f6oht", function(module, exports) {

$parcel$export(module.exports, "default", () => $afea4036e4b96092$export$2e2bcd8739ae039);


var $f88hq = parcelRequire("f88hq");
var $afea4036e4b96092$var$now = Date.now();
var $afea4036e4b96092$var$fnValuesNs = "fnValues" + $afea4036e4b96092$var$now;
var $afea4036e4b96092$var$fnRuleNs = "fnStyle" + ++$afea4036e4b96092$var$now;
var $afea4036e4b96092$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $f88hq.createRule)(name, {}, options);
            rule[$afea4036e4b96092$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($afea4036e4b96092$var$fnValuesNs in rule || $afea4036e4b96092$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$afea4036e4b96092$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$afea4036e4b96092$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$afea4036e4b96092$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $afea4036e4b96092$export$2e2bcd8739ae039 = $afea4036e4b96092$var$functionPlugin;

});

parcelRequire.register("29zp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1917e24186a6046e$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $f88hq = parcelRequire("f88hq");
var $1917e24186a6046e$var$at = "@global";
var $1917e24186a6046e$var$atPrefix = "@global ";
var $1917e24186a6046e$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $1917e24186a6046e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $f88hq.RuleList)((0, $8nd05.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $1917e24186a6046e$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $1917e24186a6046e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($1917e24186a6046e$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $8nd05.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $1917e24186a6046e$var$separatorRegExp = /\s*,\s*/g;
function $1917e24186a6046e$var$addScope(selector, scope) {
    var parts = selector.split($1917e24186a6046e$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $1917e24186a6046e$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$1917e24186a6046e$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $8nd05.default)({}, options, {
        selector: $1917e24186a6046e$var$addScope(name, rule.selector)
    }));
    delete style[$1917e24186a6046e$var$at];
}
function $1917e24186a6046e$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $1917e24186a6046e$var$at.length) !== $1917e24186a6046e$var$at) continue;
        var selector = $1917e24186a6046e$var$addScope(prop.substr($1917e24186a6046e$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $8nd05.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $1917e24186a6046e$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $1917e24186a6046e$var$at) return new $1917e24186a6046e$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $1917e24186a6046e$var$atPrefix.length) === $1917e24186a6046e$var$atPrefix) return new $1917e24186a6046e$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== "style" || !sheet) return;
        $1917e24186a6046e$var$handleNestedGlobalContainerRule(rule, sheet);
        $1917e24186a6046e$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $1917e24186a6046e$export$2e2bcd8739ae039 = $1917e24186a6046e$var$jssGlobal;

});

parcelRequire.register("dj0fa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9afd3d12d6cbc635$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9afd3d12d6cbc635$var$separatorRegExp = /\s*,\s*/g;
var $9afd3d12d6cbc635$var$parentRegExp = /&/g;
var $9afd3d12d6cbc635$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $9afd3d12d6cbc635$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($9afd3d12d6cbc635$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($9afd3d12d6cbc635$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($9afd3d12d6cbc635$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $8nd05.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $8nd05.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($9afd3d12d6cbc635$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ("replaceRule" in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $8nd05.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $8nd05.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $9afd3d12d6cbc635$export$2e2bcd8739ae039 = $9afd3d12d6cbc635$var$jssNested;

});

parcelRequire.register("87e0Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e89d92f45e570c6$export$2e2bcd8739ae039);

var $hrHWs = parcelRequire("hrHWs");
/**
 * Convert camel cased property names to dash separated.
 */ function $5e89d92f45e570c6$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $hrHWs.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($5e89d92f45e570c6$var$convertCase);
        else converted.fallbacks = $5e89d92f45e570c6$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $5e89d92f45e570c6$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $5e89d92f45e570c6$var$convertCase(style[index]);
            return style;
        }
        return $5e89d92f45e570c6$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $hrHWs.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5e89d92f45e570c6$export$2e2bcd8739ae039 = $5e89d92f45e570c6$var$camelCase;

});
parcelRequire.register("hrHWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb370b3f4a9491f5$export$2e2bcd8739ae039);
/* eslint-disable no-var, prefer-template */ var $cb370b3f4a9491f5$var$uppercasePattern = /[A-Z]/g;
var $cb370b3f4a9491f5$var$msPattern = /^ms-/;
var $cb370b3f4a9491f5$var$cache = {};
function $cb370b3f4a9491f5$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $cb370b3f4a9491f5$var$hyphenateStyleName(name) {
    if ($cb370b3f4a9491f5$var$cache.hasOwnProperty(name)) return $cb370b3f4a9491f5$var$cache[name];
    var hName = name.replace($cb370b3f4a9491f5$var$uppercasePattern, $cb370b3f4a9491f5$var$toHyphenLower);
    return $cb370b3f4a9491f5$var$cache[name] = $cb370b3f4a9491f5$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $cb370b3f4a9491f5$export$2e2bcd8739ae039 = $cb370b3f4a9491f5$var$hyphenateStyleName;

});


parcelRequire.register("75add", function(module, exports) {

$parcel$export(module.exports, "default", () => $5280ebef38a3c5c6$export$2e2bcd8739ae039);

var $f88hq = parcelRequire("f88hq");
var $5280ebef38a3c5c6$var$px = (0, $f88hq.hasCSSTOMSupport) && CSS ? CSS.px : "px";
var $5280ebef38a3c5c6$var$ms = (0, $f88hq.hasCSSTOMSupport) && CSS ? CSS.ms : "ms";
var $5280ebef38a3c5c6$var$percent = (0, $f88hq.hasCSSTOMSupport) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $5280ebef38a3c5c6$var$defaultUnits = {
    // Animation properties
    "animation-delay": $5280ebef38a3c5c6$var$ms,
    "animation-duration": $5280ebef38a3c5c6$var$ms,
    // Background properties
    "background-position": $5280ebef38a3c5c6$var$px,
    "background-position-x": $5280ebef38a3c5c6$var$px,
    "background-position-y": $5280ebef38a3c5c6$var$px,
    "background-size": $5280ebef38a3c5c6$var$px,
    // Border Properties
    border: $5280ebef38a3c5c6$var$px,
    "border-bottom": $5280ebef38a3c5c6$var$px,
    "border-bottom-left-radius": $5280ebef38a3c5c6$var$px,
    "border-bottom-right-radius": $5280ebef38a3c5c6$var$px,
    "border-bottom-width": $5280ebef38a3c5c6$var$px,
    "border-left": $5280ebef38a3c5c6$var$px,
    "border-left-width": $5280ebef38a3c5c6$var$px,
    "border-radius": $5280ebef38a3c5c6$var$px,
    "border-right": $5280ebef38a3c5c6$var$px,
    "border-right-width": $5280ebef38a3c5c6$var$px,
    "border-top": $5280ebef38a3c5c6$var$px,
    "border-top-left-radius": $5280ebef38a3c5c6$var$px,
    "border-top-right-radius": $5280ebef38a3c5c6$var$px,
    "border-top-width": $5280ebef38a3c5c6$var$px,
    "border-width": $5280ebef38a3c5c6$var$px,
    "border-block": $5280ebef38a3c5c6$var$px,
    "border-block-end": $5280ebef38a3c5c6$var$px,
    "border-block-end-width": $5280ebef38a3c5c6$var$px,
    "border-block-start": $5280ebef38a3c5c6$var$px,
    "border-block-start-width": $5280ebef38a3c5c6$var$px,
    "border-block-width": $5280ebef38a3c5c6$var$px,
    "border-inline": $5280ebef38a3c5c6$var$px,
    "border-inline-end": $5280ebef38a3c5c6$var$px,
    "border-inline-end-width": $5280ebef38a3c5c6$var$px,
    "border-inline-start": $5280ebef38a3c5c6$var$px,
    "border-inline-start-width": $5280ebef38a3c5c6$var$px,
    "border-inline-width": $5280ebef38a3c5c6$var$px,
    "border-start-start-radius": $5280ebef38a3c5c6$var$px,
    "border-start-end-radius": $5280ebef38a3c5c6$var$px,
    "border-end-start-radius": $5280ebef38a3c5c6$var$px,
    "border-end-end-radius": $5280ebef38a3c5c6$var$px,
    // Margin properties
    margin: $5280ebef38a3c5c6$var$px,
    "margin-bottom": $5280ebef38a3c5c6$var$px,
    "margin-left": $5280ebef38a3c5c6$var$px,
    "margin-right": $5280ebef38a3c5c6$var$px,
    "margin-top": $5280ebef38a3c5c6$var$px,
    "margin-block": $5280ebef38a3c5c6$var$px,
    "margin-block-end": $5280ebef38a3c5c6$var$px,
    "margin-block-start": $5280ebef38a3c5c6$var$px,
    "margin-inline": $5280ebef38a3c5c6$var$px,
    "margin-inline-end": $5280ebef38a3c5c6$var$px,
    "margin-inline-start": $5280ebef38a3c5c6$var$px,
    // Padding properties
    padding: $5280ebef38a3c5c6$var$px,
    "padding-bottom": $5280ebef38a3c5c6$var$px,
    "padding-left": $5280ebef38a3c5c6$var$px,
    "padding-right": $5280ebef38a3c5c6$var$px,
    "padding-top": $5280ebef38a3c5c6$var$px,
    "padding-block": $5280ebef38a3c5c6$var$px,
    "padding-block-end": $5280ebef38a3c5c6$var$px,
    "padding-block-start": $5280ebef38a3c5c6$var$px,
    "padding-inline": $5280ebef38a3c5c6$var$px,
    "padding-inline-end": $5280ebef38a3c5c6$var$px,
    "padding-inline-start": $5280ebef38a3c5c6$var$px,
    // Mask properties
    "mask-position-x": $5280ebef38a3c5c6$var$px,
    "mask-position-y": $5280ebef38a3c5c6$var$px,
    "mask-size": $5280ebef38a3c5c6$var$px,
    // Width and height properties
    height: $5280ebef38a3c5c6$var$px,
    width: $5280ebef38a3c5c6$var$px,
    "min-height": $5280ebef38a3c5c6$var$px,
    "max-height": $5280ebef38a3c5c6$var$px,
    "min-width": $5280ebef38a3c5c6$var$px,
    "max-width": $5280ebef38a3c5c6$var$px,
    // Position properties
    bottom: $5280ebef38a3c5c6$var$px,
    left: $5280ebef38a3c5c6$var$px,
    top: $5280ebef38a3c5c6$var$px,
    right: $5280ebef38a3c5c6$var$px,
    inset: $5280ebef38a3c5c6$var$px,
    "inset-block": $5280ebef38a3c5c6$var$px,
    "inset-block-end": $5280ebef38a3c5c6$var$px,
    "inset-block-start": $5280ebef38a3c5c6$var$px,
    "inset-inline": $5280ebef38a3c5c6$var$px,
    "inset-inline-end": $5280ebef38a3c5c6$var$px,
    "inset-inline-start": $5280ebef38a3c5c6$var$px,
    // Shadow properties
    "box-shadow": $5280ebef38a3c5c6$var$px,
    "text-shadow": $5280ebef38a3c5c6$var$px,
    // Column properties
    "column-gap": $5280ebef38a3c5c6$var$px,
    "column-rule": $5280ebef38a3c5c6$var$px,
    "column-rule-width": $5280ebef38a3c5c6$var$px,
    "column-width": $5280ebef38a3c5c6$var$px,
    // Font and text properties
    "font-size": $5280ebef38a3c5c6$var$px,
    "font-size-delta": $5280ebef38a3c5c6$var$px,
    "letter-spacing": $5280ebef38a3c5c6$var$px,
    "text-decoration-thickness": $5280ebef38a3c5c6$var$px,
    "text-indent": $5280ebef38a3c5c6$var$px,
    "text-stroke": $5280ebef38a3c5c6$var$px,
    "text-stroke-width": $5280ebef38a3c5c6$var$px,
    "word-spacing": $5280ebef38a3c5c6$var$px,
    // Motion properties
    motion: $5280ebef38a3c5c6$var$px,
    "motion-offset": $5280ebef38a3c5c6$var$px,
    // Outline properties
    outline: $5280ebef38a3c5c6$var$px,
    "outline-offset": $5280ebef38a3c5c6$var$px,
    "outline-width": $5280ebef38a3c5c6$var$px,
    // Perspective properties
    perspective: $5280ebef38a3c5c6$var$px,
    "perspective-origin-x": $5280ebef38a3c5c6$var$percent,
    "perspective-origin-y": $5280ebef38a3c5c6$var$percent,
    // Transform properties
    "transform-origin": $5280ebef38a3c5c6$var$percent,
    "transform-origin-x": $5280ebef38a3c5c6$var$percent,
    "transform-origin-y": $5280ebef38a3c5c6$var$percent,
    "transform-origin-z": $5280ebef38a3c5c6$var$percent,
    // Transition properties
    "transition-delay": $5280ebef38a3c5c6$var$ms,
    "transition-duration": $5280ebef38a3c5c6$var$ms,
    // Alignment properties
    "vertical-align": $5280ebef38a3c5c6$var$px,
    "flex-basis": $5280ebef38a3c5c6$var$px,
    // Some random properties
    "shape-margin": $5280ebef38a3c5c6$var$px,
    size: $5280ebef38a3c5c6$var$px,
    gap: $5280ebef38a3c5c6$var$px,
    // Grid properties
    grid: $5280ebef38a3c5c6$var$px,
    "grid-gap": $5280ebef38a3c5c6$var$px,
    "row-gap": $5280ebef38a3c5c6$var$px,
    "grid-row-gap": $5280ebef38a3c5c6$var$px,
    "grid-column-gap": $5280ebef38a3c5c6$var$px,
    "grid-template-rows": $5280ebef38a3c5c6$var$px,
    "grid-template-columns": $5280ebef38a3c5c6$var$px,
    "grid-auto-rows": $5280ebef38a3c5c6$var$px,
    "grid-auto-columns": $5280ebef38a3c5c6$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $5280ebef38a3c5c6$var$px,
    "box-shadow-y": $5280ebef38a3c5c6$var$px,
    "box-shadow-blur": $5280ebef38a3c5c6$var$px,
    "box-shadow-spread": $5280ebef38a3c5c6$var$px,
    "font-line-height": $5280ebef38a3c5c6$var$px,
    "text-shadow-x": $5280ebef38a3c5c6$var$px,
    "text-shadow-y": $5280ebef38a3c5c6$var$px,
    "text-shadow-blur": $5280ebef38a3c5c6$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $5280ebef38a3c5c6$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $5280ebef38a3c5c6$var$units = $5280ebef38a3c5c6$var$addCamelCasedVersion($5280ebef38a3c5c6$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $5280ebef38a3c5c6$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $5280ebef38a3c5c6$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $5280ebef38a3c5c6$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $5280ebef38a3c5c6$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === "number" && isNaN(value) === false) {
        var unit = options[prop] || $5280ebef38a3c5c6$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $5280ebef38a3c5c6$var$px)) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $5280ebef38a3c5c6$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $5280ebef38a3c5c6$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $5280ebef38a3c5c6$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $5280ebef38a3c5c6$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5280ebef38a3c5c6$export$2e2bcd8739ae039 = $5280ebef38a3c5c6$var$defaultUnit;

});

parcelRequire.register("81Rrl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d87dec9ac2db100$export$2e2bcd8739ae039);

var $WZ5By = parcelRequire("WZ5By");

var $f88hq = parcelRequire("f88hq");
/**
 * Add vendor prefix to a property name when needed.
 */ function $5d87dec9ac2db100$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $WZ5By.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $WZ5By.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $WZ5By.supportedValue)(supportedProp, (0, $f88hq.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $WZ5By.supportedValue)(prop, (0, $f88hq.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5d87dec9ac2db100$export$2e2bcd8739ae039 = $5d87dec9ac2db100$var$jssVendorPrefixer;

});
parcelRequire.register("WZ5By", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", () => $0b14cdf9ea25e36f$export$b6aa0648d950180a);
$parcel$export(module.exports, "supportedProperty", () => $0b14cdf9ea25e36f$export$ce097f82c2e4551a);
$parcel$export(module.exports, "supportedValue", () => $0b14cdf9ea25e36f$export$511766124059c277);

var $ja49S = parcelRequire("ja49S");

var $kbxxf = parcelRequire("kbxxf");
// Export javascript style and css style vendor prefixes.
var $0b14cdf9ea25e36f$var$js = "";
var $0b14cdf9ea25e36f$var$css = "";
var $0b14cdf9ea25e36f$var$vendor = "";
var $0b14cdf9ea25e36f$var$browser = "";
var $0b14cdf9ea25e36f$var$isTouch = (0, $ja49S.default) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $ja49S.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $0b14cdf9ea25e36f$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $0b14cdf9ea25e36f$var$_document$createEleme = document.createElement("p"), $0b14cdf9ea25e36f$var$style = $0b14cdf9ea25e36f$var$_document$createEleme.style;
    var $0b14cdf9ea25e36f$var$testProp = "Transform";
    for(var $0b14cdf9ea25e36f$var$key in $0b14cdf9ea25e36f$var$jsCssMap)if ($0b14cdf9ea25e36f$var$key + $0b14cdf9ea25e36f$var$testProp in $0b14cdf9ea25e36f$var$style) {
        $0b14cdf9ea25e36f$var$js = $0b14cdf9ea25e36f$var$key;
        $0b14cdf9ea25e36f$var$css = $0b14cdf9ea25e36f$var$jsCssMap[$0b14cdf9ea25e36f$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($0b14cdf9ea25e36f$var$js === "Webkit" && "msHyphens" in $0b14cdf9ea25e36f$var$style) {
        $0b14cdf9ea25e36f$var$js = "ms";
        $0b14cdf9ea25e36f$var$css = $0b14cdf9ea25e36f$var$jsCssMap.ms;
        $0b14cdf9ea25e36f$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($0b14cdf9ea25e36f$var$js === "Webkit" && "-apple-trailing-word" in $0b14cdf9ea25e36f$var$style) $0b14cdf9ea25e36f$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $0b14cdf9ea25e36f$export$82e9f45cca5ba907 = {
    js: $0b14cdf9ea25e36f$var$js,
    css: $0b14cdf9ea25e36f$var$css,
    vendor: $0b14cdf9ea25e36f$var$vendor,
    browser: $0b14cdf9ea25e36f$var$browser,
    isTouch: $0b14cdf9ea25e36f$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $0b14cdf9ea25e36f$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $0b14cdf9ea25e36f$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $0b14cdf9ea25e36f$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $0b14cdf9ea25e36f$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$camelize(str) {
    return str.replace($0b14cdf9ea25e36f$var$regExp, $0b14cdf9ea25e36f$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$pascalize(str) {
    return $0b14cdf9ea25e36f$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $0b14cdf9ea25e36f$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($0b14cdf9ea25e36f$var$camelize(longhand) in style) return prop;
            if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(longhand) in style) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $0b14cdf9ea25e36f$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.vendor === "apple" && !$0b14cdf9ea25e36f$export$82e9f45cca5ba907.isTouch) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $0b14cdf9ea25e36f$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $0b14cdf9ea25e36f$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $0b14cdf9ea25e36f$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit" || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms" && $0b14cdf9ea25e36f$export$82e9f45cca5ba907.browser !== "edge") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $0b14cdf9ea25e36f$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Moz" || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms" || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.vendor === "apple") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $0b14cdf9ea25e36f$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $0b14cdf9ea25e36f$var$pascalize(prop);
            return jsProp in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $0b14cdf9ea25e36f$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $0b14cdf9ea25e36f$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $0b14cdf9ea25e36f$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $0b14cdf9ea25e36f$var$camelize(prop) in style ? prop : false;
    }
};
var $0b14cdf9ea25e36f$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $0b14cdf9ea25e36f$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + pascalized in style) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $0b14cdf9ea25e36f$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return "" + $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $0b14cdf9ea25e36f$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === "ms") return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $0b14cdf9ea25e36f$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $0b14cdf9ea25e36f$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $0b14cdf9ea25e36f$var$propMap[prop];
        if (!newProp) return false;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $0b14cdf9ea25e36f$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $0b14cdf9ea25e36f$var$propKeys = Object.keys($0b14cdf9ea25e36f$var$propMap$1);
var $0b14cdf9ea25e36f$var$prefixCss = function prefixCss(p) {
    return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $0b14cdf9ea25e36f$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($0b14cdf9ea25e36f$var$propKeys.indexOf(prop) > -1) {
            var newProp = $0b14cdf9ea25e36f$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($0b14cdf9ea25e36f$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $0b14cdf9ea25e36f$var$plugins = [
    $0b14cdf9ea25e36f$var$appearence,
    $0b14cdf9ea25e36f$var$colorAdjust,
    $0b14cdf9ea25e36f$var$mask,
    $0b14cdf9ea25e36f$var$textOrientation,
    $0b14cdf9ea25e36f$var$transform,
    $0b14cdf9ea25e36f$var$transition,
    $0b14cdf9ea25e36f$var$writingMode,
    $0b14cdf9ea25e36f$var$userSelect,
    $0b14cdf9ea25e36f$var$breakPropsOld,
    $0b14cdf9ea25e36f$var$inlineLogicalOld,
    $0b14cdf9ea25e36f$var$unprefixed,
    $0b14cdf9ea25e36f$var$prefixed,
    $0b14cdf9ea25e36f$var$scrollSnap,
    $0b14cdf9ea25e36f$var$overscrollBehavior,
    $0b14cdf9ea25e36f$var$flex2012,
    $0b14cdf9ea25e36f$var$flex2009
];
var $0b14cdf9ea25e36f$var$propertyDetectors = $0b14cdf9ea25e36f$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $0b14cdf9ea25e36f$var$noPrefill = $0b14cdf9ea25e36f$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $kbxxf.default)(p.noPrefill));
    return a;
}, []);
var $0b14cdf9ea25e36f$var$el;
var $0b14cdf9ea25e36f$var$cache = {};
if (0, $ja49S.default) {
    $0b14cdf9ea25e36f$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $0b14cdf9ea25e36f$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $0b14cdf9ea25e36f$var$key$1 in $0b14cdf9ea25e36f$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($0b14cdf9ea25e36f$var$key$1)) $0b14cdf9ea25e36f$var$cache[$0b14cdf9ea25e36f$var$computed[$0b14cdf9ea25e36f$var$key$1]] = $0b14cdf9ea25e36f$var$computed[$0b14cdf9ea25e36f$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $0b14cdf9ea25e36f$var$noPrefill.forEach(function(x) {
        return delete $0b14cdf9ea25e36f$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $0b14cdf9ea25e36f$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$0b14cdf9ea25e36f$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($0b14cdf9ea25e36f$var$cache[prop] != null) return $0b14cdf9ea25e36f$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $0b14cdf9ea25e36f$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $0b14cdf9ea25e36f$var$propertyDetectors.length; i++){
        $0b14cdf9ea25e36f$var$cache[prop] = $0b14cdf9ea25e36f$var$propertyDetectors[i](prop, $0b14cdf9ea25e36f$var$el.style, options); // Break loop, if value found.
        if ($0b14cdf9ea25e36f$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $0b14cdf9ea25e36f$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $0b14cdf9ea25e36f$var$cache[prop];
}
var $0b14cdf9ea25e36f$var$cache$1 = {};
var $0b14cdf9ea25e36f$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $0b14cdf9ea25e36f$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $0b14cdf9ea25e36f$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $0b14cdf9ea25e36f$export$ce097f82c2e4551a(p1) : ", " + $0b14cdf9ea25e36f$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $ja49S.default) $0b14cdf9ea25e36f$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $0b14cdf9ea25e36f$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$0b14cdf9ea25e36f$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($0b14cdf9ea25e36f$var$cache$1[cacheKey] != null) return $0b14cdf9ea25e36f$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $0b14cdf9ea25e36f$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $0b14cdf9ea25e36f$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($0b14cdf9ea25e36f$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($0b14cdf9ea25e36f$var$transPropsRegExp, $0b14cdf9ea25e36f$var$prefixTransitionCallback);
    else if ($0b14cdf9ea25e36f$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $0b14cdf9ea25e36f$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $0b14cdf9ea25e36f$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($0b14cdf9ea25e36f$var$el$1.style[property] === "") {
            $0b14cdf9ea25e36f$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $0b14cdf9ea25e36f$var$el$1.style[property] = ""; // Write current value to cache.
    $0b14cdf9ea25e36f$var$cache$1[cacheKey] = prefixedValue;
    return $0b14cdf9ea25e36f$var$cache$1[cacheKey];
}

});
parcelRequire.register("kbxxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1ed927433e7e98$export$2e2bcd8739ae039);

var $cN7Ua = parcelRequire("cN7Ua");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $fB5Ly = parcelRequire("fB5Ly");
function $eb1ed927433e7e98$export$2e2bcd8739ae039(arr) {
    return (0, $cN7Ua.default)(arr) || (0, $dOjF6.default)(arr) || (0, $abLc2.default)(arr) || (0, $fB5Ly.default)();
}

});
parcelRequire.register("cN7Ua", function(module, exports) {

$parcel$export(module.exports, "default", () => $95003165623aa54c$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $95003165623aa54c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $7K8zV.default)(arr);
}

});
parcelRequire.register("7K8zV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a337bca9556bfe7$export$2e2bcd8739ae039);
function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRequire.register("dOjF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0df324e6f81ee90$export$2e2bcd8739ae039);
function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRequire.register("abLc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af8a05551d5f25$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7K8zV.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7K8zV.default)(o, minLen);
}

});

parcelRequire.register("fB5Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5aec8b8da7ac2f2$export$2e2bcd8739ae039);
function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRequire.register("3TmXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d5851d4b913d01d$export$2e2bcd8739ae039);
/**
 * Sort props by length.
 */ function $2d5851d4b913d01d$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $2d5851d4b913d01d$export$2e2bcd8739ae039 = $2d5851d4b913d01d$var$jssPropsSort;

});



parcelRequire.register("edKwj", function(module, exports) {

$parcel$export(module.exports, "increment", () => $a5a65d8b4db31f3c$export$a2647aa13413c947);
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $a5a65d8b4db31f3c$var$indexCounter = -1000000000;
function $a5a65d8b4db31f3c$export$a2647aa13413c947() {
    $a5a65d8b4db31f3c$var$indexCounter += 1;
    return $a5a65d8b4db31f3c$var$indexCounter;
}

});

parcelRequire.register("77xio", function(module, exports) {

$parcel$export(module.exports, "default", () => $52f303b00b2e0414$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("fSwVM");

var $izL69 = parcelRequire("izL69");

function $52f303b00b2e0414$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === "function";
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $8nd05.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $izL69.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRequire.register("izL69", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8600793c65c158d$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");
function $d8600793c65c158d$export$53b83ca8eaab0383(item) {
    return item && (0, $fSwVM.default)(item) === "object" && item.constructor === Object;
}
function $d8600793c65c158d$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $8nd05.default)({}, target) : target;
    if ($d8600793c65c158d$export$53b83ca8eaab0383(target) && $d8600793c65c158d$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($d8600793c65c158d$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $d8600793c65c158d$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});


parcelRequire.register("ei4PC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6767e97a39dccd9$export$2e2bcd8739ae039);
// We use the same empty object to ref count the styles that don't need a theme object.
var $a6767e97a39dccd9$var$noopTheme = {};
var $a6767e97a39dccd9$export$2e2bcd8739ae039 = $a6767e97a39dccd9$var$noopTheme;

});


parcelRequire.register("kD2D5", function(module, exports) {

$parcel$export(module.exports, "default", () => $03e0272eaaa661f3$export$2e2bcd8739ae039);
/* eslint-disable no-restricted-syntax */ function $03e0272eaaa661f3$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRequire.register("kpDC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $edc4ded6dfec889f$export$2e2bcd8739ae039);

var $eOWQz = parcelRequire("eOWQz");
var $edc4ded6dfec889f$var$defaultTheme = (0, $eOWQz.default)();
var $edc4ded6dfec889f$export$2e2bcd8739ae039 = $edc4ded6dfec889f$var$defaultTheme;

});
parcelRequire.register("eOWQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $aca361f45e881e1e$export$2e2bcd8739ae039);
parcelRequire("kSlfw");

var $9X7IJ = parcelRequire("9X7IJ");

var $izL69 = parcelRequire("izL69");

var $jKDgp = parcelRequire("jKDgp");

var $egNiU = parcelRequire("egNiU");

var $gyFQg = parcelRequire("gyFQg");

var $6kj3D = parcelRequire("6kj3D");

var $eF57Y = parcelRequire("eF57Y");

var $lnT3F = parcelRequire("lnT3F");

var $gdeSj = parcelRequire("gdeSj");

var $3Z9df = parcelRequire("3Z9df");

var $efglq = parcelRequire("efglq");
function $aca361f45e881e1e$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $9X7IJ.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $gyFQg.default)(paletteInput);
    var breakpoints = (0, $jKDgp.default)(breakpointsInput);
    var spacing = (0, $gdeSj.default)(spacingInput);
    var muiTheme = (0, $izL69.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        mixins: (0, $egNiU.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $eF57Y.default),
        typography: (0, $6kj3D.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $lnT3F.default),
        transitions: (0, $3Z9df.default),
        zIndex: (0, $efglq.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $izL69.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $aca361f45e881e1e$var$warnedOnce = false;
function $aca361f45e881e1e$export$c469355549431d9b() {
    return $aca361f45e881e1e$var$createTheme.apply(void 0, arguments);
}
var $aca361f45e881e1e$export$2e2bcd8739ae039 = $aca361f45e881e1e$var$createTheme;

});
parcelRequire.register("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $4ZreY.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRequire.register("jKDgp", function(module, exports) {

$parcel$export(module.exports, "keys", () => $e610c528979d3b2e$export$ed97f33186d4b816);
$parcel$export(module.exports, "default", () => $e610c528979d3b2e$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");
var $e610c528979d3b2e$export$ed97f33186d4b816 = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]; // Keep in mind that @media is inclusive by the CSS specification.
function $e610c528979d3b2e$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $9X7IJ.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $e610c528979d3b2e$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$e610c528979d3b2e$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $e610c528979d3b2e$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up("xs");
        var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $e610c528979d3b2e$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $e610c528979d3b2e$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$e610c528979d3b2e$export$ed97f33186d4b816[endIndex + 1]] === "number" ? values[$e610c528979d3b2e$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $8nd05.default)({
        keys: $e610c528979d3b2e$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRequire.register("egNiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a638ce0ba59ac53f$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");
function $a638ce0ba59ac53f$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $8nd05.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                "Material-UI: theme.mixins.gutters() is deprecated.",
                "You can use the source of the mixin directly:",
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join("\n"));
            return (0, $8nd05.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $kSlfw.default)({}, breakpoints.up("sm"), (0, $8nd05.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up("sm")])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $kSlfw.default)(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $kSlfw.default)(_toolbar, breakpoints.up("sm"), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRequire.register("gyFQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0e04740eb31aaf4$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $izL69 = parcelRequire("izL69");
var $gMaRA = parcelRequire("gMaRA");

var $bQGos = parcelRequire("bQGos");

var $3gVaZ = parcelRequire("3gVaZ");

var $hClfA = parcelRequire("hClfA");

var $858Ql = parcelRequire("858Ql");

var $fMZcm = parcelRequire("fMZcm");

var $5UuqN = parcelRequire("5UuqN");

var $6LNdu = parcelRequire("6LNdu");

var $4kOxD = parcelRequire("4kOxD");

var $9GbWv = parcelRequire("9GbWv");
var $c0e04740eb31aaf4$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.54)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)",
        // Text hints.
        hint: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $bQGos.default).white,
        default: (0, $3gVaZ.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $c0e04740eb31aaf4$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $bQGos.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        hint: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: (0, $3gVaZ.default)[800],
        default: "#303030"
    },
    action: {
        active: (0, $bQGos.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $c0e04740eb31aaf4$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $9GbWv.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $9GbWv.darken)(intent.main, tonalOffsetDark);
    }
}
function $c0e04740eb31aaf4$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $hClfA.default)[300],
        main: (0, $hClfA.default)[500],
        dark: (0, $hClfA.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $858Ql.default).A200,
        main: (0, $858Ql.default).A400,
        dark: (0, $858Ql.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $fMZcm.default)[300],
        main: (0, $fMZcm.default)[500],
        dark: (0, $fMZcm.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $5UuqN.default)[300],
        main: (0, $5UuqN.default)[500],
        dark: (0, $5UuqN.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $6LNdu.default)[300],
        main: (0, $6LNdu.default)[500],
        dark: (0, $6LNdu.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $4kOxD.default)[300],
        main: (0, $4kOxD.default)[500],
        dark: (0, $4kOxD.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $9X7IJ.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $9GbWv.getContrastRatio)(background, $c0e04740eb31aaf4$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $c0e04740eb31aaf4$export$55ce6f3a06c59543.text.primary : $c0e04740eb31aaf4$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $8nd05.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $gMaRA.default)(4, mainShade));
        if (typeof color.main !== "string") throw new Error((0, $gMaRA.default)(5, JSON.stringify(color.main)));
        $c0e04740eb31aaf4$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $c0e04740eb31aaf4$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $c0e04740eb31aaf4$export$55ce6f3a06c59543,
        light: $c0e04740eb31aaf4$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $izL69.default)((0, $8nd05.default)({
        // A collection of common colors.
        common: (0, $bQGos.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, "A400", "A200", "A700"),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $3gVaZ.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRequire.register("gMaRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3698e480604b2e2$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $c3698e480604b2e2$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = "https://mui.com/production-error/?code=" + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified Material-UI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});

parcelRequire.register("bQGos", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a056f7d70be33fa$export$2e2bcd8739ae039);
var $8a056f7d70be33fa$var$common = {
    black: "#000",
    white: "#fff"
};
var $8a056f7d70be33fa$export$2e2bcd8739ae039 = $8a056f7d70be33fa$var$common;

});

parcelRequire.register("3gVaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $261f37bcb99a0a85$export$2e2bcd8739ae039);
var $261f37bcb99a0a85$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161"
};
var $261f37bcb99a0a85$export$2e2bcd8739ae039 = $261f37bcb99a0a85$var$grey;

});

parcelRequire.register("hClfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd36782f8b31900d$export$2e2bcd8739ae039);
var $cd36782f8b31900d$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $cd36782f8b31900d$export$2e2bcd8739ae039 = $cd36782f8b31900d$var$indigo;

});

parcelRequire.register("858Ql", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e25a66d20ac5abf$export$2e2bcd8739ae039);
var $5e25a66d20ac5abf$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $5e25a66d20ac5abf$export$2e2bcd8739ae039 = $5e25a66d20ac5abf$var$pink;

});

parcelRequire.register("fMZcm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7eacf6dfa54ff7f$export$2e2bcd8739ae039);
var $b7eacf6dfa54ff7f$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $b7eacf6dfa54ff7f$export$2e2bcd8739ae039 = $b7eacf6dfa54ff7f$var$red;

});

parcelRequire.register("5UuqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $44d9c9b51d2e8ade$export$2e2bcd8739ae039);
var $44d9c9b51d2e8ade$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $44d9c9b51d2e8ade$export$2e2bcd8739ae039 = $44d9c9b51d2e8ade$var$orange;

});

parcelRequire.register("6LNdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4edd4f399ca1309c$export$2e2bcd8739ae039);
var $4edd4f399ca1309c$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $4edd4f399ca1309c$export$2e2bcd8739ae039 = $4edd4f399ca1309c$var$blue;

});

parcelRequire.register("4kOxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $32803c282f51058e$export$2e2bcd8739ae039);
var $32803c282f51058e$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $32803c282f51058e$export$2e2bcd8739ae039 = $32803c282f51058e$var$green;

});

parcelRequire.register("9GbWv", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", () => $70c14cd82f6bad00$export$d061e26956a60b0a);
$parcel$export(module.exports, "emphasize", () => $70c14cd82f6bad00$export$e665714f76e581fd);
$parcel$export(module.exports, "darken", () => $70c14cd82f6bad00$export$4b073707ff63303);
$parcel$export(module.exports, "lighten", () => $70c14cd82f6bad00$export$c0816ed86df316af);
$parcel$export(module.exports, "alpha", () => $70c14cd82f6bad00$export$58f0f39f63f3cf42);

var $gMaRA = parcelRequire("gMaRA");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $70c14cd82f6bad00$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $70c14cd82f6bad00$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", "), ")") : "";
}
function $70c14cd82f6bad00$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $70c14cd82f6bad00$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    var _decomposeColor = $70c14cd82f6bad00$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $70c14cd82f6bad00$var$intToHex(n);
    }).join(""));
}
function $70c14cd82f6bad00$export$29fb7152bd3f781a(color) {
    color = $70c14cd82f6bad00$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = "rgb";
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $70c14cd82f6bad00$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $70c14cd82f6bad00$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $70c14cd82f6bad00$export$677b39864803984e($70c14cd82f6bad00$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf("(");
    var type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla"
    ].indexOf(type) === -1) throw new Error((0, $gMaRA.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(",");
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $70c14cd82f6bad00$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf("hsl") !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(", "), ")");
}
function $70c14cd82f6bad00$export$d061e26956a60b0a(foreground, background) {
    var lumA = $70c14cd82f6bad00$export$c852d90bf7403b62(foreground);
    var lumB = $70c14cd82f6bad00$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $70c14cd82f6bad00$export$c852d90bf7403b62(color) {
    color = $70c14cd82f6bad00$export$677b39864803984e(color);
    var rgb = color.type === "hsl" ? $70c14cd82f6bad00$export$677b39864803984e($70c14cd82f6bad00$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $70c14cd82f6bad00$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $70c14cd82f6bad00$export$c852d90bf7403b62(color) > 0.5 ? $70c14cd82f6bad00$export$4b073707ff63303(color, coefficient) : $70c14cd82f6bad00$export$c0816ed86df316af(color, coefficient);
}
var $70c14cd82f6bad00$var$warnedOnce = false;
function $70c14cd82f6bad00$export$cbea29d068a2e18f(color, value) {
    return $70c14cd82f6bad00$export$58f0f39f63f3cf42(color, value);
}
function $70c14cd82f6bad00$export$58f0f39f63f3cf42(color, value) {
    color = $70c14cd82f6bad00$export$677b39864803984e(color);
    value = $70c14cd82f6bad00$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    color.values[3] = value;
    return $70c14cd82f6bad00$export$211a73f2b8c10ce4(color);
}
function $70c14cd82f6bad00$export$4b073707ff63303(color, coefficient) {
    color = $70c14cd82f6bad00$export$677b39864803984e(color);
    coefficient = $70c14cd82f6bad00$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $70c14cd82f6bad00$export$211a73f2b8c10ce4(color);
}
function $70c14cd82f6bad00$export$c0816ed86df316af(color, coefficient) {
    color = $70c14cd82f6bad00$export$677b39864803984e(color);
    coefficient = $70c14cd82f6bad00$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $70c14cd82f6bad00$export$211a73f2b8c10ce4(color);
}

});


parcelRequire.register("6kj3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $49b364cb8cb99087$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $izL69 = parcelRequire("izL69");
function $49b364cb8cb99087$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $49b364cb8cb99087$var$warnedOnce = false;
function $49b364cb8cb99087$var$roundWithDeprecationWarning(value) {
    return $49b364cb8cb99087$var$round(value);
}
var $49b364cb8cb99087$var$caseAllCaps = {
    textTransform: "uppercase"
};
var $49b364cb8cb99087$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $49b364cb8cb99087$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $49b364cb8cb99087$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $9X7IJ.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $8nd05.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $49b364cb8cb99087$var$defaultFontFamily ? {
            letterSpacing: "".concat($49b364cb8cb99087$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $49b364cb8cb99087$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $49b364cb8cb99087$var$caseAllCaps)
    };
    return (0, $izL69.default)((0, $8nd05.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $49b364cb8cb99087$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("eF57Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aac8df47118989c3$export$2e2bcd8739ae039);
var $aac8df47118989c3$var$shadowKeyUmbraOpacity = 0.2;
var $aac8df47118989c3$var$shadowKeyPenumbraOpacity = 0.14;
var $aac8df47118989c3$var$shadowAmbientShadowOpacity = 0.12;
function $aac8df47118989c3$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($aac8df47118989c3$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($aac8df47118989c3$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($aac8df47118989c3$var$shadowAmbientShadowOpacity, ")")
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $aac8df47118989c3$var$shadows = [
    "none",
    $aac8df47118989c3$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $aac8df47118989c3$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $aac8df47118989c3$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $aac8df47118989c3$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $aac8df47118989c3$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $aac8df47118989c3$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $aac8df47118989c3$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $aac8df47118989c3$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $aac8df47118989c3$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $aac8df47118989c3$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $aac8df47118989c3$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $aac8df47118989c3$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $aac8df47118989c3$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $aac8df47118989c3$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $aac8df47118989c3$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $aac8df47118989c3$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $aac8df47118989c3$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $aac8df47118989c3$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $aac8df47118989c3$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $aac8df47118989c3$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $aac8df47118989c3$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $aac8df47118989c3$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $aac8df47118989c3$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $aac8df47118989c3$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $aac8df47118989c3$export$2e2bcd8739ae039 = $aac8df47118989c3$var$shadows;

});

parcelRequire.register("lnT3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $f916745da3cdbda0$export$2e2bcd8739ae039);
var $f916745da3cdbda0$var$shape = {
    borderRadius: 4
};
var $f916745da3cdbda0$export$2e2bcd8739ae039 = $f916745da3cdbda0$var$shape;

});

parcelRequire.register("gdeSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd96616285ed264$export$2e2bcd8739ae039);

var $azmQN = parcelRequire("azmQN");
var $bcd96616285ed264$var$warnOnce;
function $bcd96616285ed264$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $azmQN.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === "string") return argument;
            var output = transform(argument);
            return typeof output === "number" ? "".concat(output, "px") : output;
        }).join(" ");
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, "unit", {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("azmQN", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", () => $7b1ee5eb83d90478$export$1def6f833384e3d1);
$parcel$export(module.exports, "default", () => $7b1ee5eb83d90478$export$2e2bcd8739ae039);

var $eUqlC = parcelRequire("eUqlC");


var $47Boo = parcelRequire("47Boo");

var $50JXT = parcelRequire("50JXT");

var $hATSm = parcelRequire("hATSm");
var $7b1ee5eb83d90478$var$properties = {
    m: "margin",
    p: "padding"
};
var $7b1ee5eb83d90478$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
var $7b1ee5eb83d90478$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $7b1ee5eb83d90478$var$getCssProperties = (0, $hATSm.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($7b1ee5eb83d90478$var$aliases[prop]) prop = $7b1ee5eb83d90478$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(""), _prop$split2 = (0, $eUqlC.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $7b1ee5eb83d90478$var$properties[a];
    var direction = $7b1ee5eb83d90478$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $7b1ee5eb83d90478$var$spacingKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY"
];
function $7b1ee5eb83d90478$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === "number") return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return function() {
        return undefined;
    };
}
function $7b1ee5eb83d90478$var$getValue(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return "-".concat(transformed);
}
function $7b1ee5eb83d90478$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $7b1ee5eb83d90478$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $7b1ee5eb83d90478$var$spacing(props) {
    var theme = props.theme;
    var transformer = $7b1ee5eb83d90478$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($7b1ee5eb83d90478$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $7b1ee5eb83d90478$var$getCssProperties(prop);
        var styleFromPropValue = $7b1ee5eb83d90478$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $47Boo.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $50JXT.default), {});
}
$7b1ee5eb83d90478$var$spacing.propTypes = {};
$7b1ee5eb83d90478$var$spacing.filterProps = $7b1ee5eb83d90478$var$spacingKeys;
var $7b1ee5eb83d90478$export$2e2bcd8739ae039 = $7b1ee5eb83d90478$var$spacing;

});
parcelRequire.register("eUqlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaabbc18727b3e6$export$2e2bcd8739ae039);

var $1uEeT = parcelRequire("1uEeT");

var $guSBA = parcelRequire("guSBA");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $adaabbc18727b3e6$export$2e2bcd8739ae039(arr, i) {
    return (0, $1uEeT.default)(arr) || (0, $guSBA.default)(arr, i) || (0, $abLc2.default)(arr, i) || (0, $782Uh.default)();
}

});
parcelRequire.register("1uEeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1167ce760980f343$export$2e2bcd8739ae039);
function $1167ce760980f343$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("guSBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c029ce1ef065e371$export$2e2bcd8739ae039);
function $c029ce1ef065e371$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}

});

parcelRequire.register("782Uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $530b88ff20858fe6$export$2e2bcd8739ae039);
function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRequire.register("47Boo", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", () => $3004d24072c2b669$export$88347efdb2e19abd);

var $kbxxf = parcelRequire("kbxxf");

var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");


var $50JXT = parcelRequire("50JXT");
// For instance with the first breakpoint xs: [xs, sm[.
var $3004d24072c2b669$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $3004d24072c2b669$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: function up(key) {
        return "@media (min-width:".concat($3004d24072c2b669$var$values[key], "px)");
    }
};
function $3004d24072c2b669$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $3004d24072c2b669$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $fSwVM.default)(propValue) === "object") {
        var _themeBreakpoints = props.theme.breakpoints || $3004d24072c2b669$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $3004d24072c2b669$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $3004d24072c2b669$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8nd05.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $50JXT.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].concat((0, $kbxxf.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $3004d24072c2b669$export$2e2bcd8739ae039 = $3004d24072c2b669$var$breakpoints;

});
parcelRequire.register("50JXT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a609b87cb3c2488$export$2e2bcd8739ae039);

var $izL69 = parcelRequire("izL69");
function $3a609b87cb3c2488$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $izL69.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $3a609b87cb3c2488$export$2e2bcd8739ae039 = $3a609b87cb3c2488$var$merge;

});


parcelRequire.register("hATSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf1243d1db5d9a5$export$2e2bcd8739ae039);
function $ccf1243d1db5d9a5$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRequire.register("3Z9df", function(module, exports) {

$parcel$export(module.exports, "duration", () => $2e6e3712075ad2db$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $2e6e3712075ad2db$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");
var $2e6e3712075ad2db$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $2e6e3712075ad2db$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $2e6e3712075ad2db$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $2e6e3712075ad2db$export$2e2bcd8739ae039 = {
    easing: $2e6e3712075ad2db$export$24c5ac7c37452e7d,
    duration: $2e6e3712075ad2db$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            "all"
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $2e6e3712075ad2db$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $2e6e3712075ad2db$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $9X7IJ.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : $2e6e3712075ad2db$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : $2e6e3712075ad2db$var$formatMs(delay));
        }).join(",");
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRequire.register("efglq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5ef251776b47b14$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $a5ef251776b47b14$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $a5ef251776b47b14$export$2e2bcd8739ae039 = $a5ef251776b47b14$var$zIndex;

});




parcelRequire.register("f9tk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07e714550ec75bc$export$2e2bcd8739ae039);

var $gMaRA = parcelRequire("gMaRA");
function $b07e714550ec75bc$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $gMaRA.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});




parcelRequire.register("9cCWX", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = 60103, $6b3372b60d35b33f$var$c = 60106, $6b3372b60d35b33f$var$d = 60107, $6b3372b60d35b33f$var$e = 60108, $6b3372b60d35b33f$var$f = 60114, $6b3372b60d35b33f$var$g = 60109, $6b3372b60d35b33f$var$h = 60110, $6b3372b60d35b33f$var$k = 60112, $6b3372b60d35b33f$var$l = 60113, $6b3372b60d35b33f$var$m = 60120, $6b3372b60d35b33f$var$n = 60115, $6b3372b60d35b33f$var$p = 60116, $6b3372b60d35b33f$var$q = 60121, $6b3372b60d35b33f$var$r = 60122, $6b3372b60d35b33f$var$u = 60117, $6b3372b60d35b33f$var$v = 60129, $6b3372b60d35b33f$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $6b3372b60d35b33f$var$x = Symbol.for;
    $6b3372b60d35b33f$var$b = $6b3372b60d35b33f$var$x("react.element");
    $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$x("react.portal");
    $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$x("react.fragment");
    $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$x("react.strict_mode");
    $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$x("react.profiler");
    $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$x("react.provider");
    $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$x("react.context");
    $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$x("react.forward_ref");
    $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$x("react.suspense");
    $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$x("react.suspense_list");
    $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$x("react.memo");
    $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$x("react.lazy");
    $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$x("react.block");
    $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$x("react.server.block");
    $6b3372b60d35b33f$var$u = $6b3372b60d35b33f$var$x("react.fundamental");
    $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$x("react.debug_trace_mode");
    $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$x("react.legacy_hidden");
}
function $6b3372b60d35b33f$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $6b3372b60d35b33f$var$b:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$d:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$h:
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$p:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $6b3372b60d35b33f$var$c:
                return t;
        }
    }
}
var $6b3372b60d35b33f$var$z = $6b3372b60d35b33f$var$g, $6b3372b60d35b33f$var$A = $6b3372b60d35b33f$var$b, $6b3372b60d35b33f$var$B = $6b3372b60d35b33f$var$k, $6b3372b60d35b33f$var$C = $6b3372b60d35b33f$var$d, $6b3372b60d35b33f$var$D = $6b3372b60d35b33f$var$p, $6b3372b60d35b33f$var$E = $6b3372b60d35b33f$var$n, $6b3372b60d35b33f$var$F = $6b3372b60d35b33f$var$c, $6b3372b60d35b33f$var$G = $6b3372b60d35b33f$var$f, $6b3372b60d35b33f$var$H = $6b3372b60d35b33f$var$e, $6b3372b60d35b33f$var$I = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$z;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$B;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$C;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$D;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$E;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$F;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$G;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$H;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$I;
$6b3372b60d35b33f$export$92387174baf9b227 = function() {
    return !1;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$b;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$d || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$v || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$l || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$w || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$p || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$g || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$u || a.$$typeof === $6b3372b60d35b33f$var$q || a[0] === $6b3372b60d35b33f$var$r) ? !0 : !1;
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$y;

});

parcelRequire.register("45fvw", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRequire.register("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRequire.register("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRequire.register("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});


parcelRequire.register("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRequire.register("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("7we3r", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance($lk5EI(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));

$57966c7e0affc4cb$var$axios.VERSION = (parcelRequire("35BUy")).version;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));

// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (parcelRequire("dxy9O"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRequire.register("gKvUL", function(module, exports) {
"use strict";

var $jJbMR = parcelRequire("jJbMR");
// utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM
};

});
parcelRequire.register("jJbMR", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("ewFRw", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $bv3QM = parcelRequire("bv3QM");
var $a93486d2307f31c3$var$validators = $bv3QM.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $bv3QM.assertOptions(transitional, {
        silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
        forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
        clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $dlZEJ,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $dlZEJ(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRequire.register("cbIsf", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($gKvUL.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + "=" + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("83RYu", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRequire.register("dlZEJ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $4Tkeq("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("7YJ0v", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $lJY4v;
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("lJY4v", function(module, exports) {

var $hJ3nf = parcelRequire("hJ3nf");
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");

var $8v8A7 = parcelRequire("8v8A7");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    else if (typeof $hJ3nf !== "undefined" && Object.prototype.toString.call($hJ3nf) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
function $fd3c65eeb28abd71$var$stringifySafely(rawValue, parser, encoder) {
    if ($gKvUL.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $gKvUL.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $fd3c65eeb28abd71$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, "Accept");
            $kiL6T(headers, "Content-Type");
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($gKvUL.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/json");
                return $fd3c65eeb28abd71$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $fd3c65eeb28abd71$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $gKvUL.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $8v8A7(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$gKvUL.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRequire.register("hJ3nf", function(module, exports) {
module.exports = {};

});

parcelRequire.register("kiL6T", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("8v8A7", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRequire.register("at5cb", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");

var $lJY4v = parcelRequire("lJY4v");

var $4Tkeq = parcelRequire("4Tkeq");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($gKvUL.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $lJY4v.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $4Tkeq("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("kk0E9", function(module, exports) {
"use strict";

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRequire.register("kjF3e", function(module, exports) {
"use strict";

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});


parcelRequire.register("8JRzs", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push("path=" + path);
            if ($gKvUL.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("7GD7a", function(module, exports) {
"use strict";

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("ckHwb", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("fE4ul", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("lDriZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("889er", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRequire.register("4Tkeq", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});




parcelRequire.register("7L4QX", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("lk5EI", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $gKvUL.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $gKvUL.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRequire.register("bv3QM", function(module, exports) {
"use strict";

var $35BUy = parcelRequire("35BUy");
var $85f59389941e7907$require$VERSION = $35BUy.version;
var $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $85f59389941e7907$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRequire.register("35BUy", function(module, exports) {
module.exports = {
    "version": "0.24.0"
};

});



parcelRequire.register("lAKPy", function(module, exports) {
"use strict";

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $fb81495929d8a282$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $fb81495929d8a282$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRequire.register("JEeti", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("dxy9O", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});


parcelRequire.register("cSJDD", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $960dedfd64f242ab$export$a7c73072b1a182ae, (v) => $960dedfd64f242ab$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $960dedfd64f242ab$export$9f27bc3417b4524d, (v) => $960dedfd64f242ab$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $960dedfd64f242ab$export$db77ccec0bb4ccac, (v) => $960dedfd64f242ab$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $960dedfd64f242ab$export$8392c0c9d3dcbd35, (v) => $960dedfd64f242ab$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $960dedfd64f242ab$export$ffb0004e005737fa, (v) => $960dedfd64f242ab$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $960dedfd64f242ab$export$b624eff549462981, (v) => $960dedfd64f242ab$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $960dedfd64f242ab$export$7897aa7841a5380c, (v) => $960dedfd64f242ab$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $960dedfd64f242ab$export$602eac185826482c, (v) => $960dedfd64f242ab$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $960dedfd64f242ab$export$e2c29f18771995cb, (v) => $960dedfd64f242ab$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $960dedfd64f242ab$export$5f8d39834fd61797, (v) => $960dedfd64f242ab$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $960dedfd64f242ab$export$74bf444e3cd11ea5, (v) => $960dedfd64f242ab$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $960dedfd64f242ab$export$998bcd577473dd93, (v) => $960dedfd64f242ab$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $960dedfd64f242ab$export$92387174baf9b227, (v) => $960dedfd64f242ab$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $960dedfd64f242ab$export$ec112efeb987d9c6, (v) => $960dedfd64f242ab$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $960dedfd64f242ab$export$b706b080d889d2c9, (v) => $960dedfd64f242ab$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $960dedfd64f242ab$export$5be5a87408f70ddc, (v) => $960dedfd64f242ab$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $960dedfd64f242ab$export$45a5e7f76e0caa8d, (v) => $960dedfd64f242ab$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $960dedfd64f242ab$export$455c2e768291efa6, (v) => $960dedfd64f242ab$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $960dedfd64f242ab$export$9522e17588c12572, (v) => $960dedfd64f242ab$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $960dedfd64f242ab$export$2110ac352bb060b9, (v) => $960dedfd64f242ab$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $960dedfd64f242ab$export$56885ab8b9c456ab, (v) => $960dedfd64f242ab$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $960dedfd64f242ab$export$d927fcb6adf8f9de, (v) => $960dedfd64f242ab$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $960dedfd64f242ab$export$b82d16f27459e05a, (v) => $960dedfd64f242ab$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $960dedfd64f242ab$export$522c17b4f5e123e8, (v) => $960dedfd64f242ab$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $960dedfd64f242ab$export$1aabd8a0274ecfd6, (v) => $960dedfd64f242ab$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $960dedfd64f242ab$export$3d6c20d97e46b957, (v) => $960dedfd64f242ab$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $960dedfd64f242ab$export$9b621391a187a31a, (v) => $960dedfd64f242ab$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $960dedfd64f242ab$export$f5bbd400c2f4426f, (v) => $960dedfd64f242ab$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $960dedfd64f242ab$export$a7c73072b1a182ae;
var $960dedfd64f242ab$export$9f27bc3417b4524d;
var $960dedfd64f242ab$export$db77ccec0bb4ccac;
var $960dedfd64f242ab$export$8392c0c9d3dcbd35;
var $960dedfd64f242ab$export$ffb0004e005737fa;
var $960dedfd64f242ab$export$b624eff549462981;
var $960dedfd64f242ab$export$7897aa7841a5380c;
var $960dedfd64f242ab$export$602eac185826482c;
var $960dedfd64f242ab$export$e2c29f18771995cb;
var $960dedfd64f242ab$export$5f8d39834fd61797;
var $960dedfd64f242ab$export$74bf444e3cd11ea5;
var $960dedfd64f242ab$export$998bcd577473dd93;
var $960dedfd64f242ab$export$92387174baf9b227;
var $960dedfd64f242ab$export$ec112efeb987d9c6;
var $960dedfd64f242ab$export$b706b080d889d2c9;
var $960dedfd64f242ab$export$5be5a87408f70ddc;
var $960dedfd64f242ab$export$45a5e7f76e0caa8d;
var $960dedfd64f242ab$export$455c2e768291efa6;
var $960dedfd64f242ab$export$9522e17588c12572;
var $960dedfd64f242ab$export$2110ac352bb060b9;
var $960dedfd64f242ab$export$56885ab8b9c456ab;
var $960dedfd64f242ab$export$d927fcb6adf8f9de;
var $960dedfd64f242ab$export$b82d16f27459e05a;
var $960dedfd64f242ab$export$522c17b4f5e123e8;
var $960dedfd64f242ab$export$1aabd8a0274ecfd6;
var $960dedfd64f242ab$export$3d6c20d97e46b957;
var $960dedfd64f242ab$export$9b621391a187a31a;
var $960dedfd64f242ab$export$f5bbd400c2f4426f;
"use strict";
var $960dedfd64f242ab$var$b = Symbol.for("react.element"), $960dedfd64f242ab$var$c = Symbol.for("react.portal"), $960dedfd64f242ab$var$d = Symbol.for("react.fragment"), $960dedfd64f242ab$var$e = Symbol.for("react.strict_mode"), $960dedfd64f242ab$var$f = Symbol.for("react.profiler"), $960dedfd64f242ab$var$g = Symbol.for("react.provider"), $960dedfd64f242ab$var$h = Symbol.for("react.context"), $960dedfd64f242ab$var$k = Symbol.for("react.server_context"), $960dedfd64f242ab$var$l = Symbol.for("react.forward_ref"), $960dedfd64f242ab$var$m = Symbol.for("react.suspense"), $960dedfd64f242ab$var$n = Symbol.for("react.suspense_list"), $960dedfd64f242ab$var$p = Symbol.for("react.memo"), $960dedfd64f242ab$var$q = Symbol.for("react.lazy"), $960dedfd64f242ab$var$t = Symbol.for("react.offscreen"), $960dedfd64f242ab$var$u;
$960dedfd64f242ab$var$u = Symbol.for("react.module.reference");
function $960dedfd64f242ab$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $960dedfd64f242ab$var$b:
                switch(a = a.type, a){
                    case $960dedfd64f242ab$var$d:
                    case $960dedfd64f242ab$var$f:
                    case $960dedfd64f242ab$var$e:
                    case $960dedfd64f242ab$var$m:
                    case $960dedfd64f242ab$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $960dedfd64f242ab$var$k:
                            case $960dedfd64f242ab$var$h:
                            case $960dedfd64f242ab$var$l:
                            case $960dedfd64f242ab$var$q:
                            case $960dedfd64f242ab$var$p:
                            case $960dedfd64f242ab$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $960dedfd64f242ab$var$c:
                return r;
        }
    }
}
$960dedfd64f242ab$export$a7c73072b1a182ae = $960dedfd64f242ab$var$h;
$960dedfd64f242ab$export$9f27bc3417b4524d = $960dedfd64f242ab$var$g;
$960dedfd64f242ab$export$db77ccec0bb4ccac = $960dedfd64f242ab$var$b;
$960dedfd64f242ab$export$8392c0c9d3dcbd35 = $960dedfd64f242ab$var$l;
$960dedfd64f242ab$export$ffb0004e005737fa = $960dedfd64f242ab$var$d;
$960dedfd64f242ab$export$b624eff549462981 = $960dedfd64f242ab$var$q;
$960dedfd64f242ab$export$7897aa7841a5380c = $960dedfd64f242ab$var$p;
$960dedfd64f242ab$export$602eac185826482c = $960dedfd64f242ab$var$c;
$960dedfd64f242ab$export$e2c29f18771995cb = $960dedfd64f242ab$var$f;
$960dedfd64f242ab$export$5f8d39834fd61797 = $960dedfd64f242ab$var$e;
$960dedfd64f242ab$export$74bf444e3cd11ea5 = $960dedfd64f242ab$var$m;
$960dedfd64f242ab$export$998bcd577473dd93 = $960dedfd64f242ab$var$n;
$960dedfd64f242ab$export$92387174baf9b227 = function() {
    return !1;
};
$960dedfd64f242ab$export$ec112efeb987d9c6 = function() {
    return !1;
};
$960dedfd64f242ab$export$b706b080d889d2c9 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$h;
};
$960dedfd64f242ab$export$5be5a87408f70ddc = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$g;
};
$960dedfd64f242ab$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $960dedfd64f242ab$var$b;
};
$960dedfd64f242ab$export$455c2e768291efa6 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$l;
};
$960dedfd64f242ab$export$9522e17588c12572 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$d;
};
$960dedfd64f242ab$export$2110ac352bb060b9 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$q;
};
$960dedfd64f242ab$export$56885ab8b9c456ab = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$p;
};
$960dedfd64f242ab$export$d927fcb6adf8f9de = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$c;
};
$960dedfd64f242ab$export$b82d16f27459e05a = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$f;
};
$960dedfd64f242ab$export$522c17b4f5e123e8 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$e;
};
$960dedfd64f242ab$export$1aabd8a0274ecfd6 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$m;
};
$960dedfd64f242ab$export$3d6c20d97e46b957 = function(a) {
    return $960dedfd64f242ab$var$v(a) === $960dedfd64f242ab$var$n;
};
$960dedfd64f242ab$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $960dedfd64f242ab$var$d || a === $960dedfd64f242ab$var$f || a === $960dedfd64f242ab$var$e || a === $960dedfd64f242ab$var$m || a === $960dedfd64f242ab$var$n || a === $960dedfd64f242ab$var$t || "object" === typeof a && null !== a && (a.$$typeof === $960dedfd64f242ab$var$q || a.$$typeof === $960dedfd64f242ab$var$p || a.$$typeof === $960dedfd64f242ab$var$g || a.$$typeof === $960dedfd64f242ab$var$h || a.$$typeof === $960dedfd64f242ab$var$l || a.$$typeof === $960dedfd64f242ab$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$960dedfd64f242ab$export$f5bbd400c2f4426f = $960dedfd64f242ab$var$v;

});

parcelRequire.register("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));




var $acw62 = parcelRequire("acw62");
var $af9e91ea6e32034a$exports = {};
"use strict";
Object.defineProperty($af9e91ea6e32034a$exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
function $af9e91ea6e32034a$var$create$1(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (nextState !== state) {
            var _previousState = state;
            state = replace ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribeWithSelector = function subscribeWithSelector(listener, selector, equalityFn) {
        if (selector === void 0) selector = getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        var currentSlice = selector(state);
        function listenerToAdd() {
            var nextSlice = selector(state);
            if (!equalityFn(currentSlice, nextSlice)) {
                var _previousSlice = currentSlice;
                listener(currentSlice = nextSlice, _previousSlice);
            }
        }
        listeners.add(listenerToAdd);
        return function() {
            return listeners.delete(listenerToAdd);
        };
    };
    var subscribe = function subscribe(listener, selector, equalityFn) {
        if (selector || equalityFn) return subscribeWithSelector(listener, selector, equalityFn);
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        return listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
}
var $af9e91ea6e32034a$var$isSSR = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
var $af9e91ea6e32034a$var$useIsomorphicLayoutEffect = $af9e91ea6e32034a$var$isSSR ? $acw62.useEffect : $acw62.useLayoutEffect;
function $af9e91ea6e32034a$var$create(createState) {
    var api = typeof createState === "function" ? $af9e91ea6e32034a$var$create$1(createState) : createState;
    var useStore = function useStore(selector, equalityFn) {
        if (selector === void 0) selector = api.getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        var _ref = $acw62.useReducer(function(c) {
            return c + 1;
        }, 0), forceUpdate = _ref[1];
        var state = api.getState();
        var stateRef = $acw62.useRef(state);
        var selectorRef = $acw62.useRef(selector);
        var equalityFnRef = $acw62.useRef(equalityFn);
        var erroredRef = $acw62.useRef(false);
        var currentSliceRef = $acw62.useRef();
        if (currentSliceRef.current === undefined) currentSliceRef.current = selector(state);
        var newStateSlice;
        var hasNewStateSlice = false;
        if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
            newStateSlice = selector(state);
            hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
        }
        $af9e91ea6e32034a$var$useIsomorphicLayoutEffect(function() {
            if (hasNewStateSlice) currentSliceRef.current = newStateSlice;
            stateRef.current = state;
            selectorRef.current = selector;
            equalityFnRef.current = equalityFn;
            erroredRef.current = false;
        });
        var stateBeforeSubscriptionRef = $acw62.useRef(state);
        $af9e91ea6e32034a$var$useIsomorphicLayoutEffect(function() {
            var listener = function listener() {
                try {
                    var nextState = api.getState();
                    var nextStateSlice = selectorRef.current(nextState);
                    if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
                        stateRef.current = nextState;
                        currentSliceRef.current = nextStateSlice;
                        forceUpdate();
                    }
                } catch (error) {
                    erroredRef.current = true;
                    forceUpdate();
                }
            };
            var unsubscribe = api.subscribe(listener);
            if (api.getState() !== stateBeforeSubscriptionRef.current) listener();
            return unsubscribe;
        }, []);
        return hasNewStateSlice ? newStateSlice : currentSliceRef.current;
    };
    Object.assign(useStore, api);
    useStore[Symbol.iterator] = function() {
        console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
        var items = [
            useStore,
            api
        ];
        return {
            next: function next() {
                var done = items.length <= 0;
                return {
                    value: items.shift(),
                    done: done
                };
            }
        };
    };
    return useStore;
}
$af9e91ea6e32034a$exports["default"] = $af9e91ea6e32034a$var$create;


const [$fa8bb1513e386061$export$650ce9f0b4df82fd, $fa8bb1513e386061$export$ba889d2df1fabb20] = (0, (/*@__PURE__*/$parcel$interopDefault($af9e91ea6e32034a$exports)))((set, get)=>({
        user: undefined,
        signIn: async ()=>{
            if (get().user !== undefined) {
                console.log("User is defined");
                return;
            }
            set({
                user: {
                    token: localStorage.getItem("token"),
                    refresh_token: localStorage.getItem("refresh_token")
                }
            });
        },
        signOut: async ()=>{
            if (get().user === undefined) {
                console.log("User is undefined");
                return;
            }
            localStorage.removeItem("token");
            localStorage.removeItem("refresh_token");
            set({
                user: undefined
            });
        }
    })) // await fetch()
 // fetch().then(response => {} // rest of the code)
 // fetch returns a Promise<T>
;





var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8nd05 = parcelRequire("8nd05");
function $0b14391bdc5d7d11$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $0b14391bdc5d7d11$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $0b14391bdc5d7d11$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $0b14391bdc5d7d11$var$isAbsolute(to);
    var isFromAbs = from && $0b14391bdc5d7d11$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $0b14391bdc5d7d11$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$0b14391bdc5d7d11$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $0b14391bdc5d7d11$export$2e2bcd8739ae039 = $0b14391bdc5d7d11$var$resolvePathname;


function $6e4c488965e5c6e8$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $6e4c488965e5c6e8$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $6e4c488965e5c6e8$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $6e4c488965e5c6e8$var$valueOf(a);
        var bValue = $6e4c488965e5c6e8$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $6e4c488965e5c6e8$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $6e4c488965e5c6e8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $6e4c488965e5c6e8$export$2e2bcd8739ae039 = $6e4c488965e5c6e8$var$valueEqual;



var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = "Invariant failed";
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}


function $2756f79476f0245f$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $2756f79476f0245f$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $2756f79476f0245f$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $2756f79476f0245f$var$stripBasename(path, prefix) {
    return $2756f79476f0245f$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $2756f79476f0245f$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $2756f79476f0245f$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $2756f79476f0245f$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $2756f79476f0245f$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $2756f79476f0245f$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $8nd05.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $0b14391bdc5d7d11$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $2756f79476f0245f$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $6e4c488965e5c6e8$export$2e2bcd8739ae039)(a.state, b.state);
}
function $2756f79476f0245f$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $2756f79476f0245f$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $2756f79476f0245f$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $2756f79476f0245f$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $2756f79476f0245f$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $2756f79476f0245f$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $2756f79476f0245f$var$PopStateEvent = "popstate";
var $2756f79476f0245f$var$HashChangeEvent = "hashchange";
function $2756f79476f0245f$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $2756f79476f0245f$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $2756f79476f0245f$var$supportsHistory();
    var needsHashChangeListener = !$2756f79476f0245f$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($2756f79476f0245f$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($2756f79476f0245f$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($2756f79476f0245f$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $2756f79476f0245f$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $2756f79476f0245f$var$HashChangeEvent$1 = "hashchange";
var $2756f79476f0245f$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $2756f79476f0245f$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $2756f79476f0245f$var$stripLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    },
    slash: {
        encodePath: $2756f79476f0245f$var$addLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    }
};
function $2756f79476f0245f$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $2756f79476f0245f$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $2756f79476f0245f$var$pushHashPath(path) {
    window.location.hash = path;
}
function $2756f79476f0245f$var$replaceHashPath(path) {
    window.location.replace($2756f79476f0245f$var$stripHash(window.location.href) + "#" + path);
}
function $2756f79476f0245f$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $2756f79476f0245f$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($2756f79476f0245f$var$getHashPath());
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $2756f79476f0245f$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $2756f79476f0245f$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $2756f79476f0245f$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $2756f79476f0245f$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $2756f79476f0245f$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $2756f79476f0245f$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $2756f79476f0245f$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $2756f79476f0245f$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $2756f79476f0245f$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $2756f79476f0245f$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $2756f79476f0245f$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, createKey()) : $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $2756f79476f0245f$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $2756f79476f0245f$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $8nd05 = parcelRequire("8nd05");
var $62ddf3174d9df941$exports = {};
var $52af415c3a3d4253$exports = {};
$52af415c3a3d4253$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $62ddf3174d9df941$exports = $62ddf3174d9df941$var$pathToRegexp;
$62ddf3174d9df941$exports.parse = $62ddf3174d9df941$var$parse;
$62ddf3174d9df941$exports.compile = $62ddf3174d9df941$var$compile;
$62ddf3174d9df941$exports.tokensToFunction = $62ddf3174d9df941$var$tokensToFunction;
$62ddf3174d9df941$exports.tokensToRegExp = $62ddf3174d9df941$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $62ddf3174d9df941$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $62ddf3174d9df941$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $62ddf3174d9df941$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $62ddf3174d9df941$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $62ddf3174d9df941$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $62ddf3174d9df941$var$compile(str, options) {
    return $62ddf3174d9df941$var$tokensToFunction($62ddf3174d9df941$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $62ddf3174d9df941$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $62ddf3174d9df941$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $62ddf3174d9df941$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($52af415c3a3d4253$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $62ddf3174d9df941$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $62ddf3174d9df941$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $62ddf3174d9df941$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($62ddf3174d9df941$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $62ddf3174d9df941$var$flags(options));
    return $62ddf3174d9df941$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$stringToRegexp(path, keys, options) {
    return $62ddf3174d9df941$var$tokensToRegExp($62ddf3174d9df941$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$tokensToRegExp(tokens, keys, options) {
    if (!$52af415c3a3d4253$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $62ddf3174d9df941$var$escapeString(token);
        else {
            var prefix = $62ddf3174d9df941$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $62ddf3174d9df941$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $62ddf3174d9df941$var$attachKeys(new RegExp("^" + route, $62ddf3174d9df941$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$pathToRegexp(path, keys, options) {
    if (!$52af415c3a3d4253$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $62ddf3174d9df941$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($52af415c3a3d4253$exports(path)) return $62ddf3174d9df941$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $62ddf3174d9df941$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $9ceddbf24b52ffba$exports = {};
"use strict";

$9ceddbf24b52ffba$exports = (parcelRequire("bilNr"));



var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");
var $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $ebf4c3fe5600f7ed$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $ebf4c3fe5600f7ed$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $ebf4c3fe5600f7ed$var$commonjsGlobal[key] = ($ebf4c3fe5600f7ed$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $ebf4c3fe5600f7ed$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $ebf4c3fe5600f7ed$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $ebf4c3fe5600f7ed$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $ebf4c3fe5600f7ed$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $ebf4c3fe5600f7ed$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $g7ajw.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $ebf4c3fe5600f7ed$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($ebf4c3fe5600f7ed$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $g7ajw.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $ebf4c3fe5600f7ed$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $ebf4c3fe5600f7ed$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext || $ebf4c3fe5600f7ed$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $ebf4c3fe5600f7ed$var$createNamedContext = function createNamedContext(name) {
    var context = $ebf4c3fe5600f7ed$var$createContext();
    context.displayName = name;
    return context;
};
var $ebf4c3fe5600f7ed$export$c213558b66925821 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router-History");
var $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $ebf4c3fe5600f7ed$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $ebf4c3fe5600f7ed$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $ebf4c3fe5600f7ed$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $ebf4c3fe5600f7ed$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $ebf4c3fe5600f7ed$var$messageType;
var $ebf4c3fe5600f7ed$var$cache = {};
var $ebf4c3fe5600f7ed$var$cacheLimit = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount = 0;
function $ebf4c3fe5600f7ed$var$compilePath(path) {
    if ($ebf4c3fe5600f7ed$var$cache[path]) return $ebf4c3fe5600f7ed$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($62ddf3174d9df941$exports))).compile(path);
    if ($ebf4c3fe5600f7ed$var$cacheCount < $ebf4c3fe5600f7ed$var$cacheLimit) {
        $ebf4c3fe5600f7ed$var$cache[path] = generator;
        $ebf4c3fe5600f7ed$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $ebf4c3fe5600f7ed$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $ebf4c3fe5600f7ed$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $2756f79476f0245f$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $ebf4c3fe5600f7ed$export$82476f982757e71e(to, computedMatch.params) : (0, $8nd05.default)({}, to, {
            pathname: $ebf4c3fe5600f7ed$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $2756f79476f0245f$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $2756f79476f0245f$export$c3e8bb440bd55b18)(prevLocation, (0, $8nd05.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $ebf4c3fe5600f7ed$var$cache$1 = {};
var $ebf4c3fe5600f7ed$var$cacheLimit$1 = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount$1 = 0;
function $ebf4c3fe5600f7ed$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $ebf4c3fe5600f7ed$var$cache$1[cacheKey] || ($ebf4c3fe5600f7ed$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($62ddf3174d9df941$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($ebf4c3fe5600f7ed$var$cacheCount$1 < $ebf4c3fe5600f7ed$var$cacheLimit$1) {
        pathCache[path] = result;
        $ebf4c3fe5600f7ed$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $ebf4c3fe5600f7ed$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $ebf4c3fe5600f7ed$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $ebf4c3fe5600f7ed$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 0;
}
function $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $8nd05.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $ebf4c3fe5600f7ed$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
function $ebf4c3fe5600f7ed$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $ebf4c3fe5600f7ed$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: $ebf4c3fe5600f7ed$var$addLeadingSlash(basename) + location.pathname
    });
}
function $ebf4c3fe5600f7ed$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $ebf4c3fe5600f7ed$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $ebf4c3fe5600f7ed$var$createURL(location) {
    return typeof location === "string" ? location : (0, $2756f79476f0245f$export$fe53371bee54353d)(location);
}
function $ebf4c3fe5600f7ed$var$staticHandler(methodName) {
    return function() {
        (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
    };
}
function $ebf4c3fe5600f7ed$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $ebf4c3fe5600f7ed$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        _this.handleBlock = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $ebf4c3fe5600f7ed$var$addBasename(basename, (0, $2756f79476f0245f$export$90c043f1c57770b8)(location));
        context.url = $ebf4c3fe5600f7ed$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $1En50.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $ebf4c3fe5600f7ed$var$addLeadingSlash(basename + $ebf4c3fe5600f7ed$var$createURL(path));
            },
            action: "POP",
            location: $ebf4c3fe5600f7ed$var$stripBasename(basename, (0, $2756f79476f0245f$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $ebf4c3fe5600f7ed$var$staticHandler("go"),
            goBack: $ebf4c3fe5600f7ed$var$staticHandler("goBack"),
            goForward: $ebf4c3fe5600f7ed$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, (0, $8nd05.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, (0, $8nd05.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $ebf4c3fe5600f7ed$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $1En50.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component);
}
var $ebf4c3fe5600f7ed$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext;
function $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$c213558b66925821);
}
function $ebf4c3fe5600f7ed$export$45d76561a5302f2b() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).location;
}
function $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef() {
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $ebf4c3fe5600f7ed$export$632be4bb944c1bc7(path) {
    var location = $ebf4c3fe5600f7ed$export$45d76561a5302f2b();
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, path) : match;
}
var $ebf4c3fe5600f7ed$var$global$1, $ebf4c3fe5600f7ed$var$key, $ebf4c3fe5600f7ed$var$buildNames, $ebf4c3fe5600f7ed$var$initialBuildName, $ebf4c3fe5600f7ed$var$secondaryBuildName;



var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $3189c83282a9a1c6$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $3189c83282a9a1c6$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $2756f79476f0245f$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $3189c83282a9a1c6$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $3189c83282a9a1c6$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $2756f79476f0245f$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $3189c83282a9a1c6$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef === "undefined") $3189c83282a9a1c6$var$forwardRef = $3189c83282a9a1c6$var$forwardRefShim;
function $3189c83282a9a1c6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $3189c83282a9a1c6$var$LinkAnchor = $3189c83282a9a1c6$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1En50.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $8nd05.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$3189c83282a9a1c6$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $3189c83282a9a1c6$export$a6c7ac8248d6e38a = $3189c83282a9a1c6$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $3189c83282a9a1c6$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1En50.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $8nd05.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $3189c83282a9a1c6$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $2756f79476f0245f$export$fe53371bee54353d)(context.location) === (0, $2756f79476f0245f$export$fe53371bee54353d)($3189c83282a9a1c6$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props);
    });
});
var $3189c83282a9a1c6$var$toType, $3189c83282a9a1c6$var$refType;
var $3189c83282a9a1c6$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef$1 === "undefined") $3189c83282a9a1c6$var$forwardRef$1 = $3189c83282a9a1c6$var$forwardRefShim$1;
function $3189c83282a9a1c6$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $3189c83282a9a1c6$export$b0d92dbee9b5b60d = $3189c83282a9a1c6$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1En50.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $ebf4c3fe5600f7ed$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $3189c83282a9a1c6$var$joinClassnames(className, activeClassName);
            style = (0, $8nd05.default)({}, style, activeStyle);
        }
        var props = (0, $8nd05.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim$1 !== $3189c83282a9a1c6$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3189c83282a9a1c6$export$a6c7ac8248d6e38a, props);
    });
});
var $3189c83282a9a1c6$var$ariaCurrentType;




var $acw62 = parcelRequire("acw62");



const $e0668e8a5168414a$var$AMAX_API_URL = "https://amax-emu.com/api";
const [$e0668e8a5168414a$export$f1ca3e4aa5b73d6d, $e0668e8a5168414a$export$4a6e94a6e80a47] = (0, (/*@__PURE__*/$parcel$interopDefault($af9e91ea6e32034a$exports)))((set, get)=>{
    return {
        userData: undefined,
        getData: async ()=>{
            const auth = (0, $fa8bb1513e386061$export$ba889d2df1fabb20).getState();
            if (auth.user === undefined) return;
            else {
                // if (get().userData !== undefined) {
                //     console.log("User is defined")
                //     return
                // } else {
                console.log("GETTING USER DATA");
                const resp = await fetch($e0668e8a5168414a$var$AMAX_API_URL + "/players/@me", {
                    method: "GET",
                    headers: {
                        "content-type": "application/json;charset=UTF-8",
                        "Authorization": `Bearer ${auth.user.token}`
                    }
                });
                const temp = await resp.json();
                console.log("GOT USER DATA");
                set({
                    userData: temp
                });
                console.log("SET USER DATA");
            // }
            }
        },
        clearData: async ()=>{
            const auth = (0, $fa8bb1513e386061$export$ba889d2df1fabb20).getState();
            if (auth.user !== undefined) return;
            set({
                userData: undefined
            });
        }
    };
}) // await fetch()
 // fetch().then(response => {} // rest of the code)
 // fetch returns a Promise<T>
;



var $3ecb7368762fc268$export$f9380c9a627682d3;
var $3ecb7368762fc268$export$98e6a39c04603d36;
var $3ecb7368762fc268$export$fac44ee5b035f737;
var $3ecb7368762fc268$export$7a5253c0f62e0150;
var $3ecb7368762fc268$export$a8c1621ea79325d3;
var $3ecb7368762fc268$export$357523c63a2253b9;
var $3ecb7368762fc268$export$44c361b8ec72ef7f;
"use strict";
var $2854ab6fe5249e91$exports = {};
"use strict";
$2854ab6fe5249e91$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $40bbc24beab9f9b8$exports = {};
"use strict";
var $40bbc24beab9f9b8$var$token = "%[a-f0-9]{2}";
var $40bbc24beab9f9b8$var$singleMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")|([^%]+?)", "gi");
var $40bbc24beab9f9b8$var$multiMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")+", "gi");
function $40bbc24beab9f9b8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $40bbc24beab9f9b8$var$decodeComponents(left), $40bbc24beab9f9b8$var$decodeComponents(right));
}
function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $40bbc24beab9f9b8$var$decodeComponents(tokens, i).join("");
            tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        }
        return input;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "��",
        "%FF%FE": "��"
    };
    var match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "�";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$40bbc24beab9f9b8$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
};


var $08bd16383ca1ef3d$exports = {};
"use strict";
$08bd16383ca1ef3d$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $36fe9d1ef26e3f64$exports = {};
"use strict";
$36fe9d1ef26e3f64$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $3ecb7368762fc268$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $3ecb7368762fc268$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $3ecb7368762fc268$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            $3ecb7368762fc268$var$encode(index, options),
                            "]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $3ecb7368762fc268$var$encode(key, options),
                                keyValueSep,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $3ecb7368762fc268$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $3ecb7368762fc268$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $3ecb7368762fc268$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $3ecb7368762fc268$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options)) : value === null ? value : $3ecb7368762fc268$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $3ecb7368762fc268$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3ecb7368762fc268$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $3ecb7368762fc268$var$encode(value, options) {
    if (options.encode) return options.strict ? $2854ab6fe5249e91$exports(value) : encodeURIComponent(value);
    return value;
}
function $3ecb7368762fc268$var$decode(value, options) {
    if (options.decode) return $40bbc24beab9f9b8$exports(value);
    return value;
}
function $3ecb7368762fc268$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $3ecb7368762fc268$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $3ecb7368762fc268$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $3ecb7368762fc268$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $3ecb7368762fc268$var$extract(input) {
    input = $3ecb7368762fc268$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $3ecb7368762fc268$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $3ecb7368762fc268$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $3ecb7368762fc268$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $08bd16383ca1ef3d$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $3ecb7368762fc268$var$decode(value, options);
        formatter($3ecb7368762fc268$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $3ecb7368762fc268$var$parseValue(value[k], options);
        else ret[key] = $3ecb7368762fc268$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $3ecb7368762fc268$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$3ecb7368762fc268$export$f9380c9a627682d3 = $3ecb7368762fc268$var$extract;
$3ecb7368762fc268$export$98e6a39c04603d36 = $3ecb7368762fc268$var$parse;
$3ecb7368762fc268$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $3ecb7368762fc268$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $3ecb7368762fc268$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $3ecb7368762fc268$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $3ecb7368762fc268$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $3ecb7368762fc268$var$encode(key, options) + "=" + $3ecb7368762fc268$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$3ecb7368762fc268$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $08bd16383ca1ef3d$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $3ecb7368762fc268$var$parse($3ecb7368762fc268$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $3ecb7368762fc268$var$decode(hash, options)
    } : {});
};
$3ecb7368762fc268$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $3ecb7368762fc268$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $3ecb7368762fc268$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $3ecb7368762fc268$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $3ecb7368762fc268$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $3ecb7368762fc268$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$3ecb7368762fc268$var$encodeFragmentIdentifier] ? $3ecb7368762fc268$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$3ecb7368762fc268$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url , query: query , fragmentIdentifier: fragmentIdentifier  } = $3ecb7368762fc268$export$7a5253c0f62e0150(input, options);
    return $3ecb7368762fc268$export$a8c1621ea79325d3({
        url: url,
        query: $36fe9d1ef26e3f64$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$3ecb7368762fc268$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $3ecb7368762fc268$export$357523c63a2253b9(input, exclusionFilter, options);
};


function $bdbc953dcbe2c506$export$2e2bcd8739ae039() {
    const parsed = $3ecb7368762fc268$export$98e6a39c04603d36(location.search);
    const auth = (0, $fa8bb1513e386061$export$650ce9f0b4df82fd)();
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    const history = (0, $2756f79476f0245f$export$719fc203c4e16dee)({
        forceRefresh: true
    });
    const token = parsed.token;
    const refresh_token = parsed.refresh_token;
    if (typeof token === "string") localStorage.setItem("token", token);
    if (typeof refresh_token === "string") localStorage.setItem("refresh_token", refresh_token);
    // auth.signIn()
    // user.getData()
    $acw62.useEffect(()=>{
        setTimeout(()=>{
            history.push("/Dashboard");
        }, 1000);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: auth.user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
            children: "Discord login is successful"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
            children: "Fail to log in"
        })
    });
}



parcelRequire("acw62");

const $4f0ef7a7899ea494$var$AMAX_API_URL = "https://amax-emu.com/api";
function $4f0ef7a7899ea494$var$user_data_getter() {
    const auth = (0, $fa8bb1513e386061$export$650ce9f0b4df82fd)();
    const headers = {
        "Content-Type": "application/json"
    };
    headers["Authorization"] = `Bearer ${auth.user.token}`;
    fetch($4f0ef7a7899ea494$var$AMAX_API_URL + "/players/@me", {
        headers: headers
    }).then((response)=>response.json()).then((responseData)=>{
        console.log(responseData);
        return responseData;
    }).catch((error)=>console.warn(error));
}
function $4f0ef7a7899ea494$export$2e2bcd8739ae039() {
    const auth = (0, $fa8bb1513e386061$export$650ce9f0b4df82fd)();
    if (auth.user) {
        let user_data_request = {};
        $4f0ef7a7899ea494$var$user_data_getter();
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
            children: "Logged in"
        });
    } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
        children: "You're not logged in"
    });
}



var $eOWQz = parcelRequire("eOWQz");
var $8nd05 = parcelRequire("8nd05");

var $cp2NC = parcelRequire("cp2NC");

var $kpDC5 = parcelRequire("kpDC5");
function $682e8c99752ec43b$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $cp2NC.default)(stylesOrCreator, (0, $8nd05.default)({
        defaultTheme: (0, $kpDC5.default)
    }, options));
}
var $682e8c99752ec43b$export$2e2bcd8739ae039 = $682e8c99752ec43b$var$makeStyles;


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $k4AIz = parcelRequire("k4AIz");

var $gkNc2 = parcelRequire("gkNc2");

var $bh5Jy = parcelRequire("bh5Jy");
function $4d79f8f47db109a9$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $4d79f8f47db109a9$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $gkNc2.default)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $4d79f8f47db109a9$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $bh5Jy.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k4AIz.default).Provider, {
        value: theme
    }, children);
}
var $4d79f8f47db109a9$export$2e2bcd8739ae039 = $4d79f8f47db109a9$var$ThemeProvider;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $kQaj4 = parcelRequire("kQaj4");

var $cb625d82dd03aa71$export$c0bb0b647f701bb5 = {
    WebkitFontSmoothing: "antialiased",
    // Antialiasing.
    MozOsxFontSmoothing: "grayscale",
    // Antialiasing.
    // Change from `box-sizing: content-box` so that `width`
    // is not affected by `padding` or `border`.
    boxSizing: "border-box"
};
var $cb625d82dd03aa71$export$32180ef41b15b513 = function body(theme) {
    return (0, $8nd05.default)({
        color: theme.palette.text.primary
    }, theme.typography.body2, {
        backgroundColor: theme.palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: theme.palette.common.white
        }
    });
};
var $cb625d82dd03aa71$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        "@global": {
            html: $cb625d82dd03aa71$export$c0bb0b647f701bb5,
            "*, *::before, *::after": {
                boxSizing: "inherit"
            },
            "strong, b": {
                fontWeight: theme.typography.fontWeightBold
            },
            body: (0, $8nd05.default)({
                margin: 0
            }, $cb625d82dd03aa71$export$32180ef41b15b513(theme), {
                // Add support for document.body.requestFullScreen().
                // Other elements, if background transparent, are not supported.
                "&::backdrop": {
                    backgroundColor: theme.palette.background.default
                }
            })
        }
    };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $cb625d82dd03aa71$var$CssBaseline(props) {
    /* eslint-disable no-unused-vars */ var _props$children = props.children, children = _props$children === void 0 ? null : _props$children, classes = props.classes;
    /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, children);
}
var $cb625d82dd03aa71$export$2e2bcd8739ae039 = (0, $kQaj4.default)($cb625d82dd03aa71$export$9dd6ff9ea0189349, {
    name: "MuiCssBaseline"
})($cb625d82dd03aa71$var$CssBaseline);




var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");

var $f9tk6 = parcelRequire("f9tk6");
var $a36c7122d0aec5cd$var$SIZE = 44;
var $a36c7122d0aec5cd$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "inline-block"
        },
        /* Styles applied to the root element if `variant="static"`. */ static: {
            transition: theme.transitions.create("transform")
        },
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {
            animation: "$circular-rotate 1.4s linear infinite"
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {
            transition: theme.transitions.create("transform")
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the `svg` element. */ svg: {
            display: "block" // Keeps the progress centered
        },
        /* Styles applied to the `circle` svg path. */ circle: {
            stroke: "currentColor" // Use butt to follow the specification, by chance, it's already the default CSS value.
        },
        /* Styles applied to the `circle` svg path if `variant="static"`. */ circleStatic: {
            transition: theme.transitions.create("stroke-dashoffset")
        },
        /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */ circleIndeterminate: {
            animation: "$circular-dash 1.4s ease-in-out infinite",
            // Some default value that looks fine waiting for the animation to kicks in.
            strokeDasharray: "80px, 200px",
            strokeDashoffset: "0px" // Add the unit to fix a Edge 16 and below bug.
        },
        /* Styles applied to the `circle` svg path if `variant="determinate"`. */ circleDeterminate: {
            transition: theme.transitions.create("stroke-dashoffset")
        },
        "@keyframes circular-rotate": {
            "0%": {
                // Fix IE 11 wobbly
                transformOrigin: "50% 50%"
            },
            "100%": {
                transform: "rotate(360deg)"
            }
        },
        "@keyframes circular-dash": {
            "0%": {
                strokeDasharray: "1px, 200px",
                strokeDashoffset: "0px"
            },
            "50%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-15px"
            },
            "100%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-125px"
            }
        },
        /* Styles applied to the `circle` svg path if `disableShrink={true}`. */ circleDisableShrink: {
            animation: "none"
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $a36c7122d0aec5cd$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? "indeterminate" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === "determinate" || variant === "static") {
        var circumference = 2 * Math.PI * (($a36c7122d0aec5cd$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $f9tk6.default)(color))], {
            "determinate": classes.determinate,
            "indeterminate": classes.indeterminate,
            "static": classes.static
        }[variant]),
        style: (0, $8nd05.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ref: ref,
        role: "progressbar"
    }, rootProps, other), /*#__PURE__*/ $acw62.createElement("svg", {
        className: classes.svg,
        viewBox: "".concat($a36c7122d0aec5cd$var$SIZE / 2, " ").concat($a36c7122d0aec5cd$var$SIZE / 2, " ").concat($a36c7122d0aec5cd$var$SIZE, " ").concat($a36c7122d0aec5cd$var$SIZE)
    }, /*#__PURE__*/ $acw62.createElement("circle", {
        className: (0, $1SA7b.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
            "determinate": classes.circleDeterminate,
            "indeterminate": classes.circleIndeterminate,
            "static": classes.circleStatic
        }[variant]),
        style: circleStyle,
        cx: $a36c7122d0aec5cd$var$SIZE,
        cy: $a36c7122d0aec5cd$var$SIZE,
        r: ($a36c7122d0aec5cd$var$SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
});
var $a36c7122d0aec5cd$export$2e2bcd8739ae039 = (0, $kQaj4.default)($a36c7122d0aec5cd$export$9dd6ff9ea0189349, {
    name: "MuiCircularProgress",
    flip: false
})($a36c7122d0aec5cd$var$CircularProgress);


function $aab70964ff9d4b98$export$2e2bcd8739ae039(styles) {
    return styles;
}


function $5dbed217b9b82c10$export$2e2bcd8739ae039(styles) {
    // warning(
    //   warnOnce,
    //   [
    //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
    //     'Please use @material-ui/styles/createStyles',
    //   ].join('\n'),
    // );
    // warnOnce = true;
    return (0, $aab70964ff9d4b98$export$2e2bcd8739ae039)(styles);
}


var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;


var $51f08ebed50a2438$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $51f08ebed50a2438$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1e0ecff44bad0ea1$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1e0ecff44bad0ea1$exports(o, minLen);
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(arr, i) {
    return $bf2dbd940d8d1ee7$exports(arr) || $efa3fde0b6100532$exports(arr, i) || $51f08ebed50a2438$exports(arr, i) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;


var $bb7ca61ce45563c4$exports = {};
var $010f4e0e13c82e16$exports = {};
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(obj);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


var $010f4e0e13c82e16$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $b77c8068776c2a21$exports = {};

var $b77c8068776c2a21$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $b77c8068776c2a21$var$_toPrimitive(input, hint) {
    if ($b77c8068776c2a21$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b77c8068776c2a21$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$_toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$_toPropertyKey(arg) {
    var key = $b77c8068776c2a21$exports(arg, "string");
    return $010f4e0e13c82e16$var$_typeof(key) === "symbol" ? key : String(key);
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$_toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $010f4e0e13c82e16$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;



var $acw62 = parcelRequire("acw62");
var $b45a6abf916bff88$exports = {};
function $b45a6abf916bff88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$b45a6abf916bff88$exports = $b45a6abf916bff88$var$_classCallCheck, $b45a6abf916bff88$exports.__esModule = true, $b45a6abf916bff88$exports["default"] = $b45a6abf916bff88$exports;


var $fe9438347a673ba6$exports = {};

function $fe9438347a673ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $010f4e0e13c82e16$exports(descriptor.key), descriptor);
    }
}
function $fe9438347a673ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9438347a673ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9438347a673ba6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$fe9438347a673ba6$exports = $fe9438347a673ba6$var$_createClass, $fe9438347a673ba6$exports.__esModule = true, $fe9438347a673ba6$exports["default"] = $fe9438347a673ba6$exports;




var $acw62 = parcelRequire("acw62");
var $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $d7f2d92b0368699f$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $d7f2d92b0368699f$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $d7f2d92b0368699f$var$htmlEntities[m];
};
var $d7f2d92b0368699f$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);
};


function $0636c84fe4549f1f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0636c84fe4549f1f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0636c84fe4549f1f$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0636c84fe4549f1f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $0636c84fe4549f1f$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $d7f2d92b0368699f$export$e8bacd2802a88316)
};
var $0636c84fe4549f1f$var$i18nInstance;
var $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
function $0636c84fe4549f1f$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $0636c84fe4549f1f$var$defaultOptions = $0636c84fe4549f1f$var$_objectSpread($0636c84fe4549f1f$var$_objectSpread({}, $0636c84fe4549f1f$var$defaultOptions), options);
}
function $0636c84fe4549f1f$export$212bb2fc580a90a8() {
    return $0636c84fe4549f1f$var$defaultOptions;
}
var $0636c84fe4549f1f$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $0636c84fe4549f1f$export$a039134f2fc7e0(instance) {
    $0636c84fe4549f1f$var$i18nInstance = instance;
}
function $0636c84fe4549f1f$export$64af334f494c2f47() {
    return $0636c84fe4549f1f$var$i18nInstance;
}
var $0636c84fe4549f1f$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        $0636c84fe4549f1f$export$2e2366488d12e20d(instance.options.react);
        $0636c84fe4549f1f$export$a039134f2fc7e0(instance);
    }
};
function $0636c84fe4549f1f$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($0636c84fe4549f1f$var$_objectSpread($0636c84fe4549f1f$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $0636c84fe4549f1f$export$704200e5d0b9e8f() {
    var i18n = $0636c84fe4549f1f$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $cfb6e0167e0b350d$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $cfb6e0167e0b350d$var$alreadyWarned = {};
function $cfb6e0167e0b350d$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $cfb6e0167e0b350d$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $cfb6e0167e0b350d$var$alreadyWarned[args[0]] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    });
}
function $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $cfb6e0167e0b350d$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $cfb6e0167e0b350d$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


function $3765cebd031b52c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3765cebd031b52c0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3765cebd031b52c0$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3765cebd031b52c0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $3765cebd031b52c0$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $3765cebd031b52c0$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $0636c84fe4549f1f$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $3765cebd031b52c0$var$_objectSpread($3765cebd031b52c0$var$_objectSpread($3765cebd031b52c0$var$_objectSpread({}, (0, $0636c84fe4549f1f$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $acw62.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $3765cebd031b52c0$var$usePrevious(joinedNS);
    var isMounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}


const $2a981844268212c5$var$AMAX_API_URL = "https://amax-emu.com/api";
const $2a981844268212c5$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            margin: 15,
            width: 570,
            height: 636,
            /* Blue/700 (2 L) */ background: "#304254",
            /* Blue/600 */ border: "1px solid #3E5270",
            boxSizing: "border-box",
            borderRadius: 8
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        }
    }));
function $2a981844268212c5$export$2e2bcd8739ae039() {
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $2a981844268212c5$var$useStyles();
    const [serverStatusData, setserverStatusData] = $acw62.useState(undefined);
    const [severDataFlag, setseverDataFlag] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        async function getServerData() {
            const resp = await fetch($2a981844268212c5$var$AMAX_API_URL + "/data/server_status", {
                method: "GET",
                headers: {
                    "content-type": "application/json;charset=UTF-8"
                }
            });
            setserverStatusData(await resp.json());
            setseverDataFlag(true);
        }
        getServerData().catch(()=>{});
    }, []);
    const ServerStatusLabel = ()=>{
        if (severDataFlag) {
            if (serverStatusData.data.server_status) return t("server_status_widget.online");
            else return t("server_status_widget.offline");
        } else return "";
    };
    const LedContent = ()=>{
        if (severDataFlag) {
            if (serverStatusData.data.server_status) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "server_header_lamp"
            });
            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "server_header_lamp_offline"
            });
        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    };
    const CardContent = ()=>{
        if (severDataFlag) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "card_item",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "card_item_name",
                            children: t("server_status_widget.players")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "card_item_value",
                            children: serverStatusData.data.server_status ? serverStatusData.data.total_players : "Nan"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "card_item",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "card_item_name",
                            children: t("server_status_widget.sessions")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "card_item_value",
                            children: serverStatusData.data.server_status ? serverStatusData.data.total_sessions : "Nan"
                        })
                    ]
                })
            ]
        });
        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: classes.spinner,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a36c7122d0aec5cd$export$2e2bcd8739ae039), {})
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "server_status_widget_container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "server_header",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: "server_status_header",
                        children: t("server_status_widget.server_status")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: "server_status",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ServerStatusLabel, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(LedContent, {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "card_container",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(CardContent, {})
            })
        ]
    });
}



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $f9tk6 = parcelRequire("f9tk6");
var $64d9a99297a346fe$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $kSlfw.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            display: "block"
        }, theme.breakpoints.up("sm"), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `disableGutters={true}`. */ disableGutters: {
            paddingLeft: 0,
            paddingRight: 0
        },
        /* Styles applied to the root element if `fixed={true}`. */ fixed: Object.keys(theme.breakpoints.values).reduce(function(acc, breakpoint) {
            var value = theme.breakpoints.values[breakpoint];
            if (value !== 0) acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: value
            };
            return acc;
        }, {}),
        /* Styles applied to the root element if `maxWidth="xs"`. */ maxWidthXs: (0, $kSlfw.default)({}, theme.breakpoints.up("xs"), {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444)
        }),
        /* Styles applied to the root element if `maxWidth="sm"`. */ maxWidthSm: (0, $kSlfw.default)({}, theme.breakpoints.up("sm"), {
            maxWidth: theme.breakpoints.values.sm
        }),
        /* Styles applied to the root element if `maxWidth="md"`. */ maxWidthMd: (0, $kSlfw.default)({}, theme.breakpoints.up("md"), {
            maxWidth: theme.breakpoints.values.md
        }),
        /* Styles applied to the root element if `maxWidth="lg"`. */ maxWidthLg: (0, $kSlfw.default)({}, theme.breakpoints.up("lg"), {
            maxWidth: theme.breakpoints.values.lg
        }),
        /* Styles applied to the root element if `maxWidth="xl"`. */ maxWidthXl: (0, $kSlfw.default)({}, theme.breakpoints.up("xl"), {
            maxWidth: theme.breakpoints.values.xl
        })
    };
};
var $64d9a99297a346fe$var$Container = /*#__PURE__*/ $acw62.forwardRef(function Container(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$fixed = props.fixed, fixed = _props$fixed === void 0 ? false : _props$fixed, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? "lg" : _props$maxWidth, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "fixed",
        "maxWidth"
    ]);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0, $f9tk6.default)(String(maxWidth)))]),
        ref: ref
    }, other));
});
var $64d9a99297a346fe$export$2e2bcd8739ae039 = (0, $kQaj4.default)($64d9a99297a346fe$export$9dd6ff9ea0189349, {
    name: "MuiContainer"
})($64d9a99297a346fe$var$Container);



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




parcelRequire("acw62");


parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $a189f5f328f4f0c2$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");



var $kQaj4 = parcelRequire("kQaj4");

var $9GbWv = parcelRequire("9GbWv");

var $acw62 = parcelRequire("acw62");
// TODO v5: consider to make it private
function $dc6adfc0d47b3cd2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $2e19e2d9ab6312a7$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $acw62.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $dc6adfc0d47b3cd2$export$2e2bcd8739ae039)(refA, refValue);
            (0, $dc6adfc0d47b3cd2$export$2e2bcd8739ae039)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}




var $f9tk6 = parcelRequire("f9tk6");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");



var $1SA7b = parcelRequire("1SA7b");



var $acw62 = parcelRequire("acw62");
var $78f4792555064dc2$var$useEnhancedEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
function $78f4792555064dc2$export$2e2bcd8739ae039(fn) {
    var ref = $acw62.useRef(fn);
    $78f4792555064dc2$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $acw62.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}




var $kQaj4 = parcelRequire("kQaj4");
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $acw62 = parcelRequire("acw62");

var $7beb6b6538ff0014$var$hadKeyboardEvent = true;
var $7beb6b6538ff0014$var$hadFocusVisibleRecently = false;
var $7beb6b6538ff0014$var$hadFocusVisibleRecentlyTimeout = null;
var $7beb6b6538ff0014$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $7beb6b6538ff0014$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === "INPUT" && $7beb6b6538ff0014$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $7beb6b6538ff0014$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $7beb6b6538ff0014$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $7beb6b6538ff0014$var$handlePointerDown() {
    $7beb6b6538ff0014$var$hadKeyboardEvent = false;
}
function $7beb6b6538ff0014$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($7beb6b6538ff0014$var$hadFocusVisibleRecently) $7beb6b6538ff0014$var$hadKeyboardEvent = true;
    }
}
function $7beb6b6538ff0014$var$prepare(doc) {
    doc.addEventListener("keydown", $7beb6b6538ff0014$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $7beb6b6538ff0014$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $7beb6b6538ff0014$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $7beb6b6538ff0014$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $7beb6b6538ff0014$var$handleVisibilityChange, true);
}
function $7beb6b6538ff0014$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $7beb6b6538ff0014$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $7beb6b6538ff0014$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $7beb6b6538ff0014$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $7beb6b6538ff0014$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $7beb6b6538ff0014$var$handleVisibilityChange, true);
}
function $7beb6b6538ff0014$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(":focus-visible");
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $7beb6b6538ff0014$var$hadKeyboardEvent || $7beb6b6538ff0014$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $7beb6b6538ff0014$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $7beb6b6538ff0014$var$hadFocusVisibleRecently = true;
    window.clearTimeout($7beb6b6538ff0014$var$hadFocusVisibleRecentlyTimeout);
    $7beb6b6538ff0014$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $7beb6b6538ff0014$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $7beb6b6538ff0014$export$2e2bcd8739ae039() {
    var ref = $acw62.useCallback(function(instance) {
        var node = $11492dca620dcaa5$exports.findDOMNode(instance);
        if (node != null) $7beb6b6538ff0014$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $7beb6b6538ff0014$var$isFocusVisible,
        onBlurVisible: $7beb6b6538ff0014$var$handleBlurVisible,
        ref: ref
    };
}



var $8nd05 = parcelRequire("8nd05");

var $kbxxf = parcelRequire("kbxxf");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);



var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, "appear", props),
            enter: $04540450bf60efa1$var$getProp(child, "enter", props),
            exit: $04540450bf60efa1$var$getProp(child, "exit", props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, "exit", nextProps),
            enter: $04540450bf60efa1$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, "exit", nextProps),
            enter: $04540450bf60efa1$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hDpcU.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1En50.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;



var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $29856bfb2e7b4a91$var$useEnhancedEffect = typeof window === "undefined" ? $acw62.useEffect : $acw62.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $29856bfb2e7b4a91$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $acw62.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $1SA7b.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $1SA7b.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $29856bfb2e7b4a91$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $acw62.createElement("span", {
        className: childClassName
    }));
}
var $29856bfb2e7b4a91$export$2e2bcd8739ae039 = $29856bfb2e7b4a91$var$Ripple;


var $1aa6ee629397579b$var$DURATION = 550;
var $1aa6ee629397579b$export$95d0c9356b2231a3 = 80;
var $1aa6ee629397579b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit"
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: "absolute"
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: "scale(1)",
            animation: "$enter ".concat($1aa6ee629397579b$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: "block",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "currentColor"
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($1aa6ee629397579b$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: "absolute",
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        "@keyframes enter": {
            "0%": {
                transform: "scale(0)",
                opacity: 0.1
            },
            "100%": {
                transform: "scale(1)",
                opacity: 0.3
            }
        },
        "@keyframes exit": {
            "0%": {
                opacity: 1
            },
            "100%": {
                opacity: 0
            }
        },
        "@keyframes pulsate": {
            "0%": {
                transform: "scale(1)"
            },
            "50%": {
                transform: "scale(0.92)"
            },
            "100%": {
                transform: "scale(1)"
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $1aa6ee629397579b$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $9X7IJ.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $acw62.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $acw62.useRef(0);
    var rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $acw62.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $acw62.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $acw62.useRef(null);
    var container = $acw62.useRef(null);
    $acw62.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $acw62.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $kbxxf.default)(oldRipples), [
                /*#__PURE__*/ $acw62.createElement((0, $29856bfb2e7b4a91$export$2e2bcd8739ae039), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $1aa6ee629397579b$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $acw62.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === "touchstart") ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $1aa6ee629397579b$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $acw62.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $acw62.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === "touchend" && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $acw62.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $acw62.createElement("span", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $acw62.createElement((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
        component: null,
        exit: true
    }, ripples));
});
var $1aa6ee629397579b$export$2e2bcd8739ae039 = (0, $kQaj4.default)($1aa6ee629397579b$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiTouchRipple"
})(/*#__PURE__*/ $acw62.memo($1aa6ee629397579b$var$TouchRipple));


var $ac65ba7da5d490c4$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        textDecoration: "none",
        // So we take precedent over the style of a native <a /> element.
        color: "inherit",
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$disabled": {
            pointerEvents: "none",
            // Disable link interactions
            cursor: "default"
        },
        "@media print": {
            colorAdjust: "exact"
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $ac65ba7da5d490c4$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, other = (0, $9X7IJ.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $acw62.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $11492dca620dcaa5$exports.findDOMNode(buttonRef.current);
    }
    var rippleRef = $acw62.useRef(null);
    var _React$useState = $acw62.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $7beb6b6538ff0014$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $acw62.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $acw62.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler("start", onMouseDown);
    var handleDragLeave = useRippleHandler("stop", onDragLeave);
    var handleMouseUp = useRippleHandler("stop", onMouseUp);
    var handleMouseLeave = useRippleHandler("stop", function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler("start", onTouchStart);
    var handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    var handleTouchMove = useRippleHandler("stop", onTouchMove);
    var handleBlur = useRippleHandler("stop", function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $acw62.useRef(false);
    var handleKeyDown = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === "button" && other.href) ComponentProp = "a";
    var buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== "a" || !other.href) buttonProps.role = "button";
        buttonProps["aria-disabled"] = disabled;
    }
    var handleUserRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(buttonRefProp, ref);
    var handleOwnRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(focusVisibleRef, buttonRef);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(handleUserRef, handleOwnRef);
    var _React$useState2 = $acw62.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $acw62.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $acw62.createElement(ComponentProp, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $acw62.createElement((0, $1aa6ee629397579b$export$2e2bcd8739ae039), (0, $8nd05.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $ac65ba7da5d490c4$export$2e2bcd8739ae039 = (0, $kQaj4.default)($ac65ba7da5d490c4$export$9dd6ff9ea0189349, {
    name: "MuiButtonBase"
})($ac65ba7da5d490c4$var$ButtonBase);


var $ec92ca55cb2fca7f$export$9dd6ff9ea0189349 = function styles(theme) {
    var backgroundColor = theme.palette.type === "light" ? theme.palette.grey[300] : theme.palette.grey[700];
    var deleteIconColor = (0, $9GbWv.alpha)(theme.palette.text.primary, 0.26);
    return {
        /* Styles applied to the root element. */ root: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(13),
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            height: 32,
            color: theme.palette.getContrastText(backgroundColor),
            backgroundColor: backgroundColor,
            borderRadius: 16,
            whiteSpace: "nowrap",
            transition: theme.transitions.create([
                "background-color",
                "box-shadow"
            ]),
            // label will inherit this from root, then `clickable` class overrides this for both
            cursor: "default",
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0,
            textDecoration: "none",
            border: "none",
            // Remove `button` border
            padding: 0,
            // Remove `button` padding
            verticalAlign: "middle",
            boxSizing: "border-box",
            "&$disabled": {
                opacity: 0.5,
                pointerEvents: "none"
            },
            "& $avatar": {
                marginLeft: 5,
                marginRight: -6,
                width: 24,
                height: 24,
                color: theme.palette.type === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
                fontSize: theme.typography.pxToRem(12)
            },
            "& $avatarColorPrimary": {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.dark
            },
            "& $avatarColorSecondary": {
                color: theme.palette.secondary.contrastText,
                backgroundColor: theme.palette.secondary.dark
            },
            "& $avatarSmall": {
                marginLeft: 4,
                marginRight: -4,
                width: 18,
                height: 18,
                fontSize: theme.typography.pxToRem(10)
            }
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            height: 24
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */ clickable: {
            userSelect: "none",
            WebkitTapHighlightColor: "transparent",
            cursor: "pointer",
            "&:hover, &:focus": {
                backgroundColor: (0, $9GbWv.emphasize)(backgroundColor, 0.08)
            },
            "&:active": {
                boxShadow: theme.shadows[1]
            }
        },
        /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */ clickableColorPrimary: {
            "&:hover, &:focus": {
                backgroundColor: (0, $9GbWv.emphasize)(theme.palette.primary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */ clickableColorSecondary: {
            "&:hover, &:focus": {
                backgroundColor: (0, $9GbWv.emphasize)(theme.palette.secondary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` is defined. */ deletable: {
            "&:focus": {
                backgroundColor: (0, $9GbWv.emphasize)(backgroundColor, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */ deletableColorPrimary: {
            "&:focus": {
                backgroundColor: (0, $9GbWv.emphasize)(theme.palette.primary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */ deletableColorSecondary: {
            "&:focus": {
                backgroundColor: (0, $9GbWv.emphasize)(theme.palette.secondary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            backgroundColor: "transparent",
            border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
            "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
            },
            "& $avatar": {
                marginLeft: 4
            },
            "& $avatarSmall": {
                marginLeft: 2
            },
            "& $icon": {
                marginLeft: 4
            },
            "& $iconSmall": {
                marginLeft: 2
            },
            "& $deleteIcon": {
                marginRight: 5
            },
            "& $deleteIconSmall": {
                marginRight: 3
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat(theme.palette.primary.main),
            "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat(theme.palette.secondary.main),
            "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
            }
        },
        // TODO v5: remove
        /* Styles applied to the `avatar` element. */ avatar: {},
        /* Styles applied to the `avatar` element if `size="small"`. */ avatarSmall: {},
        /* Styles applied to the `avatar` element if `color="primary"`. */ avatarColorPrimary: {},
        /* Styles applied to the `avatar` element if `color="secondary"`. */ avatarColorSecondary: {},
        /* Styles applied to the `icon` element. */ icon: {
            color: theme.palette.type === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
            marginLeft: 5,
            marginRight: -6
        },
        /* Styles applied to the `icon` element if `size="small"`. */ iconSmall: {
            width: 18,
            height: 18,
            marginLeft: 4,
            marginRight: -4
        },
        /* Styles applied to the `icon` element if `color="primary"`. */ iconColorPrimary: {
            color: "inherit"
        },
        /* Styles applied to the `icon` element if `color="secondary"`. */ iconColorSecondary: {
            color: "inherit"
        },
        /* Styles applied to the label `span` element. */ label: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            paddingLeft: 12,
            paddingRight: 12,
            whiteSpace: "nowrap"
        },
        /* Styles applied to the label `span` element if `size="small"`. */ labelSmall: {
            paddingLeft: 8,
            paddingRight: 8
        },
        /* Styles applied to the `deleteIcon` element. */ deleteIcon: {
            WebkitTapHighlightColor: "transparent",
            color: deleteIconColor,
            height: 22,
            width: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: (0, $9GbWv.alpha)(deleteIconColor, 0.4)
            }
        },
        /* Styles applied to the `deleteIcon` element if `size="small"`. */ deleteIconSmall: {
            height: 16,
            width: 16,
            marginRight: 4,
            marginLeft: -4
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */ deleteIconColorPrimary: {
            color: (0, $9GbWv.alpha)(theme.palette.primary.contrastText, 0.7),
            "&:hover, &:active": {
                color: theme.palette.primary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */ deleteIconColorSecondary: {
            color: (0, $9GbWv.alpha)(theme.palette.secondary.contrastText, 0.7),
            "&:hover, &:active": {
                color: theme.palette.secondary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */ deleteIconOutlinedColorPrimary: {
            color: (0, $9GbWv.alpha)(theme.palette.primary.main, 0.7),
            "&:hover, &:active": {
                color: theme.palette.primary.main
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */ deleteIconOutlinedColorSecondary: {
            color: (0, $9GbWv.alpha)(theme.palette.secondary.main, 0.7),
            "&:hover, &:active": {
                color: theme.palette.secondary.main
            }
        }
    };
};
function $ec92ca55cb2fca7f$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ var $ec92ca55cb2fca7f$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(props, ref) {
    var avatarProp = props.avatar, classes = props.classes, className = props.className, clickableProp = props.clickable, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, ComponentProp = props.component, deleteIconProp = props.deleteIcon, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, iconProp = props.icon, label = props.label, onClick = props.onClick, onDelete = props.onDelete, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? "default" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "avatar",
        "classes",
        "className",
        "clickable",
        "color",
        "component",
        "deleteIcon",
        "disabled",
        "icon",
        "label",
        "onClick",
        "onDelete",
        "onKeyDown",
        "onKeyUp",
        "size",
        "variant"
    ]);
    var chipRef = $acw62.useRef(null);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(chipRef, ref);
    var handleDeleteIconClick = function handleDeleteIconClick(event) {
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    var handleKeyDown = function handleKeyDown(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $ec92ca55cb2fca7f$var$isDeleteKeyboardEvent(event)) // will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    var handleKeyUp = function handleKeyUp(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $ec92ca55cb2fca7f$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    var clickable = clickableProp !== false && onClick ? true : clickableProp;
    var small = size === "small";
    var Component = ComponentProp || (clickable ? (0, $ac65ba7da5d490c4$export$2e2bcd8739ae039) : "div");
    var moreProps = Component === (0, $ac65ba7da5d490c4$export$2e2bcd8739ae039) ? {
        component: "div"
    } : {};
    var deleteIcon = null;
    if (onDelete) {
        var customClasses = (0, $1SA7b.default)(color !== "default" && (variant === "default" ? classes["deleteIconColor".concat((0, $f9tk6.default)(color))] : classes["deleteIconOutlinedColor".concat((0, $f9tk6.default)(color))]), small && classes.deleteIconSmall);
        deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
            className: (0, $1SA7b.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        }) : /*#__PURE__*/ $acw62.createElement((0, $a189f5f328f4f0c2$export$2e2bcd8739ae039), {
            className: (0, $1SA7b.default)(classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        });
    }
    var avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $1SA7b.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== "default" && classes["avatarColor".concat((0, $f9tk6.default)(color))])
    });
    var icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $1SA7b.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== "default" && classes["iconColor".concat((0, $f9tk6.default)(color))])
    });
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        role: clickable || onDelete ? "button" : undefined,
        className: (0, $1SA7b.default)(classes.root, className, color !== "default" && [
            classes["color".concat((0, $f9tk6.default)(color))],
            clickable && classes["clickableColor".concat((0, $f9tk6.default)(color))],
            onDelete && classes["deletableColor".concat((0, $f9tk6.default)(color))]
        ], variant !== "default" && [
            classes.outlined,
            {
                "primary": classes.outlinedPrimary,
                "secondary": classes.outlinedSecondary
            }[color]
        ], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
        "aria-disabled": disabled ? true : undefined,
        tabIndex: clickable || onDelete ? 0 : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef
    }, moreProps, other), avatar || icon, /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $1SA7b.default)(classes.label, small && classes.labelSmall)
    }, label), deleteIcon);
});
var $ec92ca55cb2fca7f$export$2e2bcd8739ae039 = (0, $kQaj4.default)($ec92ca55cb2fca7f$export$9dd6ff9ea0189349, {
    name: "MuiChip"
})($ec92ca55cb2fca7f$var$Chip);


function $3d0539293769f9ac$var$return_rank_class(level, legend) {
    if (legend > 0) return "legend" + legend;
    else return "rank" + level;
}
function $3d0539293769f9ac$export$2e2bcd8739ae039({ player_name: player_name , level: level , legend: legend , is_bot: is_bot  }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "player_component",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "rank_wrapper",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "rank_container",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: $3d0539293769f9ac$var$return_rank_class(level + 1, legend)
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "level_value",
                children: level + 1
            }),
            !is_bot ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                to: "/profile/" + player_name,
                style: {
                    color: "white",
                    textDecoration: "none"
                },
                activeStyle: {
                    textDecoration: "none"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "player_name",
                    children: player_name
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "player_name",
                        children: player_name
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec92ca55cb2fca7f$export$2e2bcd8739ae039), {
                        style: {
                            marginLeft: "0.2em"
                        },
                        color: "primary",
                        size: "small",
                        label: "Bot"
                    })
                ]
            })
        ]
    });
}


var $204cd6e9ed0955b7$exports = {};
"use strict";
var $0f49c8ba50dff6ee$exports = {};
function $0f49c8ba50dff6ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$0f49c8ba50dff6ee$exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, $0f49c8ba50dff6ee$exports.__esModule = true, $0f49c8ba50dff6ee$exports["default"] = $0f49c8ba50dff6ee$exports;


var $27c3440315f0d929$exports = {};

var $27c3440315f0d929$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $27c3440315f0d929$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($27c3440315f0d929$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $27c3440315f0d929$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $27c3440315f0d929$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $27c3440315f0d929$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
$27c3440315f0d929$exports = $27c3440315f0d929$var$_interopRequireWildcard, $27c3440315f0d929$exports.__esModule = true, $27c3440315f0d929$exports["default"] = $27c3440315f0d929$exports;


Object.defineProperty($204cd6e9ed0955b7$exports, "__esModule", {
    value: true
});
$204cd6e9ed0955b7$exports.default = void 0;

var $204cd6e9ed0955b7$var$React = $27c3440315f0d929$exports((parcelRequire("acw62")));

var $204cd6e9ed0955b7$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("iAQWD")));
var $204cd6e9ed0955b7$var$_default = (0, $204cd6e9ed0955b7$var$_createSvgIcon.default)(/*#__PURE__*/ $204cd6e9ed0955b7$var$React.createElement("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
}), "People");
$204cd6e9ed0955b7$exports.default = $204cd6e9ed0955b7$var$_default;



var $664ee3ebc2ea1d35$exports = {};
var $11a8e3762602c939$exports = {};

$11a8e3762602c939$exports = new URL((parcelRequire("27Lyk")).resolve("ivfkX"), import.meta.url).toString();


var $1965e0c377934b1a$exports = {};

$1965e0c377934b1a$exports = new URL((parcelRequire("27Lyk")).resolve("iwlaE"), import.meta.url).toString();


var $b5f351a6e2e58df8$exports = {};

$b5f351a6e2e58df8$exports = new URL((parcelRequire("27Lyk")).resolve("bz0xS"), import.meta.url).toString();


var $14805eb38e5ff71a$exports = {};

$14805eb38e5ff71a$exports = new URL((parcelRequire("27Lyk")).resolve("fRaji"), import.meta.url).toString();


var $65cdf2939bd17310$exports = {};

$65cdf2939bd17310$exports = new URL((parcelRequire("27Lyk")).resolve("bJrKA"), import.meta.url).toString();


var $6bf74da5b8b169bc$exports = {};

$6bf74da5b8b169bc$exports = new URL((parcelRequire("27Lyk")).resolve("c9hBj"), import.meta.url).toString();


var $66b67085be39ce94$exports = {};

$66b67085be39ce94$exports = new URL((parcelRequire("27Lyk")).resolve("jXoQO"), import.meta.url).toString();


var $39f0dfb60a24a9d2$exports = {};

$39f0dfb60a24a9d2$exports = new URL((parcelRequire("27Lyk")).resolve("6rBTD"), import.meta.url).toString();


var $1de8d875e601b982$exports = {};

$1de8d875e601b982$exports = new URL((parcelRequire("27Lyk")).resolve("fSouE"), import.meta.url).toString();


var $c080ca2e0df40a4e$exports = {};

$c080ca2e0df40a4e$exports = new URL((parcelRequire("27Lyk")).resolve("eJiw1"), import.meta.url).toString();


var $250e80ad2f40d63e$exports = {};

$250e80ad2f40d63e$exports = new URL((parcelRequire("27Lyk")).resolve("5TUYM"), import.meta.url).toString();


$664ee3ebc2ea1d35$exports = {
    "community_events_icon": $11a8e3762602c939$exports,
    "default_icon": $1965e0c377934b1a$exports,
    "driving_school": $b5f351a6e2e58df8$exports,
    "hardcore_racing_icon": $14805eb38e5ff71a$exports,
    "motor_mash_icon": $65cdf2939bd17310$exports,
    "one_on_one_icon": $6bf74da5b8b169bc$exports,
    "powered_up_icon": $66b67085be39ce94$exports,
    "skirmish_racing_icon": $39f0dfb60a24a9d2$exports,
    "team_motor_mash_icon": $1de8d875e601b982$exports,
    "team_racing_icon": $c080ca2e0df40a4e$exports,
    "world_tour_icon": $250e80ad2f40d63e$exports
};


var $884c408395c77142$exports = {};
var $535b66fb033fec97$exports = {};

$535b66fb033fec97$exports = new URL((parcelRequire("27Lyk")).resolve("eFuwI"), import.meta.url).toString();


var $15d6f2372943589e$exports = {};

$15d6f2372943589e$exports = new URL((parcelRequire("27Lyk")).resolve("kkxc6"), import.meta.url).toString();


var $f50567b59283beb8$exports = {};

$f50567b59283beb8$exports = new URL((parcelRequire("27Lyk")).resolve("jvZ2i"), import.meta.url).toString();


var $914a2125b690c9b6$exports = {};

$914a2125b690c9b6$exports = new URL((parcelRequire("27Lyk")).resolve("bIti5"), import.meta.url).toString();


var $3f4022fe3199eb8f$exports = {};

$3f4022fe3199eb8f$exports = new URL((parcelRequire("27Lyk")).resolve("2DO8Z"), import.meta.url).toString();


var $1cad37b956f4931b$exports = {};

$1cad37b956f4931b$exports = new URL((parcelRequire("27Lyk")).resolve("dlBU9"), import.meta.url).toString();


var $3750e825479644dd$exports = {};

$3750e825479644dd$exports = new URL((parcelRequire("27Lyk")).resolve("1A0Y5"), import.meta.url).toString();


var $78be2663451a7173$exports = {};

$78be2663451a7173$exports = new URL((parcelRequire("27Lyk")).resolve("4D01k"), import.meta.url).toString();


var $7951bbc7ed443352$exports = {};

$7951bbc7ed443352$exports = new URL((parcelRequire("27Lyk")).resolve("7DY1e"), import.meta.url).toString();


$884c408395c77142$exports = {
    "community_events_header": $535b66fb033fec97$exports,
    "driving_school_header": $15d6f2372943589e$exports,
    "hardcore_racing_header": $f50567b59283beb8$exports,
    "motor_mash_header": $914a2125b690c9b6$exports,
    "powered_up_racing_header": $3f4022fe3199eb8f$exports,
    "skirmish_racing_header": $1cad37b956f4931b$exports,
    "team_motor_mash_header": $3750e825479644dd$exports,
    "team_racing_header": $78be2663451a7173$exports,
    "world_tour_header": $7951bbc7ed443352$exports
};



function $e01dc1b8dd3a027a$var$GetGametypeData(game_mode_id) {
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    switch(game_mode_id){
        case "community_event":
            return {
                name: t("sessions_widget.gamemode.communityevent"),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($664ee3ebc2ea1d35$exports))).community_events_icon,
                header_image: (0, (/*@__PURE__*/$parcel$interopDefault($884c408395c77142$exports))).community_events_header
            };
        case "team_racing":
            return {
                name: t("sessions_widget.gamemode.teamracing"),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($664ee3ebc2ea1d35$exports))).team_racing_icon,
                header_image: (0, (/*@__PURE__*/$parcel$interopDefault($884c408395c77142$exports))).team_racing_header
            };
        case "powered_up_racing":
            return {
                name: t("sessions_widget.gamemode.powered_up_racing"),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($664ee3ebc2ea1d35$exports))).powered_up_icon,
                header_image: (0, (/*@__PURE__*/$parcel$interopDefault($884c408395c77142$exports))).powered_up_racing_header
            };
        case "skirmish_racing":
            return {
                name: t("sessions_widget.gamemode.skirmish"),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($664ee3ebc2ea1d35$exports))).skirmish_racing_icon,
                header_image: (0, (/*@__PURE__*/$parcel$interopDefault($884c408395c77142$exports))).skirmish_racing_header
            };
        case "motor_mash":
            return {
                name: t("sessions_widget.gamemode.motormash"),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($664ee3ebc2ea1d35$exports))).motor_mash_icon,
                header_image: (0, (/*@__PURE__*/$parcel$interopDefault($884c408395c77142$exports))).motor_mash_header
            };
        case "team_motor_mash":
            return {
                name: t("sessions_widget.gamemode.team_motor_mash"),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($664ee3ebc2ea1d35$exports))).team_motor_mash_icon,
                header_image: (0, (/*@__PURE__*/$parcel$interopDefault($884c408395c77142$exports))).team_motor_mash_header
            };
        case "world_tour":
            return {
                name: t("sessions_widget.gamemode.worldtour"),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($664ee3ebc2ea1d35$exports))).world_tour_icon,
                header_image: (0, (/*@__PURE__*/$parcel$interopDefault($884c408395c77142$exports))).world_tour_header
            };
        case "driving_school":
            return {
                name: t("sessions_widget.gamemode.drivingschool"),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($664ee3ebc2ea1d35$exports))).driving_school,
                header_image: (0, (/*@__PURE__*/$parcel$interopDefault($884c408395c77142$exports))).driving_school_header
            };
        case "hardcore_racing":
            return {
                name: t("sessions_widget.gamemode.hardcore_racing"),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($664ee3ebc2ea1d35$exports))).hardcore_racing_icon,
                header_image: (0, (/*@__PURE__*/$parcel$interopDefault($884c408395c77142$exports))).hardcore_racing_header
            };
        case "custom_game":
            return {
                name: "Custom game",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($664ee3ebc2ea1d35$exports))).default_icon,
                header_image: (0, (/*@__PURE__*/$parcel$interopDefault($884c408395c77142$exports))).driving_school_header
            };
        case "unknown":
            return {
                name: "Session",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($664ee3ebc2ea1d35$exports))).default_icon,
                header_image: (0, (/*@__PURE__*/$parcel$interopDefault($884c408395c77142$exports))).driving_school_header
            };
    }
}
function $e01dc1b8dd3a027a$export$2e2bcd8739ae039({ data: data  }) {
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const mediadata = $e01dc1b8dd3a027a$var$GetGametypeData(data.gameType);
    const GameStatus = ()=>{
        if (data.isInProgress === 1) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: "game_in_progress",
                        children: t("sessions_widget.status.inprogress")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "led_in_progress"
                    })
                ]
            })
        });
        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                className: "game_in_progress",
                children: t("sessions_widget.status.inlobby")
            })
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "session_item_container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "session_info",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "session_info_text",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "gamemode_info",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "icon_container",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            className: "icon",
                                            src: mediadata.icon
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            marginLeft: "0.5rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontWeight: "bold",
                                                    fontSize: "1.4rem"
                                                },
                                                children: mediadata.name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "playersCounter",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($204cd6e9ed0955b7$exports))), {
                                                        style: {
                                                            fontSize: "1.2rem",
                                                            display: "inline-block"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        style: {
                                                            fontSize: "1.2rem",
                                                            display: "inline-block",
                                                            marginLeft: "0.3rem"
                                                        },
                                                        children: data.players_list.length + "/" + data.totalSlots
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "lobby_status_container",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(GameStatus, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: mediadata.header_image,
                        className: "session_header_img"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "players",
                children: data.players_list.map((player)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "player_card",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d0539293769f9ac$export$2e2bcd8739ae039), {
                            player_name: player.bdPlayerName,
                            place: 0,
                            level: player.statLevel,
                            legend: player.statLegend
                        })
                    });
                })
            })
        ]
    });
}





var $8DzwJ = parcelRequire("8DzwJ");
parcelRequire("acw62");

const $fdd862b2a5201b09$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>({
        CustomIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24"
        },
        BigIcon: {
            width: "2em",
            height: "2em",
            viewBox: "0 0 2em 2em"
        }
    }));
function $fdd862b2a5201b09$export$7051e699fb15be2d() {
    const classes = $fdd862b2a5201b09$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8DzwJ.default), {
        className: classes.CustomIcon,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M23.1022 15.2708L23.2825 15.2891L23.4508 15.3416L23.6032 15.4246L23.7363 15.5345L23.8461 15.6675L23.9292 15.82L23.9817 15.9882L24 16.1686V18.1523L23.9817 18.3326L23.9292 18.5009L23.8461 18.6533L23.7363 18.7864L23.6033 18.8962L23.4508 18.9793L23.2825 19.0318L23.1022 19.0501H16.6377L16.5035 19.04L16.3755 19.0107L16.2551 18.9636L16.1438 18.9003L16.043 18.8223L15.9542 18.7311L15.8788 18.6281L15.8183 18.5149L5.35827 17.2895L5.26779 17.9552L5.21104 18.1875L5.11374 18.3974L4.98068 18.5813L4.81672 18.7353L4.62672 18.8556L4.4155 18.9386L4.18788 18.9805L3.94874 18.9775L1.03111 18.6359L0.798914 18.5846L0.588242 18.4911L0.403173 18.3605L0.247739 18.1982L0.126039 18.0094L0.0421081 17.7993L0 17.5733L0.0038579 17.3365L0.00523885 17.3354L0.00556765 17.3334L0.00587453 17.3302L0.00626909 17.3255L0.00692669 17.3191L0.007935 17.3109L0.00946939 17.3007L0.843127 11.1691L0.857462 11.0894L0.876905 11.0123L0.901171 10.9376L0.930017 10.8656L0.96316 10.7962L1.00036 10.7295L1.04135 10.6656L1.08582 10.6045L1.19911 9.38641L2.23092 8.84104L2.28037 8.77125L2.25933 8.76844L2.01466 8.71447L1.7923 8.61574L1.59669 8.47779L1.43216 8.30619L1.30314 8.10652L1.21406 7.88434L1.16925 7.6452L1.17315 7.39468L1.17666 7.36382L1.23074 7.11926L1.32957 6.897L1.4676 6.70141L1.63926 6.53691L1.83899 6.40788L2.06126 6.31873L2.30047 6.27385L2.55112 6.27764L3.30727 6.36637L3.38049 6.37742L3.45199 6.39282L3.52169 6.41238L3.5896 6.4359L3.65558 6.46321L3.71959 6.49411L3.78155 6.52841L3.84142 6.56593L4.48545 5.65966L4.68818 5.37564L4.87242 5.11839L5.03066 4.89858L5.15538 4.72684L5.23903 4.61383L5.42042 4.40932L5.6392 4.24807L5.92541 4.12829L6.30903 4.04821L6.82007 4.00604L7.48856 4L8.34446 4.0283L9.41784 4.08916L9.96193 4.12633L10.4855 4.16523L10.9734 4.20389L11.4104 4.24032L11.7816 4.27254L12.0718 4.29857L12.2659 4.31643L12.3488 4.32414L12.3747 4.32624L12.4003 4.32975L12.676 4.36898L12.9644 4.41075L13.3331 4.46522L13.7669 4.53083L14.2505 4.60604L14.7688 4.68929L15.3067 4.77902L16.3649 4.9675L17.204 5.13755L17.8529 5.29783L18.3403 5.45696L18.6951 5.62359L18.9459 5.80635L19.1216 6.01389L19.2509 6.25484L19.3066 6.3839L19.3884 6.57966L19.4916 6.83001L19.6115 7.12283L19.7431 7.44601L20.1603 8.47664L21.2013 11.0625L22.0795 11.8306L21.9087 13.0409L21.9379 13.1107L21.9631 13.1824L21.984 13.2559L22.0003 13.3311L22.0118 13.4078L22.0183 13.486L22.0194 13.5655L22.0149 13.6462L21.8678 15.2708H23.1022ZM3.75654 12.8859L4.0774 12.891L4.38354 12.8339L4.66782 12.7201L4.92321 12.5551L5.14262 12.3447L5.31901 12.0944L5.44525 11.8097L5.51434 11.4963L5.51951 11.1754L5.46246 10.8693L5.34871 10.585L5.18392 10.3296L4.97358 10.1102L4.72332 9.93373L4.43864 9.80738L4.12515 9.73818L3.80415 9.73304L3.49795 9.79018L3.21359 9.90403L2.95818 10.069L2.73874 10.2795L2.56235 10.53L2.43609 10.8148L2.367 11.1284L2.36184 11.4492L2.41899 11.7553L2.53282 12.0395L2.69772 12.2949L2.90815 12.5143L3.15848 12.6907L3.44313 12.8169L3.75654 12.8859ZM15.9225 14.9528L15.8009 14.9302L6.77552 12.3016L6.66057 12.2554L6.56783 12.1919L6.49828 12.1139L6.4529 12.0243L6.43265 11.9259L6.43852 11.8216L6.47145 11.7143L6.53247 11.6068L6.92773 11.0453L7.01337 10.9449L7.11732 10.8582L7.23549 10.7866L7.36389 10.7315L7.49857 10.6942L7.63552 10.6763L7.77075 10.6791L7.90027 10.7041L15.709 12.9785L15.8319 13.027L15.9477 13.0972L16.0538 13.1858L16.1475 13.2895L16.2263 13.4049L16.2876 13.5288L16.3287 13.6578L16.347 13.7886L16.3796 14.4746L16.3732 14.5982L16.3432 14.7064L16.292 14.7974L16.2219 14.8694L16.1354 14.9206L16.0348 14.949L15.9225 14.9528ZM15.3814 9.03358L15.9389 9.14418L16.4732 9.26347L16.9795 9.38794L17.453 9.51407L17.8888 9.63836L18.2819 9.7573L18.6276 9.86738L18.9209 9.96509L18.9768 9.98467L19.0545 10.0123L19.474 10.1629L18.5754 7.94633L18.3523 7.39857L18.1816 6.98226L18.0921 6.76865L17.7896 6.60381L17.1016 6.41626L16.1593 6.21977L15.0939 6.0281L14.0369 5.85505L13.1193 5.71439L12.4726 5.61988L12.2278 5.58532L11.9816 5.56241L11.3304 5.50496L10.405 5.42987L9.33642 5.35407L8.25551 5.29446L7.29321 5.26795L6.58039 5.29146L6.24804 5.38191L6.11159 5.56911L5.84939 5.93479L5.50579 6.41624L4.11988 8.36547L4.4669 8.32644L4.56245 8.3159L4.64449 8.30703L4.70348 8.30093L5.01156 8.27362L5.37342 8.24633L5.78347 8.22138L6.23621 8.20107L6.72607 8.18769L7.2475 8.18355L7.79495 8.19096L8.36287 8.2122L9.17334 8.25615L9.88219 8.30088L10.4874 8.34434L10.9869 8.38449L11.3789 8.41928L11.6614 8.44667L11.8323 8.4646L11.8897 8.47103L11.947 8.47804L12.1174 8.50009L12.3985 8.5387L12.7879 8.59541L13.2833 8.67172L13.8823 8.76917L14.5824 8.88928L15.3814 9.03358ZM19.1047 14.65L18.7841 14.6447L18.4704 14.5755L18.1855 14.4492L17.935 14.2728L17.7246 14.0534L17.5596 13.798L17.4458 13.5139L17.3887 13.2079L17.3939 12.8873L17.4629 12.5738L17.5892 12.2891L17.7655 12.0387L17.9849 11.8283L18.2403 11.6634L18.5247 11.5497L18.8309 11.4926L19.152 11.4977L19.4654 11.5667L19.7501 11.6929L20.0004 11.8692L20.2108 12.0886L20.3757 12.344L20.4894 12.6283L20.5465 12.9345L20.5412 13.2555L20.4721 13.5688L20.3458 13.8534L20.1695 14.1038L19.95 14.3142L19.6947 14.4791L19.4106 14.5929L19.1047 14.65Z",
            fill: "white"
        })
    });
}
function $fdd862b2a5201b09$export$7a09e274d1b493bd() {
    const classes = $fdd862b2a5201b09$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8DzwJ.default), {
        className: classes.CustomIcon,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.6236 9.84062L12.5986 10.0662L12.6103 10.2707L12.6475 10.4508L12.6984 10.6031L12.752 10.7243L12.7966 10.8112L12.7969 10.8115L12.797 10.8117L12.797 10.812L12.831 10.8964L12.8642 10.9811L12.8967 11.066L12.9284 11.151L12.9597 11.2361L12.9905 11.3213L13.051 11.49L13.2036 11.9174L13.1144 11.9678L13.0289 12.0165L12.9473 12.0633L12.8696 12.108L12.7965 12.1505L12.728 12.1906L12.6668 12.0006L12.5844 11.8066L12.4786 11.609L12.3468 11.4082L12.187 11.2049L11.9967 10.9995L7.30706 6.3094L7.25038 6.25293L7.00577 6.0079L9.58521 6.74491L9.5345 5.50868L9.54979 5.30128L9.61014 5.15018L9.70954 5.05872L9.84143 5.02996L9.99974 5.06717L10.178 5.17352L11.1641 5.92566L12.1834 4.28437L12.3155 4.12025L12.4592 4.02562L12.607 4L12.7507 4.04291L12.8826 4.15384L12.9948 4.33231L13.813 6.08184L14.8809 5.45115L15.0707 5.3664L15.2323 5.34802L15.3599 5.3921L15.4476 5.49467L15.4896 5.65181L15.48 5.8596L15.2849 7.08242L18.5977 6.54527L18.8004 6.53248L18.944 6.56466L19.0258 6.63705L19.043 6.74481L18.9928 6.88325L18.8726 7.04748L17.8238 8.2264L17.7817 8.21478L17.6553 8.17939L17.6132 8.16775L17.5711 8.1563L17.2762 8.07554L17.2307 8.05543L17.1743 8.01972L17.1101 7.97212L17.0407 7.91619L16.9689 7.85565L16.8974 7.79408L16.8354 7.74057L16.8043 7.71388L16.7729 7.68727L16.7415 7.6608L16.7099 7.63449L16.703 7.62839L16.6961 7.62229L16.6892 7.61621L16.6822 7.61014L16.6751 7.60418L16.6681 7.59826L16.5345 7.50209L16.3958 7.4236L16.2523 7.36277L16.1043 7.31941L15.9522 7.29347L15.7962 7.28484L15.5047 7.31459L15.24 7.39334L15.0037 7.50536L14.7976 7.63475L14.6234 7.76574L14.4829 7.8825L14.4368 7.92128L14.4157 7.93902L14.3951 7.95673L14.3749 7.97444L14.3549 7.99213L14.3353 8.00986L14.3158 8.0276L14.1824 8.05115L14.0343 8.09182L13.8766 8.15478L13.714 8.24509L13.5517 8.36798L13.3945 8.52853L13.3212 8.61355L13.1961 8.76043L13.0611 8.93036L12.9264 9.12337L12.8018 9.33937L12.6975 9.57849L12.6236 9.84062Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.25476 19.1691L4.97398 19.1313L4.71542 19.024L4.49207 18.8565L4.31655 18.6381L4.20192 18.378L4.16085 18.0856V15.591H0V9.85767H4.16085V7.35558L4.20394 7.05238L4.32326 6.79056L4.50416 6.57629L4.73177 6.41561L4.99145 6.31475L5.26839 6.27978L5.40071 6.2879L5.53196 6.31265L5.66066 6.35473L5.78514 6.41471L5.90409 6.49328L6.01585 6.59108L11.2105 11.7862L11.3766 11.9676L11.517 12.1614L11.6226 12.3685L11.6836 12.5899L11.6908 12.8263L11.6345 13.0789L11.5708 13.2213L11.4875 13.3514L11.3899 13.4721L11.2827 13.586L11.1713 13.696L11.0605 13.8048L6.1586 18.7067L6.07551 18.7889L5.99134 18.8677L5.90393 18.9412L5.81109 19.0074L5.71052 19.0646L5.60036 19.1107L5.54283 19.1288L5.48509 19.1434L5.4274 19.1548L5.36966 19.1627L5.31213 19.1675L5.25476 19.1691Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.3745 11.282L16.5907 11.5178L16.7363 11.7945L16.8094 12.0959L16.8079 12.4059L16.73 12.7086L16.5735 12.9877L16.4409 13.1375L16.2892 13.2608L16.1223 13.3572L15.9438 13.4265L15.7578 13.4684L15.5678 13.4824L15.416 13.4734L15.2658 13.4462L15.1193 13.4007L14.9783 13.3367L14.8448 13.2542L14.7206 13.1528L14.5205 12.9094L14.3915 12.63L14.3342 12.3301L14.3492 12.0252L14.4369 11.7312L14.5979 11.4634L14.6081 11.4506L14.6184 11.4379L14.6287 11.4253L14.639 11.4128L14.6499 11.4003L14.661 11.3879L14.6666 11.3822L14.6723 11.3765L14.678 11.371L14.6837 11.3655L14.6951 11.3547L14.8213 11.246L14.9589 11.1566L15.1056 11.0868L15.2591 11.0368L15.4174 11.0066L15.578 10.9965L15.7196 11.0044L15.8596 11.0279L15.9967 11.0674L16.1292 11.1228L16.2557 11.1943L16.3745 11.282Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M23.673 17.9118L23.6139 17.9603L23.5547 18.0088L23.4954 18.0574L23.3172 18.2032L23.32 18.2307L23.3481 18.2827L23.3899 18.3478L23.4332 18.4148L23.4666 18.4726L23.4779 18.5096L23.4553 18.5543L23.4068 18.6052L23.3437 18.6575L23.277 18.7068L23.2177 18.7484L23.177 18.7779L23.0758 18.8595L22.9697 18.943L22.8586 19.0221L22.7419 19.09L22.6195 19.1403L22.4909 19.1663L22.4809 19.1672L22.471 19.1679L22.4612 19.1684L22.4514 19.1688L22.4418 19.169L22.4321 19.1691L22.2981 19.1548L22.1742 19.1157L22.0584 19.0575L21.9481 18.9856L21.8414 18.9058L21.7358 18.8235L22.2222 18.4485L22.5442 17.9557L22.6968 17.3942L22.6743 16.8127L22.4716 16.2601L22.0831 15.7853L21.9031 15.6477L21.7123 15.5363L21.5132 15.4507L21.3078 15.3902L21.0985 15.3544L20.8874 15.3425L20.5204 15.378L20.1674 15.4826L19.8401 15.6533L19.5508 15.887L19.3114 16.1809L19.1342 16.5319L18.7031 16.0682L18.2655 15.6129L17.8198 15.1669L17.3643 14.7306L16.8978 14.3048L16.4184 13.89L16.8787 13.5534L17.2024 13.108L17.3819 12.5935L17.4096 12.0494L17.2777 11.5153L16.9788 11.0308L16.7845 10.837L16.5688 10.6788L16.3363 10.5561L16.0909 10.4686L15.8372 10.4163L15.5793 10.3989L15.4788 10.4015L15.3785 10.4093L15.2788 10.4224L15.1798 10.4407L15.0819 10.4642L14.9853 10.4928L14.8238 10.5538L14.6681 10.6299L14.5194 10.7211L14.3787 10.8274L14.2474 10.9486L14.1266 11.0847L14.1221 11.0903L14.1173 11.0956L14.1128 11.1008L14.1081 11.106L14.1035 11.1114L14.0989 11.1169L14.0886 11.0882L14.0782 11.0593L14.068 11.0305L14.0576 11.0015L14.0367 10.9437L14.0017 10.8474L13.9665 10.7511L13.9307 10.655L13.8941 10.5592L13.8567 10.4637L13.8181 10.3686L13.7952 10.3204L13.7688 10.2705L13.7431 10.2194L13.7224 10.1673L13.7111 10.1145L13.7133 10.0614L13.7604 9.91213L13.8351 9.76687L13.9291 9.62667L14.0339 9.49254L14.1415 9.36558L14.2434 9.24679L14.3239 9.17504L14.4059 9.13943L14.4897 9.12646L14.5756 9.12249L14.6637 9.11408L14.7543 9.08763L14.7553 9.0872L14.7563 9.08667L14.7572 9.08608L14.7581 9.08544L14.759 9.08481L14.7599 9.08422L14.8292 9.04584L14.8961 8.99814L14.9607 8.94445L15.0233 8.88793L15.0842 8.83194L15.1434 8.77974L15.2273 8.70903L15.328 8.62628L15.4401 8.54259L15.5588 8.46903L15.6792 8.41675L15.7962 8.39685L15.8245 8.39821L15.8521 8.40245L15.879 8.40977L15.9051 8.42026L15.9305 8.43419L15.9548 8.45161L15.9596 8.45569L15.9644 8.45987L15.9692 8.46413L15.9789 8.47271L15.9837 8.47697L16.1398 8.60912L16.2938 8.74141L16.4502 8.86766L16.6133 8.98147L16.7875 9.07658L16.9771 9.14665L17.1028 9.18143L17.2291 9.21592L17.3558 9.25036L17.4825 9.28504L17.6094 9.3203L17.736 9.35631L17.8521 9.39056L17.9676 9.42604L18.0825 9.46309L18.1965 9.50187L18.3095 9.54275L18.4213 9.586L18.6868 9.70151L18.9462 9.83029L19.1996 9.97107L19.4468 10.1224L19.6878 10.2831L19.9226 10.4517L20.1471 10.622L20.3726 10.8015L20.5936 10.9907L20.8046 11.1902L21.0001 11.4006L21.1746 11.6225L21.2941 11.8081L21.3977 12.0036L21.4877 12.2068L21.5657 12.4152L21.6338 12.6268L21.694 12.839L21.7477 13.0533L21.7955 13.2692L21.8375 13.4863L21.8742 13.7045L21.906 13.9233L21.9331 14.1425L21.943 14.2423L21.9517 14.324L21.9647 14.3942L21.9873 14.4596L22.0252 14.5272L22.0835 14.6036L22.435 15.0223L22.7824 15.454L23.1148 15.9003L23.4216 16.3629L23.692 16.8433L23.9151 17.3433L23.9346 17.3925L23.9618 17.4668L23.987 17.551L24 17.6299L23.9912 17.6884L23.9505 17.7113L23.9469 17.7111L23.9434 17.7109L23.9398 17.7105L23.9359 17.7098L23.9318 17.709L23.9274 17.7081L23.9268 17.7079L23.9262 17.7077L23.9257 17.7077L23.9251 17.7076L23.9244 17.7077L23.9236 17.7076L23.8905 17.7208L23.8444 17.7544L23.7926 17.7994L23.742 17.8466L23.6998 17.8871L23.673 17.9118ZM18.9735 10.2768L18.9702 10.2329L18.9414 10.1909L18.8964 10.152L18.8443 10.1177L18.7945 10.0893L18.7562 10.0682L18.6664 10.0164L18.5638 9.96085L18.4514 9.90521L18.3321 9.85309L18.2089 9.80826L18.0846 9.77436L18.0527 9.76767L18.0207 9.76208L17.9891 9.7576L17.9575 9.75427L17.9263 9.75228L17.8954 9.75156L17.8576 9.75265L17.8207 9.75603L17.7847 9.76197L17.7497 9.77047L17.7158 9.78173L17.6832 9.79588L17.6348 9.8309L17.609 9.87543L17.6031 9.92782L17.614 9.98623L17.6392 10.049L17.6755 10.1144L17.7371 10.2032L17.8073 10.2897L17.8799 10.3701L17.948 10.4402L18.0053 10.496L18.045 10.5335L18.1973 10.6838L18.283 10.7609L18.3721 10.8271L18.4628 10.8736L18.5529 10.8911L18.5875 10.8881L18.6214 10.8789L18.6548 10.8629L18.6874 10.8396L18.7194 10.8085L18.7502 10.769L18.7982 10.6938L18.8422 10.6146L18.8819 10.5323L18.9171 10.4479L18.9477 10.3624L18.9735 10.2768ZM20.8896 11.8937L20.9794 12.0591L21.0537 12.2172L21.124 12.3818L21.1838 12.5514L21.2265 12.7244L21.2456 12.8994L21.2342 13.0748L21.2287 13.1003L21.221 13.1227L21.2112 13.1414L21.1989 13.1557L21.1844 13.1647L21.1673 13.1679L21.1563 13.1669L21.1444 13.1635L21.1317 13.1577L21.118 13.1494L21.1036 13.1386L21.0881 13.1251L21.0832 13.1211L21.0778 13.1178L21.0722 13.1153L21.0661 13.1135L21.0598 13.1124L21.0531 13.1121L21.0056 13.1243L20.9522 13.1554L20.8981 13.1974L20.8479 13.2424L20.8068 13.2823L20.7795 13.3092L20.719 13.3706L20.6625 13.3168L20.606 13.2629L20.5496 13.209L20.4934 13.1549L20.4374 13.1006L20.3815 13.0461L20.2844 12.9516L20.1876 12.8568L20.0912 12.7618L19.995 12.6666L19.8992 12.5712L19.8037 12.4757L19.6867 12.3573L19.5702 12.2386L19.4542 12.1192L19.3386 11.9993L19.2237 11.8786L19.1095 11.7572L19.0775 11.7264L19.0454 11.6973L19.0171 11.6681L18.9967 11.6368L18.9885 11.6016L18.9966 11.5605L19.0465 11.4331L19.1067 11.2903L19.1786 11.1449L19.2633 11.0092L19.3621 10.8959L19.4764 10.8176L19.4966 10.8092L19.517 10.8025L19.5376 10.7974L19.5583 10.7937L19.5793 10.7916L19.6004 10.7909L19.7249 10.8119L19.8499 10.8671L19.9711 10.945L20.0846 11.034L20.1861 11.1225L20.2716 11.199L20.411 11.3246L20.5446 11.4556L20.6702 11.5932L20.7859 11.7388L20.8896 11.8937Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21.6693 16.2276L21.8786 16.4542L22.0229 16.7192L22.1002 17.0086L22.108 17.3078L22.0444 17.6027L21.9071 17.8787L21.7744 18.044L21.6191 18.1807L21.4457 18.2881L21.2584 18.3656L21.0619 18.4126L20.8605 18.4284L20.7209 18.4208L20.5826 18.3977L20.447 18.3589L20.3156 18.3043L20.1899 18.2335L20.0713 18.1466L19.8404 17.8912L19.6924 17.5904L19.6286 17.2644L19.6504 16.9329L19.7592 16.616L19.9562 16.3337L20.0847 16.2147L20.2263 16.1168L20.3785 16.0404L20.5385 15.9855L20.7039 15.9525L20.872 15.9415L21.0136 15.9494L21.1537 15.973L21.291 16.0126L21.4236 16.0681L21.5503 16.1398L21.6693 16.2276Z",
                fill: "white"
            })
        ]
    });
}
function $fdd862b2a5201b09$export$5e7ca23b710499b9() {
    const classes = $fdd862b2a5201b09$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8DzwJ.default), {
        className: classes.CustomIcon,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M22.1747 7.64314L22.2782 13.2458L22.2728 13.4967L22.24 13.7377L22.1686 13.9645L22.0468 14.1727L21.8635 14.358L21.6247 14.4973L21.3656 14.5707L21.0936 14.5982L20.8166 14.5997L20.5421 14.5952L20.4592 14.386L20.3585 14.1828L20.2399 13.9872L20.1032 13.8005L19.948 13.6244L19.4999 13.1591H19.4954L14.0528 7.56125L13.7335 7.27974L13.3743 7.05354L12.9834 6.88684L12.5688 6.78383L12.1388 6.74869L11.7088 6.78367L11.2937 6.88675L10.9015 7.05451L10.5405 7.28348L10.2189 7.57018L4.33848 13.6177L4.1781 13.7982L4.03714 13.9899L3.91544 14.1912L3.8127 14.4003L3.72878 14.6156L3.58196 14.6166L3.43562 14.6151L3.29002 14.6104L3.14546 14.6014L3.0022 14.5873L2.38475 14.2958L2.08476 13.7038L2 12.9509L2.02821 12.1766L2.06717 11.5206L2.13715 7.73843L2.15662 7.59656L2.19902 7.45544L2.24827 7.31695L2.28833 7.18298L2.30316 7.0554L2.28158 6.13824L2.35425 5.89704L2.54519 5.72693L2.79357 5.5885L3.03863 5.44232L3.21958 5.249L2.79259 5.17365L2.43855 4.95693L2.18232 4.63375L2.04875 4.2388L2.06271 3.80701L2.21753 3.42299L2.46899 3.15998L2.7925 2.99749L3.16331 2.91502L3.55681 2.89208L3.73793 2.89164L3.91662 2.89588L4.0926 2.91316L4.26558 2.95179L4.43526 3.02013L5.09558 1.81598L5.21274 1.59153L5.3326 1.3561L5.46291 1.12336L5.61137 0.906933L5.78568 0.720531L6.0581 0.537897L6.37021 0.414447L6.70403 0.335001L7.0415 0.284274L7.36466 0.247063L8.13832 0.170781L8.91474 0.115622L9.69259 0.0760382L10.4704 0.0465046L11.2469 0.0214959L12.4074 0L13.5729 0.0107247L14.7389 0.0559963L15.9007 0.138106L17.0536 0.259347L17.3648 0.298814L17.6883 0.352844L18.0066 0.436106L18.3024 0.563209L18.5582 0.74882L18.6479 0.845342L18.7265 0.950449L18.797 1.06146L18.8626 1.17566L19.089 1.58169L19.2503 1.87347L19.4109 2.16559L19.7314 2.75026L19.8038 2.88296L19.8547 2.95386L19.909 2.97601L19.9918 2.96248L20.1282 2.92633L20.1848 2.91334L20.2413 2.90367L20.2981 2.89707L20.3553 2.89329L20.4133 2.89208H20.8458L21.0735 2.89692L21.2938 2.9186L21.505 2.96791L21.7056 3.05559L21.894 3.19247L22.214 3.67973L22.2576 4.22682L22.0613 4.73591L21.6614 5.10923L21.0945 5.249L21.2444 5.39412L21.4853 5.5403L21.7454 5.68673L21.9528 5.83248L22.0355 5.97669L22.0317 6.14509L22.0154 6.81866L22.0286 6.99241L22.0664 7.15315L22.1135 7.30946L22.1546 7.46991L22.1747 7.64314ZM5.73953 8.09316V5.89928H3.48907V8.09316H5.73953ZM7.20236 5.8989V8.09316H6.41399V5.8989H7.20236ZM12.1388 5.81255L12.4629 5.70725L12.6249 5.45618L12.625 5.15649L12.4629 4.9054L12.1388 4.8001L11.8147 4.90539L11.6526 5.15648V5.45618L11.8147 5.70726L12.1388 5.81255ZM14.581 3.63438L12.1388 3.59261L9.69691 3.63438L7.77939 3.73399L6.39671 3.85286L5.55941 3.95248L5.27797 3.99424L5.37175 3.34642L5.61865 2.71272L5.967 2.11951L6.36521 1.5932L6.76165 1.16013L7.18889 0.996049L8.04456 0.865887L9.22431 0.776135L10.6238 0.733341L12.1388 0.743984L13.6543 0.733341L15.0538 0.776146L16.2335 0.865864L17.0893 0.996037L17.5174 1.16013L17.9129 1.59321L18.3109 2.11953L18.6593 2.7127L18.9064 3.34641L19.0004 3.99424L18.7189 3.95249L17.8816 3.85289L16.4988 3.73398L14.581 3.63438ZM17.8636 8.09316V5.8989H17.076V8.09316H17.8636ZM20.7893 5.89928V8.09316H18.538V5.89928H20.7893Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.36209 17.4695L5.14157 17.1735L5.02873 16.8361L5.02382 16.4838L5.12715 16.143L5.33901 15.8402L11.2276 9.78305L11.3663 9.65982L11.5213 9.56167L11.6892 9.4899L11.8668 9.4459L12.0509 9.43093L12.2353 9.4459L12.4129 9.48993L12.5808 9.56165L12.7361 9.65982L12.8758 9.78305L18.7651 15.8406L18.9757 16.1436L19.0781 16.4844L19.0727 16.8365L18.9598 17.1736L18.7398 17.4695L18.4392 17.6786L18.0997 17.7806L17.7481 17.7751L17.4118 17.6621L17.1176 17.4412L12.3554 12.5401L12.3033 12.4952L12.2459 12.4597L12.1841 12.4341L12.1188 12.4185L12.0509 12.4132L11.9828 12.4185L11.9174 12.4341L11.8559 12.4597L11.7994 12.4952L11.7487 12.5401L6.9835 17.4486L6.84035 17.5708L6.68305 17.6671L6.51515 17.7367L6.34016 17.779L6.16163 17.7933L5.98951 17.7803L5.82017 17.7414L5.65692 17.6765L5.50313 17.5859L5.36209 17.4695Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.7695 20.9538L13.1676 23.5613L12.7582 23.8537L12.2929 24L11.809 24L11.3436 23.8538L10.9343 23.5613L8.33243 20.9538L8.03763 20.5464L7.89022 20.0816L7.89023 19.5976L8.03764 19.1328L8.33243 18.7253L10.9343 16.1187L11.3436 15.8235L11.809 15.6759L12.2929 15.6759L12.7582 15.8235L13.1676 16.1187L15.7695 18.7253L16.0646 19.1329L16.2122 19.5978V20.0819L16.0646 20.5467L15.7695 20.9538Z",
                fill: "white"
            })
        ]
    });
}
function $fdd862b2a5201b09$export$7f5f9f33dccbc355() {
    const classes = $fdd862b2a5201b09$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8DzwJ.default), {
        className: classes.CustomIcon,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.32479 6.69579L4.3143 6.79424L4.30376 6.89688L4.29369 7.00346L4.2844 7.11361L4.27639 7.22709L4.27004 7.34359L4.12674 7.38755L3.97603 7.42301L3.81765 7.44945L3.65117 7.46629L3.47628 7.47305L3.2926 7.46916L3.33351 6.9448L3.45574 6.50178L3.64928 6.13011L3.9041 5.81966L4.21021 5.56042L4.55757 5.34237L4.50086 5.54801L4.45454 5.7517L4.41706 5.95265L4.38684 6.15002L4.36236 6.34298L4.34202 6.53077L4.32479 6.69579Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.26468 7.57675L4.26734 7.7555L4.2773 7.93831L4.29594 8.12453L4.32453 8.31347L4.36448 8.50451L4.41706 8.697L4.42175 8.71121L4.4269 8.72488L4.43233 8.73825L4.43782 8.75156L4.44328 8.76503L4.44846 8.77893L4.31671 9.2769L4.11879 9.72195L3.85153 10.1035L3.51174 10.411L3.09627 10.6338L2.60192 10.7614L2.52252 9.9965L2.6418 9.34536L2.91773 8.7929L3.3082 8.32402L3.77123 7.92367L4.26468 7.57675Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.14989 3.41008L5.90797 3.53343L5.67891 3.68213L5.46414 3.85568L5.26502 4.0534L5.08297 4.27478L4.91938 4.51922L4.88239 4.58194L4.84748 4.64488L4.81442 4.70802L4.78298 4.77129L4.75295 4.83472L4.72412 4.89825L4.61871 4.93113L4.50981 4.95985L4.39725 4.98411L4.28078 5.00357L4.16022 5.01793L4.03535 5.0269L4.08342 4.17203L4.33264 3.51835L4.73723 3.02013L5.25136 2.63149L5.82928 2.30672L6.42517 2L6.40608 2.24547L6.37685 2.48834L6.33706 2.72744L6.28626 2.96151L6.22401 3.18949L6.14989 3.41008Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.2353 4.88409L19.0639 4.55942L18.8673 4.26516L18.647 4.00279L18.4041 3.77375L18.1399 3.57953L17.8555 3.42156L17.78 3.19943L17.7166 2.96976L17.665 2.73375L17.6246 2.49262L17.5949 2.24764L17.5756 2L18.1715 2.30674L18.7494 2.63152L19.2634 3.02013L19.6679 3.51835L19.9169 4.17203L19.9646 5.0269L19.8316 5.01706L19.7035 5.00117L19.58 4.97961L19.461 4.95266L19.3461 4.92071L19.2353 4.88409Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.42523 16.7868L8.22744 16.9895L8.03803 17.2177L7.86573 17.4719L7.71922 17.7527L7.60725 18.0607L7.53853 18.3964L7.37856 18.013L7.27182 17.5858L7.21587 17.1251L7.2082 16.6413L7.24639 16.1448L7.32795 15.6459L7.52016 15.7855L7.71394 15.9476L7.90531 16.1304L8.09028 16.3323L8.26492 16.5516L8.42523 16.7868Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.5508 8.77357L19.6126 8.57001L19.6599 8.36657L19.6942 8.16434L19.7168 7.96433L19.7293 7.7676L19.733 7.57522L20.227 7.92232L20.6907 8.32282L21.0819 8.79185L21.3585 9.34452L21.4782 9.996L21.3988 10.7614L20.9037 10.6335L20.4876 10.4101L20.1475 10.1017L19.88 9.71908L19.6822 9.27282L19.5508 8.77357Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.6626 6.61002L19.6532 6.53192L19.6487 6.49349L19.6444 6.45543L19.6403 6.41783L19.6365 6.38069L19.6133 6.19326L19.5842 6.01042L19.5493 5.83224L19.509 5.65876L19.4632 5.49011L19.4122 5.32629L19.767 5.54462L20.0802 5.80451L20.3414 6.11647L20.5401 6.4909L20.6658 6.93833L20.7082 7.46916L20.5238 7.47299L20.3483 7.46609L20.1813 7.44902L20.0225 7.42232L19.8716 7.38662L19.728 7.34244L19.7208 7.20827L19.7113 7.07829L19.7002 6.95297L19.6879 6.83283L19.6752 6.71834L19.6626 6.61002Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14.6172 20.6047L15.002 20.5702L15.3488 20.4771L15.6545 20.3288L15.9161 20.1288L16.1303 19.8805L16.2942 19.5875L16.6285 19.7223L16.94 19.8903L17.2281 20.0786L17.4923 20.2745L17.7321 20.465L17.947 20.6373L17.4685 20.8121L16.9121 20.9498L16.3178 21.0284L15.7257 21.0259L15.176 20.9205L14.7087 20.6901L14.7006 20.6836L14.6891 20.6734L14.6746 20.6601L14.6575 20.6439L14.6383 20.6253L14.6172 20.6047Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.5841 17.8232L18.8484 17.2502L19.3032 16.8247L19.9043 16.5442L20.6072 16.4063L21.3678 16.4086L22.1416 16.5487L21.8156 16.9981L21.3353 17.4389L20.7364 17.8064L20.0545 18.0359L19.3251 18.0631L18.5841 17.8232Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.5135 19.2567L16.8813 18.7128L17.4539 18.3761L18.1561 18.2278L18.9122 18.2491L19.6466 18.4213L20.284 18.7256L19.8163 19.0903L19.2081 19.4111L18.5165 19.638L17.7987 19.7211L17.112 19.6106L16.5135 19.2567Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.284 16.0709L20.477 15.4033L20.8473 14.8862L21.3685 14.5141L22.0145 14.2815L22.759 14.1828L23.5758 14.2125L23.2252 14.7293L22.8214 15.2403L22.3448 15.6876L21.776 16.0135L21.0955 16.1605L20.284 16.0709Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.70162 19.5894L7.86709 19.8837L8.0819 20.1359L8.34014 20.341L8.63582 20.4939L8.96303 20.5894L9.31576 20.6223L9.3242 20.6222L9.33292 20.6217L9.34185 20.6211L9.35077 20.6204L9.35961 20.6198L9.36822 20.6193L9.35099 20.6362L9.3351 20.6515L9.32093 20.6649L9.30878 20.676L9.29905 20.6845L9.29203 20.6901L8.82473 20.9205L8.27498 21.0259L7.68286 21.0284L7.08843 20.9498L6.53181 20.8121L6.05303 20.6373L6.26744 20.4655L6.50673 20.2756L6.77036 20.0803L7.05776 19.8923L7.36837 19.7245L7.70162 19.5894Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.8941 17.9825L17.4369 17.4899L17.2177 16.8314L17.1978 16.0855L17.3385 15.3305L17.6012 14.6447L17.947 14.1064L18.2462 14.6672L18.48 15.3677L18.6051 16.1288L18.5781 16.8711L18.3556 17.5154L17.8941 17.9825Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.2319 20.6066H13.7688L14.0917 20.7403L14.3968 20.9015L14.6795 21.0842L14.935 21.2822L15.1587 21.4893L15.3458 21.6993L14.7834 21.882L14.1747 21.9793L13.5559 21.986L12.9632 21.8963L12.4326 21.7049L12.0004 21.4061L11.5679 21.7049L11.0372 21.8964L10.4445 21.986L9.82583 21.9793L9.21727 21.882L8.65495 21.6993L8.84209 21.4893L9.06576 21.2822L9.32127 21.0842L9.60392 20.9015L9.90905 20.7402L10.2319 20.6066Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.6728 15.6459L16.7552 16.1524L16.7926 16.6561L16.7827 17.1463L16.7228 17.6123L16.6106 18.0433L16.4435 18.4286L16.3985 18.1806L16.3209 17.918L16.2053 17.644L16.0465 17.3614L15.8391 17.0734L15.5778 16.783L15.738 16.5486L15.9123 16.3299L16.0969 16.1288L16.2878 15.9466L16.481 15.7851L16.6728 15.6459Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.8054 16.2834L19.2542 15.9754L18.895 15.4135L18.7147 14.6922L18.7001 13.9055L18.8381 13.148L19.1155 12.5137L19.479 12.9936L19.8198 13.5859L20.0804 14.2508L20.2032 14.9485L20.1307 15.6393L19.8054 16.2834Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.19462 16.2834L3.86957 15.6394L3.79718 14.9486L3.92001 14.2508L4.18059 13.5859L4.52152 12.9936L4.8853 12.5137L5.16266 13.148L5.30061 13.9056L5.28597 14.6922L5.10553 15.4135L4.74616 15.9753L4.19462 16.2834Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21.0267 6.51316L20.9426 6.46475L20.8184 6.33941L20.6749 6.16428L20.5328 5.96632L20.4132 5.77268L20.3368 5.61038L20.2239 5.04131L20.2531 4.47742L20.3863 3.93957L20.5851 3.44852L20.8113 3.02517L21.0267 2.6903L21.1926 3.06989L21.386 3.48997L21.571 3.94704L21.7119 4.43751L21.7726 4.95792L21.7174 5.50471L21.6785 5.61507L21.5928 5.81262L21.4725 6.04928L21.33 6.27696L21.1773 6.44762L21.0267 6.51316Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M2.9733 6.51316L2.82302 6.44763L2.67055 6.27698L2.52812 6.04928L2.40795 5.81259L2.3223 5.61504L2.28338 5.50471L2.22788 4.95793L2.28851 4.43753L2.42935 3.94704L2.61438 3.48997L2.8077 3.06988L2.9733 2.6903L3.18899 3.02518L3.41542 3.44854L3.6144 3.93957L3.74762 4.47741L3.7769 5.0413L3.66398 5.61038L3.58755 5.7727L3.46789 5.96634L3.32581 6.16428L3.18212 6.33941L3.05768 6.46473L2.9733 6.51316Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.48722 19.2567L6.88873 19.6107L6.20189 19.7211L5.484 19.638L4.79231 19.411L4.18418 19.0903L3.71681 18.7256L4.35382 18.4213L5.08807 18.2491L5.84408 18.2278L6.54627 18.3761L7.11916 18.7128L7.48722 19.2567Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3.239 13.5754L3.00004 12.8414L3.01263 12.1355L3.21555 11.4737L3.54755 10.8718L3.94741 10.3459L4.35389 9.91182L4.5659 10.6411L4.6211 11.415L4.51776 12.1644L4.25411 12.8203L3.82844 13.3137L3.239 13.5754Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M2.23055 9.32757L1.69358 9.00545L1.35059 8.47633L1.17739 7.80622L1.14973 7.06117L1.24342 6.30719L1.4342 5.61038L1.88291 6.03307L2.26906 6.60737L2.54478 7.2786L2.66217 7.99212L2.57339 8.69333L2.23055 9.32757Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M2.33622 12.0355L1.67841 11.8085L1.16905 11.433L0.793287 10.9238L0.536184 10.2959L0.382908 9.56408L0.31854 8.74332L0.89776 9.06105L1.45115 9.44755L1.92521 9.92052L2.26642 10.4977L2.42125 11.1968L2.33622 12.0355Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M24 11.7698L23.726 12.3834L23.3928 12.964L22.9757 13.4666L22.4499 13.8458L21.7909 14.0564L20.9739 14.0532L21.1253 13.3197L21.4557 12.7652L21.9368 12.3614L22.5401 12.0798L23.2373 11.8921L24 11.7698Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.41595 17.8232L4.67513 18.0631L3.94587 18.0359L3.26389 17.8064L2.66484 17.4389L2.18446 16.9981L1.85841 16.5487L2.63257 16.4087L3.39331 16.4064L4.09632 16.5442L4.69729 16.8247L5.15194 17.2502L5.41595 17.8232Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21.7702 9.32757L21.4274 8.69334L21.3386 7.99214L21.456 7.2786L21.7317 6.60733L22.1178 6.03305L22.5666 5.61038L22.7574 6.30721L22.851 7.06118L22.8234 7.80622L22.6502 8.47631L22.3072 9.00544L21.7702 9.32757Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3.71681 16.0709L2.90517 16.1606L2.22459 16.0136L1.65568 15.6876L1.17903 15.2402L0.775269 14.7293L0.424975 14.2125L1.24174 14.1828L1.98611 14.2815L2.63198 14.5141L3.15313 14.8862L3.52348 15.4033L3.71681 16.0709Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.10663 17.9825L5.64521 17.5154L5.42263 16.8711L5.39556 16.1288L5.52054 15.3677L5.75416 14.6671L6.05303 14.1064L6.39913 14.6447L6.66197 15.3305L6.80286 16.0855L6.78306 16.8314L6.56389 17.4899L6.10663 17.9825Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21.6638 12.0355L21.5788 11.1968L21.7337 10.4977L22.0751 9.92052L22.5492 9.44752L23.1025 9.06105L23.6815 8.74332L23.6174 9.56409L23.4643 10.2959L23.2073 10.9238L22.8314 11.433L22.3219 11.8085L21.6638 12.0355Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.6461 9.91182L20.0526 10.3459L20.4526 10.8718L20.7848 11.4737L20.9879 12.1355L21.0007 12.8414L20.7618 13.5754L20.1721 13.3137L19.7463 12.8203L19.4826 12.1644L19.3792 11.415L19.4344 10.6411L19.6461 9.91182Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3.0269 14.0532L2.20978 14.0564L1.55061 13.8458L1.02473 13.4666L0.607432 12.964L0.27408 12.3834L0 11.7698L0.762778 11.8921L1.46011 12.0798L2.06362 12.3614L2.54484 12.7652L2.87541 13.3197L3.0269 14.0532Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M9.11477 18.8999L9.10937 18.5404L9.23946 18.2288L9.46432 17.957L9.74314 17.7166L10.0352 17.4996L10.2997 17.2976L10.4672 17.1369L10.6103 16.9558L10.7314 16.7585L10.8327 16.5492L10.9162 16.3322L10.9843 16.1115L11.0304 15.9432L11.0895 15.7079L11.1432 15.4426L11.1732 15.1842L11.1612 14.9696L11.0888 14.8358L10.7229 14.5076L10.4083 14.1237L10.1389 13.6989L9.90827 13.2486L9.71039 12.7877L9.53898 12.3315L9.42074 12.0715L9.26271 11.8159L9.07787 11.5664L8.87912 11.3249L8.67948 11.0928L8.49185 10.872L8.36575 10.7213L8.23775 10.5723L8.1077 10.425L7.97535 10.2798L7.84058 10.1369L7.70316 9.99643L7.54962 9.8458L7.39261 9.69941L7.23195 9.55729L7.06753 9.41936L6.89921 9.28562L6.72686 9.15605L6.55832 9.03077L6.39512 8.90013L6.24331 8.75969L6.10884 8.60502L5.99773 8.43168L5.91597 8.23527L5.85921 7.98572L5.83436 7.7281L5.83384 7.46606L5.85003 7.2032L5.87535 6.94319L5.90218 6.68966L5.92812 6.45491L5.96155 6.21984L6.00709 5.98711L6.06934 5.75919L6.15293 5.53871L6.26245 5.32821L6.39489 5.14056L6.53953 4.99347L6.6947 4.88409L6.85866 4.80953L7.02974 4.76697L7.20621 4.75354L7.48048 4.78213L7.75713 4.86131L8.03017 4.9811L8.29353 5.13147L8.54119 5.30244L8.76713 5.48403L9.26399 5.19909L9.78309 4.96541L10.3201 4.7833L10.8707 4.65292L11.4306 4.57451L11.9954 4.54832L12.3738 4.56006L12.7512 4.59535L13.1263 4.65428L13.4977 4.73686L13.8642 4.84317L14.2244 4.9733L14.3894 5.0415L14.5525 5.11445L14.7134 5.1922L14.8719 5.27471L15.0275 5.36202L15.18 5.45417L15.184 5.45626L15.1881 5.45799L15.1924 5.45934L15.197 5.4603L15.2018 5.46087L15.2068 5.46106L15.2756 5.44029L15.3607 5.38705L15.4532 5.315L15.5437 5.2377L15.623 5.16877L15.682 5.12185L15.7847 5.0535L15.8903 4.98984L15.9988 4.93166L16.1103 4.87964L16.2249 4.83458L16.3424 4.79718L16.4112 4.77955L16.4783 4.76529L16.5438 4.75435L16.6077 4.7466L16.6699 4.74203L16.7306 4.74052L17.1297 4.81613L17.4509 5.02251L17.7003 5.32893L17.8837 5.70459L18.0071 6.11877L18.0764 6.54073L18.1159 6.88594L18.1531 7.2534L18.1673 7.62786L18.1376 7.99416L18.0431 8.33709L17.8631 8.64149L17.7033 8.81291L17.527 8.969L17.34 9.11504L17.1482 9.25631L16.9577 9.39813L16.7743 9.5458L16.5888 9.71059L16.4082 9.88072L16.2321 10.0557L16.0604 10.2349L15.8929 10.4179L15.7291 10.604L15.4822 10.8874L15.2297 11.182L14.9837 11.4878L14.7562 11.8047L14.5593 12.1325L14.4051 12.4712L14.269 12.8202L14.1188 13.1662L13.9519 13.5053L13.7655 13.8333L13.557 14.1463L13.3236 14.4403L13.2695 14.5006L13.214 14.5596L13.1571 14.6172L13.0987 14.6732L13.0389 14.7273L12.9774 14.7795L12.9154 14.8315L12.8744 14.8737L12.8508 14.9142L12.8408 14.961L12.8406 15.0221L12.8465 15.1057L12.8596 15.2564L12.8762 15.4068L12.8966 15.5567L12.9209 15.706L12.9496 15.8544L12.9828 16.002L13.0875 16.3457L13.2225 16.6446L13.3902 16.9082L13.5929 17.1463L13.8332 17.3686L14.2996 17.7282L14.4808 17.8924L14.644 18.0764L14.7765 18.2794L14.8654 18.5004L14.8979 18.7387L14.8926 18.864L14.8742 18.9484L14.8389 19L14.7828 19.0267L14.702 19.0369L14.5927 19.0384H9.56042L9.51761 19.0396L9.47519 19.0425L9.4335 19.0463L9.39279 19.0501L9.35346 19.053L9.31577 19.0541L9.26917 19.0515L9.2268 19.0423L9.18942 19.0245L9.15777 18.9962L9.13264 18.9553L9.11477 18.8999ZM15.1073 9.80002L15.2977 9.59048L15.4929 9.38568L15.693 9.186L15.8985 8.99187L16.1097 8.80372L16.3267 8.62195L16.4449 8.53591L16.5846 8.44484L16.7321 8.3483L16.8735 8.24582L16.995 8.13694L17.0829 8.02125L17.1649 7.8164L17.192 7.55729L17.1799 7.26983L17.1443 6.97989L17.1013 6.71342L17.0664 6.49631L17.05 6.38234L17.0297 6.26356L17.0029 6.14384L16.9674 6.02702L16.9209 5.91695L16.8608 5.8175L16.8358 5.79187L16.8094 5.77178L16.782 5.75686L16.7535 5.74668L16.7242 5.74087L16.6943 5.73901L16.6319 5.74585L16.5685 5.76426L16.5054 5.79113L16.4436 5.82325L16.3846 5.85746L16.3294 5.89063L16.1799 5.98859L16.0366 6.09705L15.8991 6.2139L15.7669 6.3371L15.6397 6.46459L15.517 6.59432L15.4393 6.72486L15.3975 6.8919L15.3812 7.08027L15.3796 7.27467L15.3822 7.45992L15.3784 7.62077L15.3475 7.98545L15.3113 8.34969L15.2695 8.71341L15.2218 9.07643L15.1679 9.43869L15.1073 9.80002ZM8.81626 9.36347L8.88887 9.80079L8.6662 9.55731L8.43704 9.31983L8.20097 9.08929L7.95753 8.86652L7.70637 8.65252L7.44702 8.44814L7.35413 8.38255L7.25334 8.31497L7.15073 8.24389L7.05235 8.1678L6.96429 8.0853L6.89264 7.99483L6.84815 7.89266L6.82698 7.77343L6.82296 7.64471L6.82988 7.51406L6.85205 7.27735L6.86093 7.08379L6.87919 6.77551L6.91838 6.41932L6.99003 6.0821L7.10575 5.83076L7.27703 5.73213L7.28166 5.7322L7.28635 5.73239L7.2911 5.7327L7.2959 5.73313L7.30078 5.73372L7.30574 5.73443L7.45836 5.77463L7.60996 5.84486L7.75718 5.93672L7.89664 6.0418L8.02498 6.15177L8.13885 6.25818L8.19826 6.31305L8.2567 6.36884L8.3142 6.42554L8.37079 6.48299L8.42656 6.5412L8.48151 6.60007L8.53686 6.67976L8.56801 6.76772L8.58177 6.86176L8.58489 6.95975L8.58419 7.05957L8.58641 7.15905L8.61563 7.60147L8.65291 8.04337L8.69859 8.48451L8.75293 8.92462L8.81626 9.36347Z",
                fill: "white"
            })
        ]
    });
}
function $fdd862b2a5201b09$export$64d17932e486b075() {
    const classes = $fdd862b2a5201b09$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8DzwJ.default), {
        className: classes.CustomIcon,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M23.923 17.7917L23.8959 18.0286L23.865 18.2745L23.8217 18.5211L23.757 18.7603L23.6622 18.9838L23.5282 19.1834L23.3309 19.3691L23.1102 19.499L22.8718 19.5855L22.6206 19.641L22.3622 19.6779L22.1017 19.7084L22.2534 18.5926L22.039 17.535L21.5149 16.6062L20.7368 15.8768L19.761 15.4174L18.6433 15.2986L17.5587 15.556L16.654 16.1293L15.9753 16.943L15.569 17.9215L15.4814 18.9893L15.7588 20.0708L14.5989 20.0199L13.4416 19.9891L12.2857 19.9811L11.1301 19.9985L9.97358 20.0438L8.8149 20.1197L8.98218 19.0886L8.83092 18.0914L8.40245 17.1896L7.73761 16.4445L6.87766 15.9176L5.86361 15.6702L4.83888 15.7477L3.91652 16.1163L3.145 16.7256L2.57264 17.5247L2.24799 18.4632L2.21938 19.4903L1.99944 19.3848L1.77914 19.2797L1.55827 19.1756L1.33642 19.0732L1.11347 18.9733L0.889079 18.8765L0.797175 18.8433L0.698429 18.8125L0.599164 18.779L0.505135 18.7376L0.422561 18.6834L0.357456 18.6111L0.227039 18.3556L0.137364 18.0699L0.0792043 17.7662L0.043127 17.4565L0.0198011 17.153L0 16.8678L0.0126478 16.6703L0.073658 16.5179L0.166132 16.3928L0.272757 16.2769L0.376687 16.1523L0.460712 16.0011L0.504046 15.8606L0.530897 15.7106L0.54624 15.5552L0.554949 15.3987L0.562154 15.2452L0.572676 15.0988L0.596313 14.8419L0.632287 14.5356L0.696044 14.2203L0.802877 13.9366L0.968283 13.7252L1.20756 13.6267L1.57911 13.5963L1.94828 13.571L2.31305 13.5373L2.67087 13.4819L3.01977 13.3915L3.35727 13.2526L5.34526 12.9026L5.31374 12.942L5.28419 12.9821L5.25708 13.0233L5.23262 13.0655L5.21131 13.109L5.19348 13.1539L5.21468 13.3801L5.42052 13.5256L5.73734 13.6078L6.09096 13.6442L6.40767 13.6524L6.61335 13.6499L6.87849 13.6497L7.17007 13.6427L7.44992 13.6039L7.67981 13.5086L7.82163 13.3317L7.83708 13.0486L7.81816 12.9552L7.79541 12.8617L7.76907 12.7686L7.73932 12.6759L7.70667 12.5839L7.67121 12.4929L8.82112 12.2897L8.80371 12.5312L8.83527 12.7896L8.90214 13.0534L8.99047 13.3112L9.08673 13.5517L9.17692 13.7635L9.21974 13.8271L9.27593 13.8624L9.34269 13.877L9.41707 13.8789L9.49633 13.8757L9.5775 13.8755L9.88266 13.8859L10.1879 13.8949L10.4931 13.9024L10.7983 13.9086L11.1035 13.9134L11.4087 13.9169L11.6567 13.9191L11.9048 13.9205L12.153 13.9212L12.4011 13.9211L12.6492 13.9203L12.897 13.9186L13.0399 13.9171L13.1829 13.9153L13.326 13.9133L13.755 13.9061L13.7601 13.8889L13.7616 13.8612L13.7606 13.8284L13.7583 13.7954L13.7561 13.7673L13.755 13.7494L13.7556 13.6641L13.7592 13.5359L13.7714 13.3906L13.7983 13.254L13.846 13.1522L13.9201 13.1108L14.0125 13.0988L14.0711 13.0708L14.0999 13.0296L14.1024 12.9783L14.0828 12.9197L14.0449 12.857L13.8346 12.6138L13.5846 12.4098L13.306 12.2388L13.0093 12.0944L12.7056 11.9703L12.4056 11.8601L12.332 11.835L12.258 11.812L12.1838 11.7909L12.1092 11.7713L12.0344 11.7533L11.9594 11.7365L13.4245 11.4786L13.5812 11.5522L13.7364 11.6286L13.8901 11.7076L14.0421 11.7888L14.1923 11.8721L14.3405 11.9571L14.6874 12.1674L15.0282 12.3873L15.363 12.6161L15.6919 12.8532L16.0149 13.0979L16.3323 13.3496L16.4739 13.4672L16.5904 13.5623L16.6978 13.637L16.8115 13.6932L16.9474 13.7328L17.1214 13.7577L18.1191 13.8507L19.128 13.9661L20.1364 14.1199L21.1322 14.328L22.1039 14.6064L23.0393 14.971L23.134 15.0133L23.2743 15.0804L23.4219 15.1642L23.5385 15.2562L23.5856 15.348L23.5249 15.4313L23.4958 15.4841L23.4771 15.5856L23.4664 15.7131L23.4608 15.8438L23.4576 15.9549L23.4544 16.0235L23.396 16.5823L23.3816 16.7222L23.3673 16.862L23.4056 16.8946L23.5088 16.9265L23.6469 16.958L23.7898 16.9897L23.9077 17.0219L23.9703 17.0552L23.9981 17.1426L24 17.271L23.9849 17.4204L23.9613 17.5704L23.9377 17.7009L23.923 17.7917Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.6723 16.4083L19.2368 16.4338L19.7665 16.5934L20.2399 16.8712L20.6355 17.2514L20.9323 17.718L21.1086 18.2553L21.1368 18.9042L20.9852 19.5167L20.6778 20.0612L20.2384 20.5057L19.6911 20.8187L19.0596 20.9682L18.4298 20.933L17.8496 20.7317L17.3466 20.3886L16.9482 19.928L16.6821 19.3744L16.5757 18.7521L16.6362 18.1692L16.8385 17.6338L17.1631 17.1678L17.5899 16.7935L18.0996 16.533L18.6723 16.4083Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.39999 16.7766L5.98527 16.8057L6.53114 16.9789L7.0144 17.2776L7.41167 17.6837L7.69972 18.1788L7.85533 18.7447L7.84812 19.396L7.6625 20.001L7.32422 20.5289L6.85911 20.9493L6.29296 21.2314L5.65171 21.3447L5.04876 21.2782L4.49796 21.0598L4.02366 20.7121L3.64988 20.2579L3.40112 19.7197L3.30129 19.1204L3.3624 18.5378L3.56523 18.0024L3.89019 17.5364L4.31741 17.1619L4.82727 16.9013L5.39999 16.7766Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M2.7282 12.0699L2.29858 12.1462L1.932 10.062L1.88888 9.81987L1.17438 5.77423L1.14504 5.57116L1.13359 5.40424L1.13934 5.27381L1.16147 5.18021L1.19942 5.1238L1.25234 5.10493H1.25276L1.30521 5.1172L1.36612 5.15407L1.43506 5.21575L1.51157 5.30236L1.59544 5.41411L1.6861 5.55113L4.60878 9.13481L4.75599 9.31395L5.13501 9.2476L6.61087 3.78873L6.664 3.59338L6.73092 3.43299L6.81012 3.3078L6.89969 3.21805L6.99823 3.16403L7.10392 3.14597L7.19609 3.15846L7.29089 3.19603L7.38757 3.25897L7.48502 3.34746L7.58231 3.46176L7.67867 3.60212L10.9323 8.225L11.3129 8.15865L11.3702 7.99361L12.9103 3.57143L12.9523 3.39664L12.9972 3.25372L13.0445 3.14265L13.0931 3.06336L13.1427 3.01582L13.1923 3L13.2433 3.01681L13.2931 3.06724L13.3408 3.15136L13.3859 3.26919L13.4275 3.42081L13.4652 3.60627L14.1788 7.65274L14.2224 7.89408L14.5894 9.97993L2.7282 12.0699Z",
                fill: "white"
            })
        ]
    });
}
function $fdd862b2a5201b09$export$919f9e6aad25b3cc() {
    const classes = $fdd862b2a5201b09$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8DzwJ.default), {
        className: classes.CustomIcon,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M23.5888 5.10296L19.3257 10.6287L19.3118 10.6247L19.2978 10.6208L19.2838 10.6169L19.2697 10.613L19.2557 10.6091L19.2417 10.6053L19.2279 10.6016L19.2142 10.5979L19.2006 10.5942L19.1874 10.5907V10.5926L19.1192 10.578L19.0514 10.5652L18.9838 10.554L18.9166 10.5443L18.8496 10.5363L18.783 10.5297L18.7169 10.5248L18.6511 10.5212L18.5859 10.5191L18.5211 10.5184L18.2112 10.5376L17.9174 10.5824L17.6394 10.65L17.3774 10.7375L17.1311 10.8419L16.9004 10.9604L16.6854 11.0899L16.4857 11.2276L16.3015 11.3706L16.1325 11.516L15.9637 11.3706L15.7797 11.2277L15.5803 11.0899L15.3655 10.9604L15.135 10.8419L14.8889 10.7375L14.6271 10.65L14.3495 10.5824L14.0558 10.5376L13.7462 10.5184L13.6811 10.5191L13.6157 10.5212L13.5498 10.5248L13.4835 10.5298L13.4169 10.5363L13.3498 10.5443L13.2824 10.554L13.2147 10.5652L13.1466 10.578L13.0783 10.5926L12.8768 10.644L12.6675 10.7097L12.4518 10.79L12.2313 10.8854L12.0073 10.9961L11.7813 11.1225L11.5549 11.265L11.3294 11.4241L11.1064 11.5999L10.8872 11.793L10.6763 12.0028L10.475 12.2329L10.2861 12.483L10.1128 12.7525L9.95797 13.041L9.82475 13.348L9.71607 13.673L9.63504 14.0156L9.58453 14.3752L9.56765 14.7515L9.60317 15.2713L9.70044 15.8061L9.86298 16.3565L10.0946 16.9233L10.399 17.507L10.7799 18.1085L11.241 18.7283L11.7861 19.3674L12.4188 20.0262L13.1429 20.7055H8.18275L7.73525 20.669L7.3151 20.5632L6.92764 20.3941L6.57834 20.1675L6.27266 19.8892L6.01606 19.5651L5.81406 19.201L5.672 18.8028L5.59539 18.3763L5.58972 17.9273L5.96246 12.5168L5.9625 12.5134L5.9627 12.51L5.96298 12.5067L5.96334 12.5035L5.96371 12.5002L5.96411 12.497L5.96455 12.4938L5.96491 12.4906L5.96524 12.4873L5.96553 12.484L5.92516 12.4513L5.88529 12.4178L5.84602 12.3832L5.80743 12.3476L5.76946 12.3109L5.73235 12.2729L5.69614 12.2337L5.66085 12.1932L5.62666 12.1513L5.59356 12.108L0.382898 5.00324L0.219416 4.7398L0.101615 4.46277L0.0286759 4.17738L0 3.88911L0.0147703 3.60316L0.0723383 3.325L0.172032 3.05993L0.313082 2.8133L0.494768 2.59045L0.716442 2.39676L0.967921 2.24324L1.23523 2.13682L1.51293 2.07645L1.79575 2.06122L2.07838 2.09013L2.35551 2.16221L2.62181 2.27648L2.87196 2.43196L3.10063 2.62768L3.30256 2.86268L8.38564 9.79755L8.43714 9.78751L8.48884 9.77848L8.5407 9.77034L8.59272 9.76318L8.64483 9.75701L8.69714 9.75182L8.74955 9.74764L8.80209 9.74447L8.85471 9.74236L8.90748 9.74125L8.65033 9.48648L8.41437 9.21188L8.20093 8.91861L8.01142 8.6081L7.84719 8.28159L7.70972 7.94048L7.60035 7.58609L7.52049 7.21972L7.47157 6.84268L7.45495 6.45635L7.51324 5.73356L7.68205 5.04793L7.95214 4.40856L8.31444 3.82464L8.75963 3.30536L9.27868 2.85992L9.86233 2.49748L10.5014 2.22722L11.1869 2.05831L11.9094 2L12.6321 2.05831L13.3178 2.22722L13.9571 2.49748L14.541 2.85994L15.0602 3.30536L15.5055 3.82462L15.8679 4.40854L16.1382 5.04791L16.307 5.73359L16.3653 6.45635L16.3486 6.84268L16.2997 7.21974L16.2198 7.58611L16.1103 7.94051L15.9727 8.28159L15.8084 8.60805L15.6188 8.91859L15.4052 9.21185L15.1692 9.48651L14.912 9.74125L14.9615 9.74233L15.011 9.74445L15.0603 9.7475L15.1095 9.75153L15.1584 9.75638L15.2073 9.7621L15.256 9.76863L15.3045 9.77588L15.3527 9.78388L15.4008 9.79255L20.7237 2.89227L20.9313 2.66212L21.1649 2.47202L21.4189 2.32274L21.688 2.21509L21.9668 2.14991L22.2501 2.12803L22.5325 2.15025L22.8086 2.2174L23.0731 2.3303L23.3206 2.48975L23.5376 2.68865L23.7139 2.91585L23.8488 3.16575L23.9419 3.43312L23.9925 3.71256L24 3.99872L23.964 4.2862L23.8838 4.56964L23.7589 4.84367L23.5888 5.10296Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M13.842 19.5545L16.1578 21.2704L18.4734 19.5545L20.0712 18.0159L21.0498 16.6527L21.5081 15.4631L21.5448 14.4451L21.2587 13.597L20.7485 12.9168L20.1131 12.4027L19.4512 12.0528L18.8615 11.8653L18.8132 11.8559L18.7654 11.8477L18.7177 11.8405L18.6705 11.8343L18.6235 11.829L18.5768 11.8248L18.5305 11.8216L18.4845 11.8193L18.4388 11.8179L18.3935 11.8174L18.0778 11.8394L17.7799 11.9009L17.5006 11.995L17.2411 12.1151L17.0025 12.2543L16.7857 12.4058L16.5917 12.5629L16.4218 12.7188L16.2768 12.8668L16.1578 13L16.0387 12.8668L15.8936 12.7189L15.7236 12.5629L15.5297 12.4058L15.3129 12.2543L15.0743 12.1151L14.8149 11.995L14.5357 11.9009L14.2378 11.8394L13.9222 11.8174L13.8768 11.8179L13.8311 11.8193L13.7851 11.8216L13.7388 11.8248L13.6921 11.829L13.6451 11.8343L13.5977 11.8405L13.5499 11.8477L13.5018 11.856L13.4534 11.8653L12.8639 12.0528L12.2021 12.4027L11.5668 12.9168L11.0566 13.597L10.7705 14.4451L10.8072 15.4631L11.2655 16.6527L12.2442 18.0159L13.842 19.5545ZM17.3334 19.1797L16.1578 20.0484L14.9822 19.1797L14.0315 18.3817L13.283 17.6541L12.7137 16.9971L12.3006 16.4106L12.0211 15.8945L11.8522 15.4488L11.771 15.0735L11.7546 14.7684L11.7803 14.5336L11.8668 14.2451L12.0022 13.9832L12.1765 13.7479L12.3799 13.5394L12.6025 13.3578L12.8344 13.2033L13.0657 13.076L13.2865 12.976L13.4869 12.9034L13.657 12.8584L13.6837 12.8531L13.7105 12.8484L13.7372 12.8442L13.7639 12.8405L13.7904 12.8373L13.817 12.8347L13.8434 12.8327L13.8698 12.8312L13.896 12.8303L13.9222 12.83L14.1237 12.8464L14.3168 12.8922L14.5001 12.9618L14.6722 13.0498L14.8316 13.1507L14.9769 13.259L15.1066 13.3694L15.2192 13.4764L15.3134 13.5744L15.3878 13.6581L16.1578 14.5603L16.9279 13.6581L17.0021 13.5744L17.0963 13.4764L17.2089 13.3694L17.3386 13.259L17.4837 13.1507L17.6431 13.0498L17.8152 12.9618L17.9986 12.8922L18.1918 12.8465L18.3935 12.83L18.4196 12.8303L18.4458 12.8312L18.472 12.8326L18.4984 12.8347L18.5248 12.8373L18.5513 12.8405L18.5779 12.8442L18.6045 12.8484L18.6311 12.8531L18.6579 12.8584L18.8282 12.9034L19.0288 12.976L19.2497 13.076L19.4811 13.2033L19.7131 13.3578L19.9357 13.5394L20.1391 13.7479L20.3135 13.9832L20.4489 14.2452L20.5354 14.5336L20.561 14.7684L20.5446 15.0735L20.4634 15.4488L20.2946 15.8945L20.015 16.4106L19.602 16.9971L19.0327 17.6541L18.2841 18.3816L17.3334 19.1797Z",
                fill: "white"
            })
        ]
    });
}
function $fdd862b2a5201b09$export$77afd8b5a8f1e556() {
    const classes = $fdd862b2a5201b09$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8DzwJ.default), {
        className: classes.CustomIcon,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M23.8975 9.35299L23.9411 9.47473L23.973 9.60023L23.9928 9.72872L24.0002 9.85924L23.9949 9.99102L23.9763 10.1231L23.9671 10.1672L23.9564 10.2112L23.9442 10.2551L23.9304 10.2988L23.915 10.3423L23.898 10.3856L21.1803 16.9711L21.1002 17.1334L21.001 17.282L20.8839 17.4155L20.7503 17.5327L20.6015 17.6323L20.4389 17.713L20.2656 17.7723L20.0888 17.8079L19.9105 17.8201L19.7325 17.8086L19.5567 17.7738L19.385 17.7154L13.5794 15.3107L14.846 18.3792L14.8858 18.5302L14.8843 18.6817L14.8446 18.8262L14.7697 18.9563L14.6627 19.0648L14.5264 19.1442L13.1419 19.7169L13.0676 19.7423L12.9916 19.7573L12.9146 19.7622L12.8375 19.7569L12.7614 19.7416L12.687 19.7161L12.6164 19.681L12.5516 19.6376L12.4932 19.5864L12.4419 19.528L12.3985 19.4631L12.3636 19.3921L12.0003 18.5123L11.6369 19.3921L11.602 19.4631L11.5586 19.528L11.5074 19.5864L11.449 19.6376L11.3841 19.681L11.3135 19.7161L11.2391 19.7416L11.1629 19.757L11.0859 19.7622L11.0089 19.7573L10.9328 19.7422L10.8587 19.7169L9.47415 19.1442L9.33788 19.0648L9.23077 18.9564L9.15585 18.8262L9.11611 18.6817L9.11465 18.5302L9.15443 18.3792L10.4211 15.3107L4.61557 17.7154L4.44383 17.7738L4.26801 17.8087L4.09 17.8201L3.91168 17.8079L3.73495 17.7722L3.56167 17.713L3.39901 17.6324L3.25019 17.5327L3.11659 17.4155L2.99949 17.2819L2.90029 17.1334L2.82027 16.9711L0.102531 10.3856L0.0854949 10.3424L0.0700924 10.2988L0.0562933 10.2551L0.0440375 10.2112L0.0333349 10.1672L0.0241254 10.1231L0.00564645 9.99102L0.000305176 9.85926L0.00773084 9.72872L0.0275126 9.60021L0.0592896 9.47469L0.102691 9.35299L0.119527 9.31339L0.137625 9.27426L0.156986 9.23564L0.177569 9.19756L0.199415 9.1601L0.222464 9.12323L0.228076 9.11344L0.28227 9.04642L0.327726 8.98874L0.375908 8.9331L0.426975 8.87985L0.48114 8.82926L0.538611 8.78168L0.59958 8.73745L0.63746 8.71262L0.676362 8.68903L0.716266 8.6667L0.757142 8.64556L0.799021 8.62557L0.841851 8.60678L6.8818 6.1055L6.58357 5.38269L6.54394 5.23141L6.54543 5.07973L6.58511 4.93503L6.66001 4.80469L6.76719 4.69612L6.90376 4.61676L8.28588 4.04483L8.35985 4.01994L8.43585 4.00511L8.51296 4.00034L8.59016 4.00555L8.6666 4.02072L8.74124 4.04579L8.81171 4.08087L8.8764 4.12426L8.93465 4.17545L8.98575 4.23385L9.02905 4.29895L9.06384 4.37016L12.0003 11.4848L14.9367 4.37016L14.9714 4.29897L15.0147 4.23387L15.0658 4.17545L15.124 4.12424L15.1887 4.08085L15.2592 4.04579L15.3338 4.02074L15.4103 4.00557L15.4875 4.00034L15.5646 4.00509L15.6406 4.0199L15.7147 4.04483L17.0966 4.61676L17.2332 4.69618L17.3404 4.80471L17.4153 4.93503L17.4549 5.07969L17.4564 5.23137L17.4168 5.38269L17.1188 6.1055L23.1589 8.60678L23.2016 8.62562L23.2433 8.64556L23.2841 8.6667L23.324 8.68899L23.3628 8.71258L23.4007 8.73745L23.4617 8.7817L23.5192 8.82929L23.5735 8.87985L23.6246 8.9331L23.6729 8.98872L23.7184 9.04642L23.7725 9.11344L23.7781 9.12323L23.8011 9.1601L23.823 9.19756L23.8436 9.23564L23.8629 9.27424L23.8809 9.31335L23.8975 9.35299ZM7.56933 12.4401L8.47315 14.6344L10.6653 13.7264L9.76147 11.5317L7.56933 12.4401ZM5.37526 13.3491L7.56933 12.4401L6.66213 10.2483L8.85797 9.33888L7.95173 7.14465L5.7567 8.05409L6.66213 10.2483L4.4687 11.1566L3.56472 8.96208L1.37257 9.87008L2.27656 12.0646L4.4687 11.1566L5.37526 13.3491ZM5.37526 13.3491L3.18023 14.2579L4.08566 16.4516L6.28101 15.5424L5.37526 13.3491ZM22.6281 9.87008L21.724 12.0646L19.5318 11.1566L20.4358 8.96208L22.6281 9.87008ZM18.6253 13.3491L19.5318 11.1566L17.3384 10.2483L18.2437 8.05409L16.0488 7.14465L15.1424 9.33888L17.3384 10.2483L16.4311 12.4401L14.2389 11.5317L13.3353 13.7264L15.5274 14.6344L16.4311 12.4401L18.6253 13.3491ZM18.6253 13.3491L20.8202 14.2579L19.9149 16.4516L17.7194 15.5424L18.6253 13.3491Z",
            fill: "white"
        })
    });
}
function $fdd862b2a5201b09$export$7e95adcf912503e3() {
    const classes = $fdd862b2a5201b09$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8DzwJ.default), {
        className: classes.CustomIcon,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M18.5326 8.0305L19.3312 8.88414L20.0095 9.82485L20.5629 10.8383L20.9866 11.9099L21.276 13.0253L21.4264 14.1702L21.4331 15.3301L21.2914 16.4905L21.0462 17.48L20.6937 18.4315L20.2405 19.3364L19.6926 20.1862L19.0567 20.9723L18.339 21.6863L17.5461 22.3196L16.6845 22.8636L15.1866 23.5248L13.6225 23.9009L12.0309 24L10.4509 23.8297L8.92129 23.3981L7.4812 22.7128L6.16943 21.7819L5.02487 20.613L4.04874 19.1411L3.38807 17.5425L3.03965 15.866L3 14.1608L3.26603 12.4756L3.8342 10.8595L4.70143 9.3615L5.86423 8.0305L5.34297 7.15454L5.20615 7.23657L5.07413 7.28472L4.94874 7.30203L4.83174 7.29163L4.72494 7.25658L4.63005 7.19996L4.549 7.12488L4.48343 7.03443L4.06539 6.33488L4.01894 6.23547L3.99408 6.13202L3.99003 6.02749L4.00598 5.92481L4.04123 5.82693L4.09489 5.73679L4.16621 5.65731L4.25447 5.59146L6.81901 4.06522L6.91866 4.01855L7.0224 3.99355L7.12721 3.98944L7.23007 4.00537L7.32807 4.0405L7.41816 4.09403L7.49739 4.16508L7.56266 4.25289L7.97836 4.95244L8.0346 5.09134L8.0546 5.22009L8.04316 5.33843L8.00481 5.4461L7.94417 5.54292L7.86587 5.62861L7.77456 5.70298L7.6748 5.76576L8.098 6.47657L8.20632 6.42399L8.31535 6.37262L8.42502 6.3225L8.53534 6.2738L8.64641 6.22654L8.75825 6.18081L8.87086 6.13675L8.98428 6.09442L8.4988 5.10164L8.32309 4.06818L8.42907 3.04734L8.78852 2.09255L9.37335 1.25707L10.1552 0.594247L11.1063 0.157454L12.1982 0L13.2884 0.157498L14.2392 0.594364L15.0221 1.2572L15.6083 2.09266L15.9692 3.04731L16.076 4.06777L15.9001 5.10064L15.413 6.09255L15.5265 6.13543L15.6393 6.17984L15.7513 6.2257L15.8626 6.27303L15.9731 6.3218L16.0829 6.372L16.192 6.4236L16.3002 6.47657L16.7234 5.76576L16.5898 5.68489L16.4864 5.59197L16.4118 5.49003L16.3644 5.38215L16.3428 5.27141L16.3456 5.16081L16.3713 5.05347L16.4185 4.95244L16.8341 4.25289L16.8999 4.16509L16.9795 4.09401L17.0698 4.0405L17.168 4.00537L17.271 3.98943L17.3758 3.99356L17.4796 4.01853L17.5792 4.06522L20.1428 5.59146L20.2314 5.65731L20.3029 5.73679L20.3566 5.82693L20.3918 5.92481L20.4077 6.02751L20.4036 6.13202L20.3786 6.23547L20.3319 6.33488L19.9148 7.03443L19.8483 7.124L19.765 7.19692L19.6673 7.25086L19.5579 7.28353L19.4393 7.29256L19.3142 7.27561L19.185 7.23038L19.0543 7.15454L18.5326 8.0305ZM10.4552 14.0299L10.4203 14.1277L10.39 14.2426L10.3643 14.3652L10.3432 14.4863L10.3267 14.5966L10.3149 14.6869L10.3079 14.7479L10.3055 14.7703L10.3683 15.2486L10.5441 15.6772L10.8146 16.0438L11.1611 16.336L11.565 16.5416L12.0077 16.6481L12.4708 16.6433L12.9357 16.5149L13.2597 16.3352L13.5424 16.0935L13.7761 15.8019L13.9531 15.4728L14.0656 15.1183L14.1059 14.7507L14.0663 14.3822L13.9388 14.025L13.9014 13.9426L13.8597 13.8621L13.814 13.7836L13.7645 13.7074L13.7115 13.6336L13.6551 13.5623L13.5957 13.4938L13.5335 13.4282L13.4938 13.3837L13.4492 13.342L13.401 13.3029L13.3502 13.2658L13.2982 13.2304L13.1948 13.163L13.1459 13.1303L12.6453 6.24245L12.5922 5.97764L12.4887 5.78832L12.3515 5.67459L12.1976 5.6365L12.0438 5.67417L11.907 5.78765L11.8041 5.97705L11.752 6.24245L11.2523 13.1303L11.1232 13.21L11.0012 13.3015L10.887 13.4034L10.7812 13.5146L10.6845 13.6339L10.5976 13.7601L10.5209 13.8919L10.4552 14.0283V14.0299ZM9.6151 4.15621L9.6022 3.8949L9.63674 3.52887L9.74371 3.11559L9.92839 2.68465L10.1959 2.26567L10.5515 1.88825L11.0002 1.58202L11.5474 1.37656L12.1982 1.30151L12.9161 1.39178L13.493 1.63416L13.9427 1.98603L14.2794 2.4047L14.5172 2.8476L14.6702 3.27207L14.7525 3.63545L14.7782 3.89514L14.7696 4.13763L14.7386 4.37898L14.6847 4.61746L14.6077 4.85133L14.5069 5.07882L14.3821 5.29816L14.2327 5.50764L14.0585 5.70547L13.8553 5.66981L13.8347 5.6101L13.7698 5.45267L13.656 5.23009L13.4889 4.97496L13.2642 4.71981L12.9771 4.49723L12.6233 4.3398L12.1982 4.2801L11.7732 4.3398L11.4195 4.49724L11.1324 4.71981L10.9079 4.97496L10.741 5.2301L10.6274 5.45267L10.5626 5.61011L10.542 5.66981L10.3379 5.70547L10.1757 5.52258L10.0311 5.32489L9.90529 5.11357L9.79955 4.88983L9.71509 4.65489L9.65322 4.40995L9.6151 4.15621Z",
            fill: "white"
        })
    });
}
function $fdd862b2a5201b09$export$d3e24e2ed1fd2185() {
    const classes = $fdd862b2a5201b09$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8DzwJ.default), {
        className: classes.CustomIcon,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.44546 21.6995L5.22642 21.7769L4.99972 21.8134L4.77132 21.8092L4.54714 21.7648L4.33315 21.6807L4.13536 21.5571L4.04813 21.484L3.96632 21.4036L3.88875 21.3181L3.81406 21.2297L3.74103 21.1404L3.66842 21.0526L2.34099 19.4732L2.25092 19.3646L2.16487 19.255L2.08506 19.1422L2.0136 19.0241L1.95274 18.8986L1.90466 18.7636L1.85189 18.499L1.84661 18.2302L1.88774 17.965L1.97395 17.7112L2.10417 17.4766L2.27718 17.2691L1.80747 17.2307L1.36298 17.0962L0.957861 16.8748L0.606086 16.5759L0.321692 16.209L0.118764 15.7834L0.0189949 15.371L0 14.9521L0.0589212 14.5388L0.192716 14.1433L0.398571 13.7778L0.67349 13.4546L1.00602 13.191L1.37835 12.9981L1.77833 12.8782L2.1935 12.8339L2.61162 12.8675L3.02038 12.9817L3.4385 13.1992L3.7952 13.4961L4.08156 13.8581L4.28861 14.2707L4.40751 14.7196L4.42932 15.1903L4.4997 15.1286L4.57388 15.0725L4.65141 15.0219L4.73188 14.9764L4.81501 14.936L4.90032 14.9004L5.04196 15.0937L4.75832 19.2552L4.75323 19.7016L4.7988 20.1373L4.89304 20.5586L5.03363 20.9618L5.21849 21.3433L5.44546 21.6995Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M22.7098 16.6505L23.0759 16.8652L23.3905 17.1426L23.647 17.4721L23.8385 17.8431L23.9585 18.245L24 18.6673L23.9586 19.0896L23.8386 19.4916L23.647 19.8626L23.3905 20.192L23.0758 20.4694L22.7098 20.6841L22.2627 20.8337L21.8013 20.884L21.3421 20.8386L20.9014 20.701L20.496 20.4747L20.142 20.1633L20.1049 20.4683L20.0049 20.7561L19.8496 21.0178L19.646 21.2445L19.4016 21.4274L19.1237 21.5575L18.989 21.5957L18.8504 21.6214L18.7094 21.6379L18.5674 21.6484L18.4257 21.6562L18.286 21.6645L17.8051 21.6973L18.0315 21.3412L18.2158 20.96L18.3559 20.5572L18.4497 20.1365L18.4952 19.7014L18.4904 19.2556L18.2436 15.6676L18.2884 15.6706L18.3331 15.6737L18.4675 15.683L18.5125 15.686L18.6531 15.6967L18.7917 15.711L18.9283 15.7319L19.0629 15.7623L19.1955 15.8056L19.3261 15.8645L19.5529 16.0107L19.7498 16.1938L19.9121 16.4077L20.0347 16.6461L20.113 16.9027L20.142 17.1713L20.496 16.86L20.9015 16.6338L21.3421 16.4961L21.8013 16.4506L22.2627 16.5009L22.7098 16.6505Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M17.1349 19.7723L17.1408 19.3482L16.8786 15.5363L16.8689 15.3868L16.86 15.2359L16.8507 15.084L16.8399 14.9318L16.8266 14.7797L16.8096 14.6282L16.8559 14.5878L16.9012 14.5459L16.9455 14.5024L16.9883 14.4567L17.0295 14.4088L17.0689 14.3582L21.5904 8.19355L21.8047 7.80561L21.9102 7.39341L21.9098 6.97842L21.8062 6.58212L21.6023 6.22599L21.3009 5.93149L21.1629 5.84149L21.0186 5.76832L20.8693 5.71176L20.7161 5.67161L20.5603 5.64767L20.4031 5.63974L20.151 5.65984L19.9035 5.71953L19.6653 5.81789L19.4414 5.95398L19.237 6.1269L19.0569 6.33573L14.6545 12.3414L14.6042 12.3347L14.5312 12.3268L14.4481 12.3189L14.3675 12.3118L14.3021 12.3067L14.2646 12.3046L14.7397 11.7807L15.1056 11.1874L15.3585 10.5429L15.4944 9.86542L15.5097 9.17334L15.4003 8.48492L9.78209 9.47038L8.36503 9.71599L7.77427 9.8142L7.77007 9.81409L7.76597 9.8138L7.76191 9.81342L7.75781 9.81299L7.75371 9.81262L7.74956 9.81236L7.82303 10.2766L7.95085 10.7289L8.13195 11.1636L8.36519 11.5749L8.6496 11.9571L8.98404 12.3046L8.94638 12.3067L8.88091 12.3118L8.80027 12.3189L8.71708 12.3268L8.64407 12.3347L8.59382 12.3414L4.19142 6.33573L4.01141 6.12691L3.807 5.95399L3.58317 5.81789L3.3449 5.71953L3.09723 5.65983L2.84518 5.63974L2.68801 5.64768L2.53227 5.67161L2.37916 5.71176L2.2298 5.7683L2.08552 5.84148L1.94744 5.93149L1.64615 6.22599L1.44234 6.58212L1.33882 6.97842L1.33838 7.3934L1.44393 7.80561L1.65827 8.19355L6.17943 14.3582L6.21883 14.4088L6.26012 14.4567L6.30304 14.5024L6.34732 14.5459L6.39278 14.5878L6.43909 14.6282L6.42183 14.7797L6.40834 14.9318L6.39751 15.084L6.38817 15.2359L6.37932 15.3868L6.36975 15.5363L6.10788 19.3482L6.11357 19.7723L6.18879 20.1823L6.33232 20.5686L6.5428 20.9214L6.81908 21.2313L7.15979 21.4885L7.28598 21.5592L7.41374 21.619L7.54301 21.669L7.67369 21.7099L7.80592 21.7426L7.93951 21.7681L8.01823 21.7834L8.09804 21.796L8.17879 21.8058L8.26046 21.8129L8.34299 21.8172L8.42637 21.8186H14.8219L14.9056 21.8172L14.9882 21.8129L15.0698 21.8058L15.1504 21.7959L15.2301 21.7834L15.3088 21.7681L15.4425 21.7426L15.5748 21.7099L15.7056 21.669L15.8348 21.619L15.9624 21.5592L16.0885 21.4885L16.4292 21.2313L16.7055 20.9214L16.916 20.5686L17.0596 20.1823L17.1349 19.7723ZM13.2632 15.3054L15.0277 15.5617L15.1442 15.5928L15.2248 15.6444L15.2684 15.7125L15.2734 15.7932L15.2387 15.8824L15.1627 15.9759L13.8858 17.2207L13.7953 17.3292L13.7197 17.4602L13.6613 17.6057L13.6229 17.7577L13.6072 17.9081L13.6166 18.0488L13.9183 19.8066L13.9245 19.9269L13.9001 20.0195L13.8488 20.0819L13.7736 20.1116L13.6781 20.106L13.5657 20.0626L11.9871 19.2327L11.8561 19.1802L11.7082 19.1486L11.5517 19.1381L11.3953 19.1486L11.2474 19.1802L11.1166 19.2327L9.53803 20.0626L9.42554 20.106L9.33005 20.1116L9.255 20.0819L9.20364 20.0195L9.17945 19.9269L9.18579 19.8066L9.48713 18.0488L9.49654 17.9081L9.48075 17.7577L9.44241 17.6057L9.38402 17.4602L9.30834 17.3292L9.21788 17.2207L7.94098 15.9759L7.86502 15.8824L7.83024 15.7932L7.83526 15.7125L7.87872 15.6444L7.95928 15.5927L8.07561 15.5617L9.84047 15.3054L9.97736 15.2708L10.1155 15.2092L10.2483 15.1258L10.3687 15.0253L10.4698 14.9129L10.5449 14.7935L11.3342 13.1942L11.3997 13.0931L11.4736 13.0324L11.5519 13.0122L11.6301 13.0324L11.704 13.0931L11.7695 13.1942L12.5588 14.7935L12.6339 14.9129L12.735 15.0254L12.8554 15.1258L12.9881 15.2092L13.1264 15.2707L13.2632 15.3054Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.1126 7.16745L7.77427 8.46132L7.103 4.65606L7.08534 4.53506L7.07847 4.43555L7.08193 4.35777L7.09514 4.30192L7.11773 4.26825L7.1491 4.25698H7.14947L7.18084 4.26429L7.21724 4.28627L7.25846 4.32305L7.3042 4.37473L7.35424 4.44144L7.40839 4.52328L9.24076 6.76985L9.46796 6.73038L10.3487 3.471L10.3804 3.35443L10.4203 3.25858L10.4675 3.18368L10.521 3.12992L10.5799 3.09752L10.6431 3.08668L10.698 3.09417L10.7545 3.11668L10.8123 3.15436L10.8705 3.20726L10.9287 3.27552L10.9864 3.35924L12.9291 6.11996L13.1563 6.08013L14.1097 3.34154L14.1349 3.23697L14.1618 3.15152L14.19 3.08515L14.2191 3.03781L14.2486 3.00943L14.2783 3L14.3088 3.01005L14.3386 3.04021L14.3672 3.0905L14.3941 3.16091L14.4191 3.25148L14.4417 3.36219L15.1126 7.16745Z",
                fill: "white"
            })
        ]
    });
}
function $fdd862b2a5201b09$export$5a540ecc9c1f0346() {
    const classes = $fdd862b2a5201b09$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8DzwJ.default), {
        className: classes.CustomIcon,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                "clip-path": "url(#clip0_317:5)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M11.2904 17.2726L11.3328 17.311L11.3762 17.3485L11.4203 17.3852L11.465 17.4214L11.5101 17.457L11.5554 17.4923H4.80191L4.84027 17.0895L4.90201 16.7037L4.98714 16.335L5.09561 15.9833L5.22747 15.6486L5.38276 15.331L5.56563 15.0243L5.77952 14.7221L6.02453 14.4246L6.30055 14.1315L6.6076 13.8431L6.94568 13.5593L7.06553 13.4673L7.20457 13.3645L7.3627 13.2509L7.53997 13.1265L7.73636 12.9912L7.95187 12.8452L8.16659 12.6994L8.36061 12.5653L8.53395 12.4428L8.68651 12.3319L8.81834 12.2327L8.92937 12.145L9.0932 12.0029L9.24251 11.8601L9.37734 11.7167L9.49762 11.5727L9.60342 11.428L9.69466 11.2828L9.77174 11.1365L9.83493 10.9888L9.88417 10.8398L9.9194 10.6894L9.94058 10.5378L9.94764 10.3847L9.93839 10.1693L9.91061 9.97073L9.86439 9.78912L9.79966 9.6244L9.71655 9.47653L9.61497 9.34551L9.49685 9.23301L9.36345 9.14096L9.21479 9.06937L9.05085 9.01823L8.87171 8.98755L8.67731 8.97732L8.46032 8.99066L8.26177 9.03067L8.08177 9.09738L7.92025 9.19075L7.77731 9.31081L7.6529 9.45754L7.54685 9.63051L7.46013 9.82975L7.39276 10.0553L7.3446 10.3071L7.31574 10.5851L7.30612 10.8895L4.91052 10.8825L4.94336 10.3108L5.03259 9.77917L5.17823 9.2877L5.3802 8.83633L5.63852 8.42503L5.95314 8.05378L6.31493 7.73174L6.71459 7.46828L7.15211 7.26339L7.6274 7.11705L8.14052 7.02926L8.69143 7L9.14523 7.01735L9.5745 7.06928L9.97937 7.1556L10.3598 7.27614L10.716 7.4307L11.0479 7.61911L10.7963 7.97106L10.5874 8.35254L10.4215 8.76337L10.299 9.20333L10.2206 9.67219L10.1865 10.1698L10.1653 11.1001L12.4129 11.107L12.3835 11.2265L12.3499 11.3441L12.3122 11.4598L12.2703 11.5736L12.2241 11.6853L12.1736 11.7951L12.0544 12.0163L11.9108 12.2409L11.743 12.4687L11.5509 12.6998L11.3346 12.9342L11.0941 13.1717H10.0164L10.0241 14.021L9.8503 14.1444L9.79018 14.1868L9.72865 14.23L9.66552 14.274L9.35209 14.4966L9.07066 14.7077L8.82133 14.9071L8.60405 15.095L8.41896 15.2712L8.26609 15.4357H10.1999L10.3126 15.7913L10.4528 16.1275L10.6207 16.444L10.8162 16.7405L11.0394 17.0168L11.2904 17.2726Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5.10178 11.7953V14.1096L5.00285 14.2387L4.90867 14.3687L4.8193 14.4995L4.73474 14.6312L4.6551 14.7637L4.58036 14.897L4.39612 15.273L4.23947 15.6686L4.11059 16.0831L4.00958 16.5159L3.93671 16.9663L3.89203 17.4335L3.8877 17.4923H2.45025V10.6013H0V8.93064H0.215629L0.653833 8.91785L1.05293 8.87948L1.41292 8.81552L1.73369 8.72595L2.01521 8.61079L2.25739 8.47001L2.46425 8.30145L2.63873 8.10226L2.78098 7.87248L2.89101 7.61215L2.96897 7.32131L3.01494 7H5.10178V7.64233L4.77111 8.08447L4.49839 8.56597L4.28424 9.0863L4.12909 9.6449L4.03357 10.2412L3.99814 10.8747L3.99039 11.7919L5.10178 11.7953Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M17.8305 13.4689V15.2085L17.8377 15.354L17.8586 15.4954L17.8927 15.6322L17.9391 15.7637L17.9973 15.8893L18.0664 16.0084L17.9875 16.1189L17.9033 16.2262L17.8135 16.3302L17.7178 16.4307L17.6161 16.5277L17.5081 16.6209L17.1334 16.8872L16.7165 17.1051L16.2573 17.2745L15.7558 17.3955L15.2122 17.4681L14.6264 17.4923L14.063 17.4676L13.544 17.3935L13.0692 17.2701L12.6387 17.0972L12.2524 16.8749L11.9102 16.6031L11.6169 16.2863L11.376 15.9283L11.1874 15.5291L11.0513 15.0886L10.9678 14.6069L10.9368 14.0839H13.3262L13.3404 14.3157L13.3739 14.5282L13.4267 14.7217L13.4985 14.896L13.5894 15.0512L13.6994 15.1873L13.8277 15.3032L13.974 15.398L14.1382 15.4718L14.3204 15.5245L14.5205 15.5561L14.7386 15.5667L14.934 15.5567L15.1163 15.5268L15.2856 15.477L15.442 15.4073L15.5855 15.3177L15.7163 15.2083L15.8299 15.0826L15.9228 14.9444L15.9952 14.7936L16.0468 14.6304L16.0778 14.4547L16.0882 14.2665L16.0758 14.0511L16.0387 13.8544L15.9768 13.6764L15.8901 13.5171L15.7785 13.3765L15.6421 13.2546L15.4806 13.1515L15.2934 13.0672L15.0807 13.0016L14.8424 12.9548L14.5785 12.9268L14.2889 12.9174H14.0785V11.2306H14.2466L14.5096 11.2219L14.7496 11.1959L14.9667 11.1524L15.1609 11.0916L15.3322 11.0135L15.4807 10.918L15.6062 10.805L15.7089 10.6748L15.7889 10.5272L15.8461 10.3622L15.8804 10.1798L15.8919 9.9801L15.8834 9.80829L15.8579 9.64896L15.8154 9.50214L15.7559 9.36781L15.6794 9.24601L15.5859 9.13671L15.4779 9.04208L15.3576 8.9647L15.225 8.90454L15.0801 8.8616L14.923 8.83585L14.7536 8.82727L14.551 8.83664L14.3648 8.86475L14.1953 8.9116L14.0423 8.97718L13.906 9.06148L13.7864 9.16449L13.6832 9.28686L13.5958 9.42919L13.5241 9.59148L13.4681 9.77369L13.428 9.9758L13.4039 10.1978L11.0986 10.1905L11.1362 9.70138L11.2256 9.25071L11.3667 8.83848L11.5596 8.4647L11.8042 8.12936L12.1005 7.83246L12.4443 7.57804L12.8311 7.36992L13.2609 7.20806L13.7339 7.09246L14.25 7.02311L14.8092 7L15.3166 7.0205L15.7886 7.08198L16.2255 7.18446L16.6272 7.32795L16.9938 7.51245L17.3255 7.73797L17.5228 7.90808L17.6965 8.09048L17.8468 8.28507L17.9738 8.49176L18.0779 8.71048L18.1591 8.94112L17.9966 9.10356L16.2678 10.8326L16.0734 11.0702L15.9327 11.3359L15.8472 11.6213L15.8186 11.9183L15.8484 12.2186L15.9381 12.5141L16.0835 12.7862L16.2746 13.0194L16.5044 13.209L16.7659 13.3502L17.0522 13.4384L17.3562 13.4689H17.8305Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M23.9672 11.7272L24 11.9226L23.9693 12.1103L23.8841 12.278L23.7532 12.4132L23.5857 12.5034L23.3904 12.5362H21.9876V15.2085L21.9679 15.3547L21.9121 15.4864L21.8257 15.5982L21.7139 15.6847L21.5821 15.7406L21.4354 15.7604H19.3156L19.1691 15.7406L19.0372 15.6847L18.9254 15.5982L18.8388 15.4864L18.7829 15.3547L18.7632 15.2085V12.5362H17.3562L17.1131 12.4852L16.9239 12.3499L16.7996 12.1566L16.751 11.9318L16.7894 11.702L16.9256 11.4936L16.9731 11.4463L17.115 11.3041L17.1622 11.2568L19.8475 8.57179L19.9258 8.49871L20.008 8.43343L20.0945 8.37839L20.1854 8.33605L20.2811 8.30885L20.3819 8.29924L20.413 8.30016L20.4445 8.30292L20.4764 8.30755L20.5087 8.31408L20.5415 8.32254L20.5749 8.33294L20.6552 8.36892L20.7284 8.41579L20.7962 8.47075L20.8603 8.53098L20.9222 8.59368L20.9837 8.65604L23.7397 11.4128L23.7859 11.4595L23.8302 11.5068L23.8716 11.556L23.9088 11.6083L23.9411 11.665L23.9672 11.7272Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_317:5",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "24",
                        height: "10.4923",
                        fill: "white",
                        transform: "translate(0 7)"
                    })
                })
            })
        ]
    });
}
function $fdd862b2a5201b09$export$1275ec47d57fe997() {
    const classes = $fdd862b2a5201b09$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8DzwJ.default), {
        className: classes.BigIcon,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                "clip-path": "url(#clip0_107_4)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M2.4344 15.6697L2.5719 15.7313L2.65699 15.7707L2.74408 15.8029L2.83273 15.828L2.92253 15.8459L3.01316 15.8566L3.1041 15.8602L3.13373 15.8598L3.16328 15.8586L3.1928 15.8567L3.22231 15.854L3.25188 15.8505L3.28151 15.8462L3.59342 16.3455L3.98811 16.7787L4.45464 17.1348L4.98186 17.4027L5.5589 17.5716L6.17463 17.6303L6.6256 17.5979L7.06474 17.5025L7.48579 17.3469L7.88246 17.134L8.24854 16.8665L8.57775 16.5472L8.61761 16.5018L8.70606 16.5305L8.81643 16.5541L8.93177 16.5726L9.0351 16.5858L9.10954 16.5937L9.13809 16.5964L9.46493 16.581L9.79489 16.5685L10.1276 16.5588L10.4623 16.5519L10.7988 16.5478L11.1364 16.5464L11.7832 16.5512L12.4459 16.5658L13.1265 16.5903L13.8271 16.6249L14.55 16.6696L15.2971 16.7246L15.3123 16.7256L15.3276 16.7264L15.3428 16.727L15.3581 16.7274L15.3733 16.7276L15.3885 16.7277L15.4756 16.7244L15.5616 16.7148L15.6462 16.6989L15.7292 16.6767L15.8101 16.6486L15.8887 16.6144L16.2043 16.9067L16.5566 17.1556L16.9412 17.3568L17.3538 17.5059L17.7901 17.5985L18.2457 17.6303L18.2762 17.6302L18.3069 17.6298L18.3376 17.6291L18.3684 17.628L18.3993 17.6266L18.4302 17.6249L18.8647 17.5691L19.285 17.4548L19.6854 17.2847L20.0604 17.0619L20.4045 16.7893L20.7121 16.4698L20.8102 16.4956L20.9477 16.5151L21.0991 16.5289L21.2388 16.5378L21.3413 16.5426L21.3811 16.544L21.6665 16.5158L21.9845 16.4668L22.3227 16.3804L22.6687 16.2399L23.01 16.0286L23.3341 15.7297L23.5695 15.3241L23.7708 14.7257L23.9203 14.0331L24 13.3449L23.9921 12.7597L23.8788 12.3763L23.8421 12.326L23.8042 12.2789L23.7651 12.235L23.7249 12.1941L23.6839 12.1561L23.642 12.1207L23.6524 12.084L23.6784 11.9879L23.7118 11.8535L23.7447 11.7018L23.7689 11.5541L23.7764 11.4314L23.6827 11.0434L23.4696 10.7117L23.198 10.4428L22.9286 10.243L22.7224 10.1185L22.6401 10.0755L21.7646 9.69989L20.8626 9.40208L19.9328 9.16802L18.9736 8.98358L17.9838 8.83465L16.9617 8.70713L16.8415 8.60957L16.5573 8.38386L16.1661 8.0789L15.7249 7.7435L15.2907 7.42657L14.9204 7.17694L14.596 6.98032L14.2385 6.77984L13.8502 6.58525L13.4331 6.4062L12.9897 6.25244L12.522 6.13364L12.297 6.09253L12.0653 6.05905L11.8264 6.03312L11.5792 6.01468L11.3232 6.00366L11.0575 6L10.7492 6.0046L10.4442 6.01733L10.1451 6.03654L9.85424 6.06055L9.57429 6.08774L9.30767 6.11644L8.73994 6.18997L8.19474 6.28182L7.67043 6.39241L7.16536 6.52207L6.67801 6.67119L6.20667 6.84012L5.87236 6.97644L5.54571 7.12215L5.22588 7.27502L4.91204 7.43284L4.60337 7.5934L4.29902 7.75447L4.22092 7.79555L4.06506 7.87776L3.98723 7.91871L3.90944 7.95944L3.83168 7.99987L3.69336 8.05728L3.53667 8.09816L3.36327 8.12588L3.17481 8.14383L2.97301 8.15541L2.75946 8.16398L2.67486 8.16714L2.58997 8.17045L2.50489 8.17414L2.41965 8.17834L2.33437 8.18323L2.24914 8.18899L1.63412 8.3614L1.19348 8.72324L0.896945 9.19732L0.714073 9.70644L0.614602 10.1734L0.568127 10.521L0.561094 10.5839L0.55301 10.6701L0.54478 10.7661L0.530811 10.9339L0.526708 10.979L0.418421 11.111L0.297288 11.3031L0.179232 11.547L0.0800789 11.8343L0.0158491 12.1568L0.00231934 12.506L0.0154584 12.799L0.0397094 13.1173L0.0849633 13.4516L0.161062 13.793L0.277921 14.1323L0.445431 14.4606L0.703059 14.7172L1.12488 14.998L1.61681 15.2715L2.08468 15.5059L2.4344 15.6697ZM10.7829 7.16462L11.0574 7.16053L11.2669 7.16316L11.4754 7.17141L11.6825 7.18583L11.8875 7.20696L12.0902 7.23534L12.2899 7.27151L12.6465 7.36159L12.9951 7.4816L13.3353 7.6266L13.6671 7.79158L13.9903 7.97159L14.3046 8.16164L14.6139 8.3612L14.9176 8.56949L15.2158 8.78586L15.5085 9.00965L15.7958 9.24022L16.0778 9.47691L16.2037 9.58693L16.3072 9.67613L16.4027 9.74662L16.5046 9.80051L16.6273 9.83989L16.7851 9.86688L17.6891 9.9767L18.6026 10.107L19.5145 10.2721L20.4136 10.4861L21.2888 10.7634L22.129 11.1181L22.1977 11.1681L22.2876 11.253L22.3838 11.353L22.471 11.4487L22.5344 11.5204L22.5588 11.5487L22.3791 12.8444L22.9222 13.0351L22.9089 13.1546L22.8696 13.4602L22.805 13.8725L22.7159 14.3121L22.6031 14.6998L22.4674 14.956L22.2836 15.12L22.0801 15.2326L21.8612 15.3053L21.6316 15.3495L21.3959 15.3767L21.1584 15.3984L21.3246 14.406L21.1674 13.4548L20.7336 12.6067L20.0698 11.924L19.2226 11.4688L18.2387 11.3033L18.2206 11.3033L18.2023 11.3035L18.1839 11.3039L18.1654 11.3043L18.1469 11.3049L18.1285 11.3056L17.1368 11.5118L16.3004 12.0096L15.6633 12.7316L15.2696 13.6101L15.1634 14.5778L15.3885 15.5672L14.6784 15.5146L13.9693 15.4699L13.261 15.4339L12.553 15.4073L11.8449 15.3907L11.1364 15.3851L10.794 15.3864L10.4515 15.3906L10.1088 15.3977L9.76592 15.4076L9.42281 15.4206L9.07946 15.4366L9.25701 14.5042L9.1446 13.5946L8.778 12.7646L8.19295 12.071L7.42527 11.5707L6.51066 11.3205L6.45601 11.3151L6.4015 11.3108L6.34713 11.3075L6.29289 11.3051L6.23877 11.3037L6.18478 11.3033L5.32576 11.4289L4.55437 11.7807L3.90855 12.3212L3.42624 13.0127L3.14546 13.8178L3.10409 14.6989L2.85023 14.5763L2.51723 14.4234L2.1572 14.2573L1.82206 14.0952L1.56395 13.9546L1.4348 13.8525L1.32268 13.6175L1.24846 13.3559L1.20338 13.0785L1.17852 12.7961L1.16509 12.5196L1.15424 12.2598L1.17085 12.081L1.23029 11.9442L1.31748 11.8329L1.41734 11.7304L1.51488 11.6198L1.59501 11.4846L1.63802 11.358L1.6661 11.2225L1.68381 11.0819L1.69556 10.9401L1.70591 10.8011L1.71927 10.6687L1.74674 10.4355L1.78694 10.1578L1.85281 9.87284L1.95714 9.6179L2.11285 9.43026L2.33275 9.34718L2.68423 9.32851L3.03324 9.31478L3.37791 9.29208L3.71623 9.24645L4.04634 9.16396L4.36622 9.03067L4.73665 8.83602L5.10787 8.63954L5.48113 8.44562L5.85757 8.25865L6.23838 8.08308L6.62476 7.92328L7.07884 7.76183L7.54071 7.62346L8.0088 7.50664L8.48157 7.4098L8.9575 7.33142L9.43505 7.26994L9.69785 7.24175L9.96505 7.21587L10.2357 7.19355L10.5087 7.17605L10.7829 7.16462ZM18.2457 16.4698L18.8318 16.3493L19.3587 16.0779L19.7973 15.6841L20.1186 15.1963L20.2936 14.643L20.2932 14.0526L20.1538 13.5768L19.9102 13.1573L19.5795 12.8075L19.1789 12.5409L18.7255 12.371L18.2363 12.3114L17.705 12.4101L17.2151 12.6343L16.7913 12.9643L16.4582 13.3801L16.2403 13.862L16.1622 14.3902L16.2384 14.9396L16.4523 15.4354L16.782 15.857L17.2054 16.1837L17.7006 16.3948L18.2457 16.4698ZM6.15242 12.3115L6.17071 12.3114L6.67849 12.3758L7.1461 12.5587L7.55495 12.8445L7.88625 13.2176L8.12139 13.6625L8.24169 14.1636L8.21881 14.7553L8.03501 15.3002L7.71457 15.7712L7.28152 16.1412L6.76018 16.3831L6.17462 16.4698L5.62852 16.3943L5.13375 16.1821L4.71174 15.8544L4.3838 15.4323L4.17138 14.9372L4.09582 14.3902L4.16579 13.8622L4.36341 13.3809L4.67032 12.9657L5.06786 12.6364L5.53772 12.4125L6.0613 12.3138L6.07959 12.313L6.09778 12.3124L6.116 12.312L6.13417 12.3117L6.15242 12.3115Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_107_4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "24",
                        height: "11.6303",
                        fill: "white",
                        transform: "translate(0 6)"
                    })
                })
            })
        ]
    });
}



var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");
var $ca4ada9c808bb355$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $8nd05.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create("box-shadow")
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $ca4ada9c808bb355$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? "elevation" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, variant === "outlined" ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
var $ca4ada9c808bb355$export$2e2bcd8739ae039 = (0, $kQaj4.default)($ca4ada9c808bb355$export$9dd6ff9ea0189349, {
    name: "MuiPaper"
})($ca4ada9c808bb355$var$Paper);


var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $f9tk6 = parcelRequire("f9tk6");
var $f763543f732472dc$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: "absolute",
            height: 1,
            width: 1,
            overflow: "hidden"
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: "left"
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: "center"
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: "right"
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: "justify"
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: "0.35em"
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: "inline"
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: "block"
        }
    };
};
var $f763543f732472dc$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p"
};
var $f763543f732472dc$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "initial" : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? "initial" : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? "body1" : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $f763543f732472dc$var$defaultVariantMapping : _props$variantMapping, other = (0, $9X7IJ.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? "p" : variantMapping[variant] || $f763543f732472dc$var$defaultVariantMapping[variant]) || "span";
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, variant !== "inherit" && classes[variant], color !== "initial" && classes["color".concat((0, $f9tk6.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== "inherit" && classes["align".concat((0, $f9tk6.default)(align))], display !== "initial" && classes["display".concat((0, $f9tk6.default)(display))]),
        ref: ref
    }, other));
});
var $f763543f732472dc$export$2e2bcd8739ae039 = (0, $kQaj4.default)($f763543f732472dc$export$9dd6ff9ea0189349, {
    name: "MuiTypography"
})($f763543f732472dc$var$Typography);


const $123e4e14bb8cd798$var$AMAX_API_URL = "https://amax-emu.com/api";
const $123e4e14bb8cd798$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            flexGrow: 1,
            alignItems: "flex-end",
            // minWidth: 400,
            width: "100%"
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "50%",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        }
    }));
function $123e4e14bb8cd798$export$2e2bcd8739ae039() {
    const classes = $123e4e14bb8cd798$var$useStyles();
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    let [session_data, setData] = $acw62.useState(undefined);
    let [dataRequested, setRequestStatus] = $acw62.useState(false);
    const RenderSessions = ()=>{
        if (dataRequested) {
            if (session_data.data.length > 0) return session_data.data.map((session_data)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e01dc1b8dd3a027a$export$2e2bcd8739ae039), {
                    data: session_data
                }, session_data.sessionId));
            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ca4ada9c808bb355$export$2e2bcd8739ae039), {
                style: {
                    "display": "grid",
                    "justifyItems": "center",
                    "marginTop": "15px",
                    "backgroundColor": "#304254"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$1275ec47d57fe997), {
                        sx: {
                            fontSize: 40
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            children: "No sessions!"
                        })
                    })
                ]
            });
        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: classes.spinner,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a36c7122d0aec5cd$export$2e2bcd8739ae039), {})
        });
    };
    // Lucas:
    // Functions passed to useEffect cannot be async.
    $acw62.useEffect(()=>{
        async function getSessionsData() {
            const resp = await fetch($123e4e14bb8cd798$var$AMAX_API_URL + "/sessions", {
                method: "GET",
                headers: {
                    "content-type": "application/json;charset=UTF-8"
                }
            });
            setData(await resp.json());
            setRequestStatus(true);
        }
        getSessionsData().catch(()=>{});
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                className: "session_item_name",
                children: t("sessions_widget_header")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RenderSessions, {})
        ]
    });
}





var $acw62 = parcelRequire("acw62");

var $gkNc2 = parcelRequire("gkNc2");
parcelRequire("acw62");

var $kpDC5 = parcelRequire("kpDC5");
function $8d81b008787777c3$export$2e2bcd8739ae039() {
    var theme = (0, $gkNc2.default)() || (0, $kpDC5.default);
    return theme;
}



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $f9tk6 = parcelRequire("f9tk6");

var $968e2cc4493acf64$export$9dd6ff9ea0189349 = function styles(theme) {
    var backgroundColorDefault = theme.palette.type === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return {
        /* Styles applied to the root element. */ root: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            boxSizing: "border-box",
            // Prevent padding issue with the Modal and fixed positioned AppBar.
            zIndex: theme.zIndex.appBar,
            flexShrink: 0
        },
        /* Styles applied to the root element if `position="fixed"`. */ positionFixed: {
            position: "fixed",
            top: 0,
            left: "auto",
            right: 0,
            "@media print": {
                // Prevent the app bar to be visible on each printed page.
                position: "absolute"
            }
        },
        /* Styles applied to the root element if `position="absolute"`. */ positionAbsolute: {
            position: "absolute",
            top: 0,
            left: "auto",
            right: 0
        },
        /* Styles applied to the root element if `position="sticky"`. */ positionSticky: {
            // ⚠️ sticky is not supported by IE 11.
            position: "sticky",
            top: 0,
            left: "auto",
            right: 0
        },
        /* Styles applied to the root element if `position="static"`. */ positionStatic: {
            position: "static"
        },
        /* Styles applied to the root element if `position="relative"`. */ positionRelative: {
            position: "relative"
        },
        /* Styles applied to the root element if `color="default"`. */ colorDefault: {
            backgroundColor: backgroundColorDefault,
            color: theme.palette.getContrastText(backgroundColorDefault)
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="transparent"`. */ colorTransparent: {
            backgroundColor: "transparent",
            color: "inherit"
        }
    };
};
var $968e2cc4493acf64$var$AppBar = /*#__PURE__*/ $acw62.forwardRef(function AppBar(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$position = props.position, position = _props$position === void 0 ? "fixed" : _props$position, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "color",
        "position"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $ca4ada9c808bb355$export$2e2bcd8739ae039), (0, $8nd05.default)({
        square: true,
        component: "header",
        elevation: 4,
        className: (0, $1SA7b.default)(classes.root, classes["position".concat((0, $f9tk6.default)(position))], classes["color".concat((0, $f9tk6.default)(color))], className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $968e2cc4493acf64$export$2e2bcd8739ae039 = (0, $kQaj4.default)($968e2cc4493acf64$export$9dd6ff9ea0189349, {
    name: "MuiAppBar"
})($968e2cc4493acf64$var$AppBar);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));




var $1SA7b = parcelRequire("1SA7b");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $3308074b7cd66a5b$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}


function $837f0f05a75630be$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $9eefbb746c8fa92f$export$2e2bcd8739ae039(node) {
    var doc = (0, $837f0f05a75630be$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Source from https://github.com/alitaheri/normalize-scroll-left
var $9f0b23415b672dbc$var$cachedType;
function $9f0b23415b672dbc$export$a10970ffb6510128() {
    if ($9f0b23415b672dbc$var$cachedType) return $9f0b23415b672dbc$var$cachedType;
    var dummy = document.createElement("div");
    var container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    $9f0b23415b672dbc$var$cachedType = "reverse";
    if (dummy.scrollLeft > 0) $9f0b23415b672dbc$var$cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $9f0b23415b672dbc$var$cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return $9f0b23415b672dbc$var$cachedType;
} // Based on https://stackoverflow.com/a/24394376
function $9f0b23415b672dbc$export$3c615b88e5d7e4f6(element, direction) {
    var scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== "rtl") return scrollLeft;
    var type = $9f0b23415b672dbc$export$a10970ffb6510128();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $3ca2ff0b71a1ebf6$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $3ca2ff0b71a1ebf6$export$2e2bcd8739ae039(property, element, to) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function() {};
    var _options$ease = options.ease, ease = _options$ease === void 0 ? $3ca2ff0b71a1ebf6$var$easeInOutSin : _options$ease, _options$duration = options.duration, duration = _options$duration === void 0 ? 300 : _options$duration;
    var start = null;
    var from = element[property];
    var cancelled = false;
    var cancel = function cancel() {
        cancelled = true;
    };
    var step = function step(timestamp) {
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        var time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(function() {
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $22232ad7ebb1b79f$var$styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function $22232ad7ebb1b79f$export$2e2bcd8739ae039(props) {
    var onChange = props.onChange, other = (0, $9X7IJ.default)(props, [
        "onChange"
    ]);
    var scrollbarHeight = $acw62.useRef();
    var nodeRef = $acw62.useRef(null);
    var setMeasurements = function setMeasurements() {
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    $acw62.useEffect(function() {
        var handleResize = (0, $3308074b7cd66a5b$export$2e2bcd8739ae039)(function() {
            var prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(function() {
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        style: $22232ad7ebb1b79f$var$styles,
        ref: nodeRef
    }, other));
}



var $kQaj4 = parcelRequire("kQaj4");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $f9tk6 = parcelRequire("f9tk6");
var $70d4af6838e745c8$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        root: {
            position: "absolute",
            height: 2,
            bottom: 0,
            width: "100%",
            transition: theme.transitions.create()
        },
        colorPrimary: {
            backgroundColor: theme.palette.primary.main
        },
        colorSecondary: {
            backgroundColor: theme.palette.secondary.main
        },
        vertical: {
            height: "100%",
            width: 2,
            right: 0
        }
    };
};
/**
 * @ignore - internal component.
 */ var $70d4af6838e745c8$var$TabIndicator = /*#__PURE__*/ $acw62.forwardRef(function TabIndicator(props, ref) {
    var classes = props.classes, className = props.className, color = props.color, orientation = props.orientation, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "color",
        "orientation"
    ]);
    return /*#__PURE__*/ $acw62.createElement("span", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes["color".concat((0, $f9tk6.default)(color))], className, orientation === "vertical" && classes.vertical),
        ref: ref
    }, other));
});
var $70d4af6838e745c8$export$2e2bcd8739ae039 = (0, $kQaj4.default)($70d4af6838e745c8$export$9dd6ff9ea0189349, {
    name: "PrivateTabIndicator"
})($70d4af6838e745c8$var$TabIndicator);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $c412fe06a5b1fa44$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");



var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $929f740b24f30705$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");



var $kQaj4 = parcelRequire("kQaj4");

var $5feb98201800c91f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        "&$disabled": {
            opacity: 0
        }
    },
    /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
        width: "100%",
        height: 40,
        "& svg": {
            transform: "rotate(90deg)"
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {}
};
var $5feb98201800c91f$var$_ref = /*#__PURE__*/ $acw62.createElement((0, $c412fe06a5b1fa44$export$2e2bcd8739ae039), {
    fontSize: "small"
});
var $5feb98201800c91f$var$_ref2 = /*#__PURE__*/ $acw62.createElement((0, $929f740b24f30705$export$2e2bcd8739ae039), {
    fontSize: "small"
});
var $5feb98201800c91f$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(props, ref) {
    var classes = props.classes, classNameProp = props.className, direction = props.direction, orientation = props.orientation, disabled = props.disabled, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "direction",
        "orientation",
        "disabled"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $ac65ba7da5d490c4$export$2e2bcd8739ae039), (0, $8nd05.default)({
        component: "div",
        className: (0, $1SA7b.default)(classes.root, classNameProp, disabled && classes.disabled, orientation === "vertical" && classes.vertical),
        ref: ref,
        role: null,
        tabIndex: null
    }, other), direction === "left" ? $5feb98201800c91f$var$_ref : $5feb98201800c91f$var$_ref2);
});
var $5feb98201800c91f$export$2e2bcd8739ae039 = (0, $kQaj4.default)($5feb98201800c91f$export$9dd6ff9ea0189349, {
    name: "MuiTabScrollButton"
})($5feb98201800c91f$var$TabScrollButton);




var $6e5c13c2d64ec58c$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: "hidden",
            minHeight: 48,
            WebkitOverflowScrolling: "touch",
            // Add iOS momentum scrolling.
            display: "flex"
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            flexDirection: "column"
        },
        /* Styles applied to the flex container element. */ flexContainer: {
            display: "flex"
        },
        /* Styles applied to the flex container element if `orientation="vertical"`. */ flexContainerVertical: {
            flexDirection: "column"
        },
        /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */ centered: {
            justifyContent: "center"
        },
        /* Styles applied to the tablist element. */ scroller: {
            position: "relative",
            display: "inline-block",
            flex: "1 1 auto",
            whiteSpace: "nowrap"
        },
        /* Styles applied to the tablist element if `!variant="scrollable"`. */ fixed: {
            overflowX: "hidden",
            width: "100%"
        },
        /* Styles applied to the tablist element if `variant="scrollable"`. */ scrollable: {
            overflowX: "scroll",
            // Hide dimensionless scrollbar on MacOS
            scrollbarWidth: "none",
            // Firefox
            "&::-webkit-scrollbar": {
                display: "none" // Safari + Chrome
            }
        },
        /* Styles applied to the `ScrollButtonComponent` component. */ scrollButtons: {},
        /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */ scrollButtonsDesktop: (0, $kSlfw.default)({}, theme.breakpoints.down("xs"), {
            display: "none"
        }),
        /* Styles applied to the `TabIndicator` component. */ indicator: {}
    };
};
var $6e5c13c2d64ec58c$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(props, ref) {
    var ariaLabel = props["aria-label"], ariaLabelledBy = props["aria-labelledby"], action = props.action, _props$centered = props.centered, centered = _props$centered === void 0 ? false : _props$centered, childrenProp = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$indicatorColor = props.indicatorColor, indicatorColor = _props$indicatorColor === void 0 ? "secondary" : _props$indicatorColor, onChange = props.onChange, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, _props$ScrollButtonCo = props.ScrollButtonComponent, ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? (0, $5feb98201800c91f$export$2e2bcd8739ae039) : _props$ScrollButtonCo, _props$scrollButtons = props.scrollButtons, scrollButtons = _props$scrollButtons === void 0 ? "auto" : _props$scrollButtons, selectionFollowsFocus = props.selectionFollowsFocus, _props$TabIndicatorPr = props.TabIndicatorProps, TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr, TabScrollButtonProps = props.TabScrollButtonProps, _props$textColor = props.textColor, textColor = _props$textColor === void 0 ? "inherit" : _props$textColor, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "aria-label",
        "aria-labelledby",
        "action",
        "centered",
        "children",
        "classes",
        "className",
        "component",
        "indicatorColor",
        "onChange",
        "orientation",
        "ScrollButtonComponent",
        "scrollButtons",
        "selectionFollowsFocus",
        "TabIndicatorProps",
        "TabScrollButtonProps",
        "textColor",
        "value",
        "variant"
    ]);
    var theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    var scrollable = variant === "scrollable";
    var isRtl = theme.direction === "rtl";
    var vertical = orientation === "vertical";
    var scrollStart = vertical ? "scrollTop" : "scrollLeft";
    var start = vertical ? "top" : "left";
    var end = vertical ? "bottom" : "right";
    var clientSize = vertical ? "clientHeight" : "clientWidth";
    var size = vertical ? "height" : "width";
    var _React$useState = $acw62.useState(false), mounted = _React$useState[0], setMounted = _React$useState[1];
    var _React$useState2 = $acw62.useState({}), indicatorStyle = _React$useState2[0], setIndicatorStyle = _React$useState2[1];
    var _React$useState3 = $acw62.useState({
        start: false,
        end: false
    }), displayScroll = _React$useState3[0], setDisplayScroll = _React$useState3[1];
    var _React$useState4 = $acw62.useState({
        overflow: "hidden",
        marginBottom: null
    }), scrollerStyle = _React$useState4[0], setScrollerStyle = _React$useState4[1];
    var valueToIndex = new Map();
    var tabsRef = $acw62.useRef(null);
    var tabListRef = $acw62.useRef(null);
    var getTabsMeta = function getTabsMeta() {
        var tabsNode = tabsRef.current;
        var tabsMeta;
        if (tabsNode) {
            var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $9f0b23415b672dbc$export$3c615b88e5d7e4f6)(tabsNode, theme.direction),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        var tabMeta;
        if (tabsNode && value !== false) {
            var _children = tabListRef.current.children;
            if (_children.length > 0) {
                var tab = _children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    var updateIndicatorState = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function() {
        var _newIndicatorStyle;
        var _getTabsMeta = getTabsMeta(), tabsMeta = _getTabsMeta.tabsMeta, tabMeta = _getTabsMeta.tabMeta;
        var startValue = 0;
        if (tabMeta && tabsMeta) {
            if (vertical) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
            else {
                var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = tabMeta.left - tabsMeta.left + correction;
            }
        }
        var newIndicatorStyle = (_newIndicatorStyle = {}, (0, $kSlfw.default)(_newIndicatorStyle, start, startValue), (0, $kSlfw.default)(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);
        if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
            var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    var scroll = function scroll(scrollValue) {
        (0, $3ca2ff0b71a1ebf6$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue);
    };
    var moveTabsScroll = function moveTabsScroll(delta) {
        var scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge
            scrollValue *= isRtl && (0, $9f0b23415b672dbc$export$a10970ffb6510128)() === "reverse" ? -1 : 1;
        }
        scroll(scrollValue);
    };
    var handleStartScrollClick = function handleStartScrollClick() {
        moveTabsScroll(-tabsRef.current[clientSize]);
    };
    var handleEndScrollClick = function handleEndScrollClick() {
        moveTabsScroll(tabsRef.current[clientSize]);
    };
    var handleScrollbarSizeChange = $acw62.useCallback(function(scrollbarHeight) {
        setScrollerStyle({
            overflow: null,
            marginBottom: -scrollbarHeight
        });
    }, []);
    var getConditionalElements = function getConditionalElements() {
        var conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ $acw62.createElement((0, $22232ad7ebb1b79f$export$2e2bcd8739ae039), {
            className: classes.scrollable,
            onChange: handleScrollbarSizeChange
        }) : null;
        var scrollButtonsActive = displayScroll.start || displayScroll.end;
        var showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === "desktop" || scrollButtons === "on");
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ $acw62.createElement(ScrollButtonComponent, (0, $8nd05.default)({
            orientation: orientation,
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayScroll.start,
            className: (0, $1SA7b.default)(classes.scrollButtons, scrollButtons !== "on" && classes.scrollButtonsDesktop)
        }, TabScrollButtonProps)) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ $acw62.createElement(ScrollButtonComponent, (0, $8nd05.default)({
            orientation: orientation,
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayScroll.end,
            className: (0, $1SA7b.default)(classes.scrollButtons, scrollButtons !== "on" && classes.scrollButtonsDesktop)
        }, TabScrollButtonProps)) : null;
        return conditionalElements;
    };
    var scrollSelectedIntoView = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function() {
        var _getTabsMeta2 = getTabsMeta(), tabsMeta = _getTabsMeta2.tabsMeta, tabMeta = _getTabsMeta2.tabMeta;
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart);
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(_nextScrollStart);
        }
    });
    var updateScrollButtonState = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function() {
        if (scrollable && scrollButtons !== "off") {
            var _tabsRef$current = tabsRef.current, scrollTop = _tabsRef$current.scrollTop, scrollHeight = _tabsRef$current.scrollHeight, clientHeight = _tabsRef$current.clientHeight, scrollWidth = _tabsRef$current.scrollWidth, clientWidth = _tabsRef$current.clientWidth;
            var showStartScroll;
            var showEndScroll;
            if (vertical) {
                showStartScroll = scrollTop > 1;
                showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
            } else {
                var scrollLeft = (0, $9f0b23415b672dbc$export$3c615b88e5d7e4f6)(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.
                showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
                showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
            }
            if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) setDisplayScroll({
                start: showStartScroll,
                end: showEndScroll
            });
        }
    });
    $acw62.useEffect(function() {
        var handleResize = (0, $3308074b7cd66a5b$export$2e2bcd8739ae039)(function() {
            updateIndicatorState();
            updateScrollButtonState();
        });
        var win = (0, $9eefbb746c8fa92f$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    var handleTabsScroll = $acw62.useCallback((0, $3308074b7cd66a5b$export$2e2bcd8739ae039)(function() {
        updateScrollButtonState();
    }));
    $acw62.useEffect(function() {
        return function() {
            handleTabsScroll.clear();
        };
    }, [
        handleTabsScroll
    ]);
    $acw62.useEffect(function() {
        setMounted(true);
    }, []);
    $acw62.useEffect(function() {
        updateIndicatorState();
        updateScrollButtonState();
    });
    $acw62.useEffect(function() {
        scrollSelectedIntoView();
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, function() {
        return {
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    var indicator = /*#__PURE__*/ $acw62.createElement((0, $70d4af6838e745c8$export$2e2bcd8739ae039), (0, $8nd05.default)({
        className: classes.indicator,
        orientation: orientation,
        color: indicatorColor
    }, TabIndicatorProps, {
        style: (0, $8nd05.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    var childIndex = 0;
    var children = $acw62.Children.map(childrenProp, function(child) {
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        var childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        var selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        });
    });
    var handleKeyDown = function handleKeyDown(event) {
        var target = event.target; // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        var role = target.getAttribute("role");
        if (role !== "tab") return;
        var newFocusTarget = null;
        var previousItemKey = orientation !== "vertical" ? "ArrowLeft" : "ArrowUp";
        var nextItemKey = orientation !== "vertical" ? "ArrowRight" : "ArrowDown";
        if (orientation !== "vertical" && theme.direction === "rtl") {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                newFocusTarget = target.previousElementSibling || tabListRef.current.lastChild;
                break;
            case nextItemKey:
                newFocusTarget = target.nextElementSibling || tabListRef.current.firstChild;
                break;
            case "Home":
                newFocusTarget = tabListRef.current.firstChild;
                break;
            case "End":
                newFocusTarget = tabListRef.current.lastChild;
                break;
            default:
                break;
        }
        if (newFocusTarget !== null) {
            newFocusTarget.focus();
            event.preventDefault();
        }
    };
    var conditionalElements = getConditionalElements();
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, vertical && classes.vertical),
        ref: ref
    }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $1SA7b.default)(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
        style: scrollerStyle,
        ref: tabsRef,
        onScroll: handleTabsScroll
    }, /*#__PURE__*/ $acw62.createElement("div", {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        className: (0, $1SA7b.default)(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
        onKeyDown: handleKeyDown,
        ref: tabListRef,
        role: "tablist"
    }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
});
var $6e5c13c2d64ec58c$export$2e2bcd8739ae039 = (0, $kQaj4.default)($6e5c13c2d64ec58c$export$9dd6ff9ea0189349, {
    name: "MuiTabs"
})($6e5c13c2d64ec58c$var$Tabs);



var $9X7IJ = parcelRequire("9X7IJ");

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");


var $f9tk6 = parcelRequire("f9tk6");

var $e0edc8e5721a6e65$export$9dd6ff9ea0189349 = function styles(theme) {
    var _extends2;
    return {
        /* Styles applied to the root element. */ root: (0, $8nd05.default)({}, theme.typography.button, (_extends2 = {
            maxWidth: 264,
            minWidth: 72,
            position: "relative",
            boxSizing: "border-box",
            minHeight: 48,
            flexShrink: 0,
            padding: "6px 12px"
        }, (0, $kSlfw.default)(_extends2, theme.breakpoints.up("sm"), {
            padding: "6px 24px"
        }), (0, $kSlfw.default)(_extends2, "overflow", "hidden"), (0, $kSlfw.default)(_extends2, "whiteSpace", "normal"), (0, $kSlfw.default)(_extends2, "textAlign", "center"), (0, $kSlfw.default)(_extends2, theme.breakpoints.up("sm"), {
            minWidth: 160
        }), _extends2)),
        /* Styles applied to the root element if both `icon` and `label` are provided. */ labelIcon: {
            minHeight: 72,
            paddingTop: 9,
            "& $wrapper > *:first-child": {
                marginBottom: 6
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */ textColorInherit: {
            color: "inherit",
            opacity: 0.7,
            "&$selected": {
                opacity: 1
            },
            "&$disabled": {
                opacity: 0.5
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */ textColorPrimary: {
            color: theme.palette.text.secondary,
            "&$selected": {
                color: theme.palette.primary.main
            },
            "&$disabled": {
                color: theme.palette.text.disabled
            }
        },
        /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */ textColorSecondary: {
            color: theme.palette.text.secondary,
            "&$selected": {
                color: theme.palette.secondary.main
            },
            "&$disabled": {
                color: theme.palette.text.disabled
            }
        },
        /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */ selected: {},
        /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */ disabled: {},
        /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */ fullWidth: {
            flexShrink: 1,
            flexGrow: 1,
            flexBasis: 0,
            maxWidth: "none"
        },
        /* Styles applied to the root element if `wrapped={true}`. */ wrapped: {
            fontSize: theme.typography.pxToRem(12),
            lineHeight: 1.5
        },
        /* Styles applied to the `icon` and `label`'s wrapper element. */ wrapper: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            flexDirection: "column"
        }
    };
};
var $e0edc8e5721a6e65$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(props, ref) {
    var classes = props.classes, className = props.className, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, fullWidth = props.fullWidth, icon = props.icon, indicator = props.indicator, label = props.label, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, selected = props.selected, selectionFollowsFocus = props.selectionFollowsFocus, _props$textColor = props.textColor, textColor = _props$textColor === void 0 ? "inherit" : _props$textColor, value = props.value, _props$wrapped = props.wrapped, wrapped = _props$wrapped === void 0 ? false : _props$wrapped, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "disabled",
        "disableFocusRipple",
        "fullWidth",
        "icon",
        "indicator",
        "label",
        "onChange",
        "onClick",
        "onFocus",
        "selected",
        "selectionFollowsFocus",
        "textColor",
        "value",
        "wrapped"
    ]);
    var handleClick = function handleClick(event) {
        if (onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    var handleFocus = function handleFocus(event) {
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $ac65ba7da5d490c4$export$2e2bcd8739ae039), (0, $8nd05.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $1SA7b.default)(classes.root, classes["textColor".concat((0, $f9tk6.default)(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        tabIndex: selected ? 0 : -1
    }, other), /*#__PURE__*/ $acw62.createElement("span", {
        className: classes.wrapper
    }, icon, label), indicator);
});
var $e0edc8e5721a6e65$export$2e2bcd8739ae039 = (0, $kQaj4.default)($e0edc8e5721a6e65$export$9dd6ff9ea0189349, {
    name: "MuiTab"
})($e0edc8e5721a6e65$var$Tab);




var $kSlfw = parcelRequire("kSlfw");


var $47Boo = parcelRequire("47Boo");
function $5e5da10edfabbc14$var$getPath(obj, path) {
    if (!path || typeof path !== "string") return null;
    return path.split(".").reduce(function(acc, item) {
        return acc && acc[item] ? acc[item] : null;
    }, obj);
}
function $5e5da10edfabbc14$var$style(options) {
    var prop = options.prop, _options$cssProperty = options.cssProperty, cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty, themeKey = options.themeKey, transform = options.transform;
    var fn = function fn(props) {
        if (props[prop] == null) return null;
        var propValue = props[prop];
        var theme = props.theme;
        var themeMapping = $5e5da10edfabbc14$var$getPath(theme, themeKey) || {};
        var styleFromPropValue = function styleFromPropValue(propValueFinal) {
            var value;
            if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
            else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || propValueFinal;
            else {
                value = $5e5da10edfabbc14$var$getPath(themeMapping, propValueFinal) || propValueFinal;
                if (transform) value = transform(value);
            }
            if (cssProperty === false) return value;
            return (0, $kSlfw.default)({}, cssProperty, value);
        };
        return (0, $47Boo.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $5e5da10edfabbc14$export$2e2bcd8739ae039 = $5e5da10edfabbc14$var$style;


parcelRequire("8nd05");

var $50JXT = parcelRequire("50JXT");
function $89b6940de910c4fb$var$compose() {
    for(var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++)styles[_key] = arguments[_key];
    var fn = function fn(props) {
        return styles.reduce(function(acc, style) {
            var output = style(props);
            if (output) return (0, $50JXT.default)(acc, output);
            return acc;
        }, {});
    }; // Alternative approach that doesn't yield any performance gain.
    // const handlers = styles.reduce((acc, style) => {
    //   style.filterProps.forEach(prop => {
    //     acc[prop] = style;
    //   });
    //   return acc;
    // }, {});
    // const fn = props => {
    //   return Object.keys(props).reduce((acc, prop) => {
    //     if (handlers[prop]) {
    //       return merge(acc, handlers[prop](props));
    //     }
    //     return acc;
    //   }, {});
    // };
    fn.propTypes = {};
    fn.filterProps = styles.reduce(function(acc, style) {
        return acc.concat(style.filterProps);
    }, []);
    return fn;
}
var $89b6940de910c4fb$export$2e2bcd8739ae039 = $89b6940de910c4fb$var$compose;


function $91619248e5d48b84$var$getBorder(value) {
    if (typeof value !== "number") return value;
    return "".concat(value, "px solid");
}
var $91619248e5d48b84$export$1edee58a52776cd9 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "border",
    themeKey: "borders",
    transform: $91619248e5d48b84$var$getBorder
});
var $91619248e5d48b84$export$f9a7b6bd24892946 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $91619248e5d48b84$var$getBorder
});
var $91619248e5d48b84$export$5abca33e6be905d2 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $91619248e5d48b84$var$getBorder
});
var $91619248e5d48b84$export$e2ce9f12a980a822 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $91619248e5d48b84$var$getBorder
});
var $91619248e5d48b84$export$47658cca1a909427 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $91619248e5d48b84$var$getBorder
});
var $91619248e5d48b84$export$e7fb0694ba2404fc = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "borderColor",
    themeKey: "palette"
});
var $91619248e5d48b84$export$7a57f79000377ca2 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "borderRadius",
    themeKey: "shape"
});
var $91619248e5d48b84$var$borders = (0, $89b6940de910c4fb$export$2e2bcd8739ae039)($91619248e5d48b84$export$1edee58a52776cd9, $91619248e5d48b84$export$f9a7b6bd24892946, $91619248e5d48b84$export$5abca33e6be905d2, $91619248e5d48b84$export$e2ce9f12a980a822, $91619248e5d48b84$export$47658cca1a909427, $91619248e5d48b84$export$e7fb0694ba2404fc, $91619248e5d48b84$export$7a57f79000377ca2);
var $91619248e5d48b84$export$2e2bcd8739ae039 = $91619248e5d48b84$var$borders;



var $efe8643d722fc93b$export$95a5c40fb210fe3e = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "displayPrint",
    cssProperty: false,
    transform: function transform(value) {
        return {
            "@media print": {
                display: value
            }
        };
    }
});
var $efe8643d722fc93b$export$e5efd59aba9975ad = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "display"
});
var $efe8643d722fc93b$export$f6530fb6e67e00bd = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "overflow"
});
var $efe8643d722fc93b$export$f00f69a6f0e8c5b6 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "textOverflow"
});
var $efe8643d722fc93b$export$91fa9ac3f4021ce4 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "visibility"
});
var $efe8643d722fc93b$export$9ef81298ca34ad41 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "whiteSpace"
});
var $efe8643d722fc93b$export$2e2bcd8739ae039 = (0, $89b6940de910c4fb$export$2e2bcd8739ae039)($efe8643d722fc93b$export$95a5c40fb210fe3e, $efe8643d722fc93b$export$e5efd59aba9975ad, $efe8643d722fc93b$export$f6530fb6e67e00bd, $efe8643d722fc93b$export$f00f69a6f0e8c5b6, $efe8643d722fc93b$export$91fa9ac3f4021ce4, $efe8643d722fc93b$export$9ef81298ca34ad41);



var $85c481831d20ba3b$export$d2ad290394bbc49d = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "flexBasis"
});
var $85c481831d20ba3b$export$84c3c16c9ed6c908 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "flexDirection"
});
var $85c481831d20ba3b$export$9a4bcd01f5c204bc = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "flexWrap"
});
var $85c481831d20ba3b$export$8dea3061ba53bfd1 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "justifyContent"
});
var $85c481831d20ba3b$export$898d9006406726bd = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "alignItems"
});
var $85c481831d20ba3b$export$38c32c6918694134 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "alignContent"
});
var $85c481831d20ba3b$export$aaaeab0fac9a3ccb = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "order"
});
var $85c481831d20ba3b$export$97691fbb80847c19 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "flex"
});
var $85c481831d20ba3b$export$36c65c169152373d = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "flexGrow"
});
var $85c481831d20ba3b$export$2670ac60b02109d2 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "flexShrink"
});
var $85c481831d20ba3b$export$4545dd3632cb520b = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "alignSelf"
});
var $85c481831d20ba3b$export$55e6b7a7f0eaa3ff = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "justifyItems"
});
var $85c481831d20ba3b$export$d012640ac9a6446f = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "justifySelf"
});
var $85c481831d20ba3b$var$flexbox = (0, $89b6940de910c4fb$export$2e2bcd8739ae039)($85c481831d20ba3b$export$d2ad290394bbc49d, $85c481831d20ba3b$export$84c3c16c9ed6c908, $85c481831d20ba3b$export$9a4bcd01f5c204bc, $85c481831d20ba3b$export$8dea3061ba53bfd1, $85c481831d20ba3b$export$898d9006406726bd, $85c481831d20ba3b$export$38c32c6918694134, $85c481831d20ba3b$export$aaaeab0fac9a3ccb, $85c481831d20ba3b$export$97691fbb80847c19, $85c481831d20ba3b$export$36c65c169152373d, $85c481831d20ba3b$export$2670ac60b02109d2, $85c481831d20ba3b$export$4545dd3632cb520b, $85c481831d20ba3b$export$55e6b7a7f0eaa3ff, $85c481831d20ba3b$export$d012640ac9a6446f);
var $85c481831d20ba3b$export$2e2bcd8739ae039 = $85c481831d20ba3b$var$flexbox;



var $dd45cce3645197d2$export$62ffeaf1cd78b2a6 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridGap"
});
var $dd45cce3645197d2$export$d6171c086ca0de0 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridColumnGap"
});
var $dd45cce3645197d2$export$8bb113508eaa54d = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridRowGap"
});
var $dd45cce3645197d2$export$baf44164ca3a34e8 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridColumn"
});
var $dd45cce3645197d2$export$8f7213a1cd01e832 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridRow"
});
var $dd45cce3645197d2$export$b0e0abbc49ba668 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridAutoFlow"
});
var $dd45cce3645197d2$export$bcd8b929d4b4142 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridAutoColumns"
});
var $dd45cce3645197d2$export$e5039a674e14c828 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridAutoRows"
});
var $dd45cce3645197d2$export$42bd9088661ffb03 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridTemplateColumns"
});
var $dd45cce3645197d2$export$920682ae05b999bc = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridTemplateRows"
});
var $dd45cce3645197d2$export$1b88fbdd482fd33a = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridTemplateAreas"
});
var $dd45cce3645197d2$export$bdb486e40d52d26f = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "gridArea"
});
var $dd45cce3645197d2$var$grid = (0, $89b6940de910c4fb$export$2e2bcd8739ae039)($dd45cce3645197d2$export$62ffeaf1cd78b2a6, $dd45cce3645197d2$export$d6171c086ca0de0, $dd45cce3645197d2$export$8bb113508eaa54d, $dd45cce3645197d2$export$baf44164ca3a34e8, $dd45cce3645197d2$export$8f7213a1cd01e832, $dd45cce3645197d2$export$b0e0abbc49ba668, $dd45cce3645197d2$export$bcd8b929d4b4142, $dd45cce3645197d2$export$e5039a674e14c828, $dd45cce3645197d2$export$42bd9088661ffb03, $dd45cce3645197d2$export$920682ae05b999bc, $dd45cce3645197d2$export$1b88fbdd482fd33a, $dd45cce3645197d2$export$bdb486e40d52d26f);
var $dd45cce3645197d2$export$2e2bcd8739ae039 = $dd45cce3645197d2$var$grid;



var $2a5e4386ae1dc0e4$export$35e9368ef982300f = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "color",
    themeKey: "palette"
});
var $2a5e4386ae1dc0e4$export$2506f56c10355b33 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette"
});
var $2a5e4386ae1dc0e4$var$palette = (0, $89b6940de910c4fb$export$2e2bcd8739ae039)($2a5e4386ae1dc0e4$export$35e9368ef982300f, $2a5e4386ae1dc0e4$export$2506f56c10355b33);
var $2a5e4386ae1dc0e4$export$2e2bcd8739ae039 = $2a5e4386ae1dc0e4$var$palette;



var $3e53b80d46b3d90d$export$5880b8b5730aff45 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "position"
});
var $3e53b80d46b3d90d$export$56446adcecbeec34 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "zIndex",
    themeKey: "zIndex"
});
var $3e53b80d46b3d90d$export$1e95b668f3b82d = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "top"
});
var $3e53b80d46b3d90d$export$79ffe56a765070d2 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "right"
});
var $3e53b80d46b3d90d$export$40e543e69a8b3fbb = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "bottom"
});
var $3e53b80d46b3d90d$export$eabcd2c8791e7bf4 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "left"
});
var $3e53b80d46b3d90d$export$2e2bcd8739ae039 = (0, $89b6940de910c4fb$export$2e2bcd8739ae039)($3e53b80d46b3d90d$export$5880b8b5730aff45, $3e53b80d46b3d90d$export$56446adcecbeec34, $3e53b80d46b3d90d$export$1e95b668f3b82d, $3e53b80d46b3d90d$export$79ffe56a765070d2, $3e53b80d46b3d90d$export$40e543e69a8b3fbb, $3e53b80d46b3d90d$export$eabcd2c8791e7bf4);


var $5fde20db2253bc50$var$boxShadow = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "boxShadow",
    themeKey: "shadows"
});
var $5fde20db2253bc50$export$2e2bcd8739ae039 = $5fde20db2253bc50$var$boxShadow;



function $2d4cfa0cc3e51cea$var$transform(value) {
    return value <= 1 ? "".concat(value * 100, "%") : value;
}
var $2d4cfa0cc3e51cea$export$7e3df82ee760448c = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "width",
    transform: $2d4cfa0cc3e51cea$var$transform
});
var $2d4cfa0cc3e51cea$export$488fda99655ff65a = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "maxWidth",
    transform: $2d4cfa0cc3e51cea$var$transform
});
var $2d4cfa0cc3e51cea$export$ee148fbbe8357dd2 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "minWidth",
    transform: $2d4cfa0cc3e51cea$var$transform
});
var $2d4cfa0cc3e51cea$export$ac607276a8fe9f0a = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "height",
    transform: $2d4cfa0cc3e51cea$var$transform
});
var $2d4cfa0cc3e51cea$export$dc0d8bd0b94f8570 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "maxHeight",
    transform: $2d4cfa0cc3e51cea$var$transform
});
var $2d4cfa0cc3e51cea$export$a43cf604e12f3b17 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "minHeight",
    transform: $2d4cfa0cc3e51cea$var$transform
});
var $2d4cfa0cc3e51cea$export$ffed9f14fb65e276 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "width",
    transform: $2d4cfa0cc3e51cea$var$transform
});
var $2d4cfa0cc3e51cea$export$905076ed6620e671 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "height",
    transform: $2d4cfa0cc3e51cea$var$transform
});
var $2d4cfa0cc3e51cea$export$6ccc93f785106a58 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "boxSizing"
});
var $2d4cfa0cc3e51cea$var$sizing = (0, $89b6940de910c4fb$export$2e2bcd8739ae039)($2d4cfa0cc3e51cea$export$7e3df82ee760448c, $2d4cfa0cc3e51cea$export$488fda99655ff65a, $2d4cfa0cc3e51cea$export$ee148fbbe8357dd2, $2d4cfa0cc3e51cea$export$ac607276a8fe9f0a, $2d4cfa0cc3e51cea$export$dc0d8bd0b94f8570, $2d4cfa0cc3e51cea$export$a43cf604e12f3b17, $2d4cfa0cc3e51cea$export$6ccc93f785106a58);
var $2d4cfa0cc3e51cea$export$2e2bcd8739ae039 = $2d4cfa0cc3e51cea$var$sizing;


var $azmQN = parcelRequire("azmQN");
var $kbxxf = parcelRequire("kbxxf");

var $8nd05 = parcelRequire("8nd05");



var $50JXT = parcelRequire("50JXT");
function $72dd3fb3cbafef65$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
}
var $72dd3fb3cbafef65$var$warnedOnce = false;
function $72dd3fb3cbafef65$var$styleFunctionSx(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var output = styleFunction(props);
        if (props.css) return (0, $8nd05.default)({}, (0, $50JXT.default)(output, styleFunction((0, $8nd05.default)({
            theme: props.theme
        }, props.css))), $72dd3fb3cbafef65$var$omit(props.css, [
            styleFunction.filterProps
        ]));
        if (props.sx) return (0, $8nd05.default)({}, (0, $50JXT.default)(output, styleFunction((0, $8nd05.default)({
            theme: props.theme
        }, props.sx))), $72dd3fb3cbafef65$var$omit(props.sx, [
            styleFunction.filterProps
        ]));
        return output;
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "css",
        "sx"
    ].concat((0, $kbxxf.default)(styleFunction.filterProps));
    return newStyleFunction;
}
function $72dd3fb3cbafef65$export$dbf350e5966cf602(styleFunction) {
    return $72dd3fb3cbafef65$var$styleFunctionSx(styleFunction);
}
var $72dd3fb3cbafef65$export$2e2bcd8739ae039 = $72dd3fb3cbafef65$var$styleFunctionSx;



var $bd0326975b091423$export$a5975749f0374264 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "fontFamily",
    themeKey: "typography"
});
var $bd0326975b091423$export$85e3c3ca0c6fb93 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "fontSize",
    themeKey: "typography"
});
var $bd0326975b091423$export$a827189a08c5a3a3 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "fontStyle",
    themeKey: "typography"
});
var $bd0326975b091423$export$bc0b29e67df3229e = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "fontWeight",
    themeKey: "typography"
});
var $bd0326975b091423$export$3eb52878e4502ad1 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "letterSpacing"
});
var $bd0326975b091423$export$c9b91427b594e14 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "lineHeight"
});
var $bd0326975b091423$export$a87999391cd10ae9 = (0, $5e5da10edfabbc14$export$2e2bcd8739ae039)({
    prop: "textAlign"
});
var $bd0326975b091423$var$typography = (0, $89b6940de910c4fb$export$2e2bcd8739ae039)($bd0326975b091423$export$a5975749f0374264, $bd0326975b091423$export$85e3c3ca0c6fb93, $bd0326975b091423$export$a827189a08c5a3a3, $bd0326975b091423$export$bc0b29e67df3229e, $bd0326975b091423$export$3eb52878e4502ad1, $bd0326975b091423$export$c9b91427b594e14, $bd0326975b091423$export$a87999391cd10ae9);
var $bd0326975b091423$export$2e2bcd8739ae039 = $bd0326975b091423$var$typography;



var $8nd05 = parcelRequire("8nd05");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");



var $9ORqK = parcelRequire("9ORqK");

var $cp2NC = parcelRequire("cp2NC");
function $2d71ec4a7bb02597$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
} // styled-components's API removes the mapping between components and styles.
function $2d71ec4a7bb02597$export$2e2bcd8739ae039(Component) {
    var componentCreator = function componentCreator(style) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var name = options.name, stylesOptions = (0, $9X7IJ.default)(options, [
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var stylesOrCreator = typeof style === "function" ? function(theme) {
            return {
                root: function root(props) {
                    return style((0, $8nd05.default)({
                        theme: theme
                    }, props));
                }
            };
        } : {
            root: style
        };
        var useStyles = (0, $cp2NC.default)(stylesOrCreator, (0, $8nd05.default)({
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var filterProps;
        var propTypes = {};
        if (style.filterProps) {
            filterProps = style.filterProps;
            delete style.filterProps;
        }
        /* eslint-disable react/forbid-foreign-prop-types */ if (style.propTypes) {
            propTypes = style.propTypes;
            delete style.propTypes;
        }
        /* eslint-enable react/forbid-foreign-prop-types */ var StyledComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function StyledComponent(props, ref) {
            var children = props.children, classNameProp = props.className, clone = props.clone, ComponentProp = props.component, other = (0, $9X7IJ.default)(props, [
                "children",
                "className",
                "clone",
                "component"
            ]);
            var classes = useStyles(props);
            var className = (0, $1SA7b.default)(classes.root, classNameProp);
            var spread = other;
            if (filterProps) spread = $2d71ec4a7bb02597$var$omit(spread, filterProps);
            if (clone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, (0, $8nd05.default)({
                className: (0, $1SA7b.default)(children.props.className, className)
            }, spread));
            if (typeof children === "function") return children((0, $8nd05.default)({
                className: className
            }, spread));
            var FinalComponent = ComponentProp || Component;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FinalComponent, (0, $8nd05.default)({
                ref: ref,
                className: className
            }, spread), children);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(StyledComponent, Component);
        return StyledComponent;
    };
    return componentCreator;
}



var $kpDC5 = parcelRequire("kpDC5");
var $f6852e7e0b5ef51f$var$styled = function styled(Component) {
    var componentCreator = (0, $2d71ec4a7bb02597$export$2e2bcd8739ae039)(Component);
    return function(style, options) {
        return componentCreator(style, (0, $8nd05.default)({
            defaultTheme: (0, $kpDC5.default)
        }, options));
    };
};
var $f6852e7e0b5ef51f$export$2e2bcd8739ae039 = $f6852e7e0b5ef51f$var$styled;


var $f71923faed635e4f$export$8b4cd039ebcc4f7b = (0, $72dd3fb3cbafef65$export$2e2bcd8739ae039)((0, $89b6940de910c4fb$export$2e2bcd8739ae039)((0, $91619248e5d48b84$export$2e2bcd8739ae039), (0, $efe8643d722fc93b$export$2e2bcd8739ae039), (0, $85c481831d20ba3b$export$2e2bcd8739ae039), (0, $dd45cce3645197d2$export$2e2bcd8739ae039), (0, $3e53b80d46b3d90d$export$2e2bcd8739ae039), (0, $2a5e4386ae1dc0e4$export$2e2bcd8739ae039), (0, $5fde20db2253bc50$export$2e2bcd8739ae039), (0, $2d4cfa0cc3e51cea$export$2e2bcd8739ae039), (0, $azmQN.default), (0, $bd0326975b091423$export$2e2bcd8739ae039)));
/**
 * @ignore - do not document.
 */ var $f71923faed635e4f$var$Box = (0, $f6852e7e0b5ef51f$export$2e2bcd8739ae039)("div")($f71923faed635e4f$export$8b4cd039ebcc4f7b, {
    name: "MuiBox"
});
var $f71923faed635e4f$export$2e2bcd8739ae039 = $f71923faed635e4f$var$Box;



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ var $833843e8611f5913$var$Tablelvl2Context = $acw62.createContext();
var $833843e8611f5913$export$2e2bcd8739ae039 = $833843e8611f5913$var$Tablelvl2Context;


var $c3d6bc8b29873e89$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "table-header-group"
    }
};
var $c3d6bc8b29873e89$var$tablelvl2 = {
    variant: "head"
};
var $c3d6bc8b29873e89$var$defaultComponent = "thead";
var $c3d6bc8b29873e89$var$TableHead = /*#__PURE__*/ $acw62.forwardRef(function TableHead(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $c3d6bc8b29873e89$var$defaultComponent : _props$component, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $833843e8611f5913$export$2e2bcd8739ae039).Provider, {
        value: $c3d6bc8b29873e89$var$tablelvl2
    }, /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref,
        role: Component === $c3d6bc8b29873e89$var$defaultComponent ? null : "rowgroup"
    }, other)));
});
var $c3d6bc8b29873e89$export$2e2bcd8739ae039 = (0, $kQaj4.default)($c3d6bc8b29873e89$export$9dd6ff9ea0189349, {
    name: "MuiTableHead"
})($c3d6bc8b29873e89$var$TableHead);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");


var $9GbWv = parcelRequire("9GbWv");
var $58a81d8428d1c8f8$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: "inherit",
            display: "table-row",
            verticalAlign: "middle",
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0,
            "&$hover:hover": {
                backgroundColor: theme.palette.action.hover
            },
            "&$selected, &$selected:hover": {
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
            }
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {},
        /* Pseudo-class applied to the root element if `hover={true}`. */ hover: {},
        /* Styles applied to the root element if table variant="head". */ head: {},
        /* Styles applied to the root element if table variant="footer". */ footer: {}
    };
};
var $58a81d8428d1c8f8$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ var $58a81d8428d1c8f8$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $58a81d8428d1c8f8$var$defaultComponent : _props$component, _props$hover = props.hover, hover = _props$hover === void 0 ? false : _props$hover, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "component",
        "hover",
        "selected"
    ]);
    var tablelvl2 = $acw62.useContext((0, $833843e8611f5913$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, className, tablelvl2 && ({
            "head": classes.head,
            "footer": classes.footer
        })[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
        role: Component === $58a81d8428d1c8f8$var$defaultComponent ? null : "row"
    }, other));
});
var $58a81d8428d1c8f8$export$2e2bcd8739ae039 = (0, $kQaj4.default)($58a81d8428d1c8f8$export$9dd6ff9ea0189349, {
    name: "MuiTableRow"
})($58a81d8428d1c8f8$var$TableRow);



var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");

var $f9tk6 = parcelRequire("f9tk6");

var $9GbWv = parcelRequire("9GbWv");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ var $e2daeac44548f9de$var$TableContext = $acw62.createContext();
var $e2daeac44548f9de$export$2e2bcd8739ae039 = $e2daeac44548f9de$var$TableContext;



var $61094b1ba82ad225$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $8nd05.default)({}, theme.typography.body2, {
            display: "table-cell",
            verticalAlign: "inherit",
            // Workaround for a rendering bug with spanned columns in Chrome 62.0.
            // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
            borderBottom: "1px solid\n    ".concat(theme.palette.type === "light" ? (0, $9GbWv.lighten)((0, $9GbWv.alpha)(theme.palette.divider, 1), 0.88) : (0, $9GbWv.darken)((0, $9GbWv.alpha)(theme.palette.divider, 1), 0.68)),
            textAlign: "left",
            padding: 16
        }),
        /* Styles applied to the root element if `variant="head"` or `context.table.head`. */ head: {
            color: theme.palette.text.primary,
            lineHeight: theme.typography.pxToRem(24),
            fontWeight: theme.typography.fontWeightMedium
        },
        /* Styles applied to the root element if `variant="body"` or `context.table.body`. */ body: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */ footer: {
            color: theme.palette.text.secondary,
            lineHeight: theme.typography.pxToRem(21),
            fontSize: theme.typography.pxToRem(12)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: "6px 24px 6px 16px",
            "&:last-child": {
                paddingRight: 16
            },
            "&$paddingCheckbox": {
                width: 24,
                // prevent the checkbox column from growing
                padding: "0 12px 0 16px",
                "&:last-child": {
                    paddingLeft: 12,
                    paddingRight: 16
                },
                "& > *": {
                    padding: 0
                }
            }
        },
        /* Styles applied to the root element if `padding="checkbox"`. */ paddingCheckbox: {
            width: 48,
            // prevent the checkbox column from growing
            padding: "0 0 0 4px",
            "&:last-child": {
                paddingLeft: 0,
                paddingRight: 4
            }
        },
        /* Styles applied to the root element if `padding="none"`. */ paddingNone: {
            padding: 0,
            "&:last-child": {
                padding: 0
            }
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: "left"
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: "center"
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: "right",
            flexDirection: "row-reverse"
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: "justify"
        },
        /* Styles applied to the root element if `context.table.stickyHeader={true}`. */ stickyHeader: {
            position: "sticky",
            top: 0,
            left: 0,
            zIndex: 2,
            backgroundColor: theme.palette.background.default
        }
    };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ var $61094b1ba82ad225$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, component = props.component, paddingProp = props.padding, scopeProp = props.scope, sizeProp = props.size, sortDirection = props.sortDirection, variantProp = props.variant, other = (0, $9X7IJ.default)(props, [
        "align",
        "classes",
        "className",
        "component",
        "padding",
        "scope",
        "size",
        "sortDirection",
        "variant"
    ]);
    var table = $acw62.useContext((0, $e2daeac44548f9de$export$2e2bcd8739ae039));
    var tablelvl2 = $acw62.useContext((0, $833843e8611f5913$export$2e2bcd8739ae039));
    var isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    var role;
    var Component;
    if (component) {
        Component = component;
        role = isHeadCell ? "columnheader" : "cell";
    } else Component = isHeadCell ? "th" : "td";
    var scope = scopeProp;
    if (!scope && isHeadCell) scope = "col";
    var padding = paddingProp || (table && table.padding ? table.padding : "normal");
    var size = sizeProp || (table && table.size ? table.size : "medium");
    var variant = variantProp || tablelvl2 && tablelvl2.variant;
    var ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, classes[variant], className, align !== "inherit" && classes["align".concat((0, $f9tk6.default)(align))], padding !== "normal" && classes["padding".concat((0, $f9tk6.default)(padding))], size !== "medium" && classes["size".concat((0, $f9tk6.default)(size))], variant === "head" && table && table.stickyHeader && classes.stickyHeader),
        "aria-sort": ariaSort,
        role: role,
        scope: scope
    }, other));
});
var $61094b1ba82ad225$export$2e2bcd8739ae039 = (0, $kQaj4.default)($61094b1ba82ad225$export$9dd6ff9ea0189349, {
    name: "MuiTableCell"
})($61094b1ba82ad225$var$TableCell);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");
var $b289f7d30c9e5e15$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        width: "100%",
        overflowX: "auto"
    }
};
var $b289f7d30c9e5e15$var$TableContainer = /*#__PURE__*/ $acw62.forwardRef(function TableContainer(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, className)
    }, other));
});
var $b289f7d30c9e5e15$export$2e2bcd8739ae039 = (0, $kQaj4.default)($b289f7d30c9e5e15$export$9dd6ff9ea0189349, {
    name: "MuiTableContainer"
})($b289f7d30c9e5e15$var$TableContainer);




var $acw62 = parcelRequire("acw62");


var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");

var $e06e485673548dbd$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "table",
            width: "100%",
            borderCollapse: "collapse",
            borderSpacing: 0,
            "& caption": (0, $8nd05.default)({}, theme.typography.body2, {
                padding: theme.spacing(2),
                color: theme.palette.text.secondary,
                textAlign: "left",
                captionSide: "bottom"
            })
        },
        /* Styles applied to the root element if `stickyHeader={true}`. */ stickyHeader: {
            borderCollapse: "separate"
        }
    };
};
var $e06e485673548dbd$var$defaultComponent = "table";
var $e06e485673548dbd$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $e06e485673548dbd$var$defaultComponent : _props$component, _props$padding = props.padding, padding = _props$padding === void 0 ? "normal" : _props$padding, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$stickyHeader = props.stickyHeader, stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "component",
        "padding",
        "size",
        "stickyHeader"
    ]);
    var table = $acw62.useMemo(function() {
        return {
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        };
    }, [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $e2daeac44548f9de$export$2e2bcd8739ae039).Provider, {
        value: table
    }, /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        role: Component === $e06e485673548dbd$var$defaultComponent ? null : "table",
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, className, stickyHeader && classes.stickyHeader)
    }, other)));
});
var $e06e485673548dbd$export$2e2bcd8739ae039 = (0, $kQaj4.default)($e06e485673548dbd$export$9dd6ff9ea0189349, {
    name: "MuiTable"
})($e06e485673548dbd$var$Table);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $1ffd6f30eceff04f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "table-row-group"
    }
};
var $1ffd6f30eceff04f$var$tablelvl2 = {
    variant: "body"
};
var $1ffd6f30eceff04f$var$defaultComponent = "tbody";
var $1ffd6f30eceff04f$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $1ffd6f30eceff04f$var$defaultComponent : _props$component, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $833843e8611f5913$export$2e2bcd8739ae039).Provider, {
        value: $1ffd6f30eceff04f$var$tablelvl2
    }, /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref,
        role: Component === $1ffd6f30eceff04f$var$defaultComponent ? null : "rowgroup"
    }, other)));
});
var $1ffd6f30eceff04f$export$2e2bcd8739ae039 = (0, $kQaj4.default)($1ffd6f30eceff04f$export$9dd6ff9ea0189349, {
    name: "MuiTableBody"
})($1ffd6f30eceff04f$var$TableBody);





const $0d7e950fa58312d2$var$AMAX_API_URL = "https://amax-emu.com/api";
const $0d7e950fa58312d2$var$columns = [
    {
        id: "pos",
        label: "Pos.",
        minWidth: 10
    },
    {
        id: "playername",
        label: "Player",
        minWidth: 100
    },
    {
        id: "value",
        label: "Value",
        minWidth: 10,
        align: "center"
    }
];
function $0d7e950fa58312d2$var$createData(name, code, population, size) {
    const density = population / size;
    return {
        name: name,
        code: code,
        population: population,
        size: size,
        density: density
    };
}
const $0d7e950fa58312d2$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)({
    root: {
        width: "100%"
    },
    container: {
        maxHeight: 440
    },
    datacell: {
        borderBottom: "none"
    }
});
function $0d7e950fa58312d2$var$GetCellData({ sortTypeName: sortTypeName , playerData: playerData  }) {
    const classes = $0d7e950fa58312d2$var$useStyles();
    switch(sortTypeName){
        case "sortType":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                className: classes.datacell,
                align: "right",
                children: playerData.statFans
            });
        case "statDriverScore":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                className: classes.datacell,
                align: "right",
                children: playerData.statDriverScore
            });
        case "statLegend":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                className: classes.datacell,
                align: "right",
                children: playerData.statLegend
            });
        default:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                className: classes.datacell,
                align: "right",
                children: playerData.statFans
            });
    }
}
function $0d7e950fa58312d2$export$2e2bcd8739ae039({ sortType: sortType  }) {
    const classes = $0d7e950fa58312d2$var$useStyles();
    const [serverLeaderboardData, setserverStatusData] = $acw62.useState(undefined);
    const [severLeaderboardDataFlag, setLeaderboardDataFlag] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        async function getServerData() {
            const resp = await fetch($0d7e950fa58312d2$var$AMAX_API_URL + "/leaderboards/multiplayer" + "?sortby=" + sortType, {
                method: "GET",
                headers: {
                    "content-type": "application/json;charset=UTF-8"
                }
            });
            setserverStatusData(await resp.json());
            setLeaderboardDataFlag(true);
        }
        getServerData().catch(()=>{});
    }, []);
    const TableBodyData = ()=>{
        if (severLeaderboardDataFlag) {
            const temp = serverLeaderboardData.data.map((row, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $58a81d8428d1c8f8$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                            className: classes.datacell,
                            component: "th",
                            scope: "row",
                            children: index + 1
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                            className: classes.datacell,
                            component: "th",
                            scope: "row",
                            align: "center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d0539293769f9ac$export$2e2bcd8739ae039), {
                                player_name: row.bdPlayerName,
                                place: 0,
                                legend: row.statLegend,
                                level: row.statLevel
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0d7e950fa58312d2$var$GetCellData, {
                            sortTypeName: sortType,
                            playerData: row
                        })
                    ]
                }, row.PlayerId));
            console.log(temp);
            return temp;
        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
            children: "Loading"
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e06e485673548dbd$export$2e2bcd8739ae039), {
        stickyHeader: true,
        padding: "none",
        size: "small",
        "aria-label": "sticky table",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ffd6f30eceff04f$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TableBodyData, {})
        })
    });
}





function $8309befce8872736$var$TabPanel(props) {
    const { children: children , value: value , index: index , ...other } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "tabpanel",
        hidden: value !== index,
        id: `full-width-tabpanel-${index}`,
        "aria-labelledby": `full-width-tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f71923faed635e4f$export$2e2bcd8739ae039), {
            p: 3,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                children: children
            })
        })
    });
}
function $8309befce8872736$var$a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`
    };
}
const $8309befce8872736$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>({
        root: {
            backgroundColor: "#304254",
            borderRadius: 8,
            margin: "13px 0px 15px 0px"
        },
        top: {
            borderRadius: "8px 8px 0px 0px"
        },
        tableHeader: {
            width: "100%"
        },
        container: {
            maxHeight: 440
        },
        widgetName: {
            alignSelf: "flex-start",
            fontStyle: "normal",
            fontWeight: "bold",
            fontSize: 32,
            lineHeight: "122%",
            color: "#E6E6E6"
        },
        CustomIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24"
        }
    }));
function $8309befce8872736$export$2e2bcd8739ae039() {
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $8309befce8872736$var$useStyles();
    const theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    const [value, setValue] = $acw62.useState(0);
    const handleChange = (event, newValue)=>{
        setValue(newValue);
    };
    const handleChangeIndex = (index)=>{
        setValue(index);
    };
    const LeaderboardsFansContent = ()=>{};
    const columns = [
        {
            id: "pos",
            label: t("leaderboard_widget.position"),
            minWidth: 10,
            align: "left"
        },
        {
            id: "playername",
            label: t("leaderboard_widget.player"),
            minWidth: 100,
            align: "center"
        },
        {
            id: "value",
            label: t("leaderboard_widget.value"),
            minWidth: 10,
            align: "center"
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            "width": "100%"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                className: classes.widgetName,
                children: t("leaderboard_widget.header")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: classes.root,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $968e2cc4493acf64$export$2e2bcd8739ae039), {
                        className: classes.top,
                        position: "static",
                        color: "default",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6e5c13c2d64ec58c$export$2e2bcd8739ae039), {
                                value: value,
                                onChange: handleChange,
                                indicatorColor: "primary",
                                textColor: "primary",
                                variant: "fullWidth",
                                "aria-label": "full width tabs example",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0edc8e5721a6e65$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$919f9e6aad25b3cc), {}),
                                        label: t("leaderboard_widget.fans"),
                                        ...$8309befce8872736$var$a11yProps(0)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0edc8e5721a6e65$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$5a540ecc9c1f0346), {}),
                                        label: t("leaderboard_widget.driving_score"),
                                        ...$8309befce8872736$var$a11yProps(1)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0edc8e5721a6e65$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$d3e24e2ed1fd2185), {}),
                                        label: t("leaderboard_widget.legend"),
                                        ...$8309befce8872736$var$a11yProps(2)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b289f7d30c9e5e15$export$2e2bcd8739ae039), {
                                className: classes.container,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e06e485673548dbd$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3d6bc8b29873e89$export$2e2bcd8739ae039), {
                                        className: classes.tableHeader,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $58a81d8428d1c8f8$export$2e2bcd8739ae039), {
                                            children: columns.map((column)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                                    align: column.align,
                                                    style: {
                                                        minWidth: column.minWidth
                                                    },
                                                    children: column.label
                                                }, column.id))
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8309befce8872736$var$TabPanel, {
                        value: value,
                        index: 0,
                        dir: theme.direction,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7e950fa58312d2$export$2e2bcd8739ae039), {
                            sortType: "statFans"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8309befce8872736$var$TabPanel, {
                        value: value,
                        index: 1,
                        dir: theme.direction,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7e950fa58312d2$export$2e2bcd8739ae039), {
                            sortType: "statDriverScore"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8309befce8872736$var$TabPanel, {
                        value: value,
                        index: 2,
                        dir: theme.direction,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7e950fa58312d2$export$2e2bcd8739ae039), {
                            sortType: "statLegend"
                        })
                    })
                ]
            })
        ]
    });
}



parcelRequire("acw62");


var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $9GbWv = parcelRequire("9GbWv");


var $f9tk6 = parcelRequire("f9tk6");
var $5212fe45b57eccf6$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $8nd05.default)({}, theme.typography.button, {
            boxSizing: "border-box",
            minWidth: 64,
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                "background-color",
                "box-shadow",
                "border"
            ], {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                },
                "&$disabled": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: "100%",
            // Ensure the correct width for iOS Safari
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit"
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: "6px 8px"
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: "5px 15px",
            border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $9GbWv.alpha)(theme.palette.primary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $9GbWv.alpha)(theme.palette.secondary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            "&:hover": {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                "&$disabled": {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            "&$focusVisible": {
                boxShadow: theme.shadows[6]
            },
            "&:active": {
                boxShadow: theme.shadows[8]
            },
            "&$disabled": {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: "none",
            "&:hover": {
                boxShadow: "none"
            },
            "&$focusVisible": {
                boxShadow: "none"
            },
            "&:active": {
                boxShadow: "none"
            },
            "&$disabled": {
                boxShadow: "none"
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit",
            borderColor: "currentColor"
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: "4px 5px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: "8px 11px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: "3px 9px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: "7px 21px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: "4px 10px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: "8px 22px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: "inherit",
            marginRight: 8,
            marginLeft: -4,
            "&$iconSizeSmall": {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: "inherit",
            marginRight: -4,
            marginLeft: 8,
            "&$iconSizeSmall": {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            "& > *:first-child": {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            "& > *:first-child": {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            "& > *:first-child": {
                fontSize: 22
            }
        }
    };
};
var $5212fe45b57eccf6$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $1SA7b.default)(classes.startIcon, classes["iconSize".concat((0, $f9tk6.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $1SA7b.default)(classes.endIcon, classes["iconSize".concat((0, $f9tk6.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $acw62.createElement((0, $ac65ba7da5d490c4$export$2e2bcd8739ae039), (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes[variant], className, color === "inherit" ? classes.colorInherit : color !== "default" && classes["".concat(variant).concat((0, $f9tk6.default)(color))], size !== "medium" && [
            classes["".concat(variant, "Size").concat((0, $f9tk6.default)(size))],
            classes["size".concat((0, $f9tk6.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $1SA7b.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $acw62.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $5212fe45b57eccf6$export$2e2bcd8739ae039 = (0, $kQaj4.default)($5212fe45b57eccf6$export$9dd6ff9ea0189349, {
    name: "MuiButton"
})($5212fe45b57eccf6$var$Button);






const $1a97421a8c872c1a$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            flexGrow: 1
        },
        menuButton: {
            backgroundColor: "#111111"
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        }
    }));
function $1a97421a8c872c1a$export$2e2bcd8739ae039() {
    const classes = $1a97421a8c872c1a$var$useStyles();
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: t("intro_welcome_header")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "Welcome to the Amax Emu - the home of Blur online emulator.",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            "In order to play Blur online you need Blur, Amax Emu account and install Amax Emu files."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                to: "/how_to_play",
                style: {
                    color: "#92929F",
                    textDecoration: "none"
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                    className: classes.menuButton,
                    size: "large",
                    children: "Let's begin!"
                })
            })
        ]
    });
}





function $65c9201c81d680dd$export$2e2bcd8739ae039() {
    const auth = (0, $fa8bb1513e386061$export$650ce9f0b4df82fd)();
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64d9a99297a346fe$export$2e2bcd8739ae039), {
        maxWidth: "xl",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "dashboard_container",
            children: [
                user.userData?.amax_account ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "main_widget_container",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a97421a8c872c1a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "column1_container",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $123e4e14bb8cd798$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "column2_container",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8309befce8872736$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "column3_container",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a981844268212c5$export$2e2bcd8739ae039), {}),
                        user.userData?.amax_account ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                marginTop: 200
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                src: "https://discord.com/widget?id=840455397818630175&theme=dark",
                                width: "350",
                                height: "500",
                                allowTransparency: true,
                                frameBorder: "0",
                                sandbox: "allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                marginTop: 120
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                src: "https://discord.com/widget?id=840455397818630175&theme=dark",
                                width: "350",
                                height: "500",
                                allowTransparency: true,
                                frameBorder: "0",
                                sandbox: "allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
                            })
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");

/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [plugins=[]] **deprecated**: use `remarkPlugins` instead
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ var $58805e71bbbc0b37$exports = {};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ $58805e71bbbc0b37$exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $b094d2c4d032c594$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $b094d2c4d032c594$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $b094d2c4d032c594$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $b094d2c4d032c594$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $b094d2c4d032c594$var$point(point) {
    return $b094d2c4d032c594$var$index(point && point.line) + ":" + $b094d2c4d032c594$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $b094d2c4d032c594$var$position(pos) {
    return $b094d2c4d032c594$var$point(pos && pos.start) + "-" + $b094d2c4d032c594$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $b094d2c4d032c594$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}


class $84ecfcc79391545c$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === "string") {
            origin = place;
            place = undefined;
        }
        if (typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ("type" in place || "position" in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ("start" in place || "end" in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ("line" in place || "column" in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $b094d2c4d032c594$export$c304dd45fe166145)(place) || "1:1";
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === "object" ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = "";
        if (typeof reason === "object" && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.file = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.name = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.reason = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.message = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.stack = "";
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.fatal = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.column = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.line = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.source = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.ruleId = null;
$84ecfcc79391545c$export$752e5c445fe834ef.prototype.position = null;


// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $6c0e34cf2f183349$export$bb654e07daaf8c3a = {
    basename: $6c0e34cf2f183349$var$basename,
    dirname: $6c0e34cf2f183349$var$dirname,
    extname: $6c0e34cf2f183349$var$extname,
    join: $6c0e34cf2f183349$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $6c0e34cf2f183349$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $6c0e34cf2f183349$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$dirname(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $6c0e34cf2f183349$var$extname(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $6c0e34cf2f183349$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $6c0e34cf2f183349$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $6c0e34cf2f183349$var$normalize(path) {
    $6c0e34cf2f183349$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $6c0e34cf2f183349$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $6c0e34cf2f183349$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $6c0e34cf2f183349$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $329b4cd6854e87dd$export$97a5aaf482767187 = {
    cwd: $329b4cd6854e87dd$var$cwd
};
function $329b4cd6854e87dd$var$cwd() {
    return "/";
}


/// <reference lib="dom" />
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $ea6379392cbaeecd$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}


function $028cf007d1b71fb0$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $ea6379392cbaeecd$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $028cf007d1b71fb0$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $028cf007d1b71fb0$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $ebdb906eb43ac433$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $ebdb906eb43ac433$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === "string" || $ebdb906eb43ac433$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $ea6379392cbaeecd$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $329b4cd6854e87dd$export$97a5aaf482767187).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $ebdb906eb43ac433$var$order.length){
            const prop = $ebdb906eb43ac433$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$ebdb906eb43ac433$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $ea6379392cbaeecd$export$8304a22d431f958)(path)) path = (0, $028cf007d1b71fb0$export$9b2b676c902de799)(path);
        $ebdb906eb43ac433$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === "string" ? (0, $6c0e34cf2f183349$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $ebdb906eb43ac433$var$assertPath(this.basename, "dirname");
        this.path = (0, $6c0e34cf2f183349$export$bb654e07daaf8c3a).join(dirname || "", this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === "string" ? (0, $6c0e34cf2f183349$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $ebdb906eb43ac433$var$assertNonEmpty(basename, "basename");
        $ebdb906eb43ac433$var$assertPart(basename, "basename");
        this.path = (0, $6c0e34cf2f183349$export$bb654e07daaf8c3a).join(this.dirname || "", basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === "string" ? (0, $6c0e34cf2f183349$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $ebdb906eb43ac433$var$assertPart(extname, "extname");
        $ebdb906eb43ac433$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $6c0e34cf2f183349$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === "string" ? (0, $6c0e34cf2f183349$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $ebdb906eb43ac433$var$assertNonEmpty(stem, "stem");
        $ebdb906eb43ac433$var$assertPart(stem, "stem");
        this.path = (0, $6c0e34cf2f183349$export$bb654e07daaf8c3a).join(this.dirname || "", stem + (this.extname || ""));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || "").toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $84ecfcc79391545c$export$752e5c445fe834ef)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertPart(part, name) {
    if (part && part.includes((0, $6c0e34cf2f183349$export$bb654e07daaf8c3a).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $6c0e34cf2f183349$export$bb654e07daaf8c3a).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $ebdb906eb43ac433$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $ebdb906eb43ac433$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($58805e71bbbc0b37$exports)))(value);
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $ed6a7f7e034afcf2$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}



var $16d474a0815e976d$exports = {};
"use strict";
var $16d474a0815e976d$var$hasOwn = Object.prototype.hasOwnProperty;
var $16d474a0815e976d$var$toStr = Object.prototype.toString;
var $16d474a0815e976d$var$defineProperty = Object.defineProperty;
var $16d474a0815e976d$var$gOPD = Object.getOwnPropertyDescriptor;
var $16d474a0815e976d$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $16d474a0815e976d$var$toStr.call(arr) === "[object Array]";
};
var $16d474a0815e976d$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $16d474a0815e976d$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $16d474a0815e976d$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $16d474a0815e976d$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $16d474a0815e976d$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $16d474a0815e976d$var$setProperty = function setProperty(target, options) {
    if ($16d474a0815e976d$var$defineProperty && options.name === "__proto__") $16d474a0815e976d$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $16d474a0815e976d$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$16d474a0815e976d$var$hasOwn.call(obj, name)) return void 0;
        else if ($16d474a0815e976d$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $16d474a0815e976d$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$16d474a0815e976d$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $16d474a0815e976d$var$getProperty(target, name);
            copy = $16d474a0815e976d$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($16d474a0815e976d$var$isPlainObject(copy) || (copyIsArray = $16d474a0815e976d$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $16d474a0815e976d$var$isArray(src) ? src : [];
                    } else clone = src && $16d474a0815e976d$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $16d474a0815e976d$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $16d474a0815e976d$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


function $fd11a02fceb57d58$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */ function $17ea1ee7077b6d45$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $17ea1ee7077b6d45$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $17ea1ee7077b6d45$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result instanceof Promise) result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}



const $cd17945441716b11$export$7cc1b2fe10c52bb = $cd17945441716b11$var$base().freeze();
const $cd17945441716b11$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $cd17945441716b11$var$base() {
    const transformers = (0, $17ea1ee7077b6d45$export$91b56f5ca106aa43)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $cd17945441716b11$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($16d474a0815e976d$exports)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $cd17945441716b11$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $cd17945441716b11$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $cd17945441716b11$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $cd17945441716b11$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, ...options);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $fd11a02fceb57d58$export$2e2bcd8739ae039)(entry[1]) && (0, $fd11a02fceb57d58$export$2e2bcd8739ae039)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($16d474a0815e976d$exports)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $cd17945441716b11$var$vfile(doc);
        const Parser = processor.Parser;
        $cd17945441716b11$var$assertParser("parse", Parser);
        if ($cd17945441716b11$var$newable(Parser, "parse")) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $cd17945441716b11$var$vfile(doc);
        const Compiler = processor.Compiler;
        $cd17945441716b11$var$assertCompiler("stringify", Compiler);
        $cd17945441716b11$var$assertNode(node);
        if ($cd17945441716b11$var$newable(Compiler, "compile")) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $cd17945441716b11$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === "function") {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $cd17945441716b11$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $cd17945441716b11$var$assertDone("runSync", "run", complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $ed6a7f7e034afcf2$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $cd17945441716b11$var$assertParser("process", processor.Parser);
        $cd17945441716b11$var$assertCompiler("process", processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $cd17945441716b11$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($cd17945441716b11$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $cd17945441716b11$var$assertParser("processSync", processor.Parser);
        $cd17945441716b11$var$assertCompiler("processSync", processor.Compiler);
        const file = $cd17945441716b11$var$vfile(doc);
        processor.process(file, done);
        $cd17945441716b11$var$assertDone("processSync", "process", complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $ed6a7f7e034afcf2$export$dd911e13ecb11e05)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $cd17945441716b11$var$newable(value, name) {
    return typeof value === "function" && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($cd17945441716b11$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $cd17945441716b11$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($cd17945441716b11$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $cd17945441716b11$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $cd17945441716b11$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $cd17945441716b11$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $cd17945441716b11$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $fd11a02fceb57d58$export$2e2bcd8739ae039)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $cd17945441716b11$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $cd17945441716b11$var$vfile(value) {
    return $cd17945441716b11$var$looksLikeAVFile(value) ? value : new (0, $ebdb906eb43ac433$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $cd17945441716b11$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $cd17945441716b11$var$looksLikeAVFileValue(value) {
    return typeof value === "string" || (0, (/*@__PURE__*/$parcel$interopDefault($58805e71bbbc0b37$exports)))(value);
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ /**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $79369f5237095e86$var$emptyOptions = {};
function $79369f5237095e86$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $79369f5237095e86$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $79369f5237095e86$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $79369f5237095e86$var$one(value, includeImageAlt, includeHtml) {
    if ($79369f5237095e86$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $79369f5237095e86$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $79369f5237095e86$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $79369f5237095e86$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $79369f5237095e86$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $79369f5237095e86$var$node(value) {
    return Boolean(value && typeof value === "object");
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Create} Create
 */ /**
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 * @param {T[]} list
 * @param {number} start
 * @param {number} remove
 * @param {T[]} items
 * @returns {void}
 */ function $0a9edb7ff3ef159f$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {unknown[]} */ let parameters // Make start between zero and `end` (included).
    ;
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0 // No need to chunk the items if there’s only a couple (10k) items.
    ;
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove) // @ts-expect-error Hush, it’s fine.
        ;
        [].splice.apply(list, parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) [].splice.apply(list, [
            start,
            remove
        ]) // Insert the items in chunks to not cause stack overflows.
        ;
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0) // @ts-expect-error Hush, it’s fine.
            ;
            [].splice.apply(list, parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $0a9edb7ff3ef159f$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $0a9edb7ff3ef159f$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


const $12b512a5203a7cce$var$hasOwnProperty = {}.hasOwnProperty;
function $12b512a5203a7cce$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$12b512a5203a7cce$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all Extension to merge into.
 * @param {Extension} extension Extension to merge.
 * @returns {void}
 */ function $12b512a5203a7cce$var$syntaxExtension(all, extension) {
    /** @type {string} */ let hook;
    for(hook in extension){
        const maybe = $12b512a5203a7cce$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {string} */ let code;
        for(code in right){
            if (!$12b512a5203a7cce$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $12b512a5203a7cce$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {unknown[]} existing
 * @param {unknown[]} list
 * @returns {void}
 */ function $12b512a5203a7cce$var$constructs(existing, list) {
    let index = -1;
    /** @type {unknown[]} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $0a9edb7ff3ef159f$export$869882364835d202)(existing, 0, 0, before);
}
function $12b512a5203a7cce$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$12b512a5203a7cce$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all Extension to merge into.
 * @param {HtmlExtension} extension Extension to merge.
 * @returns {void}
 */ function $12b512a5203a7cce$var$htmlExtension(all, extension) {
    /** @type {string} */ let hook;
    for(hook in extension){
        const maybe = $12b512a5203a7cce$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {string} */ let type;
        if (right) for(type in right)left[type] = right[type];
    }
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 */ // This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
const $166bac51b6e2a8af$export$85b5101f24802e8c = /[!-/:-@[-`{-~\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;


const $432513c48b12fdfc$export$d65d6b62c24d5436 = $432513c48b12fdfc$var$regexCheck(/[A-Za-z]/);
const $432513c48b12fdfc$export$ca8b5b1a6c320e6e = $432513c48b12fdfc$var$regexCheck(/\d/);
const $432513c48b12fdfc$export$eca2752363989806 = $432513c48b12fdfc$var$regexCheck(/[\dA-Fa-f]/);
const $432513c48b12fdfc$export$75c76db11865a9f4 = $432513c48b12fdfc$var$regexCheck(/[\dA-Za-z]/);
const $432513c48b12fdfc$export$35794a7d1db99380 = $432513c48b12fdfc$var$regexCheck(/[!-/:-@[-`{-~]/);
const $432513c48b12fdfc$export$4397998b34fe597d = $432513c48b12fdfc$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $432513c48b12fdfc$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
function $432513c48b12fdfc$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $432513c48b12fdfc$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $432513c48b12fdfc$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $432513c48b12fdfc$export$a0ff789c034ffdf4 = $432513c48b12fdfc$var$regexCheck(/\s/);
const $432513c48b12fdfc$export$aa04114dd888a7a0 = $432513c48b12fdfc$var$regexCheck((0, $166bac51b6e2a8af$export$85b5101f24802e8c));
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => code is number}
 */ function $432513c48b12fdfc$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code Character code
   * @returns {code is number} Whether the character code matches the bound regex
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}


function $653f8b80711d97d0$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $171a79fbb1402b9a$export$a7db06668cad9adb = {
    tokenize: $171a79fbb1402b9a$var$initializeContent
};
/** @type {Initializer} */ function $171a79fbb1402b9a$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        } // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Point} Point
 */ /**
 * @typedef {Record<string, unknown>} StackState
 * @typedef {[Construct, StackState]} StackItem
 */ 


const $348cdb85d1aeadd1$export$5a7bfc01df82fcd1 = {
    tokenize: $348cdb85d1aeadd1$var$initializeDocument
};
/** @type {Construct} */ const $348cdb85d1aeadd1$var$containerConstruct = {
    tokenize: $348cdb85d1aeadd1$var$tokenizeContainer
};
/** @type {Initializer} */ function $348cdb85d1aeadd1$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext|undefined} */ let childFlow;
    /** @type {Token|undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        } // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++ // Note: this field is called `_closeFlow` but it also closes containers.
        ;
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
             // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point|undefined} */ let point // Find the flow chunk.
            ;
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued) // Fix positions.
            ;
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            } // Inject the exits earlier (they’re still also at the end).
            (0, $0a9edb7ff3ef159f$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits)) // Discard the duplicate exits.
            ;
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
             // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
             // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        } // Check if there is a new container.
        self.containerState = {};
        return effects.check($348cdb85d1aeadd1$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($348cdb85d1aeadd1$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]) // Try another.
        ;
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow")) // Get ready for the next line.
            ;
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream) // Alright, so we just added a lazy line:
        ;
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            } // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean|undefined} */ let seen;
            /** @type {Point|undefined} */ let point // Find the previous chunk (the one before the lazy line).
            ;
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued) // Fix positions.
            ;
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            } // Inject the exits earlier (they’re still also at the end).
            (0, $0a9edb7ff3ef159f$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits)) // Discard the duplicate exits.
            ;
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length // Exit open containers.
        ;
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/** @type {Tokenizer} */ function $348cdb85d1aeadd1$var$tokenizeContainer(effects, ok, nok) {
    return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */ 

const $ad11d598ddddec2e$export$d50d28ce3ab2a612 = {
    tokenize: $ad11d598ddddec2e$var$tokenizeBlankLine,
    partial: true
};
/** @type {Tokenizer} */ function $ad11d598ddddec2e$var$tokenizeBlankLine(effects, ok, nok) {
    return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, afterWhitespace, "linePrefix");
    /** @type {State} */ function afterWhitespace(code) {
        return code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */ 

/**
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $dae5d3de466990fa$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number|undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Event[]} */ let parameters;
    /** @type {Event[]} */ let subevents;
    /** @type {boolean|undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index] // Add a hook for the GFM tasklist extension, which needs to know if text
        ;
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        } // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $dae5d3de466990fa$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start) // Switch container exit w/ line endings.
                ;
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $0a9edb7ff3ef159f$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Event[]} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $dae5d3de466990fa$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {number[]} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {[number, number][]} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Chunk[]} */ let stream;
    /** @type {Token|undefined} */ let previous;
    let index = -1;
    /** @type {Token|undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ] // Loop forward through the linked tokens to pass them in order to the
    ;
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        } // Unravel the next token.
        previous = current;
        current = current.next;
    } // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start) // Help GC.
        ;
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
     // Help GC.
    tokenizer.events = [] // If there’s one more token (which is the cases for lines that end in an
    ;
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
     // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $0a9edb7ff3ef159f$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $deaf16079a1807fb$export$a7db06668cad9adb = {
    tokenize: $deaf16079a1807fb$var$tokenizeContent,
    resolve: $deaf16079a1807fb$var$resolveContent
};
/** @type {Construct} */ const $deaf16079a1807fb$var$continuationConstruct = {
    tokenize: $deaf16079a1807fb$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $deaf16079a1807fb$var$resolveContent(events) {
    (0, $dae5d3de466990fa$export$12949d1dd00fddf4)(events);
    return events;
}
/** @type {Tokenizer} */ function $deaf16079a1807fb$var$tokenizeContent(effects, ok) {
    /** @type {Token} */ let previous;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) return contentEnd(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return effects.check($deaf16079a1807fb$var$continuationConstruct, contentContinue, contentEnd)(code);
         // Data.
        effects.consume(code);
        return data;
    }
    /** @type {State} */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /** @type {State} */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return data;
    }
}
/** @type {Tokenizer} */ function $deaf16079a1807fb$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /** @type {State} */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /** @type {State} */ function prefixed(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return nok(code);
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $e2fdd11cbe455c51$export$ccc7b0636abaffc3 = {
    tokenize: $e2fdd11cbe455c51$var$initializeFlow
};
/** @type {Initializer} */ function $e2fdd11cbe455c51$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $ad11d598ddddec2e$export$d50d28ce3ab2a612), atBlankEnding, effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $deaf16079a1807fb$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */ const $1fdcbfee479a4092$export$50397835cbfdbc24 = {
    resolveAll: $1fdcbfee479a4092$var$createResolver()
};
const $1fdcbfee479a4092$export$22b082955e083ec3 = $1fdcbfee479a4092$var$initializeFactory("string");
const $1fdcbfee479a4092$export$6f093cfa640b7166 = $1fdcbfee479a4092$var$initializeFactory("text");
/**
 * @param {'string'|'text'} field
 * @returns {InitialConstruct}
 */ function $1fdcbfee479a4092$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $1fdcbfee479a4092$var$createResolver(field === "text" ? $1fdcbfee479a4092$var$resolveAllLineSuffixes : undefined)
    };
    /** @type {Initializer} */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            } // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver} [extraResolver]
 * @returns {Resolver}
 */ function $1fdcbfee479a4092$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number|undefined} */ let enter // A rather boring computation (to merge adjacent `data` events) which
        ;
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $1fdcbfee479a4092$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean|undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 */ /**
 * @typedef Info
 * @property {() => void} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 

/**
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {{resolveAll?: Resolver}[]} constructs
 * @param {Event[]} events
 * @param {TokenizeContext} context
 * @returns {Event[]}
 */ function $5fffc2d235733349$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Resolver[]} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $4a83eb91ec5d6b95$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean|undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State|void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(chunks, slice);
        main() // Exit if we’re not done, resolve might change stuff.
        ;
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0) // Otherwise, resolve, and exit.
        ;
        context.events = (0, $5fffc2d235733349$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    } //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $4a83eb91ec5d6b95$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $4a83eb91ec5d6b95$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        return Object.assign({}, point);
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    } //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index] // If we’re in a buffer chunk, loop through it.
            ;
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        } // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++ // At end of string chunk.
            ;
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        } // Expose the previous character.
        context.previous = code // Mark as consumed.
        ;
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {Record<string, unknown>} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Construct|Array<Construct>|ConstructRecord} constructs
     * @param {State} returnState
     * @param {State} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : "tokenize" in constructs // @ts-expect-error Looks like a construct.
             ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $0a9edb7ff3ef159f$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'start'|'end'>} token
 * @returns {Array<Chunk>}
 */ function $4a83eb91ec5d6b95$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view[0] = view[0].slice(startBufferIndex);
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean} [expandTabs=false]
 * @returns {string}
 */ function $4a83eb91ec5d6b95$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean|undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}


var $62cac499df3c25a0$exports = {};

$parcel$export($62cac499df3c25a0$exports, "document", () => $62cac499df3c25a0$export$5a7bfc01df82fcd1);
$parcel$export($62cac499df3c25a0$exports, "contentInitial", () => $62cac499df3c25a0$export$5a2181fb44b58173);
$parcel$export($62cac499df3c25a0$exports, "flowInitial", () => $62cac499df3c25a0$export$cf8bead395eff824);
$parcel$export($62cac499df3c25a0$exports, "flow", () => $62cac499df3c25a0$export$ccc7b0636abaffc3);
$parcel$export($62cac499df3c25a0$exports, "string", () => $62cac499df3c25a0$export$22b082955e083ec3);
$parcel$export($62cac499df3c25a0$exports, "text", () => $62cac499df3c25a0$export$6f093cfa640b7166);
$parcel$export($62cac499df3c25a0$exports, "insideSpan", () => $62cac499df3c25a0$export$d44f260a3f9b69f5);
$parcel$export($62cac499df3c25a0$exports, "attentionMarkers", () => $62cac499df3c25a0$export$b9c0b60d74426aea);
$parcel$export($62cac499df3c25a0$exports, "disable", () => $62cac499df3c25a0$export$e20fbacbb41798b);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Point} Point
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $d2c40a75b3c1060a$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) || (0, $432513c48b12fdfc$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $432513c48b12fdfc$export$aa04114dd888a7a0)(code)) return 2;
}



const $ab77d7b684ccca7a$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $ab77d7b684ccca7a$var$tokenizeAttention,
    resolveAll: $ab77d7b684ccca7a$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $ab77d7b684ccca7a$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Event[]} */ let nextEvents;
    /** @type {number} */ let offset // Walk through all events.
    ;
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index // Now walk back to find an opener.
        ;
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
             // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $ab77d7b684ccca7a$var$movePoint(start, -use);
            $ab77d7b684ccca7a$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [] // If there are more markers in the opening, add them before.
            ;
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
             // Opening.
            nextEvents = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]) // Between.
            ;
            nextEvents = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(nextEvents, (0, $5fffc2d235733349$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context)) // Closing.
            ;
            nextEvents = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]) // If there are more markers in the closing, add them after.
            ;
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $0a9edb7ff3ef159f$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
     // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/** @type {Tokenizer} */ function $ab77d7b684ccca7a$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $d2c40a75b3c1060a$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("attentionSequence");
        marker = code;
        return sequence(code);
    }
    /** @type {State} */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            return sequence;
        }
        const token = effects.exit("attentionSequence");
        const after = (0, $d2c40a75b3c1060a$export$e3902bc0d835cad0)(code);
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $ab77d7b684ccca7a$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */ 
const $5d33fad6991aa1ad$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $5d33fad6991aa1ad$var$tokenizeAutolink
};
/** @type {Tokenizer} */ function $5d33fad6991aa1ad$var$tokenizeAutolink(effects, ok, nok) {
    let size = 1;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /** @type {State} */ function open(code) {
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return (0, $432513c48b12fdfc$export$4397998b34fe597d)(code) ? emailAtext(code) : nok(code);
    }
    /** @type {State} */ function schemeOrEmailAtext(code) {
        return code === 43 || code === 45 || code === 46 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code) ? schemeInsideOrEmailAtext(code) : emailAtext(code);
    }
    /** @type {State} */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            return urlInside;
        }
        if ((code === 43 || code === 45 || code === 46 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        return emailAtext(code);
    }
    /** @type {State} */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            return end(code);
        }
        if (code === null || code === 32 || code === 60 || (0, $432513c48b12fdfc$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /** @type {State} */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if ((0, $432513c48b12fdfc$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /** @type {State} */ function emailAtSignOrDot(code) {
        return (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /** @type {State} */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            return end(code);
        }
        return emailValue(code);
    }
    /** @type {State} */ function emailValue(code) {
        if ((code === 45 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) && size++ < 63) {
            effects.consume(code);
            return code === 45 ? emailValue : emailLabel;
        }
        return nok(code);
    }
    /** @type {State} */ function end(code) {
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.exit("autolink");
        return ok;
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 */ 

const $76cd53d8c5b717c4$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $76cd53d8c5b717c4$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $76cd53d8c5b717c4$var$tokenizeBlockQuoteContinuation
    },
    exit: $76cd53d8c5b717c4$var$exit
};
/** @type {Tokenizer} */ function $76cd53d8c5b717c4$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /** @type {State} */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /** @type {State} */ function after(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/** @type {Tokenizer} */ function $76cd53d8c5b717c4$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, effects.attempt($76cd53d8c5b717c4$export$200dcd0a5903c968, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}
/** @type {Exiter} */ function $76cd53d8c5b717c4$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */ 
const $59f80dfce403f5de$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $59f80dfce403f5de$var$tokenizeCharacterEscape
};
/** @type {Tokenizer} */ function $59f80dfce403f5de$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return open;
    }
    /** @type {State} */ function open(code) {
        if ((0, $432513c48b12fdfc$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */ /**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $ed3e2b2347fac27f$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: "&",
    Aacute: "\xc1",
    Abreve: "Ă",
    Acirc: "\xc2",
    Acy: "А",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "Α",
    Amacr: "Ā",
    And: "⩓",
    Aogon: "Ą",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "⁡",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "≔",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "∖",
    Barv: "⫧",
    Barwed: "⌆",
    Bcy: "Б",
    Because: "∵",
    Bernoullis: "ℬ",
    Beta: "Β",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "˘",
    Bscr: "ℬ",
    Bumpeq: "≎",
    CHcy: "Ч",
    COPY: "\xa9",
    Cacute: "Ć",
    Cap: "⋒",
    CapitalDifferentialD: "ⅅ",
    Cayleys: "ℭ",
    Ccaron: "Č",
    Ccedil: "\xc7",
    Ccirc: "Ĉ",
    Cconint: "∰",
    Cdot: "Ċ",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "ℭ",
    Chi: "Χ",
    CircleDot: "⊙",
    CircleMinus: "⊖",
    CirclePlus: "⊕",
    CircleTimes: "⊗",
    ClockwiseContourIntegral: "∲",
    CloseCurlyDoubleQuote: "”",
    CloseCurlyQuote: "’",
    Colon: "∷",
    Colone: "⩴",
    Congruent: "≡",
    Conint: "∯",
    ContourIntegral: "∮",
    Copf: "ℂ",
    Coproduct: "∐",
    CounterClockwiseContourIntegral: "∳",
    Cross: "⨯",
    Cscr: "\uD835\uDC9E",
    Cup: "⋓",
    CupCap: "≍",
    DD: "ⅅ",
    DDotrahd: "⤑",
    DJcy: "Ђ",
    DScy: "Ѕ",
    DZcy: "Џ",
    Dagger: "‡",
    Darr: "↡",
    Dashv: "⫤",
    Dcaron: "Ď",
    Dcy: "Д",
    Del: "∇",
    Delta: "Δ",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "˙",
    DiacriticalDoubleAcute: "˝",
    DiacriticalGrave: "`",
    DiacriticalTilde: "˜",
    Diamond: "⋄",
    DifferentialD: "ⅆ",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "⃜",
    DotEqual: "≐",
    DoubleContourIntegral: "∯",
    DoubleDot: "\xa8",
    DoubleDownArrow: "⇓",
    DoubleLeftArrow: "⇐",
    DoubleLeftRightArrow: "⇔",
    DoubleLeftTee: "⫤",
    DoubleLongLeftArrow: "⟸",
    DoubleLongLeftRightArrow: "⟺",
    DoubleLongRightArrow: "⟹",
    DoubleRightArrow: "⇒",
    DoubleRightTee: "⊨",
    DoubleUpArrow: "⇑",
    DoubleUpDownArrow: "⇕",
    DoubleVerticalBar: "∥",
    DownArrow: "↓",
    DownArrowBar: "⤓",
    DownArrowUpArrow: "⇵",
    DownBreve: "̑",
    DownLeftRightVector: "⥐",
    DownLeftTeeVector: "⥞",
    DownLeftVector: "↽",
    DownLeftVectorBar: "⥖",
    DownRightTeeVector: "⥟",
    DownRightVector: "⇁",
    DownRightVectorBar: "⥗",
    DownTee: "⊤",
    DownTeeArrow: "↧",
    Downarrow: "⇓",
    Dscr: "\uD835\uDC9F",
    Dstrok: "Đ",
    ENG: "Ŋ",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "Ě",
    Ecirc: "\xca",
    Ecy: "Э",
    Edot: "Ė",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "∈",
    Emacr: "Ē",
    EmptySmallSquare: "◻",
    EmptyVerySmallSquare: "▫",
    Eogon: "Ę",
    Eopf: "\uD835\uDD3C",
    Epsilon: "Ε",
    Equal: "⩵",
    EqualTilde: "≂",
    Equilibrium: "⇌",
    Escr: "ℰ",
    Esim: "⩳",
    Eta: "Η",
    Euml: "\xcb",
    Exists: "∃",
    ExponentialE: "ⅇ",
    Fcy: "Ф",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "◼",
    FilledVerySmallSquare: "▪",
    Fopf: "\uD835\uDD3D",
    ForAll: "∀",
    Fouriertrf: "ℱ",
    Fscr: "ℱ",
    GJcy: "Ѓ",
    GT: ">",
    Gamma: "Γ",
    Gammad: "Ϝ",
    Gbreve: "Ğ",
    Gcedil: "Ģ",
    Gcirc: "Ĝ",
    Gcy: "Г",
    Gdot: "Ġ",
    Gfr: "\uD835\uDD0A",
    Gg: "⋙",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "≥",
    GreaterEqualLess: "⋛",
    GreaterFullEqual: "≧",
    GreaterGreater: "⪢",
    GreaterLess: "≷",
    GreaterSlantEqual: "⩾",
    GreaterTilde: "≳",
    Gscr: "\uD835\uDCA2",
    Gt: "≫",
    HARDcy: "Ъ",
    Hacek: "ˇ",
    Hat: "^",
    Hcirc: "Ĥ",
    Hfr: "ℌ",
    HilbertSpace: "ℋ",
    Hopf: "ℍ",
    HorizontalLine: "─",
    Hscr: "ℋ",
    Hstrok: "Ħ",
    HumpDownHump: "≎",
    HumpEqual: "≏",
    IEcy: "Е",
    IJlig: "Ĳ",
    IOcy: "Ё",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "И",
    Idot: "İ",
    Ifr: "ℑ",
    Igrave: "\xcc",
    Im: "ℑ",
    Imacr: "Ī",
    ImaginaryI: "ⅈ",
    Implies: "⇒",
    Int: "∬",
    Integral: "∫",
    Intersection: "⋂",
    InvisibleComma: "⁣",
    InvisibleTimes: "⁢",
    Iogon: "Į",
    Iopf: "\uD835\uDD40",
    Iota: "Ι",
    Iscr: "ℐ",
    Itilde: "Ĩ",
    Iukcy: "І",
    Iuml: "\xcf",
    Jcirc: "Ĵ",
    Jcy: "Й",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "Ј",
    Jukcy: "Є",
    KHcy: "Х",
    KJcy: "Ќ",
    Kappa: "Κ",
    Kcedil: "Ķ",
    Kcy: "К",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "Љ",
    LT: "<",
    Lacute: "Ĺ",
    Lambda: "Λ",
    Lang: "⟪",
    Laplacetrf: "ℒ",
    Larr: "↞",
    Lcaron: "Ľ",
    Lcedil: "Ļ",
    Lcy: "Л",
    LeftAngleBracket: "⟨",
    LeftArrow: "←",
    LeftArrowBar: "⇤",
    LeftArrowRightArrow: "⇆",
    LeftCeiling: "⌈",
    LeftDoubleBracket: "⟦",
    LeftDownTeeVector: "⥡",
    LeftDownVector: "⇃",
    LeftDownVectorBar: "⥙",
    LeftFloor: "⌊",
    LeftRightArrow: "↔",
    LeftRightVector: "⥎",
    LeftTee: "⊣",
    LeftTeeArrow: "↤",
    LeftTeeVector: "⥚",
    LeftTriangle: "⊲",
    LeftTriangleBar: "⧏",
    LeftTriangleEqual: "⊴",
    LeftUpDownVector: "⥑",
    LeftUpTeeVector: "⥠",
    LeftUpVector: "↿",
    LeftUpVectorBar: "⥘",
    LeftVector: "↼",
    LeftVectorBar: "⥒",
    Leftarrow: "⇐",
    Leftrightarrow: "⇔",
    LessEqualGreater: "⋚",
    LessFullEqual: "≦",
    LessGreater: "≶",
    LessLess: "⪡",
    LessSlantEqual: "⩽",
    LessTilde: "≲",
    Lfr: "\uD835\uDD0F",
    Ll: "⋘",
    Lleftarrow: "⇚",
    Lmidot: "Ŀ",
    LongLeftArrow: "⟵",
    LongLeftRightArrow: "⟷",
    LongRightArrow: "⟶",
    Longleftarrow: "⟸",
    Longleftrightarrow: "⟺",
    Longrightarrow: "⟹",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "↙",
    LowerRightArrow: "↘",
    Lscr: "ℒ",
    Lsh: "↰",
    Lstrok: "Ł",
    Lt: "≪",
    Map: "⤅",
    Mcy: "М",
    MediumSpace: " ",
    Mellintrf: "ℳ",
    Mfr: "\uD835\uDD10",
    MinusPlus: "∓",
    Mopf: "\uD835\uDD44",
    Mscr: "ℳ",
    Mu: "Μ",
    NJcy: "Њ",
    Nacute: "Ń",
    Ncaron: "Ň",
    Ncedil: "Ņ",
    Ncy: "Н",
    NegativeMediumSpace: "​",
    NegativeThickSpace: "​",
    NegativeThinSpace: "​",
    NegativeVeryThinSpace: "​",
    NestedGreaterGreater: "≫",
    NestedLessLess: "≪",
    NewLine: "\n",
    Nfr: "\uD835\uDD11",
    NoBreak: "⁠",
    NonBreakingSpace: "\xa0",
    Nopf: "ℕ",
    Not: "⫬",
    NotCongruent: "≢",
    NotCupCap: "≭",
    NotDoubleVerticalBar: "∦",
    NotElement: "∉",
    NotEqual: "≠",
    NotEqualTilde: "≂̸",
    NotExists: "∄",
    NotGreater: "≯",
    NotGreaterEqual: "≱",
    NotGreaterFullEqual: "≧̸",
    NotGreaterGreater: "≫̸",
    NotGreaterLess: "≹",
    NotGreaterSlantEqual: "⩾̸",
    NotGreaterTilde: "≵",
    NotHumpDownHump: "≎̸",
    NotHumpEqual: "≏̸",
    NotLeftTriangle: "⋪",
    NotLeftTriangleBar: "⧏̸",
    NotLeftTriangleEqual: "⋬",
    NotLess: "≮",
    NotLessEqual: "≰",
    NotLessGreater: "≸",
    NotLessLess: "≪̸",
    NotLessSlantEqual: "⩽̸",
    NotLessTilde: "≴",
    NotNestedGreaterGreater: "⪢̸",
    NotNestedLessLess: "⪡̸",
    NotPrecedes: "⊀",
    NotPrecedesEqual: "⪯̸",
    NotPrecedesSlantEqual: "⋠",
    NotReverseElement: "∌",
    NotRightTriangle: "⋫",
    NotRightTriangleBar: "⧐̸",
    NotRightTriangleEqual: "⋭",
    NotSquareSubset: "⊏̸",
    NotSquareSubsetEqual: "⋢",
    NotSquareSuperset: "⊐̸",
    NotSquareSupersetEqual: "⋣",
    NotSubset: "⊂⃒",
    NotSubsetEqual: "⊈",
    NotSucceeds: "⊁",
    NotSucceedsEqual: "⪰̸",
    NotSucceedsSlantEqual: "⋡",
    NotSucceedsTilde: "≿̸",
    NotSuperset: "⊃⃒",
    NotSupersetEqual: "⊉",
    NotTilde: "≁",
    NotTildeEqual: "≄",
    NotTildeFullEqual: "≇",
    NotTildeTilde: "≉",
    NotVerticalBar: "∤",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "Ν",
    OElig: "Œ",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "О",
    Odblac: "Ő",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "Ō",
    Omega: "Ω",
    Omicron: "Ο",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "“",
    OpenCurlyQuote: "‘",
    Or: "⩔",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "⨷",
    Ouml: "\xd6",
    OverBar: "‾",
    OverBrace: "⏞",
    OverBracket: "⎴",
    OverParenthesis: "⏜",
    PartialD: "∂",
    Pcy: "П",
    Pfr: "\uD835\uDD13",
    Phi: "Φ",
    Pi: "Π",
    PlusMinus: "\xb1",
    Poincareplane: "ℌ",
    Popf: "ℙ",
    Pr: "⪻",
    Precedes: "≺",
    PrecedesEqual: "⪯",
    PrecedesSlantEqual: "≼",
    PrecedesTilde: "≾",
    Prime: "″",
    Product: "∏",
    Proportion: "∷",
    Proportional: "∝",
    Pscr: "\uD835\uDCAB",
    Psi: "Ψ",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "ℚ",
    Qscr: "\uD835\uDCAC",
    RBarr: "⤐",
    REG: "\xae",
    Racute: "Ŕ",
    Rang: "⟫",
    Rarr: "↠",
    Rarrtl: "⤖",
    Rcaron: "Ř",
    Rcedil: "Ŗ",
    Rcy: "Р",
    Re: "ℜ",
    ReverseElement: "∋",
    ReverseEquilibrium: "⇋",
    ReverseUpEquilibrium: "⥯",
    Rfr: "ℜ",
    Rho: "Ρ",
    RightAngleBracket: "⟩",
    RightArrow: "→",
    RightArrowBar: "⇥",
    RightArrowLeftArrow: "⇄",
    RightCeiling: "⌉",
    RightDoubleBracket: "⟧",
    RightDownTeeVector: "⥝",
    RightDownVector: "⇂",
    RightDownVectorBar: "⥕",
    RightFloor: "⌋",
    RightTee: "⊢",
    RightTeeArrow: "↦",
    RightTeeVector: "⥛",
    RightTriangle: "⊳",
    RightTriangleBar: "⧐",
    RightTriangleEqual: "⊵",
    RightUpDownVector: "⥏",
    RightUpTeeVector: "⥜",
    RightUpVector: "↾",
    RightUpVectorBar: "⥔",
    RightVector: "⇀",
    RightVectorBar: "⥓",
    Rightarrow: "⇒",
    Ropf: "ℝ",
    RoundImplies: "⥰",
    Rrightarrow: "⇛",
    Rscr: "ℛ",
    Rsh: "↱",
    RuleDelayed: "⧴",
    SHCHcy: "Щ",
    SHcy: "Ш",
    SOFTcy: "Ь",
    Sacute: "Ś",
    Sc: "⪼",
    Scaron: "Š",
    Scedil: "Ş",
    Scirc: "Ŝ",
    Scy: "С",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "↓",
    ShortLeftArrow: "←",
    ShortRightArrow: "→",
    ShortUpArrow: "↑",
    Sigma: "Σ",
    SmallCircle: "∘",
    Sopf: "\uD835\uDD4A",
    Sqrt: "√",
    Square: "□",
    SquareIntersection: "⊓",
    SquareSubset: "⊏",
    SquareSubsetEqual: "⊑",
    SquareSuperset: "⊐",
    SquareSupersetEqual: "⊒",
    SquareUnion: "⊔",
    Sscr: "\uD835\uDCAE",
    Star: "⋆",
    Sub: "⋐",
    Subset: "⋐",
    SubsetEqual: "⊆",
    Succeeds: "≻",
    SucceedsEqual: "⪰",
    SucceedsSlantEqual: "≽",
    SucceedsTilde: "≿",
    SuchThat: "∋",
    Sum: "∑",
    Sup: "⋑",
    Superset: "⊃",
    SupersetEqual: "⊇",
    Supset: "⋑",
    THORN: "\xde",
    TRADE: "™",
    TSHcy: "Ћ",
    TScy: "Ц",
    Tab: "	",
    Tau: "Τ",
    Tcaron: "Ť",
    Tcedil: "Ţ",
    Tcy: "Т",
    Tfr: "\uD835\uDD17",
    Therefore: "∴",
    Theta: "Θ",
    ThickSpace: "  ",
    ThinSpace: " ",
    Tilde: "∼",
    TildeEqual: "≃",
    TildeFullEqual: "≅",
    TildeTilde: "≈",
    Topf: "\uD835\uDD4B",
    TripleDot: "⃛",
    Tscr: "\uD835\uDCAF",
    Tstrok: "Ŧ",
    Uacute: "\xda",
    Uarr: "↟",
    Uarrocir: "⥉",
    Ubrcy: "Ў",
    Ubreve: "Ŭ",
    Ucirc: "\xdb",
    Ucy: "У",
    Udblac: "Ű",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "Ū",
    UnderBar: "_",
    UnderBrace: "⏟",
    UnderBracket: "⎵",
    UnderParenthesis: "⏝",
    Union: "⋃",
    UnionPlus: "⊎",
    Uogon: "Ų",
    Uopf: "\uD835\uDD4C",
    UpArrow: "↑",
    UpArrowBar: "⤒",
    UpArrowDownArrow: "⇅",
    UpDownArrow: "↕",
    UpEquilibrium: "⥮",
    UpTee: "⊥",
    UpTeeArrow: "↥",
    Uparrow: "⇑",
    Updownarrow: "⇕",
    UpperLeftArrow: "↖",
    UpperRightArrow: "↗",
    Upsi: "ϒ",
    Upsilon: "Υ",
    Uring: "Ů",
    Uscr: "\uD835\uDCB0",
    Utilde: "Ũ",
    Uuml: "\xdc",
    VDash: "⊫",
    Vbar: "⫫",
    Vcy: "В",
    Vdash: "⊩",
    Vdashl: "⫦",
    Vee: "⋁",
    Verbar: "‖",
    Vert: "‖",
    VerticalBar: "∣",
    VerticalLine: "|",
    VerticalSeparator: "❘",
    VerticalTilde: "≀",
    VeryThinSpace: " ",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "⊪",
    Wcirc: "Ŵ",
    Wedge: "⋀",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "Ξ",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "Я",
    YIcy: "Ї",
    YUcy: "Ю",
    Yacute: "\xdd",
    Ycirc: "Ŷ",
    Ycy: "Ы",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "Ÿ",
    ZHcy: "Ж",
    Zacute: "Ź",
    Zcaron: "Ž",
    Zcy: "З",
    Zdot: "Ż",
    ZeroWidthSpace: "​",
    Zeta: "Ζ",
    Zfr: "ℨ",
    Zopf: "ℤ",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "ă",
    ac: "∾",
    acE: "∾̳",
    acd: "∿",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "а",
    aelig: "\xe6",
    af: "⁡",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "ℵ",
    aleph: "ℵ",
    alpha: "α",
    amacr: "ā",
    amalg: "⨿",
    amp: "&",
    and: "∧",
    andand: "⩕",
    andd: "⩜",
    andslope: "⩘",
    andv: "⩚",
    ang: "∠",
    ange: "⦤",
    angle: "∠",
    angmsd: "∡",
    angmsdaa: "⦨",
    angmsdab: "⦩",
    angmsdac: "⦪",
    angmsdad: "⦫",
    angmsdae: "⦬",
    angmsdaf: "⦭",
    angmsdag: "⦮",
    angmsdah: "⦯",
    angrt: "∟",
    angrtvb: "⊾",
    angrtvbd: "⦝",
    angsph: "∢",
    angst: "\xc5",
    angzarr: "⍼",
    aogon: "ą",
    aopf: "\uD835\uDD52",
    ap: "≈",
    apE: "⩰",
    apacir: "⩯",
    ape: "≊",
    apid: "≋",
    apos: "'",
    approx: "≈",
    approxeq: "≊",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: "*",
    asymp: "≈",
    asympeq: "≍",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "∳",
    awint: "⨑",
    bNot: "⫭",
    backcong: "≌",
    backepsilon: "϶",
    backprime: "‵",
    backsim: "∽",
    backsimeq: "⋍",
    barvee: "⊽",
    barwed: "⌅",
    barwedge: "⌅",
    bbrk: "⎵",
    bbrktbrk: "⎶",
    bcong: "≌",
    bcy: "б",
    bdquo: "„",
    becaus: "∵",
    because: "∵",
    bemptyv: "⦰",
    bepsi: "϶",
    bernou: "ℬ",
    beta: "β",
    beth: "ℶ",
    between: "≬",
    bfr: "\uD835\uDD1F",
    bigcap: "⋂",
    bigcirc: "◯",
    bigcup: "⋃",
    bigodot: "⨀",
    bigoplus: "⨁",
    bigotimes: "⨂",
    bigsqcup: "⨆",
    bigstar: "★",
    bigtriangledown: "▽",
    bigtriangleup: "△",
    biguplus: "⨄",
    bigvee: "⋁",
    bigwedge: "⋀",
    bkarow: "⤍",
    blacklozenge: "⧫",
    blacksquare: "▪",
    blacktriangle: "▴",
    blacktriangledown: "▾",
    blacktriangleleft: "◂",
    blacktriangleright: "▸",
    blank: "␣",
    blk12: "▒",
    blk14: "░",
    blk34: "▓",
    block: "█",
    bne: "=⃥",
    bnequiv: "≡⃥",
    bnot: "⌐",
    bopf: "\uD835\uDD53",
    bot: "⊥",
    bottom: "⊥",
    bowtie: "⋈",
    boxDL: "╗",
    boxDR: "╔",
    boxDl: "╖",
    boxDr: "╓",
    boxH: "═",
    boxHD: "╦",
    boxHU: "╩",
    boxHd: "╤",
    boxHu: "╧",
    boxUL: "╝",
    boxUR: "╚",
    boxUl: "╜",
    boxUr: "╙",
    boxV: "║",
    boxVH: "╬",
    boxVL: "╣",
    boxVR: "╠",
    boxVh: "╫",
    boxVl: "╢",
    boxVr: "╟",
    boxbox: "⧉",
    boxdL: "╕",
    boxdR: "╒",
    boxdl: "┐",
    boxdr: "┌",
    boxh: "─",
    boxhD: "╥",
    boxhU: "╨",
    boxhd: "┬",
    boxhu: "┴",
    boxminus: "⊟",
    boxplus: "⊞",
    boxtimes: "⊠",
    boxuL: "╛",
    boxuR: "╘",
    boxul: "┘",
    boxur: "└",
    boxv: "│",
    boxvH: "╪",
    boxvL: "╡",
    boxvR: "╞",
    boxvh: "┼",
    boxvl: "┤",
    boxvr: "├",
    bprime: "‵",
    breve: "˘",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "⁏",
    bsim: "∽",
    bsime: "⋍",
    bsol: "\\",
    bsolb: "⧅",
    bsolhsub: "⟈",
    bull: "•",
    bullet: "•",
    bump: "≎",
    bumpE: "⪮",
    bumpe: "≏",
    bumpeq: "≏",
    cacute: "ć",
    cap: "∩",
    capand: "⩄",
    capbrcup: "⩉",
    capcap: "⩋",
    capcup: "⩇",
    capdot: "⩀",
    caps: "∩︀",
    caret: "⁁",
    caron: "ˇ",
    ccaps: "⩍",
    ccaron: "č",
    ccedil: "\xe7",
    ccirc: "ĉ",
    ccups: "⩌",
    ccupssm: "⩐",
    cdot: "ċ",
    cedil: "\xb8",
    cemptyv: "⦲",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "ч",
    check: "✓",
    checkmark: "✓",
    chi: "χ",
    cir: "○",
    cirE: "⧃",
    circ: "ˆ",
    circeq: "≗",
    circlearrowleft: "↺",
    circlearrowright: "↻",
    circledR: "\xae",
    circledS: "Ⓢ",
    circledast: "⊛",
    circledcirc: "⊚",
    circleddash: "⊝",
    cire: "≗",
    cirfnint: "⨐",
    cirmid: "⫯",
    cirscir: "⧂",
    clubs: "♣",
    clubsuit: "♣",
    colon: ":",
    colone: "≔",
    coloneq: "≔",
    comma: ",",
    commat: "@",
    comp: "∁",
    compfn: "∘",
    complement: "∁",
    complexes: "ℂ",
    cong: "≅",
    congdot: "⩭",
    conint: "∮",
    copf: "\uD835\uDD54",
    coprod: "∐",
    copy: "\xa9",
    copysr: "℗",
    crarr: "↵",
    cross: "✗",
    cscr: "\uD835\uDCB8",
    csub: "⫏",
    csube: "⫑",
    csup: "⫐",
    csupe: "⫒",
    ctdot: "⋯",
    cudarrl: "⤸",
    cudarrr: "⤵",
    cuepr: "⋞",
    cuesc: "⋟",
    cularr: "↶",
    cularrp: "⤽",
    cup: "∪",
    cupbrcap: "⩈",
    cupcap: "⩆",
    cupcup: "⩊",
    cupdot: "⊍",
    cupor: "⩅",
    cups: "∪︀",
    curarr: "↷",
    curarrm: "⤼",
    curlyeqprec: "⋞",
    curlyeqsucc: "⋟",
    curlyvee: "⋎",
    curlywedge: "⋏",
    curren: "\xa4",
    curvearrowleft: "↶",
    curvearrowright: "↷",
    cuvee: "⋎",
    cuwed: "⋏",
    cwconint: "∲",
    cwint: "∱",
    cylcty: "⌭",
    dArr: "⇓",
    dHar: "⥥",
    dagger: "†",
    daleth: "ℸ",
    darr: "↓",
    dash: "‐",
    dashv: "⊣",
    dbkarow: "⤏",
    dblac: "˝",
    dcaron: "ď",
    dcy: "д",
    dd: "ⅆ",
    ddagger: "‡",
    ddarr: "⇊",
    ddotseq: "⩷",
    deg: "\xb0",
    delta: "δ",
    demptyv: "⦱",
    dfisht: "⥿",
    dfr: "\uD835\uDD21",
    dharl: "⇃",
    dharr: "⇂",
    diam: "⋄",
    diamond: "⋄",
    diamondsuit: "♦",
    diams: "♦",
    die: "\xa8",
    digamma: "ϝ",
    disin: "⋲",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "⋇",
    divonx: "⋇",
    djcy: "ђ",
    dlcorn: "⌞",
    dlcrop: "⌍",
    dollar: "$",
    dopf: "\uD835\uDD55",
    dot: "˙",
    doteq: "≐",
    doteqdot: "≑",
    dotminus: "∸",
    dotplus: "∔",
    dotsquare: "⊡",
    doublebarwedge: "⌆",
    downarrow: "↓",
    downdownarrows: "⇊",
    downharpoonleft: "⇃",
    downharpoonright: "⇂",
    drbkarow: "⤐",
    drcorn: "⌟",
    drcrop: "⌌",
    dscr: "\uD835\uDCB9",
    dscy: "ѕ",
    dsol: "⧶",
    dstrok: "đ",
    dtdot: "⋱",
    dtri: "▿",
    dtrif: "▾",
    duarr: "⇵",
    duhar: "⥯",
    dwangle: "⦦",
    dzcy: "џ",
    dzigrarr: "⟿",
    eDDot: "⩷",
    eDot: "≑",
    eacute: "\xe9",
    easter: "⩮",
    ecaron: "ě",
    ecir: "≖",
    ecirc: "\xea",
    ecolon: "≕",
    ecy: "э",
    edot: "ė",
    ee: "ⅇ",
    efDot: "≒",
    efr: "\uD835\uDD22",
    eg: "⪚",
    egrave: "\xe8",
    egs: "⪖",
    egsdot: "⪘",
    el: "⪙",
    elinters: "⏧",
    ell: "ℓ",
    els: "⪕",
    elsdot: "⪗",
    emacr: "ē",
    empty: "∅",
    emptyset: "∅",
    emptyv: "∅",
    emsp13: " ",
    emsp14: " ",
    emsp: " ",
    eng: "ŋ",
    ensp: " ",
    eogon: "ę",
    eopf: "\uD835\uDD56",
    epar: "⋕",
    eparsl: "⧣",
    eplus: "⩱",
    epsi: "ε",
    epsilon: "ε",
    epsiv: "ϵ",
    eqcirc: "≖",
    eqcolon: "≕",
    eqsim: "≂",
    eqslantgtr: "⪖",
    eqslantless: "⪕",
    equals: "=",
    equest: "≟",
    equiv: "≡",
    equivDD: "⩸",
    eqvparsl: "⧥",
    erDot: "≓",
    erarr: "⥱",
    escr: "ℯ",
    esdot: "≐",
    esim: "≂",
    eta: "η",
    eth: "\xf0",
    euml: "\xeb",
    euro: "€",
    excl: "!",
    exist: "∃",
    expectation: "ℰ",
    exponentiale: "ⅇ",
    fallingdotseq: "≒",
    fcy: "ф",
    female: "♀",
    ffilig: "ﬃ",
    fflig: "ﬀ",
    ffllig: "ﬄ",
    ffr: "\uD835\uDD23",
    filig: "ﬁ",
    fjlig: "fj",
    flat: "♭",
    fllig: "ﬂ",
    fltns: "▱",
    fnof: "ƒ",
    fopf: "\uD835\uDD57",
    forall: "∀",
    fork: "⋔",
    forkv: "⫙",
    fpartint: "⨍",
    frac12: "\xbd",
    frac13: "⅓",
    frac14: "\xbc",
    frac15: "⅕",
    frac16: "⅙",
    frac18: "⅛",
    frac23: "⅔",
    frac25: "⅖",
    frac34: "\xbe",
    frac35: "⅗",
    frac38: "⅜",
    frac45: "⅘",
    frac56: "⅚",
    frac58: "⅝",
    frac78: "⅞",
    frasl: "⁄",
    frown: "⌢",
    fscr: "\uD835\uDCBB",
    gE: "≧",
    gEl: "⪌",
    gacute: "ǵ",
    gamma: "γ",
    gammad: "ϝ",
    gap: "⪆",
    gbreve: "ğ",
    gcirc: "ĝ",
    gcy: "г",
    gdot: "ġ",
    ge: "≥",
    gel: "⋛",
    geq: "≥",
    geqq: "≧",
    geqslant: "⩾",
    ges: "⩾",
    gescc: "⪩",
    gesdot: "⪀",
    gesdoto: "⪂",
    gesdotol: "⪄",
    gesl: "⋛︀",
    gesles: "⪔",
    gfr: "\uD835\uDD24",
    gg: "≫",
    ggg: "⋙",
    gimel: "ℷ",
    gjcy: "ѓ",
    gl: "≷",
    glE: "⪒",
    gla: "⪥",
    glj: "⪤",
    gnE: "≩",
    gnap: "⪊",
    gnapprox: "⪊",
    gne: "⪈",
    gneq: "⪈",
    gneqq: "≩",
    gnsim: "⋧",
    gopf: "\uD835\uDD58",
    grave: "`",
    gscr: "ℊ",
    gsim: "≳",
    gsime: "⪎",
    gsiml: "⪐",
    gt: ">",
    gtcc: "⪧",
    gtcir: "⩺",
    gtdot: "⋗",
    gtlPar: "⦕",
    gtquest: "⩼",
    gtrapprox: "⪆",
    gtrarr: "⥸",
    gtrdot: "⋗",
    gtreqless: "⋛",
    gtreqqless: "⪌",
    gtrless: "≷",
    gtrsim: "≳",
    gvertneqq: "≩︀",
    gvnE: "≩︀",
    hArr: "⇔",
    hairsp: " ",
    half: "\xbd",
    hamilt: "ℋ",
    hardcy: "ъ",
    harr: "↔",
    harrcir: "⥈",
    harrw: "↭",
    hbar: "ℏ",
    hcirc: "ĥ",
    hearts: "♥",
    heartsuit: "♥",
    hellip: "…",
    hercon: "⊹",
    hfr: "\uD835\uDD25",
    hksearow: "⤥",
    hkswarow: "⤦",
    hoarr: "⇿",
    homtht: "∻",
    hookleftarrow: "↩",
    hookrightarrow: "↪",
    hopf: "\uD835\uDD59",
    horbar: "―",
    hscr: "\uD835\uDCBD",
    hslash: "ℏ",
    hstrok: "ħ",
    hybull: "⁃",
    hyphen: "‐",
    iacute: "\xed",
    ic: "⁣",
    icirc: "\xee",
    icy: "и",
    iecy: "е",
    iexcl: "\xa1",
    iff: "⇔",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "ⅈ",
    iiiint: "⨌",
    iiint: "∭",
    iinfin: "⧜",
    iiota: "℩",
    ijlig: "ĳ",
    imacr: "ī",
    image: "ℑ",
    imagline: "ℐ",
    imagpart: "ℑ",
    imath: "ı",
    imof: "⊷",
    imped: "Ƶ",
    in: "∈",
    incare: "℅",
    infin: "∞",
    infintie: "⧝",
    inodot: "ı",
    int: "∫",
    intcal: "⊺",
    integers: "ℤ",
    intercal: "⊺",
    intlarhk: "⨗",
    intprod: "⨼",
    iocy: "ё",
    iogon: "į",
    iopf: "\uD835\uDD5A",
    iota: "ι",
    iprod: "⨼",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "∈",
    isinE: "⋹",
    isindot: "⋵",
    isins: "⋴",
    isinsv: "⋳",
    isinv: "∈",
    it: "⁢",
    itilde: "ĩ",
    iukcy: "і",
    iuml: "\xef",
    jcirc: "ĵ",
    jcy: "й",
    jfr: "\uD835\uDD27",
    jmath: "ȷ",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "ј",
    jukcy: "є",
    kappa: "κ",
    kappav: "ϰ",
    kcedil: "ķ",
    kcy: "к",
    kfr: "\uD835\uDD28",
    kgreen: "ĸ",
    khcy: "х",
    kjcy: "ќ",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "⇚",
    lArr: "⇐",
    lAtail: "⤛",
    lBarr: "⤎",
    lE: "≦",
    lEg: "⪋",
    lHar: "⥢",
    lacute: "ĺ",
    laemptyv: "⦴",
    lagran: "ℒ",
    lambda: "λ",
    lang: "⟨",
    langd: "⦑",
    langle: "⟨",
    lap: "⪅",
    laquo: "\xab",
    larr: "←",
    larrb: "⇤",
    larrbfs: "⤟",
    larrfs: "⤝",
    larrhk: "↩",
    larrlp: "↫",
    larrpl: "⤹",
    larrsim: "⥳",
    larrtl: "↢",
    lat: "⪫",
    latail: "⤙",
    late: "⪭",
    lates: "⪭︀",
    lbarr: "⤌",
    lbbrk: "❲",
    lbrace: "{",
    lbrack: "[",
    lbrke: "⦋",
    lbrksld: "⦏",
    lbrkslu: "⦍",
    lcaron: "ľ",
    lcedil: "ļ",
    lceil: "⌈",
    lcub: "{",
    lcy: "л",
    ldca: "⤶",
    ldquo: "“",
    ldquor: "„",
    ldrdhar: "⥧",
    ldrushar: "⥋",
    ldsh: "↲",
    le: "≤",
    leftarrow: "←",
    leftarrowtail: "↢",
    leftharpoondown: "↽",
    leftharpoonup: "↼",
    leftleftarrows: "⇇",
    leftrightarrow: "↔",
    leftrightarrows: "⇆",
    leftrightharpoons: "⇋",
    leftrightsquigarrow: "↭",
    leftthreetimes: "⋋",
    leg: "⋚",
    leq: "≤",
    leqq: "≦",
    leqslant: "⩽",
    les: "⩽",
    lescc: "⪨",
    lesdot: "⩿",
    lesdoto: "⪁",
    lesdotor: "⪃",
    lesg: "⋚︀",
    lesges: "⪓",
    lessapprox: "⪅",
    lessdot: "⋖",
    lesseqgtr: "⋚",
    lesseqqgtr: "⪋",
    lessgtr: "≶",
    lesssim: "≲",
    lfisht: "⥼",
    lfloor: "⌊",
    lfr: "\uD835\uDD29",
    lg: "≶",
    lgE: "⪑",
    lhard: "↽",
    lharu: "↼",
    lharul: "⥪",
    lhblk: "▄",
    ljcy: "љ",
    ll: "≪",
    llarr: "⇇",
    llcorner: "⌞",
    llhard: "⥫",
    lltri: "◺",
    lmidot: "ŀ",
    lmoust: "⎰",
    lmoustache: "⎰",
    lnE: "≨",
    lnap: "⪉",
    lnapprox: "⪉",
    lne: "⪇",
    lneq: "⪇",
    lneqq: "≨",
    lnsim: "⋦",
    loang: "⟬",
    loarr: "⇽",
    lobrk: "⟦",
    longleftarrow: "⟵",
    longleftrightarrow: "⟷",
    longmapsto: "⟼",
    longrightarrow: "⟶",
    looparrowleft: "↫",
    looparrowright: "↬",
    lopar: "⦅",
    lopf: "\uD835\uDD5D",
    loplus: "⨭",
    lotimes: "⨴",
    lowast: "∗",
    lowbar: "_",
    loz: "◊",
    lozenge: "◊",
    lozf: "⧫",
    lpar: "(",
    lparlt: "⦓",
    lrarr: "⇆",
    lrcorner: "⌟",
    lrhar: "⇋",
    lrhard: "⥭",
    lrm: "‎",
    lrtri: "⊿",
    lsaquo: "‹",
    lscr: "\uD835\uDCC1",
    lsh: "↰",
    lsim: "≲",
    lsime: "⪍",
    lsimg: "⪏",
    lsqb: "[",
    lsquo: "‘",
    lsquor: "‚",
    lstrok: "ł",
    lt: "<",
    ltcc: "⪦",
    ltcir: "⩹",
    ltdot: "⋖",
    lthree: "⋋",
    ltimes: "⋉",
    ltlarr: "⥶",
    ltquest: "⩻",
    ltrPar: "⦖",
    ltri: "◃",
    ltrie: "⊴",
    ltrif: "◂",
    lurdshar: "⥊",
    luruhar: "⥦",
    lvertneqq: "≨︀",
    lvnE: "≨︀",
    mDDot: "∺",
    macr: "\xaf",
    male: "♂",
    malt: "✠",
    maltese: "✠",
    map: "↦",
    mapsto: "↦",
    mapstodown: "↧",
    mapstoleft: "↤",
    mapstoup: "↥",
    marker: "▮",
    mcomma: "⨩",
    mcy: "м",
    mdash: "—",
    measuredangle: "∡",
    mfr: "\uD835\uDD2A",
    mho: "℧",
    micro: "\xb5",
    mid: "∣",
    midast: "*",
    midcir: "⫰",
    middot: "\xb7",
    minus: "−",
    minusb: "⊟",
    minusd: "∸",
    minusdu: "⨪",
    mlcp: "⫛",
    mldr: "…",
    mnplus: "∓",
    models: "⊧",
    mopf: "\uD835\uDD5E",
    mp: "∓",
    mscr: "\uD835\uDCC2",
    mstpos: "∾",
    mu: "μ",
    multimap: "⊸",
    mumap: "⊸",
    nGg: "⋙̸",
    nGt: "≫⃒",
    nGtv: "≫̸",
    nLeftarrow: "⇍",
    nLeftrightarrow: "⇎",
    nLl: "⋘̸",
    nLt: "≪⃒",
    nLtv: "≪̸",
    nRightarrow: "⇏",
    nVDash: "⊯",
    nVdash: "⊮",
    nabla: "∇",
    nacute: "ń",
    nang: "∠⃒",
    nap: "≉",
    napE: "⩰̸",
    napid: "≋̸",
    napos: "ŉ",
    napprox: "≉",
    natur: "♮",
    natural: "♮",
    naturals: "ℕ",
    nbsp: "\xa0",
    nbump: "≎̸",
    nbumpe: "≏̸",
    ncap: "⩃",
    ncaron: "ň",
    ncedil: "ņ",
    ncong: "≇",
    ncongdot: "⩭̸",
    ncup: "⩂",
    ncy: "н",
    ndash: "–",
    ne: "≠",
    neArr: "⇗",
    nearhk: "⤤",
    nearr: "↗",
    nearrow: "↗",
    nedot: "≐̸",
    nequiv: "≢",
    nesear: "⤨",
    nesim: "≂̸",
    nexist: "∄",
    nexists: "∄",
    nfr: "\uD835\uDD2B",
    ngE: "≧̸",
    nge: "≱",
    ngeq: "≱",
    ngeqq: "≧̸",
    ngeqslant: "⩾̸",
    nges: "⩾̸",
    ngsim: "≵",
    ngt: "≯",
    ngtr: "≯",
    nhArr: "⇎",
    nharr: "↮",
    nhpar: "⫲",
    ni: "∋",
    nis: "⋼",
    nisd: "⋺",
    niv: "∋",
    njcy: "њ",
    nlArr: "⇍",
    nlE: "≦̸",
    nlarr: "↚",
    nldr: "‥",
    nle: "≰",
    nleftarrow: "↚",
    nleftrightarrow: "↮",
    nleq: "≰",
    nleqq: "≦̸",
    nleqslant: "⩽̸",
    nles: "⩽̸",
    nless: "≮",
    nlsim: "≴",
    nlt: "≮",
    nltri: "⋪",
    nltrie: "⋬",
    nmid: "∤",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "∉",
    notinE: "⋹̸",
    notindot: "⋵̸",
    notinva: "∉",
    notinvb: "⋷",
    notinvc: "⋶",
    notni: "∌",
    notniva: "∌",
    notnivb: "⋾",
    notnivc: "⋽",
    npar: "∦",
    nparallel: "∦",
    nparsl: "⫽⃥",
    npart: "∂̸",
    npolint: "⨔",
    npr: "⊀",
    nprcue: "⋠",
    npre: "⪯̸",
    nprec: "⊀",
    npreceq: "⪯̸",
    nrArr: "⇏",
    nrarr: "↛",
    nrarrc: "⤳̸",
    nrarrw: "↝̸",
    nrightarrow: "↛",
    nrtri: "⋫",
    nrtrie: "⋭",
    nsc: "⊁",
    nsccue: "⋡",
    nsce: "⪰̸",
    nscr: "\uD835\uDCC3",
    nshortmid: "∤",
    nshortparallel: "∦",
    nsim: "≁",
    nsime: "≄",
    nsimeq: "≄",
    nsmid: "∤",
    nspar: "∦",
    nsqsube: "⋢",
    nsqsupe: "⋣",
    nsub: "⊄",
    nsubE: "⫅̸",
    nsube: "⊈",
    nsubset: "⊂⃒",
    nsubseteq: "⊈",
    nsubseteqq: "⫅̸",
    nsucc: "⊁",
    nsucceq: "⪰̸",
    nsup: "⊅",
    nsupE: "⫆̸",
    nsupe: "⊉",
    nsupset: "⊃⃒",
    nsupseteq: "⊉",
    nsupseteqq: "⫆̸",
    ntgl: "≹",
    ntilde: "\xf1",
    ntlg: "≸",
    ntriangleleft: "⋪",
    ntrianglelefteq: "⋬",
    ntriangleright: "⋫",
    ntrianglerighteq: "⋭",
    nu: "ν",
    num: "#",
    numero: "№",
    numsp: " ",
    nvDash: "⊭",
    nvHarr: "⤄",
    nvap: "≍⃒",
    nvdash: "⊬",
    nvge: "≥⃒",
    nvgt: ">⃒",
    nvinfin: "⧞",
    nvlArr: "⤂",
    nvle: "≤⃒",
    nvlt: "<⃒",
    nvltrie: "⊴⃒",
    nvrArr: "⤃",
    nvrtrie: "⊵⃒",
    nvsim: "∼⃒",
    nwArr: "⇖",
    nwarhk: "⤣",
    nwarr: "↖",
    nwarrow: "↖",
    nwnear: "⤧",
    oS: "Ⓢ",
    oacute: "\xf3",
    oast: "⊛",
    ocir: "⊚",
    ocirc: "\xf4",
    ocy: "о",
    odash: "⊝",
    odblac: "ő",
    odiv: "⨸",
    odot: "⊙",
    odsold: "⦼",
    oelig: "œ",
    ofcir: "⦿",
    ofr: "\uD835\uDD2C",
    ogon: "˛",
    ograve: "\xf2",
    ogt: "⧁",
    ohbar: "⦵",
    ohm: "Ω",
    oint: "∮",
    olarr: "↺",
    olcir: "⦾",
    olcross: "⦻",
    oline: "‾",
    olt: "⧀",
    omacr: "ō",
    omega: "ω",
    omicron: "ο",
    omid: "⦶",
    ominus: "⊖",
    oopf: "\uD835\uDD60",
    opar: "⦷",
    operp: "⦹",
    oplus: "⊕",
    or: "∨",
    orarr: "↻",
    ord: "⩝",
    order: "ℴ",
    orderof: "ℴ",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "⊶",
    oror: "⩖",
    orslope: "⩗",
    orv: "⩛",
    oscr: "ℴ",
    oslash: "\xf8",
    osol: "⊘",
    otilde: "\xf5",
    otimes: "⊗",
    otimesas: "⨶",
    ouml: "\xf6",
    ovbar: "⌽",
    par: "∥",
    para: "\xb6",
    parallel: "∥",
    parsim: "⫳",
    parsl: "⫽",
    part: "∂",
    pcy: "п",
    percnt: "%",
    period: ".",
    permil: "‰",
    perp: "⊥",
    pertenk: "‱",
    pfr: "\uD835\uDD2D",
    phi: "φ",
    phiv: "ϕ",
    phmmat: "ℳ",
    phone: "☎",
    pi: "π",
    pitchfork: "⋔",
    piv: "ϖ",
    planck: "ℏ",
    planckh: "ℎ",
    plankv: "ℏ",
    plus: "+",
    plusacir: "⨣",
    plusb: "⊞",
    pluscir: "⨢",
    plusdo: "∔",
    plusdu: "⨥",
    pluse: "⩲",
    plusmn: "\xb1",
    plussim: "⨦",
    plustwo: "⨧",
    pm: "\xb1",
    pointint: "⨕",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "≺",
    prE: "⪳",
    prap: "⪷",
    prcue: "≼",
    pre: "⪯",
    prec: "≺",
    precapprox: "⪷",
    preccurlyeq: "≼",
    preceq: "⪯",
    precnapprox: "⪹",
    precneqq: "⪵",
    precnsim: "⋨",
    precsim: "≾",
    prime: "′",
    primes: "ℙ",
    prnE: "⪵",
    prnap: "⪹",
    prnsim: "⋨",
    prod: "∏",
    profalar: "⌮",
    profline: "⌒",
    profsurf: "⌓",
    prop: "∝",
    propto: "∝",
    prsim: "≾",
    prurel: "⊰",
    pscr: "\uD835\uDCC5",
    psi: "ψ",
    puncsp: " ",
    qfr: "\uD835\uDD2E",
    qint: "⨌",
    qopf: "\uD835\uDD62",
    qprime: "⁗",
    qscr: "\uD835\uDCC6",
    quaternions: "ℍ",
    quatint: "⨖",
    quest: "?",
    questeq: "≟",
    quot: '"',
    rAarr: "⇛",
    rArr: "⇒",
    rAtail: "⤜",
    rBarr: "⤏",
    rHar: "⥤",
    race: "∽̱",
    racute: "ŕ",
    radic: "√",
    raemptyv: "⦳",
    rang: "⟩",
    rangd: "⦒",
    range: "⦥",
    rangle: "⟩",
    raquo: "\xbb",
    rarr: "→",
    rarrap: "⥵",
    rarrb: "⇥",
    rarrbfs: "⤠",
    rarrc: "⤳",
    rarrfs: "⤞",
    rarrhk: "↪",
    rarrlp: "↬",
    rarrpl: "⥅",
    rarrsim: "⥴",
    rarrtl: "↣",
    rarrw: "↝",
    ratail: "⤚",
    ratio: "∶",
    rationals: "ℚ",
    rbarr: "⤍",
    rbbrk: "❳",
    rbrace: "}",
    rbrack: "]",
    rbrke: "⦌",
    rbrksld: "⦎",
    rbrkslu: "⦐",
    rcaron: "ř",
    rcedil: "ŗ",
    rceil: "⌉",
    rcub: "}",
    rcy: "р",
    rdca: "⤷",
    rdldhar: "⥩",
    rdquo: "”",
    rdquor: "”",
    rdsh: "↳",
    real: "ℜ",
    realine: "ℛ",
    realpart: "ℜ",
    reals: "ℝ",
    rect: "▭",
    reg: "\xae",
    rfisht: "⥽",
    rfloor: "⌋",
    rfr: "\uD835\uDD2F",
    rhard: "⇁",
    rharu: "⇀",
    rharul: "⥬",
    rho: "ρ",
    rhov: "ϱ",
    rightarrow: "→",
    rightarrowtail: "↣",
    rightharpoondown: "⇁",
    rightharpoonup: "⇀",
    rightleftarrows: "⇄",
    rightleftharpoons: "⇌",
    rightrightarrows: "⇉",
    rightsquigarrow: "↝",
    rightthreetimes: "⋌",
    ring: "˚",
    risingdotseq: "≓",
    rlarr: "⇄",
    rlhar: "⇌",
    rlm: "‏",
    rmoust: "⎱",
    rmoustache: "⎱",
    rnmid: "⫮",
    roang: "⟭",
    roarr: "⇾",
    robrk: "⟧",
    ropar: "⦆",
    ropf: "\uD835\uDD63",
    roplus: "⨮",
    rotimes: "⨵",
    rpar: ")",
    rpargt: "⦔",
    rppolint: "⨒",
    rrarr: "⇉",
    rsaquo: "›",
    rscr: "\uD835\uDCC7",
    rsh: "↱",
    rsqb: "]",
    rsquo: "’",
    rsquor: "’",
    rthree: "⋌",
    rtimes: "⋊",
    rtri: "▹",
    rtrie: "⊵",
    rtrif: "▸",
    rtriltri: "⧎",
    ruluhar: "⥨",
    rx: "℞",
    sacute: "ś",
    sbquo: "‚",
    sc: "≻",
    scE: "⪴",
    scap: "⪸",
    scaron: "š",
    sccue: "≽",
    sce: "⪰",
    scedil: "ş",
    scirc: "ŝ",
    scnE: "⪶",
    scnap: "⪺",
    scnsim: "⋩",
    scpolint: "⨓",
    scsim: "≿",
    scy: "с",
    sdot: "⋅",
    sdotb: "⊡",
    sdote: "⩦",
    seArr: "⇘",
    searhk: "⤥",
    searr: "↘",
    searrow: "↘",
    sect: "\xa7",
    semi: ";",
    seswar: "⤩",
    setminus: "∖",
    setmn: "∖",
    sext: "✶",
    sfr: "\uD835\uDD30",
    sfrown: "⌢",
    sharp: "♯",
    shchcy: "щ",
    shcy: "ш",
    shortmid: "∣",
    shortparallel: "∥",
    shy: "\xad",
    sigma: "σ",
    sigmaf: "ς",
    sigmav: "ς",
    sim: "∼",
    simdot: "⩪",
    sime: "≃",
    simeq: "≃",
    simg: "⪞",
    simgE: "⪠",
    siml: "⪝",
    simlE: "⪟",
    simne: "≆",
    simplus: "⨤",
    simrarr: "⥲",
    slarr: "←",
    smallsetminus: "∖",
    smashp: "⨳",
    smeparsl: "⧤",
    smid: "∣",
    smile: "⌣",
    smt: "⪪",
    smte: "⪬",
    smtes: "⪬︀",
    softcy: "ь",
    sol: "/",
    solb: "⧄",
    solbar: "⌿",
    sopf: "\uD835\uDD64",
    spades: "♠",
    spadesuit: "♠",
    spar: "∥",
    sqcap: "⊓",
    sqcaps: "⊓︀",
    sqcup: "⊔",
    sqcups: "⊔︀",
    sqsub: "⊏",
    sqsube: "⊑",
    sqsubset: "⊏",
    sqsubseteq: "⊑",
    sqsup: "⊐",
    sqsupe: "⊒",
    sqsupset: "⊐",
    sqsupseteq: "⊒",
    squ: "□",
    square: "□",
    squarf: "▪",
    squf: "▪",
    srarr: "→",
    sscr: "\uD835\uDCC8",
    ssetmn: "∖",
    ssmile: "⌣",
    sstarf: "⋆",
    star: "☆",
    starf: "★",
    straightepsilon: "ϵ",
    straightphi: "ϕ",
    strns: "\xaf",
    sub: "⊂",
    subE: "⫅",
    subdot: "⪽",
    sube: "⊆",
    subedot: "⫃",
    submult: "⫁",
    subnE: "⫋",
    subne: "⊊",
    subplus: "⪿",
    subrarr: "⥹",
    subset: "⊂",
    subseteq: "⊆",
    subseteqq: "⫅",
    subsetneq: "⊊",
    subsetneqq: "⫋",
    subsim: "⫇",
    subsub: "⫕",
    subsup: "⫓",
    succ: "≻",
    succapprox: "⪸",
    succcurlyeq: "≽",
    succeq: "⪰",
    succnapprox: "⪺",
    succneqq: "⪶",
    succnsim: "⋩",
    succsim: "≿",
    sum: "∑",
    sung: "♪",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "⊃",
    supE: "⫆",
    supdot: "⪾",
    supdsub: "⫘",
    supe: "⊇",
    supedot: "⫄",
    suphsol: "⟉",
    suphsub: "⫗",
    suplarr: "⥻",
    supmult: "⫂",
    supnE: "⫌",
    supne: "⊋",
    supplus: "⫀",
    supset: "⊃",
    supseteq: "⊇",
    supseteqq: "⫆",
    supsetneq: "⊋",
    supsetneqq: "⫌",
    supsim: "⫈",
    supsub: "⫔",
    supsup: "⫖",
    swArr: "⇙",
    swarhk: "⤦",
    swarr: "↙",
    swarrow: "↙",
    swnwar: "⤪",
    szlig: "\xdf",
    target: "⌖",
    tau: "τ",
    tbrk: "⎴",
    tcaron: "ť",
    tcedil: "ţ",
    tcy: "т",
    tdot: "⃛",
    telrec: "⌕",
    tfr: "\uD835\uDD31",
    there4: "∴",
    therefore: "∴",
    theta: "θ",
    thetasym: "ϑ",
    thetav: "ϑ",
    thickapprox: "≈",
    thicksim: "∼",
    thinsp: " ",
    thkap: "≈",
    thksim: "∼",
    thorn: "\xfe",
    tilde: "˜",
    times: "\xd7",
    timesb: "⊠",
    timesbar: "⨱",
    timesd: "⨰",
    tint: "∭",
    toea: "⤨",
    top: "⊤",
    topbot: "⌶",
    topcir: "⫱",
    topf: "\uD835\uDD65",
    topfork: "⫚",
    tosa: "⤩",
    tprime: "‴",
    trade: "™",
    triangle: "▵",
    triangledown: "▿",
    triangleleft: "◃",
    trianglelefteq: "⊴",
    triangleq: "≜",
    triangleright: "▹",
    trianglerighteq: "⊵",
    tridot: "◬",
    trie: "≜",
    triminus: "⨺",
    triplus: "⨹",
    trisb: "⧍",
    tritime: "⨻",
    trpezium: "⏢",
    tscr: "\uD835\uDCC9",
    tscy: "ц",
    tshcy: "ћ",
    tstrok: "ŧ",
    twixt: "≬",
    twoheadleftarrow: "↞",
    twoheadrightarrow: "↠",
    uArr: "⇑",
    uHar: "⥣",
    uacute: "\xfa",
    uarr: "↑",
    ubrcy: "ў",
    ubreve: "ŭ",
    ucirc: "\xfb",
    ucy: "у",
    udarr: "⇅",
    udblac: "ű",
    udhar: "⥮",
    ufisht: "⥾",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "↿",
    uharr: "↾",
    uhblk: "▀",
    ulcorn: "⌜",
    ulcorner: "⌜",
    ulcrop: "⌏",
    ultri: "◸",
    umacr: "ū",
    uml: "\xa8",
    uogon: "ų",
    uopf: "\uD835\uDD66",
    uparrow: "↑",
    updownarrow: "↕",
    upharpoonleft: "↿",
    upharpoonright: "↾",
    uplus: "⊎",
    upsi: "υ",
    upsih: "ϒ",
    upsilon: "υ",
    upuparrows: "⇈",
    urcorn: "⌝",
    urcorner: "⌝",
    urcrop: "⌎",
    uring: "ů",
    urtri: "◹",
    uscr: "\uD835\uDCCA",
    utdot: "⋰",
    utilde: "ũ",
    utri: "▵",
    utrif: "▴",
    uuarr: "⇈",
    uuml: "\xfc",
    uwangle: "⦧",
    vArr: "⇕",
    vBar: "⫨",
    vBarv: "⫩",
    vDash: "⊨",
    vangrt: "⦜",
    varepsilon: "ϵ",
    varkappa: "ϰ",
    varnothing: "∅",
    varphi: "ϕ",
    varpi: "ϖ",
    varpropto: "∝",
    varr: "↕",
    varrho: "ϱ",
    varsigma: "ς",
    varsubsetneq: "⊊︀",
    varsubsetneqq: "⫋︀",
    varsupsetneq: "⊋︀",
    varsupsetneqq: "⫌︀",
    vartheta: "ϑ",
    vartriangleleft: "⊲",
    vartriangleright: "⊳",
    vcy: "в",
    vdash: "⊢",
    vee: "∨",
    veebar: "⊻",
    veeeq: "≚",
    vellip: "⋮",
    verbar: "|",
    vert: "|",
    vfr: "\uD835\uDD33",
    vltri: "⊲",
    vnsub: "⊂⃒",
    vnsup: "⊃⃒",
    vopf: "\uD835\uDD67",
    vprop: "∝",
    vrtri: "⊳",
    vscr: "\uD835\uDCCB",
    vsubnE: "⫋︀",
    vsubne: "⊊︀",
    vsupnE: "⫌︀",
    vsupne: "⊋︀",
    vzigzag: "⦚",
    wcirc: "ŵ",
    wedbar: "⩟",
    wedge: "∧",
    wedgeq: "≙",
    weierp: "℘",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "℘",
    wr: "≀",
    wreath: "≀",
    wscr: "\uD835\uDCCC",
    xcap: "⋂",
    xcirc: "◯",
    xcup: "⋃",
    xdtri: "▽",
    xfr: "\uD835\uDD35",
    xhArr: "⟺",
    xharr: "⟷",
    xi: "ξ",
    xlArr: "⟸",
    xlarr: "⟵",
    xmap: "⟼",
    xnis: "⋻",
    xodot: "⨀",
    xopf: "\uD835\uDD69",
    xoplus: "⨁",
    xotime: "⨂",
    xrArr: "⟹",
    xrarr: "⟶",
    xscr: "\uD835\uDCCD",
    xsqcup: "⨆",
    xuplus: "⨄",
    xutri: "△",
    xvee: "⋁",
    xwedge: "⋀",
    yacute: "\xfd",
    yacy: "я",
    ycirc: "ŷ",
    ycy: "ы",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "ї",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "ю",
    yuml: "\xff",
    zacute: "ź",
    zcaron: "ž",
    zcy: "з",
    zdot: "ż",
    zeetrf: "ℨ",
    zeta: "ζ",
    zfr: "\uD835\uDD37",
    zhcy: "ж",
    zigrarr: "⇝",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "‍",
    zwnj: "‌"
};


const $c0a58af43f6129ac$var$own = {}.hasOwnProperty;
function $c0a58af43f6129ac$export$289b6a6320f709b4(value) {
    return $c0a58af43f6129ac$var$own.call((0, $ed3e2b2347fac27f$export$ec810d1aafce79a7), value) ? (0, $ed3e2b2347fac27f$export$ec810d1aafce79a7)[value] : false;
}



const $ce662a9402db28e3$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $ce662a9402db28e3$var$tokenizeCharacterReference
};
/** @type {Tokenizer} */ function $ce662a9402db28e3$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => code is number} */ let test;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /** @type {State} */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $432513c48b12fdfc$export$75c76db11865a9f4);
        return value(code);
    }
    /** @type {State} */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $432513c48b12fdfc$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $432513c48b12fdfc$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /** @type {State} */ function value(code) {
        /** @type {Token} */ let token;
        if (code === 59 && size) {
            token = effects.exit("characterReferenceValue");
            if (test === (0, $432513c48b12fdfc$export$75c76db11865a9f4) && !(0, $c0a58af43f6129ac$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */ 

const $1c411422dc205d23$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $1c411422dc205d23$var$tokenizeCodeFenced,
    concrete: true
};
/** @type {Tokenizer} */ function $1c411422dc205d23$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closingFenceConstruct = {
        tokenize: tokenizeClosingFence,
        partial: true
    };
    /** @type {Construct} */ const nonLazyLine = {
        tokenize: tokenizeNonLazyLine,
        partial: true
    };
    const tail = this.events[this.events.length - 1];
    const initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        marker = code;
        return sequenceOpen(code);
    }
    /** @type {State} */ function sequenceOpen(code) {
        if (code === marker) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeFencedFenceSequence");
        return sizeOpen < 3 ? nok(code) : (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, infoOpen, "whitespace")(code);
    }
    /** @type {State} */ function infoOpen(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return openAfter(code);
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /** @type {State} */ function info(code) {
        if (code === null || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, infoAfter, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /** @type {State} */ function infoAfter(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return openAfter(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /** @type {State} */ function meta(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return openAfter(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /** @type {State} */ function openAfter(code) {
        effects.exit("codeFencedFence");
        return self.interrupt ? ok(code) : contentStart(code);
    }
    /** @type {State} */ function contentStart(code) {
        if (code === null) return after(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return effects.attempt(nonLazyLine, effects.attempt(closingFenceConstruct, after, initialPrefix ? (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix", initialPrefix + 1) : contentStart), after)(code);
        effects.enter("codeFlowValue");
        return contentContinue(code);
    }
    /** @type {State} */ function contentContinue(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return contentStart(code);
        }
        effects.consume(code);
        return contentContinue;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /** @type {Tokenizer} */ function tokenizeNonLazyLine(effects, ok, nok) {
        const self = this;
        return start;
        /** @type {State} */ function start(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return lineStart;
        }
        /** @type {State} */ function lineStart(code) {
            return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
        }
    }
    /** @type {Tokenizer} */ function tokenizeClosingFence(effects, ok, nok) {
        let size = 0;
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, closingSequenceStart, "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
        /** @type {State} */ function closingSequenceStart(code) {
            effects.enter("codeFencedFence");
            effects.enter("codeFencedFenceSequence");
            return closingSequence(code);
        }
        /** @type {State} */ function closingSequence(code) {
            if (code === marker) {
                effects.consume(code);
                size++;
                return closingSequence;
            }
            if (size < sizeOpen) return nok(code);
            effects.exit("codeFencedFenceSequence");
            return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, closingSequenceEnd, "whitespace")(code);
        }
        /** @type {State} */ function closingSequenceEnd(code) {
            if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */ 

const $ab4d46130bbbc8bd$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $ab4d46130bbbc8bd$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $ab4d46130bbbc8bd$var$indentedContent = {
    tokenize: $ab4d46130bbbc8bd$var$tokenizeIndentedContent,
    partial: true
};
/** @type {Tokenizer} */ function $ab4d46130bbbc8bd$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("codeIndented");
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, afterStartPrefix, "linePrefix", 5)(code);
    }
    /** @type {State} */ function afterStartPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? afterPrefix(code) : nok(code);
    }
    /** @type {State} */ function afterPrefix(code) {
        if (code === null) return after(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return effects.attempt($ab4d46130bbbc8bd$var$indentedContent, afterPrefix, after)(code);
        effects.enter("codeFlowValue");
        return content(code);
    }
    /** @type {State} */ function content(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return afterPrefix(code);
        }
        effects.consume(code);
        return content;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        return ok(code);
    }
}
/** @type {Tokenizer} */ function $ab4d46130bbbc8bd$var$tokenizeIndentedContent(effects, ok, nok) {
    const self = this;
    return start;
    /** @type {State} */ function start(code) {
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code) ? start(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */ 
const $16c806108f267846$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $16c806108f267846$var$tokenizeCodeText,
    resolve: $16c806108f267846$var$resolveCodeText,
    previous: $16c806108f267846$var$previous
};
/** @type {Resolver} */ function $16c806108f267846$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number|undefined} */ let enter // If we start and end with an EOL or a space.
    ;
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex // And we have data.
        ;
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    } // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/** @type {Previous} */ function $16c806108f267846$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/** @type {Tokenizer} */ function $16c806108f267846$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return openingSequence(code);
    }
    /** @type {State} */ function openingSequence(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return openingSequence;
        }
        effects.exit("codeTextSequence");
        return gap(code);
    }
    /** @type {State} */ function gap(code) {
        // EOF.
        if (code === null) return nok(code);
         // Closing fence?
        // Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return closingSequence(code);
        } // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return gap;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return gap;
        } // Data.
        effects.enter("codeTextData");
        return data(code);
    } // In code.
    /** @type {State} */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return gap(code);
        }
        effects.consume(code);
        return data;
    } // Closing fence.
    /** @type {State} */ function closingSequence(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return closingSequence;
        } // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        } // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 
function $b2c7e8deac525d60$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /** @type {State} */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return destinationEnclosedBefore;
        }
        if (code === null || code === 41 || (0, $432513c48b12fdfc$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return destinationRaw(code);
    }
    /** @type {State} */ function destinationEnclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return destinationEnclosed(code);
    }
    /** @type {State} */ function destinationEnclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return destinationEnclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationEnclosedEscape : destinationEnclosed;
    }
    /** @type {State} */ function destinationEnclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return destinationEnclosed;
        }
        return destinationEnclosed(code);
    }
    /** @type {State} */ function destinationRaw(code) {
        if (code === 40) {
            if (++balance > limit) return nok(code);
            effects.consume(code);
            return destinationRaw;
        }
        if (code === 41) {
            if (!balance--) {
                effects.exit("chunkString");
                effects.exit(stringType);
                effects.exit(rawType);
                effects.exit(type);
                return ok(code);
            }
            effects.consume(code);
            return destinationRaw;
        }
        if (code === null || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) {
            if (balance) return nok(code);
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if ((0, $432513c48b12fdfc$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationRawEscape : destinationRaw;
    }
    /** @type {State} */ function destinationRawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return destinationRaw;
        }
        return destinationRaw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').State} State
 */ 
function $d33e937ae1ea4ed4$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let data;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /** @type {State} */ function atBreak(code) {
        if (code === null || code === 91 || code === 93 && !data || /* To do: remove in the future once we’ve switched from
       * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
       * which doesn’t need this */ /* Hidden footnotes hook */ /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs || size > 999) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return label(code);
    }
    /** @type {State} */ function label(code) {
        if (code === null || code === 91 || code === 93 || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        data = data || !(0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : label;
    }
    /** @type {State} */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return label;
        }
        return label(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */ 

function $f42304cc65ff93d0$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        marker = code === 40 ? 41 : code;
        return atFirstTitleBreak;
    }
    /** @type {State} */ function atFirstTitleBreak(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atTitleBreak(code);
    }
    /** @type {State} */ function atTitleBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return atFirstTitleBreak(marker);
        }
        if (code === null) return nok(code);
         // Note: blank lines can’t exist in content.
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, atTitleBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return title(code);
    }
    /** @type {State} */ function title(code) {
        if (code === marker || code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atTitleBreak(code);
        }
        effects.consume(code);
        return code === 92 ? titleEscape : title;
    }
    /** @type {State} */ function titleEscape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return title;
        }
        return title(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $42ba7c725dbf102d$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}


/**
 * Normalize an identifier (such as used in definitions).
 *
 * @param {string} value
 * @returns {string}
 */ function $710781c0cdec9f6d$export$806d55e226cfcd08(value) {
    return value // Collapse Markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ") // Trim.
    .replace(/^ | $/g, "") // Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}



const $d7e2fdfd86ff4dd4$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $d7e2fdfd86ff4dd4$var$tokenizeDefinition
};
/** @type {Construct} */ const $d7e2fdfd86ff4dd4$var$titleConstruct = {
    tokenize: $d7e2fdfd86ff4dd4$var$tokenizeTitle,
    partial: true
};
/** @type {Tokenizer} */ function $d7e2fdfd86ff4dd4$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("definition");
        return (0, $d33e937ae1ea4ed4$export$7b768614d8ba97a7).call(self, effects, labelAfter, nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /** @type {State} */ function labelAfter(code) {
        identifier = (0, $710781c0cdec9f6d$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker") // Note: blank lines can’t exist in content.
            ;
            return (0, $42ba7c725dbf102d$export$1f27bd1aa33ce173)(effects, (0, $b2c7e8deac525d60$export$2e6c8deaa96af245)(effects, effects.attempt($d7e2fdfd86ff4dd4$var$titleConstruct, (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, after, "whitespace"), (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, after, "whitespace")), nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString"));
        }
        return nok(code);
    }
    /** @type {State} */ function after(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            if (!self.parser.defined.includes(identifier)) self.parser.defined.push(identifier);
            return ok(code);
        }
        return nok(code);
    }
}
/** @type {Tokenizer} */ function $d7e2fdfd86ff4dd4$var$tokenizeTitle(effects, ok, nok) {
    return start;
    /** @type {State} */ function start(code) {
        return (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) ? (0, $42ba7c725dbf102d$export$1f27bd1aa33ce173)(effects, before)(code) : nok(code);
    }
    /** @type {State} */ function before(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $f42304cc65ff93d0$export$f970569cc855e483)(effects, (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, after, "whitespace"), nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
        return nok(code);
    }
    /** @type {State} */ function after(code) {
        return code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */ 
const $0e19123aa1bdeff9$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $0e19123aa1bdeff9$var$tokenizeHardBreakEscape
};
/** @type {Tokenizer} */ function $0e19123aa1bdeff9$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        return open;
    }
    /** @type {State} */ function open(code) {
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("escapeMarker");
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */ 


const $a46ae5f97ae33c5d$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $a46ae5f97ae33c5d$var$tokenizeHeadingAtx,
    resolve: $a46ae5f97ae33c5d$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $a46ae5f97ae33c5d$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text // Prefix whitespace, part of the opening.
    ;
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
     // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            // @ts-expect-error Constants are fine to assign.
            contentType: "text"
        };
        (0, $0a9edb7ff3ef159f$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/** @type {Tokenizer} */ function $a46ae5f97ae33c5d$var$tokenizeHeadingAtx(effects, ok, nok) {
    const self = this;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("atxHeading");
        effects.enter("atxHeadingSequence");
        return fenceOpenInside(code);
    }
    /** @type {State} */ function fenceOpenInside(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return fenceOpenInside;
        }
        if (code === null || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return self.interrupt ? ok(code) : headingBreak(code);
        }
        return nok(code);
    }
    /** @type {State} */ function headingBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequence(code);
        }
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            return ok(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, headingBreak, "whitespace")(code);
        effects.enter("atxHeadingText");
        return data(code);
    }
    /** @type {State} */ function sequence(code) {
        if (code === 35) {
            effects.consume(code);
            return sequence;
        }
        effects.exit("atxHeadingSequence");
        return headingBreak(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null || code === 35 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return headingBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */ 
/**
 * List of lowercase HTML tag names which when parsing HTML (flow), result
 * in more relaxed rules (condition 6): because they are known blocks, the
 * HTML-like syntax doesn’t have to be strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 */ const $71c3e0f388301604$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $71c3e0f388301604$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];



const $7d9d35fac2b6ebcc$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $7d9d35fac2b6ebcc$var$tokenizeHtmlFlow,
    resolveTo: $7d9d35fac2b6ebcc$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $7d9d35fac2b6ebcc$var$nextBlankConstruct = {
    tokenize: $7d9d35fac2b6ebcc$var$tokenizeNextBlank,
    partial: true
};
/** @type {Resolver} */ function $7d9d35fac2b6ebcc$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start // Add the prefix start to the HTML line token.
        ;
        events[index + 1][1].start = events[index - 2][1].start // Remove the line prefix.
        ;
        events.splice(index - 2, 2);
    }
    return events;
}
/** @type {Tokenizer} */ function $7d9d35fac2b6ebcc$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let kind;
    /** @type {boolean} */ let startTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let marker;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /** @type {State} */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationStart;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            kind = 3 // While we’re in an instruction instead of a declaration, we’re on a `?`
            ;
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            buffer = String.fromCharCode(code);
            startTag = true;
            return tagName;
        }
        return nok(code);
    }
    /** @type {State} */ function declarationStart(code) {
        if (code === 45) {
            effects.consume(code);
            kind = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            kind = 5;
            buffer = "CDATA[";
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            kind = 4;
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /** @type {State} */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /** @type {State} */ function cdataOpenInside(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? self.interrupt ? ok : continuation : cdataOpenInside;
        }
        return nok(code);
    }
    /** @type {State} */ function tagCloseStart(code) {
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /** @type {State} */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) {
            if (code !== 47 && startTag && (0, $71c3e0f388301604$export$948e66da505d080).includes(buffer.toLowerCase())) {
                kind = 1;
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $71c3e0f388301604$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                kind = 6;
                if (code === 47) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                return self.interrupt ? ok(code) : continuation(code);
            }
            kind = 7 // Do not support complete HTML when interrupting
            ;
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : startTag ? completeAttributeNameBefore(code) : completeClosingTagAfter(code);
        }
        if (code === 45 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /** @type {State} */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /** @type {State} */ function completeClosingTagAfter(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /** @type {State} */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        if (code === 58 || code === 95 || (0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /** @type {State} */ function completeAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /** @type {State} */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /** @type {State} */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        marker = null;
        return completeAttributeValueUnquoted(code);
    }
    /** @type {State} */ function completeAttributeValueQuoted(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return nok(code);
        if (code === marker) {
            effects.consume(code);
            return completeAttributeValueQuotedAfter;
        }
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /** @type {State} */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /** @type {State} */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /** @type {State} */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /** @type {State} */ function completeAfter(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code) ? continuation(code) : nok(code);
    }
    /** @type {State} */ function continuation(code) {
        if (code === 45 && kind === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && kind === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && kind === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && kind === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && kind === 5) {
            effects.consume(code);
            return continuationCharacterDataInside;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code) && (kind === 6 || kind === 7)) return effects.check($7d9d35fac2b6ebcc$var$nextBlankConstruct, continuationClose, continuationAtLineEnding)(code);
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return continuationAtLineEnding(code);
        effects.consume(code);
        return continuation;
    }
    /** @type {State} */ function continuationAtLineEnding(code) {
        effects.exit("htmlFlowData");
        return htmlContinueStart(code);
    }
    /** @type {State} */ function htmlContinueStart(code) {
        if (code === null) return done(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return effects.attempt({
            tokenize: htmlLineEnd,
            partial: true
        }, htmlContinueStart, done)(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /** @type {Tokenizer} */ function htmlLineEnd(effects, ok, nok) {
        return start;
        /** @type {State} */ function start(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return lineStart;
        }
        /** @type {State} */ function lineStart(code) {
            return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
        }
    }
    /** @type {State} */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /** @type {State} */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /** @type {State} */ function continuationRawEndTag(code) {
        if (code === 62 && (0, $71c3e0f388301604$export$948e66da505d080).includes(buffer.toLowerCase())) {
            effects.consume(code);
            return continuationClose;
        }
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /** @type {State} */ function continuationCharacterDataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /** @type {State} */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        } // More dashes.
        if (code === 45 && kind === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /** @type {State} */ function continuationClose(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return done(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /** @type {State} */ function done(code) {
        effects.exit("htmlFlow");
        return ok(code);
    }
}
/** @type {Tokenizer} */ function $7d9d35fac2b6ebcc$var$tokenizeNextBlank(effects, ok, nok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.exit("htmlFlowData");
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        return effects.attempt((0, $ad11d598ddddec2e$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */ 

const $b5a186cf1fccfac7$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $b5a186cf1fccfac7$var$tokenizeHtmlText
};
/** @type {Tokenizer} */ function $b5a186cf1fccfac7$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>|undefined} */ let marker;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /** @type {State} */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /** @type {State} */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpen;
        }
        if (code === 91) {
            effects.consume(code);
            buffer = "CDATA[";
            index = 0;
            return cdataOpen;
        }
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /** @type {State} */ function commentOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentStart;
        }
        return nok(code);
    }
    /** @type {State} */ function commentStart(code) {
        if (code === null || code === 62) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentStartDash;
        }
        return comment(code);
    }
    /** @type {State} */ function commentStartDash(code) {
        if (code === null || code === 62) return nok(code);
        return comment(code);
    }
    /** @type {State} */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return atLineEnding(code);
        }
        effects.consume(code);
        return comment;
    }
    /** @type {State} */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return end;
        }
        return comment(code);
    }
    /** @type {State} */ function cdataOpen(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? cdata : cdataOpen;
        }
        return nok(code);
    }
    /** @type {State} */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return atLineEnding(code);
        }
        effects.consume(code);
        return cdata;
    }
    /** @type {State} */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /** @type {State} */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /** @type {State} */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return atLineEnding(code);
        }
        effects.consume(code);
        return declaration;
    }
    /** @type {State} */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return atLineEnding(code);
        }
        effects.consume(code);
        return instruction;
    }
    /** @type {State} */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /** @type {State} */ function tagCloseStart(code) {
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /** @type {State} */ function tagClose(code) {
        if (code === 45 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /** @type {State} */ function tagCloseBetween(code) {
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return atLineEnding(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /** @type {State} */ function tagOpen(code) {
        if (code === 45 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /** @type {State} */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        if (code === 58 || code === 95 || (0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return atLineEnding(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /** @type {State} */ function tagOpenAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /** @type {State} */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return atLineEnding(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /** @type {State} */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return atLineEnding(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        marker = undefined;
        return tagOpenAttributeValueUnquoted;
    }
    /** @type {State} */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return atLineEnding(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /** @type {State} */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 62 || code === 47 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /** @type {State} */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 62 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    } // We can’t have blank lines in content, so no need to worry about empty
    // tokens.
    /** @type {State} */ function atLineEnding(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
    }
    /** @type {State} */ function afterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
    /** @type {State} */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */ 







const $1dc73455d0df3be9$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $1dc73455d0df3be9$var$tokenizeLabelEnd,
    resolveTo: $1dc73455d0df3be9$var$resolveToLabelEnd,
    resolveAll: $1dc73455d0df3be9$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$resourceConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeResource
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$fullReferenceConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeFullReference
};
/** @type {Construct} */ const $1dc73455d0df3be9$var$collapsedReferenceConstruct = {
    tokenize: $1dc73455d0df3be9$var$tokenizeCollapsedReference
};
/** @type {Resolver} */ function $1dc73455d0df3be9$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Token} */ let token;
    while(++index < events.length){
        token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $1dc73455d0df3be9$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number|undefined} */ let open;
    /** @type {number|undefined} */ let close;
    /** @type {Event[]} */ let media // Find an opening.
    ;
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
             // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ] // Opening marker.
    ;
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3)) // Text open.
    ;
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, [
        [
            "enter",
            text,
            context
        ]
    ]) // Between.
    ;
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, (0, $5fffc2d235733349$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context)) // Text close, marker close, label close.
    ;
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]) // Reference, resource, or so.
    ;
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, events.slice(close + 1)) // Media close.
    ;
    media = (0, $0a9edb7ff3ef159f$export$4cbf152802aa238)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $0a9edb7ff3ef159f$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/** @type {Tokenizer} */ function $1dc73455d0df3be9$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined // Find an opening.
    ;
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /** @type {State} */ function start(code) {
        if (!labelStart) return nok(code);
         // It’s a balanced bracket, but contains a link.
        if (labelStart._inactive) return balanced(code);
        defined = self.parser.defined.includes((0, $710781c0cdec9f6d$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return afterLabelEnd;
    }
    /** @type {State} */ function afterLabelEnd(code) {
        // Resource: `[asd](fgh)`.
        if (code === 40) return effects.attempt($1dc73455d0df3be9$var$resourceConstruct, ok, defined ? ok : balanced)(code);
         // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?
        if (code === 91) return effects.attempt($1dc73455d0df3be9$var$fullReferenceConstruct, ok, defined ? effects.attempt($1dc73455d0df3be9$var$collapsedReferenceConstruct, ok, balanced) : balanced)(code);
         // Shortcut reference: `[asd]`?
        return defined ? ok(code) : balanced(code);
    }
    /** @type {State} */ function balanced(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/** @type {Tokenizer} */ function $1dc73455d0df3be9$var$tokenizeResource(effects, ok, nok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return (0, $42ba7c725dbf102d$export$1f27bd1aa33ce173)(effects, open);
    }
    /** @type {State} */ function open(code) {
        if (code === 41) return end(code);
        return (0, $b2c7e8deac525d60$export$2e6c8deaa96af245)(effects, destinationAfter, nok, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /** @type {State} */ function destinationAfter(code) {
        return (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) ? (0, $42ba7c725dbf102d$export$1f27bd1aa33ce173)(effects, between)(code) : end(code);
    }
    /** @type {State} */ function between(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $f42304cc65ff93d0$export$f970569cc855e483)(effects, (0, $42ba7c725dbf102d$export$1f27bd1aa33ce173)(effects, end), nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return end(code);
    }
    /** @type {State} */ function end(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/** @type {Tokenizer} */ function $1dc73455d0df3be9$var$tokenizeFullReference(effects, ok, nok) {
    const self = this;
    return start;
    /** @type {State} */ function start(code) {
        return (0, $d33e937ae1ea4ed4$export$7b768614d8ba97a7).call(self, effects, afterLabel, nok, "reference", "referenceMarker", "referenceString")(code);
    }
    /** @type {State} */ function afterLabel(code) {
        return self.parser.defined.includes((0, $710781c0cdec9f6d$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
}
/** @type {Tokenizer} */ function $1dc73455d0df3be9$var$tokenizeCollapsedReference(effects, ok, nok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return open;
    }
    /** @type {State} */ function open(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */ 
const $f5591a0a77ea393a$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $f5591a0a77ea393a$var$tokenizeLabelStartImage,
    resolveAll: (0, $1dc73455d0df3be9$export$470a5dafbbf62654).resolveAll
};
/** @type {Tokenizer} */ function $f5591a0a77ea393a$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /** @type {State} */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /** @type {State} */ function after(code) {
        /* To do: remove in the future once we’ve switched from
     * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
     * which doesn’t need this */ /* Hidden footnotes hook */ /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */ 
const $d496929de41504d8$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $d496929de41504d8$var$tokenizeLabelStartLink,
    resolveAll: (0, $1dc73455d0df3be9$export$470a5dafbbf62654).resolveAll
};
/** @type {Tokenizer} */ function $d496929de41504d8$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        /* To do: remove in the future once we’ve switched from
     * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
     * which doesn’t need this */ /* Hidden footnotes hook. */ /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */ 

const $6e24888a23d546e6$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $6e24888a23d546e6$var$tokenizeLineEnding
};
/** @type {Tokenizer} */ function $6e24888a23d546e6$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */ /**
 * @typedef {Record<string, unknown> & {marker: Code, type: string, size: number}} ListContainerState
 * @typedef {TokenizeContext & {containerState: ListContainerState}} TokenizeContextWithState
 */ 


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */ 

const $aa27701f1509407c$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $aa27701f1509407c$var$tokenizeThematicBreak
};
/** @type {Tokenizer} */ function $aa27701f1509407c$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("thematicBreak");
        marker = code;
        return atBreak(code);
    }
    /** @type {State} */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        if (size < 3 || code !== null && !(0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return nok(code);
        effects.exit("thematicBreak");
        return ok(code);
    }
    /** @type {State} */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return atBreak(code);
    }
}


const $57144dde063f82cb$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $57144dde063f82cb$var$tokenizeListStart,
    continuation: {
        tokenize: $57144dde063f82cb$var$tokenizeListContinuation
    },
    exit: $57144dde063f82cb$var$tokenizeListEnd
};
/** @type {Construct} */ const $57144dde063f82cb$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $57144dde063f82cb$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $57144dde063f82cb$var$indentConstruct = {
    tokenize: $57144dde063f82cb$var$tokenizeIndent,
    partial: true
};
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */ function $57144dde063f82cb$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $432513c48b12fdfc$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $aa27701f1509407c$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $432513c48b12fdfc$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $ad11d598ddddec2e$export$d50d28ce3ab2a612), self.interrupt ? nok : onBlank, effects.attempt($57144dde063f82cb$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */ function $57144dde063f82cb$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $ad11d598ddddec2e$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine // We have a blank line.
        ;
        // Still, try to consume at most the items size.
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($57144dde063f82cb$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true // As we’re closing flow, we’re no longer interrupting.
        ;
        self.interrupt = undefined;
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, effects.attempt($57144dde063f82cb$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */ function $57144dde063f82cb$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContextWithState}
 */ function $57144dde063f82cb$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */ function $57144dde063f82cb$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */ 

const $8eba9e38644cd781$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $8eba9e38644cd781$var$tokenizeSetextUnderline,
    resolveTo: $8eba9e38644cd781$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $8eba9e38644cd781$var$resolveToSetextUnderline(events, context) {
    let index = events.length;
    /** @type {number|undefined} */ let content;
    /** @type {number|undefined} */ let text;
    /** @type {number|undefined} */ let definition // Find the opening of the content.
    ;
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    } // Change the paragraph to setext heading text.
    ;
    events[text][1].type = "setextHeadingText" // If we have definitions in the content, we’ll keep on having content,
    ;
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
     // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/** @type {Tokenizer} */ function $8eba9e38644cd781$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {NonNullable<Code>} */ let marker;
    /** @type {boolean} */ let paragraph // Find an opening.
    ;
    while(index--)// Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
        paragraph = self.events[index][1].type === "paragraph";
        break;
    }
    return start;
    /** @type {State} */ function start(code) {
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            effects.enter("setextHeadingLineSequence");
            marker = code;
            return closingSequence(code);
        }
        return nok(code);
    }
    /** @type {State} */ function closingSequence(code) {
        if (code === marker) {
            effects.consume(code);
            return closingSequence;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, closingSequenceEnd, "lineSuffix")(code);
    }
    /** @type {State} */ function closingSequenceEnd(code) {
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $62cac499df3c25a0$export$5a7bfc01df82fcd1 = {
    [42]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [43]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [45]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [48]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [49]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [50]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [51]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [52]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [53]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [54]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [55]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [56]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [57]: (0, $57144dde063f82cb$export$8837f4fc672e936d),
    [62]: (0, $76cd53d8c5b717c4$export$200dcd0a5903c968)
};
const $62cac499df3c25a0$export$5a2181fb44b58173 = {
    [91]: (0, $d7e2fdfd86ff4dd4$export$69f215ed977cdb73)
};
const $62cac499df3c25a0$export$cf8bead395eff824 = {
    [-2]: (0, $ab4d46130bbbc8bd$export$47910b7ab28d1853),
    [-1]: (0, $ab4d46130bbbc8bd$export$47910b7ab28d1853),
    [32]: (0, $ab4d46130bbbc8bd$export$47910b7ab28d1853)
};
const $62cac499df3c25a0$export$ccc7b0636abaffc3 = {
    [35]: (0, $a46ae5f97ae33c5d$export$3871e9deb360695c),
    [42]: (0, $aa27701f1509407c$export$ba7b13e047416c03),
    [45]: [
        (0, $8eba9e38644cd781$export$e104e2de391dfde9),
        (0, $aa27701f1509407c$export$ba7b13e047416c03)
    ],
    [60]: (0, $7d9d35fac2b6ebcc$export$476ac411cb7d0d8f),
    [61]: (0, $8eba9e38644cd781$export$e104e2de391dfde9),
    [95]: (0, $aa27701f1509407c$export$ba7b13e047416c03),
    [96]: (0, $1c411422dc205d23$export$c23e4921f8d87e7c),
    [126]: (0, $1c411422dc205d23$export$c23e4921f8d87e7c)
};
const $62cac499df3c25a0$export$22b082955e083ec3 = {
    [38]: (0, $ce662a9402db28e3$export$e31905600aaf3d8e),
    [92]: (0, $59f80dfce403f5de$export$2005478564e78d96)
};
const $62cac499df3c25a0$export$6f093cfa640b7166 = {
    [-5]: (0, $6e24888a23d546e6$export$8e62e0ad51c97b2),
    [-4]: (0, $6e24888a23d546e6$export$8e62e0ad51c97b2),
    [-3]: (0, $6e24888a23d546e6$export$8e62e0ad51c97b2),
    [33]: (0, $f5591a0a77ea393a$export$3d754936e25aa5f5),
    [38]: (0, $ce662a9402db28e3$export$e31905600aaf3d8e),
    [42]: (0, $ab77d7b684ccca7a$export$45b92471da762af7),
    [60]: [
        (0, $5d33fad6991aa1ad$export$17ddf85e4c916ad6),
        (0, $b5a186cf1fccfac7$export$398af27f284914fe)
    ],
    [91]: (0, $d496929de41504d8$export$5c0cee0701a3b584),
    [92]: [
        (0, $0e19123aa1bdeff9$export$86c573ab9e06f418),
        (0, $59f80dfce403f5de$export$2005478564e78d96)
    ],
    [93]: (0, $1dc73455d0df3be9$export$470a5dafbbf62654),
    [95]: (0, $ab77d7b684ccca7a$export$45b92471da762af7),
    [96]: (0, $16c806108f267846$export$d24f93e715f9df88)
};
const $62cac499df3c25a0$export$d44f260a3f9b69f5 = {
    null: [
        (0, $ab77d7b684ccca7a$export$45b92471da762af7),
        (0, $1fdcbfee479a4092$export$50397835cbfdbc24)
    ]
};
const $62cac499df3c25a0$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $62cac499df3c25a0$export$e20fbacbb41798b = {
    null: []
};


function $1fc819ea965a3f81$export$98e6a39c04603d36(options = {}) {
    /** @type {FullNormalizedExtension} */ // @ts-expect-error `defaultConstructs` is full, so the result will be too.
    const constructs = (0, $12b512a5203a7cce$export$86a865d89ef3c690)(// @ts-expect-error Same as above.
    [
        $62cac499df3c25a0$exports
    ].concat(options.extensions || []));
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $171a79fbb1402b9a$export$a7db06668cad9adb)),
        document: create((0, $348cdb85d1aeadd1$export$5a7bfc01df82fcd1)),
        flow: create((0, $e2fdd11cbe455c51$export$ccc7b0636abaffc3)),
        string: create((0, $1fdcbfee479a4092$export$22b082955e083ec3)),
        text: create((0, $1fdcbfee479a4092$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $4a83eb91ec5d6b95$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding} [encoding]
 * @param {boolean} [end=false]
 * @returns {Array<Chunk>}
 */ const $cdd1ff6afd8515e5$var$search = /[\0\t\n\r]/g;
function $cdd1ff6afd8515e5$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean|undefined} */ let start = true;
    /** @type {boolean|undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray|null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code // @ts-expect-error `Buffer` does allow an encoding.
        ;
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $cdd1ff6afd8515e5$var$search.lastIndex = startPosition;
            match = $cdd1ff6afd8515e5$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $4e6fd59d488c6494$export$bd0e6e1378a871d7(events) {
    while(!(0, $dae5d3de466990fa$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 */ function $23c7742930bb7617$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of the basic block and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 || // Out of range
    code > 1114111) return "�";
    return String.fromCharCode(code);
}




const $0fb53ec7385928f9$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $0fb53ec7385928f9$export$a0fb664af7d0cc44(value) {
    return value.replace($0fb53ec7385928f9$var$characterEscapeOrReference, $0fb53ec7385928f9$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $0fb53ec7385928f9$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
     // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $23c7742930bb7617$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $c0a58af43f6129ac$export$289b6a6320f709b4)($2) || $0;
}





const $236f1a66ed1dd212$var$own = {}.hasOwnProperty;
const $236f1a66ed1dd212$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $236f1a66ed1dd212$var$compiler(options)((0, $4e6fd59d488c6494$export$bd0e6e1378a871d7)(// @ts-expect-error: micromark types need to accept `null`.
    (0, $1fc819ea965a3f81$export$98e6a39c04603d36)(options).document().write((0, $cdd1ff6afd8515e5$export$fc37fe19dfda43ee)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $236f1a66ed1dd212$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $236f1a66ed1dd212$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($236f1a66ed1dd212$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $236f1a66ed1dd212$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $236f1a66ed1dd212$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $236f1a66ed1dd212$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) // @ts-expect-error Patched.
                    listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        // @ts-expect-error Patched
                        _spread: false,
                        start: Object.assign({}, event[1].start)
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        // @ts-expect-error Patched.
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $236f1a66ed1dd212$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $b094d2c4d032c594$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it’s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $236f1a66ed1dd212$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $236f1a66ed1dd212$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $79369f5237095e86$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $710781c0cdec9f6d$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $236f1a66ed1dd212$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $236f1a66ed1dd212$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $236f1a66ed1dd212$var$point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData("atHardBreak", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $0fb53ec7385928f9$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $710781c0cdec9f6d$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData("inReference", true);
        if (node.type === "link") {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData("inReference");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData("referenceType", "collapsed");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $710781c0cdec9f6d$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData("characterReferenceType");
        /** @type {string} */ let value;
        if (type) {
            value = (0, $23c7742930bb7617$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else {
            const result = (0, $c0a58af43f6129ac$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $236f1a66ed1dd212$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            // @ts-expect-error Patched.
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            // @ts-expect-error Patched.
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $236f1a66ed1dd212$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $236f1a66ed1dd212$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $236f1a66ed1dd212$var$configure(combined, value);
        else $236f1a66ed1dd212$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $236f1a66ed1dd212$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($236f1a66ed1dd212$var$own.call(extension, key)) {
        if (key === "canContainEols") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "transforms") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "enter" || key === "exit") {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $236f1a66ed1dd212$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $b094d2c4d032c594$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $b094d2c4d032c594$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $b094d2c4d032c594$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}


function $2aab0d1dd6b1383c$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data("settings");
        return (0, $236f1a66ed1dd212$export$d744d789c09bfde6)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data("micromarkExtensions") || [],
            mdastExtensions: this.data("fromMarkdownExtensions") || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ /**
 * @typedef {import('mdast').Root|import('mdast').Parent['children'][number]} MdastNode
 * @typedef {import('hast').Root|import('hast').Parent['children'][number]} HastNode
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').ElementContent} Content
 * @typedef {import('unist-util-position').PositionLike} PositionLike
 *
 * @typedef EmbeddedHastFields
 * @property {string} [hName] Defines the tag name of an element
 * @property {Properties} [hProperties] Defines the properties of an element
 * @property {Array.<Content>} [hChildren] Defines the (hast) children of an element
 *
 * @typedef {Object.<string, unknown> & EmbeddedHastFields} Data unist data with embedded hast fields
 *
 * @typedef {MdastNode & {data?: Data}} NodeWithData unist node with embedded hast data
 *
 * @callback Handler
 * @param {H} h Handle context
 * @param {any} node mdast node to handle
 * @param {Parent|null} parent Parent of `node`
 * @returns {Content|Array.<Content>|null|undefined} hast node
 *
 * @callback HFunctionProps
 * @param {MdastNode|PositionLike|null|undefined} node mdast node or unist position
 * @param {string} tagName HTML tag name
 * @param {Properties} props Properties
 * @param {Array.<Content>?} [children] hast content
 * @returns {Element}
 *
 * @callback HFunctionNoProps
 * @param {MdastNode|PositionLike|null|undefined} node mdast node or unist position
 * @param {string} tagName HTML tag name
 * @param {Array.<Content>?} [children] hast content
 * @returns {Element}
 *
 * @typedef HFields
 * @property {boolean} dangerous Whether HTML is allowed
 * @property {(identifier: string) => Definition|null} definition Definition cache
 * @property {Object.<string, FootnoteDefinition>} footnoteById Footnote cache
 * @property {Array.<string>} footnoteOrder Order in which footnotes occur
 * @property {Handlers} handlers Applied handlers
 * @property {Handler} unknownHandler Handler for any none not in `passThrough` or otherwise handled
 * @property {(left: NodeWithData|PositionLike|null|undefined, right: Content) => Content} augment Like `h` but lower-level and usable on non-elements.
 * @property {Array.<string>} passThrough List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 * @property {boolean} [allowDangerousHtml=false] Whether to allow `html` nodes and inject them as `raw` HTML
 * @property {Handlers} [handlers] Object mapping mdast nodes to functions handling them
 * @property {Array.<string>} [passThrough] List of custom mdast node types to pass through (keep) in hast
 * @property {Handler} [unknownHandler] Handler for all unknown nodes.
 *
 * @typedef {Record.<string, Handler>} Handlers Map of node types to handlers
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} H Handle context
 */ /**
 * @typedef {import('unist').Node} Node
 */ /**
 * @typedef {Array<Node> | string} ChildrenOrValue
 *   List to use as `children` or value to use as `value`.
 *
 * @typedef {Record<string, unknown>} Props
 *   Other fields to add to the node.
 */ /**
 * Build a node.
 *
 * @param type
 *   Node type.
 * @param props
 *   Fields assigned to node.
 * @param value
 *   Children of node or value of `node` (cast to string).
 * @returns
 *   Built node.
 */ const $51193605e939011b$export$3b14a55fb2447963 = /**
   * @type {(
   *   (<T extends string>(type: T) => {type: T}) &
   *   (<T extends string, P extends Props>(type: T, props: P) => {type: T} & P) &
   *   (<T extends string>(type: T, value: string) => {type: T, value: string}) &
   *   (<T extends string, P extends Props>(type: T, props: P, value: string) => {type: T, value: string} & P) &
   *   (<T extends string, C extends Array<Node>>(type: T, children: C) => {type: T, children: C}) &
   *   (<T extends string, P extends Props, C extends Array<Node>>(type: T, props: P, children: C) => {type: T, children: C} & P)
   * )}
   */ /**
     * @param {string} type
     * @param {Props | ChildrenOrValue | null | undefined} [props]
     * @param {ChildrenOrValue | null | undefined} [value]
     * @returns {Node}
     */ function(type, props, value) {
    /** @type {Node} */ const node = {
        type: String(type)
    };
    if ((value === undefined || value === null) && (typeof props === "string" || Array.isArray(props))) value = props;
    else Object.assign(node, props);
    if (Array.isArray(value)) // @ts-expect-error: create a parent.
    node.children = value;
    else if (value !== undefined && value !== null) // @ts-expect-error: create a literal.
    node.value = String(value);
    return node;
};


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $96c8174c61624bc3$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $96c8174c61624bc3$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === "string" ? Boolean(check.call(context, node, index, parent)) : false;
};
const $96c8174c61624bc3$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $96c8174c61624bc3$var$ok;
    if (typeof test === "string") return $96c8174c61624bc3$var$typeFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $96c8174c61624bc3$var$anyFactory(test) : $96c8174c61624bc3$var$propsFactory(test);
    if (typeof test === "function") return $96c8174c61624bc3$var$castFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $96c8174c61624bc3$export$9c68d69a4c5bbcf9(tests[index]);
    return $96c8174c61624bc3$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$propsFactory(check) {
    return $96c8174c61624bc3$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$typeFactory(check) {
    return $96c8174c61624bc3$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $96c8174c61624bc3$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === "object" && "type" in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $96c8174c61624bc3$var$ok() {
    return true;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $17fc07be418e6e2a$export$35e9368ef982300f(d) {
    return d;
}


const $d5f8100665f1cd06$export$f4d8133c446fe484 = true;
const $d5f8100665f1cd06$export$7f100f842f565dc9 = false;
const $d5f8100665f1cd06$export$8773f85c2fb2c116 = "skip";
const $d5f8100665f1cd06$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $96c8174c61624bc3$export$9c68d69a4c5bbcf9)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $17fc07be418e6e2a$export$35e9368ef982300f)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $d5f8100665f1cd06$var$toResult(visitor(node, parents));
                if (result[0] === $d5f8100665f1cd06$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $d5f8100665f1cd06$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $d5f8100665f1cd06$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $d5f8100665f1cd06$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $d5f8100665f1cd06$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}


const $4ad53e9051b55a53$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $d5f8100665f1cd06$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};


/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $bbca31c5046a61f5$export$771bf3e4949bfbee = $bbca31c5046a61f5$var$point("start");
const $bbca31c5046a61f5$export$da309cdce9dc2a25 = $bbca31c5046a61f5$var$point("end");
function $bbca31c5046a61f5$export$5880b8b5730aff45(node) {
    return {
        start: $bbca31c5046a61f5$export$771bf3e4949bfbee(node),
        end: $bbca31c5046a61f5$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $bbca31c5046a61f5$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}


/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $2e8577aa1764555c$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
const $e3d29f9dd459ad71$var$own = {}.hasOwnProperty;
function $e3d29f9dd459ad71$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error("mdast-util-definitions expected node");
    (0, $4ad53e9051b55a53$export$bf638b60ea8b89b7)(tree, "definition", (definition)=>{
        const id = $e3d29f9dd459ad71$var$clean(definition.identifier);
        if (id && !$e3d29f9dd459ad71$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $e3d29f9dd459ad71$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $e3d29f9dd459ad71$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $e3d29f9dd459ad71$var$clean(value) {
    return String(value || "").toUpperCase();
}


/**
 * @typedef {import('mdast').Root|import('mdast').Parent['children'][number]} MdastNode
 * @typedef {import('./index.js').H} H
 * @typedef {import('./index.js').Handler} Handler
 * @typedef {import('./index.js').Content} Content
 */ 
const $f4a5c290bddc7972$var$own = {}.hasOwnProperty;
/**
 * Transform an unknown node.
 * @type {Handler}
 * @param {MdastNode} node
 */ function $f4a5c290bddc7972$var$unknown(h, node) {
    const data = node.data || {};
    if ("value" in node && !($f4a5c290bddc7972$var$own.call(data, "hName") || $f4a5c290bddc7972$var$own.call(data, "hProperties") || $f4a5c290bddc7972$var$own.call(data, "hChildren"))) return h.augment(node, (0, $51193605e939011b$export$3b14a55fb2447963)("text", node.value));
    return h(node, "div", $f4a5c290bddc7972$export$84bf76cd7afc7469(h, node));
}
function $f4a5c290bddc7972$export$80bf7733f1207381(h, node, parent) {
    const type = node && node.type;
    /** @type {Handler} */ let fn;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($f4a5c290bddc7972$var$own.call(h.handlers, type)) fn = h.handlers[type];
    else if (h.passThrough && h.passThrough.includes(type)) fn = $f4a5c290bddc7972$var$returnNode;
    else fn = h.unknownHandler;
    return (typeof fn === "function" ? fn : $f4a5c290bddc7972$var$unknown)(h, node, parent);
}
/**
 * @type {Handler}
 * @param {MdastNode} node
 */ function $f4a5c290bddc7972$var$returnNode(h, node) {
    // @ts-expect-error: Pass through custom node.
    return "children" in node ? {
        ...node,
        children: $f4a5c290bddc7972$export$84bf76cd7afc7469(h, node)
    } : node;
}
function $f4a5c290bddc7972$export$84bf76cd7afc7469(h, parent) {
    /** @type {Array.<Content>} */ const values = [];
    if ("children" in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $f4a5c290bddc7972$export$80bf7733f1207381(h, nodes[index], parent);
            if (result) {
                if (index && nodes[index - 1].type === "break") {
                    if (!Array.isArray(result) && result.type === "text") result.value = result.value.replace(/^\s+/, "");
                    if (!Array.isArray(result) && result.type === "element") {
                        const head = result.children[0];
                        if (head && head.type === "text") head.value = head.value.replace(/^\s+/, "");
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}


/**
 * @typedef {import('mdast').BlockContent} BlockContent
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('./index.js').H} H
 */ /**
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 */ /**
 * @type {Handler}
 * @param {ThematicBreak} [node]
 * @returns {Element}
 */ function $02537fefb8a9d631$export$ba7b13e047416c03(h, node) {
    return h(node, "hr");
}


/**
 * @typedef {import('mdast').List} List
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ /**
 * @typedef {import('./index.js').Content} Content
 */ 
function $6312036d85444421$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array.<Content>} */ const result = [];
    let index = -1;
    if (loose) result.push((0, $51193605e939011b$export$3b14a55fb2447963)("text", "\n"));
    while(++index < nodes.length){
        if (index) result.push((0, $51193605e939011b$export$3b14a55fb2447963)("text", "\n"));
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push((0, $51193605e939011b$export$3b14a55fb2447963)("text", "\n"));
    return result;
}



function $6d52c8b65c22a0f3$export$8837f4fc672e936d(h, node) {
    /** @type {Properties} */ const props = {};
    const name = node.ordered ? "ol" : "ul";
    const items = (0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) props.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < items.length){
        const item = items[index];
        if (item.type === "element" && item.tagName === "li" && item.properties && Array.isArray(item.properties.className) && item.properties.className.includes("task-list-item")) {
            props.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    return h(node, name, props, (0, $6312036d85444421$export$4997ffc0176396a6)(items, true));
}



function $43b288b5d784432f$export$adb608be33961c98(h) {
    const footnoteById = h.footnoteById;
    const footnoteOrder = h.footnoteOrder;
    let index = -1;
    /** @type {Array.<ListItem>} */ const listItems = [];
    while(++index < footnoteOrder.length){
        const def = footnoteById[footnoteOrder[index].toUpperCase()];
        if (!def) continue;
        const marker = String(index + 1);
        const content = [
            ...def.children
        ];
        /** @type {Link} */ const backReference = {
            type: "link",
            url: "#fnref" + marker,
            data: {
                hProperties: {
                    className: [
                        "footnote-back"
                    ],
                    role: "doc-backlink"
                }
            },
            children: [
                {
                    type: "text",
                    value: "↩"
                }
            ]
        };
        const tail = content[content.length - 1];
        if (tail && tail.type === "paragraph") tail.children.push(backReference);
        else // @ts-expect-error Indeed, link directly added in block content.
        // Which we do because that way at least the handlers will be called
        // for the other HTML we’re generating (as markdown).
        content.push(backReference);
        listItems.push({
            type: "listItem",
            data: {
                hProperties: {
                    id: "fn" + marker,
                    role: "doc-endnote"
                }
            },
            children: content,
            position: def.position
        });
    }
    if (listItems.length === 0) return null;
    return h(null, "section", {
        className: [
            "footnotes"
        ],
        role: "doc-endnotes"
    }, (0, $6312036d85444421$export$4997ffc0176396a6)([
        (0, $02537fefb8a9d631$export$ba7b13e047416c03)(h),
        (0, $6d52c8b65c22a0f3$export$8837f4fc672e936d)(h, {
            type: "list",
            ordered: true,
            children: listItems
        })
    ], true));
}


/**
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../index.js').Handler} Handler
 */ 

function $0d7bf6069cd4a99d$export$67dc04e652a298ca(h, node) {
    return h(node, "blockquote", (0, $6312036d85444421$export$4997ffc0176396a6)((0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node), true));
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $5f854cb469f7f6cd$export$371da9dd35aba193(h, node) {
    return [
        h(node, "br"),
        (0, $51193605e939011b$export$3b14a55fb2447963)("text", "\n")
    ];
}


/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $9f7a2a9a3e8cdc0a$export$6565f9f03506010b(h, node) {
    const value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
    /** @type {Properties} */ const props = {};
    if (lang) props.className = [
        "language-" + lang
    ];
    const code = h(node, "code", props, [
        (0, $51193605e939011b$export$3b14a55fb2447963)("text", value)
    ]);
    if (node.meta) code.data = {
        meta: node.meta
    };
    return h(node.position, "pre", [
        code
    ]);
}


/**
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $4f75ba80b35d3487$export$19426ff118fe8be(h, node) {
    return h(node, "del", (0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node));
}


/**
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $71ae8bf40e51fddd$export$bef81ba411953b51(h, node) {
    return h(node, "em", (0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node));
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $d059032a2037e72d$export$7f87ee744075c1ba(h, node) {
    const footnoteOrder = h.footnoteOrder;
    const identifier = String(node.identifier);
    const index = footnoteOrder.indexOf(identifier);
    const marker = String(index === -1 ? footnoteOrder.push(identifier) : index + 1);
    return h(node, "a", {
        href: "#fn" + marker,
        className: [
            "footnote-ref"
        ],
        id: "fnref" + marker,
        role: "doc-noteref"
    }, [
        h(node.position, "sup", [
            (0, $51193605e939011b$export$3b14a55fb2447963)("text", marker)
        ])
    ]);
}


/**
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $b302441aef2a42d1$export$3b6a720baa2c20ec(h, node) {
    const footnoteById = h.footnoteById;
    const footnoteOrder = h.footnoteOrder;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    // No need to check if `identifier` exists in `footnoteOrder`, it’s guaranteed
    // to not exist because we just generated it.
    footnoteOrder.push(identifier);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $d059032a2037e72d$export$7f87ee744075c1ba)(h, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}


/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $80a0025fee2734a4$export$46e4a324ac90507f(h, node) {
    return h(node, "h" + node.depth, (0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node));
}


/**
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $a544d24f31a6d015$export$c0bb0b647f701bb5(h, node) {
    return h.dangerous ? h.augment(node, (0, $51193605e939011b$export$3b14a55fb2447963)("raw", node.value)) : null;
}


/**
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ var $a09f9057097f68d0$exports = {};
"use strict";
var $a09f9057097f68d0$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $a09f9057097f68d0$var$getEncodeCache(exclude) {
    var i, ch, cache = $a09f9057097f68d0$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $a09f9057097f68d0$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $a09f9057097f68d0$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = "";
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $a09f9057097f68d0$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    cache = $a09f9057097f68d0$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$a09f9057097f68d0$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$a09f9057097f68d0$var$encode.componentChars = "-_.!~*'()";
$a09f9057097f68d0$exports = $a09f9057097f68d0$var$encode;


/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('./index.js').Handler} Handler
 * @typedef {import('./index.js').Content} Content
 */ 

function $457fc7453091eab4$export$3fdd26f3d9e7dc78(h, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return (0, $51193605e939011b$export$3b14a55fb2447963)("text", "![" + node.alt + suffix);
    const contents = (0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift((0, $51193605e939011b$export$3b14a55fb2447963)("text", "["));
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push((0, $51193605e939011b$export$3b14a55fb2447963)("text", suffix));
    return contents;
}


function $34e938c73615b97e$export$f281796f6bc3b8db(h, node) {
    const def = h.definition(node.identifier);
    if (!def) return (0, $457fc7453091eab4$export$3fdd26f3d9e7dc78)(h, node);
    /** @type {Properties} */ const props = {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a09f9057097f68d0$exports)))(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, "img", props);
}


/**
 * @typedef {import('mdast').Image} Image
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $fa267d4e016e1a94$export$5c452ff88e35e47d(h, node) {
    /** @type {Properties} */ const props = {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($a09f9057097f68d0$exports)))(node.url),
        alt: node.alt
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, "img", props);
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $a18e1d7c380780d4$export$91b9bee19a0d8569(h, node) {
    return h(node, "code", [
        (0, $51193605e939011b$export$3b14a55fb2447963)("text", node.value.replace(/\r?\n|\r/g, " "))
    ]);
}


/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ 


function $5ffda1b647f76013$export$e6c469b1b7b2bc6a(h, node) {
    const def = h.definition(node.identifier);
    if (!def) return (0, $457fc7453091eab4$export$3fdd26f3d9e7dc78)(h, node);
    /** @type {Properties} */ const props = {
        href: (0, (/*@__PURE__*/$parcel$interopDefault($a09f9057097f68d0$exports)))(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) props.title = def.title;
    return h(node, "a", props, (0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node));
}


/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */ 

function $97ae763275816d1f$export$9c30223ca0a664fb(h, node) {
    /** @type {Properties} */ const props = {
        href: (0, (/*@__PURE__*/$parcel$interopDefault($a09f9057097f68d0$exports)))(node.url)
    };
    if (node.title !== null && node.title !== undefined) props.title = node.title;
    return h(node, "a", props, (0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node));
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').List} List
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 * @typedef {import('../index.js').Content} Content
 */ 

function $0bf735405dac3389$export$76c7e83ecc9cdf05(h, node, parent) {
    const result = (0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node);
    const loose = parent ? $0bf735405dac3389$var$listLoose(parent) : $0bf735405dac3389$var$listItemLoose(node);
    /** @type {Properties} */ const props = {};
    /** @type {Array.<Content>} */ const wrapped = [];
    if (typeof node.checked === "boolean") {
        /** @type {Element} */ let paragraph;
        if (result[0] && result[0].type === "element" && result[0].tagName === "p") paragraph = result[0];
        else {
            paragraph = h(null, "p", []);
            result.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift((0, $51193605e939011b$export$3b14a55fb2447963)("text", " "));
        paragraph.children.unshift(h(null, "input", {
            type: "checkbox",
            checked: node.checked,
            disabled: true
        }));
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        props.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < result.length){
        const child = result[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") wrapped.push((0, $51193605e939011b$export$3b14a55fb2447963)("text", "\n"));
        if (child.type === "element" && child.tagName === "p" && !loose) wrapped.push(...child.children);
        else wrapped.push(child);
    }
    const tail = result[result.length - 1];
    // Add a final eol.
    if (tail && (loose || !("tagName" in tail) || tail.tagName !== "p")) wrapped.push((0, $51193605e939011b$export$3b14a55fb2447963)("text", "\n"));
    return h(node, "li", props, wrapped);
}
/**
 * @param {List} node
 * @return {Boolean}
 */ function $0bf735405dac3389$var$listLoose(node) {
    let loose = node.spread;
    const children = node.children;
    let index = -1;
    while(!loose && ++index < children.length)loose = $0bf735405dac3389$var$listItemLoose(children[index]);
    return Boolean(loose);
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $0bf735405dac3389$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}



/**
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $3d9c5fb20df8334b$export$9c206ddddb32a9b(h, node) {
    return h(node, "p", (0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node));
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../index.js').Handler} Handler
 */ 


function $921589a7f49d4b71$export$e8e78c978b129247(h, node) {
    // @ts-expect-error `root`s are also fine.
    return h.augment(node, (0, $51193605e939011b$export$3b14a55fb2447963)("root", (0, $6312036d85444421$export$4997ffc0176396a6)((0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node))));
}


/**
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $76efd80b61faffa2$export$59ae2c325a998f89(h, node) {
    return h(node, "strong", (0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, node));
}


/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 * @typedef {import('../index.js').Content} Content
 */ 


function $be7da570dd44e9e6$export$9852986a3ec5f6a0(h, node) {
    const rows = node.children;
    let index = -1;
    const align = node.align || [];
    /** @type {Array.<Element>} */ const result = [];
    while(++index < rows.length){
        const row = rows[index].children;
        const name = index === 0 ? "th" : "td";
        let pos = node.align ? align.length : row.length;
        /** @type {Array.<Content>} */ const out = [];
        while(pos--){
            const cell = row[pos];
            out[pos] = h(cell, name, {
                align: align[pos]
            }, cell ? (0, $f4a5c290bddc7972$export$84bf76cd7afc7469)(h, cell) : []);
        }
        result[index] = h(rows[index], "tr", (0, $6312036d85444421$export$4997ffc0176396a6)(out, true));
    }
    return h(node, "table", (0, $6312036d85444421$export$4997ffc0176396a6)([
        h(result[0].position, "thead", (0, $6312036d85444421$export$4997ffc0176396a6)([
            result[0]
        ], true))
    ].concat(result[1] ? h({
        start: (0, $bbca31c5046a61f5$export$771bf3e4949bfbee)(result[1]),
        end: (0, $bbca31c5046a61f5$export$da309cdce9dc2a25)(result[result.length - 1])
    }, "tbody", (0, $6312036d85444421$export$4997ffc0176396a6)(result.slice(1), true)) : []), true));
}


/**
 * @typedef {import('mdast').Text} Text
 * @typedef {import('../index.js').Handler} Handler
 */ 
function $c898c12a1a7a9791$export$6f093cfa640b7166(h, node) {
    return h.augment(node, (0, $51193605e939011b$export$3b14a55fb2447963)("text", String(node.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, "$1")));
}



const $22ba932f8fab6e62$export$455ce229eb3d2472 = {
    blockquote: $0d7bf6069cd4a99d$export$67dc04e652a298ca,
    break: (0, $5f854cb469f7f6cd$export$371da9dd35aba193),
    code: $9f7a2a9a3e8cdc0a$export$6565f9f03506010b,
    delete: (0, $4f75ba80b35d3487$export$19426ff118fe8be),
    emphasis: $71ae8bf40e51fddd$export$bef81ba411953b51,
    footnoteReference: $d059032a2037e72d$export$7f87ee744075c1ba,
    footnote: $b302441aef2a42d1$export$3b6a720baa2c20ec,
    heading: $80a0025fee2734a4$export$46e4a324ac90507f,
    html: $a544d24f31a6d015$export$c0bb0b647f701bb5,
    imageReference: $34e938c73615b97e$export$f281796f6bc3b8db,
    image: $fa267d4e016e1a94$export$5c452ff88e35e47d,
    inlineCode: $a18e1d7c380780d4$export$91b9bee19a0d8569,
    linkReference: $5ffda1b647f76013$export$e6c469b1b7b2bc6a,
    link: $97ae763275816d1f$export$9c30223ca0a664fb,
    listItem: $0bf735405dac3389$export$76c7e83ecc9cdf05,
    list: $6d52c8b65c22a0f3$export$8837f4fc672e936d,
    paragraph: $3d9c5fb20df8334b$export$9c206ddddb32a9b,
    root: $921589a7f49d4b71$export$e8e78c978b129247,
    strong: $76efd80b61faffa2$export$59ae2c325a998f89,
    table: $be7da570dd44e9e6$export$9852986a3ec5f6a0,
    text: $c898c12a1a7a9791$export$6f093cfa640b7166,
    thematicBreak: $02537fefb8a9d631$export$ba7b13e047416c03,
    toml: $22ba932f8fab6e62$var$ignore,
    yaml: $22ba932f8fab6e62$var$ignore,
    definition: $22ba932f8fab6e62$var$ignore,
    footnoteDefinition: $22ba932f8fab6e62$var$ignore
};
// Return nothing for nodes that are ignored.
function $22ba932f8fab6e62$var$ignore() {
    return null;
}


const $e651c33bf4085f1d$var$own = {}.hasOwnProperty;
/**
 * Factory to transform.
 * @param {MdastNode} tree mdast node
 * @param {Options} [options] Configuration
 * @returns {H} `h` function
 */ function $e651c33bf4085f1d$var$factory(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Object.<string, FootnoteDefinition>} */ const footnoteById = {};
    h.dangerous = dangerous;
    h.definition = (0, $e3d29f9dd459ad71$export$d79264f26953ec1)(tree);
    h.footnoteById = footnoteById;
    /** @type {Array.<string>} */ h.footnoteOrder = [];
    h.augment = augment;
    h.handlers = {
        ...(0, $22ba932f8fab6e62$export$455ce229eb3d2472),
        ...settings.handlers
    };
    h.unknownHandler = settings.unknownHandler;
    h.passThrough = settings.passThrough;
    (0, $4ad53e9051b55a53$export$bf638b60ea8b89b7)(tree, "footnoteDefinition", (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$e651c33bf4085f1d$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return h;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   * @param {(NodeWithData|PositionLike)?} left
   * @param {Content} right
   * @returns {Content}
   */ function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left && left.data) {
            /** @type {Data} */ const data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ("children" in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = "type" in left ? left : {
                position: left
            };
            if (!(0, $2e8577aa1764555c$export$41ad1363166ec91a)(ctx)) right.position = {
                start: (0, $bbca31c5046a61f5$export$771bf3e4949bfbee)(ctx),
                end: (0, $bbca31c5046a61f5$export$da309cdce9dc2a25)(ctx)
            };
        }
        return right;
    }
    /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ function h(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
}
function $e651c33bf4085f1d$export$c0e4c5cf07538633(tree, options) {
    const h = $e651c33bf4085f1d$var$factory(tree, options);
    const node = (0, $f4a5c290bddc7972$export$80bf7733f1207381)(h, tree, null);
    const foot = (0, $43b288b5d784432f$export$adb608be33961c98)(h);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push((0, $51193605e939011b$export$3b14a55fb2447963)("text", "\n"), foot);
    return Array.isArray(node) ? {
        type: "root",
        children: node
    } : node;
}


// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin to bridge or mutate to rehype.
 *
 * If a destination is given, runs the destination with the new hast tree
 * (bridge-mode).
 * Without destination, returns the hast tree: further plugins run on that tree
 * (mutate-mode).
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $7f182373f6e7fb77$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && "run" in destination ? $7f182373f6e7fb77$var$bridge(destination, options) : $7f182373f6e7fb77$var$mutate(destination);
};
var $7f182373f6e7fb77$export$2e2bcd8739ae039 = $7f182373f6e7fb77$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $7f182373f6e7fb77$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $e651c33bf4085f1d$export$c0e4c5cf07538633)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further transformers run on the nlcst tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $7f182373f6e7fb77$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned for `toHast`.
    return (node)=>(0, $e651c33bf4085f1d$export$c0e4c5cf07538633)(node, options);
}



var $c9Z8w = parcelRequire("c9Z8w");
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $ebcb43fb277eac89$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $ebcb43fb277eac89$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $ebcb43fb277eac89$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $ebcb43fb277eac89$export$19342e026b58ebb7.prototype.space = null;


function $9557e96728c042cf$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $ebcb43fb277eac89$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $e8e4f4c42f412e49$export$a3295358bff77e(value) {
    return value.toLowerCase();
}



class $5570beed4f72c7cb$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.space = null;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.boolean = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.booleanish = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.number = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$5570beed4f72c7cb$export$c4868e4a24d48fad.prototype.defined = false;


var $7bb28a628b951544$exports = {};

$parcel$export($7bb28a628b951544$exports, "boolean", () => $7bb28a628b951544$export$4a21f16c33752377);
$parcel$export($7bb28a628b951544$exports, "booleanish", () => $7bb28a628b951544$export$55e9e1fbc638dc8f);
$parcel$export($7bb28a628b951544$exports, "overloadedBoolean", () => $7bb28a628b951544$export$242ac3d3042558aa);
$parcel$export($7bb28a628b951544$exports, "number", () => $7bb28a628b951544$export$98e628dec113755e);
$parcel$export($7bb28a628b951544$exports, "spaceSeparated", () => $7bb28a628b951544$export$ab8645c862eb5a3e);
$parcel$export($7bb28a628b951544$exports, "commaSeparated", () => $7bb28a628b951544$export$9c8d678629b3d3);
$parcel$export($7bb28a628b951544$exports, "commaOrSpaceSeparated", () => $7bb28a628b951544$export$2ad25cfebf36cacd);
let $7bb28a628b951544$var$powers = 0;
const $7bb28a628b951544$export$4a21f16c33752377 = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$55e9e1fbc638dc8f = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$242ac3d3042558aa = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$98e628dec113755e = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$ab8645c862eb5a3e = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$9c8d678629b3d3 = $7bb28a628b951544$var$increment();
const $7bb28a628b951544$export$2ad25cfebf36cacd = $7bb28a628b951544$var$increment();
function $7bb28a628b951544$var$increment() {
    return 2 ** ++$7bb28a628b951544$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $de3826e2cce515f8$var$checks = Object.keys($7bb28a628b951544$exports);
class $de3826e2cce515f8$export$ea6b9f0064e88c9b extends (0, $5570beed4f72c7cb$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $de3826e2cce515f8$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $de3826e2cce515f8$var$checks.length){
            const check = $de3826e2cce515f8$var$checks[index];
            $de3826e2cce515f8$var$mark(this, $de3826e2cce515f8$var$checks[index], (mask & $7bb28a628b951544$exports[check]) === $7bb28a628b951544$exports[check]);
        }
    }
}
$de3826e2cce515f8$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $de3826e2cce515f8$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}


const $9ab7a0f2f5273cb1$var$own = {}.hasOwnProperty;
function $9ab7a0f2f5273cb1$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($9ab7a0f2f5273cb1$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $de3826e2cce515f8$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $e8e4f4c42f412e49$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $e8e4f4c42f412e49$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $ebcb43fb277eac89$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $54e6fef78f3cbe14$export$2bd1230ec7600845 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $9c2001df32d7e0eb$export$f2913fe8983302e = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $fa5ee16f731231fb$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $f2ac7ad36db76cd1$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $fa5ee16f731231fb$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $6b2d9925b04ededa$export$e20c24a128671213 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $f2ac7ad36db76cd1$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $90343b68c9a7ed34$export$4d2d26490572750a = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaColIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaColSpan: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaControls: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaLevel: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaPressed: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaRowIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaRowSpan: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaSelected: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaValueMin: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaValueNow: (0, $7bb28a628b951544$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $71d94da779c1399e$export$c0bb0b647f701bb5 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $f2ac7ad36db76cd1$export$32b9e4cec9c208e1),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        acceptCharset: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        accessKey: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $7bb28a628b951544$export$4a21f16c33752377),
        allowPaymentRequest: (0, $7bb28a628b951544$export$4a21f16c33752377),
        allowUserMedia: (0, $7bb28a628b951544$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $7bb28a628b951544$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        autoFocus: (0, $7bb28a628b951544$export$4a21f16c33752377),
        autoPlay: (0, $7bb28a628b951544$export$4a21f16c33752377),
        capture: (0, $7bb28a628b951544$export$4a21f16c33752377),
        charSet: null,
        checked: (0, $7bb28a628b951544$export$4a21f16c33752377),
        cite: null,
        className: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        cols: (0, $7bb28a628b951544$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        controls: (0, $7bb28a628b951544$export$4a21f16c33752377),
        controlsList: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        coords: (0, $7bb28a628b951544$export$98e628dec113755e) | (0, $7bb28a628b951544$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $7bb28a628b951544$export$4a21f16c33752377),
        defer: (0, $7bb28a628b951544$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $7bb28a628b951544$export$4a21f16c33752377),
        download: (0, $7bb28a628b951544$export$242ac3d3042558aa),
        draggable: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $7bb28a628b951544$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        height: (0, $7bb28a628b951544$export$98e628dec113755e),
        hidden: (0, $7bb28a628b951544$export$4a21f16c33752377),
        high: (0, $7bb28a628b951544$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        httpEquiv: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $7bb28a628b951544$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        itemRef: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        itemScope: (0, $7bb28a628b951544$export$4a21f16c33752377),
        itemType: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $7bb28a628b951544$export$4a21f16c33752377),
        low: (0, $7bb28a628b951544$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $7bb28a628b951544$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $7bb28a628b951544$export$98e628dec113755e),
        multiple: (0, $7bb28a628b951544$export$4a21f16c33752377),
        muted: (0, $7bb28a628b951544$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noValidate: (0, $7bb28a628b951544$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $7bb28a628b951544$export$4a21f16c33752377),
        optimum: (0, $7bb28a628b951544$export$98e628dec113755e),
        pattern: null,
        ping: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $7bb28a628b951544$export$4a21f16c33752377),
        poster: null,
        preload: null,
        readOnly: (0, $7bb28a628b951544$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        required: (0, $7bb28a628b951544$export$4a21f16c33752377),
        reversed: (0, $7bb28a628b951544$export$4a21f16c33752377),
        rows: (0, $7bb28a628b951544$export$98e628dec113755e),
        rowSpan: (0, $7bb28a628b951544$export$98e628dec113755e),
        sandbox: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $7bb28a628b951544$export$4a21f16c33752377),
        seamless: (0, $7bb28a628b951544$export$4a21f16c33752377),
        selected: (0, $7bb28a628b951544$export$4a21f16c33752377),
        shape: null,
        size: (0, $7bb28a628b951544$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $7bb28a628b951544$export$98e628dec113755e),
        spellCheck: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $7bb28a628b951544$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $7bb28a628b951544$export$4a21f16c33752377),
        useMap: null,
        value: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        width: (0, $7bb28a628b951544$export$98e628dec113755e),
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $7bb28a628b951544$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $7bb28a628b951544$export$4a21f16c33752377),
        declare: (0, $7bb28a628b951544$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $7bb28a628b951544$export$98e628dec113755e),
        leftMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        marginWidth: (0, $7bb28a628b951544$export$98e628dec113755e),
        noResize: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noHref: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noShade: (0, $7bb28a628b951544$export$4a21f16c33752377),
        noWrap: (0, $7bb28a628b951544$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $7bb28a628b951544$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $7bb28a628b951544$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $7bb28a628b951544$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $7bb28a628b951544$export$4a21f16c33752377),
        disableRemotePlayback: (0, $7bb28a628b951544$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $7bb28a628b951544$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $81184b40caf3b243$export$7ed1367e7fa1ad68 = (0, $9ab7a0f2f5273cb1$export$185802fd694ee1f5)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $fa5ee16f731231fb$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        accentHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $7bb28a628b951544$export$98e628dec113755e),
        amplitude: (0, $7bb28a628b951544$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $7bb28a628b951544$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $7bb28a628b951544$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $7bb28a628b951544$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        className: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $7bb28a628b951544$export$98e628dec113755e),
        diffuseConstant: (0, $7bb28a628b951544$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $7bb28a628b951544$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $7bb28a628b951544$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $7bb28a628b951544$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $7bb28a628b951544$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $7bb28a628b951544$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        g2: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        glyphName: (0, $7bb28a628b951544$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $7bb28a628b951544$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $7bb28a628b951544$export$98e628dec113755e),
        horizOriginX: (0, $7bb28a628b951544$export$98e628dec113755e),
        horizOriginY: (0, $7bb28a628b951544$export$98e628dec113755e),
        id: null,
        ideographic: (0, $7bb28a628b951544$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $7bb28a628b951544$export$98e628dec113755e),
        k: (0, $7bb28a628b951544$export$98e628dec113755e),
        k1: (0, $7bb28a628b951544$export$98e628dec113755e),
        k2: (0, $7bb28a628b951544$export$98e628dec113755e),
        k3: (0, $7bb28a628b951544$export$98e628dec113755e),
        k4: (0, $7bb28a628b951544$export$98e628dec113755e),
        kernelMatrix: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $7bb28a628b951544$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $7bb28a628b951544$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $7bb28a628b951544$export$98e628dec113755e),
        overlineThickness: (0, $7bb28a628b951544$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $7bb28a628b951544$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $7bb28a628b951544$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $7bb28a628b951544$export$98e628dec113755e),
        pointsAtY: (0, $7bb28a628b951544$export$98e628dec113755e),
        pointsAtZ: (0, $7bb28a628b951544$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        rev: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        requiredFonts: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        requiredFormats: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $7bb28a628b951544$export$98e628dec113755e),
        specularExponent: (0, $7bb28a628b951544$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $7bb28a628b951544$export$98e628dec113755e),
        strikethroughThickness: (0, $7bb28a628b951544$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $7bb28a628b951544$export$98e628dec113755e),
        strokeOpacity: (0, $7bb28a628b951544$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $7bb28a628b951544$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        tabIndex: (0, $7bb28a628b951544$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $7bb28a628b951544$export$98e628dec113755e),
        targetY: (0, $7bb28a628b951544$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $7bb28a628b951544$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $7bb28a628b951544$export$98e628dec113755e),
        underlineThickness: (0, $7bb28a628b951544$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $7bb28a628b951544$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $7bb28a628b951544$export$98e628dec113755e),
        vMathematical: (0, $7bb28a628b951544$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $7bb28a628b951544$export$98e628dec113755e),
        vIdeographic: (0, $7bb28a628b951544$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $7bb28a628b951544$export$98e628dec113755e),
        vertOriginX: (0, $7bb28a628b951544$export$98e628dec113755e),
        vertOriginY: (0, $7bb28a628b951544$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $7bb28a628b951544$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 


const $a05ae03077f3d80b$var$valid = /^data[-\w.:]+$/i;
const $a05ae03077f3d80b$var$dash = /-[a-z]/g;
const $a05ae03077f3d80b$var$cap = /[A-Z]/g;
function $a05ae03077f3d80b$export$71aa6c912b956294(schema, value) {
    const normal = (0, $e8e4f4c42f412e49$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $5570beed4f72c7cb$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $a05ae03077f3d80b$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($a05ae03077f3d80b$var$dash, $a05ae03077f3d80b$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$a05ae03077f3d80b$var$dash.test(rest)) {
                let dashes = rest.replace($a05ae03077f3d80b$var$cap, $a05ae03077f3d80b$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $de3826e2cce515f8$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $a05ae03077f3d80b$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $a05ae03077f3d80b$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $d2bfbc2ede41b173$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};



const $01d5cbc38ad1c0e8$export$c0bb0b647f701bb5 = (0, $9557e96728c042cf$export$4950aa0f605343fb)([
    (0, $9c2001df32d7e0eb$export$f2913fe8983302e),
    (0, $54e6fef78f3cbe14$export$2bd1230ec7600845),
    (0, $6b2d9925b04ededa$export$e20c24a128671213),
    (0, $90343b68c9a7ed34$export$4d2d26490572750a),
    (0, $71d94da779c1399e$export$c0bb0b647f701bb5)
], "html");
const $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68 = (0, $9557e96728c042cf$export$4950aa0f605343fb)([
    (0, $9c2001df32d7e0eb$export$f2913fe8983302e),
    (0, $54e6fef78f3cbe14$export$2bd1230ec7600845),
    (0, $6b2d9925b04ededa$export$e20c24a128671213),
    (0, $90343b68c9a7ed34$export$4d2d26490572750a),
    (0, $81184b40caf3b243$export$7ed1367e7fa1ad68)
], "svg");



function $1f6d99e229d437d1$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $4ad53e9051b55a53$export$bf638b60ea8b89b7)(tree, "element", (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === "number") remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === "number") {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}


const $0f027a92973e6333$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
function $0f027a92973e6333$export$b83532a10e2e268b(uri) {
    const url = (uri || "").trim();
    const first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    const colon = url.indexOf(":");
    if (colon === -1) return url;
    let index = -1;
    while(++index < $0f027a92973e6333$var$protocols.length){
        const protocol = $0f027a92973e6333$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
}


/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'table'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: boolean}} TableCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableCellProps>} TableCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableCellComponent|ReactMarkdownNames} td
 * @property {TableCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $b9c59aaa17277982$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === "object" && thing.type === "text" ? thing.value || "" : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === "string" && value.replace(/[ \t\n\f\r]/g, "") === "";
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $38edd4def83e695e$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $38edd4def83e695e$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $79f9d1c25aee8303$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || "");
    let index = input.indexOf(",");
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $79f9d1c25aee8303$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === "" ? [
        ...values,
        ""
    ] : values;
    return input.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}


var $676978e4775c0e9c$exports = {};
var $9d69df5777ad44b8$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $9d69df5777ad44b8$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $9d69df5777ad44b8$var$NEWLINE_REGEX = /\n/g;
var $9d69df5777ad44b8$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $9d69df5777ad44b8$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $9d69df5777ad44b8$var$COLON_REGEX = /^:\s*/;
var $9d69df5777ad44b8$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $9d69df5777ad44b8$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $9d69df5777ad44b8$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $9d69df5777ad44b8$var$NEWLINE = "\n";
var $9d69df5777ad44b8$var$FORWARD_SLASH = "/";
var $9d69df5777ad44b8$var$ASTERISK = "*";
var $9d69df5777ad44b8$var$EMPTY_STRING = "";
// types
var $9d69df5777ad44b8$var$TYPE_COMMENT = "comment";
var $9d69df5777ad44b8$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $9d69df5777ad44b8$exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($9d69df5777ad44b8$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($9d69df5777ad44b8$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($9d69df5777ad44b8$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(0) || $9d69df5777ad44b8$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($9d69df5777ad44b8$var$EMPTY_STRING != style.charAt(i) && ($9d69df5777ad44b8$var$ASTERISK != style.charAt(i) || $9d69df5777ad44b8$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($9d69df5777ad44b8$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $9d69df5777ad44b8$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($9d69df5777ad44b8$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($9d69df5777ad44b8$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($9d69df5777ad44b8$var$VALUE_REGEX);
        var ret = pos({
            type: $9d69df5777ad44b8$var$TYPE_DECLARATION,
            property: $9d69df5777ad44b8$var$trim(prop[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)),
            value: val ? $9d69df5777ad44b8$var$trim(val[0].replace($9d69df5777ad44b8$var$COMMENT_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING)) : $9d69df5777ad44b8$var$EMPTY_STRING
        });
        // ;
        match($9d69df5777ad44b8$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $9d69df5777ad44b8$var$trim(str) {
    return str ? str.replace($9d69df5777ad44b8$var$TRIM_REGEX, $9d69df5777ad44b8$var$EMPTY_STRING) : $9d69df5777ad44b8$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $676978e4775c0e9c$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $9d69df5777ad44b8$exports(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$676978e4775c0e9c$exports = $676978e4775c0e9c$var$StyleToObject;


const $d2c4e6a13f14eb77$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $d2c4e6a13f14eb77$var$tableElements = new Set([
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
]);
function $d2c4e6a13f14eb77$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === "element") children.push($d2c4e6a13f14eb77$var$toReact(context, child, childIndex, node));
        else if (child.type === "text") // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== "element" || !$d2c4e6a13f14eb77$var$tableElements.has(node.tagName) || !(0, $b9c59aaa17277982$export$7af1228ff777d175)(child)) children.push(child.value);
        } else if (child.type === "raw" && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $d2c4e6a13f14eb77$var$toReact(context, node, index, parent) {
    const options = context.options;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === "html" && name === "svg") {
        schema = (0, $01d5cbc38ad1c0e8$export$7ed1367e7fa1ad68);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($d2c4e6a13f14eb77$var$own.call(node.properties, property)) $d2c4e6a13f14eb77$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === "ol" || name === "ul") context.listDepth++;
    const children = $d2c4e6a13f14eb77$export$4b745c302603ab5d(context, node);
    if (name === "ol" || name === "ul") context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $d2c4e6a13f14eb77$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === "string" || component === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3251146683c5d714$exports))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = [
        name,
        position.start.line,
        position.start.column,
        index
    ].join("-");
    if (name === "a" && options.linkTarget) properties.target = typeof options.linkTarget === "function" ? options.linkTarget(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null) : options.linkTarget;
    if (name === "a" && options.transformLinkUri) properties.href = options.transformLinkUri(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "code" && parent.type === "element" && parent.tagName !== "pre") properties.inline = true;
    if (!basic && (name === "h1" || name === "h2" || name === "h3" || name === "h4" || name === "h5" || name === "h6")) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === "img" && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ""), String(properties.alt || ""), typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "li" && parent.type === "element") {
        const input = $d2c4e6a13f14eb77$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === "ol";
    }
    if (!basic && (name === "ol" || name === "ul")) {
        properties.ordered = name === "ol";
        properties.depth = context.listDepth;
    }
    if (name === "td" || name === "th") {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === "th";
    }
    if (!basic && name === "tr" && parent.type === "element") properties.isHeader = Boolean(parent.tagName === "thead");
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties["data-sourcepos"] = $d2c4e6a13f14eb77$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $d2c4e6a13f14eb77$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === "element" && child.tagName === "input") return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $d2c4e6a13f14eb77$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === "element") count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $d2c4e6a13f14eb77$var$addProperty(props, prop, value, ctx) {
    const info = (0, $a05ae03077f3d80b$export$71aa6c912b956294)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $79f9d1c25aee8303$export$fac44ee5b035f737)(result) : (0, $38edd4def83e695e$export$fac44ee5b035f737)(result);
    if (info.property === "style" && typeof result === "string") result = $d2c4e6a13f14eb77$var$parseStyle(result);
    if (info.space && info.property) props[$d2c4e6a13f14eb77$var$own.call((0, $d2bfbc2ede41b173$export$d8abd7e5fb6871f9), info.property) ? (0, $d2bfbc2ede41b173$export$d8abd7e5fb6871f9)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $d2c4e6a13f14eb77$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, (/*@__PURE__*/$parcel$interopDefault($676978e4775c0e9c$exports)))(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === "-ms-" ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $d2c4e6a13f14eb77$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $d2c4e6a13f14eb77$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $d2c4e6a13f14eb77$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map((d)=>String(d)).join("");
}


const $cb8544603a0b034a$var$own = {}.hasOwnProperty;
const $cb8544603a0b034a$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {Record<string, Deprecation>} */ const $cb8544603a0b034a$var$deprecated = {
    renderers: {
        to: "components",
        id: "change-renderers-to-components"
    },
    astPlugins: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    allowDangerousHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    escapeHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    source: {
        to: "children",
        id: "change-source-to-children"
    },
    allowNode: {
        to: "allowElement",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    allowedTypes: {
        to: "allowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    disallowedTypes: {
        to: "disallowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    includeNodeIndex: {
        to: "includeElementIndex",
        id: "change-includenodeindex-to-includeelementindex"
    }
};
function $cb8544603a0b034a$export$83ef7ab426386201(options) {
    for(const key in $cb8544603a0b034a$var$deprecated)if ($cb8544603a0b034a$var$own.call($cb8544603a0b034a$var$deprecated, key) && $cb8544603a0b034a$var$own.call(options, key)) {
        const deprecation = $cb8544603a0b034a$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : "remove"} \`${key}\` (see <${$cb8544603a0b034a$var$changelog}#${deprecation.id}> for more info)`);
        delete $cb8544603a0b034a$var$deprecated[key];
    }
    const processor = (0, $cd17945441716b11$export$7cc1b2fe10c52bb)().use((0, $2aab0d1dd6b1383c$export$2e2bcd8739ae039))// TODO: deprecate `plugins` in v8.0.0.
    .use(options.remarkPlugins || options.plugins || []).use((0, $7f182373f6e7fb77$export$2e2bcd8739ae039), {
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $1f6d99e229d437d1$export$2e2bcd8739ae039), options);
    const file = new (0, $ebdb906eb43ac433$export$93dff69eb10dc7ce)();
    if (typeof options.children === "string") file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== "root") throw new TypeError("Expected a `root` node");
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {}, (0, $d2c4e6a13f14eb77$export$4b745c302603ab5d)({
        options: options,
        schema: (0, $01d5cbc38ad1c0e8$export$c0bb0b647f701bb5),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: options.className
    }, result);
    return result;
}
$cb8544603a0b034a$export$83ef7ab426386201.defaultProps = {
    transformLinkUri: (0, $0f027a92973e6333$export$b83532a10e2e268b)
};
$cb8544603a0b034a$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};




parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");

var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $7f59fc6bb97d136a$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");


var $13ea67090213a71b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            width: 40,
            height: 40,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(20),
            lineHeight: 1,
            borderRadius: "50%",
            overflow: "hidden",
            userSelect: "none"
        },
        /* Styles applied to the root element if not `src` or `srcSet`. */ colorDefault: {
            color: theme.palette.background.default,
            backgroundColor: theme.palette.type === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
        },
        /* Styles applied to the root element if `variant="circle"`. */ circle: {},
        /* Styles applied to the root element if `variant="circular"`. */ circular: {},
        /* Styles applied to the root element if `variant="rounded"`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="square"`. */ square: {
            borderRadius: 0
        },
        /* Styles applied to the img element if either `src` or `srcSet` is defined. */ img: {
            width: "100%",
            height: "100%",
            textAlign: "center",
            // Handle non-square image. The property isn't supported by IE 11.
            objectFit: "cover",
            // Hide alt text.
            color: "transparent",
            // Hide the image broken icon, only works on Chrome.
            textIndent: 10000
        },
        /* Styles applied to the fallback icon */ fallback: {
            width: "75%",
            height: "75%"
        }
    };
};
function $13ea67090213a71b$var$useLoaded(_ref) {
    var src = _ref.src, srcSet = _ref.srcSet;
    var _React$useState = $acw62.useState(false), loaded = _React$useState[0], setLoaded = _React$useState[1];
    $acw62.useEffect(function() {
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        var active = true;
        var image = new Image();
        image.src = src;
        image.srcSet = srcSet;
        image.onload = function() {
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = function() {
            if (!active) return;
            setLoaded("error");
        };
        return function() {
            active = false;
        };
    }, [
        src,
        srcSet
    ]);
    return loaded;
}
var $13ea67090213a71b$var$Avatar = /*#__PURE__*/ $acw62.forwardRef(function Avatar(props, ref) {
    var alt = props.alt, childrenProp = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, imgProps = props.imgProps, sizes = props.sizes, src = props.src, srcSet = props.srcSet, _props$variant = props.variant, variant = _props$variant === void 0 ? "circular" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "alt",
        "children",
        "classes",
        "className",
        "component",
        "imgProps",
        "sizes",
        "src",
        "srcSet",
        "variant"
    ]);
    var children = null; // Use a hook instead of onError on the img element to support server-side rendering.
    var loaded = $13ea67090213a71b$var$useLoaded({
        src: src,
        srcSet: srcSet
    });
    var hasImg = src || srcSet;
    var hasImgNotFailing = hasImg && loaded !== "error";
    if (hasImgNotFailing) children = /*#__PURE__*/ $acw62.createElement("img", (0, $8nd05.default)({
        alt: alt,
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ $acw62.createElement((0, $7f59fc6bb97d136a$export$2e2bcd8739ae039), {
        className: classes.fallback
    });
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
        ref: ref
    }, other), children);
});
var $13ea67090213a71b$export$2e2bcd8739ae039 = (0, $kQaj4.default)($13ea67090213a71b$export$9dd6ff9ea0189349, {
    name: "MuiAvatar"
})($13ea67090213a71b$var$Avatar);




var $45fvw = parcelRequire("45fvw");
const $084511095ab51c55$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            maxWidth: 200,
            display: "grid",
            gridAutoColumns: "1fr",
            gridTemplateColumns: "auto auto",
            gridTemplateRows: "1fr",
            gap: "0px 0px",
            gridTemplateAreas: "avatar data",
            width: "100%",
            height: "100%"
        },
        avatar_container: {
            gridArea: "avatar"
        },
        data_container: {
            gridArea: "data"
        },
        username: {
            fontFamily: "Ubuntu",
            fontStyle: "normal",
            fontWeight: "bold",
            fontSize: 16,
            lineHeight: "120%",
            textShadow: "0px 0px 20px rgba(4, 181, 0, 0.7)",
            backdropFilter: "blur(8px)",
            margin: "4px 0px"
        },
        avatar: {
            margin: "0px 8px"
        },
        date_text: {
            whiteSpace: "nowrap"
        }
    }));
function $084511095ab51c55$export$2e2bcd8739ae039({ avatar_url: avatar_url , author_name: author_name , post_date: post_date  }) {
    const classes = $084511095ab51c55$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "avatar_container",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ea67090213a71b$export$2e2bcd8739ae039), {
                    className: classes.avatar,
                    src: avatar_url
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "data_container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: classes.username,
                        children: author_name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: classes.date_text,
                        children: $45fvw(post_date).local().format("D/M/YYYY- h:mm A z")
                    })
                ]
            })
        ]
    });
}



parcelRequire("acw62");

const $ed87dbbed9d26a59$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        emoji_container: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            height: 26,
            padding: "4px 8px",
            background: "#304254",
            borderRadius: 4,
            margin: "2px 2px 2px 2px"
        },
        emoji_img: {
            display: "block",
            maxWidth: "18px",
            maxHeight: "18px",
            width: "auto",
            height: "auto"
        },
        emoji_img_container: {
            height: 18,
            width: 18,
            margin: "0px 4px",
            display: "flex",
            alignItems: "center",
            justifyItems: "center"
        },
        reactions_container: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center"
        },
        emoji_text: {
            height: 16,
            wight: 16
        }
    }));
function $ed87dbbed9d26a59$export$2e2bcd8739ae039({ reactions_data: reactions_data  }) {
    const classes = $ed87dbbed9d26a59$var$useStyles();
    function ReactionItem({ emoji_url: emoji_url , emoji_text: emoji_text , count: count  }) {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: classes.emoji_container,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: classes.emoji_img_container,
                    children: emoji_url === "" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: classes.emoji_text,
                        children: emoji_text
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: emoji_url,
                        className: classes.emoji_img
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    children: count
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: classes.reactions_container,
        children: reactions_data.map((reaction)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ReactionItem, {
                emoji_url: reaction.url,
                emoji_text: reaction.text,
                count: reaction.count
            }))
    });
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-gfm').Options & import('mdast-util-gfm').Options} Options
 */ /**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $870300dc21c8be50$var$wwwPrefix = {
    tokenize: $870300dc21c8be50$var$tokenizeWwwPrefix,
    partial: true
};
const $870300dc21c8be50$var$domain = {
    tokenize: $870300dc21c8be50$var$tokenizeDomain,
    partial: true
};
const $870300dc21c8be50$var$path = {
    tokenize: $870300dc21c8be50$var$tokenizePath,
    partial: true
};
const $870300dc21c8be50$var$trail = {
    tokenize: $870300dc21c8be50$var$tokenizeTrail,
    partial: true
};
const $870300dc21c8be50$var$emailDomainDotTrail = {
    tokenize: $870300dc21c8be50$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $870300dc21c8be50$var$wwwAutolink = {
    tokenize: $870300dc21c8be50$var$tokenizeWwwAutolink,
    previous: $870300dc21c8be50$var$previousWww
};
const $870300dc21c8be50$var$protocolAutolink = {
    tokenize: $870300dc21c8be50$var$tokenizeProtocolAutolink,
    previous: $870300dc21c8be50$var$previousProtocol
};
const $870300dc21c8be50$var$emailAutolink = {
    tokenize: $870300dc21c8be50$var$tokenizeEmailAutolink,
    previous: $870300dc21c8be50$var$previousEmail
};
/** @type {ConstructRecord} */ const $870300dc21c8be50$var$text = {};
const $870300dc21c8be50$export$608123d9b549151 = {
    text: $870300dc21c8be50$var$text
};
let $870300dc21c8be50$var$code = 48;
// Add alphanumerics.
while($870300dc21c8be50$var$code < 123){
    $870300dc21c8be50$var$text[$870300dc21c8be50$var$code] = $870300dc21c8be50$var$emailAutolink;
    $870300dc21c8be50$var$code++;
    if ($870300dc21c8be50$var$code === 58) $870300dc21c8be50$var$code = 65;
    else if ($870300dc21c8be50$var$code === 91) $870300dc21c8be50$var$code = 97;
}
$870300dc21c8be50$var$text[43] = $870300dc21c8be50$var$emailAutolink;
$870300dc21c8be50$var$text[45] = $870300dc21c8be50$var$emailAutolink;
$870300dc21c8be50$var$text[46] = $870300dc21c8be50$var$emailAutolink;
$870300dc21c8be50$var$text[95] = $870300dc21c8be50$var$emailAutolink;
$870300dc21c8be50$var$text[72] = [
    $870300dc21c8be50$var$emailAutolink,
    $870300dc21c8be50$var$protocolAutolink
];
$870300dc21c8be50$var$text[104] = [
    $870300dc21c8be50$var$emailAutolink,
    $870300dc21c8be50$var$protocolAutolink
];
$870300dc21c8be50$var$text[87] = [
    $870300dc21c8be50$var$emailAutolink,
    $870300dc21c8be50$var$wwwAutolink
];
$870300dc21c8be50$var$text[119] = [
    $870300dc21c8be50$var$emailAutolink,
    $870300dc21c8be50$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$870300dc21c8be50$var$gfmAtext(code) || !$870300dc21c8be50$var$previousEmail.call(self, self.previous) || $870300dc21c8be50$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkEmail");
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($870300dc21c8be50$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($870300dc21c8be50$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $432513c48b12fdfc$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit("literalAutolinkEmail");
            effects.exit("literalAutolink");
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$870300dc21c8be50$var$previousWww.call(self, self.previous) || $870300dc21c8be50$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkWww");
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($870300dc21c8be50$var$wwwPrefix, effects.attempt($870300dc21c8be50$var$domain, effects.attempt($870300dc21c8be50$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit("literalAutolinkWww");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = "";
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $870300dc21c8be50$var$previousProtocol.call(self, self.previous) && !$870300dc21c8be50$var$previousUnbalanced(self.events)) {
            effects.enter("literalAutolink");
            effects.enter("literalAutolinkHttp");
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === "http" || protocol === "https") {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $432513c48b12fdfc$export$67dbf494fc8394df)(code) || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) || (0, $432513c48b12fdfc$export$a0ff789c034ffdf4)(code) || (0, $432513c48b12fdfc$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($870300dc21c8be50$var$domain, effects.attempt($870300dc21c8be50$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit("literalAutolinkHttp");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($870300dc21c8be50$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) || (0, $432513c48b12fdfc$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $432513c48b12fdfc$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($870300dc21c8be50$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) || (0, $432513c48b12fdfc$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharRefStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) || (0, $432513c48b12fdfc$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code) || (0, $432513c48b12fdfc$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code) ? trailCharRefInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharRefInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $870300dc21c8be50$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $870300dc21c8be50$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $870300dc21c8be50$var$previousProtocol(code) {
    return !(0, $432513c48b12fdfc$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $870300dc21c8be50$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $870300dc21c8be50$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $870300dc21c8be50$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $432513c48b12fdfc$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $870300dc21c8be50$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
            result = true;
            break;
        }
        // @ts-expect-error If we’ve seen this token, and it was marked as not
        // having any unbalanced bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // @ts-expect-error Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ 
const $66b350feb28b9f84$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $66b350feb28b9f84$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $66b350feb28b9f84$var$characterReferences[value] + ";";
    }
}


function $628da7f4dfdef27c$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $66b350feb28b9f84$export$c564cdbbe6da493)($628da7f4dfdef27c$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $628da7f4dfdef27c$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "" // A correct percent encoded value.
        ;
        if (code === 37 && (0, $432513c48b12fdfc$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $432513c48b12fdfc$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1) // A correct surrogate pair.
            ;
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "�";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}


const $95fb6725110a34a2$export$999603f1f1c3d2f9 = {
    exit: {
        literalAutolinkEmail: $95fb6725110a34a2$var$literalAutolinkEmail,
        literalAutolinkHttp: $95fb6725110a34a2$var$literalAutolinkHttp,
        literalAutolinkWww: $95fb6725110a34a2$var$literalAutolinkWww
    }
};
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $95fb6725110a34a2$var$literalAutolinkWww(token) {
    $95fb6725110a34a2$var$anchorFromToken.call(this, token, "http://");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $95fb6725110a34a2$var$literalAutolinkEmail(token) {
    $95fb6725110a34a2$var$anchorFromToken.call(this, token, "mailto:");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $95fb6725110a34a2$var$literalAutolinkHttp(token) {
    $95fb6725110a34a2$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {void}
 */ function $95fb6725110a34a2$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $628da7f4dfdef27c$export$d130a2d684099e5a)((protocol || "") + url) + '">');
    this.raw(this.encode(url));
    this.tag("</a>");
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde.
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */ 


function $8de17f6af7e064b6$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = "strikethroughSequence";
                events[open][1].type = "strikethroughSequence";
                const strikethrough = {
                    type: "strikethrough",
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                const text = {
                    type: "strikethroughText",
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                const nextEvents = [
                    [
                        "enter",
                        strikethrough,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $0a9edb7ff3ef159f$export$869882364835d202)(nextEvents, nextEvents.length, 0, // @ts-expect-error: to do: update `mdast-util-types` to allow explicit `undefined`s.
                (0, $5fffc2d235733349$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $0a9edb7ff3ef159f$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        strikethrough,
                        context
                    ]
                ]);
                (0, $0a9edb7ff3ef159f$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === "strikethroughSequenceTemporary") events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter("strikethroughSequenceTemporary");
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $d2c40a75b3c1060a$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit("strikethroughSequenceTemporary");
            const after = (0, $d2c40a75b3c1060a$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function instead of object.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions`, to
 * support GFM strikethrough when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $541bc950d159d0d0$export$58acedca46108820 = {
    enter: {
        strikethrough () {
            this.tag("<del>");
        }
    },
    exit: {
        strikethrough () {
            this.tag("</del>");
        }
    }
};


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $17d4a96c5c2b61f6$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */ add(index, remove, add) {
        $17d4a96c5c2b61f6$var$addImpl(this, index, remove, add);
    }
    // To do: not used here.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {void}
    //  */
    // addBefore(index, remove, add) {
    //   addImpl(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */ consume(events) {
        this.map.sort((a, b)=>a[0] - b[0]);
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]));
            // eslint-disable-next-line unicorn/no-array-push-push
            vecs.push(this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push([
            ...events
        ]);
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            events.push(...slice);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {void}
 */ function $17d4a96c5c2b61f6$var$addImpl(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       console.log('to do: links?', add, rmCurr)
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ /**
 * @typedef {'left' | 'center' | 'right' | 'none'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {Array<Align>}
 */ function $84a857714c6d1171$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === "enter") // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === "tableContent") align.push(events[index + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
            } else if (event[1].type === "tableContent") {
                if (events[index - 1][1].type === "tableDelimiterMarker") {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
                }
            } else if (event[1].type === "tableDelimiterRow") break;
        } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") inDelimiterRow = true;
        index += 1;
    }
    return align;
}


const $e8e0082f4ed3192c$export$e36cebda627bf2dd = {
    flow: {
        null: {
            tokenize: $e8e0082f4ed3192c$var$tokenizeTable,
            resolveAll: $e8e0082f4ed3192c$var$resolveTable
        }
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e8e0082f4ed3192c$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter("tableHead");
        effects.enter("tableRow");
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit("tableRow");
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter("tableDelimiterRow");
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit("tableDelimiterFiller");
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit("tableDelimiterFiller");
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit("tableDelimiterRow");
            effects.exit("tableHead");
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter("tableRow");
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return bodyRowBreak;
        }
        if (code === null || (0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) {
            effects.exit("tableRow");
            return ok(code);
        }
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ // eslint-disable-next-line complexity
function $e8e0082f4ed3192c$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $17d4a96c5c2b61f6$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === "enter") {
            // Start of head.
            if (token.type === "tableHead") {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $e8e0082f4ed3192c$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: "table",
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        "enter",
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: "tableBody",
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            "enter",
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $e8e0082f4ed3192c$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === "tableCellDivider") {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $e8e0082f4ed3192c$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === "tableHead") {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $e8e0082f4ed3192c$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $e8e0082f4ed3192c$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) cell[3] = index;
    }
    if (lastTableEnd !== 0) $e8e0082f4ed3192c$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === "enter" && event[1].type === "table") // @ts-expect-error: custom field.
        event[1]._align = (0, $84a857714c6d1171$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/// Generate a cell.
/**
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {Range} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $e8e0082f4ed3192c$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = "tableContent";
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $e8e0082f4ed3192c$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $e8e0082f4ed3192c$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            "enter",
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $e8e0082f4ed3192c$var$getPoint(context.events, range[2]);
        const relatedEnd = $e8e0082f4ed3192c$var$getPoint(context.events, range[3]);
        const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                "enter",
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            // @ts-expect-error It’s fine.
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                "exit",
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $e8e0082f4ed3192c$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $e8e0082f4ed3192c$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $e8e0082f4ed3192c$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            "exit",
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        "exit",
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {readonly Point}
 */ function $e8e0082f4ed3192c$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === "enter" ? "start" : "end";
    return event[1][side];
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @typedef {import('./infer.js').Align} Align
 */ const $fdf0cfa5379dfe0c$var$alignment = {
    none: "",
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
const $fdf0cfa5379dfe0c$export$c64626c032567c7f = {
    enter: {
        table (token) {
            /** @type {Array<Align>} */ // @ts-expect-error Custom.
            const tableAlign = token._align;
            this.lineEndingIfNeeded();
            this.tag("<table>");
            this.setData("tableAlign", tableAlign);
        },
        tableBody () {
            this.tag("<tbody>");
        },
        tableData () {
            const tableAlign = /** @type {Array<Align>} */ this.getData("tableAlign");
            const tableColumn = /** @type {number} */ this.getData("tableColumn");
            const align = $fdf0cfa5379dfe0c$var$alignment[tableAlign[tableColumn]];
            if (align === undefined) // Capture results to ignore them.
            this.buffer();
            else {
                this.lineEndingIfNeeded();
                this.tag("<td" + align + ">");
            }
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("<thead>");
        },
        tableHeader () {
            const tableAlign = /** @type {Array<Align>} */ this.getData("tableAlign");
            const tableColumn = /** @type {number} */ this.getData("tableColumn");
            const align = $fdf0cfa5379dfe0c$var$alignment[tableAlign[tableColumn]];
            this.lineEndingIfNeeded();
            this.tag("<th" + align + ">");
        },
        tableRow () {
            this.setData("tableColumn", 0);
            this.lineEndingIfNeeded();
            this.tag("<tr>");
        }
    },
    exit: {
        // Overwrite the default code text data handler to unescape escaped pipes when
        // they are in tables.
        codeTextData (token) {
            let value = this.sliceSerialize(token);
            if (this.getData("tableAlign")) value = value.replace(/\\([\\|])/g, $fdf0cfa5379dfe0c$var$replace);
            this.raw(this.encode(value));
        },
        table () {
            this.setData("tableAlign");
            // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
            // but we do need to reset it to match a funky newline GH generates for
            // list items combined with tables.
            this.setData("slurpAllLineEndings");
            this.lineEndingIfNeeded();
            this.tag("</table>");
        },
        tableBody () {
            this.lineEndingIfNeeded();
            this.tag("</tbody>");
        },
        tableData () {
            const tableAlign = /** @type {Array<Align>} */ this.getData("tableAlign");
            const tableColumn = /** @type {number} */ this.getData("tableColumn");
            if (tableColumn in tableAlign) {
                this.tag("</td>");
                this.setData("tableColumn", tableColumn + 1);
            } else // Stop capturing.
            this.resume();
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("</thead>");
        },
        tableHeader () {
            const tableColumn = /** @type {number} */ this.getData("tableColumn");
            this.tag("</th>");
            this.setData("tableColumn", tableColumn + 1);
        },
        tableRow () {
            const tableAlign = /** @type {Array<Align>} */ this.getData("tableAlign");
            let tableColumn = /** @type {number} */ this.getData("tableColumn");
            while(tableColumn < tableAlign.length){
                this.lineEndingIfNeeded();
                this.tag("<td" + $fdf0cfa5379dfe0c$var$alignment[tableAlign[tableColumn]] + "></td>");
                tableColumn++;
            }
            this.setData("tableColumn", tableColumn);
            this.lineEndingIfNeeded();
            this.tag("</tr>");
        }
    }
};
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $fdf0cfa5379dfe0c$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $828380b1cc355827$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $828380b1cc355827$var$reText = new RegExp("^" + $828380b1cc355827$var$reFlow.source, "i");
const $828380b1cc355827$export$c9bf87ea36d00682 = {
    exit: {
        htmlFlowData (token) {
            $828380b1cc355827$var$exitHtmlData.call(this, token, $828380b1cc355827$var$reFlow);
        },
        htmlTextData (token) {
            $828380b1cc355827$var$exitHtmlData.call(this, token, $828380b1cc355827$var$reText);
        }
    }
};
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 */ function $828380b1cc355827$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, "&lt;$1$2");
    this.raw(this.encode(value));
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $b0463e2b7dbcb345$var$tasklistCheck = {
    tokenize: $b0463e2b7dbcb345$var$tokenizeTasklistCheck
};
const $b0463e2b7dbcb345$export$2912e8b2802475ff = {
    text: {
        [91]: $b0463e2b7dbcb345$var$tasklistCheck
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b0463e2b7dbcb345$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter("taskListCheck");
        effects.enter("taskListCheckMarker");
        effects.consume(code);
        effects.exit("taskListCheckMarker");
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $432513c48b12fdfc$export$a30284361b3814b7)(code)) {
            effects.enter("taskListCheckValueUnchecked");
            effects.consume(code);
            effects.exit("taskListCheckValueUnchecked");
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter("taskListCheckValueChecked");
            effects.consume(code);
            effects.exit("taskListCheckValueChecked");
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter("taskListCheckMarker");
            effects.consume(code);
            effects.exit("taskListCheckMarker");
            effects.exit("taskListCheck");
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $432513c48b12fdfc$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $432513c48b12fdfc$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $b0463e2b7dbcb345$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b0463e2b7dbcb345$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $653f8b80711d97d0$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function to make extension.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions` to
 * support GFM task list items when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $833162a9c651eda0$export$4b6a13e2af1b08ed = {
    enter: {
        taskListCheck () {
            this.tag('<input type="checkbox" disabled="" ');
        }
    },
    exit: {
        taskListCheck () {
            this.tag("/>");
        },
        taskListCheckValueChecked () {
            this.tag('checked="" ');
        }
    }
};


function $efcd1b8103398179$export$59ffe8c4d7a4aab2(options) {
    return (0, $12b512a5203a7cce$export$86a865d89ef3c690)([
        (0, $870300dc21c8be50$export$608123d9b549151),
        (0, $8de17f6af7e064b6$export$8bbec8ea1400a00e)(options),
        (0, $e8e0082f4ed3192c$export$e36cebda627bf2dd),
        (0, $b0463e2b7dbcb345$export$2912e8b2802475ff)
    ]);
}
const $efcd1b8103398179$export$6983b82e6105d62a = (0, $12b512a5203a7cce$export$eaf8c406dfb0a620)([
    (0, $95fb6725110a34a2$export$999603f1f1c3d2f9),
    (0, $541bc950d159d0d0$export$58acedca46108820),
    (0, $fdf0cfa5379dfe0c$export$c64626c032567c7f),
    (0, $828380b1cc355827$export$c9bf87ea36d00682),
    (0, $833162a9c651eda0$export$4b6a13e2af1b08ed)
]);


/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-gfm-table').Options} Options
 */ /**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $d213d2d8a1d4dc2a$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== "string") throw new TypeError("Expected character");
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


/**
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Content | Root} Node
 * @typedef {Extract<Node, MdastParent>} Parent
 * @typedef {Exclude<Parent, Root>} ContentParent
 *
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[Root, ...Array<ContentParent>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | undefined | null}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {string | RegExp} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 * @typedef {Record<string, Replace>} FindAndReplaceSchema
 *   Several find and replaces, in object form.
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 * @typedef {string | ReplaceFunction} Replace
 *   Thing to replace with.
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore.
 */ function $fa553a9daaa2884b$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}




const $a63c8d941f8d83a2$var$own = {}.hasOwnProperty;
const $a63c8d941f8d83a2$export$fb306ebf003fc574 = /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/ /**
     * @template {Node} Tree
     * @param {Tree} tree
     * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
     * @param {Replace | Options | null | undefined} [replace]
     * @param {Options | null | undefined} [options]
     * @returns {Tree}
     */ function(tree, find, replace, options) {
    /** @type {Options | null | undefined} */ let settings;
    /** @type {FindAndReplaceSchema|FindAndReplaceList} */ let schema;
    if (typeof find === "string" || find instanceof RegExp) {
        // @ts-expect-error don’t expect options twice.
        schema = [
            [
                find,
                replace
            ]
        ];
        settings = options;
    } else {
        schema = find;
        // @ts-expect-error don’t expect replace twice.
        settings = replace;
    }
    if (!settings) settings = {};
    const ignored = (0, $96c8174c61624bc3$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $a63c8d941f8d83a2$var$toPairs(schema);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $d5f8100665f1cd06$export$70008a21eb6de899)(tree, "text", visitor);
    // To do next major: don’t return the given tree.
    return tree;
    /** @type {import('unist-util-visit-parents/complex-types.js').BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parent | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            if (ignored(parent, // @ts-expect-error: TS doesn’t understand but it’s perfect.
            grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
       * Handle a text node which is not in an ignored parent.
       *
       * @param {Text} node
       *   Text node.
       * @param {Array<Parent>} parents
       *   Parents.
       * @returns {VisitorResult}
       *   Result.
       */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        // @ts-expect-error: TS is wrong, some of these children can be text.
        const index = parent.children.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                // @ts-expect-error: stack is fine.
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === "string") value = value.length > 0 ? {
                type: "text",
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value !== false) {
                if (start !== position) nodes.push({
                    type: "text",
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: "text",
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
};
/**
 * Turn a schema into pairs.
 *
 * @param {FindAndReplaceSchema | FindAndReplaceList} schema
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $a63c8d941f8d83a2$var$toPairs(schema) {
    /** @type {Pairs} */ const result = [];
    if (typeof schema !== "object") throw new TypeError("Expected array or object as schema");
    if (Array.isArray(schema)) {
        let index = -1;
        while(++index < schema.length)result.push([
            $a63c8d941f8d83a2$var$toExpression(schema[index][0]),
            $a63c8d941f8d83a2$var$toFunction(schema[index][1])
        ]);
    } else {
        /** @type {string} */ let key;
        for(key in schema)if ($a63c8d941f8d83a2$var$own.call(schema, key)) result.push([
            $a63c8d941f8d83a2$var$toExpression(key),
            $a63c8d941f8d83a2$var$toFunction(schema[key])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $a63c8d941f8d83a2$var$toExpression(find) {
    return typeof find === "string" ? new RegExp((0, $fa553a9daaa2884b$export$2e2bcd8739ae039)(find), "g") : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $a63c8d941f8d83a2$var$toFunction(replace) {
    return typeof replace === "function" ? replace : ()=>replace;
}



/** @type {ConstructName} */ const $e2d831a13731c0dd$var$inConstruct = "phrasing";
/** @type {Array<ConstructName>} */ const $e2d831a13731c0dd$var$notInConstruct = [
    "autolink",
    "link",
    "image",
    "label"
];
const $e2d831a13731c0dd$export$b6afdfff2163546f = {
    transforms: [
        $e2d831a13731c0dd$var$transformGfmAutolinkLiterals
    ],
    enter: {
        literalAutolink: $e2d831a13731c0dd$var$enterLiteralAutolink,
        literalAutolinkEmail: $e2d831a13731c0dd$var$enterLiteralAutolinkValue,
        literalAutolinkHttp: $e2d831a13731c0dd$var$enterLiteralAutolinkValue,
        literalAutolinkWww: $e2d831a13731c0dd$var$enterLiteralAutolinkValue
    },
    exit: {
        literalAutolink: $e2d831a13731c0dd$var$exitLiteralAutolink,
        literalAutolinkEmail: $e2d831a13731c0dd$var$exitLiteralAutolinkEmail,
        literalAutolinkHttp: $e2d831a13731c0dd$var$exitLiteralAutolinkHttp,
        literalAutolinkWww: $e2d831a13731c0dd$var$exitLiteralAutolinkWww
    }
};
const $e2d831a13731c0dd$export$d3ace9096b01c39d = {
    unsafe: [
        {
            character: "@",
            before: "[+\\-.\\w]",
            after: "[\\-.\\w]",
            inConstruct: $e2d831a13731c0dd$var$inConstruct,
            notInConstruct: $e2d831a13731c0dd$var$notInConstruct
        },
        {
            character: ".",
            before: "[Ww]",
            after: "[\\-.\\w]",
            inConstruct: $e2d831a13731c0dd$var$inConstruct,
            notInConstruct: $e2d831a13731c0dd$var$notInConstruct
        },
        {
            character: ":",
            before: "[ps]",
            after: "\\/",
            inConstruct: $e2d831a13731c0dd$var$inConstruct,
            notInConstruct: $e2d831a13731c0dd$var$notInConstruct
        }
    ]
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$enterLiteralAutolink(token) {
    this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = /** @type {Link} */ this.stack[this.stack.length - 1];
    node.url = "http://" + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $e2d831a13731c0dd$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $e2d831a13731c0dd$var$transformGfmAutolinkLiterals(tree) {
    (0, $a63c8d941f8d83a2$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $e2d831a13731c0dd$var$findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g,
            $e2d831a13731c0dd$var$findEmail
        ]
    ], {
        ignore: [
            "link",
            "linkReference"
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Link | Array<PhrasingContent> | false}
 */ // eslint-disable-next-line max-params
function $e2d831a13731c0dd$var$findUrl(_, protocol, domain, path, match) {
    let prefix = "";
    // Not an expected previous character.
    if (!$e2d831a13731c0dd$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = "";
        prefix = "http://";
    }
    if (!$e2d831a13731c0dd$var$isCorrectDomain(domain)) return false;
    const parts = $e2d831a13731c0dd$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: "link",
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: "text",
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: "text",
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $e2d831a13731c0dd$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$e2d831a13731c0dd$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: "link",
        title: null,
        url: "mailto:" + atext + "@" + label,
        children: [
            {
                type: "text",
                value: atext + "@" + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $e2d831a13731c0dd$var$isCorrectDomain(domain) {
    const parts = domain.split(".");
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $e2d831a13731c0dd$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(")");
    const openingParens = (0, $d213d2d8a1d4dc2a$export$fa42eaa97a352e23)(url, "(");
    let closingParens = (0, $d213d2d8a1d4dc2a$export$fa42eaa97a352e23)(url, ")");
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(")");
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $e2d831a13731c0dd$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $432513c48b12fdfc$export$a0ff789c034ffdf4)(code) || (0, $432513c48b12fdfc$export$aa04114dd888a7a0)(code)) && (!email || code !== 47);
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {import('../types.js').Handle} Handle
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').PhrasingContent} PhrasingContent
 * @typedef {import('../types.js').State} State
 */ /**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @param {Parent & {children: Array<PhrasingContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $672cb4db25cfb369$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, {
                before: "",
                after: "",
                ...tracker.current()
            }).charAt(0) : "";
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === "\r" || before === "\n") && child.type === "html") {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, " ");
            before = " ";
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(""));
        }
        results.push(tracker.move(state.handle(child, parent, state, {
            ...tracker.current(),
            before: before,
            after: after
        })));
        before = results[results.length - 1].slice(-1);
    }
    indexStack.pop();
    return results.join("");
}


/**
 * @typedef {import('../types.js').CreateTracker} CreateTracker
 * @typedef {import('../types.js').TrackCurrent} TrackCurrent
 * @typedef {import('../types.js').TrackMove} TrackMove
 * @typedef {import('../types.js').TrackShift} TrackShift
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $6966a4bac7e40d15$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || "";
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}


// To do: next major: expose functions.
// To do: next major: use `state`, state utilities.
/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $490483cfdd6b5d27$var$constructsWithoutStrikethrough = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
];
$490483cfdd6b5d27$var$handleDelete.peek = $490483cfdd6b5d27$var$peekDelete;
const $490483cfdd6b5d27$export$34d64e709dd0b9bb = {
    canContainEols: [
        "delete"
    ],
    enter: {
        strikethrough: $490483cfdd6b5d27$var$enterStrikethrough
    },
    exit: {
        strikethrough: $490483cfdd6b5d27$var$exitStrikethrough
    }
};
const $490483cfdd6b5d27$export$1632835bd2c84956 = {
    unsafe: [
        {
            character: "~",
            inConstruct: "phrasing",
            notInConstruct: $490483cfdd6b5d27$var$constructsWithoutStrikethrough
        }
    ],
    handlers: {
        delete: $490483cfdd6b5d27$var$handleDelete
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $490483cfdd6b5d27$var$enterStrikethrough(token) {
    this.enter({
        type: "delete",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $490483cfdd6b5d27$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $490483cfdd6b5d27$var$handleDelete(node, _, context, safeOptions) {
    const tracker = (0, $6966a4bac7e40d15$export$6b2a7d5132615086)(safeOptions);
    const exit = context.enter("strikethrough");
    let value = tracker.move("~~");
    value += (0, $672cb4db25cfb369$export$f4090a9439f37631)(node, context, {
        ...tracker.current(),
        before: value,
        after: "~"
    });
    value += tracker.move("~~");
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $490483cfdd6b5d27$var$peekDelete() {
    return "~";
}


/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').InlineCode} InlineCode
 *
 * @typedef {import('markdown-table').MarkdownTableOptions} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Context} ToMarkdownContext
 * @typedef {import('mdast-util-to-markdown').SafeOptions} SafeOptions
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells.
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters.
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells
 */ 
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */ /**
 * @param {Unsafe} pattern
 * @returns {RegExp}
 */ function $c874fcc3f337e271$export$7993761911514c15(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? "[\\r\\n][\\t ]*" : "") + (pattern.before ? "(?:" + pattern.before + ")" : "");
        pattern._compiled = new RegExp((before ? "(" + before + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? "\\" : "") + pattern.character + (pattern.after ? "(?:" + pattern.after + ")" : ""), "g");
    }
    return pattern._compiled;
}


$85c0b25e011fb514$export$91b9bee19a0d8569.peek = $85c0b25e011fb514$var$inlineCodePeek;
function $85c0b25e011fb514$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || "";
    let sequence = "`";
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value))sequence += "`";
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = " " + value + " ";
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = (0, $c874fcc3f337e271$export$7993761911514c15)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + " " + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $85c0b25e011fb514$var$inlineCodePeek() {
    return "`";
}


/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|ReadonlyArray<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */ /**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {ReadonlyArray<ReadonlyArray<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */ function $cb34e05222debc2c$export$cdb7288612c4f3d6(table, options = {}) {
    const align = (options.align || []).concat();
    const stringLength = options.stringLength || $cb34e05222debc2c$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $cb34e05222debc2c$var$serialize(table[rowIndex][columnIndex]);
            if (options.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === "object" && "length" in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $cb34e05222debc2c$var$toAlignment(align[columnIndex]);
    else {
        const code = $cb34e05222debc2c$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = "";
        let after = "";
        if (code === 99 /* `c` */ ) {
            before = ":";
            after = ":";
        } else if (code === 108 /* `l` */ ) before = ":";
        else if (code === 114 /* `r` */ ) after = ":";
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = options.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + "-".repeat(size) + after;
        if (options.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || "";
            let before = "";
            let after = "";
            if (options.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = " ".repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = " ".repeat(size / 2 + 0.5);
                        after = " ".repeat(size / 2 - 0.5);
                    } else {
                        before = " ".repeat(size / 2);
                        after = before;
                    }
                } else after = " ".repeat(size);
            }
            if (options.delimiterStart !== false && !columnIndex) line.push("|");
            if (options.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(options.alignDelimiters === false && cell === "") && (options.delimiterStart !== false || columnIndex)) line.push(" ");
            if (options.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (options.alignDelimiters !== false) line.push(after);
            if (options.padding !== false) line.push(" ");
            if (options.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push("|");
        }
        lines.push(options.delimiterEnd === false ? line.join("").replace(/ +$/, "") : line.join(""));
    }
    return lines.join("\n");
}
/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */ function $cb34e05222debc2c$var$serialize(value) {
    return value === null || value === undefined ? "" : String(value);
}
/**
 * @param {string} value
 * @returns {number}
 */ function $cb34e05222debc2c$var$defaultStringLength(value) {
    return value.length;
}
/**
 * @param {string|null|undefined} value
 * @returns {number}
 */ function $cb34e05222debc2c$var$toAlignment(value) {
    const code = typeof value === "string" ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


const $7f6220023e6c5bbd$export$8bd0ec8ecf6adb7d = {
    enter: {
        table: $7f6220023e6c5bbd$var$enterTable,
        tableData: $7f6220023e6c5bbd$var$enterCell,
        tableHeader: $7f6220023e6c5bbd$var$enterCell,
        tableRow: $7f6220023e6c5bbd$var$enterRow
    },
    exit: {
        codeText: $7f6220023e6c5bbd$var$exitCodeText,
        table: $7f6220023e6c5bbd$var$exitTable,
        tableData: $7f6220023e6c5bbd$var$exit,
        tableHeader: $7f6220023e6c5bbd$var$exit,
        tableRow: $7f6220023e6c5bbd$var$exit
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$enterTable(token) {
    /** @type {Array<'left' | 'right' | 'center' | 'none'>} */ // @ts-expect-error: `align` is custom.
    const align = token._align;
    this.enter({
        type: "table",
        align: align.map((d)=>d === "none" ? null : d),
        children: []
    }, token);
    this.setData("inTable", true);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$exitTable(token) {
    this.exit(token);
    this.setData("inTable");
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$enterRow(token) {
    this.enter({
        type: "tableRow",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$enterCell(token) {
    this.enter({
        type: "tableCell",
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7f6220023e6c5bbd$var$exitCodeText(token) {
    let value = this.resume();
    if (this.getData("inTable")) value = value.replace(/\\([\\|])/g, $7f6220023e6c5bbd$var$replace);
    const node = /** @type {InlineCode} */ this.stack[this.stack.length - 1];
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $7f6220023e6c5bbd$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}
function $7f6220023e6c5bbd$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? " " : "|";
    return {
        unsafe: [
            {
                character: "\r",
                inConstruct: "tableCell"
            },
            {
                character: "\n",
                inConstruct: "tableCell"
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: "|",
                after: "[	 :-]"
            },
            // A pipe in a cell must be encoded.
            {
                character: "|",
                inConstruct: "tableCell"
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ":",
                after: "-"
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            table: handleTable,
            tableRow: handleTableRow,
            tableCell: handleTableCell,
            inlineCode: inlineCodeWithTable
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, context, safeOptions) {
        return serializeData(handleTableAsData(node, context, safeOptions), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, context, safeOptions) {
        const row = handleTableRowAsData(node, context, safeOptions);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf("\n"));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, context, safeOptions) {
        const exit = context.enter("tableCell");
        const subexit = context.enter("phrasing");
        const value = (0, $672cb4db25cfb369$export$f4090a9439f37631)(node, context, {
            ...safeOptions,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $cb34e05222debc2c$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = context.enter("table");
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableRowAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = context.enter("tableRow");
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, context) {
        let value = (0, $85c0b25e011fb514$export$91b9bee19a0d8569)(node, parent, context);
        if (context.stack.includes("tableCell")) value = value.replace(/\|/g, "\\$&");
        return value;
    }
}


/**
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {Extract<Root | Content, Parent>} Parents
 */ /**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ /**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $72597098fa7e90b1$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || "*";
    if (marker !== "*" && marker !== "+" && marker !== "-") throw new Error("Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return marker;
}


/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $65267d532af6493a$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || "tab";
    // To do: remove in a major.
    // @ts-expect-error: deprecated.
    if (style === 1 || style === "1") return "one";
    if (style !== "tab" && style !== "one" && style !== "mixed") throw new Error("Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return style;
}


function $f3edcc74c0b233fe$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $65267d532af6493a$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $72597098fa7e90b1$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === "list" && parent.ordered) bullet = (typeof parent.start === "number" && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.type === "list" && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + " ".repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter("listItem");
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? "" : " ".repeat(size)) + line;
        return (blank ? bullet : bullet + " ".repeat(size - bullet.length)) + line;
    }
}



const $4bb08fb2c9b2cb2b$export$a427a608608b215f = {
    exit: {
        taskListCheckValueChecked: $4bb08fb2c9b2cb2b$var$exitCheck,
        taskListCheckValueUnchecked: $4bb08fb2c9b2cb2b$var$exitCheck,
        paragraph: $4bb08fb2c9b2cb2b$var$exitParagraphWithTaskListItem
    }
};
const $4bb08fb2c9b2cb2b$export$9975722e7e834b78 = {
    unsafe: [
        {
            atBreak: true,
            character: "-",
            after: "[:|-]"
        }
    ],
    handlers: {
        listItem: $4bb08fb2c9b2cb2b$var$listItemWithTaskListItem
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4bb08fb2c9b2cb2b$var$exitCheck(token) {
    const node = /** @type {ListItem} */ this.stack[this.stack.length - 2];
    // We’re always in a paragraph, in a list item.
    node.checked = token.type === "taskListCheckValueChecked";
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4bb08fb2c9b2cb2b$var$exitParagraphWithTaskListItem(token) {
    const parent = /** @type {Parents} */ this.stack[this.stack.length - 2];
    if (parent && parent.type === "listItem" && typeof parent.checked === "boolean") {
        const node = /** @type {Paragraph} */ this.stack[this.stack.length - 1];
        const head = node.children[0];
        if (head && head.type === "text") {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === "paragraph") {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === "number") {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $4bb08fb2c9b2cb2b$var$listItemWithTaskListItem(node, parent, context, safeOptions) {
    const head = node.children[0];
    const checkable = typeof node.checked === "boolean" && head && head.type === "paragraph";
    const checkbox = "[" + (node.checked ? "x" : " ") + "] ";
    const tracker = (0, $6966a4bac7e40d15$export$6b2a7d5132615086)(safeOptions);
    if (checkable) tracker.move(checkbox);
    let value = (0, $f3edcc74c0b233fe$export$76c7e83ecc9cdf05)(node, parent, context, {
        ...safeOptions,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


const $4212352a90319ff1$export$95adae814eb7433e = [
    (0, $e2d831a13731c0dd$export$b6afdfff2163546f),
    (0, $490483cfdd6b5d27$export$34d64e709dd0b9bb),
    (0, $7f6220023e6c5bbd$export$8bd0ec8ecf6adb7d),
    (0, $4bb08fb2c9b2cb2b$export$a427a608608b215f)
];
function $4212352a90319ff1$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $e2d831a13731c0dd$export$d3ace9096b01c39d),
            (0, $490483cfdd6b5d27$export$1632835bd2c84956),
            (0, $7f6220023e6c5bbd$export$dafcad76ea6e0045)(options),
            (0, $4bb08fb2c9b2cb2b$export$9975722e7e834b78)
        ]
    };
}


function $5a545addcc5524a2$export$2e2bcd8739ae039(options = {}) {
    const data = this.data();
    add("micromarkExtensions", (0, $efcd1b8103398179$export$59ffe8c4d7a4aab2)(options));
    add("fromMarkdownExtensions", (0, $4212352a90319ff1$export$95adae814eb7433e));
    add("toMarkdownExtensions", (0, $4212352a90319ff1$export$ea77de6901e7c72b)(options));
    /**
   * @param {string} field
   * @param {unknown} value
   */ function add(field, value) {
        const list = /** @type {unknown[]} */ // Other extensions
        /* c8 ignore next 2 */ data[field] ? data[field] : data[field] = [];
        list.push(value);
    }
}



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");



var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $c692acbe65dd62b9$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "flex",
        flexWrap: "wrap",
        overflowY: "auto",
        listStyle: "none",
        padding: 0,
        WebkitOverflowScrolling: "touch" // Add iOS momentum scrolling.
    }
};
var $c692acbe65dd62b9$var$ImageList = /*#__PURE__*/ $acw62.forwardRef(function ImageList(props, ref) {
    var cellHeight = props.cellHeight, children = props.children, classes = props.classes, className = props.className, _props$cols = props.cols, cols = _props$cols === void 0 ? 2 : _props$cols, _props$component = props.component, Component = _props$component === void 0 ? "ul" : _props$component, _props$gap = props.gap, gapProp = _props$gap === void 0 ? 4 : _props$gap, _props$rowHeight = props.rowHeight, rowHeightProp = _props$rowHeight === void 0 ? 180 : _props$rowHeight, spacing = props.spacing, style = props.style, other = (0, $9X7IJ.default)(props, [
        "cellHeight",
        "children",
        "classes",
        "className",
        "cols",
        "component",
        "gap",
        "rowHeight",
        "spacing",
        "style"
    ]);
    var gap = spacing || gapProp;
    var rowHeight = cellHeight || rowHeightProp;
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref,
        style: (0, $8nd05.default)({
            margin: -gap / 2
        }, style)
    }, other), $acw62.Children.map(children, function(child) {
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        var childCols = child.props.cols || 1;
        var childRows = child.props.rows || 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            style: (0, $8nd05.default)({
                width: "".concat(100 / cols * childCols, "%"),
                height: rowHeight === "auto" ? "auto" : rowHeight * childRows + gap,
                padding: gap / 2
            }, child.props.style)
        });
    }));
});
var $c692acbe65dd62b9$export$2e2bcd8739ae039 = (0, $kQaj4.default)($c692acbe65dd62b9$export$9dd6ff9ea0189349, {
    name: "MuiImageList"
})($c692acbe65dd62b9$var$ImageList);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $kbxxf = parcelRequire("kbxxf");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");

var $acw62 = parcelRequire("acw62");
function $3b76a084116f5c1d$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}


var $202cc2525ebb287b$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        boxSizing: "border-box",
        flexShrink: 0
    },
    /* Styles applied to the `div` element that wraps the children. */ item: {
        position: "relative",
        display: "block",
        // In case it's not rendered with a div.
        height: "100%",
        overflow: "hidden"
    },
    /* Styles applied to an `img` element child, if needed to ensure it covers the item. */ imgFullHeight: {
        height: "100%",
        transform: "translateX(-50%)",
        position: "relative",
        left: "50%"
    },
    /* Styles applied to an `img` element child, if needed to ensure it covers the item. */ imgFullWidth: {
        width: "100%",
        position: "relative",
        transform: "translateY(-50%)",
        top: "50%"
    }
};
var $202cc2525ebb287b$var$fit = function fit(imgEl, classes) {
    if (!imgEl || !imgEl.complete) return;
    if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
        var _imgEl$classList, _imgEl$classList2;
        (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, (0, $kbxxf.default)(classes.imgFullWidth.split(" ")));
        (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, (0, $kbxxf.default)(classes.imgFullHeight.split(" ")));
    } else {
        var _imgEl$classList3, _imgEl$classList4;
        (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, (0, $kbxxf.default)(classes.imgFullHeight.split(" ")));
        (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, (0, $kbxxf.default)(classes.imgFullWidth.split(" ")));
    }
};
function $202cc2525ebb287b$var$ensureImageCover(imgEl, classes) {
    if (!imgEl) return;
    if (imgEl.complete) $202cc2525ebb287b$var$fit(imgEl, classes);
    else imgEl.addEventListener("load", function() {
        $202cc2525ebb287b$var$fit(imgEl, classes);
    });
}
var $202cc2525ebb287b$var$ImageListItem = /*#__PURE__*/ $acw62.forwardRef(function ImageListItem(props, ref) {
    // cols rows default values are for docs only
    var children = props.children, classes = props.classes, className = props.className, _props$cols = props.cols, cols = _props$cols === void 0 ? 1 : _props$cols, _props$component = props.component, Component = _props$component === void 0 ? "li" : _props$component, _props$rows = props.rows, rows = _props$rows === void 0 ? 1 : _props$rows, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "cols",
        "component",
        "rows"
    ]);
    var imgRef = $acw62.useRef(null);
    $acw62.useEffect(function() {
        $202cc2525ebb287b$var$ensureImageCover(imgRef.current, classes);
    });
    $acw62.useEffect(function() {
        var handleResize = (0, $3308074b7cd66a5b$export$2e2bcd8739ae039)(function() {
            $202cc2525ebb287b$var$fit(imgRef.current, classes);
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        classes
    ]);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $acw62.createElement("div", {
        className: classes.item
    }, $acw62.Children.map(children, function(child) {
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        if (child.type === "img" || (0, $3b76a084116f5c1d$export$2e2bcd8739ae039)(child, [
            "Image"
        ])) return /*#__PURE__*/ $acw62.cloneElement(child, {
            ref: imgRef
        });
        return child;
    })));
});
var $202cc2525ebb287b$export$2e2bcd8739ae039 = (0, $kQaj4.default)($202cc2525ebb287b$export$9dd6ff9ea0189349, {
    name: "MuiImageListItem"
})($202cc2525ebb287b$var$ImageListItem);


const $8f76904474008aa0$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            width: "100%",
            minWidth: "40vw",
            maxWidth: "700px",
            background: "#2C3845",
            marginBottom: "1em",
            marginTop: "1em",
            borderRadius: 4,
            justifySelf: "center",
            padding: "1em"
        },
        container: {
            width: "100%"
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        },
        imageList: {
            width: "100%"
        },
        a_img_container: {
            height: "100%"
        }
    }));
function $8f76904474008aa0$export$2e2bcd8739ae039({ data: data  }) {
    const classes = $8f76904474008aa0$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb8544603a0b034a$export$83ef7ab426386201), {
                        linkTarget: "_blank",
                        remarkPlugins: [
                            (0, $5a545addcc5524a2$export$2e2bcd8739ae039)
                        ],
                        children: data.text
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c692acbe65dd62b9$export$2e2bcd8739ae039), {
                    rowHeight: 160,
                    className: classes.imageList,
                    cols: 2,
                    children: [
                        data.embeds?.map((item, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $202cc2525ebb287b$export$2e2bcd8739ae039), {
                                cols: 1,
                                className: classes.imageList,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: item.url,
                                    className: classes.a_img_container,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: item.thumbnail?.url,
                                        alt: item.title,
                                        className: classes.a_img_container
                                    })
                                })
                            }, i)),
                        data.attachments?.map((item, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $202cc2525ebb287b$export$2e2bcd8739ae039), {
                                cols: 1,
                                className: classes.imageList,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: item.url,
                                    className: classes.a_img_container,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: item.url,
                                        className: classes.a_img_container
                                    })
                                })
                            }, i))
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $084511095ab51c55$export$2e2bcd8739ae039), {
                    author_name: data.author_name,
                    post_date: data.timestamp,
                    avatar_url: data.author_avatar_url
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed87dbbed9d26a59$export$2e2bcd8739ae039), {
                    reactions_data: data.reactions
                })
            ]
        })
    });
}





var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $8accd9aba21f8e48$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }


function $4e2f201fa2fbf9f3$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $8accd9aba21f8e48$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;


const $35cd7d64717698f7$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    readOnly: "readOnly",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    required: "required",
    selected: "selected"
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $35cd7d64717698f7$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $8484d09248d25570$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}


/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */ function $119760d6b00d97d7$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $119760d6b00d97d7$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}


function $8ec30e4d54713c84$export$2e2bcd8739ae039(params) {
    const { theme: theme , name: name , props: props  } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $119760d6b00d97d7$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
function $0d0b82dec42cae84$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $0d0b82dec42cae84$var$deepClone(source) {
    if (!$0d0b82dec42cae84$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $0d0b82dec42cae84$var$deepClone(source[key]);
    });
    return output;
}
function $0d0b82dec42cae84$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($0d0b82dec42cae84$export$53b83ca8eaab0383(target) && $0d0b82dec42cae84$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($0d0b82dec42cae84$export$53b83ca8eaab0383(source[key]) && key in target && $0d0b82dec42cae84$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $0d0b82dec42cae84$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $0d0b82dec42cae84$export$53b83ca8eaab0383(source[key]) ? $0d0b82dec42cae84$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $a06500f70819ed69$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $a06500f70819ed69$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $a06500f70819ed69$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $8nd05.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $a06500f70819ed69$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    } , unit: unit = "px" , step: step = 5  } = breakpoints, other = (0, $1En50.default)(breakpoints, $a06500f70819ed69$var$_excluded);
    const sortedValues = $a06500f70819ed69$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $8nd05.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}


const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;




var $8nd05 = parcelRequire("8nd05");



function $7c3aede628aa278f$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $0d0b82dec42cae84$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $7c3aede628aa278f$export$2e2bcd8739ae039 = $7c3aede628aa278f$var$merge;


const $2c79a5510dec9b08$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2c79a5510dec9b08$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$2c79a5510dec9b08$export$68c286be0e7e55b7[key]}px)`
};
function $2c79a5510dec9b08$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $2c79a5510dec9b08$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2c79a5510dec9b08$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2c79a5510dec9b08$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8nd05.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $7c3aede628aa278f$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2c79a5510dec9b08$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2c79a5510dec9b08$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2c79a5510dec9b08$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $0d0b82dec42cae84$export$2e2bcd8739ae039)(prev, next), {});
    return $2c79a5510dec9b08$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2c79a5510dec9b08$export$980e6a259d807490({ values: breakpointValues , breakpoints: themeBreakpoints , base: customBase  }) {
    const base = customBase || $2c79a5510dec9b08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2c79a5510dec9b08$export$2e2bcd8739ae039 = $2c79a5510dec9b08$var$breakpoints;





function $e901fa2f27580273$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $e901fa2f27580273$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $e901fa2f27580273$var$style(options) {
    const { prop: prop , cssProperty: cssProperty = options.prop , themeKey: themeKey , transform: transform  } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $e901fa2f27580273$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $e901fa2f27580273$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $4e2f201fa2fbf9f3$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $e901fa2f27580273$export$2e2bcd8739ae039 = $e901fa2f27580273$var$style;



function $cb619e97db430627$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $94935f79a2c44a85$var$properties = {
    m: "margin",
    p: "padding"
};
const $94935f79a2c44a85$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $94935f79a2c44a85$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $94935f79a2c44a85$var$getCssProperties = (0, $cb619e97db430627$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($94935f79a2c44a85$var$aliases[prop]) prop = $94935f79a2c44a85$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $94935f79a2c44a85$var$properties[a];
    const direction = $94935f79a2c44a85$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $94935f79a2c44a85$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $94935f79a2c44a85$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $94935f79a2c44a85$var$spacingKeys = [
    ...$94935f79a2c44a85$export$aab52a0dde05ad8a,
    ...$94935f79a2c44a85$export$f8397d44f03ab6ad
];
function $94935f79a2c44a85$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $e901fa2f27580273$export$2aa3fd96c49a84a8)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $94935f79a2c44a85$export$1def6f833384e3d1(theme) {
    return $94935f79a2c44a85$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $94935f79a2c44a85$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $94935f79a2c44a85$var$getCssProperties(prop);
    const styleFromPropValue = $94935f79a2c44a85$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $94935f79a2c44a85$var$style(props, keys) {
    const transformer = $94935f79a2c44a85$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$94935f79a2c44a85$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $7c3aede628aa278f$export$2e2bcd8739ae039), {});
}
function $94935f79a2c44a85$export$7ede87f9b603dd3c(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$export$aab52a0dde05ad8a);
}
$94935f79a2c44a85$export$7ede87f9b603dd3c.propTypes = {};
$94935f79a2c44a85$export$7ede87f9b603dd3c.filterProps = $94935f79a2c44a85$export$aab52a0dde05ad8a;
function $94935f79a2c44a85$export$6f98e8eaf0be1996(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$export$f8397d44f03ab6ad);
}
$94935f79a2c44a85$export$6f98e8eaf0be1996.propTypes = {};
$94935f79a2c44a85$export$6f98e8eaf0be1996.filterProps = $94935f79a2c44a85$export$f8397d44f03ab6ad;
function $94935f79a2c44a85$var$spacing(props) {
    return $94935f79a2c44a85$var$style(props, $94935f79a2c44a85$var$spacingKeys);
}
$94935f79a2c44a85$var$spacing.propTypes = {};
$94935f79a2c44a85$var$spacing.filterProps = $94935f79a2c44a85$var$spacingKeys;
var $94935f79a2c44a85$export$2e2bcd8739ae039 = $94935f79a2c44a85$var$spacing;


function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $94935f79a2c44a85$export$1def6f833384e3d1)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}










function $beedfc9d7e65f133$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $7c3aede628aa278f$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $beedfc9d7e65f133$export$2e2bcd8739ae039 = $beedfc9d7e65f133$var$compose;




function $e39f6794db8cf9ac$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $e39f6794db8cf9ac$export$1edee58a52776cd9 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "border",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$export$34e2febe53ae29cc
});
const $e39f6794db8cf9ac$export$f9a7b6bd24892946 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$export$34e2febe53ae29cc
});
const $e39f6794db8cf9ac$export$5abca33e6be905d2 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$export$34e2febe53ae29cc
});
const $e39f6794db8cf9ac$export$e2ce9f12a980a822 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$export$34e2febe53ae29cc
});
const $e39f6794db8cf9ac$export$47658cca1a909427 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $e39f6794db8cf9ac$export$34e2febe53ae29cc
});
const $e39f6794db8cf9ac$export$e7fb0694ba2404fc = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$126a92c968acdb85 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$340b0327727f6d1a = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$60beef91a985b4bf = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $e39f6794db8cf9ac$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $94935f79a2c44a85$export$cb5ee237cce814a2)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $94935f79a2c44a85$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$e39f6794db8cf9ac$export$7a57f79000377ca2.propTypes = {};
$e39f6794db8cf9ac$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $e39f6794db8cf9ac$var$borders = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($e39f6794db8cf9ac$export$1edee58a52776cd9, $e39f6794db8cf9ac$export$f9a7b6bd24892946, $e39f6794db8cf9ac$export$5abca33e6be905d2, $e39f6794db8cf9ac$export$e2ce9f12a980a822, $e39f6794db8cf9ac$export$47658cca1a909427, $e39f6794db8cf9ac$export$e7fb0694ba2404fc, $e39f6794db8cf9ac$export$126a92c968acdb85, $e39f6794db8cf9ac$export$85cc51cb8fbb8c0e, $e39f6794db8cf9ac$export$340b0327727f6d1a, $e39f6794db8cf9ac$export$60beef91a985b4bf, $e39f6794db8cf9ac$export$7a57f79000377ca2);
var $e39f6794db8cf9ac$export$2e2bcd8739ae039 = $e39f6794db8cf9ac$var$borders;







const $0481dc1348188242$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $94935f79a2c44a85$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $94935f79a2c44a85$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$5df9adcb0db95e1e.propTypes = {};
$0481dc1348188242$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $0481dc1348188242$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $94935f79a2c44a85$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $94935f79a2c44a85$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$ec60d70ff941a580.propTypes = {};
$0481dc1348188242$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $0481dc1348188242$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $94935f79a2c44a85$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $94935f79a2c44a85$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$0481dc1348188242$export$8a833ffa5f5dbeda.propTypes = {};
$0481dc1348188242$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $0481dc1348188242$export$baf44164ca3a34e8 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridColumn"
});
const $0481dc1348188242$export$8f7213a1cd01e832 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridRow"
});
const $0481dc1348188242$export$b0e0abbc49ba668 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridAutoFlow"
});
const $0481dc1348188242$export$bcd8b929d4b4142 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridAutoColumns"
});
const $0481dc1348188242$export$e5039a674e14c828 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridAutoRows"
});
const $0481dc1348188242$export$42bd9088661ffb03 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridTemplateColumns"
});
const $0481dc1348188242$export$920682ae05b999bc = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridTemplateRows"
});
const $0481dc1348188242$export$1b88fbdd482fd33a = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridTemplateAreas"
});
const $0481dc1348188242$export$bdb486e40d52d26f = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "gridArea"
});
const $0481dc1348188242$var$grid = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($0481dc1348188242$export$5df9adcb0db95e1e, $0481dc1348188242$export$ec60d70ff941a580, $0481dc1348188242$export$8a833ffa5f5dbeda, $0481dc1348188242$export$baf44164ca3a34e8, $0481dc1348188242$export$8f7213a1cd01e832, $0481dc1348188242$export$b0e0abbc49ba668, $0481dc1348188242$export$bcd8b929d4b4142, $0481dc1348188242$export$e5039a674e14c828, $0481dc1348188242$export$42bd9088661ffb03, $0481dc1348188242$export$920682ae05b999bc, $0481dc1348188242$export$1b88fbdd482fd33a, $0481dc1348188242$export$bdb486e40d52d26f);
var $0481dc1348188242$export$2e2bcd8739ae039 = $0481dc1348188242$var$grid;




function $625822e5d7cce21a$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $625822e5d7cce21a$export$35e9368ef982300f = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "color",
    themeKey: "palette",
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$export$2506f56c10355b33 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$export$8c5a050822fd698c = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $625822e5d7cce21a$export$dbaffd4420ea0ac6
});
const $625822e5d7cce21a$var$palette = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($625822e5d7cce21a$export$35e9368ef982300f, $625822e5d7cce21a$export$2506f56c10355b33, $625822e5d7cce21a$export$8c5a050822fd698c);
var $625822e5d7cce21a$export$2e2bcd8739ae039 = $625822e5d7cce21a$var$palette;





function $d5d974b5976c38ad$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $d5d974b5976c38ad$export$7e3df82ee760448c = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "width",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
            const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || (0, $2c79a5510dec9b08$export$68c286be0e7e55b7)[propValue];
            return {
                maxWidth: breakpoint || $d5d974b5976c38ad$export$8afece71750ec241(propValue)
            };
        };
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$d5d974b5976c38ad$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $d5d974b5976c38ad$export$ee148fbbe8357dd2 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "minWidth",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$ac607276a8fe9f0a = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "height",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$dc0d8bd0b94f8570 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "maxHeight",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$a43cf604e12f3b17 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "minHeight",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$ffed9f14fb65e276 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "width",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$905076ed6620e671 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "height",
    transform: $d5d974b5976c38ad$export$8afece71750ec241
});
const $d5d974b5976c38ad$export$6ccc93f785106a58 = (0, $e901fa2f27580273$export$2e2bcd8739ae039)({
    prop: "boxSizing"
});
const $d5d974b5976c38ad$var$sizing = (0, $beedfc9d7e65f133$export$2e2bcd8739ae039)($d5d974b5976c38ad$export$7e3df82ee760448c, $d5d974b5976c38ad$export$488fda99655ff65a, $d5d974b5976c38ad$export$ee148fbbe8357dd2, $d5d974b5976c38ad$export$ac607276a8fe9f0a, $d5d974b5976c38ad$export$dc0d8bd0b94f8570, $d5d974b5976c38ad$export$a43cf604e12f3b17, $d5d974b5976c38ad$export$6ccc93f785106a58);
var $d5d974b5976c38ad$export$2e2bcd8739ae039 = $d5d974b5976c38ad$var$sizing;


const $f27f6a6c429b3415$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $e39f6794db8cf9ac$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $e39f6794db8cf9ac$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $e39f6794db8cf9ac$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $e39f6794db8cf9ac$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $e39f6794db8cf9ac$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $e39f6794db8cf9ac$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $625822e5d7cce21a$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $625822e5d7cce21a$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $625822e5d7cce21a$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $94935f79a2c44a85$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $94935f79a2c44a85$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $0481dc1348188242$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $0481dc1348188242$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $0481dc1348188242$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $d5d974b5976c38ad$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $d5d974b5976c38ad$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $d5d974b5976c38ad$export$8afece71750ec241)
    },
    height: {
        transform: (0, $d5d974b5976c38ad$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $d5d974b5976c38ad$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $d5d974b5976c38ad$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $f27f6a6c429b3415$export$2e2bcd8739ae039 = $f27f6a6c429b3415$var$defaultSxConfig;


function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $6b750d631801d296$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop , themeKey: themeKey , transform: transform , style: style  } = options;
        if (val == null) return null;
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $e901fa2f27580273$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $e901fa2f27580273$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $e901fa2f27580273$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $4e2f201fa2fbf9f3$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx , theme: theme = {}  } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $f27f6a6c429b3415$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $2c79a5510dec9b08$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $7c3aede628aa278f$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $2c79a5510dec9b08$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $7c3aede628aa278f$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $7c3aede628aa278f$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $2c79a5510dec9b08$export$8922c90b6e020726)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    "sx"
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;



const $4a66cd95e497efc7$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {} , palette: paletteInput = {} , spacing: spacingInput , shape: shapeInput = {}  } = options, other = (0, $1En50.default)(options, $4a66cd95e497efc7$var$_excluded);
    const breakpoints = (0, $a06500f70819ed69$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $1f392ba2ebd18096$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $0d0b82dec42cae84$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $8nd05.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $8nd05.default)({}, (0, $8aecb04a157fa644$export$2e2bcd8739ae039), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $0d0b82dec42cae84$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $f27f6a6c429b3415$export$2e2bcd8739ae039), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6b750d631801d296$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-item-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
        (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e18645ac1956fbe6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};



var $8nd05 = parcelRequire("8nd05");


var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $84b101df16c1118f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $84b101df16c1118f$export$2e2bcd8739ae039)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};



var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;


var $0fe24a6591b39473$export$23f2a1d2818174ef = true;
var $0fe24a6591b39473$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $0fe24a6591b39473$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $0fe24a6591b39473$export$e7094788287c5e9b = $0fe24a6591b39473$var$EmotionCacheContext.Provider;
var $0fe24a6591b39473$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
};
var $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$0fe24a6591b39473$export$23f2a1d2818174ef) $0fe24a6591b39473$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($0fe24a6591b39473$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
                key: "css"
            });
            return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $0fe24a6591b39473$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $0fe24a6591b39473$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
};
var $0fe24a6591b39473$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $0fe24a6591b39473$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $0fe24a6591b39473$var$getTheme(outerTheme, theme);
    });
});
var $0fe24a6591b39473$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $0fe24a6591b39473$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $0fe24a6591b39473$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $0fe24a6591b39473$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $0fe24a6591b39473$var$getLastPart(match[1]);
    return undefined;
};
var $0fe24a6591b39473$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $0fe24a6591b39473$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $0fe24a6591b39473$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $0fe24a6591b39473$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($0fe24a6591b39473$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $0fe24a6591b39473$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $0fe24a6591b39473$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $0fe24a6591b39473$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$0fe24a6591b39473$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $0fe24a6591b39473$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $0fe24a6591b39473$var$Emotion = /* #__PURE__ */ $0fe24a6591b39473$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$0fe24a6591b39473$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($0fe24a6591b39473$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($0fe24a6591b39473$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $0fe24a6591b39473$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($0fe24a6591b39473$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $0fe24a6591b39473$export$a9c23c6ac3fc3eca = $0fe24a6591b39473$var$Emotion;



var $acw62 = parcelRequire("acw62");




var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;




parcelRequire("9ORqK");
var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.11.0",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $0fe24a6591b39473$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $0fe24a6591b39473$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $0fe24a6591b39473$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $acw62.createElement.apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7)));
    if (!(0, $0fe24a6591b39473$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isTestEnv, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;


function $1f701f7d1726bc9a$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $1f701f7d1726bc9a$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7));
    return !contextTheme || $1f701f7d1726bc9a$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $1f701f7d1726bc9a$export$2e2bcd8739ae039 = $1f701f7d1726bc9a$var$useTheme;


const $59c0686cf27fa016$export$35e57303dbd8a66 = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)();
function $59c0686cf27fa016$var$useTheme(defaultTheme = $59c0686cf27fa016$export$35e57303dbd8a66) {
    return (0, $1f701f7d1726bc9a$export$2e2bcd8739ae039)(defaultTheme);
}
var $59c0686cf27fa016$export$2e2bcd8739ae039 = $59c0686cf27fa016$var$useTheme;


function $9f45a3834bb6880f$export$2e2bcd8739ae039({ props: props , name: name , defaultTheme: defaultTheme , themeId: themeId  }) {
    let theme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $8ec30e4d54713c84$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
/**
 * @mui/styled-engine v5.13.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});






var $60e97af874e8cdaa$var$testOmitPropsOnStringTag = (0, $bcd4e42ca4163639$export$2e2bcd8739ae039);
var $60e97af874e8cdaa$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $60e97af874e8cdaa$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $60e97af874e8cdaa$var$testOmitPropsOnStringTag : $60e97af874e8cdaa$var$testOmitPropsOnComponent;
};
var $60e97af874e8cdaa$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $60e97af874e8cdaa$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $60e97af874e8cdaa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $60e97af874e8cdaa$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $60e97af874e8cdaa$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $60e97af874e8cdaa$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $0fe24a6591b39473$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $0fe24a6591b39473$export$971d5caa766a69d7));
            }
            if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $60e97af874e8cdaa$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($60e97af874e8cdaa$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $60e97af874e8cdaa$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};



parcelRequire("acw62");





var $12ab803fa905d303$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $12ab803fa905d303$export$2e2bcd8739ae039 = (0, $60e97af874e8cdaa$export$2e2bcd8739ae039).bind();
$12ab803fa905d303$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $12ab803fa905d303$export$2e2bcd8739ae039[tagName] = $12ab803fa905d303$export$2e2bcd8739ae039(tagName);
});




parcelRequire("acw62");



function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$export$2e2bcd8739ae039(props) {
    const { styles: styles , defaultTheme: defaultTheme = {}  } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: globalStyles
    });
}


function $89ab6b9e702438b4$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $12ab803fa905d303$export$2e2bcd8739ae039)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $89ab6b9e702438b4$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};





var $1En50 = parcelRequire("1En50");

const $20be6fcb5f4e29cd$var$_excluded = [
    "variant"
];
function $20be6fcb5f4e29cd$var$isEmpty(string) {
    return string.length === 0;
}
function $20be6fcb5f4e29cd$export$2e2bcd8739ae039(props) {
    const { variant: variant  } = props, other = (0, $1En50.default)(props, $20be6fcb5f4e29cd$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $20be6fcb5f4e29cd$var$isEmpty(classKey) ? props[key] : (0, $4e2f201fa2fbf9f3$export$2e2bcd8739ae039)(props[key]);
        else classKey += `${$20be6fcb5f4e29cd$var$isEmpty(classKey) ? key : (0, $4e2f201fa2fbf9f3$export$2e2bcd8739ae039)(key)}${(0, $4e2f201fa2fbf9f3$export$2e2bcd8739ae039)(props[key].toString())}`;
    });
    return classKey;
}



const $a0abf5ad226c4fb0$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $a0abf5ad226c4fb0$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $a0abf5ad226c4fb0$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $a0abf5ad226c4fb0$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $a0abf5ad226c4fb0$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $20be6fcb5f4e29cd$export$2e2bcd8739ae039)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $a0abf5ad226c4fb0$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components, _theme$components$nam;
    const { ownerState: ownerState = {}  } = props;
    const variantsStyles = [];
    const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $20be6fcb5f4e29cd$export$2e2bcd8739ae039)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $a0abf5ad226c4fb0$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $a0abf5ad226c4fb0$export$35e57303dbd8a66 = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)();
const $a0abf5ad226c4fb0$var$lowercaseFirstLetter = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a0abf5ad226c4fb0$var$resolveTheme({ defaultTheme: defaultTheme , theme: theme , themeId: themeId  }) {
    return $a0abf5ad226c4fb0$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $a0abf5ad226c4fb0$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId , defaultTheme: defaultTheme = $a0abf5ad226c4fb0$export$35e57303dbd8a66 , rootShouldForwardProp: rootShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0 , slotShouldForwardProp: slotShouldForwardProp = $a0abf5ad226c4fb0$export$3ba67b570e26eea0  } = input;
    const systemSx = (props)=>{
        return (0, $6b750d631801d296$export$2e2bcd8739ae039)((0, $8nd05.default)({}, props, {
            theme: $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $89ab6b9e702438b4$export$e00380445f2b9e0c)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName , slot: componentSlot , skipVariantsResolver: inputSkipVariantsResolver , skipSx: inputSkipSx , overridesResolver: overridesResolver  } = inputOptions, options = (0, $1En50.default)(inputOptions, $a0abf5ad226c4fb0$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $a0abf5ad226c4fb0$export$3ba67b570e26eea0;
        if (componentSlot === "Root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($a0abf5ad226c4fb0$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $89ab6b9e702438b4$export$2e2bcd8739ae039)(tag, (0, $8nd05.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (props)=>{
                    return stylesArg((0, $8nd05.default)({}, props, {
                        theme: $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                            defaultTheme: defaultTheme,
                            themeId: themeId
                        }))
                    }));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $a0abf5ad226c4fb0$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $8nd05.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $a0abf5ad226c4fb0$var$variantsResolver(props, $a0abf5ad226c4fb0$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>styleArg((0, $8nd05.default)({}, props, {
                    theme: $a0abf5ad226c4fb0$var$resolveTheme((0, $8nd05.default)({}, props, {
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    }))
                }));
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $0016d2a363b4c314$var$styled = (0, $a0abf5ad226c4fb0$export$2e2bcd8739ae039)();
var $0016d2a363b4c314$export$2e2bcd8739ae039 = $0016d2a363b4c314$var$styled;




const $9d2a35bf051ea407$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $9d2a35bf051ea407$var$defaultTheme = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)();
const $9d2a35bf051ea407$var$defaultCreateStyledComponent = (0, $0016d2a363b4c314$export$2e2bcd8739ae039)("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $4e2f201fa2fbf9f3$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $9d2a35bf051ea407$var$useThemePropsDefault = (inProps)=>(0, $9f45a3834bb6880f$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiContainer",
        defaultTheme: $9d2a35bf051ea407$var$defaultTheme
    });
const $9d2a35bf051ea407$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)(componentName, slot);
    };
    const { classes: classes , fixed: fixed , disableGutters: disableGutters , maxWidth: maxWidth  } = ownerState;
    const slots = {
        root: [
            "root",
            maxWidth && `maxWidth${(0, $4e2f201fa2fbf9f3$export$2e2bcd8739ae039)(String(maxWidth))}`,
            fixed && "fixed",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, getContainerUtilityClass, classes);
};
function $9d2a35bf051ea407$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $9d2a35bf051ea407$var$defaultCreateStyledComponent , useThemeProps: useThemeProps = $9d2a35bf051ea407$var$useThemePropsDefault , componentName: componentName = "MuiContainer"  } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme , ownerState: ownerState  })=>(0, $8nd05.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            display: "block"
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("sm")]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme , ownerState: ownerState  })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme , ownerState: ownerState  })=>(0, $8nd05.default)({}, ownerState.maxWidth === "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("xs")]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $acw62.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className , component: component = "div" , disableGutters: disableGutters = false , fixed: fixed = false , maxWidth: maxWidth = "lg"  } = props, other = (0, $1En50.default)(props, $9d2a35bf051ea407$var$_excluded);
        const ownerState = (0, $8nd05.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $9d2a35bf051ea407$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $7b02d682eb115277$exports.jsx)(ContainerRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $1SA7b.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $e7b578196486f177$export$2e2bcd8739ae039 = (0, $4e2f201fa2fbf9f3$export$2e2bcd8739ae039);




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");




var $8nd05 = parcelRequire("8nd05");
function $4aa5f3b4975f3e4c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $8nd05.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");


/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $e0579d99723e0dfe$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $e0579d99723e0dfe$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $e0579d99723e0dfe$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $e0579d99723e0dfe$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $8accd9aba21f8e48$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $8accd9aba21f8e48$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $e0579d99723e0dfe$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $e0579d99723e0dfe$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $e0579d99723e0dfe$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $e0579d99723e0dfe$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $e0579d99723e0dfe$export$211a73f2b8c10ce4(color) {
    const { type: type , colorSpace: colorSpace  } = color;
    let { values: values  } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $e0579d99723e0dfe$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values  } = $e0579d99723e0dfe$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$e0579d99723e0dfe$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $e0579d99723e0dfe$export$29fb7152bd3f781a(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    const { values: values  } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $e0579d99723e0dfe$export$c852d90bf7403b62(color) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $e0579d99723e0dfe$export$677b39864803984e($e0579d99723e0dfe$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $e0579d99723e0dfe$export$d061e26956a60b0a(foreground, background) {
    const lumA = $e0579d99723e0dfe$export$c852d90bf7403b62(foreground);
    const lumB = $e0579d99723e0dfe$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $e0579d99723e0dfe$export$58f0f39f63f3cf42(color, value) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    value = $e0579d99723e0dfe$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $e0579d99723e0dfe$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient) {
    color = $e0579d99723e0dfe$export$677b39864803984e(color);
    coefficient = $e0579d99723e0dfe$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $e0579d99723e0dfe$export$211a73f2b8c10ce4(color);
}
function $e0579d99723e0dfe$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $e0579d99723e0dfe$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $e0579d99723e0dfe$export$c852d90bf7403b62(color) > 0.5 ? $e0579d99723e0dfe$export$4b073707ff63303(color, coefficient) : $e0579d99723e0dfe$export$c0816ed86df316af(color, coefficient);
}
function $e0579d99723e0dfe$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $e0579d99723e0dfe$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}


const $9e185cbbdd17e0f7$var$common = {
    black: "#000",
    white: "#fff"
};
var $9e185cbbdd17e0f7$export$2e2bcd8739ae039 = $9e185cbbdd17e0f7$var$common;


const $ad9a7ac9db04746c$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $ad9a7ac9db04746c$export$2e2bcd8739ae039 = $ad9a7ac9db04746c$var$grey;


const $f34748703626d0dc$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $f34748703626d0dc$export$2e2bcd8739ae039 = $f34748703626d0dc$var$purple;


const $f8f33d825c71610f$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $f8f33d825c71610f$export$2e2bcd8739ae039 = $f8f33d825c71610f$var$red;


const $a09ebaae00c386da$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $a09ebaae00c386da$export$2e2bcd8739ae039 = $a09ebaae00c386da$var$orange;


const $88d64e288ac9a70b$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $88d64e288ac9a70b$export$2e2bcd8739ae039 = $88d64e288ac9a70b$var$blue;


const $d9287623794ffe70$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $d9287623794ffe70$export$2e2bcd8739ae039 = $d9287623794ffe70$var$lightBlue;


const $a3e3b29cd31a116f$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $a3e3b29cd31a116f$export$2e2bcd8739ae039 = $a3e3b29cd31a116f$var$green;


const $368aaef25f6a2997$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $368aaef25f6a2997$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $9e185cbbdd17e0f7$export$2e2bcd8739ae039).white,
        default: (0, $9e185cbbdd17e0f7$export$2e2bcd8739ae039).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $368aaef25f6a2997$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $9e185cbbdd17e0f7$export$2e2bcd8739ae039).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $9e185cbbdd17e0f7$export$2e2bcd8739ae039).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $e0579d99723e0dfe$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $e0579d99723e0dfe$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $88d64e288ac9a70b$export$2e2bcd8739ae039)[200],
        light: (0, $88d64e288ac9a70b$export$2e2bcd8739ae039)[50],
        dark: (0, $88d64e288ac9a70b$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $88d64e288ac9a70b$export$2e2bcd8739ae039)[700],
        light: (0, $88d64e288ac9a70b$export$2e2bcd8739ae039)[400],
        dark: (0, $88d64e288ac9a70b$export$2e2bcd8739ae039)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $f34748703626d0dc$export$2e2bcd8739ae039)[200],
        light: (0, $f34748703626d0dc$export$2e2bcd8739ae039)[50],
        dark: (0, $f34748703626d0dc$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $f34748703626d0dc$export$2e2bcd8739ae039)[500],
        light: (0, $f34748703626d0dc$export$2e2bcd8739ae039)[300],
        dark: (0, $f34748703626d0dc$export$2e2bcd8739ae039)[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $f8f33d825c71610f$export$2e2bcd8739ae039)[500],
        light: (0, $f8f33d825c71610f$export$2e2bcd8739ae039)[300],
        dark: (0, $f8f33d825c71610f$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $f8f33d825c71610f$export$2e2bcd8739ae039)[700],
        light: (0, $f8f33d825c71610f$export$2e2bcd8739ae039)[400],
        dark: (0, $f8f33d825c71610f$export$2e2bcd8739ae039)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $d9287623794ffe70$export$2e2bcd8739ae039)[400],
        light: (0, $d9287623794ffe70$export$2e2bcd8739ae039)[300],
        dark: (0, $d9287623794ffe70$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $d9287623794ffe70$export$2e2bcd8739ae039)[700],
        light: (0, $d9287623794ffe70$export$2e2bcd8739ae039)[500],
        dark: (0, $d9287623794ffe70$export$2e2bcd8739ae039)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $a3e3b29cd31a116f$export$2e2bcd8739ae039)[400],
        light: (0, $a3e3b29cd31a116f$export$2e2bcd8739ae039)[300],
        dark: (0, $a3e3b29cd31a116f$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $a3e3b29cd31a116f$export$2e2bcd8739ae039)[800],
        light: (0, $a3e3b29cd31a116f$export$2e2bcd8739ae039)[500],
        dark: (0, $a3e3b29cd31a116f$export$2e2bcd8739ae039)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $a09ebaae00c386da$export$2e2bcd8739ae039)[400],
        light: (0, $a09ebaae00c386da$export$2e2bcd8739ae039)[300],
        dark: (0, $a09ebaae00c386da$export$2e2bcd8739ae039)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $a09ebaae00c386da$export$2e2bcd8739ae039)[500],
        dark: (0, $a09ebaae00c386da$export$2e2bcd8739ae039)[900]
    };
}
function $368aaef25f6a2997$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light" , contrastThreshold: contrastThreshold = 3 , tonalOffset: tonalOffset = 0.2  } = palette, other = (0, $1En50.default)(palette, $368aaef25f6a2997$var$_excluded);
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $e0579d99723e0dfe$export$d061e26956a60b0a)(background, $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary : $368aaef25f6a2997$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color , name: name , mainShade: mainShade = 500 , lightShade: lightShade = 300 , darkShade: darkShade = 700  })=>{
        color = (0, $8nd05.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $8accd9aba21f8e48$export$2e2bcd8739ae039)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $8accd9aba21f8e48$export$2e2bcd8739ae039)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $368aaef25f6a2997$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $368aaef25f6a2997$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $368aaef25f6a2997$export$55ce6f3a06c59543,
        light: $368aaef25f6a2997$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $0d0b82dec42cae84$export$2e2bcd8739ae039)((0, $8nd05.default)({
        // A collection of common colors.
        common: (0, $8nd05.default)({}, (0, $9e185cbbdd17e0f7$export$2e2bcd8739ae039)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $ad9a7ac9db04746c$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

const $98a01bf22de9dc59$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $98a01bf22de9dc59$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily , fontSize: // The default font size of the Material Specification.
    fontSize = 14 , fontWeightLight: // px
    fontWeightLight = 300 , fontWeightRegular: fontWeightRegular = 400 , fontWeightMedium: fontWeightMedium = 500 , fontWeightBold: fontWeightBold = 700 , htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16 , allVariants: // Apply the CSS properties to all the variants.
    allVariants , pxToRem: pxToRem2  } = _ref, other = (0, $1En50.default)(_ref, $98a01bf22de9dc59$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $8nd05.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
            letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $0d0b82dec42cae84$export$2e2bcd8739ae039)((0, $8nd05.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    "none",
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$export$2e2bcd8739ae039 = $e2deb8a0bbe5ea21$var$shadows;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $845514f3678d3888$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $845514f3678d3888$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $845514f3678d3888$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $845514f3678d3888$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $8nd05.default)({}, $845514f3678d3888$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $8nd05.default)({}, $845514f3678d3888$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard , easing: easingOption = mergedEasing.easeInOut , delay: delay = 0  } = options, other = (0, $1En50.default)(options, $845514f3678d3888$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(",");
    };
    return (0, $8nd05.default)({
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$export$2e2bcd8739ae039 = $f7f9291b6f07cefb$var$zIndex;


const $d5615f18e5cd04fc$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $d5615f18e5cd04fc$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {} , palette: paletteInput = {} , transitions: transitionsInput = {} , typography: typographyInput = {}  } = options, other = (0, $1En50.default)(options, $d5615f18e5cd04fc$var$_excluded);
    if (options.vars) throw new Error((0, $8accd9aba21f8e48$export$2e2bcd8739ae039)(18));
    const palette = (0, $368aaef25f6a2997$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $0d0b82dec42cae84$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $4aa5f3b4975f3e4c$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $e2deb8a0bbe5ea21$export$2e2bcd8739ae039).slice(),
        typography: (0, $98a01bf22de9dc59$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $845514f3678d3888$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: (0, $8nd05.default)({}, (0, $f7f9291b6f07cefb$export$2e2bcd8739ae039))
    });
    muiTheme = (0, $0d0b82dec42cae84$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $0d0b82dec42cae84$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $f27f6a6c429b3415$export$2e2bcd8739ae039), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6b750d631801d296$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $d5615f18e5cd04fc$var$warnedOnce = false;
function $d5615f18e5cd04fc$export$c469355549431d9b(...args) {
    return $d5615f18e5cd04fc$var$createTheme(...args);
}
var $d5615f18e5cd04fc$export$2e2bcd8739ae039 = $d5615f18e5cd04fc$var$createTheme;


const $e74a75f0176cf8e3$var$defaultTheme = (0, $d5615f18e5cd04fc$export$2e2bcd8739ae039)();
var $e74a75f0176cf8e3$export$2e2bcd8739ae039 = $e74a75f0176cf8e3$var$defaultTheme;


var $3250d9bb994a2d02$export$2e2bcd8739ae039 = "$$material";


const $0277c5e26ff0d56c$export$effb20ecdbf4d6aa = (prop)=>(0, $a0abf5ad226c4fb0$export$3ba67b570e26eea0)(prop) && prop !== "classes";
const $0277c5e26ff0d56c$export$f10c5a10d27438e5 = (0, $a0abf5ad226c4fb0$export$3ba67b570e26eea0);
const $0277c5e26ff0d56c$var$styled = (0, $a0abf5ad226c4fb0$export$2e2bcd8739ae039)({
    themeId: (0, $3250d9bb994a2d02$export$2e2bcd8739ae039),
    defaultTheme: $e74a75f0176cf8e3$export$2e2bcd8739ae039,
    rootShouldForwardProp: $0277c5e26ff0d56c$export$effb20ecdbf4d6aa
});
var $0277c5e26ff0d56c$export$2e2bcd8739ae039 = $0277c5e26ff0d56c$var$styled;





function $48eb684ebe9272b4$export$2e2bcd8739ae039({ props: props , name: name  }) {
    return (0, $9f45a3834bb6880f$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $e74a75f0176cf8e3$export$2e2bcd8739ae039,
        themeId: (0, $3250d9bb994a2d02$export$2e2bcd8739ae039)
    });
}


const $2291beb327d500f8$var$Container = (0, $9d2a35bf051ea407$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("div", {
        name: "MuiContainer",
        slot: "Root",
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState  } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $e7b578196486f177$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
            props: inProps,
            name: "MuiContainer"
        })
});
var $2291beb327d500f8$export$2e2bcd8739ae039 = $2291beb327d500f8$var$Container;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");


const $c85eb76b78f8a14c$var$_excluded = [
    "sx"
];
const $c85eb76b78f8a14c$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $f27f6a6c429b3415$export$2e2bcd8739ae039);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c85eb76b78f8a14c$export$2e2bcd8739ae039(props) {
    const { sx: inSx  } = props, other = (0, $1En50.default)(props, $c85eb76b78f8a14c$var$_excluded);
    const { systemProps: systemProps , otherProps: otherProps  } = $c85eb76b78f8a14c$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $0d0b82dec42cae84$export$53b83ca8eaab0383)(result)) return systemProps;
        return (0, $8nd05.default)({}, systemProps, result);
    };
    else finalSx = (0, $8nd05.default)({}, systemProps, inSx);
    return (0, $8nd05.default)({}, otherProps, {
        sx: finalSx
    });
}






parcelRequire("acw62");



function $0c87a2f38cd49c7a$export$2e2bcd8739ae039() {
    const theme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)((0, $e74a75f0176cf8e3$export$2e2bcd8739ae039));
    return theme[0, $3250d9bb994a2d02$export$2e2bcd8739ae039] || theme;
}



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $e1c9164ec15102c7$var$GridContext = /*#__PURE__*/ $acw62.createContext();
var $e1c9164ec15102c7$export$2e2bcd8739ae039 = $e1c9164ec15102c7$var$GridContext;



function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $35cd7d64717698f7$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $f35b8acab3fc2f62$export$9973ac5fd0181f33(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiGrid", slot);
}
const $f35b8acab3fc2f62$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f35b8acab3fc2f62$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $f35b8acab3fc2f62$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $f35b8acab3fc2f62$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f35b8acab3fc2f62$var$gridClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$f35b8acab3fc2f62$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$f35b8acab3fc2f62$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$f35b8acab3fc2f62$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f35b8acab3fc2f62$export$2e2bcd8739ae039 = $f35b8acab3fc2f62$var$gridClasses;



const $9450fbc34cc5b2ea$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $9450fbc34cc5b2ea$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $9450fbc34cc5b2ea$export$ca2a698f6020fda({ theme: theme , ownerState: ownerState  }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $2c79a5510dec9b08$export$980e6a259d807490)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $8nd05.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $9450fbc34cc5b2ea$export$71d4225eeb1bc13e({ theme: theme , ownerState: ownerState  }) {
    const directionValues = (0, $2c79a5510dec9b08$export$980e6a259d807490)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $2c79a5510dec9b08$export$88347efdb2e19abd)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints , values: values  }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $9450fbc34cc5b2ea$export$380604d7c79f9e8f({ theme: theme , ownerState: ownerState  }) {
    const { container: container , rowSpacing: rowSpacing  } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $2c79a5510dec9b08$export$980e6a259d807490)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $2c79a5510dec9b08$export$88347efdb2e19abd)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4315fba5128fb4a1({ theme: theme , ownerState: ownerState  }) {
    const { container: container , columnSpacing: columnSpacing  } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $2c79a5510dec9b08$export$980e6a259d807490)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $2c79a5510dec9b08$export$88347efdb2e19abd)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $9450fbc34cc5b2ea$var$GridRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        const { container: container , direction: direction , item: item , spacing: spacing , wrap: wrap , zeroMinWidth: zeroMinWidth , breakpoints: breakpoints  } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState  })=>(0, $8nd05.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $9450fbc34cc5b2ea$export$71d4225eeb1bc13e, $9450fbc34cc5b2ea$export$380604d7c79f9e8f, $9450fbc34cc5b2ea$export$4315fba5128fb4a1, $9450fbc34cc5b2ea$export$ca2a698f6020fda);
function $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $9450fbc34cc5b2ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , container: container , direction: direction , item: item , spacing: spacing , wrap: wrap , zeroMinWidth: zeroMinWidth , breakpoints: breakpoints  } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $f35b8acab3fc2f62$export$9973ac5fd0181f33), classes);
};
const $9450fbc34cc5b2ea$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints  } = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const props = (0, $c85eb76b78f8a14c$export$2e2bcd8739ae039)(themeProps);
    const { className: className , columns: columnsProp , columnSpacing: columnSpacingProp , component: component = "div" , container: container = false , direction: direction = "row" , item: item = false , rowSpacing: rowSpacingProp , spacing: spacing = 0 , wrap: wrap = "wrap" , zeroMinWidth: zeroMinWidth = false  } = props, other = (0, $1En50.default)(props, $9450fbc34cc5b2ea$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $acw62.useContext((0, $e1c9164ec15102c7$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $8nd05.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $9450fbc34cc5b2ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1c9164ec15102c7$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9450fbc34cc5b2ea$var$GridRoot, (0, $8nd05.default)({
            ownerState: ownerState,
            className: (0, $1SA7b.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $9450fbc34cc5b2ea$export$2e2bcd8739ae039 = $9450fbc34cc5b2ea$var$Grid;


const $1b998fd34bcc6954$var$AMAX_API_URL = "https://amax-emu.com/api";
function $1b998fd34bcc6954$export$2e2bcd8739ae039() {
    //const classes = useStyles();
    const [discordNewsData, setdiscordNewsData] = $acw62.useState(undefined);
    const [discordNewsFlag, setdiscordNewsFlag] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        async function getDiscordNews() {
            const resp = await fetch($1b998fd34bcc6954$var$AMAX_API_URL + "/data/news", {
                method: "GET",
                headers: {
                    "content-type": "application/json;charset=UTF-8"
                }
            });
            setdiscordNewsData(await resp.json());
            setdiscordNewsFlag(true);
        }
        getDiscordNews().catch(()=>{});
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
            container: true,
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            children: discordNewsFlag ? discordNewsData.data.map((NewsItemData)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f76904474008aa0$export$2e2bcd8739ae039), {
                    data: NewsItemData
                })) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a36c7122d0aec5cd$export$2e2bcd8739ae039), {})
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");




var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $gMaRA = parcelRequire("gMaRA");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");
function $0ca144f8f4dd9f6d$export$2e2bcd8739ae039(_ref) {
    var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ var $8456187c225ea082$var$FormControlContext = $acw62.createContext();
function $8456187c225ea082$export$62ecd8ad1bbe1a18() {
    return $acw62.useContext($8456187c225ea082$var$FormControlContext);
}
var $8456187c225ea082$export$2e2bcd8739ae039 = $8456187c225ea082$var$FormControlContext;



var $kQaj4 = parcelRequire("kQaj4");

var $f9tk6 = parcelRequire("f9tk6");


var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");




function $d7de3174d4009c3a$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
var $d7de3174d4009c3a$var$useEnhancedEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $d7de3174d4009c3a$var$styles = {
    /* Styles applied to the shadow textarea element. */ shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
var $d7de3174d4009c3a$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, rowsMinProp = props.rowsMin, maxRowsProp = props.maxRows, _props$minRows = props.minRows, minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows, style = props.style, value = props.value, other = (0, $9X7IJ.default)(props, [
        "onChange",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "style",
        "value"
    ]);
    var maxRows = maxRowsProp || rowsMax;
    var minRows = rows || rowsMinProp || minRowsProp;
    var _React$useRef = $acw62.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $acw62.useRef(null);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(ref, inputRef);
    var shadowRef = $acw62.useRef(null);
    var renders = $acw62.useRef(0);
    var _React$useState = $acw62.useState({}), state = _React$useState[0], setState = _React$useState[1];
    var syncHeight = $acw62.useCallback(function() {
        var input = inputRef.current;
        var computedStyle = window.getComputedStyle(input);
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        var boxSizing = computedStyle["box-sizing"];
        var padding = $d7de3174d4009c3a$var$getStyleValue(computedStyle, "padding-bottom") + $d7de3174d4009c3a$var$getStyleValue(computedStyle, "padding-top");
        var border = $d7de3174d4009c3a$var$getStyleValue(computedStyle, "border-bottom-width") + $d7de3174d4009c3a$var$getStyleValue(computedStyle, "border-top-width"); // The height of the inner content
        var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
        inputShallow.value = "x";
        var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
        var outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState(function(prevState) {
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $acw62.useEffect(function() {
        var handleResize = (0, $3308074b7cd66a5b$export$2e2bcd8739ae039)(function() {
            renders.current = 0;
            syncHeight();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        syncHeight
    ]);
    $d7de3174d4009c3a$var$useEnhancedEffect(function() {
        syncHeight();
    });
    $acw62.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function handleChange(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("textarea", (0, $8nd05.default)({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: minRows,
        style: (0, $8nd05.default)({
            height: state.outerHeightStyle,
            // Need a large enough difference to allow scrolling.
            // This prevents infinite rendering loop.
            overflow: state.overflow ? "hidden" : null
        }, style)
    }, other)), /*#__PURE__*/ $acw62.createElement("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: (0, $8nd05.default)({}, $d7de3174d4009c3a$var$styles.shadow, style)
    }));
});
var $d7de3174d4009c3a$export$2e2bcd8739ae039 = $d7de3174d4009c3a$var$TextareaAutosize;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $cc803560223295e1$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $cc803560223295e1$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && ($cc803560223295e1$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $cc803560223295e1$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
} // Determine if an Input is adorned on start.
function $cc803560223295e1$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}


var $1adb827d9b58969c$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var placeholder = {
        color: "currentColor",
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
    var placeholderHidden = {
        opacity: "0 !important"
    };
    var placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return {
        "@global": {
            "@keyframes mui-auto-fill": {},
            "@keyframes mui-auto-fill-cancel": {}
        },
        /* Styles applied to the root element. */ root: (0, $8nd05.default)({}, theme.typography.body1, {
            color: theme.palette.text.primary,
            lineHeight: "1.1876em",
            // Reset (19px), match the native input line-height
            boxSizing: "border-box",
            // Prevent padding issue with fullWidth.
            position: "relative",
            cursor: "text",
            display: "inline-flex",
            alignItems: "center",
            "&$disabled": {
                color: theme.palette.text.disabled,
                cursor: "default"
            }
        }),
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {},
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {},
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            "&$marginDense": {
                paddingTop: 3
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the `input` element. */ input: {
            font: "inherit",
            letterSpacing: "inherit",
            color: "currentColor",
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: "content-box",
            background: "none",
            height: "1.1876em",
            // Reset (19px), match the native input line-height
            margin: 0,
            // Reset for Safari
            WebkitTapHighlightColor: "transparent",
            display: "block",
            // Make the flex item shrink with Firefox
            minWidth: 0,
            width: "100%",
            // Fix IE 11 width issue
            animationName: "mui-auto-fill-cancel",
            animationDuration: "10ms",
            "&::-webkit-input-placeholder": placeholder,
            "&::-moz-placeholder": placeholder,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholder,
            // IE 11
            "&::-ms-input-placeholder": placeholder,
            // Edge
            "&:focus": {
                outline: 0
            },
            // Reset Firefox invalid required input style
            "&:invalid": {
                boxShadow: "none"
            },
            "&::-webkit-search-decoration": {
                // Remove the padding when type=search.
                "-webkit-appearance": "none"
            },
            // Show and hide the placeholder logic
            "label[data-shrink=false] + $formControl &": {
                "&::-webkit-input-placeholder": placeholderHidden,
                "&::-moz-placeholder": placeholderHidden,
                // Firefox 19+
                "&:-ms-input-placeholder": placeholderHidden,
                // IE 11
                "&::-ms-input-placeholder": placeholderHidden,
                // Edge
                "&:focus::-webkit-input-placeholder": placeholderVisible,
                "&:focus::-moz-placeholder": placeholderVisible,
                // Firefox 19+
                "&:focus:-ms-input-placeholder": placeholderVisible,
                // IE 11
                "&:focus::-ms-input-placeholder": placeholderVisible // Edge
            },
            "&$disabled": {
                opacity: 1 // Reset iOS opacity
            },
            "&:-webkit-autofill": {
                animationDuration: "5000s",
                animationName: "mui-auto-fill"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 3
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            height: "auto",
            resize: "none",
            padding: 0
        },
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {
            // Improve type search style.
            "-moz-appearance": "textfield",
            "-webkit-appearance": "textfield"
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {},
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {},
        /* Styles applied to the `input` element if `hiddenLabel={true}`. */ inputHiddenLabel: {}
    };
};
var $1adb827d9b58969c$var$useEnhancedEffect = typeof window === "undefined" ? $acw62.useEffect : $acw62.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $1adb827d9b58969c$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(props, ref) {
    var ariaDescribedby = props["aria-describedby"], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, maxRows = props.maxRows, minRows = props.minRows, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, valueProp = props.value, other = (0, $9X7IJ.default)(props, [
        "aria-describedby",
        "autoComplete",
        "autoFocus",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "startAdornment",
        "type",
        "value"
    ]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React$useRef = $acw62.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $acw62.useRef();
    var handleInputRefWarning = $acw62.useCallback(function(instance) {}, []);
    var handleInputPropsRefProp = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(inputRef, handleInputRefProp);
    var _React$useState = $acw62.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
    var muiFormControl = (0, $8456187c225ea082$export$62ecd8ad1bbe1a18)();
    var fcs = (0, $0ca144f8f4dd9f6d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "margin",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $acw62.useCallback(function(obj) {
        if ((0, $cc803560223295e1$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    $1adb827d9b58969c$var$useEnhancedEffect(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function handleFocus(event) {
        // Fix a bug with IE 11 where the focus/blur events are triggered
        // while the input is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $gMaRA.default)(1));
            checkDirty({
                value: element.value
            });
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (inputPropsProp.onChange) inputPropsProp.onChange.apply(inputPropsProp, [
            event
        ].concat(args));
         // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat(args));
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(function() {
        checkDirty(inputRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var handleClick = function handleClick(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = (0, $8nd05.default)({}, inputPropsProp, {
        ref: handleInputRef
    });
    if (typeof InputComponent !== "string") inputProps = (0, $8nd05.default)({
        // Rename ref to inputRef as we don't know the
        // provided `inputComponent` structure.
        inputRef: handleInputRef,
        type: type
    }, inputProps, {
        ref: null
    });
    else if (multiline) {
        if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) InputComponent = "textarea";
        else {
            inputProps = (0, $8nd05.default)({
                minRows: rows || minRows,
                rowsMax: rowsMax,
                maxRows: maxRows
            }, inputProps);
            InputComponent = (0, $d7de3174d4009c3a$export$2e2bcd8739ae039);
        }
    } else inputProps = (0, $8nd05.default)({
        type: type
    }, inputProps);
    var handleAutoFill = function handleAutoFill(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $acw62.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes["color".concat((0, $f9tk6.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === "dense" && classes.marginDense),
        onClick: handleClick,
        ref: ref
    }, other), startAdornment, /*#__PURE__*/ $acw62.createElement((0, $8456187c225ea082$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement(InputComponent, (0, $8nd05.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        onAnimationStart: handleAutoFill,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }, inputProps, {
        className: (0, $1SA7b.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === "search" && classes.inputTypeSearch, fcs.margin === "dense" && classes.inputMarginDense),
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus
    }))), endAdornment, renderSuffix ? renderSuffix((0, $8nd05.default)({}, fcs, {
        startAdornment: startAdornment
    })) : null);
});
var $1adb827d9b58969c$export$2e2bcd8739ae039 = (0, $kQaj4.default)($1adb827d9b58969c$export$9dd6ff9ea0189349, {
    name: "MuiInputBase"
})($1adb827d9b58969c$var$InputBase);



var $kQaj4 = parcelRequire("kQaj4");
var $fe0d2d776beaa2db$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative"
        },
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            "label + &": {
                marginTop: 16
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:not($disabled):before": {
                borderBottom: "2px solid ".concat(theme.palette.text.primary),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    borderBottom: "1px solid ".concat(bottomLineColor)
                }
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {},
        /* Styles applied to the `input` element. */ input: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {},
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {},
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {}
    };
};
var $fe0d2d776beaa2db$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $9X7IJ.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $1adb827d9b58969c$export$2e2bcd8739ae039), (0, $8nd05.default)({
        classes: (0, $8nd05.default)({}, classes, {
            root: (0, $1SA7b.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$fe0d2d776beaa2db$var$Input.muiName = "Input";
var $fe0d2d776beaa2db$export$2e2bcd8739ae039 = (0, $kQaj4.default)($fe0d2d776beaa2db$export$9dd6ff9ea0189349, {
    name: "MuiInput"
})($fe0d2d776beaa2db$var$Input);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");



var $kQaj4 = parcelRequire("kQaj4");
var $b4a4c10240b5abef$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    var backgroundColor = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            backgroundColor: backgroundColor,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            "&:hover": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: backgroundColor
                }
            },
            "&$focused": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
            },
            "&$disabled": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
            }
        },
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:before": {
                borderBottom: "1px solid ".concat(theme.palette.text.primary)
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if the component is focused. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 12
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 12
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "27px 12px 10px",
            "&$marginDense": {
                paddingTop: 23,
                paddingBottom: 6
            }
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "27px 12px 10px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 23,
            paddingBottom: 6
        },
        /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */ inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            "&$inputMarginDense": {
                paddingTop: 10,
                paddingBottom: 11
            }
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $b4a4c10240b5abef$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $9X7IJ.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $1adb827d9b58969c$export$2e2bcd8739ae039), (0, $8nd05.default)({
        classes: (0, $8nd05.default)({}, classes, {
            root: (0, $1SA7b.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$b4a4c10240b5abef$var$FilledInput.muiName = "Input";
var $b4a4c10240b5abef$export$2e2bcd8739ae039 = (0, $kQaj4.default)($b4a4c10240b5abef$export$9dd6ff9ea0189349, {
    name: "MuiFilledInput"
})($b4a4c10240b5abef$var$FilledInput);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");



var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");


var $f9tk6 = parcelRequire("f9tk6");
var $3aa084180485b7c7$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "absolute",
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: "0 8px",
            pointerEvents: "none",
            borderRadius: "inherit",
            borderStyle: "solid",
            borderWidth: 1,
            overflow: "hidden"
        },
        /* Styles applied to the legend element when `labelWidth` is provided. */ legend: {
            textAlign: "left",
            padding: 0,
            lineHeight: "11px",
            // sync with `height` in `legend` styles
            transition: theme.transitions.create("width", {
                duration: 150,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the legend element. */ legendLabelled: {
            display: "block",
            width: "auto",
            textAlign: "left",
            padding: 0,
            height: 11,
            // sync with `lineHeight` in `legend` styles
            fontSize: "0.75em",
            visibility: "hidden",
            maxWidth: 0.01,
            transition: theme.transitions.create("max-width", {
                duration: 50,
                easing: theme.transitions.easing.easeOut
            }),
            "& > span": {
                paddingLeft: 5,
                paddingRight: 5,
                display: "inline-block"
            }
        },
        /* Styles applied to the legend element is notched. */ legendNotched: {
            maxWidth: 1000,
            transition: theme.transitions.create("max-width", {
                duration: 100,
                easing: theme.transitions.easing.easeOut,
                delay: 50
            })
        }
    };
};
/**
 * @ignore - internal component.
 */ var $3aa084180485b7c7$var$NotchedOutline = /*#__PURE__*/ $acw62.forwardRef(function NotchedOutline(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "label",
        "labelWidth",
        "notched",
        "style"
    ]);
    var theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    var align = theme.direction === "rtl" ? "right" : "left";
    if (label !== undefined) return /*#__PURE__*/ $acw62.createElement("fieldset", (0, $8nd05.default)({
        "aria-hidden": true,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref,
        style: style
    }, other), /*#__PURE__*/ $acw62.createElement("legend", {
        className: (0, $1SA7b.default)(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/ $acw62.createElement("span", null, label) : /*#__PURE__*/ $acw62.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
    var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
    return /*#__PURE__*/ $acw62.createElement("fieldset", (0, $8nd05.default)({
        "aria-hidden": true,
        style: (0, $8nd05.default)((0, $kSlfw.default)({}, "padding".concat((0, $f9tk6.default)(align)), 8), style),
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $acw62.createElement("legend", {
        className: classes.legend,
        style: {
            // IE 11: fieldset with legend does not render
            // a border radius. This maintains consistency
            // by always having a legend rendered
            width: notched ? labelWidth : 0.01
        }
    }, /*#__PURE__*/ $acw62.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
});
var $3aa084180485b7c7$export$2e2bcd8739ae039 = (0, $kQaj4.default)($3aa084180485b7c7$export$9dd6ff9ea0189349, {
    name: "PrivateNotchedOutline"
})($3aa084180485b7c7$var$NotchedOutline);



var $kQaj4 = parcelRequire("kQaj4");
var $2411f6a9f9264cd4$export$9dd6ff9ea0189349 = function styles(theme) {
    var borderColor = theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            borderRadius: theme.shape.borderRadius,
            "&:hover $notchedOutline": {
                borderColor: theme.palette.text.primary
            },
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                "&:hover $notchedOutline": {
                    borderColor: borderColor
                }
            },
            "&$focused $notchedOutline": {
                borderColor: theme.palette.primary.main,
                borderWidth: 2
            },
            "&$error $notchedOutline": {
                borderColor: theme.palette.error.main
            },
            "&$disabled $notchedOutline": {
                borderColor: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused $notchedOutline": {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 14
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 14
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "18.5px 14px",
            "&$marginDense": {
                paddingTop: 10.5,
                paddingBottom: 10.5
            }
        },
        /* Styles applied to the `NotchedOutline` element. */ notchedOutline: {
            borderColor: borderColor
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "18.5px 14px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 10.5,
            paddingBottom: 10.5
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $2411f6a9f9264cd4$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(props, ref) {
    var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $9X7IJ.default)(props, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $1adb827d9b58969c$export$2e2bcd8739ae039), (0, $8nd05.default)({
        renderSuffix: function renderSuffix(state) {
            return /*#__PURE__*/ $acw62.createElement((0, $3aa084180485b7c7$export$2e2bcd8739ae039), {
                className: classes.notchedOutline,
                label: label,
                labelWidth: labelWidth,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        classes: (0, $8nd05.default)({}, classes, {
            root: (0, $1SA7b.default)(classes.root, classes.underline),
            notchedOutline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$2411f6a9f9264cd4$var$OutlinedInput.muiName = "Input";
var $2411f6a9f9264cd4$export$2e2bcd8739ae039 = (0, $kQaj4.default)($2411f6a9f9264cd4$export$9dd6ff9ea0189349, {
    name: "MuiOutlinedInput"
})($2411f6a9f9264cd4$var$OutlinedInput);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $acw62 = parcelRequire("acw62");

function $08943360f8d6f4a8$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $8456187c225ea082$export$2e2bcd8739ae039));
}



var $kQaj4 = parcelRequire("kQaj4");

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");



var $f9tk6 = parcelRequire("f9tk6");

var $kQaj4 = parcelRequire("kQaj4");
var $606fb956d2ecf56b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $8nd05.default)({
            color: theme.palette.text.secondary
        }, theme.typography.body1, {
            lineHeight: 1,
            padding: 0,
            "&$focused": {
                color: theme.palette.primary.main
            },
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused": {
                color: theme.palette.secondary.main
            }
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Styles applied to the asterisk element. */ asterisk: {
            "&$error": {
                color: theme.palette.error.main
            }
        }
    };
};
var $606fb956d2ecf56b$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? "label" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    var muiFormControl = (0, $08943360f8d6f4a8$export$2e2bcd8739ae039)();
    var fcs = (0, $0ca144f8f4dd9f6d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes["color".concat((0, $f9tk6.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
        ref: ref
    }, other), children, fcs.required && /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": true,
        className: (0, $1SA7b.default)(classes.asterisk, fcs.error && classes.error)
    }, " ", "*"));
});
var $606fb956d2ecf56b$export$2e2bcd8739ae039 = (0, $kQaj4.default)($606fb956d2ecf56b$export$9dd6ff9ea0189349, {
    name: "MuiFormLabel"
})($606fb956d2ecf56b$var$FormLabel);


var $37600a8e6097e346$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "block",
            transformOrigin: "top left"
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Pseudo-class applied to the asterisk element. */ asterisk: {},
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            position: "absolute",
            left: 0,
            top: 0,
            // slight alteration to spec spacing to match visual spec result
            transform: "translate(0, 24px) scale(1)"
        },
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            // Compensation for the `Input.inputDense` style.
            transform: "translate(0, 21px) scale(1)"
        },
        /* Styles applied to the `input` element if `shrink={true}`. */ shrink: {
            transform: "translate(0, 1.5px) scale(0.75)",
            transformOrigin: "top left"
        },
        /* Styles applied to the `input` element if `disableAnimation={false}`. */ animated: {
            transition: theme.transitions.create([
                "color",
                "transform"
            ], {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the root element if `variant="filled"`. */ filled: {
            // Chrome's autofill feature gives the input field a yellow background.
            // Since the input field is behind the label in the HTML tree,
            // the input field is drawn last and hides the label with an opaque background color.
            // zIndex: 1 will raise the label above opaque background-colors of input.
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(12px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(12px, 17px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(12px, 10px) scale(0.75)",
                "&$marginDense": {
                    transform: "translate(12px, 7px) scale(0.75)"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            // see comment above on filled.zIndex
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(14px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(14px, 12px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(14px, -6px) scale(0.75)"
            }
        }
    };
};
var $37600a8e6097e346$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(props, ref) {
    var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "disableAnimation",
        "margin",
        "shrink",
        "variant"
    ]);
    var muiFormControl = (0, $08943360f8d6f4a8$export$2e2bcd8739ae039)();
    var shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $0ca144f8f4dd9f6d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "margin",
            "variant"
        ]
    });
    return /*#__PURE__*/ $acw62.createElement((0, $606fb956d2ecf56b$export$2e2bcd8739ae039), (0, $8nd05.default)({
        "data-shrink": shrink,
        className: (0, $1SA7b.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === "dense" && classes.marginDense, {
            "filled": classes.filled,
            "outlined": classes.outlined
        }[fcs.variant]),
        classes: {
            focused: classes.focused,
            disabled: classes.disabled,
            error: classes.error,
            required: classes.required,
            asterisk: classes.asterisk
        },
        ref: ref
    }, other));
});
var $37600a8e6097e346$export$2e2bcd8739ae039 = (0, $kQaj4.default)($37600a8e6097e346$export$9dd6ff9ea0189349, {
    name: "MuiInputLabel"
})($37600a8e6097e346$var$InputLabel);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");

var $f9tk6 = parcelRequire("f9tk6");


var $af85c23dd1603048$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top" // Fix alignment issue on Safari.
    },
    /* Styles applied to the root element if `margin="normal"`. */ marginNormal: {
        marginTop: 16,
        marginBottom: 8
    },
    /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
        marginTop: 8,
        marginBottom: 4
    },
    /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
        width: "100%"
    }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */ var $af85c23dd1603048$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? "none" : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "fullWidth",
        "focused",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    var _React$useState = $acw62.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, function(child) {
            if (!(0, $3b76a084116f5c1d$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            var input = (0, $3b76a084116f5c1d$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $cc803560223295e1$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
    var _React$useState2 = $acw62.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $acw62.Children.forEach(children, function(child) {
            if (!(0, $3b76a084116f5c1d$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $cc803560223295e1$export$d652b828d7fdeff8)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    }), filled = _React$useState2[0], setFilled = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
    var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
    if (disabled && focused) setFocused(false);
    var registerEffect;
    var registeredInput;
    var onFilled = $acw62.useCallback(function() {
        setFilled(true);
    }, []);
    var onEmpty = $acw62.useCallback(function() {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: (size === "small" ? "dense" : undefined) || margin,
        onBlur: function onBlur() {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function onFocus() {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ $acw62.createElement((0, $8456187c225ea082$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, margin !== "none" && classes["margin".concat((0, $f9tk6.default)(margin))], fullWidth && classes.fullWidth),
        ref: ref
    }, other), children));
});
var $af85c23dd1603048$export$2e2bcd8739ae039 = (0, $kQaj4.default)($af85c23dd1603048$export$9dd6ff9ea0189349, {
    name: "MuiFormControl"
})($af85c23dd1603048$var$FormControl);



var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");



var $kQaj4 = parcelRequire("kQaj4");
var $74d3f5713a0fcd7a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $8nd05.default)({
            color: theme.palette.text.secondary
        }, theme.typography.caption, {
            textAlign: "left",
            marginTop: 3,
            margin: 0,
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            marginTop: 4
        },
        /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */ contained: {
            marginLeft: 14,
            marginRight: 14
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {}
    };
};
var $74d3f5713a0fcd7a$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "p" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = (0, $08943360f8d6f4a8$export$2e2bcd8739ae039)();
    var fcs = (0, $0ca144f8f4dd9f6d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "margin",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, (fcs.variant === "filled" || fcs.variant === "outlined") && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === "dense" && classes.marginDense),
        ref: ref
    }, other), children === " " ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $acw62.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : children);
});
var $74d3f5713a0fcd7a$export$2e2bcd8739ae039 = (0, $kQaj4.default)($74d3f5713a0fcd7a$export$9dd6ff9ea0189349, {
    name: "MuiFormHelperText"
})($74d3f5713a0fcd7a$var$FormHelperText);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $fuTKz = parcelRequire("fuTKz");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $fSwVM = parcelRequire("fSwVM");

var $gMaRA = parcelRequire("gMaRA");

var $acw62 = parcelRequire("acw62");



var $1SA7b = parcelRequire("1SA7b");


var $f9tk6 = parcelRequire("f9tk6");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");



var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");





var $1SA7b = parcelRequire("1SA7b");


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $dc1f76fd676f9045$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}




var $kQaj4 = parcelRequire("kQaj4");

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $kD2D5 = parcelRequire("kD2D5");
var $gkNc2 = parcelRequire("gkNc2");




var $acw62 = parcelRequire("acw62");






function $bc19b1a314f46cb5$var$getContainer(container) {
    container = typeof container === "function" ? container() : container; // #StrictMode ready
    return $11492dca620dcaa5$exports.findDOMNode(container);
}
var $bc19b1a314f46cb5$var$useEnhancedEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $bc19b1a314f46cb5$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $acw62.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(/*#__PURE__*/ $acw62.isValidElement(children) ? children.ref : null, ref);
    $bc19b1a314f46cb5$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($bc19b1a314f46cb5$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $bc19b1a314f46cb5$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $dc6adfc0d47b3cd2$export$2e2bcd8739ae039)(ref, mountNode);
            return function() {
                (0, $dc6adfc0d47b3cd2$export$2e2bcd8739ae039)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $bc19b1a314f46cb5$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) return /*#__PURE__*/ $acw62.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $11492dca620dcaa5$exports.createPortal(children, mountNode) : mountNode;
});
var $bc19b1a314f46cb5$export$2e2bcd8739ae039 = $bc19b1a314f46cb5$var$Portal;






var $efglq = parcelRequire("efglq");
function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



var $cHPF9 = parcelRequire("cHPF9");

var $kbxxf = parcelRequire("kbxxf");
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $c50077fb3587e3c7$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement("div");
    scrollDiv.style.width = "99px";
    scrollDiv.style.height = "99px";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}




function $8c93581048c4ff0c$var$isOverflowing(container) {
    var doc = (0, $837f0f05a75630be$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $9eefbb746c8fa92f$export$2e2bcd8739ae039)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $8c93581048c4ff0c$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute("aria-hidden", "true");
    else node.removeAttribute("aria-hidden");
}
function $8c93581048c4ff0c$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)["padding-right"], 10) || 0;
}
function $8c93581048c4ff0c$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $kbxxf.default)(nodesToExclude));
    var blacklistTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE"
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $8c93581048c4ff0c$export$e1bd0c6150f13d96(node, show);
    });
}
function $8c93581048c4ff0c$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $8c93581048c4ff0c$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($8c93581048c4ff0c$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $c50077fb3587e3c7$export$2e2bcd8739ae039)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: "padding-right",
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style["padding-right"] = "".concat($8c93581048c4ff0c$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $837f0f05a75630be$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($8c93581048c4ff0c$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === "HTML" && window.getComputedStyle(parent)["overflow-y"] === "scroll" ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: "overflow",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty("padding-right");
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $8c93581048c4ff0c$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute("aria-hidden") === "true") hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $8c93581048c4ff0c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $cHPF9.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $8c93581048c4ff0c$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $8c93581048c4ff0c$var$getHiddenSiblings(container);
                $8c93581048c4ff0c$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $8c93581048c4ff0c$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $8c93581048c4ff0c$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $8c93581048c4ff0c$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $8c93581048c4ff0c$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $8c93581048c4ff0c$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $8c93581048c4ff0c$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $8c93581048c4ff0c$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $acw62 = parcelRequire("acw62");





/**
 * Utility component that locks focus inside the component.
 */ function $7472b4fa4a0dee9c$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $acw62.useRef();
    var sentinelStart = $acw62.useRef(null);
    var sentinelEnd = $acw62.useRef(null);
    var nodeToRestore = $acw62.useRef();
    var rootRef = $acw62.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $acw62.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $11492dca620dcaa5$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(children.ref, handleOwnRef);
    var prevOpenRef = $acw62.useRef();
    $acw62.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== "undefined") // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $acw62.useEffect(function() {
        if (!open) return;
        var doc = (0, $837f0f05a75630be$export$2e2bcd8739ae039)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", -1);
            rootRef.current.focus();
        }
        var contain = function contain() {
            var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener("focus", contain, true);
        doc.addEventListener("keydown", loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener("focus", contain, true);
            doc.removeEventListener("keydown", loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $acw62.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
var $7472b4fa4a0dee9c$export$2e2bcd8739ae039 = $7472b4fa4a0dee9c$var$Unstable_TrapFocus;



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $82e365a6cfd28dfd$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: "fixed",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: "transparent"
    }
};
/**
 * @ignore - internal component.
 */ var $82e365a6cfd28dfd$var$SimpleBackdrop = /*#__PURE__*/ $acw62.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $9X7IJ.default)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $8nd05.default)({}, $82e365a6cfd28dfd$export$9dd6ff9ea0189349.root, invisible ? $82e365a6cfd28dfd$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
var $82e365a6cfd28dfd$export$2e2bcd8739ae039 = $82e365a6cfd28dfd$var$SimpleBackdrop;


function $b3b17170adf2941a$var$getContainer(container) {
    container = typeof container === "function" ? container() : container;
    return $11492dca620dcaa5$exports.findDOMNode(container);
}
function $b3b17170adf2941a$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty("in") : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $b3b17170adf2941a$var$defaultManager = new (0, $8c93581048c4ff0c$export$2e2bcd8739ae039)();
var $b3b17170adf2941a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "fixed",
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: "hidden"
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $b3b17170adf2941a$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $gkNc2.default)();
    var props = (0, $kD2D5.default)({
        name: "MuiModal",
        props: (0, $8nd05.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $82e365a6cfd28dfd$export$2e2bcd8739ae039) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $b3b17170adf2941a$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $9X7IJ.default)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $acw62.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $acw62.useRef({});
    var mountNodeRef = $acw62.useRef(null);
    var modalRef = $acw62.useRef(null);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(modalRef, ref);
    var hasTransition = $b3b17170adf2941a$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $837f0f05a75630be$export$2e2bcd8739ae039)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function() {
        var resolvedContainer = $b3b17170adf2941a$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $acw62.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $8c93581048c4ff0c$export$e1bd0c6150f13d96)(modalRef.current, true);
    });
    var handleClose = $acw62.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $acw62.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, "backdropClick");
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    var inlineStyle = $b3b17170adf2941a$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $efglq.default)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || "-1";
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $dc1f76fd676f9045$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $dc1f76fd676f9045$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $acw62.createElement((0, $bc19b1a314f46cb5$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $8nd05.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $acw62.createElement(BackdropComponent, (0, $8nd05.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $acw62.createElement((0, $7472b4fa4a0dee9c$export$2e2bcd8739ae039), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $acw62.cloneElement(children, childProps))));
});
var $b3b17170adf2941a$export$2e2bcd8739ae039 = $b3b17170adf2941a$var$Modal;



var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;



var $68606cb156b7db52$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $68606cb156b7db52$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}



function $c6861fdd26078775$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $c6861fdd26078775$var$styles = {
    entering: {
        opacity: 1,
        transform: $c6861fdd26078775$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $c6861fdd26078775$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? "auto" : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $0fef977f04119bf5$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $9X7IJ.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $acw62.useRef();
    var autoTimeout = $acw62.useRef();
    var theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $acw62.useRef(null);
    var foreignRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(children.ref, ref);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $eUqlC.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $68606cb156b7db52$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $68606cb156b7db52$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $68606cb156b7db52$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(",");
        node.style.opacity = "0";
        node.style.transform = $c6861fdd26078775$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $acw62.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $acw62.createElement(TransitionComponent, (0, $8nd05.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
            style: (0, $8nd05.default)({
                opacity: 0,
                transform: $c6861fdd26078775$var$getScale(0.75),
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, $c6861fdd26078775$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$c6861fdd26078775$var$Grow.muiSupportAuto = true;
var $c6861fdd26078775$export$2e2bcd8739ae039 = $c6861fdd26078775$var$Grow;



function $a58028e92151460f$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $a58028e92151460f$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $a58028e92151460f$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === "number" ? "".concat(n, "px") : n;
    }).join(" ");
} // Sum the scrollTop between two elements.
function $a58028e92151460f$var$getScrollParent(parent, child) {
    var element = child;
    var scrollTop = 0;
    while(element && element !== parent){
        element = element.parentElement;
        scrollTop += element.scrollTop;
    }
    return scrollTop;
}
function $a58028e92151460f$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
var $a58028e92151460f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the `Paper` component. */ paper: {
        position: "absolute",
        overflowY: "auto",
        overflowX: "hidden",
        // So we see the popover when it's empty.
        // It's most likely on issue on userland.
        minWidth: 16,
        minHeight: 16,
        maxWidth: "calc(100% - 32px)",
        maxHeight: "calc(100% - 32px)",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $a58028e92151460f$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? "anchorEl" : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $c6861fdd26078775$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0, $9X7IJ.default)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "classes",
        "className",
        "container",
        "elevation",
        "getContentAnchorEl",
        "marginThreshold",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperProps",
        "transformOrigin",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var paperRef = $acw62.useRef(); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $acw62.useCallback(function(contentAnchorOffset) {
        if (anchorReference === "anchorPosition") return anchorPosition;
        var resolvedAnchorEl = $a58028e92151460f$var$getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $837f0f05a75630be$export$2e2bcd8739ae039)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        var box;
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : "center";
        return {
            top: anchorRect.top + $a58028e92151460f$export$6fcff0dc60346367(anchorRect, anchorVertical),
            left: anchorRect.left + $a58028e92151460f$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the vertical offset of inner content to anchor the transform on if provided
    var getContentAnchorOffset = $acw62.useCallback(function(element) {
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === "anchorEl") {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && element.contains(contentAnchorEl)) {
                var scrollTop = $a58028e92151460f$var$getScrollParent(element, contentAnchorEl);
                contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
            } // != the default value
        }
        return contentAnchorOffset;
    }, [
        anchorOrigin.vertical,
        anchorReference,
        getContentAnchorEl
    ]); // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use
    var getTransformOrigin = $acw62.useCallback(function(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return {
            vertical: $a58028e92151460f$export$6fcff0dc60346367(elemRect, transformOrigin.vertical) + contentAnchorOffset,
            horizontal: $a58028e92151460f$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $acw62.useCallback(function(element) {
        // Check if the parent has requested anchoring on an inner content node
        var contentAnchorOffset = getContentAnchorOffset(element);
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $a58028e92151460f$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of of the anchoring element
        var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $9eefbb746c8fa92f$export$2e2bcd8739ae039)($a58028e92151460f$var$getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            var _diff = bottom - heightThreshold;
            top -= _diff;
            elemTransformOrigin.vertical += _diff;
        }
        if (left < marginThreshold) {
            var _diff2 = left - marginThreshold;
            left -= _diff2;
            elemTransformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
            var _diff3 = right - widthThreshold;
            left -= _diff3;
            elemTransformOrigin.horizontal += _diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $a58028e92151460f$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getContentAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var setPositioningStyles = $acw62.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    var handleEntering = function handleEntering(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handlePaperRef = $acw62.useCallback(function(instance) {
        // #StrictMode ready
        paperRef.current = $11492dca620dcaa5$exports.findDOMNode(instance);
    }, []);
    $acw62.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function updatePosition() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $3308074b7cd66a5b$export$2e2bcd8739ae039)(function() {
            setPositioningStyles();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $837f0f05a75630be$export$2e2bcd8739ae039)($a58028e92151460f$var$getAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ $acw62.createElement((0, $b3b17170adf2941a$export$2e2bcd8739ae039), (0, $8nd05.default)({
        container: container,
        open: open,
        ref: ref,
        BackdropProps: {
            invisible: true
        },
        className: (0, $1SA7b.default)(classes.root, className)
    }, other), /*#__PURE__*/ $acw62.createElement(TransitionComponent, (0, $8nd05.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        timeout: transitionDuration
    }, TransitionProps, {
        onEntering: (0, $dc1f76fd676f9045$export$2e2bcd8739ae039)(handleEntering, TransitionProps.onEntering)
    }), /*#__PURE__*/ $acw62.createElement((0, $ca4ada9c808bb355$export$2e2bcd8739ae039), (0, $8nd05.default)({
        elevation: elevation,
        ref: handlePaperRef
    }, PaperProps, {
        className: (0, $1SA7b.default)(classes.paper, PaperProps.className)
    }), children)));
});
var $a58028e92151460f$export$2e2bcd8739ae039 = (0, $kQaj4.default)($a58028e92151460f$export$9dd6ff9ea0189349, {
    name: "MuiPopover"
})($a58028e92151460f$var$Popover);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");





var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ var $51d781898675016d$var$ListContext = $acw62.createContext({});
var $51d781898675016d$export$2e2bcd8739ae039 = $51d781898675016d$var$ListContext;


var $4ac22d2e9f100406$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    },
    /* Styles applied to the root element if `disablePadding={false}`. */ padding: {
        paddingTop: 8,
        paddingBottom: 8
    },
    /* Styles applied to the root element if dense. */ dense: {},
    /* Styles applied to the root element if a `subheader` is provided. */ subheader: {
        paddingTop: 0
    }
};
var $4ac22d2e9f100406$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "ul" : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    var context = $acw62.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $51d781898675016d$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
        ref: ref
    }, other), subheader, children));
});
var $4ac22d2e9f100406$export$2e2bcd8739ae039 = (0, $kQaj4.default)($4ac22d2e9f100406$export$9dd6ff9ea0189349, {
    name: "MuiList"
})($4ac22d2e9f100406$var$List);




function $d14e1a94b138eeea$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $d14e1a94b138eeea$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $d14e1a94b138eeea$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $d14e1a94b138eeea$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$d14e1a94b138eeea$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return;
        }
    }
}
var $d14e1a94b138eeea$var$useEnhancedEffect = typeof window === "undefined" ? $acw62.useEffect : $acw62.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $d14e1a94b138eeea$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    var listRef = $acw62.useRef(null);
    var textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    $d14e1a94b138eeea$var$useEnhancedEffect(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $c50077fb3587e3c7$export$2e2bcd8739ae039)(true), "px");
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function handleKeyDown(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $837f0f05a75630be$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $d14e1a94b138eeea$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $d14e1a94b138eeea$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $d14e1a94b138eeea$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $d14e1a94b138eeea$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $d14e1a94b138eeea$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $d14e1a94b138eeea$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $d14e1a94b138eeea$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $d14e1a94b138eeea$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $d14e1a94b138eeea$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $d14e1a94b138eeea$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $d14e1a94b138eeea$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleOwnRef = $acw62.useCallback(function(instance) {
        // #StrictMode ready
        listRef.current = $11492dca620dcaa5$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(handleOwnRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $acw62.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ $acw62.createElement((0, $4ac22d2e9f100406$export$2e2bcd8739ae039), (0, $8nd05.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other), items);
});
var $d14e1a94b138eeea$export$2e2bcd8739ae039 = $d14e1a94b138eeea$var$MenuList;






var $3c96b1796a446bf9$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
var $3c96b1796a446bf9$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
var $3c96b1796a446bf9$export$9dd6ff9ea0189349 = {
    /* Styles applied to the `Paper` component. */ paper: {
        // specZ: The maximum height of a simple menu should be one or more rows less than the view
        // height. This ensures a tapable area outside of the simple menu with which to dismiss
        // the menu.
        maxHeight: "calc(100% - 96px)",
        // Add iOS momentum scrolling.
        WebkitOverflowScrolling: "touch"
    },
    /* Styles applied to the `List` component via `MenuList`. */ list: {
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $3c96b1796a446bf9$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(props, ref) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEnteringProp = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps;
    _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
    var onEntering = _props$TransitionProp.onEntering, TransitionProps = (0, $9X7IJ.default)(_props$TransitionProp, [
        "onEntering"
    ]), _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "autoFocus",
        "children",
        "classes",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "onEntering",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "TransitionProps",
        "variant"
    ]);
    var theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $acw62.useRef(null);
    var contentAnchorRef = $acw62.useRef(null);
    var getContentAnchorEl = function getContentAnchorEl() {
        return contentAnchorRef.current;
    };
    var handleEntering = function handleEntering(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEnteringProp) onEnteringProp(element, isAppearing);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant !== "menu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $acw62.Children.map(children, function(child, index) {
        if (index === activeItemIndex) return /*#__PURE__*/ $acw62.cloneElement(child, {
            ref: function ref(instance) {
                // #StrictMode ready
                contentAnchorRef.current = $11492dca620dcaa5$exports.findDOMNode(instance);
                (0, $dc6adfc0d47b3cd2$export$2e2bcd8739ae039)(child.ref, instance);
            }
        });
        return child;
    });
    return /*#__PURE__*/ $acw62.createElement((0, $a58028e92151460f$export$2e2bcd8739ae039), (0, $8nd05.default)({
        getContentAnchorEl: getContentAnchorEl,
        classes: PopoverClasses,
        onClose: onClose,
        TransitionProps: (0, $8nd05.default)({
            onEntering: handleEntering
        }, TransitionProps),
        anchorOrigin: theme.direction === "rtl" ? $3c96b1796a446bf9$var$RTL_ORIGIN : $3c96b1796a446bf9$var$LTR_ORIGIN,
        transformOrigin: theme.direction === "rtl" ? $3c96b1796a446bf9$var$RTL_ORIGIN : $3c96b1796a446bf9$var$LTR_ORIGIN,
        PaperProps: (0, $8nd05.default)({}, PaperProps, {
            classes: (0, $8nd05.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        open: open,
        ref: ref,
        transitionDuration: transitionDuration
    }, other), /*#__PURE__*/ $acw62.createElement((0, $d14e1a94b138eeea$export$2e2bcd8739ae039), (0, $8nd05.default)({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
    }, MenuListProps, {
        className: (0, $1SA7b.default)(classes.list, MenuListProps.className)
    }), items));
});
var $3c96b1796a446bf9$export$2e2bcd8739ae039 = (0, $kQaj4.default)($3c96b1796a446bf9$export$9dd6ff9ea0189349, {
    name: "MuiMenu"
})($3c96b1796a446bf9$var$Menu);




/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $acw62 = parcelRequire("acw62");
function $09c3426c3fc3fc28$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? "value" : _ref$state;
    var _React$useRef = $acw62.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $acw62.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    var _React$useRef2, defaultValue;
    var setValueIfUncontrolled = $acw62.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


function $1863bcddb0c6e551$var$areEqualValues(a, b) {
    if ((0, $fSwVM.default)(b) === "object" && b !== null) return a === b;
    return String(a) === String(b);
}
function $1863bcddb0c6e551$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
/**
 * @ignore - internal component.
 */ var $1863bcddb0c6e551$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    var ariaLabel = props["aria-label"], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "aria-label",
        "autoFocus",
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    var _useControlled = (0, $09c3426c3fc3fc28$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    }), _useControlled2 = (0, $eUqlC.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var inputRef = $acw62.useRef(null);
    var _React$useState = $acw62.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
    var _React$useRef = $acw62.useRef(openProp != null), isOpenControlled = _React$useRef.current;
    var _React$useState2 = $acw62.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(ref, inputRefProp);
    $acw62.useImperativeHandle(handleRef, function() {
        return {
            focus: function focus() {
                displayNode.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        displayNode,
        value
    ]);
    $acw62.useEffect(function() {
        if (autoFocus && displayNode) displayNode.focus();
    }, [
        autoFocus,
        displayNode
    ]);
    $acw62.useEffect(function() {
        if (displayNode) {
            var label = (0, $837f0f05a75630be$export$2e2bcd8739ae039)(displayNode).getElementById(labelId);
            if (label) {
                var handler = function handler() {
                    if (getSelection().isCollapsed) displayNode.focus();
                };
                label.addEventListener("click", handler);
                return function() {
                    label.removeEventListener("click", handler);
                };
            }
        }
        return undefined;
    }, [
        labelId,
        displayNode
    ]);
    var update = function update(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function handleMouseDown(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayNode.focus();
        update(true, event);
    };
    var handleClose = function handleClose(event) {
        update(false, event);
    };
    var childrenArray = $acw62.Children.toArray(children); // Support autofill.
    var handleChange = function handleChange(event) {
        var index = childrenArray.map(function(child) {
            return child.props.value;
        }).indexOf(event.target.value);
        if (index === -1) return;
        var child = childrenArray[index];
        setValue(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function handleItemClick(child) {
        return function(event) {
            if (!multiple) update(false, event);
            var newValue;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value === newValue) return;
            setValue(newValue);
            if (onChange) {
                event.persist(); // Preact support, target is read only property on a native event.
                Object.defineProperty(event, "target", {
                    writable: true,
                    value: {
                        value: newValue,
                        name: name
                    }
                });
                onChange(event, child);
            }
        };
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (!readOnly) {
            var validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function handleBlur(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist(); // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $cc803560223295e1$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $gMaRA.default)(2));
            selected = value.some(function(v) {
                return $1863bcddb0c6e551$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $1863bcddb0c6e551$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            "aria-selected": selected ? "true" : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function onKeyUp(event) {
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    if (computeDisplay) display = multiple ? displayMultiple.join(", ") : displaySingle;
     // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? "true" : undefined,
        "aria-expanded": open ? "true" : undefined,
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [
            labelId,
            buttonId
        ].filter(Boolean).join(" ") || undefined,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
    }, SelectDisplayProps, {
        // The id is required for proper a11y
        id: buttonId
    }), $1863bcddb0c6e551$var$isEmpty(display) ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $acw62.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : display), /*#__PURE__*/ $acw62.createElement("input", (0, $8nd05.default)({
        value: Array.isArray(value) ? value.join(",") : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        className: classes.nativeInput,
        autoFocus: autoFocus
    }, other)), /*#__PURE__*/ $acw62.createElement(IconComponent, {
        className: (0, $1SA7b.default)(classes.icon, classes["icon".concat((0, $f9tk6.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
    }), /*#__PURE__*/ $acw62.createElement((0, $3c96b1796a446bf9$export$2e2bcd8739ae039), (0, $8nd05.default)({
        id: "menu-".concat(name || ""),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose
    }, MenuProps, {
        MenuListProps: (0, $8nd05.default)({
            "aria-labelledby": labelId,
            role: "listbox",
            disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, $8nd05.default)({}, MenuProps.PaperProps, {
            style: (0, $8nd05.default)({
                minWidth: menuMinWidth
            }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
    }), items));
});
var $1863bcddb0c6e551$export$2e2bcd8739ae039 = $1863bcddb0c6e551$var$SelectInput;





var $kQaj4 = parcelRequire("kQaj4");

var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $3c235619a14d24fb$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");




var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $f9tk6 = parcelRequire("f9tk6");
/**
 * @ignore - internal component.
 */ var $9cd13214d273a977$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("select", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes.select, classes[variant], className, disabled && classes.disabled),
        disabled: disabled,
        ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/ $acw62.createElement(IconComponent, {
        className: (0, $1SA7b.default)(classes.icon, classes["icon".concat((0, $f9tk6.default)(variant))], disabled && classes.disabled)
    }));
});
var $9cd13214d273a977$export$2e2bcd8739ae039 = $9cd13214d273a977$var$NativeSelectInput;



var $kQaj4 = parcelRequire("kQaj4");




var $dce0c096662ddd16$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the select component `root` class. */ root: {},
        /* Styles applied to the select component `select` class. */ select: {
            "-moz-appearance": "none",
            // Reset
            "-webkit-appearance": "none",
            // Reset
            // When interacting quickly, the text can end up selected.
            // Native select can't be selected either.
            userSelect: "none",
            borderRadius: 0,
            // Reset
            minWidth: 16,
            // So it doesn't collapse.
            cursor: "pointer",
            "&:focus": {
                // Show that it's not an text input
                backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
                borderRadius: 0 // Reset Chrome style
            },
            // Remove IE 11 arrow
            "&::-ms-expand": {
                display: "none"
            },
            "&$disabled": {
                cursor: "default"
            },
            "&[multiple]": {
                height: "auto"
            },
            "&:not([multiple]) option, &:not([multiple]) optgroup": {
                backgroundColor: theme.palette.background.paper
            },
            "&&": {
                paddingRight: 24
            }
        },
        /* Styles applied to the select component if `variant="filled"`. */ filled: {
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component if `variant="outlined"`. */ outlined: {
            borderRadius: theme.shape.borderRadius,
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component `selectMenu` class. */ selectMenu: {
            height: "auto",
            // Resets for multpile select with chips
            minHeight: "1.1876em",
            // Required for select\text-field height consistency
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden"
        },
        /* Pseudo-class applied to the select component `disabled` class. */ disabled: {},
        /* Styles applied to the icon component. */ icon: {
            // We use a position absolute over a flexbox in order to forward the pointer events
            // to the input and to support wrapping tags..
            position: "absolute",
            right: 0,
            top: "calc(50% - 12px)",
            // Center vertically
            pointerEvents: "none",
            // Don't block pointer events on the select under the icon.
            color: theme.palette.action.active,
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the icon component if the popup is open. */ iconOpen: {
            transform: "rotate(180deg)"
        },
        /* Styles applied to the icon component if `variant="filled"`. */ iconFilled: {
            right: 7
        },
        /* Styles applied to the icon component if `variant="outlined"`. */ iconOutlined: {
            right: 7
        },
        /* Styles applied to the underlying native input component. */ nativeInput: {
            bottom: 0,
            left: 0,
            position: "absolute",
            opacity: 0,
            pointerEvents: "none",
            width: "100%"
        }
    };
};
var $dce0c096662ddd16$var$defaultInput = /*#__PURE__*/ $acw62.createElement((0, $fe0d2d776beaa2db$export$2e2bcd8739ae039), null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ var $dce0c096662ddd16$var$NativeSelect = /*#__PURE__*/ $acw62.forwardRef(function NativeSelect(props, ref) {
    var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $3c235619a14d24fb$export$2e2bcd8739ae039) : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? $dce0c096662ddd16$var$defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "IconComponent",
        "input",
        "inputProps",
        "variant"
    ]);
    var muiFormControl = (0, $08943360f8d6f4a8$export$2e2bcd8739ae039)();
    var fcs = (0, $0ca144f8f4dd9f6d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    return /*#__PURE__*/ $acw62.cloneElement(input, (0, $8nd05.default)({
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: (0, $9cd13214d273a977$export$2e2bcd8739ae039),
        inputProps: (0, $8nd05.default)({
            children: children,
            classes: classes,
            IconComponent: IconComponent,
            variant: fcs.variant,
            type: undefined
        }, inputProps, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$dce0c096662ddd16$var$NativeSelect.muiName = "Select";
var $dce0c096662ddd16$export$2e2bcd8739ae039 = (0, $kQaj4.default)($dce0c096662ddd16$export$9dd6ff9ea0189349, {
    name: "MuiNativeSelect"
})($dce0c096662ddd16$var$NativeSelect);





var $b2b33d3a8d93221f$export$9dd6ff9ea0189349 = (0, $dce0c096662ddd16$export$9dd6ff9ea0189349);
var $b2b33d3a8d93221f$var$_ref = /*#__PURE__*/ $acw62.createElement((0, $fe0d2d776beaa2db$export$2e2bcd8739ae039), null);
var $b2b33d3a8d93221f$var$_ref2 = /*#__PURE__*/ $acw62.createElement((0, $b4a4c10240b5abef$export$2e2bcd8739ae039), null);
var $b2b33d3a8d93221f$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(props, ref) {
    var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $3c235619a14d24fb$export$2e2bcd8739ae039) : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    var inputComponent = native ? (0, $9cd13214d273a977$export$2e2bcd8739ae039) : (0, $1863bcddb0c6e551$export$2e2bcd8739ae039);
    var muiFormControl = (0, $08943360f8d6f4a8$export$2e2bcd8739ae039)();
    var fcs = (0, $0ca144f8f4dd9f6d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || ({
        standard: $b2b33d3a8d93221f$var$_ref,
        outlined: /*#__PURE__*/ $acw62.createElement((0, $2411f6a9f9264cd4$export$2e2bcd8739ae039), {
            label: label,
            labelWidth: labelWidth
        }),
        filled: $b2b33d3a8d93221f$var$_ref2
    })[variant];
    return /*#__PURE__*/ $acw62.cloneElement(InputComponent, (0, $8nd05.default)({
        // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: inputComponent,
        inputProps: (0, $8nd05.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            // We render a select. We can ignore the type provided by the `Input`.
            multiple: multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $8nd05.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $fuTKz.default)({
                baseClasses: classes,
                newClasses: inputProps.classes,
                Component: Select
            }) : classes
        }, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$b2b33d3a8d93221f$var$Select.muiName = "Select";
var $b2b33d3a8d93221f$export$2e2bcd8739ae039 = (0, $kQaj4.default)($b2b33d3a8d93221f$export$9dd6ff9ea0189349, {
    name: "MuiSelect"
})($b2b33d3a8d93221f$var$Select);



var $kQaj4 = parcelRequire("kQaj4");
var $59744fa8faea6c4c$var$variantComponent = {
    standard: (0, $fe0d2d776beaa2db$export$2e2bcd8739ae039),
    filled: (0, $b4a4c10240b5abef$export$2e2bcd8739ae039),
    outlined: (0, $2411f6a9f9264cd4$export$2e2bcd8739ae039)
};
var $59744fa8faea6c4c$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $59744fa8faea6c4c$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(props, ref) {
    var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, maxRows = props.maxRows, minRows = props.minRows, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "maxRows",
        "minRows",
        "select",
        "SelectProps",
        "type",
        "value",
        "variant"
    ]);
    var InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        if (label) {
            var _InputLabelProps$requ;
            var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
            InputMore.label = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, label, displayRequired && "\xa0*");
        }
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $59744fa8faea6c4c$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ $acw62.createElement(InputComponent, (0, $8nd05.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ $acw62.createElement((0, $af85c23dd1603048$export$2e2bcd8739ae039), (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color,
        variant: variant
    }, other), label && /*#__PURE__*/ $acw62.createElement((0, $37600a8e6097e346$export$2e2bcd8739ae039), (0, $8nd05.default)({
        htmlFor: id,
        id: inputLabelId
    }, InputLabelProps), label), select ? /*#__PURE__*/ $acw62.createElement((0, $b2b33d3a8d93221f$export$2e2bcd8739ae039), (0, $8nd05.default)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
    }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/ $acw62.createElement((0, $74d3f5713a0fcd7a$export$2e2bcd8739ae039), (0, $8nd05.default)({
        id: helperTextId
    }, FormHelperTextProps), helperText));
});
var $59744fa8faea6c4c$export$2e2bcd8739ae039 = (0, $kQaj4.default)($59744fa8faea6c4c$export$9dd6ff9ea0189349, {
    name: "MuiTextField"
})($59744fa8faea6c4c$var$TextField);



var $acw62 = parcelRequire("acw62");
var $0d70f179cf56e662$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $0d70f179cf56e662$var$isDateObject = (value1)=>value1 instanceof Date;
var $0d70f179cf56e662$var$isNullOrUndefined = (value1)=>value1 == null;
const $0d70f179cf56e662$var$isObjectType = (value1)=>typeof value1 === "object";
var $0d70f179cf56e662$var$isObject = (value1)=>!$0d70f179cf56e662$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $0d70f179cf56e662$var$isObjectType(value1) && !$0d70f179cf56e662$var$isDateObject(value1);
var $0d70f179cf56e662$var$getEventValue = (event)=>$0d70f179cf56e662$var$isObject(event) && event.target ? $0d70f179cf56e662$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $0d70f179cf56e662$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $0d70f179cf56e662$var$isNameInFieldArray = (names, name)=>names.has($0d70f179cf56e662$var$getNodeParentName(name));
var $0d70f179cf56e662$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $0d70f179cf56e662$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $0d70f179cf56e662$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $0d70f179cf56e662$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($0d70f179cf56e662$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $0d70f179cf56e662$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$0d70f179cf56e662$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $0d70f179cf56e662$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $0d70f179cf56e662$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $0d70f179cf56e662$var$isUndefined = (val)=>val === undefined;
var $0d70f179cf56e662$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    if (!path || !$0d70f179cf56e662$var$isObject(obj)) return defaultValue;
    const result = $0d70f179cf56e662$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$0d70f179cf56e662$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $0d70f179cf56e662$var$isUndefined(result) || result === obj ? $0d70f179cf56e662$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
var $0d70f179cf56e662$var$isBoolean = (value1)=>typeof value1 === "boolean";
const $0d70f179cf56e662$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $0d70f179cf56e662$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $0d70f179cf56e662$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $0d70f179cf56e662$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0d70f179cf56e662$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children , ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d70f179cf56e662$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $0d70f179cf56e662$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $0d70f179cf56e662$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $0d70f179cf56e662$var$isEmptyObject = (value1)=>$0d70f179cf56e662$var$isObject(value1) && !Object.keys(value1).length;
var $0d70f179cf56e662$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name , ...formState } = formStateData;
    return $0d70f179cf56e662$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all));
};
var $0d70f179cf56e662$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $0d70f179cf56e662$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $0d70f179cf56e662$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $0d70f179cf56e662$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$606f11b2eb45ecc6(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control , disabled: disabled , name: name , exact: exact  } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $0d70f179cf56e662$var$shouldSubscribeByName(_name.current, value1.name, exact) && $0d70f179cf56e662$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $0d70f179cf56e662$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $0d70f179cf56e662$var$isString = (value1)=>typeof value1 === "string";
var $0d70f179cf56e662$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($0d70f179cf56e662$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $0d70f179cf56e662$export$3c773aa2b84f29e0(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control , name: name , defaultValue: defaultValue , disabled: disabled , exact: exact  } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($0d70f179cf56e662$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $0d70f179cf56e662$var$isKey = (value1)=>/^\w*$/.test(value1);
var $0d70f179cf56e662$var$stringToPath = (input)=>$0d70f179cf56e662$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function $0d70f179cf56e662$export$adaa4cf7ef1b65be(object, path, value1) {
    let index = -1;
    const tempPath = $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $0d70f179cf56e662$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$e8c786024a2b0a79(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { name: name , disabled: disabled , control: control = methods.control , shouldUnregister: shouldUnregister  } = props;
    const isArrayField = $0d70f179cf56e662$var$isNameInFieldArray(control._names.array, name);
    const value1 = $0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name, $0d70f179cf56e662$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $0d70f179cf56e662$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control.register(name, {
        ...props.rules,
        value: value1
    }));
    _registerProps.current = control.register(name, props.rules);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($0d70f179cf56e662$var$isUndefined($0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name))) $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$0d70f179cf56e662$var$isBoolean(disabled) || $0d70f179cf56e662$var$isBoolean(formState.disabled) ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $0d70f179cf56e662$var$getEventValue(event),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $0d70f179cf56e662$export$bd0bf19f25da8474 = (props)=>props.render($0d70f179cf56e662$export$e8c786024a2b0a79(props));
const $0d70f179cf56e662$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$a7fed597f4b8afd8(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { control: control = methods.control , onSubmit: onSubmit , children: children , action: action , method: method = $0d70f179cf56e662$var$POST_REQUEST , headers: headers , encType: encType , onError: onError , render: render , onSuccess: onSuccess , validateStatus: validateStatus , ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $0d70f179cf56e662$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $0d70f179cf56e662$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $0d70f179cf56e662$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $0d70f179cf56e662$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $0d70f179cf56e662$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$0d70f179cf56e662$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $0d70f179cf56e662$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $0d70f179cf56e662$var$VALIDATION_MODE.all,
        isOnTouch: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onTouched
    });
var $0d70f179cf56e662$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $0d70f179cf56e662$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f , ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) break;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) break;
            } else if ($0d70f179cf56e662$var$isObject(currentField)) $0d70f179cf56e662$var$iterateFieldsByAction(currentField, action);
        }
    }
};
var $0d70f179cf56e662$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(errors, name));
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $0d70f179cf56e662$var$isFileInput = (element)=>element.type === "file";
var $0d70f179cf56e662$var$isFunction = (value1)=>typeof value1 === "function";
var $0d70f179cf56e662$var$isHTMLElement = (value1)=>{
    if (!$0d70f179cf56e662$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $0d70f179cf56e662$var$isMessage = (value1)=>$0d70f179cf56e662$var$isString(value1);
var $0d70f179cf56e662$var$isRadioInput = (element)=>element.type === "radio";
var $0d70f179cf56e662$var$isRegex = (value1)=>value1 instanceof RegExp;
const $0d70f179cf56e662$var$defaultResult = {
    value: false,
    isValid: false
};
const $0d70f179cf56e662$var$validResult = {
    value: true,
    isValid: true
};
var $0d70f179cf56e662$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$0d70f179cf56e662$var$isUndefined(options[0].attributes.value) ? $0d70f179cf56e662$var$isUndefined(options[0].value) || options[0].value === "" ? $0d70f179cf56e662$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $0d70f179cf56e662$var$validResult : $0d70f179cf56e662$var$defaultResult;
    }
    return $0d70f179cf56e662$var$defaultResult;
};
const $0d70f179cf56e662$var$defaultReturn = {
    isValid: false,
    value: null
};
var $0d70f179cf56e662$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $0d70f179cf56e662$var$defaultReturn) : $0d70f179cf56e662$var$defaultReturn;
function $0d70f179cf56e662$var$getValidateError(result, ref, type = "validate") {
    if ($0d70f179cf56e662$var$isMessage(result) || Array.isArray(result) && result.every($0d70f179cf56e662$var$isMessage) || $0d70f179cf56e662$var$isBoolean(result) && !result) return {
        type: type,
        message: $0d70f179cf56e662$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $0d70f179cf56e662$var$getValueAndMessage = (validationData)=>$0d70f179cf56e662$var$isObject(validationData) && !$0d70f179cf56e662$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $0d70f179cf56e662$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref , refs: refs , required: required , maxLength: maxLength , minLength: minLength , min: min , max: max , pattern: pattern , validate: validate , name: name , valueAsNumber: valueAsNumber , mount: mount , disabled: disabled  } = field._f;
    const inputValue = $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($0d70f179cf56e662$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $0d70f179cf56e662$var$isRadioInput(ref);
    const isCheckBox = $0d70f179cf56e662$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $0d70f179cf56e662$var$isFileInput(ref)) && $0d70f179cf56e662$var$isUndefined(ref.value) && $0d70f179cf56e662$var$isUndefined(inputValue) || $0d70f179cf56e662$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $0d70f179cf56e662$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.maxLength, minType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $0d70f179cf56e662$var$isNullOrUndefined(inputValue)) || $0d70f179cf56e662$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$0d70f179cf56e662$var$getCheckboxValue(refs).isValid || isRadio && !$0d70f179cf56e662$var$getRadioValue(refs).isValid)) {
        const { value: value1 , message: message  } = $0d70f179cf56e662$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $0d70f179cf56e662$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$0d70f179cf56e662$var$isNullOrUndefined(min) || !$0d70f179cf56e662$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $0d70f179cf56e662$var$getValueAndMessage(max);
        const minOutput = $0d70f179cf56e662$var$getValueAndMessage(min);
        if (!$0d70f179cf56e662$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$0d70f179cf56e662$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$0d70f179cf56e662$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($0d70f179cf56e662$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($0d70f179cf56e662$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.max, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($0d70f179cf56e662$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(maxLength);
        const minLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(minLength);
        const exceedMax = !$0d70f179cf56e662$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$0d70f179cf56e662$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $0d70f179cf56e662$var$isString(inputValue)) {
        const { value: patternValue , message: message  } = $0d70f179cf56e662$var$getValueAndMessage(pattern);
        if ($0d70f179cf56e662$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($0d70f179cf56e662$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $0d70f179cf56e662$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($0d70f179cf56e662$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$0d70f179cf56e662$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $0d70f179cf56e662$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$0d70f179cf56e662$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
function $0d70f179cf56e662$var$append(data, value1) {
    return [
        ...data,
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1)
    ];
}
var $0d70f179cf56e662$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $0d70f179cf56e662$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $0d70f179cf56e662$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($0d70f179cf56e662$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $0d70f179cf56e662$var$prepend(data, value1) {
    return [
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...$0d70f179cf56e662$var$convertToArrayPayload(data)
    ];
}
function $0d70f179cf56e662$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $0d70f179cf56e662$var$compact(temp).length ? temp : [];
}
var $0d70f179cf56e662$var$removeArrayAt = (data, index)=>$0d70f179cf56e662$var$isUndefined(index) ? [] : $0d70f179cf56e662$var$removeAtIndexes(data, $0d70f179cf56e662$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $0d70f179cf56e662$var$swapArrayAt = (data, indexA, indexB)=>{
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $0d70f179cf56e662$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $0d70f179cf56e662$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $0d70f179cf56e662$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$0d70f179cf56e662$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $0d70f179cf56e662$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $0d70f179cf56e662$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($0d70f179cf56e662$var$isObject(childObject) && $0d70f179cf56e662$var$isEmptyObject(childObject) || Array.isArray(childObject) && $0d70f179cf56e662$var$isEmptyArray(childObject))) $0d70f179cf56e662$var$unset(object, paths.slice(0, -1));
    return object;
}
var $0d70f179cf56e662$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$310131896651d559(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control , name: name , keyName: keyName = "id" , shouldUnregister: shouldUnregister  } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control._getFieldArray(name).map($0d70f179cf56e662$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $0d70f179cf56e662$var$useSubscribe({
        next: ({ values: values , name: fieldArrayName  })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $0d70f179cf56e662$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($0d70f179cf56e662$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append$1 = (value1, options)=>{
        const appendValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $0d70f179cf56e662$var$append(ids.current, appendValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$append, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const prepend$1 = (value1, options)=>{
        const prependValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, 0, options);
        ids.current = $0d70f179cf56e662$var$prepend(ids.current, prependValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$prepend, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $0d70f179cf56e662$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, index, options);
        ids.current = $0d70f179cf56e662$var$insert(ids.current, index, insertValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$insert, {
            argA: index,
            argB: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $0d70f179cf56e662$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $0d70f179cf56e662$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $0d70f179cf56e662$var$cloneObject(value1);
        const updatedFieldArrayValues = $0d70f179cf56e662$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $0d70f179cf56e662$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($0d70f179cf56e662$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._state.action = false;
        $0d70f179cf56e662$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $0d70f179cf56e662$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $0d70f179cf56e662$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $0d70f179cf56e662$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $0d70f179cf56e662$var$validateField(field, control._formValues, control._options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$0d70f179cf56e662$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $0d70f179cf56e662$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $0d70f179cf56e662$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        !$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $0d70f179cf56e662$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
function $0d70f179cf56e662$var$createSubject() {
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $0d70f179cf56e662$var$isPrimitive = (value1)=>$0d70f179cf56e662$var$isNullOrUndefined(value1) || !$0d70f179cf56e662$var$isObjectType(value1);
function $0d70f179cf56e662$var$deepEqual(object1, object2) {
    if ($0d70f179cf56e662$var$isPrimitive(object1) || $0d70f179cf56e662$var$isPrimitive(object2)) return object1 === object2;
    if ($0d70f179cf56e662$var$isDateObject(object1) && $0d70f179cf56e662$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($0d70f179cf56e662$var$isDateObject(val1) && $0d70f179cf56e662$var$isDateObject(val2) || $0d70f179cf56e662$var$isObject(val1) && $0d70f179cf56e662$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$0d70f179cf56e662$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $0d70f179cf56e662$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $0d70f179cf56e662$var$isRadioOrCheckbox = (ref)=>$0d70f179cf56e662$var$isRadioInput(ref) || $0d70f179cf56e662$var$isCheckBoxInput(ref);
var $0d70f179cf56e662$var$live = (ref)=>$0d70f179cf56e662$var$isHTMLElement(ref) && ref.isConnected;
var $0d70f179cf56e662$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($0d70f179cf56e662$var$isFunction(data[key])) return true;
    }
    return false;
};
function $0d70f179cf56e662$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $0d70f179cf56e662$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$0d70f179cf56e662$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            if ($0d70f179cf56e662$var$isUndefined(formValues) || $0d70f179cf56e662$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $0d70f179cf56e662$var$markFieldsDirty(data[key], []) : {
                ...$0d70f179cf56e662$var$markFieldsDirty(data[key])
            };
            else $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data[key], $0d70f179cf56e662$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$0d70f179cf56e662$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $0d70f179cf56e662$var$getDirtyFields = (defaultValues, formValues)=>$0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $0d70f179cf56e662$var$markFieldsDirty(formValues));
var $0d70f179cf56e662$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber , valueAsDate: valueAsDate , setValueAs: setValueAs  })=>$0d70f179cf56e662$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $0d70f179cf56e662$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $0d70f179cf56e662$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($0d70f179cf56e662$var$isFileInput(ref)) return ref.files;
    if ($0d70f179cf56e662$var$isRadioInput(ref)) return $0d70f179cf56e662$var$getRadioValue(_f.refs).value;
    if ($0d70f179cf56e662$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1  })=>value1);
    if ($0d70f179cf56e662$var$isCheckBoxInput(ref)) return $0d70f179cf56e662$var$getCheckboxValue(_f.refs).value;
    return $0d70f179cf56e662$var$getFieldValueAs($0d70f179cf56e662$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $0d70f179cf56e662$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        field && $0d70f179cf56e662$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $0d70f179cf56e662$var$getRuleValue = (rule)=>$0d70f179cf56e662$var$isUndefined(rule) ? rule : $0d70f179cf56e662$var$isRegex(rule) ? rule.source : $0d70f179cf56e662$var$isObject(rule) ? $0d70f179cf56e662$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $0d70f179cf56e662$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, name) {
    const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
    if (error || $0d70f179cf56e662$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $0d70f179cf56e662$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $0d70f179cf56e662$var$unsetEmptyArray = (ref, name)=>!$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(ref, name)).length && $0d70f179cf56e662$var$unset(ref, name);
const $0d70f179cf56e662$var$defaultOptions = {
    mode: $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $0d70f179cf56e662$var$createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...$0d70f179cf56e662$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $0d70f179cf56e662$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {},
        disabled: false
    };
    let _fields = {};
    let _defaultValues = $0d70f179cf56e662$var$isObject(_options.defaultValues) || $0d70f179cf56e662$var$isObject(_options.values) ? $0d70f179cf56e662$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $0d70f179cf56e662$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $0d70f179cf56e662$var$createSubject(),
        array: $0d70f179cf56e662$var$createSubject(),
        state: $0d70f179cf56e662$var$createSubject()
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = $0d70f179cf56e662$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $0d70f179cf56e662$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $0d70f179cf56e662$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $0d70f179cf56e662$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $0d70f179cf56e662$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $0d70f179cf56e662$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = $0d70f179cf56e662$var$deepEqual($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            isCurrentFieldPristine ? $0d70f179cf56e662$var$unset(_formState.dirtyFields, name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $0d70f179cf56e662$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        if ((error ? !$0d70f179cf56e662$var$deepEqual(previousFieldError, error) : previousFieldError) || !$0d70f179cf56e662$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $0d70f179cf56e662$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, $0d70f179cf56e662$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors  } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f , ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $0d70f179cf56e662$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($0d70f179cf56e662$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $0d70f179cf56e662$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $0d70f179cf56e662$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$0d70f179cf56e662$var$live(ref)) : !$0d70f179cf56e662$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, data), !$0d70f179cf56e662$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$0d70f179cf56e662$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $0d70f179cf56e662$var$isUndefined(defaultValue) ? _defaultValues : $0d70f179cf56e662$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, $0d70f179cf56e662$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $0d70f179cf56e662$var$isHTMLElement(fieldReference.ref) && $0d70f179cf56e662$var$isNullOrUndefined(value1) ? "" : value1;
                if ($0d70f179cf56e662$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($0d70f179cf56e662$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($0d70f179cf56e662$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$0d70f179cf56e662$var$isPrimitive(fieldValue) || field && !field._f) && !$0d70f179cf56e662$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $0d70f179cf56e662$var$cloneObject(value1);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$0d70f179cf56e662$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $0d70f179cf56e662$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: name,
            values: {
                ..._formValues
            }
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $0d70f179cf56e662$var$getFieldValue(field._f) : $0d70f179cf56e662$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $0d70f179cf56e662$var$EVENTS.BLUR || event.type === $0d70f179cf56e662$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$0d70f179cf56e662$var$hasValidation(field._f) && !_options.resolver && !$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $0d70f179cf56e662$var$skipValidation(isBlurEvent, $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $0d70f179cf56e662$var$isWatched(name, _names, isBlurEvent);
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$0d70f179cf56e662$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors: errors  } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
                }
            } else {
                error = (await $0d70f179cf56e662$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $0d70f179cf56e662$var$convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($0d70f179cf56e662$var$isUndefined(name) ? name : fieldNames);
            isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$0d70f179cf56e662$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $0d70f179cf56e662$var$isUndefined(fieldNames) ? values : $0d70f179cf56e662$var$isString(fieldNames) ? $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $0d70f179cf56e662$var$convertToArrayPayload(name).forEach((inputName)=>$0d70f179cf56e662$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$0d70f179cf56e662$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $0d70f179cf56e662$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $0d70f179cf56e662$var$unset(_fields, fieldName);
                $0d70f179cf56e662$var$unset(_formValues, fieldName);
            }
            !options.keepError && $0d70f179cf56e662$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $0d70f179cf56e662$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $0d70f179cf56e662$var$unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $0d70f179cf56e662$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled , name: name , field: field , fields: fields , value: value1  })=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled)) {
            const inputValue = disabled ? undefined : $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$var$getFieldValue(field ? field._f : $0d70f179cf56e662$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $0d70f179cf56e662$var$isBoolean(options.disabled);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $0d70f179cf56e662$var$getRuleValue(options.min),
                max: $0d70f179cf56e662$var$getRuleValue(options.max),
                minLength: $0d70f179cf56e662$var$getRuleValue(options.minLength),
                maxLength: $0d70f179cf56e662$var$getRuleValue(options.maxLength),
                pattern: $0d70f179cf56e662$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $0d70f179cf56e662$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $0d70f179cf56e662$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($0d70f179cf56e662$var$live),
                                    fieldRef,
                                    ...Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($0d70f179cf56e662$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $0d70f179cf56e662$var$iterateFieldsByAction(_fields, (ref)=>{
                ref.disabled = disabled;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $0d70f179cf56e662$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors , values: values  } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $0d70f179cf56e662$var$unset(_formState.errors, "root");
            if ($0d70f179cf56e662$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                await onValid(fieldValues, e);
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $0d70f179cf56e662$var$isEmptyObject(_formState.errors),
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
        };
    const resetField = (name, options = {})=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)) {
            if ($0d70f179cf56e662$var$isUndefined(options.defaultValue)) setValue(name, $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $0d70f179cf56e662$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $0d70f179cf56e662$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $0d70f179cf56e662$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $0d70f179cf56e662$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $0d70f179cf56e662$var$cloneObject(updatedValues);
        const values = formValues && !$0d70f179cf56e662$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) for (const fieldName of _names.mount)$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(values, fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($0d70f179cf56e662$var$isWeb && $0d70f179cf56e662$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($0d70f179cf56e662$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $0d70f179cf56e662$var$cloneObject(_defaultValues) : {} : $0d70f179cf56e662$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$0d70f179cf56e662$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($0d70f179cf56e662$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$0d70f179cf56e662$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $0d70f179cf56e662$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        disabled: false,
        defaultValues: $0d70f179cf56e662$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$0d70f179cf56e662$var$createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $0d70f179cf56e662$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($0d70f179cf56e662$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.values && !$0d70f179cf56e662$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $0d70f179cf56e662$var$getProxyFormState(formState, control);
    return _formControl.current;
}


// ES6 Map
var $c20a5baa3b2b3be7$var$map;
try {
    $c20a5baa3b2b3be7$var$map = Map;
} catch (_) {}
var $c20a5baa3b2b3be7$var$set;
// ES6 Set
try {
    $c20a5baa3b2b3be7$var$set = Set;
} catch (_) {}
function $c20a5baa3b2b3be7$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== "object" || typeof src === "function") return src;
    // DOM Node
    if (src.nodeType && "cloneNode" in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($c20a5baa3b2b3be7$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($c20a5baa3b2b3be7$var$map && src instanceof $c20a5baa3b2b3be7$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($c20a5baa3b2b3be7$var$set && src instanceof $c20a5baa3b2b3be7$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $c20a5baa3b2b3be7$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $c20a5baa3b2b3be7$export$2e2bcd8739ae039(src) {
    return $c20a5baa3b2b3be7$var$baseClone(src, [], []);
}


const $3bcbbcae986c2431$var$toString = Object.prototype.toString;
const $3bcbbcae986c2431$var$errorToString = Error.prototype.toString;
const $3bcbbcae986c2431$var$regExpToString = RegExp.prototype.toString;
const $3bcbbcae986c2431$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $3bcbbcae986c2431$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $3bcbbcae986c2431$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $3bcbbcae986c2431$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $3bcbbcae986c2431$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $3bcbbcae986c2431$var$symbolToString.call(val).replace($3bcbbcae986c2431$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $3bcbbcae986c2431$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $3bcbbcae986c2431$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $3bcbbcae986c2431$var$regExpToString.call(val);
    return null;
}
function $3bcbbcae986c2431$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $3bcbbcae986c2431$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $3bcbbcae986c2431$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}


let $3ea8894c2d1a8ff8$export$9b30b6294c1449a8 = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path , type: type , value: value , originalValue: originalValue  })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(originalValue, true)}\`).` : ".");
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: "${path} must be defined"
};
let $3ea8894c2d1a8ff8$export$22b082955e083ec3 = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $3ea8894c2d1a8ff8$export$98e628dec113755e = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $3ea8894c2d1a8ff8$export$324d90190a8b822a = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $3ea8894c2d1a8ff8$export$4a21f16c33752377 = {
    isValue: "${path} field must be ${value}"
};
let $3ea8894c2d1a8ff8$export$be5493f9613cbbe = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $3ea8894c2d1a8ff8$export$2f23118c22fb2630 = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
var $3ea8894c2d1a8ff8$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $3ea8894c2d1a8ff8$export$9b30b6294c1449a8,
    string: $3ea8894c2d1a8ff8$export$22b082955e083ec3,
    number: $3ea8894c2d1a8ff8$export$98e628dec113755e,
    date: $3ea8894c2d1a8ff8$export$324d90190a8b822a,
    object: $3ea8894c2d1a8ff8$export$be5493f9613cbbe,
    array: $3ea8894c2d1a8ff8$export$2f23118c22fb2630,
    boolean: $3ea8894c2d1a8ff8$export$4a21f16c33752377
});


var $e21135b6db383fe3$exports = {};
var $3c47f0745c8ad323$exports = {};
/** Used for built-in method references. */ var $3c47f0745c8ad323$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c47f0745c8ad323$var$hasOwnProperty = $3c47f0745c8ad323$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3c47f0745c8ad323$var$baseHas(object, key) {
    return object != null && $3c47f0745c8ad323$var$hasOwnProperty.call(object, key);
}
$3c47f0745c8ad323$exports = $3c47f0745c8ad323$var$baseHas;


var $85aaea8f77d790ae$exports = {};
var $38afcbfab85a0553$exports = {};
var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


var $03e9beb856e9b4cd$exports = {};

var $6b5a5095e0934938$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($0488fde9aa355453$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};
var $4902f64a16640324$exports = {};
var $df2cd4bc93f21548$exports = {};
var $8d50e526a9e9b7fa$exports = {};
var $80f20c637ba11563$exports = {};
var $e95343b7bf5d617b$exports = {};
var $5037fd2e597c2a03$exports = {};
var $8360225fb63098b3$exports = {};
var $004783abbde551e4$exports = {};

var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = "[object AsyncFunction]", $004783abbde551e4$var$funcTag = "[object Function]", $004783abbde551e4$var$genTag = "[object GeneratorFunction]", $004783abbde551e4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$f9ff2e983beb6b86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a7f8a2555793d7d3$exports(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
$004783abbde551e4$exports = $004783abbde551e4$var$isFunction;


var $5e8d211f630cd46d$exports = {};
var $baf78e1246b3b18f$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
$baf78e1246b3b18f$exports = $baf78e1246b3b18f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($baf78e1246b3b18f$exports && $baf78e1246b3b18f$exports.keys && $baf78e1246b3b18f$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
$5e8d211f630cd46d$exports = $5e8d211f630cd46d$var$isMasked;



var $9c6b3ec69362487e$exports = {};
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$9c6b3ec69362487e$exports = $9c6b3ec69362487e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp("^" + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$f9ff2e983beb6b86$exports(value) || $5e8d211f630cd46d$exports(value)) return false;
    var pattern = $004783abbde551e4$exports(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($9c6b3ec69362487e$exports(value));
}
$8360225fb63098b3$exports = $8360225fb63098b3$var$baseIsNative;


var $d50b255f8680c47a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d50b255f8680c47a$exports = $d50b255f8680c47a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $d50b255f8680c47a$exports(object, key);
    return $8360225fb63098b3$exports(value) ? value : undefined;
}
$5037fd2e597c2a03$exports = $5037fd2e597c2a03$var$getNative;


/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $5037fd2e597c2a03$exports(Object, "create");
$e95343b7bf5d617b$exports = $e95343b7bf5d617b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $e95343b7bf5d617b$exports ? $e95343b7bf5d617b$exports(null) : {};
    this.size = 0;
}
$80f20c637ba11563$exports = $80f20c637ba11563$var$hashClear;


var $60a2188452e03a76$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$60a2188452e03a76$exports = $60a2188452e03a76$var$hashDelete;


var $0ade0ffa62051a98$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($e95343b7bf5d617b$exports) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$0ade0ffa62051a98$exports = $0ade0ffa62051a98$var$hashGet;


var $0d7f9677a17b6bef$exports = {};

/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $e95343b7bf5d617b$exports ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
$0d7f9677a17b6bef$exports = $0d7f9677a17b6bef$var$hashHas;


var $d33db65186b62952$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e95343b7bf5d617b$exports && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
$d33db65186b62952$exports = $d33db65186b62952$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $80f20c637ba11563$exports;
$8d50e526a9e9b7fa$var$Hash.prototype["delete"] = $60a2188452e03a76$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $0ade0ffa62051a98$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $0d7f9677a17b6bef$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $d33db65186b62952$exports;
$8d50e526a9e9b7fa$exports = $8d50e526a9e9b7fa$var$Hash;


var $dd14efc87ba1cd5b$exports = {};
var $83df40714bf7006e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$83df40714bf7006e$exports = $83df40714bf7006e$var$listCacheClear;


var $d22fe27824ff9351$exports = {};
var $87257b05f5d9ad81$exports = {};
var $50557587dab070a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$50557587dab070a0$exports = $50557587dab070a0$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($50557587dab070a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$87257b05f5d9ad81$exports = $87257b05f5d9ad81$var$assocIndexOf;


/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d22fe27824ff9351$exports = $d22fe27824ff9351$var$listCacheDelete;


var $b2e6263d81cdc1b3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b2e6263d81cdc1b3$exports = $b2e6263d81cdc1b3$var$listCacheGet;


var $29e2bc7b7348833e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $87257b05f5d9ad81$exports(this.__data__, key) > -1;
}
$29e2bc7b7348833e$exports = $29e2bc7b7348833e$var$listCacheHas;


var $ff9311500b60ab72$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ff9311500b60ab72$exports = $ff9311500b60ab72$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $83df40714bf7006e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype["delete"] = $d22fe27824ff9351$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $b2e6263d81cdc1b3$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $29e2bc7b7348833e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $ff9311500b60ab72$exports;
$dd14efc87ba1cd5b$exports = $dd14efc87ba1cd5b$var$ListCache;


var $19b02faa57603249$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $5037fd2e597c2a03$exports($23YZo, "Map");
$19b02faa57603249$exports = $19b02faa57603249$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $8d50e526a9e9b7fa$exports,
        "map": new ($19b02faa57603249$exports || $dd14efc87ba1cd5b$exports),
        "string": new $8d50e526a9e9b7fa$exports
    };
}
$df2cd4bc93f21548$exports = $df2cd4bc93f21548$var$mapCacheClear;


var $44464964ade29765$exports = {};
var $c0b23e5f03c2595b$exports = {};
var $09c4668903e66c1d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$09c4668903e66c1d$exports = $09c4668903e66c1d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $09c4668903e66c1d$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$c0b23e5f03c2595b$exports = $c0b23e5f03c2595b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $c0b23e5f03c2595b$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$44464964ade29765$exports = $44464964ade29765$var$mapCacheDelete;


var $ba80406da5503086$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $c0b23e5f03c2595b$exports(this, key).get(key);
}
$ba80406da5503086$exports = $ba80406da5503086$var$mapCacheGet;


var $d3abe18ea687dfb7$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $c0b23e5f03c2595b$exports(this, key).has(key);
}
$d3abe18ea687dfb7$exports = $d3abe18ea687dfb7$var$mapCacheHas;


var $347643e3dcfcc207$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $c0b23e5f03c2595b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$347643e3dcfcc207$exports = $347643e3dcfcc207$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $df2cd4bc93f21548$exports;
$4902f64a16640324$var$MapCache.prototype["delete"] = $44464964ade29765$exports;
$4902f64a16640324$var$MapCache.prototype.get = $ba80406da5503086$exports;
$4902f64a16640324$var$MapCache.prototype.has = $d3abe18ea687dfb7$exports;
$4902f64a16640324$var$MapCache.prototype.set = $347643e3dcfcc207$exports;
$4902f64a16640324$exports = $4902f64a16640324$var$MapCache;


/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $4902f64a16640324$exports);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $4902f64a16640324$exports;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};

var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + "";
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f16f644742c27c21$var$INFINITY ? "-0" : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? "" : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($0488fde9aa355453$exports(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $7d0c6fd0eb26be0e$exports = {};
var $fb8f823cdc90f511$exports = {};


/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $fb8f823cdc90f511$var$argsTag;
}
$fb8f823cdc90f511$exports = $fb8f823cdc90f511$var$baseIsArguments;



/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $fb8f823cdc90f511$exports(function() {
    return arguments;
}()) ? $fb8f823cdc90f511$exports : function(value) {
    return $61269cf1f3e020be$exports(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, "callee") && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, "callee");
};
$7d0c6fd0eb26be0e$exports = $7d0c6fd0eb26be0e$var$isArguments;



var $d83738e053b5eb08$exports = {};
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d83738e053b5eb08$exports = $d83738e053b5eb08$var$isIndex;


var $15d215b19bcf1187$exports = {};
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
$15d215b19bcf1187$exports = $15d215b19bcf1187$var$isLength;


var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == "string" || $6b5a5095e0934938$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4d60aa8c33155976$var$INFINITY ? "-0" : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4d60aa8c33155976$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $15d215b19bcf1187$exports(length) && $d83738e053b5eb08$exports(key, length) && ($0488fde9aa355453$exports(object) || $7d0c6fd0eb26be0e$exports(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $e21135b6db383fe3$var$has(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $3c47f0745c8ad323$exports);
}
$e21135b6db383fe3$exports = $e21135b6db383fe3$var$has;


const $1d4517ced724be00$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $1d4517ced724be00$export$2e2bcd8739ae039 = $1d4517ced724be00$var$isSchema;


class $7e653e8008789a27$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === "function") {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(options, "is")) throw new TypeError("`is:` is required for `when()` conditions");
        if (!options.then && !options.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is , then: then , otherwise: otherwise  } = options;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === "function") return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
var $7e653e8008789a27$export$2e2bcd8739ae039 = $7e653e8008789a27$var$Condition;



function $245da59127fdc582$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}


function $d2e70d35996a7daf$var$_extends() {
    $d2e70d35996a7daf$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d2e70d35996a7daf$var$_extends.apply(this, arguments);
}
let $d2e70d35996a7daf$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $d2e70d35996a7daf$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = $d2e70d35996a7daf$var$_extends({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($d2e70d35996a7daf$var$strReg, (_, key)=>(0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $245da59127fdc582$export$2e2bcd8739ae039)(errorOrErrors).forEach((err)=>{
            if ($d2e70d35996a7daf$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $d2e70d35996a7daf$export$2e2bcd8739ae039);
    }
}


const $d2d0e6ad55c8832e$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $d2d0e6ad55c8832e$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly , tests: tests , args: args , value: value , errors: errors , sort: sort , path: path  } = options;
    let callback = $d2d0e6ad55c8832e$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $d2e70d35996a7daf$export$2e2bcd8739ae039)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $d2e70d35996a7daf$export$2e2bcd8739ae039)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}


var $17211428bc2045c4$exports = {};
var $96b401257ea00d24$exports = {};
var $31e24313ace94404$exports = {};

var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $5037fd2e597c2a03$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$31e24313ace94404$exports = $31e24313ace94404$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $31e24313ace94404$exports) $31e24313ace94404$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$96b401257ea00d24$exports = $96b401257ea00d24$var$baseAssignValue;


var $34edfba366a0cfa1$exports = {};
var $9f0778b809a8c692$exports = {};
var $e7bbde6376f4568a$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e7bbde6376f4568a$exports = $e7bbde6376f4568a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $e7bbde6376f4568a$exports();
$9f0778b809a8c692$exports = $9f0778b809a8c692$var$baseFor;


var $08f0eaf3fbcb2fde$exports = {};
var $64568844439edb7f$exports = {};
var $b14d62a510ae7f2d$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$b14d62a510ae7f2d$exports = $b14d62a510ae7f2d$var$baseTimes;





var $f504n = parcelRequire("f504n");

var $156c3727697ab085$exports = {};
var $9d076681a0e29d68$exports = {};



/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = "[object Arguments]", $9d076681a0e29d68$var$arrayTag = "[object Array]", $9d076681a0e29d68$var$boolTag = "[object Boolean]", $9d076681a0e29d68$var$dateTag = "[object Date]", $9d076681a0e29d68$var$errorTag = "[object Error]", $9d076681a0e29d68$var$funcTag = "[object Function]", $9d076681a0e29d68$var$mapTag = "[object Map]", $9d076681a0e29d68$var$numberTag = "[object Number]", $9d076681a0e29d68$var$objectTag = "[object Object]", $9d076681a0e29d68$var$regexpTag = "[object RegExp]", $9d076681a0e29d68$var$setTag = "[object Set]", $9d076681a0e29d68$var$stringTag = "[object String]", $9d076681a0e29d68$var$weakMapTag = "[object WeakMap]";
var $9d076681a0e29d68$var$arrayBufferTag = "[object ArrayBuffer]", $9d076681a0e29d68$var$dataViewTag = "[object DataView]", $9d076681a0e29d68$var$float32Tag = "[object Float32Array]", $9d076681a0e29d68$var$float64Tag = "[object Float64Array]", $9d076681a0e29d68$var$int8Tag = "[object Int8Array]", $9d076681a0e29d68$var$int16Tag = "[object Int16Array]", $9d076681a0e29d68$var$int32Tag = "[object Int32Array]", $9d076681a0e29d68$var$uint8Tag = "[object Uint8Array]", $9d076681a0e29d68$var$uint8ClampedTag = "[object Uint8ClampedArray]", $9d076681a0e29d68$var$uint16Tag = "[object Uint16Array]", $9d076681a0e29d68$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $61269cf1f3e020be$exports(value) && $15d215b19bcf1187$exports(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$a7f8a2555793d7d3$exports(value)];
}
$9d076681a0e29d68$exports = $9d076681a0e29d68$var$baseIsTypedArray;


var $692cb5474f422969$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$692cb5474f422969$exports = $692cb5474f422969$var$baseUnary;



var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $692cb5474f422969$exports($156c3727697ab085$var$nodeIsTypedArray) : $9d076681a0e29d68$exports;
$156c3727697ab085$exports = $156c3727697ab085$var$isTypedArray;


/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $0488fde9aa355453$exports(value), isArg = !isArr && $7d0c6fd0eb26be0e$exports(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $156c3727697ab085$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $b14d62a510ae7f2d$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $d83738e053b5eb08$exports(key, length)))) result.push(key);
    return result;
}
$64568844439edb7f$exports = $64568844439edb7f$var$arrayLikeKeys;


var $e811d2e210fb58cc$exports = {};
var $292432068be14a79$exports = {};
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
$292432068be14a79$exports = $292432068be14a79$var$isPrototype;


var $0b26005314403d97$exports = {};
var $ff813e49bf3cca3d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ff813e49bf3cca3d$exports = $ff813e49bf3cca3d$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $ff813e49bf3cca3d$exports(Object.keys, Object);
$0b26005314403d97$exports = $0b26005314403d97$var$nativeKeys;


/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$292432068be14a79$exports(object)) return $0b26005314403d97$exports(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$e811d2e210fb58cc$exports = $e811d2e210fb58cc$var$baseKeys;


var $ac2c42592aa05543$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $15d215b19bcf1187$exports(value.length) && !$004783abbde551e4$exports(value);
}
$ac2c42592aa05543$exports = $ac2c42592aa05543$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $ac2c42592aa05543$exports(object) ? $64568844439edb7f$exports(object) : $e811d2e210fb58cc$exports(object);
}
$08f0eaf3fbcb2fde$exports = $08f0eaf3fbcb2fde$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $9f0778b809a8c692$exports(object, iteratee, $08f0eaf3fbcb2fde$exports);
}
$34edfba366a0cfa1$exports = $34edfba366a0cfa1$var$baseForOwn;


var $5aba4f6d9f8304a3$exports = {};
var $e780807e2b795134$exports = {};
var $ec073f38db6e7d54$exports = {};
var $bbb2d98cae25b61a$exports = {};

var $e8ee1d354807980a$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $dd14efc87ba1cd5b$exports;
    this.size = 0;
}
$e8ee1d354807980a$exports = $e8ee1d354807980a$var$stackClear;


var $b2ddb9d63293f3a5$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$b2ddb9d63293f3a5$exports = $b2ddb9d63293f3a5$var$stackDelete;


var $80d0940a423a17dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$80d0940a423a17dc$exports = $80d0940a423a17dc$var$stackGet;


var $010f38d5d914cfa2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
$010f38d5d914cfa2$exports = $010f38d5d914cfa2$var$stackHas;


var $9280d00f89f25fa9$exports = {};



/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $dd14efc87ba1cd5b$exports) {
        var pairs = data.__data__;
        if (!$19b02faa57603249$exports || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4902f64a16640324$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9280d00f89f25fa9$exports = $9280d00f89f25fa9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $dd14efc87ba1cd5b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $e8ee1d354807980a$exports;
$bbb2d98cae25b61a$var$Stack.prototype["delete"] = $b2ddb9d63293f3a5$exports;
$bbb2d98cae25b61a$var$Stack.prototype.get = $80d0940a423a17dc$exports;
$bbb2d98cae25b61a$var$Stack.prototype.has = $010f38d5d914cfa2$exports;
$bbb2d98cae25b61a$var$Stack.prototype.set = $9280d00f89f25fa9$exports;
$bbb2d98cae25b61a$exports = $bbb2d98cae25b61a$var$Stack;


var $769812b29c18141e$exports = {};
var $567f2dd161ebd4f6$exports = {};

var $1081bd3a2e361911$exports = {};
var $a29ccdc0f60e279e$exports = {};

var $dda8f7b6b589544e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
$dda8f7b6b589544e$exports = $dda8f7b6b589544e$var$setCacheAdd;


var $66732c92c350622c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$66732c92c350622c$exports = $66732c92c350622c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4902f64a16640324$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $dda8f7b6b589544e$exports;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $66732c92c350622c$exports;
$a29ccdc0f60e279e$exports = $a29ccdc0f60e279e$var$SetCache;


var $aae24ad60cc3cfcb$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$aae24ad60cc3cfcb$exports = $aae24ad60cc3cfcb$var$arraySome;


var $1b44096ad4b9e2d5$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
$1b44096ad4b9e2d5$exports = $1b44096ad4b9e2d5$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $a29ccdc0f60e279e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$aae24ad60cc3cfcb$exports(other, function(othValue, othIndex) {
                if (!$1b44096ad4b9e2d5$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$1081bd3a2e361911$exports = $1081bd3a2e361911$var$equalArrays;


var $baf52b9e146f3da7$exports = {};

var $facf83d1449a27b8$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
$facf83d1449a27b8$exports = $facf83d1449a27b8$var$Uint8Array;




var $91d4444cbb077e0c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$91d4444cbb077e0c$exports = $91d4444cbb077e0c$var$mapToArray;


var $11f509f8f53d8c36$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11f509f8f53d8c36$exports = $11f509f8f53d8c36$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = "[object Boolean]", $baf52b9e146f3da7$var$dateTag = "[object Date]", $baf52b9e146f3da7$var$errorTag = "[object Error]", $baf52b9e146f3da7$var$mapTag = "[object Map]", $baf52b9e146f3da7$var$numberTag = "[object Number]", $baf52b9e146f3da7$var$regexpTag = "[object RegExp]", $baf52b9e146f3da7$var$setTag = "[object Set]", $baf52b9e146f3da7$var$stringTag = "[object String]", $baf52b9e146f3da7$var$symbolTag = "[object Symbol]";
var $baf52b9e146f3da7$var$arrayBufferTag = "[object ArrayBuffer]", $baf52b9e146f3da7$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $facf83d1449a27b8$exports(object), new $facf83d1449a27b8$exports(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $50557587dab070a0$exports(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $91d4444cbb077e0c$exports;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11f509f8f53d8c36$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1081bd3a2e361911$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
$baf52b9e146f3da7$exports = $baf52b9e146f3da7$var$equalByTag;


var $ac8a81cbae0357e8$exports = {};
var $7958eecccfe4cef6$exports = {};
var $9144d49da7a47a72$exports = {};
var $cc77dbb7c08db6a8$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$cc77dbb7c08db6a8$exports = $cc77dbb7c08db6a8$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0488fde9aa355453$exports(object) ? result : $cc77dbb7c08db6a8$exports(result, symbolsFunc(object));
}
$9144d49da7a47a72$exports = $9144d49da7a47a72$var$baseGetAllKeys;


var $51326a29f571e7cd$exports = {};
var $6549fed720324048$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$6549fed720324048$exports = $6549fed720324048$var$arrayFilter;


var $8fc9f7df9b0c06bb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
$8fc9f7df9b0c06bb$exports = $8fc9f7df9b0c06bb$var$stubArray;


/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $8fc9f7df9b0c06bb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $6549fed720324048$exports($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
$51326a29f571e7cd$exports = $51326a29f571e7cd$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $9144d49da7a47a72$exports(object, $08f0eaf3fbcb2fde$exports, $51326a29f571e7cd$exports);
}
$7958eecccfe4cef6$exports = $7958eecccfe4cef6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $7958eecccfe4cef6$exports(object), objLength = objProps.length, othProps = $7958eecccfe4cef6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$ac8a81cbae0357e8$exports = $ac8a81cbae0357e8$var$equalObjects;


var $474f685f496bfe31$exports = {};
var $41ce0ff3b38ee753$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $5037fd2e597c2a03$exports($23YZo, "DataView");
$41ce0ff3b38ee753$exports = $41ce0ff3b38ee753$var$DataView;



var $b0226bdea11cb834$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $5037fd2e597c2a03$exports($23YZo, "Promise");
$b0226bdea11cb834$exports = $b0226bdea11cb834$var$Promise;


var $05f44e958da968eb$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $5037fd2e597c2a03$exports($23YZo, "Set");
$05f44e958da968eb$exports = $05f44e958da968eb$var$Set;


var $aedce50092a1e6a6$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $5037fd2e597c2a03$exports($23YZo, "WeakMap");
$aedce50092a1e6a6$exports = $aedce50092a1e6a6$var$WeakMap;




/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = "[object Map]", $474f685f496bfe31$var$objectTag = "[object Object]", $474f685f496bfe31$var$promiseTag = "[object Promise]", $474f685f496bfe31$var$setTag = "[object Set]", $474f685f496bfe31$var$weakMapTag = "[object WeakMap]";
var $474f685f496bfe31$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $9c6b3ec69362487e$exports($41ce0ff3b38ee753$exports), $474f685f496bfe31$var$mapCtorString = $9c6b3ec69362487e$exports($19b02faa57603249$exports), $474f685f496bfe31$var$promiseCtorString = $9c6b3ec69362487e$exports($b0226bdea11cb834$exports), $474f685f496bfe31$var$setCtorString = $9c6b3ec69362487e$exports($05f44e958da968eb$exports), $474f685f496bfe31$var$weakMapCtorString = $9c6b3ec69362487e$exports($aedce50092a1e6a6$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $a7f8a2555793d7d3$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($41ce0ff3b38ee753$exports && $474f685f496bfe31$var$getTag(new $41ce0ff3b38ee753$exports(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $19b02faa57603249$exports && $474f685f496bfe31$var$getTag(new $19b02faa57603249$exports) != $474f685f496bfe31$var$mapTag || $b0226bdea11cb834$exports && $474f685f496bfe31$var$getTag($b0226bdea11cb834$exports.resolve()) != $474f685f496bfe31$var$promiseTag || $05f44e958da968eb$exports && $474f685f496bfe31$var$getTag(new $05f44e958da968eb$exports) != $474f685f496bfe31$var$setTag || $aedce50092a1e6a6$exports && $474f685f496bfe31$var$getTag(new $aedce50092a1e6a6$exports) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $a7f8a2555793d7d3$exports(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9c6b3ec69362487e$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
$474f685f496bfe31$exports = $474f685f496bfe31$var$getTag;




var $f504n = parcelRequire("f504n");

/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = "[object Arguments]", $567f2dd161ebd4f6$var$arrayTag = "[object Array]", $567f2dd161ebd4f6$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0488fde9aa355453$exports(object), othIsArr = $0488fde9aa355453$exports(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bbb2d98cae25b61a$exports);
        return objIsArr || $156c3727697ab085$exports(object) ? $1081bd3a2e361911$exports(object, other, bitmask, customizer, equalFunc, stack) : $baf52b9e146f3da7$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bbb2d98cae25b61a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bbb2d98cae25b61a$exports);
    return $ac8a81cbae0357e8$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$567f2dd161ebd4f6$exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$61269cf1f3e020be$exports(value) && !$61269cf1f3e020be$exports(other)) return value !== value && other !== other;
    return $567f2dd161ebd4f6$exports(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
$769812b29c18141e$exports = $769812b29c18141e$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bbb2d98cae25b61a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $769812b29c18141e$exports(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$ec073f38db6e7d54$exports = $ec073f38db6e7d54$var$baseIsMatch;


var $6b4f84f6be7f825c$exports = {};
var $0ff8edf4f90a7955$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$f9ff2e983beb6b86$exports(value);
}
$0ff8edf4f90a7955$exports = $0ff8edf4f90a7955$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $08f0eaf3fbcb2fde$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $0ff8edf4f90a7955$exports(value)
        ];
    }
    return result;
}
$6b4f84f6be7f825c$exports = $6b4f84f6be7f825c$var$getMatchData;


var $1f9d5e891556ddb9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1f9d5e891556ddb9$exports = $1f9d5e891556ddb9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $6b4f84f6be7f825c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1f9d5e891556ddb9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $ec073f38db6e7d54$exports(object, source, matchData);
    };
}
$e780807e2b795134$exports = $e780807e2b795134$var$baseMatches;


var $d5fe8a98fe4800eb$exports = {};

var $d299ac421c05c135$exports = {};
var $fd2d90f592c63519$exports = {};


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4d60aa8c33155976$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fd2d90f592c63519$exports = $fd2d90f592c63519$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fd2d90f592c63519$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d299ac421c05c135$exports = $d299ac421c05c135$var$get;


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($03e9beb856e9b4cd$exports(path) && $0ff8edf4f90a7955$exports(srcValue)) return $1f9d5e891556ddb9$exports($4d60aa8c33155976$exports(path), srcValue);
    return function(object) {
        var objValue = $d299ac421c05c135$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $221e04e57e35dd04$exports(object, path) : $769812b29c18141e$exports(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
$d5fe8a98fe4800eb$exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;


var $37dff9aa04444f9c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
$37dff9aa04444f9c$exports = $37dff9aa04444f9c$var$identity;



var $87123e72266aa58c$exports = {};
var $d45a621b4548f6bb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$d45a621b4548f6bb$exports = $d45a621b4548f6bb$var$baseProperty;


var $e029d02f9dd10368$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $fd2d90f592c63519$exports(object, path);
    };
}
$e029d02f9dd10368$exports = $e029d02f9dd10368$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $03e9beb856e9b4cd$exports(path) ? $d45a621b4548f6bb$exports($4d60aa8c33155976$exports(path)) : $e029d02f9dd10368$exports(path);
}
$87123e72266aa58c$exports = $87123e72266aa58c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $37dff9aa04444f9c$exports;
    if (typeof value == "object") return $0488fde9aa355453$exports(value) ? $d5fe8a98fe4800eb$exports(value[0], value[1]) : $e780807e2b795134$exports(value);
    return $87123e72266aa58c$exports(value);
}
$5aba4f6d9f8304a3$exports = $5aba4f6d9f8304a3$var$baseIteratee;


/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $17211428bc2045c4$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $5aba4f6d9f8304a3$exports(iteratee, 3);
    $34edfba366a0cfa1$exports(object, function(value, key, object) {
        $96b401257ea00d24$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$17211428bc2045c4$exports = $17211428bc2045c4$var$mapValues;



var $0a34a21cae127bf5$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $0a34a21cae127bf5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$0a34a21cae127bf5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$0a34a21cae127bf5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$0a34a21cae127bf5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $0a34a21cae127bf5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $0a34a21cae127bf5$var$DIGIT_REGEX = /^\d+$/, $0a34a21cae127bf5$var$LEAD_DIGIT_REGEX = /^\d/, $0a34a21cae127bf5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $0a34a21cae127bf5$var$MAX_CACHE_SIZE = 512;
var $0a34a21cae127bf5$var$pathCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$setCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$getCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE);
var $0a34a21cae127bf5$var$config;
$0a34a21cae127bf5$exports = {
    Cache: $0a34a21cae127bf5$var$Cache,
    split: $0a34a21cae127bf5$var$split,
    normalizePath: $0a34a21cae127bf5$var$normalizePath,
    setter: function(path) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$setCache.get(path) || $0a34a21cae127bf5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$getCache.get(path) || $0a34a21cae127bf5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($0a34a21cae127bf5$var$isQuoted(part) || $0a34a21cae127bf5$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $0a34a21cae127bf5$var$forEach(Array.isArray(path) ? path : $0a34a21cae127bf5$var$split(path), cb, thisArg);
    }
};
function $0a34a21cae127bf5$var$normalizePath(path) {
    return $0a34a21cae127bf5$var$pathCache.get(path) || $0a34a21cae127bf5$var$pathCache.set(path, $0a34a21cae127bf5$var$split(path).map(function(part) {
        return part.replace($0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $0a34a21cae127bf5$var$split(path) {
    return path.match($0a34a21cae127bf5$var$SPLIT_REGEX) || [
        ""
    ];
}
function $0a34a21cae127bf5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($0a34a21cae127bf5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $0a34a21cae127bf5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $0a34a21cae127bf5$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $0a34a21cae127bf5$var$hasLeadingNumber(part) {
    return part.match($0a34a21cae127bf5$var$LEAD_DIGIT_REGEX) && !part.match($0a34a21cae127bf5$var$DIGIT_REGEX);
}
function $0a34a21cae127bf5$var$hasSpecialChars(part) {
    return $0a34a21cae127bf5$var$SPEC_CHAR_REGEX.test(part);
}
function $0a34a21cae127bf5$var$shouldBeQuoted(part) {
    return !$0a34a21cae127bf5$var$isQuoted(part) && ($0a34a21cae127bf5$var$hasLeadingNumber(part) || $0a34a21cae127bf5$var$hasSpecialChars(part));
}


const $f5cdfa956e941194$var$prefixes = {
    context: "$",
    value: "."
};
function $f5cdfa956e941194$export$185802fd694ee1f5(key, options) {
    return new $f5cdfa956e941194$export$2e2bcd8739ae039(key, options);
}
class $f5cdfa956e941194$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $f5cdfa956e941194$var$prefixes.context;
        this.isValue = this.key[0] === $f5cdfa956e941194$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $f5cdfa956e941194$var$prefixes.context : this.isValue ? $f5cdfa956e941194$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $0a34a21cae127bf5$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$f5cdfa956e941194$export$2e2bcd8739ae039.prototype.__isYupRef = true;


function $7c576e9ad8044c54$var$_extends() {
    $7c576e9ad8044c54$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7c576e9ad8044c54$var$_extends.apply(this, arguments);
}
function $7c576e9ad8044c54$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7c576e9ad8044c54$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value , path: path = "" , label: label , options: options , originalValue: originalValue , sync: sync  } = _ref, rest = $7c576e9ad8044c54$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name , test: test , params: params , message: message  } = config;
        let { parent: parent , context: context  } = options;
        function resolve(item) {
            return (0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($17211428bc2045c4$exports)))($7c576e9ad8044c54$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $d2e70d35996a7daf$export$2e2bcd8739ae039)((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $7c576e9ad8044c54$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === "function") throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}





let $5b552ca0a6c1ed5f$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $5b552ca0a6c1ed5f$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $0a34a21cae127bf5$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $5b552ca0a6c1ed5f$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $5b552ca0a6c1ed5f$var$reach = (obj, path, value, context)=>$5b552ca0a6c1ed5f$export$c52e5867d5879e24(obj, path, value, context).schema;
var $5b552ca0a6c1ed5f$export$2e2bcd8739ae039 = $5b552ca0a6c1ed5f$var$reach;




class $3f307508f67966f1$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $3f307508f67966f1$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}



function $bcee4fc8dbde13e1$var$_extends() {
    $bcee4fc8dbde13e1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bcee4fc8dbde13e1$var$_extends.apply(this, arguments);
}
class $bcee4fc8dbde13e1$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $3f307508f67966f1$export$2e2bcd8739ae039)();
        this._blacklist = new (0, $3f307508f67966f1$export$2e2bcd8739ae039)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).notType);
        });
        this.type = (options == null ? void 0 : options.type) || "mixed";
        this.spec = $bcee4fc8dbde13e1$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: "optional"
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $bcee4fc8dbde13e1$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $c20a5baa3b2b3be7$export$2e2bcd8739ae039)($bcee4fc8dbde13e1$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $bcee4fc8dbde13e1$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($bcee4fc8dbde13e1$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(value);
            let formattedResult = (0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync , path: path , from: from = [] , originalValue: originalValue = _value , strict: strict = this.spec.strict , abortEarly: abortEarly = this.spec.abortEarly  } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $bcee4fc8dbde13e1$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($bcee4fc8dbde13e1$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === "function" ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($bcee4fc8dbde13e1$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $bcee4fc8dbde13e1$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this) : (0, $c20a5baa3b2b3be7$export$2e2bcd8739ae039)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).defined) {
        return this.test({
            message: message,
            name: "defined",
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).required) {
        return this.clone({
            presence: "required"
        }).withMutation((s)=>s.test({
                message: message,
                name: "required",
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: "optional"
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== "required");
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = (0, $245da59127fdc582$export$2e2bcd8739ae039)(keys).map((key)=>new (0, $f5cdfa956e941194$export$2e2bcd8739ae039)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $7e653e8008789a27$export$2e2bcd8739ae039)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)({
            message: message,
            name: "typeError",
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)({
            message: message,
            name: "oneOf",
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $3ea8894c2d1a8ff8$export$9b30b6294c1449a8).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $7c576e9ad8044c54$export$2e2bcd8739ae039)({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label , meta: meta  } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent , parentPath: parentPath , schema: schema  } = (0, $5b552ca0a6c1ed5f$export$c52e5867d5879e24)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $bcee4fc8dbde13e1$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[alias] = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype[alias] = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.notOneOf;
$bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.optional = $bcee4fc8dbde13e1$export$2e2bcd8739ae039.prototype.notRequired;


const $9baedbe56e25b51a$var$Mixed = (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039);
var $9baedbe56e25b51a$export$2e2bcd8739ae039 = $9baedbe56e25b51a$var$Mixed;
function $9baedbe56e25b51a$export$185802fd694ee1f5() {
    return new $9baedbe56e25b51a$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$9baedbe56e25b51a$export$185802fd694ee1f5.prototype = $9baedbe56e25b51a$var$Mixed.prototype;




const $55daa1cd95624d91$var$isAbsent = (value)=>value == null;
var $55daa1cd95624d91$export$2e2bcd8739ae039 = $55daa1cd95624d91$var$isAbsent;


function $0237b22d97657ad7$export$185802fd694ee1f5() {
    return new $0237b22d97657ad7$export$2e2bcd8739ae039();
}
class $0237b22d97657ad7$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "boolean"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === "boolean";
    }
    isTrue(message = (0, $3ea8894c2d1a8ff8$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $3ea8894c2d1a8ff8$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === false;
            }
        });
    }
}
$0237b22d97657ad7$export$185802fd694ee1f5.prototype = $0237b22d97657ad7$export$2e2bcd8739ae039.prototype;





let $bcc252d93ab3046c$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $bcc252d93ab3046c$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $bcc252d93ab3046c$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $bcc252d93ab3046c$var$isTrimmed = (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === value.trim();
let $bcc252d93ab3046c$var$objStringTag = ({}).toString();
function $bcc252d93ab3046c$export$185802fd694ee1f5() {
    return new $bcc252d93ab3046c$export$2e2bcd8739ae039();
}
class $bcc252d93ab3046c$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "string"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $bcc252d93ab3046c$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === "string";
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false , message: message , name: name  } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).email) {
        return this.matches($bcc252d93ab3046c$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).url) {
        return this.matches($bcc252d93ab3046c$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).uuid) {
        return this.matches($bcc252d93ab3046c$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $bcc252d93ab3046c$var$isTrimmed
        });
    }
    lowercase(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).lowercase) {
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $3ea8894c2d1a8ff8$export$22b082955e083ec3).uppercase) {
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            test: (value)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value === value.toUpperCase()
        });
    }
}
$bcc252d93ab3046c$export$185802fd694ee1f5.prototype = $bcc252d93ab3046c$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //





let $425f4614c2bd74f2$var$isNaN = (value)=>value != +value;
function $425f4614c2bd74f2$export$185802fd694ee1f5() {
    return new $425f4614c2bd74f2$export$2e2bcd8739ae039();
}
class $425f4614c2bd74f2$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "number"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === "number" && !$425f4614c2bd74f2$var$isNaN(value);
    }
    min(min, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $3ea8894c2d1a8ff8$export$98e628dec113755e).integer) {
        return this.test({
            name: "integer",
            message: message,
            test: (val)=>(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round"; // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!(0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) ? Math[method](value) : value);
    }
}
$425f4614c2bd74f2$export$185802fd694ee1f5.prototype = $425f4614c2bd74f2$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //


// @ts-ignore
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $7b96554ad88dbbc3$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $7b96554ad88dbbc3$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $7b96554ad88dbbc3$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === "") && (struct[9] === undefined || struct[9] === "")) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== "Z" && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === "+") minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}






let $647598aeb0c659d9$var$invalidDate = new Date("");
let $647598aeb0c659d9$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $647598aeb0c659d9$export$185802fd694ee1f5() {
    return new $647598aeb0c659d9$export$2e2bcd8739ae039();
}
class $647598aeb0c659d9$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: "date"
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $7b96554ad88dbbc3$export$2e2bcd8739ae039)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $647598aeb0c659d9$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $647598aeb0c659d9$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $3ea8894c2d1a8ff8$export$324d90190a8b822a).min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $3ea8894c2d1a8ff8$export$324d90190a8b822a).max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$647598aeb0c659d9$export$2e2bcd8739ae039.INVALID_DATE = $647598aeb0c659d9$var$invalidDate;
$647598aeb0c659d9$export$185802fd694ee1f5.prototype = $647598aeb0c659d9$export$2e2bcd8739ae039.prototype;
$647598aeb0c659d9$export$185802fd694ee1f5.INVALID_DATE = $647598aeb0c659d9$var$invalidDate;



var $4f0248df72a92950$exports = {};
var $0b2d21aee1d97729$exports = {};
var $1389b3710f5da9e8$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$1389b3710f5da9e8$exports = $1389b3710f5da9e8$var$arrayReduce;


var $ed80fa8833e2b532$exports = {};
var $3384256242a1b577$exports = {};
var $dcb2a7eb44d37cba$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dcb2a7eb44d37cba$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$dcb2a7eb44d37cba$exports = $dcb2a7eb44d37cba$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $3384256242a1b577$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3384256242a1b577$var$deburrLetter = $dcb2a7eb44d37cba$exports($3384256242a1b577$var$deburredLetters);
$3384256242a1b577$exports = $3384256242a1b577$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ed80fa8833e2b532$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ed80fa8833e2b532$var$rsComboMarksRange = "\\u0300-\\u036f", $ed80fa8833e2b532$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $ed80fa8833e2b532$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $ed80fa8833e2b532$var$rsComboRange = $ed80fa8833e2b532$var$rsComboMarksRange + $ed80fa8833e2b532$var$reComboHalfMarksRange + $ed80fa8833e2b532$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ed80fa8833e2b532$var$rsCombo = "[" + $ed80fa8833e2b532$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ed80fa8833e2b532$var$reComboMark = RegExp($ed80fa8833e2b532$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ed80fa8833e2b532$var$deburr(string) {
    string = $f5d9385a9cc7e413$exports(string);
    return string && string.replace($ed80fa8833e2b532$var$reLatin, $3384256242a1b577$exports).replace($ed80fa8833e2b532$var$reComboMark, "");
}
$ed80fa8833e2b532$exports = $ed80fa8833e2b532$var$deburr;


var $12f2ccb7e11b3895$exports = {};
var $7e165cbd28a9af51$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $7e165cbd28a9af51$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7e165cbd28a9af51$var$asciiWords(string) {
    return string.match($7e165cbd28a9af51$var$reAsciiWord) || [];
}
$7e165cbd28a9af51$exports = $7e165cbd28a9af51$var$asciiWords;


var $8688e0b23f5a081b$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $8688e0b23f5a081b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $8688e0b23f5a081b$var$hasUnicodeWord(string) {
    return $8688e0b23f5a081b$var$reHasUnicodeWord.test(string);
}
$8688e0b23f5a081b$exports = $8688e0b23f5a081b$var$hasUnicodeWord;



var $325a565efdffbc96$exports = {};
/** Used to compose unicode character classes. */ var $325a565efdffbc96$var$rsAstralRange = "\ud800-\udfff", $325a565efdffbc96$var$rsComboMarksRange = "\\u0300-\\u036f", $325a565efdffbc96$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $325a565efdffbc96$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $325a565efdffbc96$var$rsComboRange = $325a565efdffbc96$var$rsComboMarksRange + $325a565efdffbc96$var$reComboHalfMarksRange + $325a565efdffbc96$var$rsComboSymbolsRange, $325a565efdffbc96$var$rsDingbatRange = "\\u2700-\\u27bf", $325a565efdffbc96$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $325a565efdffbc96$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $325a565efdffbc96$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $325a565efdffbc96$var$rsPunctuationRange = "\\u2000-\\u206f", $325a565efdffbc96$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $325a565efdffbc96$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $325a565efdffbc96$var$rsVarRange = "\\ufe0e\\ufe0f", $325a565efdffbc96$var$rsBreakRange = $325a565efdffbc96$var$rsMathOpRange + $325a565efdffbc96$var$rsNonCharRange + $325a565efdffbc96$var$rsPunctuationRange + $325a565efdffbc96$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $325a565efdffbc96$var$rsApos = "['’]", $325a565efdffbc96$var$rsBreak = "[" + $325a565efdffbc96$var$rsBreakRange + "]", $325a565efdffbc96$var$rsCombo = "[" + $325a565efdffbc96$var$rsComboRange + "]", $325a565efdffbc96$var$rsDigits = "\\d+", $325a565efdffbc96$var$rsDingbat = "[" + $325a565efdffbc96$var$rsDingbatRange + "]", $325a565efdffbc96$var$rsLower = "[" + $325a565efdffbc96$var$rsLowerRange + "]", $325a565efdffbc96$var$rsMisc = "[^" + $325a565efdffbc96$var$rsAstralRange + $325a565efdffbc96$var$rsBreakRange + $325a565efdffbc96$var$rsDigits + $325a565efdffbc96$var$rsDingbatRange + $325a565efdffbc96$var$rsLowerRange + $325a565efdffbc96$var$rsUpperRange + "]", $325a565efdffbc96$var$rsFitz = "\ud83c[\udffb-\udfff]", $325a565efdffbc96$var$rsModifier = "(?:" + $325a565efdffbc96$var$rsCombo + "|" + $325a565efdffbc96$var$rsFitz + ")", $325a565efdffbc96$var$rsNonAstral = "[^" + $325a565efdffbc96$var$rsAstralRange + "]", $325a565efdffbc96$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $325a565efdffbc96$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $325a565efdffbc96$var$rsUpper = "[" + $325a565efdffbc96$var$rsUpperRange + "]", $325a565efdffbc96$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $325a565efdffbc96$var$rsMiscLower = "(?:" + $325a565efdffbc96$var$rsLower + "|" + $325a565efdffbc96$var$rsMisc + ")", $325a565efdffbc96$var$rsMiscUpper = "(?:" + $325a565efdffbc96$var$rsUpper + "|" + $325a565efdffbc96$var$rsMisc + ")", $325a565efdffbc96$var$rsOptContrLower = "(?:" + $325a565efdffbc96$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $325a565efdffbc96$var$rsOptContrUpper = "(?:" + $325a565efdffbc96$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $325a565efdffbc96$var$reOptMod = $325a565efdffbc96$var$rsModifier + "?", $325a565efdffbc96$var$rsOptVar = "[" + $325a565efdffbc96$var$rsVarRange + "]?", $325a565efdffbc96$var$rsOptJoin = "(?:" + $325a565efdffbc96$var$rsZWJ + "(?:" + [
    $325a565efdffbc96$var$rsNonAstral,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join("|") + ")" + $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + ")*", $325a565efdffbc96$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $325a565efdffbc96$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $325a565efdffbc96$var$rsSeq = $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + $325a565efdffbc96$var$rsOptJoin, $325a565efdffbc96$var$rsEmoji = "(?:" + [
    $325a565efdffbc96$var$rsDingbat,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join("|") + ")" + $325a565efdffbc96$var$rsSeq;
/** Used to match complex or compound words. */ var $325a565efdffbc96$var$reUnicodeWord = RegExp([
    $325a565efdffbc96$var$rsUpper + "?" + $325a565efdffbc96$var$rsLower + "+" + $325a565efdffbc96$var$rsOptContrLower + "(?=" + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper,
        "$"
    ].join("|") + ")",
    $325a565efdffbc96$var$rsMiscUpper + "+" + $325a565efdffbc96$var$rsOptContrUpper + "(?=" + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper + $325a565efdffbc96$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $325a565efdffbc96$var$rsUpper + "?" + $325a565efdffbc96$var$rsMiscLower + "+" + $325a565efdffbc96$var$rsOptContrLower,
    $325a565efdffbc96$var$rsUpper + "+" + $325a565efdffbc96$var$rsOptContrUpper,
    $325a565efdffbc96$var$rsOrdUpper,
    $325a565efdffbc96$var$rsOrdLower,
    $325a565efdffbc96$var$rsDigits,
    $325a565efdffbc96$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $325a565efdffbc96$var$unicodeWords(string) {
    return string.match($325a565efdffbc96$var$reUnicodeWord) || [];
}
$325a565efdffbc96$exports = $325a565efdffbc96$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $12f2ccb7e11b3895$var$words(string, pattern, guard) {
    string = $f5d9385a9cc7e413$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $8688e0b23f5a081b$exports(string) ? $325a565efdffbc96$exports(string) : $7e165cbd28a9af51$exports(string);
    return string.match(pattern) || [];
}
$12f2ccb7e11b3895$exports = $12f2ccb7e11b3895$var$words;


/** Used to compose unicode capture groups. */ var $0b2d21aee1d97729$var$rsApos = "['’]";
/** Used to match apostrophes. */ var $0b2d21aee1d97729$var$reApos = RegExp($0b2d21aee1d97729$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $0b2d21aee1d97729$var$createCompounder(callback) {
    return function(string) {
        return $1389b3710f5da9e8$exports($12f2ccb7e11b3895$exports($ed80fa8833e2b532$exports(string).replace($0b2d21aee1d97729$var$reApos, "")), callback, "");
    };
}
$0b2d21aee1d97729$exports = $0b2d21aee1d97729$var$createCompounder;


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $4f0248df72a92950$var$snakeCase = $0b2d21aee1d97729$exports(function(result, word, index) {
    return result + (index ? "_" : "") + word.toLowerCase();
});
$4f0248df72a92950$exports = $4f0248df72a92950$var$snakeCase;


var $d57e6f3349076887$exports = {};
var $49f1f8db3e260fbf$exports = {};

var $da6130e1e4702e32$exports = {};
var $0d9811a54a2f955a$exports = {};
var $cfe77c1a7b7c7d6e$exports = {};
var $109fb88fe59de104$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$109fb88fe59de104$exports = $109fb88fe59de104$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cfe77c1a7b7c7d6e$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $109fb88fe59de104$exports(array, start, end);
}
$cfe77c1a7b7c7d6e$exports = $cfe77c1a7b7c7d6e$var$castSlice;


var $00fdf7eab00be2e7$exports = {};
/** Used to compose unicode character classes. */ var $00fdf7eab00be2e7$var$rsAstralRange = "\ud800-\udfff", $00fdf7eab00be2e7$var$rsComboMarksRange = "\\u0300-\\u036f", $00fdf7eab00be2e7$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $00fdf7eab00be2e7$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $00fdf7eab00be2e7$var$rsComboRange = $00fdf7eab00be2e7$var$rsComboMarksRange + $00fdf7eab00be2e7$var$reComboHalfMarksRange + $00fdf7eab00be2e7$var$rsComboSymbolsRange, $00fdf7eab00be2e7$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $00fdf7eab00be2e7$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $00fdf7eab00be2e7$var$reHasUnicode = RegExp("[" + $00fdf7eab00be2e7$var$rsZWJ + $00fdf7eab00be2e7$var$rsAstralRange + $00fdf7eab00be2e7$var$rsComboRange + $00fdf7eab00be2e7$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $00fdf7eab00be2e7$var$hasUnicode(string) {
    return $00fdf7eab00be2e7$var$reHasUnicode.test(string);
}
$00fdf7eab00be2e7$exports = $00fdf7eab00be2e7$var$hasUnicode;


var $9a986c87d425808c$exports = {};
var $43b96a6d93895c83$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $43b96a6d93895c83$var$asciiToArray(string) {
    return string.split("");
}
$43b96a6d93895c83$exports = $43b96a6d93895c83$var$asciiToArray;



var $c3bf9ebcb1b53b1d$exports = {};
/** Used to compose unicode character classes. */ var $c3bf9ebcb1b53b1d$var$rsAstralRange = "\ud800-\udfff", $c3bf9ebcb1b53b1d$var$rsComboMarksRange = "\\u0300-\\u036f", $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $c3bf9ebcb1b53b1d$var$rsComboRange = $c3bf9ebcb1b53b1d$var$rsComboMarksRange + $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange + $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange, $c3bf9ebcb1b53b1d$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $c3bf9ebcb1b53b1d$var$rsAstral = "[" + $c3bf9ebcb1b53b1d$var$rsAstralRange + "]", $c3bf9ebcb1b53b1d$var$rsCombo = "[" + $c3bf9ebcb1b53b1d$var$rsComboRange + "]", $c3bf9ebcb1b53b1d$var$rsFitz = "\ud83c[\udffb-\udfff]", $c3bf9ebcb1b53b1d$var$rsModifier = "(?:" + $c3bf9ebcb1b53b1d$var$rsCombo + "|" + $c3bf9ebcb1b53b1d$var$rsFitz + ")", $c3bf9ebcb1b53b1d$var$rsNonAstral = "[^" + $c3bf9ebcb1b53b1d$var$rsAstralRange + "]", $c3bf9ebcb1b53b1d$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $c3bf9ebcb1b53b1d$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $c3bf9ebcb1b53b1d$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $c3bf9ebcb1b53b1d$var$reOptMod = $c3bf9ebcb1b53b1d$var$rsModifier + "?", $c3bf9ebcb1b53b1d$var$rsOptVar = "[" + $c3bf9ebcb1b53b1d$var$rsVarRange + "]?", $c3bf9ebcb1b53b1d$var$rsOptJoin = "(?:" + $c3bf9ebcb1b53b1d$var$rsZWJ + "(?:" + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair
].join("|") + ")" + $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + ")*", $c3bf9ebcb1b53b1d$var$rsSeq = $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + $c3bf9ebcb1b53b1d$var$rsOptJoin, $c3bf9ebcb1b53b1d$var$rsSymbol = "(?:" + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral + $c3bf9ebcb1b53b1d$var$rsCombo + "?",
    $c3bf9ebcb1b53b1d$var$rsCombo,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair,
    $c3bf9ebcb1b53b1d$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $c3bf9ebcb1b53b1d$var$reUnicode = RegExp($c3bf9ebcb1b53b1d$var$rsFitz + "(?=" + $c3bf9ebcb1b53b1d$var$rsFitz + ")|" + $c3bf9ebcb1b53b1d$var$rsSymbol + $c3bf9ebcb1b53b1d$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c3bf9ebcb1b53b1d$var$unicodeToArray(string) {
    return string.match($c3bf9ebcb1b53b1d$var$reUnicode) || [];
}
$c3bf9ebcb1b53b1d$exports = $c3bf9ebcb1b53b1d$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9a986c87d425808c$var$stringToArray(string) {
    return $00fdf7eab00be2e7$exports(string) ? $c3bf9ebcb1b53b1d$exports(string) : $43b96a6d93895c83$exports(string);
}
$9a986c87d425808c$exports = $9a986c87d425808c$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $0d9811a54a2f955a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $f5d9385a9cc7e413$exports(string);
        var strSymbols = $00fdf7eab00be2e7$exports(string) ? $9a986c87d425808c$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $cfe77c1a7b7c7d6e$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$0d9811a54a2f955a$exports = $0d9811a54a2f955a$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $da6130e1e4702e32$var$upperFirst = $0d9811a54a2f955a$exports("toUpperCase");
$da6130e1e4702e32$exports = $da6130e1e4702e32$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $49f1f8db3e260fbf$var$capitalize(string) {
    return $da6130e1e4702e32$exports($f5d9385a9cc7e413$exports(string).toLowerCase());
}
$49f1f8db3e260fbf$exports = $49f1f8db3e260fbf$var$capitalize;



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $d57e6f3349076887$var$camelCase = $0b2d21aee1d97729$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $49f1f8db3e260fbf$exports(word) : word);
});
$d57e6f3349076887$exports = $d57e6f3349076887$var$camelCase;


var $3415b394b567e74a$exports = {};



/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $3415b394b567e74a$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $5aba4f6d9f8304a3$exports(iteratee, 3);
    $34edfba366a0cfa1$exports(object, function(value, key, object) {
        $96b401257ea00d24$exports(result, iteratee(value, key, object), value);
    });
    return result;
}
$3415b394b567e74a$exports = $3415b394b567e74a$var$mapKeys;






var $a2cee144eac47a21$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $a2cee144eac47a21$exports = function(edges) {
    return $a2cee144eac47a21$var$toposort($a2cee144eac47a21$var$uniqueNodes(edges), edges);
};
$a2cee144eac47a21$exports.array = $a2cee144eac47a21$var$toposort;
function $a2cee144eac47a21$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $a2cee144eac47a21$var$makeOutgoingEdges(edges), nodesHash = $a2cee144eac47a21$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $a2cee144eac47a21$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $a2cee144eac47a21$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $a2cee144eac47a21$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}





function $ade87c847c1ee6bb$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $0a34a21cae127bf5$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $f5cdfa956e941194$export$2e2bcd8739ae039).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $1d4517ced724be00$export$2e2bcd8739ae039)(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($a2cee144eac47a21$exports))).array(Array.from(nodes), edges).reverse();
}


function $b59a7ce2e5e0a1e4$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $b59a7ce2e5e0a1e4$var$findIndex(keys, a) - $b59a7ce2e5e0a1e4$var$findIndex(keys, b);
    };
}





function $cd7706ce94a8dfd1$var$_extends() {
    $cd7706ce94a8dfd1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd7706ce94a8dfd1$var$_extends.apply(this, arguments);
}
let $cd7706ce94a8dfd1$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $cd7706ce94a8dfd1$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $cd7706ce94a8dfd1$var$defaultSort = (0, $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039)([]);
class $cd7706ce94a8dfd1$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(spec){
        super({
            type: "object"
        });
        this.fields = Object.create(null);
        this._sortErrors = $cd7706ce94a8dfd1$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === "string") try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $cd7706ce94a8dfd1$var$isObject(value) || typeof value === "function";
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $cd7706ce94a8dfd1$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = "spec" in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync , from: from = [] , originalValue: originalValue = _value , abortEarly: abortEarly = this.spec.abortEarly , recursive: recursive = this.spec.recursive  } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$cd7706ce94a8dfd1$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf(".") === -1 ? (opts.path ? `${opts.path}.` : "") + key : `${opts.path || ""}["${key}"]`;
                    let field = this.fields[key];
                    if (field && "validate" in field) {
                        field.validate(value[key], $cd7706ce94a8dfd1$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $cd7706ce94a8dfd1$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) && schemaOrRef instanceof (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = "default" in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ("default" in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $b59a7ce2e5e0a1e4$export$2e2bcd8739ae039)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $ade87c847c1ee6bb$export$2e2bcd8739ae039)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $0a34a21cae127bf5$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($e21135b6db383fe3$exports)))(obj, from)) {
                newObj = $cd7706ce94a8dfd1$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $3ea8894c2d1a8ff8$export$be5493f9613cbbe).noUnknown) {
        if (typeof noAllow === "string") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cd7706ce94a8dfd1$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $3ea8894c2d1a8ff8$export$be5493f9613cbbe).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($3415b394b567e74a$exports)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($d57e6f3349076887$exports))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($4f0248df72a92950$exports))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($4f0248df72a92950$exports)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($17211428bc2045c4$exports)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $cd7706ce94a8dfd1$export$185802fd694ee1f5(spec) {
    return new $cd7706ce94a8dfd1$export$2e2bcd8739ae039(spec);
}
$cd7706ce94a8dfd1$export$185802fd694ee1f5.prototype = $cd7706ce94a8dfd1$export$2e2bcd8739ae039.prototype;









function $e218604b96487b25$var$_extends() {
    $e218604b96487b25$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e218604b96487b25$var$_extends.apply(this, arguments);
}
function $e218604b96487b25$export$185802fd694ee1f5(type) {
    return new $e218604b96487b25$export$2e2bcd8739ae039(type);
}
class $e218604b96487b25$export$2e2bcd8739ae039 extends (0, $bcee4fc8dbde13e1$export$2e2bcd8739ae039) {
    constructor(type){
        super({
            type: "array"
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === "string") try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $e218604b96487b25$var$_extends({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $d2e70d35996a7daf$export$2e2bcd8739ae039).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ""}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $e218604b96487b25$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $d2d0e6ad55c8832e$export$2e2bcd8739ae039)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + (0, $3bcbbcae986c2431$export$2e2bcd8739ae039)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $3ea8894c2d1a8ff8$export$2f23118c22fb2630).length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $3ea8894c2d1a8ff8$export$2f23118c22fb2630).min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $3ea8894c2d1a8ff8$export$2f23118c22fb2630).max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $55daa1cd95624d91$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$e218604b96487b25$export$185802fd694ee1f5.prototype = $e218604b96487b25$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //




function $5a78aa552a6b7bb3$export$185802fd694ee1f5(builder) {
    return new $5a78aa552a6b7bb3$var$Lazy(builder);
}
class $5a78aa552a6b7bb3$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schema)) throw new TypeError("lazy() functions must return a valid schema");
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $5a78aa552a6b7bb3$export$2e2bcd8739ae039 = $5a78aa552a6b7bb3$var$Lazy;






function $eabff3e78de076bd$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $3ea8894c2d1a8ff8$export$2e2bcd8739ae039)[type][method] = custom[type][method];
        });
    });
}



function $920660c8aca77688$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $1d4517ced724be00$export$2e2bcd8739ae039)(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}


const $76e319fbaa62cce6$var$GET_JSON = {
    method: "GET",
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
    }
};
const $76e319fbaa62cce6$var$AMAX_API_URL = "https://amax-emu.com/api";
$920660c8aca77688$export$20be359f745f973c($bcc252d93ab3046c$export$185802fd694ee1f5, "unicusername", function(message) {
    return this.test({
        name: "unicusername",
        exclusive: true,
        message: message || "Username is already taken",
        test: async function(value) {
            const response = await fetch($76e319fbaa62cce6$var$AMAX_API_URL + `/validator/username?value=${value}`, $76e319fbaa62cce6$var$GET_JSON);
            const json = await response.json();
            return json.valid;
        }
    });
});



var $302743bfdc67c75e$var$e = function(i, e, t) {
    if (i && "reportValidity" in i) {
        var f = (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(t, e);
        i.setCustomValidity(f && f.message || ""), i.reportValidity();
    }
}, $302743bfdc67c75e$export$6bd436d70894afff = function(r, i) {
    var t = function(t) {
        var f = i.fields[t];
        f && f.ref && "reportValidity" in f.ref ? $302743bfdc67c75e$var$e(f.ref, t, r) : f.refs && f.refs.forEach(function(i) {
            return $302743bfdc67c75e$var$e(i, t, r);
        });
    };
    for(var f in i.fields)t(f);
}, $302743bfdc67c75e$export$3cfb7e8a4d7a0630 = function(e, f) {
    f.shouldUseNativeValidation && $302743bfdc67c75e$export$6bd436d70894afff(e, f);
    var o = {};
    for(var a in e){
        var n = (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(f.fields, a);
        (0, $0d70f179cf56e662$export$adaa4cf7ef1b65be)(o, a, Object.assign(e[a], {
            ref: n && n.ref
        }));
    }
    return o;
};



var $0df32c3dd3ad0e0c$export$d55832dfcd4989a = function(o, n, a) {
    return void 0 === n && (n = {}), void 0 === a && (a = {}), function(s, i, c) {
        try {
            return Promise.resolve(function(t, r) {
                try {
                    var u = (n.context, Promise.resolve(o["sync" === a.mode ? "validateSync" : "validate"](s, Object.assign({
                        abortEarly: !1
                    }, n, {
                        context: i
                    }))).then(function(t) {
                        return c.shouldUseNativeValidation && (0, $302743bfdc67c75e$export$6bd436d70894afff)({}, c), {
                            values: a.rawValues ? s : t,
                            errors: {}
                        };
                    }));
                } catch (e) {
                    return r(e);
                }
                return u && u.then ? u.then(void 0, r) : u;
            }(0, function(e) {
                if (!e.inner) throw e;
                var o, n;
                return {
                    values: {},
                    errors: (0, $302743bfdc67c75e$export$3cfb7e8a4d7a0630)((o = e, n = !c.shouldUseNativeValidation && "all" === c.criteriaMode, (o.inner || []).reduce(function(e, t) {
                        if (e[t.path] || (e[t.path] = {
                            message: t.message,
                            type: t.type
                        }), n) {
                            var o = e[t.path].types, a = o && o[t.type];
                            e[t.path] = (0, $0d70f179cf56e662$export$b196c2a4f765bd30)(t.path, n, e, t.type, a ? [].concat(a, t.message) : t.message);
                        }
                        return e;
                    }, {})), c)
                };
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    };
};



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");




var $kQaj4 = parcelRequire("kQaj4");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");

var $9GbWv = parcelRequire("9GbWv");


var $f9tk6 = parcelRequire("f9tk6");
var $50480f2bcbf21ff1$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: "center",
            flex: "0 0 auto",
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: "50%",
            overflow: "visible",
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                backgroundColor: "transparent",
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            "$sizeSmall&": {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            "$sizeSmall&": {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: "100%",
            display: "flex",
            alignItems: "inherit",
            justifyContent: "inherit"
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $50480f2bcbf21ff1$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $9X7IJ.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $ac65ba7da5d490c4$export$2e2bcd8739ae039), (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, color !== "default" && classes["color".concat((0, $f9tk6.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $f9tk6.default)(size))], {
            "start": classes.edgeStart,
            "end": classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $acw62.createElement("span", {
        className: classes.label
    }, children));
});
var $50480f2bcbf21ff1$export$2e2bcd8739ae039 = (0, $kQaj4.default)($50480f2bcbf21ff1$export$9dd6ff9ea0189349, {
    name: "MuiIconButton"
})($50480f2bcbf21ff1$var$IconButton);


var $d986fe1b54c48785$export$9dd6ff9ea0189349 = {
    root: {
        padding: 9
    },
    checked: {},
    disabled: {},
    input: {
        cursor: "inherit",
        position: "absolute",
        opacity: 0,
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        margin: 0,
        padding: 0,
        zIndex: 1
    }
};
/**
 * @ignore - internal component.
 */ var $d986fe1b54c48785$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    var autoFocus = props.autoFocus, checkedProp = props.checked, checkedIcon = props.checkedIcon, classes = props.classes, className = props.className, defaultChecked = props.defaultChecked, disabledProp = props.disabled, icon = props.icon, id = props.id, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, readOnly = props.readOnly, required = props.required, tabIndex = props.tabIndex, type = props.type, value = props.value, other = (0, $9X7IJ.default)(props, [
        "autoFocus",
        "checked",
        "checkedIcon",
        "classes",
        "className",
        "defaultChecked",
        "disabled",
        "icon",
        "id",
        "inputProps",
        "inputRef",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "readOnly",
        "required",
        "tabIndex",
        "type",
        "value"
    ]);
    var _useControlled = (0, $09c3426c3fc3fc28$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    }), _useControlled2 = (0, $eUqlC.default)(_useControlled, 2), checked = _useControlled2[0], setCheckedState = _useControlled2[1];
    var muiFormControl = (0, $08943360f8d6f4a8$export$2e2bcd8739ae039)();
    var handleFocus = function handleFocus(event) {
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    var handleInputChange = function handleInputChange(event) {
        var newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v5: remove the second argument.
        onChange(event, newChecked);
    };
    var disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    var hasLabelFor = type === "checkbox" || type === "radio";
    return /*#__PURE__*/ $acw62.createElement((0, $50480f2bcbf21ff1$export$2e2bcd8739ae039), (0, $8nd05.default)({
        component: "span",
        className: (0, $1SA7b.default)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ref: ref
    }, other), /*#__PURE__*/ $acw62.createElement("input", (0, $8nd05.default)({
        autoFocus: autoFocus,
        checked: checkedProp,
        defaultChecked: defaultChecked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
    }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
var $d986fe1b54c48785$export$2e2bcd8739ae039 = (0, $kQaj4.default)($d986fe1b54c48785$export$9dd6ff9ea0189349, {
    name: "PrivateSwitchBase"
})($d986fe1b54c48785$var$SwitchBase);



var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $8b1e647e4e12d100$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");



var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $7aed3e14b604c253$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");



var $kQaj4 = parcelRequire("kQaj4");
var $9ef02f17ae50d4d9$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        root: {
            position: "relative",
            display: "flex",
            "&$checked $layer": {
                transform: "scale(1)",
                transition: theme.transitions.create("transform", {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.shortest
                })
            }
        },
        layer: {
            left: 0,
            position: "absolute",
            transform: "scale(0)",
            transition: theme.transitions.create("transform", {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.shortest
            })
        },
        checked: {}
    };
};
/**
 * @ignore - internal component.
 */ function $9ef02f17ae50d4d9$var$RadioButtonIcon(props) {
    var checked = props.checked, classes = props.classes, fontSize = props.fontSize;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $1SA7b.default)(classes.root, checked && classes.checked)
    }, /*#__PURE__*/ $acw62.createElement((0, $8b1e647e4e12d100$export$2e2bcd8739ae039), {
        fontSize: fontSize
    }), /*#__PURE__*/ $acw62.createElement((0, $7aed3e14b604c253$export$2e2bcd8739ae039), {
        fontSize: fontSize,
        className: classes.layer
    }));
}
var $9ef02f17ae50d4d9$export$2e2bcd8739ae039 = (0, $kQaj4.default)($9ef02f17ae50d4d9$export$9dd6ff9ea0189349, {
    name: "PrivateRadioButtonIcon"
})($9ef02f17ae50d4d9$var$RadioButtonIcon);



var $9GbWv = parcelRequire("9GbWv");

var $f9tk6 = parcelRequire("f9tk6");


var $kQaj4 = parcelRequire("kQaj4");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ var $83f10e4db947d7b4$var$RadioGroupContext = $acw62.createContext();
var $83f10e4db947d7b4$export$2e2bcd8739ae039 = $83f10e4db947d7b4$var$RadioGroupContext;


function $7a7644702cef654e$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $83f10e4db947d7b4$export$2e2bcd8739ae039));
}


var $9fb57efcb9309866$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            "&$checked": {
                color: theme.palette.primary.main,
                "&:hover": {
                    backgroundColor: (0, $9GbWv.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            "&$checked": {
                color: theme.palette.secondary.main,
                "&:hover": {
                    backgroundColor: (0, $9GbWv.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $9fb57efcb9309866$var$defaultCheckedIcon = /*#__PURE__*/ $acw62.createElement((0, $9ef02f17ae50d4d9$export$2e2bcd8739ae039), {
    checked: true
});
var $9fb57efcb9309866$var$defaultIcon = /*#__PURE__*/ $acw62.createElement((0, $9ef02f17ae50d4d9$export$2e2bcd8739ae039), null);
var $9fb57efcb9309866$var$Radio = /*#__PURE__*/ $acw62.forwardRef(function Radio(props, ref) {
    var checkedProp = props.checked, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? "secondary" : _props$color, nameProp = props.name, onChangeProp = props.onChange, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $9X7IJ.default)(props, [
        "checked",
        "classes",
        "color",
        "name",
        "onChange",
        "size"
    ]);
    var radioGroup = (0, $7a7644702cef654e$export$2e2bcd8739ae039)();
    var checked = checkedProp;
    var onChange = (0, $dc1f76fd676f9045$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    var name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = radioGroup.value === props.value;
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $d986fe1b54c48785$export$2e2bcd8739ae039), (0, $8nd05.default)({
        color: color,
        type: "radio",
        icon: /*#__PURE__*/ $acw62.cloneElement($9fb57efcb9309866$var$defaultIcon, {
            fontSize: size === "small" ? "small" : "medium"
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement($9fb57efcb9309866$var$defaultCheckedIcon, {
            fontSize: size === "small" ? "small" : "medium"
        }),
        classes: {
            root: (0, $1SA7b.default)(classes.root, classes["color".concat((0, $f9tk6.default)(color))]),
            checked: classes.checked,
            disabled: classes.disabled
        },
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref
    }, other));
});
var $9fb57efcb9309866$export$2e2bcd8739ae039 = (0, $kQaj4.default)($9fb57efcb9309866$export$9dd6ff9ea0189349, {
    name: "MuiRadio"
})($9fb57efcb9309866$var$Radio);



var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");
var $a1cd15e9c110441a$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    },
    /* Styles applied to the root element if `row={true}`. */ row: {
        flexDirection: "row"
    }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ var $a1cd15e9c110441a$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(props, ref) {
    var classes = props.classes, className = props.className, _props$row = props.row, row = _props$row === void 0 ? false : _props$row, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "row"
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, row && classes.row),
        ref: ref
    }, other));
});
var $a1cd15e9c110441a$export$2e2bcd8739ae039 = (0, $kQaj4.default)($a1cd15e9c110441a$export$9dd6ff9ea0189349, {
    name: "MuiFormGroup"
})($a1cd15e9c110441a$var$FormGroup);






var $acw62 = parcelRequire("acw62");
function $e4d83248821516ed$export$2e2bcd8739ae039(idOverride) {
    var _React$useState = $acw62.useState(idOverride), defaultId = _React$useState[0], setDefaultId = _React$useState[1];
    var id = idOverride || defaultId;
    $acw62.useEffect(function() {
        if (defaultId == null) // Fallback to this default id when possible.
        // Use the random value for client-side rendering only.
        // We can't use it server-side.
        setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }, [
        defaultId
    ]);
    return id;
}


var $1e0a7ca05db51369$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef(function RadioGroup(props, ref) {
    var actions = props.actions, children = props.children, nameProp = props.name, valueProp = props.value, onChange = props.onChange, other = (0, $9X7IJ.default)(props, [
        "actions",
        "children",
        "name",
        "value",
        "onChange"
    ]);
    var rootRef = $acw62.useRef(null);
    var _useControlled = (0, $09c3426c3fc3fc28$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: props.defaultValue,
        name: "RadioGroup"
    }), _useControlled2 = (0, $eUqlC.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    $acw62.useImperativeHandle(actions, function() {
        return {
            focus: function focus() {
                var input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        };
    }, []);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(ref, rootRef);
    var handleChange = function handleChange(event) {
        setValue(event.target.value);
        if (onChange) onChange(event, event.target.value);
    };
    var name = (0, $e4d83248821516ed$export$2e2bcd8739ae039)(nameProp);
    return /*#__PURE__*/ $acw62.createElement((0, $83f10e4db947d7b4$export$2e2bcd8739ae039).Provider, {
        value: {
            name: name,
            onChange: handleChange,
            value: value
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $a1cd15e9c110441a$export$2e2bcd8739ae039), (0, $8nd05.default)({
        role: "radiogroup",
        ref: handleRef
    }, other), children));
});
var $1e0a7ca05db51369$export$2e2bcd8739ae039 = $1e0a7ca05db51369$var$RadioGroup;



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");



var $kQaj4 = parcelRequire("kQaj4");


var $f9tk6 = parcelRequire("f9tk6");
var $e224cea50fd84b02$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
            // For correct alignment with the text.
            verticalAlign: "middle",
            WebkitTapHighlightColor: "transparent",
            marginLeft: -11,
            marginRight: 16,
            // used for row presentation of radio/checkbox
            "&$disabled": {
                cursor: "default"
            }
        },
        /* Styles applied to the root element if `labelPlacement="start"`. */ labelPlacementStart: {
            flexDirection: "row-reverse",
            marginLeft: 16,
            // used for row presentation of radio/checkbox
            marginRight: -11
        },
        /* Styles applied to the root element if `labelPlacement="top"`. */ labelPlacementTop: {
            flexDirection: "column-reverse",
            marginLeft: 16
        },
        /* Styles applied to the root element if `labelPlacement="bottom"`. */ labelPlacementBottom: {
            flexDirection: "column",
            marginLeft: 16
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the label's Typography component. */ label: {
            "&$disabled": {
                color: theme.palette.text.disabled
            }
        }
    };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ var $e224cea50fd84b02$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(props, ref) {
    var checked = props.checked, classes = props.classes, className = props.className, control = props.control, disabledProp = props.disabled, inputRef = props.inputRef, label = props.label, _props$labelPlacement = props.labelPlacement, labelPlacement = _props$labelPlacement === void 0 ? "end" : _props$labelPlacement, name = props.name, onChange = props.onChange, value = props.value, other = (0, $9X7IJ.default)(props, [
        "checked",
        "classes",
        "className",
        "control",
        "disabled",
        "inputRef",
        "label",
        "labelPlacement",
        "name",
        "onChange",
        "value"
    ]);
    var muiFormControl = (0, $08943360f8d6f4a8$export$2e2bcd8739ae039)();
    var disabled = disabledProp;
    if (typeof disabled === "undefined" && typeof control.props.disabled !== "undefined") disabled = control.props.disabled;
    if (typeof disabled === "undefined" && muiFormControl) disabled = muiFormControl.disabled;
    var controlProps = {
        disabled: disabled
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach(function(key) {
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    return /*#__PURE__*/ $acw62.createElement("label", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, labelPlacement !== "end" && classes["labelPlacement".concat((0, $f9tk6.default)(labelPlacement))], disabled && classes.disabled),
        ref: ref
    }, other), /*#__PURE__*/ $acw62.cloneElement(control, controlProps), /*#__PURE__*/ $acw62.createElement((0, $f763543f732472dc$export$2e2bcd8739ae039), {
        component: "span",
        className: (0, $1SA7b.default)(classes.label, disabled && classes.disabled)
    }, label));
});
var $e224cea50fd84b02$export$2e2bcd8739ae039 = (0, $kQaj4.default)($e224cea50fd84b02$export$9dd6ff9ea0189349, {
    name: "MuiFormControlLabel"
})($e224cea50fd84b02$var$FormControlLabel);






var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");



var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $a95d4722e4676fd0$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");



var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $8abf3fdcaf00a776$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");



var $9GbWv = parcelRequire("9GbWv");

var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $d4960426e2fdd538$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");



var $f9tk6 = parcelRequire("f9tk6");

var $kQaj4 = parcelRequire("kQaj4");
var $370a9b9fe5603fee$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `indeterminate={true}`. */ indeterminate: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            "&$checked": {
                color: theme.palette.primary.main,
                "&:hover": {
                    backgroundColor: (0, $9GbWv.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            "&$checked": {
                color: theme.palette.secondary.main,
                "&:hover": {
                    backgroundColor: (0, $9GbWv.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $370a9b9fe5603fee$var$defaultCheckedIcon = /*#__PURE__*/ $acw62.createElement((0, $8abf3fdcaf00a776$export$2e2bcd8739ae039), null);
var $370a9b9fe5603fee$var$defaultIcon = /*#__PURE__*/ $acw62.createElement((0, $a95d4722e4676fd0$export$2e2bcd8739ae039), null);
var $370a9b9fe5603fee$var$defaultIndeterminateIcon = /*#__PURE__*/ $acw62.createElement((0, $d4960426e2fdd538$export$2e2bcd8739ae039), null);
var $370a9b9fe5603fee$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(props, ref) {
    var _props$checkedIcon = props.checkedIcon, checkedIcon = _props$checkedIcon === void 0 ? $370a9b9fe5603fee$var$defaultCheckedIcon : _props$checkedIcon, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? "secondary" : _props$color, _props$icon = props.icon, iconProp = _props$icon === void 0 ? $370a9b9fe5603fee$var$defaultIcon : _props$icon, _props$indeterminate = props.indeterminate, indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate, _props$indeterminateI = props.indeterminateIcon, indeterminateIconProp = _props$indeterminateI === void 0 ? $370a9b9fe5603fee$var$defaultIndeterminateIcon : _props$indeterminateI, inputProps = props.inputProps, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $9X7IJ.default)(props, [
        "checkedIcon",
        "classes",
        "color",
        "icon",
        "indeterminate",
        "indeterminateIcon",
        "inputProps",
        "size"
    ]);
    var icon = indeterminate ? indeterminateIconProp : iconProp;
    var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    return /*#__PURE__*/ $acw62.createElement((0, $d986fe1b54c48785$export$2e2bcd8739ae039), (0, $8nd05.default)({
        type: "checkbox",
        classes: {
            root: (0, $1SA7b.default)(classes.root, classes["color".concat((0, $f9tk6.default)(color))], indeterminate && classes.indeterminate),
            checked: classes.checked,
            disabled: classes.disabled
        },
        color: color,
        inputProps: (0, $8nd05.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
            fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
        }),
        ref: ref
    }, other));
});
var $370a9b9fe5603fee$export$2e2bcd8739ae039 = (0, $kQaj4.default)($370a9b9fe5603fee$export$9dd6ff9ea0189349, {
    name: "MuiCheckbox"
})($370a9b9fe5603fee$var$Checkbox);





var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");


var $ecaaa74876358dcf$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $ecaaa74876358dcf$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
function $ecaaa74876358dcf$var$generateGrid(globalStyles, theme, breakpoint) {
    var styles = {};
    $ecaaa74876358dcf$var$GRID_SIZES.forEach(function(size) {
        var key = "grid-".concat(breakpoint, "-").concat(size);
        if (size === true) {
            // For the auto layouting
            styles[key] = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: "100%"
            };
            return;
        }
        if (size === "auto") {
            styles[key] = {
                flexBasis: "auto",
                flexGrow: 0,
                maxWidth: "none"
            };
            return;
        } // Keep 7 significant numbers.
        var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
        // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
        styles[key] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width
        };
    }); // No need for a media query for the first size.
    if (breakpoint === "xs") (0, $8nd05.default)(globalStyles, styles);
    else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
}
function $ecaaa74876358dcf$var$getOffset(val) {
    var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var parse = parseFloat(val);
    return "".concat(parse / div).concat(String(val).replace(String(parse), "") || "px");
}
function $ecaaa74876358dcf$var$generateGutter(theme, breakpoint) {
    var styles = {};
    $ecaaa74876358dcf$var$SPACINGS.forEach(function(spacing) {
        var themeSpacing = theme.spacing(spacing);
        if (themeSpacing === 0) return;
        styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
            margin: "-".concat($ecaaa74876358dcf$var$getOffset(themeSpacing, 2)),
            width: "calc(100% + ".concat($ecaaa74876358dcf$var$getOffset(themeSpacing), ")"),
            "& > $item": {
                padding: $ecaaa74876358dcf$var$getOffset(themeSpacing, 2)
            }
        };
    });
    return styles;
} // Default CSS values
var $ecaaa74876358dcf$export$9dd6ff9ea0189349 = function styles(theme) {
    return (0, $8nd05.default)({
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `container={true}`. */ container: {
            boxSizing: "border-box",
            display: "flex",
            flexWrap: "wrap",
            width: "100%"
        },
        /* Styles applied to the root element if `item={true}`. */ item: {
            boxSizing: "border-box",
            margin: "0" // For instance, it's useful when used with a `figure` element.
        },
        /* Styles applied to the root element if `zeroMinWidth={true}`. */ zeroMinWidth: {
            minWidth: 0
        },
        /* Styles applied to the root element if `direction="column"`. */ "direction-xs-column": {
            flexDirection: "column"
        },
        /* Styles applied to the root element if `direction="column-reverse"`. */ "direction-xs-column-reverse": {
            flexDirection: "column-reverse"
        },
        /* Styles applied to the root element if `direction="row-reverse"`. */ "direction-xs-row-reverse": {
            flexDirection: "row-reverse"
        },
        /* Styles applied to the root element if `wrap="nowrap"`. */ "wrap-xs-nowrap": {
            flexWrap: "nowrap"
        },
        /* Styles applied to the root element if `wrap="reverse"`. */ "wrap-xs-wrap-reverse": {
            flexWrap: "wrap-reverse"
        },
        /* Styles applied to the root element if `alignItems="center"`. */ "align-items-xs-center": {
            alignItems: "center"
        },
        /* Styles applied to the root element if `alignItems="flex-start"`. */ "align-items-xs-flex-start": {
            alignItems: "flex-start"
        },
        /* Styles applied to the root element if `alignItems="flex-end"`. */ "align-items-xs-flex-end": {
            alignItems: "flex-end"
        },
        /* Styles applied to the root element if `alignItems="baseline"`. */ "align-items-xs-baseline": {
            alignItems: "baseline"
        },
        /* Styles applied to the root element if `alignContent="center"`. */ "align-content-xs-center": {
            alignContent: "center"
        },
        /* Styles applied to the root element if `alignContent="flex-start"`. */ "align-content-xs-flex-start": {
            alignContent: "flex-start"
        },
        /* Styles applied to the root element if `alignContent="flex-end"`. */ "align-content-xs-flex-end": {
            alignContent: "flex-end"
        },
        /* Styles applied to the root element if `alignContent="space-between"`. */ "align-content-xs-space-between": {
            alignContent: "space-between"
        },
        /* Styles applied to the root element if `alignContent="space-around"`. */ "align-content-xs-space-around": {
            alignContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="center"`. */ "justify-content-xs-center": {
            justifyContent: "center"
        },
        /* Styles applied to the root element if `justifyContent="flex-end"`. */ "justify-content-xs-flex-end": {
            justifyContent: "flex-end"
        },
        /* Styles applied to the root element if `justifyContent="space-between"`. */ "justify-content-xs-space-between": {
            justifyContent: "space-between"
        },
        /* Styles applied to the root element if `justifyContent="space-around"`. */ "justify-content-xs-space-around": {
            justifyContent: "space-around"
        },
        /* Styles applied to the root element if `justifyContent="space-evenly"`. */ "justify-content-xs-space-evenly": {
            justifyContent: "space-evenly"
        }
    }, $ecaaa74876358dcf$var$generateGutter(theme, "xs"), theme.breakpoints.keys.reduce(function(accumulator, key) {
        // Use side effect over immutability for better performance.
        $ecaaa74876358dcf$var$generateGrid(accumulator, theme, key);
        return accumulator;
    }, {}));
};
var $ecaaa74876358dcf$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(props, ref) {
    var _props$alignContent = props.alignContent, alignContent = _props$alignContent === void 0 ? "stretch" : _props$alignContent, _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "stretch" : _props$alignItems, classes = props.classes, classNameProp = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$container = props.container, container = _props$container === void 0 ? false : _props$container, _props$direction = props.direction, direction = _props$direction === void 0 ? "row" : _props$direction, _props$item = props.item, item = _props$item === void 0 ? false : _props$item, justify = props.justify, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? "flex-start" : _props$justifyContent, _props$lg = props.lg, lg = _props$lg === void 0 ? false : _props$lg, _props$md = props.md, md = _props$md === void 0 ? false : _props$md, _props$sm = props.sm, sm = _props$sm === void 0 ? false : _props$sm, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 0 : _props$spacing, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? "wrap" : _props$wrap, _props$xl = props.xl, xl = _props$xl === void 0 ? false : _props$xl, _props$xs = props.xs, xs = _props$xs === void 0 ? false : _props$xs, _props$zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth, other = (0, $9X7IJ.default)(props, [
        "alignContent",
        "alignItems",
        "classes",
        "className",
        "component",
        "container",
        "direction",
        "item",
        "justify",
        "justifyContent",
        "lg",
        "md",
        "sm",
        "spacing",
        "wrap",
        "xl",
        "xs",
        "zeroMinWidth"
    ]);
    var className = (0, $1SA7b.default)(classes.root, classNameProp, container && [
        classes.container,
        spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]
    ], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== "row" && classes["direction-xs-".concat(String(direction))], wrap !== "wrap" && classes["wrap-xs-".concat(String(wrap))], alignItems !== "stretch" && classes["align-items-xs-".concat(String(alignItems))], alignContent !== "stretch" && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== "flex-start" && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: className,
        ref: ref
    }, other));
});
var $ecaaa74876358dcf$var$StyledGrid = (0, $kQaj4.default)($ecaaa74876358dcf$export$9dd6ff9ea0189349, {
    name: "MuiGrid"
})($ecaaa74876358dcf$var$Grid);
var $ecaaa74876358dcf$var$requireProp;
var $ecaaa74876358dcf$export$2e2bcd8739ae039 = $ecaaa74876358dcf$var$StyledGrid;





var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));




const $36a30b5161d9a218$var$AMAX_API_URL = "https://amax-emu.com/api";
const $36a30b5161d9a218$var$eula_text = `

## Amax Emu End User Agreement

### TL:DR
- Don't be a jerk
- 1 account per person
- Don't cheat
- Don't edit account data
- Don't mess up with leaderboards data (account boosting, match-fixing, etc.)

### Full version

#### Conduct
 1. Don’t be annoying, disrespectful or rude to any players. 
 2. No conduct that abuses other players or disrupts their in-game experience is permitted. This includes constant air-breaking and mobbing.

#### Accounts

* 1 person is limited to 1 in-game account.
*  Account names may not be obscene, vulgar or offensive.
* Alteration of in-game account data with 3rd party tools is prohibited, unless explicitly permitted.
* Car paint jobs editing is permitted 
* Car wraps (livery) edits are permitted 
 
#### Gameplay
 
 1. No conduct that constitutes cheating, hacking, or exploiting of game conditions for unintended advantage is permitted. Keep game fun and fair for everyone.
 2. All strategies and tactics are considered valid unless explicitly prohibited. This includes usage of Drift mod, legendary cars and Bribe.
 3. Respect less experienced players. Helping new players experience the game is essential to the future health of the community.
 `;
const $36a30b5161d9a218$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: theme.spacing(2)
        },
        textfield: {
            margin: theme.spacing(1),
            width: "300px"
        },
        selectWide: {
            //backgroundColor: "lightblue",
            //color: "black",
            //width: '400px',
            margin: theme.spacing(1)
        },
        registerButton: {
        },
        successIcon: {
            backgroundColor: "green"
        },
        errorIcon: {
            backgroundColor: "red"
        },
        hiddenClass: {
            visibility: "hidden",
            height: "0px"
        }
    }));
const $36a30b5161d9a218$var$validationSchema = $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
    username: $bcc252d93ab3046c$export$185802fd694ee1f5().required("Username is required").min(4, "Username must be at least 5 characters").max(15, "Username must not exceed 15 characters").unicusername(),
    password: $bcc252d93ab3046c$export$185802fd694ee1f5().required("Password is required").min(8, "Password must be at least 8 characters").max(15, "Password must not exceed 15 characters").matches(/^.*(?=.{8,})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, "Password must contain at least 8 characters, one uppercase, one lowercase and one number"),
    confirmPassword: $bcc252d93ab3046c$export$185802fd694ee1f5().required("Confirm Password is required").oneOf([
        $f5cdfa956e941194$export$185802fd694ee1f5("password"),
        null
    ], "Confirm Password does not match"),
    accountType: $bcc252d93ab3046c$export$185802fd694ee1f5().required("Select your account type").nullable().oneOf([
        "1",
        "0"
    ], "Selected account type is invalid").nullable(),
    acceptEULA: $0237b22d97657ad7$export$185802fd694ee1f5().oneOf([
        true
    ], "Accept Terms is required")
});
function $36a30b5161d9a218$export$2e2bcd8739ae039() {
    const classes = $36a30b5161d9a218$var$useStyles();
    const { register: register , handleSubmit: handleSubmit , formState: { errors: errors  }  } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($36a30b5161d9a218$var$validationSchema)
    });
    const auth = (0, $fa8bb1513e386061$export$650ce9f0b4df82fd)();
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    let history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [serverResponse, setResponse] = $acw62.useState(undefined);
    const [PostState, setPostState] = $acw62.useState(false);
    const [AccoutTypeValue, setAccoutTypeValue] = $acw62.useState("1");
    const [state, setState] = $acw62.useState(false);
    const [ButtonStyle, setButtonStyle] = $acw62.useState("registerButton");
    const ButtonLabel = ()=>{
        if (PostState === false) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
            children: "Create account"
        });
        else {
            if (serverResponse !== undefined) {
                if (serverResponse.success === true) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                    children: "success"
                });
                else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                    children: [
                        "Failed: ",
                        serverResponse.msg
                    ]
                });
            } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                children: "Processing"
            });
        }
    };
    function sleep(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    }
    const handleChange = (event)=>{
        console.log(AccoutTypeValue);
        console.log(event.target.value);
        setAccoutTypeValue("" + event.target.value);
        setAccoutTypeValue("" + event.target.value);
        setAccoutTypeValue("" + event.target.value);
        console.log(AccoutTypeValue);
    };
    const handleChange2 = (event)=>{
        setState(event.target.checked);
    };
    const onSubmit = (data)=>{
        console.log(data);
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($36a30b5161d9a218$var$AMAX_API_URL + "/players/create_account", data, {
            headers: {
                "content-type": "application/json;charset=UTF-8",
                "Authorization": `Bearer ${auth.user.token}`
            }
        }).then((response)=>{
            setResponse(response.data);
            setPostState(true);
            setButtonStyle("successIcon");
            sleep(10000);
            history.push("/final_steps");
        }).catch((error)=>{
            setResponse(error.response.data);
            setPostState(true);
            setButtonStyle("errorIcon");
            console.log(error.response.data);
            console.error("There was an error!", error);
        });
    };
    const CreateAccountButton = ()=>{
        if (PostState) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
            type: "submit",
            fullWidth: true,
            variant: "contained",
            color: "primary",
            disabled: true,
            className: classes[ButtonStyle],
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ButtonLabel, {})
        });
        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
            type: "submit",
            fullWidth: true,
            variant: "contained",
            color: "primary",
            className: classes[ButtonStyle],
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ButtonLabel, {})
        });
    };
    const RegisterForm = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64d9a99297a346fe$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    children: "Create new Amax Emu account"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    className: classes.root,
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ecaaa74876358dcf$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ecaaa74876358dcf$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59744fa8faea6c4c$export$2e2bcd8739ae039), {
                                            ...register("username"),
                                            id: "outlined-basic",
                                            label: "Login",
                                            variant: "outlined",
                                            className: classes.username,
                                            helperText: errors.username?.message,
                                            error: !!errors?.username
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74d3f5713a0fcd7a$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: "This will be your in-game username"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: "Minimum length is 5"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ecaaa74876358dcf$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59744fa8faea6c4c$export$2e2bcd8739ae039), {
                                            ...register("password"),
                                            id: "outlined-basic",
                                            label: "Password",
                                            variant: "outlined",
                                            className: classes.textfield,
                                            helperText: errors.password?.message,
                                            error: !!errors?.password,
                                            type: "password"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74d3f5713a0fcd7a$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: "Password must be at least 8 characters"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: "Should include at least 1 uppercase, 1 lowercase and 1 number"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ecaaa74876358dcf$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59744fa8faea6c4c$export$2e2bcd8739ae039), {
                                        ...register("confirmPassword"),
                                        id: "outlined-basic",
                                        label: "Confirm Password",
                                        variant: "outlined",
                                        className: classes.textfield,
                                        helperText: errors.confirmPassword?.message,
                                        error: !!errors?.confirmPassword,
                                        type: "password"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ecaaa74876358dcf$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $af85c23dd1603048$export$2e2bcd8739ae039), {
                                            component: "fieldset",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $606fb956d2ecf56b$export$2e2bcd8739ae039), {
                                                    component: "legend",
                                                    children: "Account type"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1e0a7ca05db51369$export$2e2bcd8739ae039), {
                                                    ...register("accountType"),
                                                    "aria-label": "accountType",
                                                    name: "accountType",
                                                    value: AccoutTypeValue,
                                                    onChange: handleChange,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e224cea50fd84b02$export$2e2bcd8739ae039), {
                                                            className: classes.selectWide,
                                                            value: "1",
                                                            control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fb57efcb9309866$export$2e2bcd8739ae039), {}),
                                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                        children: "Normal account"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                                children: "Account progression"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                                children: "Leaderboards"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                                children: "Legendary cars"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e224cea50fd84b02$export$2e2bcd8739ae039), {
                                                            className: classes.selectWide,
                                                            value: "0",
                                                            control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fb57efcb9309866$export$2e2bcd8739ae039), {}),
                                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                        children: "Fully unlocked account"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                                children: "All cars and mods unlocked"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                                children: "No leaderboards"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74d3f5713a0fcd7a$export$2e2bcd8739ae039), {
                                                            error: true,
                                                            children: errors.accountType ? errors.accountType.message : " "
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: classes.hiddenClass,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $af85c23dd1603048$export$2e2bcd8739ae039), {
                                        component: "fieldset",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1e0a7ca05db51369$export$2e2bcd8739ae039), {
                                            ...register("accountType"),
                                            "aria-label": "temp",
                                            name: "temp11",
                                            value: AccoutTypeValue,
                                            onChange: handleChange,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e224cea50fd84b02$export$2e2bcd8739ae039), {
                                                    value: "0",
                                                    control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fb57efcb9309866$export$2e2bcd8739ae039), {}),
                                                    label: "temp1"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e224cea50fd84b02$export$2e2bcd8739ae039), {
                                                    value: "1",
                                                    control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fb57efcb9309866$export$2e2bcd8739ae039), {}),
                                                    label: "temp2"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e224cea50fd84b02$export$2e2bcd8739ae039), {
                                                    value: "disabled",
                                                    disabled: true,
                                                    control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fb57efcb9309866$export$2e2bcd8739ae039), {}),
                                                    label: "(Disabled option)"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb8544603a0b034a$export$83ef7ab426386201), {
                                            linkTarget: "_blank",
                                            remarkPlugins: [
                                                (0, $5a545addcc5524a2$export$2e2bcd8739ae039)
                                            ],
                                            children: $36a30b5161d9a218$var$eula_text
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ecaaa74876358dcf$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e224cea50fd84b02$export$2e2bcd8739ae039), {
                                            control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $370a9b9fe5603fee$export$2e2bcd8739ae039), {
                                                ...register("acceptEULA"),
                                                id: "acceptEULA",
                                                checked: state,
                                                value: state,
                                                onChange: handleChange2,
                                                name: "acceptEULA",
                                                color: "primary"
                                            }),
                                            label: "I accept all of above, just let me play.",
                                            id: "acceptEULA"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74d3f5713a0fcd7a$export$2e2bcd8739ae039), {
                                            error: true,
                                            children: errors.acceptEULA ? errors.acceptEULA.message : " "
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(CreateAccountButton, {})
                    ]
                })
            ]
        });
    };
    const RegisterChecks = ()=>{
        if (user.userData?.amax_account !== undefined) {
            if (user.userData?.amax_account) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                children: "You already have an account, why do you need another one?"
            });
            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RegisterForm, {});
        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
            children: "You need to login with Discord first"
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RegisterChecks, {});
}



var $fSwVM = parcelRequire("fSwVM");


var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $VFVve = parcelRequire("VFVve");
function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $VFVve.default)(subClass, superClass);
}



var $fSwVM = parcelRequire("fSwVM");

var $hDpcU = parcelRequire("hDpcU");
function $6a259df8fa92dc4a$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $fSwVM.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hDpcU.default)(self);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(o) {
    $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4c5ebe502337db0$export$2e2bcd8739ae039(o);
}



var $kSlfw = parcelRequire("kSlfw");

var $1uEeT = parcelRequire("1uEeT");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $7d110e739ae14cc6$export$2e2bcd8739ae039(arr) {
    return (0, $1uEeT.default)(arr) || (0, $dOjF6.default)(arr) || (0, $abLc2.default)(arr) || (0, $782Uh.default)();
}


function $673ff3dfc4a496de$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $673ff3dfc4a496de$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $673ff3dfc4a496de$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $cHPF9.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, $673ff3dfc4a496de$var$_objectSpread($673ff3dfc4a496de$var$_objectSpread({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
var $673ff3dfc4a496de$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $cHPF9.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $673ff3dfc4a496de$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $673ff3dfc4a496de$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $673ff3dfc4a496de$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $673ff3dfc4a496de$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $673ff3dfc4a496de$var$setPath(object, path, newValue) {
    var _getLastOfPath = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $673ff3dfc4a496de$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $673ff3dfc4a496de$var$getPath(object, path) {
    var _getLastOfPath3 = $673ff3dfc4a496de$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key) {
    var value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
}
function $673ff3dfc4a496de$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $673ff3dfc4a496de$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $673ff3dfc4a496de$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $673ff3dfc4a496de$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $673ff3dfc4a496de$var$_entityMap[s];
    });
    return data;
}
var $673ff3dfc4a496de$var$isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var $673ff3dfc4a496de$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = $673ff3dfc4a496de$var$chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $673ff3dfc4a496de$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $673ff3dfc4a496de$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var $673ff3dfc4a496de$var$ResourceStore = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $hDpcU.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $cHPF9.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = $673ff3dfc4a496de$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return $673ff3dfc4a496de$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $673ff3dfc4a496de$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
                if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
                else pack = $673ff3dfc4a496de$var$_objectSpread$1($673ff3dfc4a496de$var$_objectSpread$1({}, pack), resources);
                $673ff3dfc4a496de$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return $673ff3dfc4a496de$var$_objectSpread$1($673ff3dfc4a496de$var$_objectSpread$1({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($673ff3dfc4a496de$var$EventEmitter);
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function $673ff3dfc4a496de$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $673ff3dfc4a496de$var$checkedLoadedFor = {};
var $673ff3dfc4a496de$var$Translator = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$1(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Translator);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $hDpcU.default)(_this));
        $673ff3dfc4a496de$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $hDpcU.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $673ff3dfc4a496de$var$baseLogger.create("translator");
        return _this;
    }
    (0, $cHPF9.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $fSwVM.default)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) {
                            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
                            return resolved;
                        }
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) {
                        resolved.res = key;
                        return resolved;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init($673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {
                        interpolation: $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? $673ff3dfc4a496de$var$_objectSpread$2({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$673ff3dfc4a496de$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $673ff3dfc4a496de$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($673ff3dfc4a496de$var$EventEmitter);
function $673ff3dfc4a496de$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $673ff3dfc4a496de$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("languageUtils");
    }
    (0, $cHPF9.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $673ff3dfc4a496de$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $673ff3dfc4a496de$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $673ff3dfc4a496de$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var $673ff3dfc4a496de$var$deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $673ff3dfc4a496de$var$createRules() {
    var rules = {};
    $673ff3dfc4a496de$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $673ff3dfc4a496de$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $673ff3dfc4a496de$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $673ff3dfc4a496de$var$createRules();
    }
    (0, $cHPF9.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return $673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !$673ff3dfc4a496de$var$deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function $673ff3dfc4a496de$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$3(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $673ff3dfc4a496de$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $cHPF9.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $673ff3dfc4a496de$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, k), f, lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && options.hasOwnProperty(matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = $673ff3dfc4a496de$var$_objectSpread$3({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $673ff3dfc4a496de$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $673ff3dfc4a496de$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$4(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $7d110e739ae14cc6$export$2e2bcd8739ae039)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $673ff3dfc4a496de$var$createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var $673ff3dfc4a496de$var$Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Formatter);
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, options);
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, options), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.DateTimeFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.RelativeTimeFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val, options.range || "day");
                };
            }),
            list: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.ListFormat(lng, $673ff3dfc4a496de$var$_objectSpread$4({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $cHPF9.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng, options) {
                var _this = this;
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = $673ff3dfc4a496de$var$parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function $673ff3dfc4a496de$var$ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$5(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var $673ff3dfc4a496de$var$Connector = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$2(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Connector);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $hDpcU.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $673ff3dfc4a496de$var$baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $cHPF9.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $673ff3dfc4a496de$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $673ff3dfc4a496de$var$removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(ns) {
                                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                return this.backend[fcName](lng, ns, function(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, $673ff3dfc4a496de$var$_objectSpread$5($673ff3dfc4a496de$var$_objectSpread$5({}, options), {}, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($673ff3dfc4a496de$var$EventEmitter);
function $673ff3dfc4a496de$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $fSwVM.default)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $fSwVM.default)(args[2]) === "object" || (0, $fSwVM.default)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $673ff3dfc4a496de$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $673ff3dfc4a496de$var$ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $673ff3dfc4a496de$var$ownKeys$6(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $673ff3dfc4a496de$var$ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$noop() {}
function $673ff3dfc4a496de$var$bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var $673ff3dfc4a496de$var$I18n = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$3(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, I18n);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $hDpcU.default)(_this));
        _this.options = $673ff3dfc4a496de$var$transformOptions(options);
        _this.services = {};
        _this.logger = $673ff3dfc4a496de$var$baseLogger;
        _this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions((0, $hDpcU.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(_this, (0, $hDpcU.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $cHPF9.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = $673ff3dfc4a496de$var$get();
                this.options = $673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6({}, defOpts), this.options), $673ff3dfc4a496de$var$transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = $673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = $673ff3dfc4a496de$var$Formatter;
                    var lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
                    this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $673ff3dfc4a496de$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = $673ff3dfc4a496de$var$noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $673ff3dfc4a496de$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $673ff3dfc4a496de$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $673ff3dfc4a496de$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $673ff3dfc4a496de$var$defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $fSwVM.default)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = $673ff3dfc4a496de$var$_objectSpread$6({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $673ff3dfc4a496de$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $673ff3dfc4a496de$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
                var mergedOptions = $673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = $673ff3dfc4a496de$var$_objectSpread$6({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}($673ff3dfc4a496de$var$EventEmitter);
(0, $kSlfw.default)($673ff3dfc4a496de$var$I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new $673ff3dfc4a496de$var$I18n(options, callback);
});
var $673ff3dfc4a496de$var$instance = $673ff3dfc4a496de$var$I18n.createInstance();
$673ff3dfc4a496de$var$instance.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
var $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$var$instance.createInstance;
var $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$var$instance.init;
var $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$var$instance.loadResources;
var $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$var$instance.reloadResources;
var $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$var$instance.use;
var $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$var$instance.changeLanguage;
var $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$var$instance.getFixedT;
var $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$var$instance.t;
var $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$var$instance.exists;
var $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$var$instance.setDefaultNamespace;
var $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$var$instance.hasLoadedNamespace;
var $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$var$instance.loadNamespaces;
var $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$var$instance.loadLanguages;
var $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$instance;




var $cHPF9 = parcelRequire("cHPF9");
var $60196a4650e96cb1$var$arr = [];
var $60196a4650e96cb1$var$each = $60196a4650e96cb1$var$arr.forEach;
var $60196a4650e96cb1$var$slice = $60196a4650e96cb1$var$arr.slice;
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$each.call($60196a4650e96cb1$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $60196a4650e96cb1$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $60196a4650e96cb1$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $60196a4650e96cb1$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $60196a4650e96cb1$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$hasLocalStorageSupport = null;
var $60196a4650e96cb1$var$localStorageAvailable = function localStorageAvailable() {
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $60196a4650e96cb1$var$hasSessionStorageSupport = null;
var $60196a4650e96cb1$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1; // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i); // if there is no match (null) return undefined
        if (!language) return undefined; // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $60196a4650e96cb1$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ] // cookieMinutes: 10,
    };
}
var $60196a4650e96cb1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $cHPF9.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults()); // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($60196a4650e96cb1$var$cookie$1);
                this.addDetector($60196a4650e96cb1$var$querystring);
                this.addDetector($60196a4650e96cb1$var$localStorage);
                this.addDetector($60196a4650e96cb1$var$sessionStorage);
                this.addDetector($60196a4650e96cb1$var$navigator$1);
                this.addDetector($60196a4650e96cb1$var$htmlTag);
                this.addDetector($60196a4650e96cb1$var$path);
                this.addDetector($60196a4650e96cb1$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$60196a4650e96cb1$export$2e2bcd8739ae039.type = "languageDetector";



var $5d0e77d58c8a7bb3$exports = {};
$5d0e77d58c8a7bb3$exports = JSON.parse('{"intro_welcome_header":"Welcome to the home of Amax Emu!","intro_welcome_description":"Blur is a pretty decent game.","sessions_widget_header":"Active sessions","sessions_widget":{"status":{"inprogress":"In progress","inlobby":"In lobby"},"gamemode":{"skirmish":"Skirmish racing","drivingschool":"Driving school","powered_up_racing":"Powered-up racing","teamracing":"Team racing","hardcore_racing":"Hardcore racing","team_motor_mash":"Team Motor Mash","motormash":"Motor Mash","communityevent":"Community events","worldtour":"World tour"}},"profile_stats":{"stats":"Stats","pastraces":"Past Races","career":"Career","combat":"Combat","racing":"Racing"},"leaderboard_widget":{"header":"Top 10","position":"Pos.","player":"Player","fans":"Fans","driving_score":"Driving score","legend":"Legend","value":"Value"},"general_values_names":{"fans":"Fans","level":"Fans","driving_score":"Driving score","legend":"Legend","total_race":"Total races","top3":"Top 3","first":"First","hits":"Hits","fired":"Fired","total_time":"Total race time","wrecked":"Wrecks"},"server_status_widget":{"server_status":"Server status","offline":"Offline","online":"Online","players":"Players online:","sessions":"Sessions:"},"appbar":{"login_discord":"Login with Discord","create_amax_account":"Create Amax Emu account","profile":"Profile"},"how_to_play":{"header":"How to play Blur online","login_step_header":"Login with your Discord account","login_step_text":"Login with your Discord account using the button below","create_amax_account_header":"Create Amax Emu account","create_amax_account_text":"Create Amax emu (in game) account using the button below.","blur_download_step_header":"Get a copy of Blur","blur_download_step_text":"Install Blur from your legally owned DVD from 2010 or download it from your Steam library.","patch_step_header":"Install patch 1.2","patch_step_text1":"You can download patch 1.2 files from here. ","patch_step_text2":"You don\'t need to do it if you installed game thought Steam","patch_step_text3":"Place patch files to the root of your Blur installation","amax_emu_step_header":"Add Amax Emu files","amax_emu_step_text":"Download latest Amax Emu files from here and place them into root of your Blur installation.","amax_emu_login_step_header":"Login into the Amax Emu in the game","amax_emu_login_step_text":"Login into the Amax Emu using your username and password.","play_step_header":"Play Blur","play_step_text":"Enjoy Blur like it is 2010 again!"}}');


var $46e8330d57a82ad9$exports = {};
$46e8330d57a82ad9$exports = JSON.parse('{"intro_welcome_header":"Добро пожаловать на сайт Amax Emu!","intro_welcome_description":"Blur is a pretty decent game.","sessions_widget_header":"Текущие сессии","sessions_widget":{"status":{"inprogress":"В процессе","inlobby":"В лобби"},"gamemode":{"skirmish":"Скирмиш рейсинг","drivingschool":"Школа вождения","powerupracing":"Power-up racing","teamracing":"Командный заезд","motormash":"Мотор меш","communityevent":"Community events","worldtour":"Мировой тур"}},"leaderboard_widget":{"header":"Топ 10","position":"№","player":"Игрок","value":" ","fans":"Фанатов","driving_score":"Очки вождения","legend":"Уровень Легенды"},"server_status_widget":{"server_status":"Статус сервера","offline":"Не в сети","online":"В сети","players":"Игроков:","sessions":"Сессий:"},"appbar":{"login_discord":"Авторизировать через Discord","profile":"Профиль"},"profile_stats":{"stats":"Статистика","pastraces":"Прошлые заезды","career":"Карьера","combat":"Бонусы","racing":"Заезды"},"general_values_names":{"fans":"Фанаты","level":"Уровень","driving_score":"Очки вождения","legend":"Легенда","total_race":"Всего заездов","top3":"Топ 3","first":"Первым","hits":"Попаданий","fired":"Выстрелов","total_time":"Общее время","wrecked":"Уничтожено"},"how_to_play":{"header":"Как играть в Blur по сети","login_step_header":"Залогиньтесь, используя свой аккаунт Discord","login_step_text":"Залогиньтесь, используя кнопку ниже.","blur_download_step_header":"Установите Blur","blur_download_step_text":"Установите Blur c вашего DVD диска, который вы купили в 2010 году, или установите игру через Steam.","patch_step_header":"Установите патч 1.2","patch_step_text1":"Вы можете скачать необходимые файлы ниже.","patch_step_text2":"Этот шаг можно пропустить, если вы установили игру через Steam.","patch_step_text3":"Поместите файлы в каталог, где установлен Blur.","amax_emu_step_header":"Добавьте файлы Amax Emu","amax_emu_step_text":"Загрузите самые последние файлы для игры через Amax Emu по ссылке ниже и поместите файлы в каталог, где установлен Blur.","amax_emu_login_step_header":"Войдите в Amax Emu в игре","amax_emu_login_step_text":"Войдите в своей профиль Amax Emu, используя ваш логин и пароль.","play_step_header":"Теперь можно играть","play_step_text":"Наслаждайтесь Blur\'ом, как будто 2010 никогда не закончился!"}}');


var $90c484ad9d705a1d$exports = {};
$90c484ad9d705a1d$exports = JSON.parse('{"intro_welcome_header":"\xa1Bienvenido a la pagina de AMAX para Blur!","intro_welcome_description":"Blur es un juego bastante bueno.","sessions_widget_header":"Sesiones activas","sessions_widget":{"status":{"inprogress":"En Progreso","inlobby":"En Lobby"},"gamemode":{"skirmish":"Carreras Individual","drivingschool":"Escuela De Conduccion","powerupracing":"Carrera Con Potenciadores","teamracing":"Duelo Por Equipos","motormash":"Motomasacre","communityevent":"Eventos Comunitarios","worldtour":"Gira Mundial"}},"leaderboard_widget":{"header":"Mejores 10","position":"Posicion","player":"Jugador","value":"Valor","fans":"Seguidores","driving_score":"Puntuaci\xf3n De Conducci\xf3n","legend":"Leyenda"},"server_status_widget":{"server_status":"Estado Del Servidor","offline":"Fuera De Linea","online":"En Linea","players":"Jugadores en linea","sessions":"Sesiones"},"appbar":{"login_discord":"Inicio De Sesi\xf3n A Trav\xe9s de Discord","profile":"Perfil"},"profile_stats":{"stats":"Estadisticas","pastraces":"Carreras Pasadas","career":"Carrera Profesional","combat":"Combate","racing":"Carreras"},"general_values_names":{"fans":"Seguidores","level":"Cantidad","driving_score":"Puntuaci\xf3n De Conducci\xf3n","legend":"Leyenda","total_race":"Carreras Totales","top3":"Tercero","first":"Primero","hits":"Aciertos","fired":"Disparado","total_time":"Tiempo Total En Carrera","wrecked":"Destruidos"}}');


var $121d5194588a8c96$exports = {};
$121d5194588a8c96$exports = JSON.parse('{"intro_welcome_header":"Willkommen bei Amax Emu!","intro_welcome_description":"Blur ist ein ziemlich cooles Spiel.","sessions_widget_header":"Aktive Sitzungen","sessions_widget":{"status":{"inprogress":"Im Gange","inlobby":"In der Lobby"},"gamemode":{"skirmish":"Gefechtsrennen","drivingschool":"Fahrschule","powerupracing":"Powerup-Rennen","teamracing":"Teamrennen","motormash":"Motorensalat","communityevent":"Community-Events","worldtour":"Welttournee"}},"leaderboard_widget":{"header":"Top 10","position":"Pos.","player":"Spieler","value":"Wert","fans":"Fans","driving_score":"Fahrerpunkte","legend":"Legende"},"server_status_widget":{"server_status":"Server Status","offline":"Offline","online":"Online","players":"Spieler online:","sessions":"Sitzungen:"},"appbar":{"login_discord":"Einloggen mit Discord","profile":"Profil"},"profile_stats":{"stats":"Statistik","pastraces":"Letzte Rennen","career":"Karriere","combat":"Gefecht","racing":"Spielen"},"general_values_names":{"fans":"Fans","level":"Fans","driving_score":"Fahrerpunkte","legend":"Legende","total_race":"Rennen","top3":"Top 3","first":"Erster","hits":"Treffer","fired":"Abgefeuert\\n","total_time":"Gesamtspielzeit","wrecked":"Demolierungen"},"how_to_play":{"header":"Wie spielt man Blur online","login_step_header":"Logge dich mit deinem Discord Account ein","login_step_text":"Logge dich mit deinem Discord Account ein, indem du den unteren Button dr\xfcckst","blur_download_step_header":"Erhalte eine Kopie von Blur","blur_download_step_text":"Installiere Blur mithilfe deiner originalen Blur CD oder downloade es aus deiner Steam Bibliothek.","patch_step_header":"Installiere Patch 1.2","patch_step_text1":"Hier kannst du die 1.2 Patch Dateien runterladen.","patch_step_text2":"Du brauchst den Patch nicht, wenn du Blur via Steam installiert hast.","patch_step_text3":"Platziere die Patch Dateien in deinem Blur Installationsverzeichnis.","amax_emu_step_header":"F\xfcge Amax Emu Dateien hinzu","amax_emu_step_text":"Downloade die neuesten Amax Emu Dateien und platziere sie in deinem Blur Installationsverzeichnis.","amax_emu_login_step_header":"Logge dich mit Amax Emu im Spiel ein","amax_emu_login_step_text":"Loge dich mit deinem Passwort und Nutzernamen bei Amax Emu ein.","play_step_header":"Spiele Blur","play_step_text":"Habe Spa\xdf, als w\xe4re es 2010!"}}');


var $92b74901bdf3643a$exports = {};
$92b74901bdf3643a$exports = JSON.parse('{"intro_welcome_header":"Bienvenue dans le menu d\'Amax Emu !","intro_welcome_description":"Blur est un jeu \xe0 peu pr\xe8s d\xe9cent.","sessions_widget_header":"Sessions active","sessions_widget":{"status":{"inprogress":"En cours","inlobby":"Dans un salon"},"gamemode":{"skirmish":"Escarmouche","drivingschool":"Auto-\xe9cole","powerupracing":"Course avec Power-ups","teamracing":"Course en \xe9quipe","motormash":"Annihilation","communityevent":"\xc9v\xe8nement communautaire","worldtour":"Tour du monde"}},"leaderboard_widget":{"header":"Top 10","position":"Pos.","player":"Joueur","value":"Valeur","fans":"Fans","driving_score":"Points de conduite","legend":"L\xe9gende"},"server_status_widget":{"server_status":"Statut du serveur","offline":"Hors Ligne","online":"En ligne","players":"Joueurs en ligne :","sessions":"Sessions :"},"appbar":{"login_discord":"Connexion avec Discord","profile":"Profile"},"profile_stats":{"stats":"Stats","pastraces":"Pr\xe9c\xe9dente courses ","career":"Carri\xe8re","combat":"Combat","racing":"Course"},"general_values_names":{"fans":"Fans","level":"Fans","driving_score":"Score de conduite","legend":"L\xe9gende","total_race":"Total de courses","top3":"Top 3","first":"Premier","hits":"Coups","fired":"Vir\xe9","total_time":"Total en temps de courses ","wrecked":"D\xe9truits"}}');


var $864bfc3f40b28f54$exports = {};
$864bfc3f40b28f54$exports = JSON.parse('{"intro_welcome_header":"एमैक्स इमयू में आपका स्वागत है!","intro_welcome_description":"ब्लर काफी अच्छा खेल है।","sessions_widget_header":"चालू सत्र","sessions_widget":{"status":{"inprogress":"प्रगति में","inlobby":"लाॅबी में"},"gamemode":{"skirmish":"स्किरमिश रेसिंग","drivingschool":"ड्राइविंग स्कूल","powerupracing":"पावर-अप रेसिंग","teamracing":"टीम रेसिंग","motormash":"मोटर मैश","communityevent":"सामुदायिक इवेंट","worldtour":"विश्व टूर"}},"leaderboard_widget":{"header":"शीर्ष 10","position":"स्थिति.","player":"खिलाड़ी","value":"वैल्यू","fans":"प्रशंसक","driving_score":"ड्राइविंग स्कोर","legend":"दिग्गज"},"server_status_widget":{"server_status":"सर्वर की स्थिति","offline":"ऑफलाइन","online":"ऑनलाइन","players":"खिलाड़ी ऑनलाइन:","sessions":"सेशंस:"},"appbar":{"login_discord":"डिस्कॉर्ड के साथ लॉगिन करें","profile":"प्रोफ़ाइल"},"profile_stats":{"stats":"आँकड़े","pastraces":"पिछली रेसेस","career":"करियर","combat":"लड़ाई","racing":"रेसिंग"},"general_values_names":{"fans":"प्रशंसक","level":"प्रशंसक","driving_score":"ड्राइविंग स्कोर","legend":"दिग्गज","total_race":"कुल रेसेस","top3":"शीर्ष 3","first":"प्रथम","hits":"हिट्स","fired":"गोलियां चलाईं","total_time":"कुल रेस का समय","wrecked":"निपटा दिए"},"how_to_play":{"header":"ब्लर ऑनलाइन कैसे खेलें","login_step_header":"अपने डिस्कॉर्ड खाते से लॉगिन करें","login_step_text":"नीचे दिए गए बटन का उपयोग करके अपने डिस्कॉर्ड खाते से लॉगिन करें","blur_download_step_header":"ब्लर की एक कॉपी प्राप्त करें","blur_download_step_text":"ब्लर को कानूनी रूप से अपने 2010 वाली डीवीडी से इनस्टॉल करें या इसे अपनी स्टीम लाइब्रेरी से डाउनलोड करें","patch_step_header":"पैच 1.2 इनस्टॉल करें","patch_step_text1":"आप यहाँ से पैच 1.2 की फ़ाइलें डाउनलोड कर सकते हैं","patch_step_text2":"यदि आपने गेम स्टीम से इनस्टॉल किया है तो आपको इसे करने की आवश्यकता नहीं है","patch_step_text3":"पैच फ़ाइलों को अपने ब्लर इंस्टॉलेशन के रुट फोल्डर में रखें","amax_emu_step_header":"ऐड एमैक्स इमयू फाइल्स","amax_emu_step_text":"नयी एमैक्स इमयू फ़ाइलें यहाँ से डाउनलोड करें और उन्हें अपने ब्लर इंस्टालेशन के रुट फोल्डर में रखें","amax_emu_login_step_header":"गेम में एमैक्स इमयू में लॉगिन करें","amax_emu_login_step_text":"अपने नाम और पासवर्ड का उपयोग करके एमैक्स इमयू में लॉगिन करें","play_step_header":"ब्लर खेलें","play_step_text":"ब्लर का आनंद लें जैसे कि यह 2010 फिर से है!"}}');


var $2b47eaf42386d4f2$exports = {};
$2b47eaf42386d4f2$exports = JSON.parse('{"intro_welcome_header":"Benvenuto nella home di Amax Emu!","intro_welcome_description":"Blur \xe8 un gioco abbastanza decente.","sessions_widget_header":"Sessioni attive","sessions_widget":{"status":{"inprogress":"In corso","inlobby":"Nella lobby"},"gamemode":{"skirmish":"Gare schermaglia","drivingschool":"Scuola guida","powerupracing":"Gare con potenziamenti","teamracing":"Gare a squadre","motormash":"Sfasciamotori","communityevent":"Eventi della comunit\xe0","worldtour":"Tour mondiale"}},"leaderboard_widget":{"header":"Top 10","position":"Pos.","player":"Giocatore","value":"Valore","fans":"Tifosi","driving_score":"Punteggio pilota","legend":"Leggenda"},"server_status_widget":{"server_status":"Stato del server","offline":"Offline","online":"Online","players":"Giocatori online:","sessions":"Sessioni:"},"appbar":{"login_discord":"Accedi con Discord","profile":"Profilo"},"profile_stats":{"stats":"Statistiche","pastraces":"Gare passate","career":"Carriera","combat":"Combattimento","racing":"Gare"},"general_values_names":{"fans":"Tifosi","level":"Tifosi","driving_score":"Punteggio pilota","legend":"Leggenda","total_race":"Partite totali","top3":"Top 3","first":"Primo","hits":"Colpi a segno","fired":"Colpi sparati","total_time":"Tempo di gioco totale","wrecked":"Colpi demolitori"},"how_to_play":{"header":"Come giocare Blur online","login_step_header":"Accedi con il tuo account Discord","login_step_text":"Accedi con il tuo account Discord usando il bottone sotto","blur_download_step_header":"Prendi una copia di Blur","blur_download_step_text":"Installa Blur usando il DVD che possiedi legalmente dal 2010 oppure scaricalo dalla tua libreria di Steam.","patch_step_header":"Installa la patch 1.2","patch_step_text1":"Puoi scaricare i file della patch 1.2 da qua. ","patch_step_text2":"Non hai bisogno di farlo se hai installato il gioco tramite Steam","patch_step_text3":"Metti i file della patch nella cartella principale in cui hai installato Blur","amax_emu_step_header":"Aggiungi i file di Amax Emu","amax_emu_step_text":"Scarica da qua i file pi\xf9 aggiornati di Amax Emu e mettili nella cartella principale in cui hai installato Blur.","amax_emu_login_step_header":"Accedi ad Amax Emu nel gioco","amax_emu_login_step_text":"Accedi ad Amax Emu usando il tuo username e password.","play_step_header":"Gioca a Blur","play_step_text":"Goditi Blur come se fosse ancora il 2010!"}}');


// the translations
const $c5f6b329bb753cb0$var$resources = {
    en: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($5d0e77d58c8a7bb3$exports)))
    },
    ru: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($46e8330d57a82ad9$exports)))
    },
    de: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($121d5194588a8c96$exports)))
    },
    es: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($90c484ad9d705a1d$exports)))
    },
    fr: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($92b74901bdf3643a$exports)))
    },
    hi: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($864bfc3f40b28f54$exports)))
    },
    it: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($2b47eaf42386d4f2$exports)))
    }
};
(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $0636c84fe4549f1f$export$ae7e14d40d89f296)).use((0, $60196a4650e96cb1$export$2e2bcd8739ae039)).init({
    resources: $c5f6b329bb753cb0$var$resources,
    fallbackLng: "en",
    debug: true,
    keySeparator: ".",
    interpolation: {
        escapeValue: false,
        formatSeparator: ","
    },
    react: {
        wait: true
    }
});
var $c5f6b329bb753cb0$export$2e2bcd8739ae039 = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039);






var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");

var $b5daafc8fcdb02e6$exports = {};
var $b441afe4fd4449f4$exports = {};

$b441afe4fd4449f4$exports = new URL((parcelRequire("27Lyk")).resolve("iTJwU"), import.meta.url).toString();


var $65b43c39a0c9d4aa$exports = {};

$65b43c39a0c9d4aa$exports = new URL((parcelRequire("27Lyk")).resolve("c0Pk2"), import.meta.url).toString();


var $662d69b42dc41dfb$exports = {};

$662d69b42dc41dfb$exports = new URL((parcelRequire("27Lyk")).resolve("10GDx"), import.meta.url).toString();


var $c45f92d6c7a5ab24$exports = {};

$c45f92d6c7a5ab24$exports = new URL((parcelRequire("27Lyk")).resolve("kgb4G"), import.meta.url).toString();


var $c032f09245a85392$exports = {};

$c032f09245a85392$exports = new URL((parcelRequire("27Lyk")).resolve("ah3MO"), import.meta.url).toString();


var $8e9dfb407e8a40ea$exports = {};

$8e9dfb407e8a40ea$exports = new URL((parcelRequire("27Lyk")).resolve("bw2hq"), import.meta.url).toString();


var $5259cb5887383a0c$exports = {};

$5259cb5887383a0c$exports = new URL((parcelRequire("27Lyk")).resolve("29yAH"), import.meta.url).toString();


var $073ea80adac71746$exports = {};

$073ea80adac71746$exports = new URL((parcelRequire("27Lyk")).resolve("dbZ8A"), import.meta.url).toString();


var $599ad2246eb7fa18$exports = {};

$599ad2246eb7fa18$exports = new URL((parcelRequire("27Lyk")).resolve("iOBSq"), import.meta.url).toString();


var $92840093777dcc9d$exports = {};

$92840093777dcc9d$exports = new URL((parcelRequire("27Lyk")).resolve("b5CjD"), import.meta.url).toString();


var $69e257862e220fe3$exports = {};

$69e257862e220fe3$exports = new URL((parcelRequire("27Lyk")).resolve("i8qJv"), import.meta.url).toString();


var $f30e5255b6a2ffd1$exports = {};

$f30e5255b6a2ffd1$exports = new URL((parcelRequire("27Lyk")).resolve("8OIfE"), import.meta.url).toString();


var $acfd55f1afd98d9f$exports = {};

$acfd55f1afd98d9f$exports = new URL((parcelRequire("27Lyk")).resolve("45hHf"), import.meta.url).toString();


var $f7bf4c39fb366607$exports = {};

$f7bf4c39fb366607$exports = new URL((parcelRequire("27Lyk")).resolve("6qy71"), import.meta.url).toString();


var $8e768a4d09a82d76$exports = {};

$8e768a4d09a82d76$exports = new URL((parcelRequire("27Lyk")).resolve("95to4"), import.meta.url).toString();


var $4880f48caba72e79$exports = {};

$4880f48caba72e79$exports = new URL((parcelRequire("27Lyk")).resolve("baFiV"), import.meta.url).toString();


var $fd60eef85d421c11$exports = {};

$fd60eef85d421c11$exports = new URL((parcelRequire("27Lyk")).resolve("3LLBl"), import.meta.url).toString();


var $6841fb6ae0702768$exports = {};

$6841fb6ae0702768$exports = new URL((parcelRequire("27Lyk")).resolve("lDCW9"), import.meta.url).toString();


var $8b4ae015b3fad810$exports = {};

$8b4ae015b3fad810$exports = new URL((parcelRequire("27Lyk")).resolve("eruf4"), import.meta.url).toString();


var $d8a32b055c356e98$exports = {};

$d8a32b055c356e98$exports = new URL((parcelRequire("27Lyk")).resolve("j16La"), import.meta.url).toString();


var $ec57ee981733b6d1$exports = {};

$ec57ee981733b6d1$exports = new URL((parcelRequire("27Lyk")).resolve("c2WJj"), import.meta.url).toString();


var $c281926698b99d5b$exports = {};

$c281926698b99d5b$exports = new URL((parcelRequire("27Lyk")).resolve("b0Pyx"), import.meta.url).toString();


var $91150a20b8b1e207$exports = {};

$91150a20b8b1e207$exports = new URL((parcelRequire("27Lyk")).resolve("9Emlc"), import.meta.url).toString();


var $809e9f628fe8a992$exports = {};

$809e9f628fe8a992$exports = new URL((parcelRequire("27Lyk")).resolve("1oB0O"), import.meta.url).toString();


var $e236466448b151f1$exports = {};

$e236466448b151f1$exports = new URL((parcelRequire("27Lyk")).resolve("6OWH3"), import.meta.url).toString();


var $fbf97dae193bf434$exports = {};

$fbf97dae193bf434$exports = new URL((parcelRequire("27Lyk")).resolve("aWIKq"), import.meta.url).toString();


var $5f82ffd16de206de$exports = {};

$5f82ffd16de206de$exports = new URL((parcelRequire("27Lyk")).resolve("h7h37"), import.meta.url).toString();


var $d0760a50f2b77bad$exports = {};

$d0760a50f2b77bad$exports = new URL((parcelRequire("27Lyk")).resolve("gLkFV"), import.meta.url).toString();


var $e800f8483e2394b3$exports = {};

$e800f8483e2394b3$exports = new URL((parcelRequire("27Lyk")).resolve("5WHsJ"), import.meta.url).toString();


var $9027a3ec19f25c48$exports = {};

$9027a3ec19f25c48$exports = new URL((parcelRequire("27Lyk")).resolve("1tDAv"), import.meta.url).toString();


var $581708ea8b5f89f5$exports = {};

$581708ea8b5f89f5$exports = new URL((parcelRequire("27Lyk")).resolve("gL6xP"), import.meta.url).toString();


var $44e0f7b9add32ba4$exports = {};

$44e0f7b9add32ba4$exports = new URL((parcelRequire("27Lyk")).resolve("3BNKv"), import.meta.url).toString();


var $3af54de073d50af4$exports = {};

$3af54de073d50af4$exports = new URL((parcelRequire("27Lyk")).resolve("gAyVA"), import.meta.url).toString();


var $5501116ec145e76e$exports = {};

$5501116ec145e76e$exports = new URL((parcelRequire("27Lyk")).resolve("h5Dj2"), import.meta.url).toString();


var $60f36669ccdbe448$exports = {};

$60f36669ccdbe448$exports = new URL((parcelRequire("27Lyk")).resolve("cr8N8"), import.meta.url).toString();


var $4374ef023720bed2$exports = {};

$4374ef023720bed2$exports = new URL((parcelRequire("27Lyk")).resolve("2J4gj"), import.meta.url).toString();


var $a68c39abac281a49$exports = {};

$a68c39abac281a49$exports = new URL((parcelRequire("27Lyk")).resolve("dNG8e"), import.meta.url).toString();


var $0abb3f3ffb199793$exports = {};

$0abb3f3ffb199793$exports = new URL((parcelRequire("27Lyk")).resolve("5MYiX"), import.meta.url).toString();


var $4ebf92e31c3a38bc$exports = {};

$4ebf92e31c3a38bc$exports = new URL((parcelRequire("27Lyk")).resolve("fstvv"), import.meta.url).toString();


var $9cc2e2637b603ca5$exports = {};

$9cc2e2637b603ca5$exports = new URL((parcelRequire("27Lyk")).resolve("2HJ4K"), import.meta.url).toString();


var $32dd24fe872a570f$exports = {};

$32dd24fe872a570f$exports = new URL((parcelRequire("27Lyk")).resolve("gHLCs"), import.meta.url).toString();


var $d575829127674951$exports = {};

$d575829127674951$exports = new URL((parcelRequire("27Lyk")).resolve("5dD1I"), import.meta.url).toString();


var $9c0d25dbc9087bc2$exports = {};

$9c0d25dbc9087bc2$exports = new URL((parcelRequire("27Lyk")).resolve("dTGGU"), import.meta.url).toString();


var $28d3955afd727599$exports = {};

$28d3955afd727599$exports = new URL((parcelRequire("27Lyk")).resolve("3m2TW"), import.meta.url).toString();


var $b025fce33fc5041e$exports = {};

$b025fce33fc5041e$exports = new URL((parcelRequire("27Lyk")).resolve("2lLEx"), import.meta.url).toString();


var $3be62b1c497fd276$exports = {};

$3be62b1c497fd276$exports = new URL((parcelRequire("27Lyk")).resolve("4sV77"), import.meta.url).toString();


var $6272760c244d88ef$exports = {};

$6272760c244d88ef$exports = new URL((parcelRequire("27Lyk")).resolve("iLCG2"), import.meta.url).toString();


var $e384b6a852a5c3b6$exports = {};

$e384b6a852a5c3b6$exports = new URL((parcelRequire("27Lyk")).resolve("9h0QM"), import.meta.url).toString();


var $41718bfaf5d8e891$exports = {};

$41718bfaf5d8e891$exports = new URL((parcelRequire("27Lyk")).resolve("jJyq5"), import.meta.url).toString();


var $52ab470ee37a1ce7$exports = {};

$52ab470ee37a1ce7$exports = new URL((parcelRequire("27Lyk")).resolve("afp96"), import.meta.url).toString();


var $f2dda6ca0e01613d$exports = {};

$f2dda6ca0e01613d$exports = new URL((parcelRequire("27Lyk")).resolve("aZNeL"), import.meta.url).toString();


var $c61e5192674d26cb$exports = {};

$c61e5192674d26cb$exports = new URL((parcelRequire("27Lyk")).resolve("adDtv"), import.meta.url).toString();


var $d40bd4e75499b460$exports = {};

$d40bd4e75499b460$exports = new URL((parcelRequire("27Lyk")).resolve("l3mpI"), import.meta.url).toString();


var $1d9cf7750c889a34$exports = {};

$1d9cf7750c889a34$exports = new URL((parcelRequire("27Lyk")).resolve("5p7s8"), import.meta.url).toString();


var $334f17657df10685$exports = {};

$334f17657df10685$exports = new URL((parcelRequire("27Lyk")).resolve("6R59M"), import.meta.url).toString();


var $bd1326a0e9447942$exports = {};

$bd1326a0e9447942$exports = new URL((parcelRequire("27Lyk")).resolve("esfjq"), import.meta.url).toString();


var $b920186af79880a7$exports = {};

$b920186af79880a7$exports = new URL((parcelRequire("27Lyk")).resolve("3yV2V"), import.meta.url).toString();


var $7cb3fd417e67a16b$exports = {};

$7cb3fd417e67a16b$exports = new URL((parcelRequire("27Lyk")).resolve("5Iuar"), import.meta.url).toString();


var $6987609c80ac4246$exports = {};

$6987609c80ac4246$exports = new URL((parcelRequire("27Lyk")).resolve("2z0ho"), import.meta.url).toString();


var $7e84c8f9a31f1ffb$exports = {};

$7e84c8f9a31f1ffb$exports = new URL((parcelRequire("27Lyk")).resolve("aMV3n"), import.meta.url).toString();


$b5daafc8fcdb02e6$exports = {
    "legend_1": $b441afe4fd4449f4$exports,
    "legend_10": $65b43c39a0c9d4aa$exports,
    "legend_2": $662d69b42dc41dfb$exports,
    "legend_3": $c45f92d6c7a5ab24$exports,
    "legend_4": $c032f09245a85392$exports,
    "legend_5": $8e9dfb407e8a40ea$exports,
    "legend_6": $5259cb5887383a0c$exports,
    "legend_7": $073ea80adac71746$exports,
    "legend_8": $599ad2246eb7fa18$exports,
    "legend_9": $92840093777dcc9d$exports,
    "level_1": $69e257862e220fe3$exports,
    "level_10": $f30e5255b6a2ffd1$exports,
    "level_11": $acfd55f1afd98d9f$exports,
    "level_12": $f7bf4c39fb366607$exports,
    "level_13": $8e768a4d09a82d76$exports,
    "level_14": $4880f48caba72e79$exports,
    "level_15": $fd60eef85d421c11$exports,
    "level_16": $6841fb6ae0702768$exports,
    "level_17": $8b4ae015b3fad810$exports,
    "level_18": $d8a32b055c356e98$exports,
    "level_19": $ec57ee981733b6d1$exports,
    "level_2": $c281926698b99d5b$exports,
    "level_20": $91150a20b8b1e207$exports,
    "level_21": $809e9f628fe8a992$exports,
    "level_22": $e236466448b151f1$exports,
    "level_23": $fbf97dae193bf434$exports,
    "level_24": $5f82ffd16de206de$exports,
    "level_25": $d0760a50f2b77bad$exports,
    "level_26": $e800f8483e2394b3$exports,
    "level_27": $9027a3ec19f25c48$exports,
    "level_28": $581708ea8b5f89f5$exports,
    "level_29": $44e0f7b9add32ba4$exports,
    "level_3": $3af54de073d50af4$exports,
    "level_30": $5501116ec145e76e$exports,
    "level_31": $60f36669ccdbe448$exports,
    "level_32": $4374ef023720bed2$exports,
    "level_33": $a68c39abac281a49$exports,
    "level_34": $0abb3f3ffb199793$exports,
    "level_35": $4ebf92e31c3a38bc$exports,
    "level_36": $9cc2e2637b603ca5$exports,
    "level_37": $32dd24fe872a570f$exports,
    "level_38": $d575829127674951$exports,
    "level_39": $9c0d25dbc9087bc2$exports,
    "level_4": $28d3955afd727599$exports,
    "level_40": $b025fce33fc5041e$exports,
    "level_41": $3be62b1c497fd276$exports,
    "level_42": $6272760c244d88ef$exports,
    "level_43": $e384b6a852a5c3b6$exports,
    "level_44": $41718bfaf5d8e891$exports,
    "level_45": $52ab470ee37a1ce7$exports,
    "level_46": $f2dda6ca0e01613d$exports,
    "level_47": $c61e5192674d26cb$exports,
    "level_48": $d40bd4e75499b460$exports,
    "level_49": $1d9cf7750c889a34$exports,
    "level_5": $334f17657df10685$exports,
    "level_50": $bd1326a0e9447942$exports,
    "level_6": $b920186af79880a7$exports,
    "level_7": $7cb3fd417e67a16b$exports,
    "level_8": $6987609c80ac4246$exports,
    "level_9": $7e84c8f9a31f1ffb$exports
};




parcelRequire("acw62");

var $kQaj4 = parcelRequire("kQaj4");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $f9tk6 = parcelRequire("f9tk6");

var $kQaj4 = parcelRequire("kQaj4");

var $9GbWv = parcelRequire("9GbWv");

var $6e8aa1abedd3c8d1$var$TRANSITION_DURATION = 4; // seconds
var $6e8aa1abedd3c8d1$export$9dd6ff9ea0189349 = function styles(theme) {
    var getColor = function getColor(color) {
        return theme.palette.type === "light" ? (0, $9GbWv.lighten)(color, 0.62) : (0, $9GbWv.darken)(color, 0.5);
    };
    var backgroundPrimary = getColor(theme.palette.primary.main);
    var backgroundSecondary = getColor(theme.palette.secondary.main);
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            overflow: "hidden",
            height: 4,
            "@media print": {
                colorAdjust: "exact"
            }
        },
        /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */ colorPrimary: {
            backgroundColor: backgroundPrimary
        },
        /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */ colorSecondary: {
            backgroundColor: backgroundSecondary
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {},
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {},
        /* Styles applied to the root element if `variant="buffer"`. */ buffer: {
            backgroundColor: "transparent"
        },
        /* Styles applied to the root element if `variant="query"`. */ query: {
            transform: "rotate(180deg)"
        },
        /* Styles applied to the additional bar element if `variant="buffer"`. */ dashed: {
            position: "absolute",
            marginTop: 0,
            height: "100%",
            width: "100%",
            animation: "$buffer 3s infinite linear"
        },
        /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */ dashedColorPrimary: {
            backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
            backgroundSize: "10px 10px",
            backgroundPosition: "0 -23px"
        },
        /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */ dashedColorSecondary: {
            backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
            backgroundSize: "10px 10px",
            backgroundPosition: "0 -23px"
        },
        /* Styles applied to the layered bar1 and bar2 elements. */ bar: {
            width: "100%",
            position: "absolute",
            left: 0,
            bottom: 0,
            top: 0,
            transition: "transform 0.2s linear",
            transformOrigin: "left"
        },
        /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */ barColorPrimary: {
            backgroundColor: theme.palette.primary.main
        },
        /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */ barColorSecondary: {
            backgroundColor: theme.palette.secondary.main
        },
        /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */ bar1Indeterminate: {
            width: "auto",
            animation: "$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite"
        },
        /* Styles applied to the bar1 element if `variant="determinate"`. */ bar1Determinate: {
            transition: "transform .".concat($6e8aa1abedd3c8d1$var$TRANSITION_DURATION, "s linear")
        },
        /* Styles applied to the bar1 element if `variant="buffer"`. */ bar1Buffer: {
            zIndex: 1,
            transition: "transform .".concat($6e8aa1abedd3c8d1$var$TRANSITION_DURATION, "s linear")
        },
        /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */ bar2Indeterminate: {
            width: "auto",
            animation: "$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite"
        },
        /* Styles applied to the bar2 element if `variant="buffer"`. */ bar2Buffer: {
            transition: "transform .".concat($6e8aa1abedd3c8d1$var$TRANSITION_DURATION, "s linear")
        },
        // Legends:
        // || represents the viewport
        // -  represents a light background
        // x  represents a dark background
        "@keyframes indeterminate1": {
            //  |-----|---x-||-----||-----|
            "0%": {
                left: "-35%",
                right: "100%"
            },
            //  |-----|-----||-----||xxxx-|
            "60%": {
                left: "100%",
                right: "-90%"
            },
            "100%": {
                left: "100%",
                right: "-90%"
            }
        },
        "@keyframes indeterminate2": {
            //  |xxxxx|xxxxx||-----||-----|
            "0%": {
                left: "-200%",
                right: "100%"
            },
            //  |-----|-----||-----||-x----|
            "60%": {
                left: "107%",
                right: "-8%"
            },
            "100%": {
                left: "107%",
                right: "-8%"
            }
        },
        "@keyframes buffer": {
            "0%": {
                opacity: 1,
                backgroundPosition: "0 -23px"
            },
            "50%": {
                opacity: 0,
                backgroundPosition: "0 -23px"
            },
            "100%": {
                opacity: 1,
                backgroundPosition: "-200px -23px"
            }
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $6e8aa1abedd3c8d1$var$LinearProgress = /*#__PURE__*/ $acw62.forwardRef(function LinearProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, value = props.value, valueBuffer = props.valueBuffer, _props$variant = props.variant, variant = _props$variant === void 0 ? "indeterminate" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "color",
        "value",
        "valueBuffer",
        "variant"
    ]);
    var theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    var rootProps = {};
    var inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            var transform = value - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            var _transform = (valueBuffer || 0) - 100;
            if (theme.direction === "rtl") _transform = -_transform;
            inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
        }
    }
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes["color".concat((0, $f9tk6.default)(color))], className, {
            "determinate": classes.determinate,
            "indeterminate": classes.indeterminate,
            "buffer": classes.buffer,
            "query": classes.query
        }[variant]),
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other), variant === "buffer" ? /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $1SA7b.default)(classes.dashed, classes["dashedColor".concat((0, $f9tk6.default)(color))])
    }) : null, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $1SA7b.default)(classes.bar, classes["barColor".concat((0, $f9tk6.default)(color))], (variant === "indeterminate" || variant === "query") && classes.bar1Indeterminate, {
            "determinate": classes.bar1Determinate,
            "buffer": classes.bar1Buffer
        }[variant]),
        style: inlineStyles.bar1
    }), variant === "determinate" ? null : /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $1SA7b.default)(classes.bar, (variant === "indeterminate" || variant === "query") && classes.bar2Indeterminate, variant === "buffer" ? [
            classes["color".concat((0, $f9tk6.default)(color))],
            classes.bar2Buffer
        ] : classes["barColor".concat((0, $f9tk6.default)(color))]),
        style: inlineStyles.bar2
    }));
});
var $6e8aa1abedd3c8d1$export$2e2bcd8739ae039 = (0, $kQaj4.default)($6e8aa1abedd3c8d1$export$9dd6ff9ea0189349, {
    name: "MuiLinearProgress"
})($6e8aa1abedd3c8d1$var$LinearProgress);


const $063a2ffe7d6b7652$var$BorderLinearProgress = (0, $kQaj4.default)((theme)=>({
        root: {
            height: 10,
            borderRadius: 8
        },
        colorPrimary: {
            backgroundColor: "#141F2A"
        },
        bar: {
            borderRadius: 8,
            background: "linear-gradient(90deg, rgba(153, 49, 252, 0.75) 0%, rgba(194, 117, 234, 0.75) 95%)",
            boxShadow: "0px 0px 16px 0px #DC04FF99"
        }
    }))((0, $6e8aa1abedd3c8d1$export$2e2bcd8739ae039));
const $063a2ffe7d6b7652$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)({
    root: {
        flexGrow: 1,
        maxWidth: 240,
        minWidth: 0,
        width: "auto"
    }
});
function $063a2ffe7d6b7652$export$2e2bcd8739ae039({ exp_value: exp_value  }) {
    const classes = $063a2ffe7d6b7652$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($063a2ffe7d6b7652$var$BorderLinearProgress, {
            variant: "determinate",
            value: exp_value
        })
    });
}



var $335165b9132fbda2$exports = {};
"use strict";


Object.defineProperty($335165b9132fbda2$exports, "__esModule", {
    value: true
});
$335165b9132fbda2$exports.default = void 0;

var $335165b9132fbda2$var$React = $27c3440315f0d929$exports((parcelRequire("acw62")));

var $335165b9132fbda2$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("iAQWD")));
var $335165b9132fbda2$var$_default = (0, $335165b9132fbda2$var$_createSvgIcon.default)(/*#__PURE__*/ $335165b9132fbda2$var$React.createElement("path", {
    d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
}), "LockOpen");
$335165b9132fbda2$exports.default = $335165b9132fbda2$var$_default;


function $de708537bc6d55c6$var$GetLevelClass(level, legend) {
    if (legend > 0) switch(legend){
        case 1:
            return "legend_1";
        case 2:
            return "legend_2";
        case 3:
            return "legend_3";
        case 4:
            return "legend_4";
        case 5:
            return "legend_5";
        case 6:
            return "legend_6";
        case 7:
            return "legend_7";
        case 8:
            return "legend_8";
        case 9:
            return "legend_9";
        case 10:
            return "legend_10";
    }
    else switch(level){
        case 1:
            return "level_1";
        case 2:
            return "level_2";
        case 3:
            return "level_3";
        case 4:
            return "level_4";
        case 5:
            return "level_5";
        case 6:
            return "level_6";
        case 7:
            return "level_7";
        case 8:
            return "level_8";
        case 9:
            return "level_9";
        case 10:
            return "level_10";
        case 11:
            return "level_11";
        case 12:
            return "level_12";
        case 13:
            return "level_13";
        case 14:
            return "level_14";
        case 15:
            return "level_15";
        case 16:
            return "level_16";
        case 17:
            return "level_17";
        case 18:
            return "level_18";
        case 19:
            return "level_19";
        case 20:
            return "level_20";
        case 21:
            return "level_21";
        case 22:
            return "level_22";
        case 23:
            return "level_23";
        case 24:
            return "level_24";
        case 25:
            return "level_25";
        case 26:
            return "level_26";
        case 27:
            return "level_27";
        case 28:
            return "level_28";
        case 29:
            return "level_29";
        case 30:
            return "level_30";
        case 31:
            return "level_31";
        case 32:
            return "level_32";
        case 33:
            return "level_33";
        case 34:
            return "level_34";
        case 35:
            return "level_35";
        case 36:
            return "level_36";
        case 37:
            return "level_37";
        case 38:
            return "level_38";
        case 39:
            return "level_39";
        case 40:
            return "level_40";
        case 41:
            return "level_41";
        case 42:
            return "level_42";
        case 43:
            return "level_43";
        case 44:
            return "level_44";
        case 45:
            return "level_45";
        case 46:
            return "level_46";
        case 47:
            return "level_47";
        case 48:
            return "level_48";
        case 49:
            return "level_49";
        case 50:
            return "level_50";
    }
}
const $de708537bc6d55c6$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            margin: "1em"
        },
        data_container2: {
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            marginLeft: "1em",
            maxWidth: "500px",
            minWidth: "240px"
        },
        container: {
            display: "grid",
            gridTemplateColumns: "min-content min-content",
            gridTemplateRows: "auto",
            gap: "0px 0px",
            gridTemplateAreas: "'avatar data'"
        },
        avatar_container: {
            gridArea: "avatar",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        data_container: {
            gridArea: "data",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            marginBottom: "1em"
        },
        avatar: {
            width: "5em",
            height: "5em"
        },
        exp_bar_container: {
            width: "100%",
            height: "auto"
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        },
        rank_icon: {
            width: "3em",
            height: "3em",
            marginRight: "1em"
        }
    }));
function $de708537bc6d55c6$export$2e2bcd8739ae039({ playerName: playerName , playerLevel: playerLevel , playerLegend: playerLegend , playerCurrentExp: playerCurrentExp , playerLevelupExp: playerLevelupExp , playerPfpUrl: playerPfpUrl , playerAccountType: playerAccountType  }) {
    const classes = $de708537bc6d55c6$var$useStyles();
    const level_class = $de708537bc6d55c6$var$GetLevelClass(playerLevel, playerLegend);
    const img_src = (0, (/*@__PURE__*/$parcel$interopDefault($b5daafc8fcdb02e6$exports)))[level_class];
    const percent = playerLevelupExp / 100;
    const percent2 = playerCurrentExp / percent;
    console.log(playerPfpUrl);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: classes.avatar_container,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ea67090213a71b$export$2e2bcd8739ae039), {
                        variant: "rounded",
                        className: classes.avatar,
                        src: playerPfpUrl
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: classes.data_container2,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    style: {
                                        fontWeight: "bold",
                                        fontSize: "32px",
                                        lineHeight: "32px",
                                        marginRight: "0.3em"
                                    },
                                    children: playerName
                                }),
                                playerAccountType === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec92ca55cb2fca7f$export$2e2bcd8739ae039), {
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($335165b9132fbda2$exports))), {}),
                                    label: "Unlocked account",
                                    size: "small",
                                    color: "secondary"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: classes.data_container,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    className: classes.rank_icon,
                                    src: img_src
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                            children: [
                                                "Level ",
                                                playerLevel
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                            children: [
                                                "Legend ",
                                                playerLegend
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: classes.exp_bar_container,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $063a2ffe7d6b7652$export$2e2bcd8739ae039), {
                                    exp_value: Math.round(percent2)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                    style: {
                                        marginTop: "0.3em"
                                    },
                                    children: [
                                        playerCurrentExp,
                                        "/",
                                        playerLevelupExp
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



parcelRequire("acw62");



parcelRequire("acw62");

const $5ad3b933ba31f0a7$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            margin: 15,
            width: 570,
            height: 636,
            /* Blue/700 (2 L) */ background: "#304254",
            /* Blue/600 */ border: "1px solid #3E5270",
            boxSizing: "border-box",
            borderRadius: 8
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        },
        CustomIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24"
        },
        sswidget_container: {
            display: "inline-flex",
            flexDirection: "column",
            flexWrap: "wrap",
            fontFamily: "Ubuntu",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "16px",
            marginTop: "1em",
            marginBottom: "1em",
            /* identical to box height, or 25px */ /* Blue / 50 */ color: "#92929F"
        },
        sswidget_icon_value: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            fontWeight: "bold",
            color: "#E6E6E6"
        },
        sswidgets_container: {
            display: "flex",
            maxWidth: "600px",
            maxHeight: "180px",
            flexWrap: "wrap",
            flexDirection: "column",
            margin: "1em"
        }
    }));
function $5ad3b933ba31f0a7$var$GetIcon({ statName: statName  }) {
    switch(statName){
        case "statRaces":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$77afd8b5a8f1e556), {});
        case "statLevel":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$77afd8b5a8f1e556), {});
        case "statFans":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$919f9e6aad25b3cc), {});
        case "statRaceTime":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$7e95adcf912503e3), {});
        case "statDriverScore":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$5a540ecc9c1f0346), {});
        case "statTop3":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$64d17932e486b075), {});
        case "statFirst":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$7f5f9f33dccbc355), {});
        case "statHits":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$7a09e274d1b493bd), {});
        case "statFired":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$5e7ca23b710499b9), {});
        case "statWrecked":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$7051e699fb15be2d), {});
        case "statLegend":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$d3e24e2ed1fd2185), {});
    }
}
const $5ad3b933ba31f0a7$var$statNames = {
    statRaces: "general_values_names.total_race",
    statLevel: "general_values_names.level",
    statFans: "general_values_names.fans",
    statRaceTime: "general_values_names.total_time",
    statDriverScore: "general_values_names.driving_score",
    statTop3: "general_values_names.top3",
    statFirst: "general_values_names.first",
    statHits: "general_values_names.hits",
    statFired: "general_values_names.fired",
    statWrecked: "general_values_names.wrecked",
    statLegend: "general_values_names.legend"
};
function $5ad3b933ba31f0a7$var$GetStatName(statName) {
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return t($5ad3b933ba31f0a7$var$statNames[statName]);
}
function $5ad3b933ba31f0a7$export$2e2bcd8739ae039({ statName: statName , value: value  }) {
    const classes = $5ad3b933ba31f0a7$var$useStyles();
    let value2 = value;
    const SECONDS_PER_DAY = 86400;
    const HOURS_PER_DAY = 24;
    const secondsToHms = (seconds)=>{
        const days = Math.floor(seconds / SECONDS_PER_DAY);
        const remainderSeconds = seconds % SECONDS_PER_DAY;
        const hms = new Date(remainderSeconds * 1000).toISOString().substring(11, 19);
        return hms.replace(/^(\d+)/, (h)=>`${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0"));
    };
    if (statName === "statRaceTime") value2 = secondsToHms(value / 1000);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: classes.sswidget_container,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: classes.sswidget_icon_value,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5ad3b933ba31f0a7$var$GetIcon, {
                        statName: statName
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        style: {
                            marginLeft: "0.3em"
                        },
                        children: value2
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                children: $5ad3b933ba31f0a7$var$GetStatName(statName)
            })
        ]
    });
}





const $343ef8de79b5e1cc$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            margin: 15,
            width: 570,
            height: 636,
            /* Blue/700 (2 L) */ background: "#304254",
            /* Blue/600 */ border: "1px solid #3E5270",
            boxSizing: "border-box",
            borderRadius: 8
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        },
        CustomIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24"
        },
        sswidget_container: {
            width: "33%",
            fontFamily: "Ubuntu",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "16px",
            marginTop: "1em",
            marginBottom: "1em",
            /* identical to box height, or 25px */ /* Blue / 50 */ color: "#92929F"
        },
        sswidget_icon_value: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            fontWeight: "bold",
            color: "#E6E6E6"
        },
        sswidgets_container: {
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            marginTop: "1em",
            maxWidth: "600px",
            columnGap: "1%",
            justifyContent: "space-around"
        },
        stats_career_container: {
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "column",
            width: "30%"
        }
    }));
function $343ef8de79b5e1cc$export$2e2bcd8739ae039({ playerStatsData: playerStatsData  }) {
    const classes = $343ef8de79b5e1cc$var$useStyles();
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                className: "session_item_name",
                children: t("profile_stats.stats")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: classes.sswidgets_container,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: classes.stats_career_container,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: t("profile_stats.career")
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad3b933ba31f0a7$export$2e2bcd8739ae039), {
                                statName: "statFans",
                                value: playerStatsData.statFans
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad3b933ba31f0a7$export$2e2bcd8739ae039), {
                                statName: "statDriverScore",
                                value: playerStatsData.statDriverScore
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad3b933ba31f0a7$export$2e2bcd8739ae039), {
                                statName: "statLegend",
                                value: playerStatsData.statLegend
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad3b933ba31f0a7$export$2e2bcd8739ae039), {
                                statName: "statRaceTime",
                                value: playerStatsData.statRaceTime
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: classes.stats_career_container,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: t("profile_stats.combat")
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad3b933ba31f0a7$export$2e2bcd8739ae039), {
                                statName: "statFired",
                                value: playerStatsData.statFired
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad3b933ba31f0a7$export$2e2bcd8739ae039), {
                                statName: "statHits",
                                value: playerStatsData.statHits
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad3b933ba31f0a7$export$2e2bcd8739ae039), {
                                statName: "statWrecked",
                                value: playerStatsData.statWrecked
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: classes.stats_career_container,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: t("profile_stats.racing")
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad3b933ba31f0a7$export$2e2bcd8739ae039), {
                                statName: "statRaces",
                                value: playerStatsData.statRaces
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad3b933ba31f0a7$export$2e2bcd8739ae039), {
                                statName: "statFirst",
                                value: playerStatsData.statFirst
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad3b933ba31f0a7$export$2e2bcd8739ae039), {
                                statName: "statTop3",
                                value: playerStatsData.statTop3
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




parcelRequire("acw62");




var $74bc2ce52eb5326a$exports = {};
var $b48906c4c49fae06$exports = {};

$b48906c4c49fae06$exports = new URL((parcelRequire("27Lyk")).resolve("jQ9md"), import.meta.url).toString();


var $1a38c32db16ad64a$exports = {};

$1a38c32db16ad64a$exports = new URL((parcelRequire("27Lyk")).resolve("85dGe"), import.meta.url).toString();


var $0ca999fd1c0e78d2$exports = {};

$0ca999fd1c0e78d2$exports = new URL((parcelRequire("27Lyk")).resolve("81G18"), import.meta.url).toString();


var $2655af346407e15b$exports = {};

$2655af346407e15b$exports = new URL((parcelRequire("27Lyk")).resolve("aJmsA"), import.meta.url).toString();


var $516793c4a5e8ede2$exports = {};

$516793c4a5e8ede2$exports = new URL((parcelRequire("27Lyk")).resolve("e7AiD"), import.meta.url).toString();


var $e6992db440c393f4$exports = {};

$e6992db440c393f4$exports = new URL((parcelRequire("27Lyk")).resolve("pHfAV"), import.meta.url).toString();


var $d49130fc369f76ef$exports = {};

$d49130fc369f76ef$exports = new URL((parcelRequire("27Lyk")).resolve("LdmUD"), import.meta.url).toString();


var $162efa20e35f6582$exports = {};

$162efa20e35f6582$exports = new URL((parcelRequire("27Lyk")).resolve("8ZqLF"), import.meta.url).toString();


var $b6c8383c5c308867$exports = {};

$b6c8383c5c308867$exports = new URL((parcelRequire("27Lyk")).resolve("2ZwBL"), import.meta.url).toString();


var $0962fa91859c263f$exports = {};

$0962fa91859c263f$exports = new URL((parcelRequire("27Lyk")).resolve("19Otj"), import.meta.url).toString();


var $8b2f2b61952087bc$exports = {};

$8b2f2b61952087bc$exports = new URL((parcelRequire("27Lyk")).resolve("jIVZX"), import.meta.url).toString();


var $4f145aa5983962ef$exports = {};

$4f145aa5983962ef$exports = new URL((parcelRequire("27Lyk")).resolve("fdIOJ"), import.meta.url).toString();


var $0e9326ca432f710d$exports = {};

$0e9326ca432f710d$exports = new URL((parcelRequire("27Lyk")).resolve("59224"), import.meta.url).toString();


var $4a1d27eb713bc537$exports = {};

$4a1d27eb713bc537$exports = new URL((parcelRequire("27Lyk")).resolve("l1B3E"), import.meta.url).toString();


var $39df1de37b002e1d$exports = {};

$39df1de37b002e1d$exports = new URL((parcelRequire("27Lyk")).resolve("eyckC"), import.meta.url).toString();


var $885e90a8b9eadd93$exports = {};

$885e90a8b9eadd93$exports = new URL((parcelRequire("27Lyk")).resolve("c3oJM"), import.meta.url).toString();


var $9a8059ddedeb3158$exports = {};

$9a8059ddedeb3158$exports = new URL((parcelRequire("27Lyk")).resolve("bixxK"), import.meta.url).toString();


var $e7d7cc99c0485d21$exports = {};

$e7d7cc99c0485d21$exports = new URL((parcelRequire("27Lyk")).resolve("4DNcJ"), import.meta.url).toString();


var $c592ba8767e29b81$exports = {};

$c592ba8767e29b81$exports = new URL((parcelRequire("27Lyk")).resolve("6KS0c"), import.meta.url).toString();


var $b77fbf613c7f914f$exports = {};

$b77fbf613c7f914f$exports = new URL((parcelRequire("27Lyk")).resolve("k9whq"), import.meta.url).toString();


var $257bdeb4a28668bb$exports = {};

$257bdeb4a28668bb$exports = new URL((parcelRequire("27Lyk")).resolve("30Xtt"), import.meta.url).toString();


var $99f8422a82acbf6b$exports = {};

$99f8422a82acbf6b$exports = new URL((parcelRequire("27Lyk")).resolve("kqnvE"), import.meta.url).toString();


var $389c89f90af5b574$exports = {};

$389c89f90af5b574$exports = new URL((parcelRequire("27Lyk")).resolve("fGZa8"), import.meta.url).toString();


var $0abe8fd6ada4f627$exports = {};

$0abe8fd6ada4f627$exports = new URL((parcelRequire("27Lyk")).resolve("4McdS"), import.meta.url).toString();


var $341325dc1925e151$exports = {};

$341325dc1925e151$exports = new URL((parcelRequire("27Lyk")).resolve("1jpa7"), import.meta.url).toString();


$74bc2ce52eb5326a$exports = {
    "battering_ram": $b48906c4c49fae06$exports,
    "bribe": $1a38c32db16ad64a$exports,
    "decoy_drop": $0ca999fd1c0e78d2$exports,
    "drifter": $2655af346407e15b$exports,
    "ecm": $516793c4a5e8ede2$exports,
    "fan_favourite": $e6992db440c393f4$exports,
    "front_runner": $d49130fc369f76ef$exports,
    "iron_fist": $162efa20e35f6582$exports,
    "jump_the_gun": $b6c8383c5c308867$exports,
    "laser_sight": $0962fa91859c263f$exports,
    "last_gasp": $8b2f2b61952087bc$exports,
    "magnetic_field": $4f145aa5983962ef$exports,
    "mastermine": $0e9326ca432f710d$exports,
    "placeholder": $4a1d27eb713bc537$exports,
    "safety_net": $39df1de37b002e1d$exports,
    "scrambler": $885e90a8b9eadd93$exports,
    "shielded_bay": $9a8059ddedeb3158$exports,
    "shielded_boosters": $e7d7cc99c0485d21$exports,
    "shielding_efficency": $c592ba8767e29b81$exports,
    "showy_flourish": $b77fbf613c7f914f$exports,
    "silent_running": $257bdeb4a28668bb$exports,
    "splash_damage": $99f8422a82acbf6b$exports,
    "stable_frame": $389c89f90af5b574$exports,
    "titanium_armor": $0abe8fd6ada4f627$exports,
    "vampiric_wreck": $341325dc1925e151$exports
};


parcelRequire("acw62");
function $aa47401a2d50c587$var$get_mod_icon(mod_id) {
    let mod_icon = "iron_fist";
    switch(mod_id){
        case 1:
            mod_icon = "iron_fist";
            break;
        case 2:
            mod_icon = "jump_the_gun";
            break;
        case 3:
            mod_icon = "front_runner";
            break;
        case 4:
            mod_icon = "drifter";
            break;
        case 5:
            mod_icon = "titanium_armor";
            break;
        case 6:
            mod_icon = "showy_flourish";
            break;
        case 7:
            mod_icon = "stable_frame";
            break;
        case 8:
            mod_icon = "battering_ram";
            break;
        case 9:
            mod_icon = "decoy_drop" //decoy drop
            ;
            break;
        case 10:
            mod_icon = "magnetic_field" //magnetic field
            ;
            break;
        case 11:
            mod_icon = "scrambler";
            break;
        case 12:
            mod_icon = "splash_damage";
            break;
        case 13:
            mod_icon = "shielding_efficency";
            break;
        case 14:
            mod_icon = "safety_net";
            break;
        case 15:
            mod_icon = "shielded_boosters";
            break;
        case 16:
            mod_icon = "shielded_bay";
            break;
        case 17:
            mod_icon = "ecm";
            break;
        case 18:
            mod_icon = "vampiric_wreck" // vampiric
            ;
            break;
        case 19:
            mod_icon = "bribe";
            break;
        case 20:
            mod_icon = "fan_favourite";
            break;
        case 21:
            mod_icon = "laser_sight";
            break;
        // case 22:
        //     mod_icon = "placeholder" // Advanced radar
        //     break;
        case 22:
            mod_icon = "silent_running";
            break;
        case 23:
            mod_icon = "last_gasp";
            break;
        case 24:
            mod_icon = "mastermine";
            break;
        default:
            mod_icon = "placeholder";
    }
    return mod_icon;
}
function $aa47401a2d50c587$export$2e2bcd8739ae039({ mod1: mod1 , mod2: mod2 , mod3: mod3 , mod1_name: mod1_name , mod2_name: mod2_name , mod3_name: mod3_name  }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mod_slots_container",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mod_slot",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($74bc2ce52eb5326a$exports)))[$aa47401a2d50c587$var$get_mod_icon(mod1)],
                    className: "mod_icon2",
                    alt: mod1_name
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mod_slot",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($74bc2ce52eb5326a$exports)))[$aa47401a2d50c587$var$get_mod_icon(mod2)],
                    className: "mod_icon2",
                    alt: mod2_name
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mod_slot",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($74bc2ce52eb5326a$exports)))[$aa47401a2d50c587$var$get_mod_icon(mod3)],
                    className: "mod_icon2",
                    alt: mod3_name
                })
            })
        ]
    });
}




var $45fvw = parcelRequire("45fvw");
const $7804fcaa8b5f4cf9$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            width: "100%",
            position: "relative"
        },
        past_race_data_container: {
            display: "flex",
            flexWrap: "nowrap",
            flexDirection: "row",
            justifyItems: "center",
            alignItems: "center",
            margin: "1em"
        },
        position_label: {
            fontWeight: "bold",
            fontSize: "25px",
            marginRight: "0.3em"
        },
        divider: {
            marginLeft: "auto"
        },
        mods_container: {
            width: "9em"
        },
        top1: {
            background: "linear-gradient(90deg, rgba(201,176,55,0.15) 0%, rgba(0,0,0,0) 100%)",
            position: "absolute",
            top: "0",
            left: "0",
            width: "50%",
            height: "100%",
            borderRadius: "5px"
        },
        top2: {
            background: "linear-gradient(90deg, rgba(215,215,215,0.15) 0%, rgba(0,0,0,0) 100%)",
            position: "absolute",
            top: "0",
            left: "0",
            width: "50%",
            height: "100%",
            borderRadius: "5px"
        },
        top3: {
            background: "linear-gradient(90deg, rgba(106,56,5,0.15) 0%, rgba(0,0,0,0) 100%)",
            position: "absolute",
            top: "0",
            left: "0",
            width: "50%",
            height: "100%",
            borderRadius: "5px"
        }
    }));
function $7804fcaa8b5f4cf9$export$2e2bcd8739ae039({ data: data  }) {
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $7804fcaa8b5f4cf9$var$useStyles();
    function Top3Classes(pos) {
        if (pos === 1) return classes.top1;
        else if (pos === 2) return classes.top2;
        else if (pos === 3) return classes.top3;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ca4ada9c808bb355$export$2e2bcd8739ae039), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: classes.past_race_data_container,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: classes.position_label,
                        children: "#" + data.finish_pos
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            data.player_car_name,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            $45fvw(data.timestamp).local().format("M/D/YYYY- h:mm A z")
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: classes.divider
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: classes.mods_container,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa47401a2d50c587$export$2e2bcd8739ae039), {
                            mod1: data.mod_1_id,
                            mod2: data.mod_2_id,
                            mod3: data.mod_3_id,
                            mod1_name: data.mod_1_name,
                            mod2_name: data.mod_2_name,
                            mod3_name: data.mod_3_name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: Top3Classes(data.finish_pos)
            })
        ]
    });
}


const $1508af06736eabc0$var$AMAX_API_URL = "https://amax-emu.com/api";
const $1508af06736eabc0$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            flexGrow: 1,
            alignItems: "flex-end",
            // minWidth: 400,
            maxWidth: "800px"
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "50%",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        }
    }));
function $1508af06736eabc0$export$2e2bcd8739ae039({ player_name: player_name  }) {
    const classes = $1508af06736eabc0$var$useStyles();
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    let [session_data, setData] = $acw62.useState(undefined);
    let [dataRequested, setRequestStatus] = $acw62.useState(false);
    const RenderPlayerPastRaces = ()=>{
        if (dataRequested) return session_data.data.map((session_data)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7804fcaa8b5f4cf9$export$2e2bcd8739ae039), {
                data: session_data
            }));
        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: classes.spinner,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a36c7122d0aec5cd$export$2e2bcd8739ae039), {})
        });
    };
    // Lucas:
    // Functions passed to useEffect cannot be async.
    $acw62.useEffect(()=>{
        async function getSessionsData() {
            const resp = await fetch($1508af06736eabc0$var$AMAX_API_URL + "/players/past_races/player/name/" + player_name, {
                method: "GET",
                headers: {
                    "content-type": "application/json;charset=UTF-8"
                }
            });
            setData(await resp.json());
            setRequestStatus(true);
        }
        getSessionsData().catch(()=>{});
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                className: "session_item_name",
                children: t("profile_stats.pastraces")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RenderPlayerPastRaces, {})
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






var $9X7IJ = parcelRequire("9X7IJ");

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $3Z9df = parcelRequire("3Z9df");

var $acw62 = parcelRequire("acw62");






function $883b5fac682906d7$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $883b5fac682906d7$var$clickedRootScrollbar(event) {
    return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */ function $883b5fac682906d7$var$ClickAwayListener(props) {
    var children = props.children, _props$disableReactTr = props.disableReactTree, disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr, _props$mouseEvent = props.mouseEvent, mouseEvent = _props$mouseEvent === void 0 ? "onClick" : _props$mouseEvent, onClickAway = props.onClickAway, _props$touchEvent = props.touchEvent, touchEvent = _props$touchEvent === void 0 ? "onTouchEnd" : _props$touchEvent;
    var movedRef = $acw62.useRef(false);
    var nodeRef = $acw62.useRef(null);
    var activatedRef = $acw62.useRef(false);
    var syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(function() {
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(function() {
            activatedRef.current = true;
        }, 0);
        return function() {
            activatedRef.current = false;
        };
    }, []); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $acw62.useCallback(function(instance) {
        // #StrictMode ready
        nodeRef.current = $11492dca620dcaa5$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    var handleClickAway = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function(event) {
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        var insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || $883b5fac682906d7$var$clickedRootScrollbar(event)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else {
            // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
            var doc = (0, $837f0f05a75630be$export$2e2bcd8739ae039)(nodeRef.current);
            insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        }
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    var createHandleSynthetic = function createHandleSynthetic(handlerName) {
        return function(event) {
            syntheticEventRef.current = true;
            var childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    };
    var childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(function() {
        if (touchEvent !== false) {
            var mappedTouchEvent = $883b5fac682906d7$var$mapEventPropToEvent(touchEvent);
            var doc = (0, $837f0f05a75630be$export$2e2bcd8739ae039)(nodeRef.current);
            var handleTouchMove = function handleTouchMove() {
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return function() {
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(function() {
        if (mouseEvent !== false) {
            var mappedMouseEvent = $883b5fac682906d7$var$mapEventPropToEvent(mouseEvent);
            var doc = (0, $837f0f05a75630be$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return function() {
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.cloneElement(children, childrenProps));
}
var $883b5fac682906d7$export$2e2bcd8739ae039 = $883b5fac682906d7$var$ClickAwayListener;




var $f9tk6 = parcelRequire("f9tk6");




var $9X7IJ = parcelRequire("9X7IJ");

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");


var $9GbWv = parcelRequire("9GbWv");
var $7470edaef55eab56$export$9dd6ff9ea0189349 = function styles(theme) {
    var emphasis = theme.palette.type === "light" ? 0.8 : 0.98;
    var backgroundColor = (0, $9GbWv.emphasize)(theme.palette.background.default, emphasis);
    return {
        /* Styles applied to the root element. */ root: (0, $8nd05.default)({}, theme.typography.body2, (0, $kSlfw.default)({
            color: theme.palette.getContrastText(backgroundColor),
            backgroundColor: backgroundColor,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            flexGrow: 1
        }, theme.breakpoints.up("sm"), {
            flexGrow: "initial",
            minWidth: 288
        })),
        /* Styles applied to the message wrapper element. */ message: {
            padding: "8px 0"
        },
        /* Styles applied to the action wrapper element if `action` is provided. */ action: {
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
            paddingLeft: 16,
            marginRight: -8
        }
    };
};
var $7470edaef55eab56$var$SnackbarContent = /*#__PURE__*/ $acw62.forwardRef(function SnackbarContent(props, ref) {
    var action = props.action, classes = props.classes, className = props.className, message = props.message, _props$role = props.role, role = _props$role === void 0 ? "alert" : _props$role, other = (0, $9X7IJ.default)(props, [
        "action",
        "classes",
        "className",
        "message",
        "role"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $ca4ada9c808bb355$export$2e2bcd8739ae039), (0, $8nd05.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $acw62.createElement("div", {
        className: classes.message
    }, message), action ? /*#__PURE__*/ $acw62.createElement("div", {
        className: classes.action
    }, action) : null);
});
var $7470edaef55eab56$export$2e2bcd8739ae039 = (0, $kQaj4.default)($7470edaef55eab56$export$9dd6ff9ea0189349, {
    name: "MuiSnackbarContent"
})($7470edaef55eab56$var$SnackbarContent);


var $ad276c267b016f4b$export$9dd6ff9ea0189349 = function styles(theme) {
    var top1 = {
        top: 8
    };
    var bottom1 = {
        bottom: 8
    };
    var right = {
        justifyContent: "flex-end"
    };
    var left = {
        justifyContent: "flex-start"
    };
    var top3 = {
        top: 24
    };
    var bottom3 = {
        bottom: 24
    };
    var right3 = {
        right: 24
    };
    var left3 = {
        left: 24
    };
    var center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return {
        /* Styles applied to the root element. */ root: {
            zIndex: theme.zIndex.snackbar,
            position: "fixed",
            display: "flex",
            left: 8,
            right: 8,
            justifyContent: "center",
            alignItems: "center"
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */ anchorOriginTopCenter: (0, $8nd05.default)({}, top1, (0, $kSlfw.default)({}, theme.breakpoints.up("sm"), (0, $8nd05.default)({}, top3, center))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */ anchorOriginBottomCenter: (0, $8nd05.default)({}, bottom1, (0, $kSlfw.default)({}, theme.breakpoints.up("sm"), (0, $8nd05.default)({}, bottom3, center))),
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */ anchorOriginTopRight: (0, $8nd05.default)({}, top1, right, (0, $kSlfw.default)({}, theme.breakpoints.up("sm"), (0, $8nd05.default)({
            left: "auto"
        }, top3, right3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */ anchorOriginBottomRight: (0, $8nd05.default)({}, bottom1, right, (0, $kSlfw.default)({}, theme.breakpoints.up("sm"), (0, $8nd05.default)({
            left: "auto"
        }, bottom3, right3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */ anchorOriginTopLeft: (0, $8nd05.default)({}, top1, left, (0, $kSlfw.default)({}, theme.breakpoints.up("sm"), (0, $8nd05.default)({
            right: "auto"
        }, top3, left3))),
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */ anchorOriginBottomLeft: (0, $8nd05.default)({}, bottom1, left, (0, $kSlfw.default)({}, theme.breakpoints.up("sm"), (0, $8nd05.default)({
            right: "auto"
        }, bottom3, left3)))
    };
};
var $ad276c267b016f4b$var$Snackbar = /*#__PURE__*/ $acw62.forwardRef(function Snackbar(props, ref) {
    var action = props.action, _props$anchorOrigin = props.anchorOrigin;
    _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "bottom",
        horizontal: "center"
    } : _props$anchorOrigin;
    var vertical = _props$anchorOrigin.vertical, horizontal = _props$anchorOrigin.horizontal, _props$autoHideDurati = props.autoHideDuration, autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati, children = props.children, classes = props.classes, className = props.className, ClickAwayListenerProps = props.ClickAwayListenerProps, ContentProps = props.ContentProps, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, message = props.message, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, open = props.open, resumeHideDuration = props.resumeHideDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $c6861fdd26078775$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? {
        enter: (0, $3Z9df.duration).enteringScreen,
        exit: (0, $3Z9df.duration).leavingScreen
    } : _props$transitionDura, TransitionProps = props.TransitionProps, other = (0, $9X7IJ.default)(props, [
        "action",
        "anchorOrigin",
        "autoHideDuration",
        "children",
        "classes",
        "className",
        "ClickAwayListenerProps",
        "ContentProps",
        "disableWindowBlurListener",
        "message",
        "onClose",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "onMouseEnter",
        "onMouseLeave",
        "open",
        "resumeHideDuration",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var timerAutoHide = $acw62.useRef();
    var _React$useState = $acw62.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var handleClose = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = (0, $78f4792555064dc2$export$2e2bcd8739ae039)(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, "timeout");
        }, autoHideDurationParam);
    });
    $acw62.useEffect(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]); // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    var handlePause = function handlePause() {
        clearTimeout(timerAutoHide.current);
    }; // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    var handleResume = $acw62.useCallback(function() {
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (onMouseEnter) onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (onMouseLeave) onMouseLeave(event);
        handleResume();
    };
    var handleClickAway = function handleClickAway(event) {
        if (onClose) onClose(event, "clickaway");
    };
    var handleExited = function handleExited() {
        setExited(true);
    };
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    $acw62.useEffect(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return function() {
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]); // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $883b5fac682906d7$export$2e2bcd8739ae039), (0, $8nd05.default)({
        onClickAway: handleClickAway
    }, ClickAwayListenerProps), /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes["anchorOrigin".concat((0, $f9tk6.default)(vertical)).concat((0, $f9tk6.default)(horizontal))], className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: ref
    }, other), /*#__PURE__*/ $acw62.createElement(TransitionComponent, (0, $8nd05.default)({
        appear: true,
        in: open,
        onEnter: (0, $dc1f76fd676f9045$export$2e2bcd8739ae039)(handleEnter, onEnter),
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: (0, $dc1f76fd676f9045$export$2e2bcd8739ae039)(handleExited, onExited),
        onExiting: onExiting,
        timeout: transitionDuration,
        direction: vertical === "top" ? "down" : "up"
    }, TransitionProps), children || /*#__PURE__*/ $acw62.createElement((0, $7470edaef55eab56$export$2e2bcd8739ae039), (0, $8nd05.default)({
        message: message,
        action: action
    }, ContentProps)))));
});
var $ad276c267b016f4b$export$2e2bcd8739ae039 = (0, $kQaj4.default)($ad276c267b016f4b$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiSnackbar"
})($ad276c267b016f4b$var$Snackbar);



var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $9GbWv = parcelRequire("9GbWv");
var $kQaj4 = parcelRequire("kQaj4");


var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $cf37c8123755a0b9$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");



var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $5f945a35964239d6$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");



var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $0bc69f03bf559605$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");



var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $6437ee8c3e7f2673$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");



var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $060c895ce7b8911d$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");




var $f9tk6 = parcelRequire("f9tk6");
var $0f0bc7d23ffa3679$export$9dd6ff9ea0189349 = function styles(theme) {
    var getColor = theme.palette.type === "light" ? (0, $9GbWv.darken) : (0, $9GbWv.lighten);
    var getBackgroundColor = theme.palette.type === "light" ? (0, $9GbWv.lighten) : (0, $9GbWv.darken);
    return {
        /* Styles applied to the root element. */ root: (0, $8nd05.default)({}, theme.typography.body2, {
            borderRadius: theme.shape.borderRadius,
            backgroundColor: "transparent",
            display: "flex",
            padding: "6px 16px"
        }),
        /* Styles applied to the root element if `variant="standard"` and `color="success"`. */ standardSuccess: {
            color: getColor(theme.palette.success.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
            "& $icon": {
                color: theme.palette.success.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="info"`. */ standardInfo: {
            color: getColor(theme.palette.info.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
            "& $icon": {
                color: theme.palette.info.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */ standardWarning: {
            color: getColor(theme.palette.warning.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
            "& $icon": {
                color: theme.palette.warning.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="error"`. */ standardError: {
            color: getColor(theme.palette.error.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
            "& $icon": {
                color: theme.palette.error.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */ outlinedSuccess: {
            color: getColor(theme.palette.success.main, 0.6),
            border: "1px solid ".concat(theme.palette.success.main),
            "& $icon": {
                color: theme.palette.success.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */ outlinedInfo: {
            color: getColor(theme.palette.info.main, 0.6),
            border: "1px solid ".concat(theme.palette.info.main),
            "& $icon": {
                color: theme.palette.info.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */ outlinedWarning: {
            color: getColor(theme.palette.warning.main, 0.6),
            border: "1px solid ".concat(theme.palette.warning.main),
            "& $icon": {
                color: theme.palette.warning.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */ outlinedError: {
            color: getColor(theme.palette.error.main, 0.6),
            border: "1px solid ".concat(theme.palette.error.main),
            "& $icon": {
                color: theme.palette.error.main
            }
        },
        /* Styles applied to the root element if `variant="filled"` and `color="success"`. */ filledSuccess: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.success.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="info"`. */ filledInfo: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.info.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */ filledWarning: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.warning.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="error"`. */ filledError: {
            color: "#fff",
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.error.main
        },
        /* Styles applied to the icon wrapper element. */ icon: {
            marginRight: 12,
            padding: "7px 0",
            display: "flex",
            fontSize: 22,
            opacity: 0.9
        },
        /* Styles applied to the message wrapper element. */ message: {
            padding: "8px 0"
        },
        /* Styles applied to the action wrapper element if `action` is provided. */ action: {
            display: "flex",
            alignItems: "center",
            marginLeft: "auto",
            paddingLeft: 16,
            marginRight: -8
        }
    };
};
var $0f0bc7d23ffa3679$var$defaultIconMapping = {
    success: /*#__PURE__*/ $acw62.createElement((0, $cf37c8123755a0b9$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ $acw62.createElement((0, $5f945a35964239d6$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ $acw62.createElement((0, $0bc69f03bf559605$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ $acw62.createElement((0, $6437ee8c3e7f2673$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
var $0f0bc7d23ffa3679$var$_ref = /*#__PURE__*/ $acw62.createElement((0, $060c895ce7b8911d$export$2e2bcd8739ae039), {
    fontSize: "small"
});
var $0f0bc7d23ffa3679$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(props, ref) {
    var action = props.action, children = props.children, classes = props.classes, className = props.className, _props$closeText = props.closeText, closeText = _props$closeText === void 0 ? "Close" : _props$closeText, color = props.color, icon = props.icon, _props$iconMapping = props.iconMapping, iconMapping = _props$iconMapping === void 0 ? $0f0bc7d23ffa3679$var$defaultIconMapping : _props$iconMapping, onClose = props.onClose, _props$role = props.role, role = _props$role === void 0 ? "alert" : _props$role, _props$severity = props.severity, severity = _props$severity === void 0 ? "success" : _props$severity, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "action",
        "children",
        "classes",
        "className",
        "closeText",
        "color",
        "icon",
        "iconMapping",
        "onClose",
        "role",
        "severity",
        "variant"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $ca4ada9c808bb355$export$2e2bcd8739ae039), (0, $8nd05.default)({
        role: role,
        square: true,
        elevation: 0,
        className: (0, $1SA7b.default)(classes.root, classes["".concat(variant).concat((0, $f9tk6.default)(color || severity))], className),
        ref: ref
    }, other), icon !== false ? /*#__PURE__*/ $acw62.createElement("div", {
        className: classes.icon
    }, icon || iconMapping[severity] || $0f0bc7d23ffa3679$var$defaultIconMapping[severity]) : null, /*#__PURE__*/ $acw62.createElement("div", {
        className: classes.message
    }, children), action != null ? /*#__PURE__*/ $acw62.createElement("div", {
        className: classes.action
    }, action) : null, action == null && onClose ? /*#__PURE__*/ $acw62.createElement("div", {
        className: classes.action
    }, /*#__PURE__*/ $acw62.createElement((0, $50480f2bcbf21ff1$export$2e2bcd8739ae039), {
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose
    }, $0f0bc7d23ffa3679$var$_ref)) : null);
});
var $0f0bc7d23ffa3679$export$2e2bcd8739ae039 = (0, $kQaj4.default)($0f0bc7d23ffa3679$export$9dd6ff9ea0189349, {
    name: "MuiAlert"
})($0f0bc7d23ffa3679$var$Alert);





var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");



var $3Z9df = parcelRequire("3Z9df");



var $b0e069c73d597420$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
var $b0e069c73d597420$var$defaultTimeout = {
    enter: (0, $3Z9df.duration).enteringScreen,
    exit: (0, $3Z9df.duration).leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $b0e069c73d597420$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $0fef977f04119bf5$export$2e2bcd8739ae039) : _props$TransitionComp, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $b0e069c73d597420$var$defaultTimeout : _props$timeout, other = (0, $9X7IJ.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "TransitionComponent",
        "timeout"
    ]);
    var theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $acw62.useRef(null);
    var foreignRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(children.ref, ref);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $eUqlC.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $68606cb156b7db52$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        var transitionProps = (0, $68606cb156b7db52$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $68606cb156b7db52$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    return /*#__PURE__*/ $acw62.createElement(TransitionComponent, (0, $8nd05.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
            style: (0, $8nd05.default)({
                opacity: 0,
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, $b0e069c73d597420$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
var $b0e069c73d597420$export$2e2bcd8739ae039 = $b0e069c73d597420$var$Fade;


var $7237e0fe40e71bf8$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        // Improve scrollable dialog support.
        zIndex: -1,
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: "transparent"
    }
};
var $7237e0fe40e71bf8$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, transitionDuration = props.transitionDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $b0e069c73d597420$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "invisible",
        "open",
        "transitionDuration",
        "TransitionComponent"
    ]);
    return /*#__PURE__*/ $acw62.createElement(TransitionComponent, (0, $8nd05.default)({
        in: open,
        timeout: transitionDuration
    }, other), /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, $1SA7b.default)(classes.root, className, invisible && classes.invisible),
        "aria-hidden": true,
        ref: ref
    }, children));
});
var $7237e0fe40e71bf8$export$2e2bcd8739ae039 = (0, $kQaj4.default)($7237e0fe40e71bf8$export$9dd6ff9ea0189349, {
    name: "MuiBackdrop"
})($7237e0fe40e71bf8$var$Backdrop);






var $acw62 = parcelRequire("acw62");













const $f29da431d2e1d0db$var$AMAX_API_URL = "https://amax-emu.com/api";
const $f29da431d2e1d0db$var$validationSchema = $cd7706ce94a8dfd1$export$185802fd694ee1f5().shape({
    password: $bcc252d93ab3046c$export$185802fd694ee1f5().required("Password is required").min(8, "Password must be at least 8 characters").max(15, "Password must not exceed 15 characters").matches(/^.*(?=.{8,})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, "Password must contain at least 8 characters, one uppercase, one lowercase and one number"),
    confirmPassword: $bcc252d93ab3046c$export$185802fd694ee1f5().required("Confirm Password is required").oneOf([
        $f5cdfa956e941194$export$185802fd694ee1f5("password"),
        null
    ], "Confirm Password does not match")
});
const $f29da431d2e1d0db$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: theme.spacing(2)
        },
        textfield: {
            margin: theme.spacing(1),
            width: "300px"
        },
        selectWide: {
            //backgroundColor: "lightblue",
            //color: "black",
            //width: '400px',
            margin: theme.spacing(1)
        },
        registerButton: {
        },
        successIcon: {
            backgroundColor: "green"
        },
        errorIcon: {
            backgroundColor: "red"
        },
        hiddenClass: {
            visibility: "hidden",
            height: "0px"
        }
    }));
function $f29da431d2e1d0db$export$2e2bcd8739ae039() {
    const classes = $f29da431d2e1d0db$var$useStyles();
    const { register: register , handleSubmit: handleSubmit , formState: { errors: errors  }  } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($f29da431d2e1d0db$var$validationSchema)
    });
    const auth = (0, $fa8bb1513e386061$export$650ce9f0b4df82fd)();
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    let history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [serverResponse, setResponse] = $acw62.useState(undefined);
    const [PostState, setPostState] = $acw62.useState(false);
    const [AccoutTypeValue, setAccoutTypeValue] = $acw62.useState("1");
    const onSubmit = (data)=>{
        console.log(data);
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($f29da431d2e1d0db$var$AMAX_API_URL + "/players/update_password", data, {
            headers: {
                "content-type": "application/json;charset=UTF-8",
                "Authorization": `Bearer ${auth.user.token}`
            }
        }).then((response)=>{
            setResponse(response.data);
            setPostState(true);
        }).catch((error)=>{
            setResponse(error.response.data);
            setPostState(true);
            console.log(error.response.data);
            console.error("There was an error!", error);
        });
    };
    const ButtonLabel = ()=>{
        if (PostState === false) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
            children: "Change password"
        });
        else {
            if (serverResponse !== undefined) {
                if (serverResponse.success === true) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                    children: "success"
                });
                else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                    children: [
                        "Failed: ",
                        serverResponse.msg
                    ]
                });
            } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                children: "Processing"
            });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64d9a99297a346fe$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Change password"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                className: classes.root,
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ecaaa74876358dcf$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ecaaa74876358dcf$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59744fa8faea6c4c$export$2e2bcd8739ae039), {
                                        ...register("password"),
                                        id: "outlined-basic",
                                        label: "Password",
                                        variant: "outlined",
                                        className: classes.textfield,
                                        helperText: errors.password?.message,
                                        error: !!errors?.password,
                                        type: "password"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74d3f5713a0fcd7a$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "Password must be at least 8 characters"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                    children: "Should include at least 1 uppercase, 1 lowercase and 1 number"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ecaaa74876358dcf$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59744fa8faea6c4c$export$2e2bcd8739ae039), {
                                    ...register("confirmPassword"),
                                    id: "outlined-basic",
                                    label: "Confirm Password",
                                    variant: "outlined",
                                    className: classes.textfield,
                                    helperText: errors.confirmPassword?.message,
                                    error: !!errors?.confirmPassword,
                                    type: "password"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                        type: "submit",
                        fullWidth: true,
                        variant: "contained",
                        color: "primary",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ButtonLabel, {})
                    })
                ]
            })
        ]
    });
}


const $282769987c6d9257$var$AMAX_API_URL = "https://amax-emu.com/api";
const $282769987c6d9257$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            margin: 15,
            width: 570,
            height: 636,
            /* Blue/700 (2 L) */ background: "#304254",
            /* Blue/600 */ border: "1px solid #3E5270",
            boxSizing: "border-box",
            borderRadius: 8
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        },
        CustomIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24"
        },
        sswidget_container: {
            display: "inline-flex",
            flex: "0 1 auto",
            flexBasis: "33.33%",
            flexDirection: "column",
            flexWrap: "wrap",
            width: "33%",
            fontFamily: "Ubuntu",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "16px",
            lineHeight: "155%",
            marginTop: "1em",
            marginBottom: "1em",
            /* identical to box height, or 25px */ /* Blue / 50 */ color: "#92929F"
        },
        sswidget_icon_value: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            fontWeight: "bold",
            color: "#E6E6E6"
        },
        sswidgets_container: {
            display: "flex",
            maxWidth: "600px",
            maxHeight: "180px",
            flexWrap: "wrap",
            flexDirection: "column",
            margin: "1em"
        },
        modal: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: 8,
            padding: "1em",
            //border: '2px solid #000',
            boxShadow: theme.shadows[5],
            backdropFilter: "blur(3px)",
            width: 600
        },
        circularProgress: {
            marginLeft: 0,
            marginRight: theme.spacing.unit
        },
        ButtonsContainer: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "0.2em",
            justifyContent: "center"
        }
    }));
function $282769987c6d9257$var$Alert(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f0bc7d23ffa3679$export$2e2bcd8739ae039), {
        elevation: 6,
        variant: "filled",
        ...props
    });
}
function $282769987c6d9257$export$2e2bcd8739ae039({ user_name: user_name  }) {
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $282769987c6d9257$var$useStyles();
    const [open, setOpen] = $acw62.useState(false);
    const [openModal, setOpenModal] = $acw62.useState(false);
    const [openPasswordModal, setOpenPasswordModal] = $acw62.useState(false);
    const [serverResponse, setResponse] = $acw62.useState(undefined);
    const [accountChangeServerResponse, setAccountChangeServerResponse] = $acw62.useState(undefined);
    const [accountChangeLoading, setAccountChangeLoading] = $acw62.useState(false);
    const [ChangedFlag, setChanged] = $acw62.useState(false);
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    const auth = (0, $fa8bb1513e386061$export$650ce9f0b4df82fd)();
    const pfpFile = (0, $acw62.useRef)(null);
    const clickUploadProfilePicture = ()=>{
        // `current` points to the mounted file input element
        pfpFile.current.click();
    };
    const uploadProfilePicture = ()=>{
        if (document.getElementById("pfp_uploader") === null) return;
        if (document.getElementById("pfp_uploader").length < 1) return;
        const selectedFile = document.getElementById("pfp_uploader").files[0];
        console.log(selectedFile);
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($282769987c6d9257$var$AMAX_API_URL + "/players/pfp/upload", selectedFile, {
            headers: {
                "Authorization": `Bearer ${auth.user.token}`
            }
        }).then((response)=>{
            console.log(response);
            const response_fake = {
                success: true,
                msg: "PFP was updated!"
            };
            setResponse(response_fake);
            main_fn().then(()=>{});
            handleClick();
            UpdateProfile();
        }).catch((error)=>{
            setResponse(error.response.data);
            console.log(error.response);
            main_fn().then(()=>{});
            handleClick();
        });
    };
    const deleteProfilePicture = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).delete($282769987c6d9257$var$AMAX_API_URL + "/players/pfp/delete", {
            headers: {
                "Authorization": `Bearer ${auth.user.token}`
            }
        }).then((response)=>{
            console.log(response);
            const response_fake = {
                success: true,
                msg: "PFP was updated!"
            };
            setResponse(response_fake);
            main_fn().then(()=>{});
            handleClick();
            UpdateProfile();
        }).catch((error)=>{
            setResponse(error.response.data);
            console.log(error.response);
            main_fn().then(()=>{});
            handleClick();
        });
    };
    const handleModalOpen = ()=>{
        setAccountChangeLoading(false);
        setAccountChangeServerResponse(undefined);
        setOpenModal(true);
    };
    const handleModalClose = ()=>{
        setOpenModal(false);
        UpdateProfile();
    };
    const handlePasswordModalClose = ()=>{
        setOpenPasswordModal(false);
    };
    const handlePasswordModalOpen = ()=>{
        setOpenPasswordModal(true);
    };
    function UpdateProfile() {
        $acw62.useEffect(()=>{
            const main_fn = async ()=>{
                await user.getData();
            };
            main_fn().then(()=>{});
        });
    }
    const changeAccountType = ()=>{
        setAccountChangeLoading(true);
        const data = {
            call: "account_change"
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($282769987c6d9257$var$AMAX_API_URL + "/players/change_account_type", data, {
            headers: {
                "content-type": "application/json;charset=UTF-8",
                "Authorization": `Bearer ${auth.user.token}`
            }
        }).then((response)=>{
            console.log(response);
            setAccountChangeServerResponse(response.data);
            main_fn().then(()=>{});
        }).catch((error)=>{
            console.log(error.response);
            setAccountChangeServerResponse(error.response.data);
            main_fn().then(()=>{});
        });
        setAccountChangeLoading(false);
    };
    const AddFriendRequest = ()=>{
        const data = {
            username: user_name
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($282769987c6d9257$var$AMAX_API_URL + "/players/add_friend", data, {
            headers: {
                "content-type": "application/json;charset=UTF-8",
                "Authorization": `Bearer ${auth.user.token}`
            }
        }).then((response)=>{
            console.log(response);
            setResponse(response.data);
            main_fn().then(()=>{});
            handleClick();
        }).catch((error)=>{
            setResponse(error.response.data);
            console.log(error.response);
            main_fn().then(()=>{});
            handleClick();
        });
    };
    const AcceptFriendRequest = ()=>{
        const data = {
            username: user_name
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($282769987c6d9257$var$AMAX_API_URL + "/players/accept_friend_request", data, {
            headers: {
                "content-type": "application/json;charset=UTF-8",
                "Authorization": `Bearer ${auth.user.token}`
            }
        }).then((response)=>{
            console.log(response);
            setResponse(response.data);
            main_fn().then(()=>{});
            handleClick();
        }).catch((error)=>{
            setResponse(error.response.data);
            console.log(error.response);
            main_fn().then(()=>{});
            handleClick();
        });
    };
    const DeclineFriendRequest = ()=>{
        const data = {
            username: user_name
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($282769987c6d9257$var$AMAX_API_URL + "/players/decline_friend_request", data, {
            headers: {
                "content-type": "application/json;charset=UTF-8",
                "Authorization": `Bearer ${auth.user.token}`
            }
        }).then((response)=>{
            console.log(response);
            setResponse(response.data);
            main_fn().then(()=>{});
            handleClick();
        }).catch((error)=>{
            setResponse(error.response.data);
            console.log(error.response);
            main_fn().then(()=>{});
            handleClick();
        });
    };
    const main_fn = async ()=>{
        await user.getData();
    };
    const CancelFriendRequest = ()=>{
        const data = {
            username: user_name
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($282769987c6d9257$var$AMAX_API_URL + "/players/cancel_friend_request", data, {
            headers: {
                "content-type": "application/json;charset=UTF-8",
                "Authorization": `Bearer ${auth.user.token}`
            }
        }).then((response)=>{
            console.log(response);
            setResponse(response.data);
            main_fn().then(()=>{});
            handleClick();
        }).catch((error)=>{
            setResponse(error.response.data);
            main_fn().then(()=>{});
            console.log(error.response);
            handleClick();
        });
    };
    const RemoveFriend = ()=>{
        const data = {
            username: user_name
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post($282769987c6d9257$var$AMAX_API_URL + "/players/remove_friend", data, {
            headers: {
                "content-type": "application/json;charset=UTF-8",
                "Authorization": `Bearer ${auth.user.token}`
            }
        }).then((response)=>{
            console.log(response);
            setResponse(response.data);
            main_fn().then(()=>{});
            handleClick();
        }).catch((error)=>{
            setResponse(error.response.data);
            main_fn().then(()=>{});
            console.log(error.response);
            handleClick();
        });
    };
    const handleClick = ()=>{
        setOpen(true);
    };
    const handleClose = (event, reason)=>{
        if (reason === "clickaway") return;
        setOpen(false);
    };
    const ChangeAccoutButton = ()=>{
        if (accountChangeLoading !== true) {
            if (accountChangeServerResponse === undefined) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                color: "primary",
                variant: "contained",
                onClick: changeAccountType,
                children: "Change account type"
            });
            else {
                if (accountChangeServerResponse.success === true) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                    color: "primary",
                    variant: "contained",
                    disabled: true,
                    children: accountChangeServerResponse.msg
                });
                else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                    color: "primary",
                    variant: "contained",
                    disabled: true,
                    children: accountChangeServerResponse.msg
                });
            }
        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
            color: "primary",
            variant: "contained",
            disabled: true,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a36c7122d0aec5cd$export$2e2bcd8739ae039), {
                    className: classes.circularProgress,
                    size: 20
                }),
                "Loading"
            ]
        });
    };
    const ResultAlert = ()=>{
        if (serverResponse !== undefined) {
            if (serverResponse.success) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($282769987c6d9257$var$Alert, {
                onClose: handleClose,
                severity: "success",
                children: serverResponse.msg
            });
            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($282769987c6d9257$var$Alert, {
                onClose: handleClose,
                severity: "error",
                children: serverResponse.msg
            });
        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    };
    const AddRemoveFriendButton = ()=>{
        if (user.userData?.amax_account) {
            if (user.userData.amax_player_data.friends.some((e)=>e.name === user_name)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                color: "primary",
                variant: "contained",
                onClick: RemoveFriend,
                children: "Remove Friend"
            });
            else if (user.userData.amax_player_data.friends_purposes.outcoming.includes(user_name)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                color: "primary",
                variant: "contained",
                onClick: CancelFriendRequest,
                children: "Cancel friend request"
            });
            else if (user.userData.amax_player_data.friends_purposes.incoming.includes(user_name)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "contained",
                        onClick: AcceptFriendRequest,
                        children: "Accept friend request"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "contained",
                        onClick: DeclineFriendRequest,
                        children: "Decline friend request"
                    })
                ]
            });
            else if (user.userData?.amax_player_data.stats.playerName === user_name) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "contained",
                        onClick: handleModalOpen,
                        children: "Change account type"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "contained",
                        onClick: handlePasswordModalOpen,
                        children: "Change password"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "contained",
                        onClick: clickUploadProfilePicture,
                        children: "Upload profile picture"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "contained",
                        onClick: deleteProfilePicture,
                        children: "Delete profile picture"
                    })
                ]
            });
            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                color: "primary",
                variant: "contained",
                onClick: AddFriendRequest,
                children: "Add friend"
            });
        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f71923faed635e4f$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: classes.ButtonsContainer,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(AddRemoveFriendButton, {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad276c267b016f4b$export$2e2bcd8739ae039), {
                open: open,
                autoHideDuration: 6000,
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ResultAlert, {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3b17170adf2941a$export$2e2bcd8739ae039), {
                "aria-labelledby": "transition-modal-title",
                "aria-describedby": "transition-modal-description",
                className: classes.modal,
                open: openModal,
                onClose: handleModalClose,
                closeAfterTransition: true,
                BackdropComponent: (0, $7237e0fe40e71bf8$export$2e2bcd8739ae039),
                BackdropProps: {
                    timeout: 500
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0e069c73d597420$export$2e2bcd8739ae039), {
                    in: openModal,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: classes.paper,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f71923faed635e4f$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    id: "transition-modal-title",
                                    children: "Attention!"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    id: "transition-modal-description",
                                    children: "Account type change can't be reversed! You'll lost all your normal account progress. If you're 100% sure press the button below."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ChangeAccoutButton, {})
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3b17170adf2941a$export$2e2bcd8739ae039), {
                "aria-labelledby": "transition-modal-title",
                "aria-describedby": "transition-modal-description",
                className: classes.modal,
                open: openPasswordModal,
                onClose: handlePasswordModalClose,
                closeAfterTransition: true,
                BackdropComponent: (0, $7237e0fe40e71bf8$export$2e2bcd8739ae039),
                BackdropProps: {
                    timeout: 500
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0e069c73d597420$export$2e2bcd8739ae039), {
                    in: openPasswordModal,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: classes.paper,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f71923faed635e4f$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f29da431d2e1d0db$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    variant: "contained",
                                    onClick: handlePasswordModalClose,
                                    children: "Close"
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "file",
                id: "pfp_uploader",
                ref: pfpFile,
                onChange: uploadProfilePicture,
                style: {
                    display: "none"
                }
            })
        ]
    });
}



const $5638eaa31046f90d$var$AMAX_API_URL = "https://amax-emu.com/api";
const $5638eaa31046f90d$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            margin: 15,
            width: 570,
            height: 636,
            /* Blue/700 (2 L) */ background: "#304254",
            /* Blue/600 */ border: "1px solid #3E5270",
            boxSizing: "border-box",
            borderRadius: 8
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        },
        CustomIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24"
        },
        sswidget_container: {
            display: "inline-flex",
            flex: "0 1 auto",
            flexBasis: "33.33%",
            flexDirection: "column",
            flexWrap: "wrap",
            width: "33%",
            fontFamily: "Ubuntu",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "16px",
            lineHeight: "155%",
            marginTop: "1em",
            marginBottom: "1em",
            /* identical to box height, or 25px */ /* Blue / 50 */ color: "#92929F"
        },
        sswidget_icon_value: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            fontWeight: "bold",
            color: "#E6E6E6"
        },
        sswidgets_container: {
            display: "flex",
            maxWidth: "600px",
            maxHeight: "180px",
            flexWrap: "wrap",
            flexDirection: "column",
            margin: "1em"
        }
    }));
function $5638eaa31046f90d$export$2e2bcd8739ae039() {
    let { profileName: profileName  } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $5638eaa31046f90d$var$useStyles();
    const [targetPlayerData, settargetPlayerData] = $acw62.useState(undefined);
    const [severDataFlag, setseverDataFlag] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        async function getServerData() {
            const resp = await fetch($5638eaa31046f90d$var$AMAX_API_URL + "/players/name/" + profileName, {
                method: "GET",
                headers: {
                    "content-type": "application/json;charset=UTF-8"
                }
            });
            settargetPlayerData(await resp.json());
            setseverDataFlag(true);
        }
        getServerData().catch(()=>{});
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        children: severDataFlag ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de708537bc6d55c6$export$2e2bcd8739ae039), {
                            playerName: profileName,
                            playerCurrentExp: targetPlayerData.data.amaxPlayerData.amaxLevelingData.fansCurrent,
                            playerLevel: targetPlayerData.data.amaxPlayerData.amaxLevelingData.level + 1,
                            playerLegend: targetPlayerData.data.amaxPlayerData.amaxLevelingData.legend,
                            playerLevelupExp: targetPlayerData.data.amaxPlayerData.amaxLevelingData.fansNeeded,
                            playerPfpUrl: targetPlayerData.data.amaxPfpUrl,
                            playerAccountType: targetPlayerData.data.accountType
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $282769987c6d9257$export$2e2bcd8739ae039), {
                            user_name: targetPlayerData.data.player_name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $343ef8de79b5e1cc$export$2e2bcd8739ae039), {
                    playerStatsData: targetPlayerData.data.amaxPlayerData.amaxStatsData
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1508af06736eabc0$export$2e2bcd8739ae039), {
                    player_name: targetPlayerData.data.player_name
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
            children: "Loading"
        })
    });
}




var $acw62 = parcelRequire("acw62");



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");



var $kQaj4 = parcelRequire("kQaj4");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");








var $3Z9df = parcelRequire("3Z9df");

// Later, we gonna translate back the node to his original location
// with `none`.`
function $9d895755ad15492b$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = window.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        var transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
    if (direction === "right") return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
    if (direction === "up") return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
     // direction === 'down'
    return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}
function $9d895755ad15492b$export$f820ccdc5b48abdf(direction, node) {
    var transform = $9d895755ad15492b$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $9d895755ad15492b$var$defaultTimeout = {
    enter: (0, $3Z9df.duration).enteringScreen,
    exit: (0, $3Z9df.duration).leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $9d895755ad15492b$var$Slide = /*#__PURE__*/ $acw62.forwardRef(function Slide(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? "down" : _props$direction, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $9d895755ad15492b$var$defaultTimeout : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $0fef977f04119bf5$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $9X7IJ.default)(props, [
        "children",
        "direction",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    var childrenRef = $acw62.useRef(null);
    /**
   * used in cloneElement(children, { ref: handleRef })
   */ var handleOwnRef = $acw62.useCallback(function(instance) {
        // #StrictMode ready
        childrenRef.current = $11492dca620dcaa5$exports.findDOMNode(instance);
    }, []);
    var handleRefIntermediary = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(children.ref, handleOwnRef);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(handleRefIntermediary, ref);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(isAppearing) {
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        $9d895755ad15492b$export$f820ccdc5b48abdf(direction, node);
        (0, $68606cb156b7db52$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var transitionProps = (0, $68606cb156b7db52$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $8nd05.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.transition = theme.transitions.create("transform", (0, $8nd05.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $68606cb156b7db52$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $8nd05.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        node.style.transition = theme.transitions.create("transform", (0, $8nd05.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        $9d895755ad15492b$export$f820ccdc5b48abdf(direction, node);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(function(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    var updatePosition = $acw62.useCallback(function() {
        if (childrenRef.current) $9d895755ad15492b$export$f820ccdc5b48abdf(direction, childrenRef.current);
    }, [
        direction
    ]);
    $acw62.useEffect(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        var handleResize = (0, $3308074b7cd66a5b$export$2e2bcd8739ae039)(function() {
            if (childrenRef.current) $9d895755ad15492b$export$f820ccdc5b48abdf(direction, childrenRef.current);
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    $acw62.useEffect(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ $acw62.createElement(TransitionComponent, (0, $8nd05.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        appear: true,
        in: inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
            ref: handleRef,
            style: (0, $8nd05.default)({
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, style, children.props.style)
        }, childProps));
    });
});
var $9d895755ad15492b$export$2e2bcd8739ae039 = $9d895755ad15492b$var$Slide;




var $f9tk6 = parcelRequire("f9tk6");

var $3Z9df = parcelRequire("3Z9df");

var $1b609827a6d58632$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `variant="permanent or persistent"`. */ docked: {
            flex: "0 0 auto"
        },
        /* Styles applied to the `Paper` component. */ paper: {
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            flex: "1 0 auto",
            zIndex: theme.zIndex.drawer,
            WebkitOverflowScrolling: "touch",
            // Add iOS momentum scrolling.
            // temporary style
            position: "fixed",
            top: 0,
            // We disable the focus ring for mouse, touch and keyboard users.
            // At some point, it would be better to keep it for keyboard users.
            // :focus-ring CSS pseudo-class will help.
            outline: 0
        },
        /* Styles applied to the `Paper` component if `anchor="left"`. */ paperAnchorLeft: {
            left: 0,
            right: "auto"
        },
        /* Styles applied to the `Paper` component if `anchor="right"`. */ paperAnchorRight: {
            left: "auto",
            right: 0
        },
        /* Styles applied to the `Paper` component if `anchor="top"`. */ paperAnchorTop: {
            top: 0,
            left: 0,
            bottom: "auto",
            right: 0,
            height: "auto",
            maxHeight: "100%"
        },
        /* Styles applied to the `Paper` component if `anchor="bottom"`. */ paperAnchorBottom: {
            top: "auto",
            left: 0,
            bottom: 0,
            right: 0,
            height: "auto",
            maxHeight: "100%"
        },
        /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */ paperAnchorDockedLeft: {
            borderRight: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */ paperAnchorDockedTop: {
            borderBottom: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */ paperAnchorDockedRight: {
            borderLeft: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */ paperAnchorDockedBottom: {
            borderTop: "1px solid ".concat(theme.palette.divider)
        },
        /* Styles applied to the `Modal` component. */ modal: {}
    };
};
var $1b609827a6d58632$var$oppositeDirection = {
    left: "right",
    right: "left",
    top: "down",
    bottom: "up"
};
function $1b609827a6d58632$export$2a62b49acb270576(anchor) {
    return [
        "left",
        "right"
    ].indexOf(anchor) !== -1;
}
function $1b609827a6d58632$export$830f4f08342d299e(theme, anchor) {
    return theme.direction === "rtl" && $1b609827a6d58632$export$2a62b49acb270576(anchor) ? $1b609827a6d58632$var$oppositeDirection[anchor] : anchor;
}
var $1b609827a6d58632$var$defaultTransitionDuration = {
    enter: (0, $3Z9df.duration).enteringScreen,
    exit: (0, $3Z9df.duration).leavingScreen
};
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ var $1b609827a6d58632$var$Drawer = /*#__PURE__*/ $acw62.forwardRef(function Drawer(props, ref) {
    var _props$anchor = props.anchor, anchorProp = _props$anchor === void 0 ? "left" : _props$anchor, BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 16 : _props$elevation, _props$ModalProps = props.ModalProps;
    _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
    var BackdropPropsProp = _props$ModalProps.BackdropProps, ModalProps = (0, $9X7IJ.default)(_props$ModalProps, [
        "BackdropProps"
    ]), onClose = props.onClose, _props$open = props.open, open = _props$open === void 0 ? false : _props$open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, SlideProps = props.SlideProps, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $9d895755ad15492b$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? $1b609827a6d58632$var$defaultTransitionDuration : _props$transitionDura, _props$variant = props.variant, variant = _props$variant === void 0 ? "temporary" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "anchor",
        "BackdropProps",
        "children",
        "classes",
        "className",
        "elevation",
        "ModalProps",
        "onClose",
        "open",
        "PaperProps",
        "SlideProps",
        "TransitionComponent",
        "transitionDuration",
        "variant"
    ]);
    var theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)(); // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    var mounted = $acw62.useRef(false);
    $acw62.useEffect(function() {
        mounted.current = true;
    }, []);
    var anchor = $1b609827a6d58632$export$830f4f08342d299e(theme, anchorProp);
    var drawer = /*#__PURE__*/ $acw62.createElement((0, $ca4ada9c808bb355$export$2e2bcd8739ae039), (0, $8nd05.default)({
        elevation: variant === "temporary" ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $1SA7b.default)(classes.paper, classes["paperAnchor".concat((0, $f9tk6.default)(anchor))], PaperProps.className, variant !== "temporary" && classes["paperAnchorDocked".concat((0, $f9tk6.default)(anchor))])
    }), children);
    if (variant === "permanent") return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes.docked, className),
        ref: ref
    }, other), drawer);
    var slidingDrawer = /*#__PURE__*/ $acw62.createElement(TransitionComponent, (0, $8nd05.default)({
        in: open,
        direction: $1b609827a6d58632$var$oppositeDirection[anchor],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps), drawer);
    if (variant === "persistent") return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes.docked, className),
        ref: ref
    }, other), slidingDrawer);
     // variant === temporary
    return /*#__PURE__*/ $acw62.createElement((0, $b3b17170adf2941a$export$2e2bcd8739ae039), (0, $8nd05.default)({
        BackdropProps: (0, $8nd05.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        BackdropComponent: (0, $7237e0fe40e71bf8$export$2e2bcd8739ae039),
        className: (0, $1SA7b.default)(classes.root, classes.modal, className),
        open: open,
        onClose: onClose,
        ref: ref
    }, other, ModalProps), slidingDrawer);
});
var $1b609827a6d58632$export$2e2bcd8739ae039 = (0, $kQaj4.default)($1b609827a6d58632$export$9dd6ff9ea0189349, {
    name: "MuiDrawer",
    flip: false
})($1b609827a6d58632$var$Drawer);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $c9Z8w = parcelRequire("c9Z8w");


var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");



var $kD2D5 = parcelRequire("kD2D5");

var $9ORqK = parcelRequire("9ORqK");


var $jKDgp = parcelRequire("jKDgp");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $kD2D5 = parcelRequire("kD2D5");
var $gkNc2 = parcelRequire("gkNc2");
function $6b7b71274da62b92$export$2e2bcd8739ae039(queryInput) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var theme = (0, $gkNc2.default)();
    var props = (0, $kD2D5.default)({
        theme: theme,
        name: "MuiUseMediaQuery",
        props: {}
    });
    var query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, ""); // Wait for jsdom to support the match media feature.
    // All the browsers Material-UI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    var supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    var _props$options = (0, $8nd05.default)({}, props, options), _props$options$defaul = _props$options.defaultMatches, defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul, _props$options$matchM = _props$options.matchMedia, matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM, _props$options$noSsr = _props$options.noSsr, noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr, _props$options$ssrMat = _props$options.ssrMatchMedia, ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
    var _React$useState = $acw62.useState(function() {
        if (noSsr && supportMatchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
         // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    }), match = _React$useState[0], setMatch = _React$useState[1];
    $acw62.useEffect(function() {
        var active = true;
        if (!supportMatchMedia) return undefined;
        var queryList = matchMedia(query);
        var updateMatch = function updateMatch() {
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addListener(updateMatch);
        return function() {
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia,
        supportMatchMedia
    ]);
    return match;
}


var $e9bfc8133d187269$export$da34bb2ed94165a0 = function isWidthUp(breakpoint, width) {
    var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (inclusive) return (0, $jKDgp.keys).indexOf(breakpoint) <= (0, $jKDgp.keys).indexOf(width);
    return (0, $jKDgp.keys).indexOf(breakpoint) < (0, $jKDgp.keys).indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.
var $e9bfc8133d187269$export$43a67ae92cf379e6 = function isWidthDown(breakpoint, width) {
    var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (inclusive) return (0, $jKDgp.keys).indexOf(width) <= (0, $jKDgp.keys).indexOf(breakpoint);
    return (0, $jKDgp.keys).indexOf(width) < (0, $jKDgp.keys).indexOf(breakpoint);
};
var $e9bfc8133d187269$var$useEnhancedEffect = typeof window === "undefined" ? $acw62.useEffect : $acw62.useLayoutEffect;
var $e9bfc8133d187269$var$withWidth = function withWidth() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(Component) {
        var _options$withTheme = options.withTheme, withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme, _options$noSSR = options.noSSR, noSSR = _options$noSSR === void 0 ? false : _options$noSSR, initialWidthOption = options.initialWidth;
        function WithWidth(props) {
            var contextTheme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
            var theme = props.theme || contextTheme;
            var _getThemeProps = (0, $kD2D5.default)({
                theme: theme,
                name: "MuiWithWidth",
                props: (0, $8nd05.default)({}, props)
            }), initialWidth = _getThemeProps.initialWidth, width = _getThemeProps.width, other = (0, $9X7IJ.default)(_getThemeProps, [
                "initialWidth",
                "width"
            ]);
            var _React$useState = $acw62.useState(false), mountedState = _React$useState[0], setMountedState = _React$useState[1];
            $e9bfc8133d187269$var$useEnhancedEffect(function() {
                setMountedState(true);
            }, []);
            /**
       * innerWidth |xs      sm      md      lg      xl
       *            |-------|-------|-------|-------|------>
       * width      |  xs   |  sm   |  md   |  lg   |  xl
       */ var keys = theme.breakpoints.keys.slice().reverse();
            var widthComputed = keys.reduce(function(output, key) {
                // eslint-disable-next-line react-hooks/rules-of-hooks
                var matches = (0, $6b7b71274da62b92$export$2e2bcd8739ae039)(theme.breakpoints.up(key));
                return !output && matches ? key : output;
            }, null);
            var more = (0, $8nd05.default)({
                width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
            }, withThemeOption ? {
                theme: theme
            } : {}, other); // When rendering the component on the server,
            // we have no idea about the client browser screen width.
            // In order to prevent blinks and help the reconciliation of the React tree
            // we are not rendering the child component.
            //
            // An alternative is to use the `initialWidth` property.
            if (more.width === undefined) return null;
            return /*#__PURE__*/ $acw62.createElement(Component, more);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(WithWidth, Component);
        return WithWidth;
    };
};
var $e9bfc8133d187269$export$2e2bcd8739ae039 = $e9bfc8133d187269$var$withWidth;



/**
 * @ignore - internal component.
 */ function $3ee8ac891a818bdc$var$HiddenJs(props) {
    var children = props.children, only = props.only, width = props.width;
    var theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    var visible = true; // `only` check is faster to get out sooner if used.
    if (only) {
        if (Array.isArray(only)) for(var i = 0; i < only.length; i += 1){
            var breakpoint = only[i];
            if (width === breakpoint) {
                visible = false;
                break;
            }
        }
        else if (only && width === only) visible = false;
    } // Allow `only` to be combined with other props. If already hidden, no need to check others.
    if (visible) // determine visibility based on the smallest size up
    for(var _i = 0; _i < theme.breakpoints.keys.length; _i += 1){
        var _breakpoint = theme.breakpoints.keys[_i];
        var breakpointUp = props["".concat(_breakpoint, "Up")];
        var breakpointDown = props["".concat(_breakpoint, "Down")];
        if (breakpointUp && (0, $e9bfc8133d187269$export$da34bb2ed94165a0)(_breakpoint, width) || breakpointDown && (0, $e9bfc8133d187269$export$43a67ae92cf379e6)(_breakpoint, width)) {
            visible = false;
            break;
        }
    }
    if (!visible) return null;
    return children;
}
$3ee8ac891a818bdc$var$HiddenJs.propTypes = {
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */ implementation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "js",
        "css"
    ]),
    /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */ initialWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ]),
    /**
   * If `true`, screens this size and down will be hidden.
   */ lgDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, screens this size and up will be hidden.
   */ lgUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, screens this size and down will be hidden.
   */ mdDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, screens this size and up will be hidden.
   */ mdUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Hide the given breakpoint(s).
   */ only: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "xs",
            "sm",
            "md",
            "lg",
            "xl"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "xs",
            "sm",
            "md",
            "lg",
            "xl"
        ]))
    ]),
    /**
   * If `true`, screens this size and down will be hidden.
   */ smDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, screens this size and up will be hidden.
   */ smUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @ignore
   * width prop provided by withWidth decorator.
   */ width: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    /**
   * If `true`, screens this size and down will be hidden.
   */ xlDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, screens this size and up will be hidden.
   */ xlUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, screens this size and down will be hidden.
   */ xsDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, screens this size and up will be hidden.
   */ xsUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $3ee8ac891a818bdc$export$2e2bcd8739ae039 = (0, $e9bfc8133d187269$export$2e2bcd8739ae039)()($3ee8ac891a818bdc$var$HiddenJs);



var $9X7IJ = parcelRequire("9X7IJ");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");


var $f9tk6 = parcelRequire("f9tk6");

var $kQaj4 = parcelRequire("kQaj4");

var $0d69a3ac920bc3da$var$styles = function styles(theme) {
    var hidden = {
        display: "none"
    };
    return theme.breakpoints.keys.reduce(function(acc, key) {
        acc["only".concat((0, $f9tk6.default)(key))] = (0, $kSlfw.default)({}, theme.breakpoints.only(key), hidden);
        acc["".concat(key, "Up")] = (0, $kSlfw.default)({}, theme.breakpoints.up(key), hidden);
        acc["".concat(key, "Down")] = (0, $kSlfw.default)({}, theme.breakpoints.down(key), hidden);
        return acc;
    }, {});
};
/**
 * @ignore - internal component.
 */ function $0d69a3ac920bc3da$var$HiddenCss(props) {
    var children = props.children, classes = props.classes, className = props.className, only = props.only, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "only"
    ]);
    var theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    var unknownProps;
    var clsx = [];
    if (className) clsx.push(className);
    for(var i = 0; i < theme.breakpoints.keys.length; i += 1){
        var breakpoint = theme.breakpoints.keys[i];
        var breakpointUp = props["".concat(breakpoint, "Up")];
        var breakpointDown = props["".concat(breakpoint, "Down")];
        if (breakpointUp) clsx.push(classes["".concat(breakpoint, "Up")]);
        if (breakpointDown) clsx.push(classes["".concat(breakpoint, "Down")]);
    }
    if (only) {
        var onlyBreakpoints = Array.isArray(only) ? only : [
            only
        ];
        onlyBreakpoints.forEach(function(breakpoint) {
            clsx.push(classes["only".concat((0, $f9tk6.default)(breakpoint))]);
        });
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: clsx.join(" ")
    }, children);
}
var $0d69a3ac920bc3da$export$2e2bcd8739ae039 = (0, $kQaj4.default)($0d69a3ac920bc3da$var$styles, {
    name: "PrivateHiddenCss"
})($0d69a3ac920bc3da$var$HiddenCss);


/**
 * Responsively hides children based on the selected implementation.
 */ function $68c66e314f33238c$var$Hidden(props) {
    var _props$implementation = props.implementation, implementation = _props$implementation === void 0 ? "js" : _props$implementation, _props$lgDown = props.lgDown, lgDown = _props$lgDown === void 0 ? false : _props$lgDown, _props$lgUp = props.lgUp, lgUp = _props$lgUp === void 0 ? false : _props$lgUp, _props$mdDown = props.mdDown, mdDown = _props$mdDown === void 0 ? false : _props$mdDown, _props$mdUp = props.mdUp, mdUp = _props$mdUp === void 0 ? false : _props$mdUp, _props$smDown = props.smDown, smDown = _props$smDown === void 0 ? false : _props$smDown, _props$smUp = props.smUp, smUp = _props$smUp === void 0 ? false : _props$smUp, _props$xlDown = props.xlDown, xlDown = _props$xlDown === void 0 ? false : _props$xlDown, _props$xlUp = props.xlUp, xlUp = _props$xlUp === void 0 ? false : _props$xlUp, _props$xsDown = props.xsDown, xsDown = _props$xsDown === void 0 ? false : _props$xsDown, _props$xsUp = props.xsUp, xsUp = _props$xsUp === void 0 ? false : _props$xsUp, other = (0, $9X7IJ.default)(props, [
        "implementation",
        "lgDown",
        "lgUp",
        "mdDown",
        "mdUp",
        "smDown",
        "smUp",
        "xlDown",
        "xlUp",
        "xsDown",
        "xsUp"
    ]);
    if (implementation === "js") return /*#__PURE__*/ $acw62.createElement((0, $3ee8ac891a818bdc$export$2e2bcd8739ae039), (0, $8nd05.default)({
        lgDown: lgDown,
        lgUp: lgUp,
        mdDown: mdDown,
        mdUp: mdUp,
        smDown: smDown,
        smUp: smUp,
        xlDown: xlDown,
        xlUp: xlUp,
        xsDown: xsDown,
        xsUp: xsUp
    }, other));
    return /*#__PURE__*/ $acw62.createElement((0, $0d69a3ac920bc3da$export$2e2bcd8739ae039), (0, $8nd05.default)({
        lgDown: lgDown,
        lgUp: lgUp,
        mdDown: mdDown,
        mdUp: mdUp,
        smDown: smDown,
        smUp: smUp,
        xlDown: xlDown,
        xlUp: xlUp,
        xsDown: xsDown,
        xsUp: xsUp
    }, other));
}
var $68c66e314f33238c$export$2e2bcd8739ae039 = $68c66e314f33238c$var$Hidden;





var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");





var $c1d5fff205df0ecf$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */ root: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            position: "relative",
            textDecoration: "none",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "left",
            paddingTop: 8,
            paddingBottom: 8,
            "&$focusVisible": {
                backgroundColor: theme.palette.action.selected
            },
            "&$selected, &$selected:hover": {
                backgroundColor: theme.palette.action.selected
            },
            "&$disabled": {
                opacity: 0.5
            }
        },
        /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */ container: {
            position: "relative"
        },
        /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */ focusVisible: {},
        /* Styles applied to the `component` element if dense. */ dense: {
            paddingTop: 4,
            paddingBottom: 4
        },
        /* Styles applied to the `component` element if `alignItems="flex-start"`. */ alignItemsFlexStart: {
            alignItems: "flex-start"
        },
        /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the inner `component` element if `divider={true}`. */ divider: {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            backgroundClip: "padding-box"
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the inner `component` element if `button={true}`. */ button: {
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */ secondaryAction: {
            // Add some space to avoid collision as `ListItemSecondaryAction`
            // is absolutely positioned.
            paddingRight: 48
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {}
    };
};
var $c1d5fff205df0ecf$var$useEnhancedEffect = typeof window === "undefined" ? $acw62.useEffect : $acw62.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ var $c1d5fff205df0ecf$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(props, ref) {
    var _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "center" : _props$alignItems, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$button = props.button, button = _props$button === void 0 ? false : _props$button, childrenProp = props.children, classes = props.classes, className = props.className, componentProp = props.component, _props$ContainerCompo = props.ContainerComponent, ContainerComponent = _props$ContainerCompo === void 0 ? "li" : _props$ContainerCompo, _props$ContainerProps = props.ContainerProps;
    _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
    var ContainerClassName = _props$ContainerProps.className, ContainerProps = (0, $9X7IJ.default)(_props$ContainerProps, [
        "className"
    ]), _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$divider = props.divider, divider = _props$divider === void 0 ? false : _props$divider, focusVisibleClassName = props.focusVisibleClassName, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $9X7IJ.default)(props, [
        "alignItems",
        "autoFocus",
        "button",
        "children",
        "classes",
        "className",
        "component",
        "ContainerComponent",
        "ContainerProps",
        "dense",
        "disabled",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected"
    ]);
    var context = $acw62.useContext((0, $51d781898675016d$export$2e2bcd8739ae039));
    var childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems
    };
    var listItemRef = $acw62.useRef(null);
    $c1d5fff205df0ecf$var$useEnhancedEffect(function() {
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var children = $acw62.Children.toArray(childrenProp);
    var hasSecondaryAction = children.length && (0, $3b76a084116f5c1d$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    var handleOwnRef = $acw62.useCallback(function(instance) {
        // #StrictMode ready
        listItemRef.current = $11492dca620dcaa5$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $2e19e2d9ab6312a7$export$2e2bcd8739ae039)(handleOwnRef, ref);
    var componentProps = (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
        disabled: disabled
    }, other);
    var Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $1SA7b.default)(classes.focusVisible, focusVisibleClassName);
        Component = (0, $ac65ba7da5d490c4$export$2e2bcd8739ae039);
    }
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component; // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ $acw62.createElement((0, $51d781898675016d$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, /*#__PURE__*/ $acw62.createElement(ContainerComponent, (0, $8nd05.default)({
            className: (0, $1SA7b.default)(classes.container, ContainerClassName),
            ref: handleRef
        }, ContainerProps), /*#__PURE__*/ $acw62.createElement(Component, componentProps, children), children.pop()));
    }
    return /*#__PURE__*/ $acw62.createElement((0, $51d781898675016d$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        ref: handleRef
    }, componentProps), children));
});
var $c1d5fff205df0ecf$export$2e2bcd8739ae039 = (0, $kQaj4.default)($c1d5fff205df0ecf$export$9dd6ff9ea0189349, {
    name: "MuiListItem"
})($c1d5fff205df0ecf$var$ListItem);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");


var $79c3e69139ae2ded$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    },
    /* Styles applied to the `Typography` components if primary and secondary are set. */ multiline: {
        marginTop: 6,
        marginBottom: 6
    },
    /* Styles applied to the `Typography` components if dense. */ dense: {},
    /* Styles applied to the root element if `inset={true}`. */ inset: {
        paddingLeft: 56
    },
    /* Styles applied to the primary `Typography` component. */ primary: {},
    /* Styles applied to the secondary `Typography` component. */ secondary: {}
};
var $79c3e69139ae2ded$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, primaryProp = props.primary, primaryTypographyProps = props.primaryTypographyProps, secondaryProp = props.secondary, secondaryTypographyProps = props.secondaryTypographyProps, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography",
        "inset",
        "primary",
        "primaryTypographyProps",
        "secondary",
        "secondaryTypographyProps"
    ]);
    var _React$useContext = $acw62.useContext((0, $51d781898675016d$export$2e2bcd8739ae039)), dense = _React$useContext.dense;
    var primary = primaryProp != null ? primaryProp : children;
    if (primary != null && primary.type !== (0, $f763543f732472dc$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ $acw62.createElement((0, $f763543f732472dc$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: "span",
        display: "block"
    }, primaryTypographyProps), primary);
    var secondary = secondaryProp;
    if (secondary != null && secondary.type !== (0, $f763543f732472dc$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ $acw62.createElement((0, $f763543f732472dc$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: "body2",
        className: classes.secondary,
        color: "textSecondary",
        display: "block"
    }, secondaryTypographyProps), secondary);
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
        ref: ref
    }, other), primary, secondary);
});
var $79c3e69139ae2ded$export$2e2bcd8739ae039 = (0, $kQaj4.default)($79c3e69139ae2ded$export$9dd6ff9ea0189349, {
    name: "MuiListItemText"
})($79c3e69139ae2ded$var$ListItemText);


var $6401342929e4b3e7$exports = {};
"use strict";


Object.defineProperty($6401342929e4b3e7$exports, "__esModule", {
    value: true
});
$6401342929e4b3e7$exports.default = void 0;

var $6401342929e4b3e7$var$React = $27c3440315f0d929$exports((parcelRequire("acw62")));

var $6401342929e4b3e7$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("iAQWD")));
var $6401342929e4b3e7$var$_default = (0, $6401342929e4b3e7$var$_createSvgIcon.default)(/*#__PURE__*/ $6401342929e4b3e7$var$React.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");
$6401342929e4b3e7$exports.default = $6401342929e4b3e7$var$_default;


var $d132c99d3d4b75f3$exports = {};
"use strict";


Object.defineProperty($d132c99d3d4b75f3$exports, "__esModule", {
    value: true
});
$d132c99d3d4b75f3$exports.default = void 0;

var $d132c99d3d4b75f3$var$React = $27c3440315f0d929$exports((parcelRequire("acw62")));

var $d132c99d3d4b75f3$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("iAQWD")));
var $d132c99d3d4b75f3$var$_default = (0, $d132c99d3d4b75f3$var$_createSvgIcon.default)(/*#__PURE__*/ $d132c99d3d4b75f3$var$React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
$d132c99d3d4b75f3$exports.default = $d132c99d3d4b75f3$var$_default;



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");
var $0f40b360697eae63$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            display: "flex",
            alignItems: "center"
        },
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: (0, $kSlfw.default)({
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }, theme.breakpoints.up("sm"), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `variant="regular"`. */ regular: theme.mixins.toolbar,
        /* Styles applied to the root element if `variant="dense"`. */ dense: {
            minHeight: 48
        }
    };
};
var $0f40b360697eae63$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$variant = props.variant, variant = _props$variant === void 0 ? "regular" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "variant"
    ]);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $0f40b360697eae63$export$2e2bcd8739ae039 = (0, $kQaj4.default)($0f40b360697eae63$export$9dd6ff9ea0189349, {
    name: "MuiToolbar"
})($0f40b360697eae63$var$Toolbar);





var $acw62 = parcelRequire("acw62");






var $8DzwJ = parcelRequire("8DzwJ");





var $acw62 = parcelRequire("acw62");

parcelRequire("eUqlC");

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");

var $f9tk6 = parcelRequire("f9tk6");
var $e7022f10a1fb19ca$var$RADIUS_STANDARD = 10;
var $e7022f10a1fb19ca$var$RADIUS_DOT = 4;
var $e7022f10a1fb19ca$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            display: "inline-flex",
            // For correct alignment with the text.
            verticalAlign: "middle",
            flexShrink: 0
        },
        /* Styles applied to the badge `span` element. */ badge: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            position: "absolute",
            boxSizing: "border-box",
            fontFamily: theme.typography.fontFamily,
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.pxToRem(12),
            minWidth: $e7022f10a1fb19ca$var$RADIUS_STANDARD * 2,
            lineHeight: 1,
            padding: "0 6px",
            height: $e7022f10a1fb19ca$var$RADIUS_STANDARD * 2,
            borderRadius: $e7022f10a1fb19ca$var$RADIUS_STANDARD,
            zIndex: 1,
            // Render the badge on top of potential ripples.
            transition: theme.transitions.create("transform", {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.enteringScreen
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText
        },
        /* Styles applied to the root element if `variant="dot"`. */ dot: {
            borderRadius: $e7022f10a1fb19ca$var$RADIUS_DOT,
            height: $e7022f10a1fb19ca$var$RADIUS_DOT * 2,
            minWidth: $e7022f10a1fb19ca$var$RADIUS_DOT * 2,
            padding: 0
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */ anchorOriginTopRightRectangle: {
            top: 0,
            right: 0,
            transform: "scale(1) translate(50%, -50%)",
            transformOrigin: "100% 0%",
            "&$invisible": {
                transform: "scale(0) translate(50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangular"`. */ anchorOriginTopRightRectangular: {
            top: 0,
            right: 0,
            transform: "scale(1) translate(50%, -50%)",
            transformOrigin: "100% 0%",
            "&$invisible": {
                transform: "scale(0) translate(50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */ anchorOriginBottomRightRectangle: {
            bottom: 0,
            right: 0,
            transform: "scale(1) translate(50%, 50%)",
            transformOrigin: "100% 100%",
            "&$invisible": {
                transform: "scale(0) translate(50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangular"`. */ anchorOriginBottomRightRectangular: {
            bottom: 0,
            right: 0,
            transform: "scale(1) translate(50%, 50%)",
            transformOrigin: "100% 100%",
            "&$invisible": {
                transform: "scale(0) translate(50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */ anchorOriginTopLeftRectangle: {
            top: 0,
            left: 0,
            transform: "scale(1) translate(-50%, -50%)",
            transformOrigin: "0% 0%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangular"`. */ anchorOriginTopLeftRectangular: {
            top: 0,
            left: 0,
            transform: "scale(1) translate(-50%, -50%)",
            transformOrigin: "0% 0%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */ anchorOriginBottomLeftRectangle: {
            bottom: 0,
            left: 0,
            transform: "scale(1) translate(-50%, 50%)",
            transformOrigin: "0% 100%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangular"`. */ anchorOriginBottomLeftRectangular: {
            bottom: 0,
            left: 0,
            transform: "scale(1) translate(-50%, 50%)",
            transformOrigin: "0% 100%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */ anchorOriginTopRightCircle: {
            top: "14%",
            right: "14%",
            transform: "scale(1) translate(50%, -50%)",
            transformOrigin: "100% 0%",
            "&$invisible": {
                transform: "scale(0) translate(50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circular"`. */ anchorOriginTopRightCircular: {
            top: "14%",
            right: "14%",
            transform: "scale(1) translate(50%, -50%)",
            transformOrigin: "100% 0%",
            "&$invisible": {
                transform: "scale(0) translate(50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */ anchorOriginBottomRightCircle: {
            bottom: "14%",
            right: "14%",
            transform: "scale(1) translate(50%, 50%)",
            transformOrigin: "100% 100%",
            "&$invisible": {
                transform: "scale(0) translate(50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circular"`. */ anchorOriginBottomRightCircular: {
            bottom: "14%",
            right: "14%",
            transform: "scale(1) translate(50%, 50%)",
            transformOrigin: "100% 100%",
            "&$invisible": {
                transform: "scale(0) translate(50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */ anchorOriginTopLeftCircle: {
            top: "14%",
            left: "14%",
            transform: "scale(1) translate(-50%, -50%)",
            transformOrigin: "0% 0%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circular"`. */ anchorOriginTopLeftCircular: {
            top: "14%",
            left: "14%",
            transform: "scale(1) translate(-50%, -50%)",
            transformOrigin: "0% 0%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, -50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */ anchorOriginBottomLeftCircle: {
            bottom: "14%",
            left: "14%",
            transform: "scale(1) translate(-50%, 50%)",
            transformOrigin: "0% 100%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, 50%)"
            }
        },
        /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circular"`. */ anchorOriginBottomLeftCircular: {
            bottom: "14%",
            left: "14%",
            transform: "scale(1) translate(-50%, 50%)",
            transformOrigin: "0% 100%",
            "&$invisible": {
                transform: "scale(0) translate(-50%, 50%)"
            }
        },
        /* Pseudo-class to the badge `span` element if `invisible={true}`. */ invisible: {
            transition: theme.transitions.create("transform", {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.leavingScreen
            })
        }
    };
};
var $e7022f10a1fb19ca$var$Badge = /*#__PURE__*/ $acw62.forwardRef(function Badge(props, ref) {
    var _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "top",
        horizontal: "right"
    } : _props$anchorOrigin, badgeContent = props.badgeContent, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, ComponentProp = _props$component === void 0 ? "span" : _props$component, invisibleProp = props.invisible, _props$max = props.max, max = _props$max === void 0 ? 99 : _props$max, _props$overlap = props.overlap, overlap = _props$overlap === void 0 ? "rectangle" : _props$overlap, _props$showZero = props.showZero, showZero = _props$showZero === void 0 ? false : _props$showZero, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "anchorOrigin",
        "badgeContent",
        "children",
        "classes",
        "className",
        "color",
        "component",
        "invisible",
        "max",
        "overlap",
        "showZero",
        "variant"
    ]);
    var invisible = invisibleProp;
    if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== "dot")) invisible = true;
    var displayValue = "";
    if (variant !== "dot") displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
    return /*#__PURE__*/ $acw62.createElement(ComponentProp, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other), children, /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, $1SA7b.default)(classes.badge, classes["".concat(anchorOrigin.horizontal).concat((0, $f9tk6.default)(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat((0, $f9tk6.default)(anchorOrigin.vertical)).concat((0, $f9tk6.default)(anchorOrigin.horizontal)).concat((0, $f9tk6.default)(overlap))], color !== "default" && classes["color".concat((0, $f9tk6.default)(color))], invisible && classes.invisible, variant === "dot" && classes.dot)
    }, displayValue));
});
var $e7022f10a1fb19ca$export$2e2bcd8739ae039 = (0, $kQaj4.default)($e7022f10a1fb19ca$export$9dd6ff9ea0189349, {
    name: "MuiBadge"
})($e7022f10a1fb19ca$var$Badge);






var $9X7IJ = parcelRequire("9X7IJ");

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $b2f42959b4d3d2ac$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $8nd05.default)({}, theme.typography.body1, (0, $kSlfw.default)({
            minHeight: 48,
            paddingTop: 6,
            paddingBottom: 6,
            boxSizing: "border-box",
            width: "auto",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }, theme.breakpoints.up("sm"), {
            minHeight: "auto"
        })),
        // TODO v5: remove
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: {},
        /* Styles applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the root element if dense. */ dense: (0, $8nd05.default)({}, theme.typography.body2, {
            minHeight: "auto"
        })
    };
};
var $b2f42959b4d3d2ac$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "li" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, ListItemClasses = props.ListItemClasses, _props$role = props.role, role = _props$role === void 0 ? "menuitem" : _props$role, selected = props.selected, tabIndexProp = props.tabIndex, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "ListItemClasses",
        "role",
        "selected",
        "tabIndex"
    ]);
    var tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ $acw62.createElement((0, $c1d5fff205df0ecf$export$2e2bcd8739ae039), (0, $8nd05.default)({
        button: true,
        role: role,
        tabIndex: tabIndex,
        component: component,
        selected: selected,
        disableGutters: disableGutters,
        classes: (0, $8nd05.default)({
            dense: classes.dense
        }, ListItemClasses),
        className: (0, $1SA7b.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $b2f42959b4d3d2ac$export$2e2bcd8739ae039 = (0, $kQaj4.default)($b2f42959b4d3d2ac$export$9dd6ff9ea0189349, {
    name: "MuiMenuItem"
})($b2f42959b4d3d2ac$var$MenuItem);



var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $9GbWv = parcelRequire("9GbWv");
var $2ff509fc6b8312a4$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 1,
            margin: 0,
            // Reset browser default style.
            border: "none",
            flexShrink: 0,
            backgroundColor: theme.palette.divider
        },
        /* Styles applied to the root element if `absolute={true}`. */ absolute: {
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%"
        },
        /* Styles applied to the root element if `variant="inset"`. */ inset: {
            marginLeft: 72
        },
        /* Styles applied to the root element if `light={true}`. */ light: {
            backgroundColor: (0, $9GbWv.alpha)(theme.palette.divider, 0.08)
        },
        /* Styles applied to the root element if `variant="middle"`. */ middle: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2)
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            height: "100%",
            width: 1
        },
        /* Styles applied to the root element if `flexItem={true}`. */ flexItem: {
            alignSelf: "stretch",
            height: "auto"
        }
    };
};
var $2ff509fc6b8312a4$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(props, ref) {
    var _props$absolute = props.absolute, absolute = _props$absolute === void 0 ? false : _props$absolute, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "hr" : _props$component, _props$flexItem = props.flexItem, flexItem = _props$flexItem === void 0 ? false : _props$flexItem, _props$light = props.light, light = _props$light === void 0 ? false : _props$light, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, _props$role = props.role, role = _props$role === void 0 ? Component !== "hr" ? "separator" : undefined : _props$role, _props$variant = props.variant, variant = _props$variant === void 0 ? "fullWidth" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "absolute",
        "classes",
        "className",
        "component",
        "flexItem",
        "light",
        "orientation",
        "role",
        "variant"
    ]);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, variant !== "fullWidth" && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === "vertical" && classes.vertical),
        role: role,
        ref: ref
    }, other));
});
var $2ff509fc6b8312a4$export$2e2bcd8739ae039 = (0, $kQaj4.default)($2ff509fc6b8312a4$export$9dd6ff9ea0189349, {
    name: "MuiDivider"
})($2ff509fc6b8312a4$var$Divider);




const $e5fc6b2ca2f72a83$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>({
        grow: {
            flexGrow: 1,
            width: `calc(100% - 240px)`,
            marginLeft: 240
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            display: "none",
            [theme.breakpoints.up("sm")]: {
                display: "block"
            }
        },
        avatarButton: {
            margin: "0px 19px"
        },
        square: {
            display: "flex",
            alignItems: "center",
            color: "#FFFFFF",
            boxShadow: "0px 0px 16px rgba(220, 4, 255, 0.6), inset 0px 0px 8px rgba(185, 122, 201, 0.6)",
            backdropFilter: "blur(8px)",
            backgroundColor: "linear-gradient(360deg, rgba(243, 239, 243, 0.1581) 0%, rgba(222, 90, 225, 0.119) 21.53%, rgba(243, 239, 243, 0.1581) 100%), url(telegram-cloud-photo-size-2-5204293876830024218-y_partial.jpg);"
        },
        inputRoot: {
            color: "inherit"
        },
        toolbar: {
            minHeight: 80,
            background: "#202A34"
        },
        inputInput: {
            padding: theme.spacing(1, 1, 1, 0),
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
            transition: theme.transitions.create("width"),
            width: "100%",
            [theme.breakpoints.up("md")]: {
                width: "20ch"
            }
        },
        sectionDesktop: {
            display: "none",
            [theme.breakpoints.up("md")]: {
                display: "flex"
            }
        },
        sectionMobile: {
            display: "flex",
            [theme.breakpoints.up("md")]: {
                display: "none"
            }
        },
        badge: {
            background: "orange"
        }
    }));
function $e5fc6b2ca2f72a83$export$2e2bcd8739ae039({ url: url , badge_count: badge_count , friends_incoming: friends_incoming  }) {
    const classes = $e5fc6b2ca2f72a83$var$useStyles();
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const open = Boolean(anchorEl);
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    const handleMenu = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const menuId = "primary-search-account-menu";
    friends_incoming.map((friend_name)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2f42959b4d3d2ac$export$2e2bcd8739ae039), {
            onClick: handleClose,
            children: friend_name
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50480f2bcbf21ff1$export$2e2bcd8739ae039), {
                className: classes.avatarButton,
                onClick: handleMenu,
                edge: "end",
                "aria-label": "account of current user",
                "aria-controls": menuId,
                "aria-haspopup": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7022f10a1fb19ca$export$2e2bcd8739ae039), {
                    badgeContent: badge_count,
                    color: "secondary",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ea67090213a71b$export$2e2bcd8739ae039), {
                        variant: "square",
                        className: classes.square,
                        src: url,
                        children: "N"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3c96b1796a446bf9$export$2e2bcd8739ae039), {
                anchorEl: anchorEl,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                id: menuId,
                keepMounted: true,
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                open: open,
                onClose: handleClose,
                onClick: handleClose,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                        to: "/profile/" + user.userData?.amax_player_data.stats.playerName,
                        style: {
                            color: "#E5E5E5",
                            textDecoration: "none"
                        },
                        activeStyle: {
                            color: "#E5E5E5",
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2f42959b4d3d2ac$export$2e2bcd8739ae039), {
                            onClick: handleClose,
                            children: "Profile"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ff509fc6b8312a4$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                        to: "/log_out",
                        style: {
                            color: "#E5E5E5",
                            textDecoration: "none"
                        },
                        activeStyle: {
                            color: "#E5E5E5",
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2f42959b4d3d2ac$export$2e2bcd8739ae039), {
                            onClick: handleClose,
                            children: "Log out"
                        })
                    })
                ]
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");





const $c62f6909a663b6c0$var$AMAX_API_URL = "https://amax-emu.com/api";
const $c62f6909a663b6c0$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            flexGrow: 1,
            marginLeft: 0,
            width: `calc(100% - 0px)`,
            [theme.breakpoints.up("sm")]: {
                width: `calc(100% - 240px)`,
                marginLeft: 240,
                flexShrink: 0
            }
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        DiscordButton: {
            backgroundColor: "#7289DA",
            marginLeft: "auto"
        },
        DiscordIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 12 12"
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        },
        avatarButton: {
            margin: "0px 19px"
        },
        square: {
            display: "flex",
            alignItems: "center",
            color: "#FFFFFF",
            boxShadow: "0px 0px 16px rgba(220, 4, 255, 0.6), inset 0px 0px 8px rgba(185, 122, 201, 0.6)",
            backdropFilter: "blur(8px)",
            backgroundColor: "linear-gradient(360deg, rgba(243, 239, 243, 0.1581) 0%, rgba(222, 90, 225, 0.119) 21.53%, rgba(243, 239, 243, 0.1581) 100%), url(telegram-cloud-photo-size-2-5204293876830024218-y_partial.jpg);"
        },
        CreateAmaxAccButton: {
            backgroundColor: "#111111",
            margin: "1em"
        }
    }));
function $c62f6909a663b6c0$export$2e2bcd8739ae039() {
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    const classes = $c62f6909a663b6c0$var$useStyles();
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [isMobile, setIsMobile] = $acw62.useState(false);
    //choose the screen size
    const handleResize = ()=>{
        if (window.innerWidth < 720) setIsMobile(true);
        else setIsMobile(false);
    };
    // create an event listener
    $acw62.useEffect(()=>{
        window.addEventListener("resize", handleResize);
    });
    const PlayerAvatarWidgetComponent = ()=>{
        if (user.userData?.amax_account !== undefined) {
            if (user.userData?.amax_account === true) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5fc6b2ca2f72a83$export$2e2bcd8739ae039), {
                url: user.userData.avatarUrl,
                badge_count: user.userData.amax_player_data.friends_purposes.incoming.length,
                friends_incoming: user.userData.amax_player_data.friends_purposes.incoming
            });
            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                        to: "/register",
                        style: {
                            color: "#92929F",
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                            className: classes.CreateAmaxAccButton,
                            size: "large",
                            children: t("appbar.create_amax_account")
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ea67090213a71b$export$2e2bcd8739ae039), {
                        variant: "square",
                        className: classes.square,
                        src: user.userData.avatarUrl,
                        children: "username"
                    })
                ]
            });
        } else {
            if (isMobile) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50480f2bcbf21ff1$export$2e2bcd8739ae039), {
                "aria-label": "login",
                href: $c62f6909a663b6c0$var$AMAX_API_URL + "/auth/login",
                className: classes.DiscordButton,
                disableElevation: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da84ea47bfe68d62$export$de73dc4d201c5f29), {})
            });
            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                href: $c62f6909a663b6c0$var$AMAX_API_URL + "/auth/login",
                className: classes.DiscordButton,
                disableElevation: true,
                endIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da84ea47bfe68d62$export$de73dc4d201c5f29), {}),
                children: t("appbar.login_discord")
            });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PlayerAvatarWidgetComponent, {});
}



parcelRequire("acw62");




parcelRequire("acw62");


function $2e9a4321ef8b6908$var$return_rank_class(level, legend) {
    if (legend > 0) return "appbar_legend" + legend;
    else return "appbar_rank" + level;
}
function $2e9a4321ef8b6908$export$2e2bcd8739ae039({ user_level: user_level , user_legend: user_legend , user_exp: user_exp , user_exp_percent: user_exp_percent , user_name: user_name  }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "appbar_player_component",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "appbar_rank_wrapper",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "appbar_rank_container",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: $2e9a4321ef8b6908$var$return_rank_class(user_level, user_legend)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "appbar_level_value",
                        children: user_level
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $063a2ffe7d6b7652$export$2e2bcd8739ae039), {
                exp_value: user_exp_percent
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "appbar_player_name",
                children: user_name
            })
        ]
    });
}


const $7a7ccac4c2d57ea1$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            flexGrow: 1,
            marginLeft: 0,
            width: `calc(100% - 0px)`,
            [theme.breakpoints.up("sm")]: {
                width: `calc(100% - 240px)`,
                marginLeft: 240,
                flexShrink: 0
            }
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        DiscordButton: {
            backgroundColor: "#7289DA"
        },
        DiscordIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 12 12"
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        },
        avatarButton: {
            margin: "0px 19px"
        },
        square: {
            display: "flex",
            alignItems: "center",
            color: "#FFFFFF",
            boxShadow: "0px 0px 16px rgba(220, 4, 255, 0.6), inset 0px 0px 8px rgba(185, 122, 201, 0.6)",
            backdropFilter: "blur(8px)",
            backgroundColor: "linear-gradient(360deg, rgba(243, 239, 243, 0.1581) 0%, rgba(222, 90, 225, 0.119) 21.53%, rgba(243, 239, 243, 0.1581) 100%), url(telegram-cloud-photo-size-2-5204293876830024218-y_partial.jpg);"
        },
        CreateAmaxAccButton: {
            backgroundColor: "#111111",
            marginLeft: "1em"
        }
    }));
function $7a7ccac4c2d57ea1$export$2e2bcd8739ae039() {
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    const classes = $7a7ccac4c2d57ea1$var$useStyles();
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const PlayerStatsWidget = ()=>{
        if (user.userData?.amax_account !== undefined) {
            if (user.userData?.amax_account === true) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e9a4321ef8b6908$export$2e2bcd8739ae039), {
                user_level: user.userData.amax_player_data.leveling.level + 1,
                user_legend: user.userData.amax_player_data.leveling.legend,
                user_exp: user.userData.amax_player_data.leveling.fans,
                user_exp_percent: user.userData.amax_player_data.leveling.fans_levelup_percent,
                user_name: user.userData.amax_player_data.stats.playerName
            });
            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PlayerStatsWidget, {});
}


const $da84ea47bfe68d62$var$AMAX_API_URL = "https://amax-emu.com/api";
const $da84ea47bfe68d62$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            flexGrow: 1,
            marginLeft: 0,
            width: `calc(100% - 0px)`,
            [theme.breakpoints.up("sm")]: {
                width: `calc(100% - 240px)`,
                marginLeft: 240,
                flexShrink: 0
            }
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        DiscordButton: {
            backgroundColor: "#7289DA"
        },
        DiscordIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 12 12"
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        },
        avatarButton: {
            margin: "0px 19px"
        },
        square: {
            display: "flex",
            alignItems: "center",
            color: "#FFFFFF",
            boxShadow: "0px 0px 16px rgba(220, 4, 255, 0.6), inset 0px 0px 8px rgba(185, 122, 201, 0.6)",
            backdropFilter: "blur(8px)",
            backgroundColor: "linear-gradient(360deg, rgba(243, 239, 243, 0.1581) 0%, rgba(222, 90, 225, 0.119) 21.53%, rgba(243, 239, 243, 0.1581) 100%), url(telegram-cloud-photo-size-2-5204293876830024218-y_partial.jpg);"
        },
        CreateAmaxAccButton: {
            backgroundColor: "#111111",
            marginLeft: "1em"
        }
    }));
function $da84ea47bfe68d62$export$de73dc4d201c5f29() {
    const classes = $da84ea47bfe68d62$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8DzwJ.default), {
        className: classes.DiscordIcon,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9.828 10.068C9.144 10.068 8.604 10.668 8.604 11.4C8.604 12.132 9.156 12.732 9.828 12.732C10.512 12.732 11.052 12.132 11.052 11.4C11.064 10.668 10.512 10.068 9.828 10.068ZM14.208 10.068C13.524 10.068 12.984 10.668 12.984 11.4C12.984 12.132 13.536 12.732 14.208 12.732C14.892 12.732 15.432 12.132 15.432 11.4C15.432 10.668 14.892 10.068 14.208 10.068Z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.04 0H3.96C2.604 0 1.5 1.104 1.5 2.472V18.696C1.5 20.064 2.604 21.168 3.96 21.168H17.568L16.932 18.948L18.468 20.376L19.92 21.72L22.5 24V2.472C22.5 1.104 21.396 0 20.04 0ZM15.408 15.672C15.408 15.672 14.976 15.156 14.616 14.7C16.188 14.256 16.788 13.272 16.788 13.272C16.296 13.596 15.828 13.824 15.408 13.98C14.808 14.232 14.232 14.4 13.668 14.496C12.6403 14.6852 11.5862 14.6812 10.56 14.484C9.95751 14.3661 9.36705 14.1934 8.796 13.968C8.49499 13.8522 8.2023 13.7159 7.92 13.56C7.884 13.536 7.848 13.524 7.812 13.5C7.788 13.488 7.776 13.476 7.764 13.464C7.548 13.344 7.428 13.26 7.428 13.26C7.428 13.26 8.004 14.22 9.528 14.676C9.168 15.132 8.724 15.672 8.724 15.672C6.072 15.588 5.064 13.848 5.064 13.848C5.064 9.984 6.792 6.852 6.792 6.852C8.52 5.556 10.164 5.592 10.164 5.592L10.284 5.736C8.124 6.36 7.128 7.308 7.128 7.308C7.128 7.308 7.392 7.164 7.836 6.96C9.12 6.396 10.14 6.24 10.56 6.204C10.632 6.192 10.692 6.18 10.764 6.18C12.8449 5.89835 14.9612 6.29384 16.8 7.308C16.8 7.308 15.852 6.408 13.812 5.784L13.98 5.592C13.98 5.592 15.624 5.556 17.352 6.852C17.352 6.852 19.08 9.984 19.08 13.848C19.08 13.848 18.06 15.588 15.408 15.672V15.672Z"
            })
        ]
    });
}
function $da84ea47bfe68d62$export$2e2bcd8739ae039() {
    const [mobileOpen, setMobileOpen] = $acw62.useState(false);
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const auth = (0, $fa8bb1513e386061$export$650ce9f0b4df82fd)();
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    const classes = $da84ea47bfe68d62$var$useStyles();
    // Lucas:
    // Functions passed to useEffect cannot be async.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968e2cc4493acf64$export$2e2bcd8739ae039), {
            position: "static",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0f40b360697eae63$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                        variant: "h6",
                        className: classes.title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a7ccac4c2d57ea1$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c62f6909a663b6c0$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
}




var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $dbb0437a81b1cf36$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            minWidth: 56,
            color: theme.palette.action.active,
            flexShrink: 0,
            display: "inline-flex"
        },
        /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */ alignItemsFlexStart: {
            marginTop: 8
        }
    };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ var $dbb0437a81b1cf36$var$ListItemIcon = /*#__PURE__*/ $acw62.forwardRef(function ListItemIcon(props, ref) {
    var classes = props.classes, className = props.className, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className"
    ]);
    var context = $acw62.useContext((0, $51d781898675016d$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $acw62.createElement("div", (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, context.alignItems === "flex-start" && classes.alignItemsFlexStart),
        ref: ref
    }, other));
});
var $dbb0437a81b1cf36$export$2e2bcd8739ae039 = (0, $kQaj4.default)($dbb0437a81b1cf36$export$9dd6ff9ea0189349, {
    name: "MuiListItemIcon"
})($dbb0437a81b1cf36$var$ListItemIcon);


var $85ce8be979e9ca01$exports = {};
"use strict";


Object.defineProperty($85ce8be979e9ca01$exports, "__esModule", {
    value: true
});
$85ce8be979e9ca01$exports.default = void 0;

var $85ce8be979e9ca01$var$React = $27c3440315f0d929$exports((parcelRequire("acw62")));

var $85ce8be979e9ca01$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("iAQWD")));
var $85ce8be979e9ca01$var$_default = (0, $85ce8be979e9ca01$var$_createSvgIcon.default)(/*#__PURE__*/ $85ce8be979e9ca01$var$React.createElement("path", {
    d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
}), "Dashboard");
$85ce8be979e9ca01$exports.default = $85ce8be979e9ca01$var$_default;


var $3b6be5b039ddc691$exports = {};
"use strict";


Object.defineProperty($3b6be5b039ddc691$exports, "__esModule", {
    value: true
});
$3b6be5b039ddc691$exports.default = void 0;

var $3b6be5b039ddc691$var$React = $27c3440315f0d929$exports((parcelRequire("acw62")));

var $3b6be5b039ddc691$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("iAQWD")));
var $3b6be5b039ddc691$var$_default = (0, $3b6be5b039ddc691$var$_createSvgIcon.default)(/*#__PURE__*/ $3b6be5b039ddc691$var$React.createElement("path", {
    d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
}), "History");
$3b6be5b039ddc691$exports.default = $3b6be5b039ddc691$var$_default;


var $d5416ad5d5dbe012$exports = {};

$d5416ad5d5dbe012$exports = new URL((parcelRequire("27Lyk")).resolve("bDEcT"), import.meta.url).toString();


var $4e2ef09b80570ea4$exports = {};
"use strict";


Object.defineProperty($4e2ef09b80570ea4$exports, "__esModule", {
    value: true
});
$4e2ef09b80570ea4$exports.default = void 0;

var $4e2ef09b80570ea4$var$React = $27c3440315f0d929$exports((parcelRequire("acw62")));

var $4e2ef09b80570ea4$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("iAQWD")));
var $4e2ef09b80570ea4$var$_default = (0, $4e2ef09b80570ea4$var$_createSvgIcon.default)(/*#__PURE__*/ $4e2ef09b80570ea4$var$React.createElement("path", {
    d: "M10 10.02h5V21h-5zM17 21h3c1.1 0 2-.9 2-2v-9h-5v11zm3-18H5c-1.1 0-2 .9-2 2v3h19V5c0-1.1-.9-2-2-2zM3 19c0 1.1.9 2 2 2h3V10H3v9z"
}), "TableChart");
$4e2ef09b80570ea4$exports.default = $4e2ef09b80570ea4$var$_default;



var $8bb90ec0b9262cf8$exports = {};
"use strict";


Object.defineProperty($8bb90ec0b9262cf8$exports, "__esModule", {
    value: true
});
$8bb90ec0b9262cf8$exports.default = void 0;

var $8bb90ec0b9262cf8$var$React = $27c3440315f0d929$exports((parcelRequire("acw62")));

var $8bb90ec0b9262cf8$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("iAQWD")));
var $8bb90ec0b9262cf8$var$_default = (0, $8bb90ec0b9262cf8$var$_createSvgIcon.default)(/*#__PURE__*/ $8bb90ec0b9262cf8$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
}), "Help");
$8bb90ec0b9262cf8$exports.default = $8bb90ec0b9262cf8$var$_default;


var $3c91c779725be378$exports = {};
"use strict";


Object.defineProperty($3c91c779725be378$exports, "__esModule", {
    value: true
});
$3c91c779725be378$exports.default = void 0;

var $3c91c779725be378$var$React = $27c3440315f0d929$exports((parcelRequire("acw62")));

var $3c91c779725be378$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("iAQWD")));
var $3c91c779725be378$var$_default = (0, $3c91c779725be378$var$_createSvgIcon.default)(/*#__PURE__*/ $3c91c779725be378$var$React.createElement("path", {
    d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"
}), "Announcement");
$3c91c779725be378$exports.default = $3c91c779725be378$var$_default;




var $adeefef78011838f$exports = {};
"use strict";


Object.defineProperty($adeefef78011838f$exports, "__esModule", {
    value: true
});
$adeefef78011838f$exports.default = void 0;

var $adeefef78011838f$var$React = $27c3440315f0d929$exports((parcelRequire("acw62")));

var $adeefef78011838f$var$_createSvgIcon = $0f49c8ba50dff6ee$exports((parcelRequire("iAQWD")));
var $adeefef78011838f$var$_default = (0, $adeefef78011838f$var$_createSvgIcon.default)(/*#__PURE__*/ $adeefef78011838f$var$React.createElement("path", {
    d: "M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"
}), "AccountBox");
$adeefef78011838f$exports.default = $adeefef78011838f$var$_default;



parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");



// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $1e4827e2a850b1f0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $1e4827e2a850b1f0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $1e4827e2a850b1f0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




var $acw62 = parcelRequire("acw62");
function $d637ac0d813ae381$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}


var $90a633ad7a979daa$export$2e2bcd8739ae039 = (0, $d637ac0d813ae381$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $8426ae8303951a73$export$2e2bcd8739ae039 = $8426ae8303951a73$var$FormControlContext;




function $ce03a37a8cfb980d$export$149c8b8bab2289d1(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiFormControl", slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $ce03a37a8cfb980d$export$2e2bcd8739ae039 = $ce03a37a8cfb980d$var$formControlClasses;



const $bcd22a386c6068c0$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , margin: margin , fullWidth: fullWidth  } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $e7b578196486f177$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $ce03a37a8cfb980d$export$149c8b8bab2289d1), classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState  }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, styles[`margin${(0, $e7b578196486f177$export$2e2bcd8739ae039)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState  })=>(0, $8nd05.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children , className: className , color: color = "primary" , component: component = "div" , disabled: disabled = false , error: error = false , focused: visuallyFocused , fullWidth: fullWidth = false , hiddenLabel: hiddenLabel = false , margin: margin = "none" , required: required = false , size: size = "medium" , variant: variant = "outlined"  } = props, other = (0, $1En50.default)(props, $bcd22a386c6068c0$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $1e4827e2a850b1f0$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(child.props, true) || (0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bcd22a386c6068c0$var$FormControlRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $1SA7b.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $bcd22a386c6068c0$export$2e2bcd8739ae039 = $bcd22a386c6068c0$var$FormControl;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $1SA7b = parcelRequire("1SA7b");
function $766e740713576b8d$export$2e2bcd8739ae039({ props: props , states: states , muiFormControl: muiFormControl  }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $acw62 = parcelRequire("acw62");

function $946238fa82894619$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $8426ae8303951a73$export$2e2bcd8739ae039));
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");








function $c678fac155df4fc3$export$f7d501e40371cd17(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiFormLabel", slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $c678fac155df4fc3$export$2e2bcd8739ae039 = $c678fac155df4fc3$var$formLabelClasses;



const $9b0ab7de0d37835d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , color: color , focused: focused , disabled: disabled , error: error , filled: filled , required: required  } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $e7b578196486f177$export$2e2bcd8739ae039)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $c678fac155df4fc3$export$f7d501e40371cd17), classes);
};
const $9b0ab7de0d37835d$export$aa5bc7f8a4705b27 = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState  }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme  })=>({
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children , className: className , component: component = "label"  } = props, other = (0, $1En50.default)(props, $9b0ab7de0d37835d$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($9b0ab7de0d37835d$export$aa5bc7f8a4705b27, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    " ",
                    "*"
                ]
            })
        ]
    }));
});
var $9b0ab7de0d37835d$export$2e2bcd8739ae039 = $9b0ab7de0d37835d$var$FormLabel;






function $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiInputLabel", slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $9313ead0c5e2e8ca$export$2e2bcd8739ae039 = $9313ead0c5e2e8ca$var$inputLabelClasses;



const $09846a8ab0aba36e$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , formControl: formControl , size: size , shrink: shrink , disableAnimation: disableAnimation , variant: variant , required: required  } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size === "small" && "sizeSmall",
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0277c5e26ff0d56c$export$effb20ecdbf4d6aa)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            {
                [`& .${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $8nd05.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $8nd05.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $8nd05.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $8nd05.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false , shrink: shrinkProp , className: className  } = props, other = (0, $1En50.default)(props, $09846a8ab0aba36e$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($09846a8ab0aba36e$var$InputLabelRoot, (0, $8nd05.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $09846a8ab0aba36e$export$2e2bcd8739ae039 = $09846a8ab0aba36e$var$InputLabel;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");


var $acw62 = parcelRequire("acw62");
var $936e1576c7caee60$exports = {};
"use strict";

$936e1576c7caee60$exports = (parcelRequire("cSJDD"));




var $1SA7b = parcelRequire("1SA7b");

function $4cf4482b502c4310$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $c10afe25107351d9$export$2e2bcd8739ae039 = (0, $4cf4482b502c4310$export$2e2bcd8739ae039);




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $1SA7b = parcelRequire("1SA7b");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");




var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $2ddba918a398c481$export$2e2bcd8739ae039 = $2ddba918a398c481$var$ListContext;




function $adbbc5717e0d0350$export$c6bd6795ed6e3203(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiList", slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $adbbc5717e0d0350$export$2e2bcd8739ae039 = $adbbc5717e0d0350$var$listClasses;



const $640cd381f5e8b3ea$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disablePadding: disablePadding , dense: dense , subheader: subheader  } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $adbbc5717e0d0350$export$c6bd6795ed6e3203), classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState  })=>(0, $8nd05.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children , className: className , component: component = "ul" , dense: dense = false , disablePadding: disablePadding = false , subheader: subheader  } = props, other = (0, $1En50.default)(props, $640cd381f5e8b3ea$var$_excluded);
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($640cd381f5e8b3ea$var$ListRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $1SA7b.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $640cd381f5e8b3ea$export$2e2bcd8739ae039 = $640cd381f5e8b3ea$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $7a9415d492047f70$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $0d80e79907b6bdbc$export$2e2bcd8739ae039 = (0, $7a9415d492047f70$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $a5536215dd353a4e$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $6fd6e1f605afb988$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $a5536215dd353a4e$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


var $72d5a979b2ad8bc9$export$2e2bcd8739ae039 = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
const $f8b7b39c1ae7354b$var$useEnhancedEffect = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
var $f8b7b39c1ae7354b$export$2e2bcd8739ae039 = $f8b7b39c1ae7354b$var$useEnhancedEffect;


var $ec346974df496fc5$export$2e2bcd8739ae039 = (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039);



const $fbb3fa0cdc277971$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions , autoFocus: autoFocus = false , autoFocusItem: autoFocusItem = false , children: children , className: className , disabledItemsFocusable: disabledItemsFocusable = false , disableListWrap: disableListWrap = false , onKeyDown: onKeyDown , variant: variant = "selectedMenu"  } = props, other = (0, $1En50.default)(props, $fbb3fa0cdc277971$var$_excluded);
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $0d80e79907b6bdbc$export$2e2bcd8739ae039)((0, $c10afe25107351d9$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $640cd381f5e8b3ea$export$2e2bcd8739ae039), (0, $8nd05.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $fbb3fa0cdc277971$export$2e2bcd8739ae039 = $fbb3fa0cdc277971$var$MenuList;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");




// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $23fa506264c010ed$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $23fa506264c010ed$export$2e2bcd8739ae039 = $23fa506264c010ed$var$getOverlayAlpha;






function $4ec306d48089c2c9$export$29cdb466b9b6f20b(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiPaper", slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $4ec306d48089c2c9$export$2e2bcd8739ae039 = $4ec306d48089c2c9$var$paperClasses;



const $595185d0d7275c3b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square , elevation: elevation , variant: variant , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $4ec306d48089c2c9$export$29cdb466b9b6f20b), classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _theme$vars$overlays;
    return (0, $8nd05.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $8nd05.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $e0579d99723e0dfe$export$58f0f39f63f3cf42)("#fff", (0, $23fa506264c010ed$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $e0579d99723e0dfe$export$58f0f39f63f3cf42)("#fff", (0, $23fa506264c010ed$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className , component: component = "div" , elevation: elevation = 1 , square: square = false , variant: variant = "elevation"  } = props, other = (0, $1En50.default)(props, $595185d0d7275c3b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($595185d0d7275c3b$var$PaperRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other));
});
var $595185d0d7275c3b$export$2e2bcd8739ae039 = $595185d0d7275c3b$var$Paper;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");




// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $41c4238d7b0ec499$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $0f2866359d6621f3$export$2e2bcd8739ae039 = (0, $41c4238d7b0ec499$export$2e2bcd8739ae039);




function $230cae465a5568fd$export$2e2bcd8739ae039(node) {
    const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $707049eb9639aeac$export$2e2bcd8739ae039 = (0, $230cae465a5568fd$export$2e2bcd8739ae039);




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");




const $cc10aae84e3e4b9c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $cc10aae84e3e4b9c$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout , easing: easing , style: style = {}  } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




const $d6f4882a3b1c59f2$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d6f4882a3b1c59f2$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener , appear: appear = true , children: children , easing: easing , in: inProp , onEnter: onEnter , onEntered: onEntered , onEntering: onEntering , onExit: onExit , onExited: onExited , onExiting: onExiting , style: style , timeout: timeout = "auto" , TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039)  } = props, other = (0, $1En50.default)(props, $d6f4882a3b1c59f2$var$_excluded);
    const timer = $acw62.useRef();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration , delay: delay , easing: transitionTimingFunction  } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration , delay: delay , easing: transitionTimingFunction  } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6f4882a3b1c59f2$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $d6f4882a3b1c59f2$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$export$2e2bcd8739ae039 = $d6f4882a3b1c59f2$var$Grow;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $c91b8f922607ad66$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}


var $acw62 = parcelRequire("acw62");

function $7132531a8fc4c99c$export$2e2bcd8739ae039(fn) {
    const ref = $acw62.useRef(fn);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $acw62.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}




var $acw62 = parcelRequire("acw62");




function $b2ad7edda02764f6$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base/react-portal/components-api/#portal)
 */ const $b2ad7edda02764f6$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children , container: container , disablePortal: disablePortal = false  } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(/*#__PURE__*/ $acw62.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($b2ad7edda02764f6$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $a5536215dd353a4e$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $a5536215dd353a4e$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
        children: mountNode ? /*#__PURE__*/ $11492dca620dcaa5$exports.createPortal(children, mountNode) : mountNode
    });
});
var $b2ad7edda02764f6$export$2e2bcd8739ae039 = $b2ad7edda02764f6$var$Portal;



// Is a vertical scrollbar displayed?
function $4a3a8d931ce9041d$var$isOverflowing(container) {
    const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $230cae465a5568fd$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $4a3a8d931ce9041d$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $4a3a8d931ce9041d$var$getPaddingRight(element) {
    return parseInt((0, $230cae465a5568fd$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $4a3a8d931ce9041d$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $4a3a8d931ce9041d$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$4a3a8d931ce9041d$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $4a3a8d931ce9041d$export$e1bd0c6150f13d96(element, show);
    });
}
function $4a3a8d931ce9041d$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $4a3a8d931ce9041d$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($4a3a8d931ce9041d$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $7a9415d492047f70$export$2e2bcd8739ae039)((0, $4cf4482b502c4310$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$4a3a8d931ce9041d$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$4a3a8d931ce9041d$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(container).body;
        else {
            // Improve Gatsby support
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $230cae465a5568fd$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value , el: el , property: property  })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $4a3a8d931ce9041d$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $4a3a8d931ce9041d$export$2e2bcd8739ae039 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $4a3a8d931ce9041d$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $4a3a8d931ce9041d$var$getHiddenSiblings(container);
        $4a3a8d931ce9041d$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $4a3a8d931ce9041d$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $4a3a8d931ce9041d$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $4a3a8d931ce9041d$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $4a3a8d931ce9041d$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $4a3a8d931ce9041d$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $4a3a8d931ce9041d$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $4a3a8d931ce9041d$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ 
var $acw62 = parcelRequire("acw62");



// Inspired by https://github.com/focus-trap/tabbable
const $9feea497446f1db4$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $9feea497446f1db4$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $9feea497446f1db4$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $9feea497446f1db4$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $9feea497446f1db4$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $9feea497446f1db4$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($9feea497446f1db4$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $9feea497446f1db4$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$9feea497446f1db4$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $9feea497446f1db4$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base/react-focus-trap/components-api/#focus-trap)
 */ function $9feea497446f1db4$var$FocusTrap(props) {
    const { children: children , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableRestoreFocus: disableRestoreFocus = false , getTabbable: getTabbable = $9feea497446f1db4$var$defaultGetTabbable , isEnabled: isEnabled = $9feea497446f1db4$var$defaultIsEnabled , open: open  } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4cf4482b502c4310$export$2e2bcd8739ae039)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement  } = rootRef;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                        if (isShiftTab) focusPrevious.focus();
                        else focusNext.focus();
                    }
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain(null);
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $9feea497446f1db4$export$2e2bcd8739ae039 = $9feea497446f1db4$var$FocusTrap;




function $c132e2fdd627b873$export$67960e22b12a638d(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiModal", slot);
}
const $c132e2fdd627b873$var$modalClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $c132e2fdd627b873$export$2e2bcd8739ae039 = $c132e2fdd627b873$var$modalClasses;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");


var $8nd05 = parcelRequire("8nd05");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $93dbc7362e67d1d8$export$2e2bcd8739ae039(element) {
    return typeof element === "string";
}


function $bca986a09b53b6aa$export$2e2bcd8739ae039(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $8nd05.default)({}, otherProps, {
        ownerState: (0, $8nd05.default)({}, otherProps.ownerState, ownerState)
    });
}



var $8nd05 = parcelRequire("8nd05");

var $1SA7b = parcelRequire("1SA7b");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $929bdf9ff30fa5c5$export$2e2bcd8739ae039(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $f743bb8bda831b4a$export$2e2bcd8739ae039(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $aedfd69e1cc9b30d$export$2e2bcd8739ae039(parameters) {
    const { getSlotProps: getSlotProps , additionalProps: additionalProps , externalSlotProps: externalSlotProps , externalForwardedProps: externalForwardedProps , className: className  } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $1SA7b.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $8nd05.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $8nd05.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $929bdf9ff30fa5c5$export$2e2bcd8739ae039)((0, $8nd05.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $f743bb8bda831b4a$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $f743bb8bda831b4a$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $1SA7b.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $8nd05.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $8nd05.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $3e85a6fbe0c646f1$export$2e2bcd8739ae039(componentProps, ownerState) {
    if (typeof componentProps === "function") return componentProps(ownerState);
    return componentProps;
}


const $fce864403201fe7f$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState"
];
function $fce864403201fe7f$export$2e2bcd8739ae039(parameters) {
    var _parameters$additiona;
    const { elementType: elementType , externalSlotProps: externalSlotProps , ownerState: ownerState  } = parameters, rest = (0, $1En50.default)(parameters, $fce864403201fe7f$var$_excluded);
    const resolvedComponentsProps = (0, $3e85a6fbe0c646f1$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps , internalRef: internalRef  } = (0, $aedfd69e1cc9b30d$export$2e2bcd8739ae039)((0, $8nd05.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $bca986a09b53b6aa$export$2e2bcd8739ae039)(elementType, (0, $8nd05.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $acw62 = parcelRequire("acw62");

const $d3d8f54fb22fe977$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $d3d8f54fb22fe977$var$ClassNameConfiguratorContext = /*#__PURE__*/ $acw62.createContext($d3d8f54fb22fe977$var$defaultContextValue);
function $d3d8f54fb22fe977$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses  } = $acw62.useContext($d3d8f54fb22fe977$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $d3d8f54fb22fe977$export$2e2bcd8739ae039(props) {
    const { disableDefaultClasses: disableDefaultClasses , children: children  } = props;
    const contextValue = $acw62.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d3d8f54fb22fe977$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



const $68faa4ffc99fe1da$var$_excluded = [
    "children",
    "closeAfterTransition",
    "container",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "manager",
    "onBackdropClick",
    "onClose",
    "onKeyDown",
    "open",
    "onTransitionEnter",
    "onTransitionExited",
    "slotProps",
    "slots"
];
const $68faa4ffc99fe1da$var$useUtilityClasses = (ownerState)=>{
    const { open: open , exited: exited  } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $d3d8f54fb22fe977$export$b0f7603cd2f9ee15)((0, $c132e2fdd627b873$export$67960e22b12a638d)));
};
function $68faa4ffc99fe1da$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $68faa4ffc99fe1da$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $68faa4ffc99fe1da$var$defaultManager = new (0, $4a3a8d931ce9041d$export$2e2bcd8739ae039)();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * *   [Dialog](https://mui.com/material-ui/api/dialog/)
 * *   [Drawer](https://mui.com/material-ui/api/drawer/)
 * *   [Menu](https://mui.com/material-ui/api/menu/)
 * *   [Popover](https://mui.com/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](https://mui.com/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base/react-modal/)
 *
 * API:
 *
 * - [Modal API](https://mui.com/base/react-modal/components-api/#modal)
 */ const $68faa4ffc99fe1da$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(props, forwardedRef) {
    var _props$ariaHidden, _slots$root;
    const { children: children , closeAfterTransition: closeAfterTransition = false , container: container , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableEscapeKeyDown: disableEscapeKeyDown = false , disablePortal: disablePortal = false , disableRestoreFocus: disableRestoreFocus = false , disableScrollLock: disableScrollLock = false , hideBackdrop: hideBackdrop = false , keepMounted: keepMounted = false , // private
    manager: managerProp = $68faa4ffc99fe1da$var$defaultManager , onBackdropClick: onBackdropClick , onClose: onClose , onKeyDown: onKeyDown , open: open , onTransitionEnter: onTransitionEnter , onTransitionExited: onTransitionExited , slotProps: slotProps = {} , slots: slots = {}  } = props, other = (0, $1En50.default)(props, $68faa4ffc99fe1da$var$_excluded);
    // TODO: `modal`` must change its type in this file to match the type of methods
    // provided by `ModalManager`
    const manager = managerProp;
    const [exited, setExited] = $acw62.useState(!open);
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(modalRef, forwardedRef);
    const hasTransition = $68faa4ffc99fe1da$var$getHasTransition(children);
    const ariaHiddenProp = (_props$ariaHidden = props["aria-hidden"]) != null ? _props$ariaHidden : true;
    const getDoc = ()=>(0, $4cf4482b502c4310$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $68faa4ffc99fe1da$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $acw62.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $7132531a8fc4c99c$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node || !modalRef.current) return;
        if (open && isTopModal()) handleMounted();
        else (0, $4a3a8d931ce9041d$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        manager,
        ariaHiddenProp
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        exited: exited,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const classes = $68faa4ffc99fe1da$var$useUtilityClasses(ownerState);
    const handleEnter = ()=>{
        setExited(false);
        if (onTransitionEnter) onTransitionEnter();
    };
    const handleExited = ()=>{
        setExited(true);
        if (onTransitionExited) onTransitionExited();
        if (closeAfterTransition) handleClose();
    };
    const handleBackdropClick = (event)=>{
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $c91b8f922607ad66$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $c91b8f922607ad66$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $fce864403201fe7f$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRef,
            role: "presentation",
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: ownerState
    });
    const BackdropComponent = slots.backdrop;
    const backdropProps = (0, $fce864403201fe7f$export$2e2bcd8739ae039)({
        elementType: BackdropComponent,
        externalSlotProps: slotProps.backdrop,
        additionalProps: {
            "aria-hidden": true,
            onClick: handleBackdropClick,
            open: open
        },
        className: classes.backdrop,
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2ad7edda02764f6$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Root, (0, $8nd05.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BackdropComponent, (0, $8nd05.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9feea497446f1db4$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $68faa4ffc99fe1da$export$2e2bcd8739ae039 = $68faa4ffc99fe1da$var$Modal;







var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");







const $5e5a92158e7d9bd4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener , appear: appear = true , children: children , easing: easing , in: inProp , onEnter: onEnter , onEntered: onEntered , onEntering: onEntering , onExit: onExit , onExited: onExited , onExiting: onExiting , style: style , timeout: timeout = defaultTimeout , TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039)  } = props, other = (0, $1En50.default)(props, $5e5a92158e7d9bd4$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $5e5a92158e7d9bd4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $5e5a92158e7d9bd4$export$2e2bcd8739ae039 = $5e5a92158e7d9bd4$var$Fade;




function $5c4c540114ae85ab$export$9927a91fd93152bd(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiBackdrop", slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $5c4c540114ae85ab$export$2e2bcd8739ae039 = $5c4c540114ae85ab$var$backdropClasses;



const $4838e5a14e330013$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , invisible: invisible  } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $5c4c540114ae85ab$export$9927a91fd93152bd), classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState  })=>(0, $8nd05.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children , className: className , component: component = "div" , components: components = {} , componentsProps: componentsProps = {} , invisible: invisible = false , open: open , slotProps: slotProps = {} , slots: slots = {} , TransitionComponent: TransitionComponent = (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039) , transitionDuration: transitionDuration  } = props, other = (0, $1En50.default)(props, $4838e5a14e330013$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4838e5a14e330013$var$BackdropRoot, (0, $8nd05.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $1SA7b.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $8nd05.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $4838e5a14e330013$export$2e2bcd8739ae039 = $4838e5a14e330013$var$Backdrop;



const $0bdcbfecdf3275a2$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $0bdcbfecdf3275a2$export$eb211a494147b724 = (0, $c132e2fdd627b873$export$2e2bcd8739ae039);
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $8nd05.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $4838e5a14e330013$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop , BackdropProps: BackdropProps , classes: classes , className: className , closeAfterTransition: closeAfterTransition = false , children: children , container: container , component: component , components: components = {} , componentsProps: componentsProps = {} , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableEscapeKeyDown: disableEscapeKeyDown = false , disablePortal: disablePortal = false , disableRestoreFocus: disableRestoreFocus = false , disableScrollLock: disableScrollLock = false , hideBackdrop: hideBackdrop = false , keepMounted: keepMounted = false , onBackdropClick: onBackdropClick , onClose: onClose , open: open , slotProps: slotProps , slots: slots , theme: // eslint-disable-next-line react/prop-types
    theme  } = props, other = (0, $1En50.default)(props, $0bdcbfecdf3275a2$var$_excluded);
    const [exited, setExited] = $acw62.useState(true);
    const commonProps = {
        container: container,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted,
        onBackdropClick: onBackdropClick,
        onClose: onClose,
        open: open
    };
    const ownerState = (0, $8nd05.default)({}, props, commonProps, {
        exited: exited
    });
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $0bdcbfecdf3275a2$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68faa4ffc99fe1da$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            backdrop: BackdropSlot
        },
        slotProps: {
            root: ()=>(0, $8nd05.default)({}, (0, $3e85a6fbe0c646f1$export$2e2bcd8739ae039)(rootSlotProps, ownerState), !(0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(RootSlot) && {
                    as: component,
                    theme: theme
                }, {
                    className: (0, $1SA7b.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
                }),
            backdrop: ()=>(0, $8nd05.default)({}, BackdropProps, (0, $3e85a6fbe0c646f1$export$2e2bcd8739ae039)(backdropSlotProps, ownerState), {
                    className: (0, $1SA7b.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop)
                })
        },
        onTransitionEnter: ()=>setExited(false),
        onTransitionExited: ()=>setExited(true),
        ref: ref
    }, other, commonProps, {
        children: children
    }));
});
var $0bdcbfecdf3275a2$export$2e2bcd8739ae039 = $0bdcbfecdf3275a2$var$Modal;





function $ea2c25a800e729b1$export$88f455dd56c95edb(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiPopover", slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiPopover", [
    "root",
    "paper"
]);
var $ea2c25a800e729b1$export$2e2bcd8739ae039 = $ea2c25a800e729b1$var$popoverClasses;



const $012baef8dc9ae9d0$var$_excluded = [
    "onEntering"
], $012baef8dc9ae9d0$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
function $012baef8dc9ae9d0$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $ea2c25a800e729b1$export$88f455dd56c95edb), classes);
};
const $012baef8dc9ae9d0$var$PopoverRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $012baef8dc9ae9d0$var$PopoverPaper = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action , anchorEl: anchorEl , anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    } , anchorPosition: anchorPosition , anchorReference: anchorReference = "anchorEl" , children: children , className: className , container: containerProp , elevation: elevation = 8 , marginThreshold: marginThreshold = 16 , open: open , PaperProps: PaperProps = {} , transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    } , TransitionComponent: TransitionComponent = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039) , transitionDuration: transitionDurationProp = "auto" , TransitionProps: { onEntering: onEntering  } = {}  } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $012baef8dc9ae9d0$var$_excluded), other = (0, $1En50.default)(props, $012baef8dc9ae9d0$var$_excluded2);
    const paperRef = $acw62.useRef();
    const handlePaperRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(paperRef, PaperProps.ref);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        PaperProps: PaperProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $c10afe25107351d9$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $c10afe25107351d9$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($012baef8dc9ae9d0$var$PopoverRoot, (0, $8nd05.default)({
        BackdropProps: {
            invisible: true
        },
        className: (0, $1SA7b.default)(classes.root, className),
        container: container,
        open: open,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($012baef8dc9ae9d0$var$PopoverPaper, (0, $8nd05.default)({
                elevation: elevation
            }, PaperProps, {
                ref: handlePaperRef,
                className: (0, $1SA7b.default)(classes.paper, PaperProps.className)
            }, isPositioned ? undefined : {
                style: (0, $8nd05.default)({}, PaperProps.style, {
                    opacity: 0
                })
            }, {
                ownerState: ownerState,
                children: children
            }))
        }))
    }));
});
var $012baef8dc9ae9d0$export$2e2bcd8739ae039 = $012baef8dc9ae9d0$var$Popover;







function $fb1e7d0ac8fac824$export$2cf86a63a84fe23d(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiMenu", slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $fb1e7d0ac8fac824$export$2e2bcd8739ae039 = $fb1e7d0ac8fac824$var$menuClasses;



const $364f3db28d8d2e79$var$_excluded = [
    "onEntering"
], $364f3db28d8d2e79$var$_excluded2 = [
    "autoFocus",
    "children",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant"
];
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $fb1e7d0ac8fac824$export$2cf86a63a84fe23d), classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $012baef8dc9ae9d0$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0277c5e26ff0d56c$export$effb20ecdbf4d6aa)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $364f3db28d8d2e79$var$MenuPaper = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $fbb3fa0cdc277971$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true , children: children , disableAutoFocusItem: disableAutoFocusItem = false , MenuListProps: MenuListProps = {} , onClose: onClose , open: open , PaperProps: PaperProps = {} , PopoverClasses: PopoverClasses , transitionDuration: transitionDuration = "auto" , TransitionProps: { onEntering: onEntering  } = {} , variant: variant = "selectedMenu"  } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $364f3db28d8d2e79$var$_excluded), other = (0, $1En50.default)(props, $364f3db28d8d2e79$var$_excluded2);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($364f3db28d8d2e79$var$MenuRoot, (0, $8nd05.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        PaperProps: (0, $8nd05.default)({
            as: $364f3db28d8d2e79$var$MenuPaper
        }, PaperProps, {
            classes: (0, $8nd05.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        className: classes.root,
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $8nd05.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($364f3db28d8d2e79$var$MenuMenuList, (0, $8nd05.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $1SA7b.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $364f3db28d8d2e79$export$2e2bcd8739ae039 = $364f3db28d8d2e79$var$Menu;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");





function $49a1663d7631a8fa$export$1ee13051fd9e2ab5(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiNativeSelect", slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $49a1663d7631a8fa$export$2e2bcd8739ae039 = $49a1663d7631a8fa$var$nativeSelectClasses;




const $db2c454fb2e8bc3c$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , disabled: disabled , multiple: multiple , open: open , error: error  } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $e7b578196486f177$export$2e2bcd8739ae039)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $49a1663d7631a8fa$export$1ee13051fd9e2ab5), classes);
};
const $db2c454fb2e8bc3c$export$c1eccd1617458c87 = ({ ownerState: ownerState , theme: theme  })=>(0, $8nd05.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $8nd05.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $0277c5e26ff0d56c$export$effb20ecdbf4d6aa),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($db2c454fb2e8bc3c$export$c1eccd1617458c87);
const $db2c454fb2e8bc3c$export$e7a817afd12a40d0 = ({ ownerState: ownerState , theme: theme  })=>(0, $8nd05.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $e7b578196486f177$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($db2c454fb2e8bc3c$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className , disabled: disabled , error: error , IconComponent: IconComponent , inputRef: inputRef , variant: variant = "standard"  } = props, other = (0, $1En50.default)(props, $db2c454fb2e8bc3c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, (0, $8nd05.default)({
                ownerState: ownerState,
                className: (0, $1SA7b.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $db2c454fb2e8bc3c$export$2e2bcd8739ae039 = $db2c454fb2e8bc3c$var$NativeSelectInput;





/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $acw62 = parcelRequire("acw62");
function $3b481a8630784b69$export$2e2bcd8739ae039({ controlled: controlled , default: defaultProp , name: name , state: state = "value"  }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled  } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


var $295ecbe78b5bad73$export$2e2bcd8739ae039 = (0, $3b481a8630784b69$export$2e2bcd8739ae039);




function $844e08aea9053c4b$export$2c0c1ee5a3392e(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiSelect", slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiSelect", [
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $844e08aea9053c4b$export$2e2bcd8739ae039 = $844e08aea9053c4b$var$selectClasses;



var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $8bd650259be885cb$var$SelectSelect = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $db2c454fb2e8bc3c$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $e7b578196486f177$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $db2c454fb2e8bc3c$export$e7a817afd12a40d0));
const $8bd650259be885cb$var$SelectNativeInput = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("input", {
    shouldForwardProp: (prop)=>(0, $0277c5e26ff0d56c$export$f10c5a10d27438e5)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $8bd650259be885cb$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8bd650259be885cb$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , disabled: disabled , multiple: multiple , open: open , error: error  } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $e7b578196486f177$export$2e2bcd8739ae039)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $844e08aea9053c4b$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    const { "aria-describedby": ariaDescribedby , "aria-label": ariaLabel , autoFocus: autoFocus , autoWidth: autoWidth , children: children , className: className , defaultOpen: defaultOpen , defaultValue: defaultValue , disabled: disabled , displayEmpty: displayEmpty , error: error = false , IconComponent: IconComponent , inputRef: inputRefProp , labelId: labelId , MenuProps: MenuProps = {} , multiple: multiple , name: name , onBlur: onBlur , onChange: onChange , onClose: onClose , onFocus: onFocus , onOpen: onOpen , open: openProp , readOnly: readOnly , renderValue: renderValue , SelectDisplayProps: SelectDisplayProps = {} , tabIndex: tabIndexProp , value: valueProp , variant: variant = "standard"  } = props, other = (0, $1En50.default)(props, $8bd650259be885cb$var$_excluded);
    const [value, setValueState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled  } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $8accd9aba21f8e48$export$2e2bcd8739ae039)(2));
            selected = value.some((v)=>$8bd650259be885cb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8bd650259be885cb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8bd650259be885cb$var$SelectSelect, (0, $8nd05.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $1SA7b.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8bd650259be885cb$var$isEmpty(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "notranslate",
                    children: "​"
                })) : display
            })),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8bd650259be885cb$var$SelectNativeInput, (0, $8nd05.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $8nd05.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                PaperProps: (0, $8nd05.default)({}, MenuProps.PaperProps, {
                    style: (0, $8nd05.default)({
                        minWidth: menuMinWidth
                    }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
                }),
                children: items
            }))
        ]
    });
});
var $8bd650259be885cb$export$2e2bcd8739ae039 = $8bd650259be885cb$var$SelectInput;




parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");






function $77fe5ab326d42cdb$export$c7c50641356bdfa5(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiSvgIcon", slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $77fe5ab326d42cdb$export$2e2bcd8739ae039 = $77fe5ab326d42cdb$var$svgIconClasses;



const $2a8a963e5702921b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color , fontSize: fontSize , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $e7b578196486f177$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $e7b578196486f177$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $77fe5ab326d42cdb$export$c7c50641356bdfa5), classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $e7b578196486f177$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $e7b578196486f177$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fill: "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children , className: className , color: color = "inherit" , component: component = "svg" , fontSize: fontSize = "medium" , htmlColor: htmlColor , inheritViewBox: inheritViewBox = false , titleAccess: titleAccess , viewBox: viewBox = "0 0 24 24"  } = props, other = (0, $1En50.default)(props, $2a8a963e5702921b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($2a8a963e5702921b$var$SvgIconRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $1SA7b.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, {
        ownerState: ownerState,
        children: [
            children,
            titleAccess ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$2a8a963e5702921b$var$SvgIcon.muiName = "SvgIcon";
var $2a8a963e5702921b$export$2e2bcd8739ae039 = $2a8a963e5702921b$var$SvgIcon;



function $825b752ac2a74c27$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a8a963e5702921b$export$2e2bcd8739ae039), (0, $8nd05.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $2a8a963e5702921b$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}



var $5a863bd9b12ca76b$export$2e2bcd8739ae039 = (0, $825b752ac2a74c27$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");


var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");




const $0311c85f7d96727c$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $0311c85f7d96727c$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $0311c85f7d96727c$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $0311c85f7d96727c$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $0311c85f7d96727c$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange , maxRows: maxRows , minRows: minRows = 1 , style: style , value: value  } = props, other = (0, $1En50.default)(props, $0311c85f7d96727c$var$_excluded);
    const { current: isControlled  } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef(null);
    const handleRef = (0, $6fd6e1f605afb988$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $acw62.useRef(null);
    const renders = $acw62.useRef(0);
    const [state, setState] = $acw62.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $acw62.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $230cae465a5568fd$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $0311c85f7d96727c$var$getStyleValue(computedStyle.paddingBottom) + $0311c85f7d96727c$var$getStyleValue(computedStyle.paddingTop);
        const border = $0311c85f7d96727c$var$getStyleValue(computedStyle.borderBottomWidth) + $0311c85f7d96727c$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle , overflow: overflow  } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $acw62.useCallback(()=>{
        const newState = getUpdatedState();
        if ($0311c85f7d96727c$var$isEmpty(newState)) return;
        setState((prevState)=>{
            return updateState(prevState, newState);
        });
    }, [
        getUpdatedState
    ]);
    const syncHeightWithFlushSync = ()=>{
        const newState = getUpdatedState();
        if ($0311c85f7d96727c$var$isEmpty(newState)) return;
        // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        $11492dca620dcaa5$exports.flushSync(()=>{
            setState((prevState)=>{
                return updateState(prevState, newState);
            });
        });
    };
    $acw62.useEffect(()=>{
        const handleResize = (0, $41c4238d7b0ec499$export$2e2bcd8739ae039)(()=>{
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        });
        let resizeObserver;
        const input = inputRef.current;
        const containerWindow = (0, $230cae465a5568fd$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", handleResize);
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    });
    (0, $f8b7b39c1ae7354b$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $acw62.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", (0, $8nd05.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $8nd05.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $8nd05.default)({}, $0311c85f7d96727c$var$styles.shadow, style, {
                    padding: 0
                })
            })
        ]
    });
});
var $0311c85f7d96727c$export$2e2bcd8739ae039 = $0311c85f7d96727c$var$TextareaAutosize;











var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

parcelRequire("acw62");




function $6942d6ec85232a9d$var$GlobalStyles({ styles: styles , themeId: themeId , defaultTheme: defaultTheme = {}  }) {
    const upperTheme = (0, $59c0686cf27fa016$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $871beca1e2477cf0$export$2e2bcd8739ae039), {
        styles: globalStyles
    });
}
var $6942d6ec85232a9d$export$2e2bcd8739ae039 = $6942d6ec85232a9d$var$GlobalStyles;





function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6942d6ec85232a9d$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        defaultTheme: (0, $e74a75f0176cf8e3$export$2e2bcd8739ae039),
        themeId: (0, $3250d9bb994a2d02$export$2e2bcd8739ae039)
    }));
}
var $03fc756f7adfd498$export$2e2bcd8739ae039 = $03fc756f7adfd498$var$GlobalStyles;





function $9b9dde6aa920e08c$export$ef57d5c8ca2278f6(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiInputBase", slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $9b9dde6aa920e08c$export$2e2bcd8739ae039 = $9b9dde6aa920e08c$var$inputBaseClasses;



const $69d1b2c99a8dc649$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $69d1b2c99a8dc649$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $e7b578196486f177$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $69d1b2c99a8dc649$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , color: color , disabled: disabled , error: error , endAdornment: endAdornment , focused: focused , formControl: formControl , fullWidth: fullWidth , hiddenLabel: hiddenLabel , multiline: multiline , readOnly: readOnly , size: size , startAdornment: startAdornment , type: type  } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $e7b578196486f177$export$2e2bcd8739ae039)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size === "small" && "sizeSmall",
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $9b9dde6aa920e08c$export$ef57d5c8ca2278f6), classes);
};
const $69d1b2c99a8dc649$export$298a043133d72a38 = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $69d1b2c99a8dc649$export$965edad20a84fa75
})(({ theme: theme , ownerState: ownerState  })=>(0, $8nd05.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $69d1b2c99a8dc649$export$a1ad29c901026019 = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $69d1b2c99a8dc649$export$cf507b112810e72d
})(({ theme: theme , ownerState: ownerState  })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $8nd05.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $8nd05.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $69d1b2c99a8dc649$var$inputGlobalStyles = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03fc756f7adfd498$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby , autoComplete: autoComplete , autoFocus: autoFocus , className: className , components: components = {} , componentsProps: componentsProps = {} , defaultValue: defaultValue , disabled: disabled , disableInjectingGlobalStyles: disableInjectingGlobalStyles , endAdornment: endAdornment , fullWidth: fullWidth = false , id: id , inputComponent: inputComponent = "input" , inputProps: inputPropsProp = {} , inputRef: inputRefProp , maxRows: maxRows , minRows: minRows , multiline: multiline = false , name: name , onBlur: onBlur , onChange: onChange , onClick: onClick , onFocus: onFocus , onKeyDown: onKeyDown , onKeyUp: onKeyUp , placeholder: placeholder , readOnly: readOnly , renderSuffix: renderSuffix , rows: rows , slotProps: slotProps = {} , slots: slots = {} , startAdornment: startAdornment , type: type = "text" , value: valueProp  } = props, other = (0, $1En50.default)(props, $69d1b2c99a8dc649$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled  } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $8accd9aba21f8e48$export$2e2bcd8739ae039)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick && !fcs.disabled) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $8nd05.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $8nd05.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $0311c85f7d96727c$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $69d1b2c99a8dc649$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $69d1b2c99a8dc649$export$a1ad29c901026019;
    inputProps = (0, $8nd05.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $69d1b2c99a8dc649$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Root, (0, $8nd05.default)({}, rootProps, !(0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $1SA7b.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Input, (0, $8nd05.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $93dbc7362e67d1d8$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $8nd05.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $1SA7b.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $8nd05.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $69d1b2c99a8dc649$export$2e2bcd8739ae039 = $69d1b2c99a8dc649$var$InputBase;





var $8nd05 = parcelRequire("8nd05");



function $80c774dd7f29b734$export$cdb270390122322b(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiInput", slot);
}
const $80c774dd7f29b734$var$inputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $80c774dd7f29b734$export$2e2bcd8739ae039 = $80c774dd7f29b734$var$inputClasses;




const $76910a07fd4ac4fe$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableUnderline: disableUnderline  } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $80c774dd7f29b734$export$cdb270390122322b), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $0277c5e26ff0d56c$export$effb20ecdbf4d6aa)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $8nd05.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}, .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $76910a07fd4ac4fe$var$InputInput = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline , components: components = {} , componentsProps: componentsPropsProp , fullWidth: fullWidth = false , inputComponent: inputComponent = "input" , multiline: multiline = false , slotProps: slotProps , slots: slots = {} , type: type = "text"  } = props, other = (0, $1En50.default)(props, $76910a07fd4ac4fe$var$_excluded);
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $0d0b82dec42cae84$export$2e2bcd8739ae039)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $76910a07fd4ac4fe$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $76910a07fd4ac4fe$var$InputInput;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$76910a07fd4ac4fe$var$Input.muiName = "Input";
var $76910a07fd4ac4fe$export$2e2bcd8739ae039 = $76910a07fd4ac4fe$var$Input;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");







var $8nd05 = parcelRequire("8nd05");



function $b0b42157daacd8b1$export$3331e419f1a48437(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiFilledInput", slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $b0b42157daacd8b1$export$2e2bcd8739ae039 = $b0b42157daacd8b1$var$filledInputClasses;




const $bb335d5457c07f5b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableUnderline: disableUnderline  } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $b0b42157daacd8b1$export$3331e419f1a48437), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $0277c5e26ff0d56c$export$effb20ecdbf4d6aa)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $8nd05.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}, .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $bb335d5457c07f5b$var$FilledInputInput = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme , ownerState: ownerState  })=>(0, $8nd05.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {} , componentsProps: componentsPropsProp , fullWidth: fullWidth = false , inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input" , multiline: multiline = false , slotProps: slotProps , slots: slots = {} , type: type = "text"  } = props, other = (0, $1En50.default)(props, $bb335d5457c07f5b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $0d0b82dec42cae84$export$2e2bcd8739ae039)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $bb335d5457c07f5b$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $bb335d5457c07f5b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$bb335d5457c07f5b$var$FilledInput.muiName = "Input";
var $bb335d5457c07f5b$export$2e2bcd8739ae039 = $bb335d5457c07f5b$var$FilledInput;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");



var $746323a953600e78$var$_span;
const $746323a953600e78$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $746323a953600e78$var$NotchedOutlineRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("legend")(({ ownerState: ownerState , theme: theme  })=>(0, $8nd05.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $8nd05.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $746323a953600e78$export$2e2bcd8739ae039(props) {
    const { className: className , label: label , notched: notched  } = props, other = (0, $1En50.default)(props, $746323a953600e78$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $8nd05.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($746323a953600e78$var$NotchedOutlineRoot, (0, $8nd05.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "notranslate",
                children: "​"
            }))
        })
    }));
}






var $8nd05 = parcelRequire("8nd05");



function $6a1dc6d1d7e1816a$export$89922944c7227687(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiOutlinedInput", slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $6a1dc6d1d7e1816a$export$2e2bcd8739ae039 = $6a1dc6d1d7e1816a$var$outlinedInputClasses;





const $d5d55d2dd82639e9$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $6a1dc6d1d7e1816a$export$89922944c7227687), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $0277c5e26ff0d56c$export$effb20ecdbf4d6aa)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $69d1b2c99a8dc649$export$965edad20a84fa75)
})(({ theme: theme , ownerState: ownerState  })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $8nd05.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).focused} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).error} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).disabled} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $746323a953600e78$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme  })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme , ownerState: ownerState  })=>(0, $8nd05.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {} , fullWidth: fullWidth = false , inputComponent: inputComponent = "input" , label: label , multiline: multiline = false , notched: notched , slots: slots = {} , type: type = "text"  } = props, other = (0, $1En50.default)(props, $d5d55d2dd82639e9$var$_excluded);
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "required"
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $d5d55d2dd82639e9$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $d5d55d2dd82639e9$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d5d55d2dd82639e9$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        " ",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $8nd05.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$d5d55d2dd82639e9$var$OutlinedInput.muiName = "Input";
var $d5d55d2dd82639e9$export$2e2bcd8739ae039 = $d5d55d2dd82639e9$var$OutlinedInput;






const $96e1233e8d06bb2d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
];
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    return classes;
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $0277c5e26ff0d56c$export$effb20ecdbf4d6aa)(prop) && prop !== "variant",
    slot: "Root"
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $76910a07fd4ac4fe$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)("");
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $d5d55d2dd82639e9$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)("");
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)((0, $bb335d5457c07f5b$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)("");
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false , children: children , classes: classesProp = {} , className: className , defaultOpen: defaultOpen = false , displayEmpty: displayEmpty = false , IconComponent: IconComponent = (0, $5a863bd9b12ca76b$export$2e2bcd8739ae039) , id: id , input: input , inputProps: inputProps , label: label , labelId: labelId , MenuProps: MenuProps , multiple: multiple = false , native: native = false , onClose: onClose , onOpen: onOpen , open: open , renderValue: renderValue , SelectDisplayProps: SelectDisplayProps , variant: variantProp = "outlined"  } = props, other = (0, $1En50.default)(props, $96e1233e8d06bb2d$var$_excluded);
    const inputComponent = native ? (0, $db2c454fb2e8bc3c$export$2e2bcd8739ae039) : (0, $8bd650259be885cb$export$2e2bcd8739ae039);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($96e1233e8d06bb2d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, (0, $8nd05.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $8nd05.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $8nd05.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $0d0b82dec42cae84$export$2e2bcd8739ae039)(classes, inputProps.classes) : classes
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $1SA7b.default)(InputComponent.props.className, className)
        }, !input && {
            variant: variant
        }, other))
    });
});
$96e1233e8d06bb2d$var$Select.muiName = "Select";
var $96e1233e8d06bb2d$export$2e2bcd8739ae039 = $96e1233e8d06bb2d$var$Select;



const $faece5106a10733c$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            width: "100%",
            marginRight: "0em",
            "& option": {
                color: "#000"
            },
            "& select": {
                color: "#fff"
            },
            "& label": {
                color: "#fff"
            }
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            width: "100%"
        },
        selectEmpty: {
            marginTop: "auto"
        }
    }));
const $faece5106a10733c$var$LanguageSelector = ()=>{
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $faece5106a10733c$var$useStyles();
    const changeLanguage = (event)=>{
        i18n.changeLanguage(event.target.value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
            variant: "filled",
            className: classes.formControl,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                    htmlFor: "filled-age-native-simple",
                    children: "Language"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                    native: true,
                    value: i18n.language,
                    onChange: changeLanguage,
                    inputProps: {
                        name: "language",
                        id: "language"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: "en",
                            children: "English"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: "ru",
                            children: "Russian"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: "de",
                            children: "German"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: "es",
                            children: "Spanish"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: "fr",
                            children: "French"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: "hi",
                            children: "Hindi"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                            value: "it",
                            children: "Italian"
                        })
                    ]
                })
            ]
        })
    });
};
var $faece5106a10733c$export$2e2bcd8739ae039 = $faece5106a10733c$var$LanguageSelector;






const $9ea341b30b1c53fb$var$AMAX_API_URL = "https://amax-emu.com/api";
const $9ea341b30b1c53fb$var$drawerWidth = 240;
const $9ea341b30b1c53fb$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>({
        root: {
            display: "flex"
        },
        logo: {
            display: "flex",
            justifyItems: "center",
            allignItems: "center",
            marginTop: 5,
            marginLeft: 6,
            marginRight: 6,
            width: `calc(${$9ea341b30b1c53fb$var$drawerWidth}px - 20px)`
        },
        logoImage: {
            justifySelf: "center",
            alignItems: "center",
            alignSelf: "center"
        },
        logoImageMobile: {
            justifySelf: "center",
            alignItems: "center",
            alignSelf: "center",
            height: "2.7em"
        },
        drawer: {
            [theme.breakpoints.up("sm")]: {
                width: $9ea341b30b1c53fb$var$drawerWidth,
                flexShrink: 0
            }
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1
        },
        menuButton: {
            marginRight: theme.spacing(2),
            [theme.breakpoints.up("sm")]: {
                display: "none"
            }
        },
        toolbar: theme.mixins.toolbar,
        drawerPaper: {
            width: $9ea341b30b1c53fb$var$drawerWidth
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3)
        },
        closeMenuButton: {
            marginRight: "auto",
            marginLeft: 0
        },
        selected: {
            backgroundColor: "#3E5270",
            borderRadius: 4
        },
        menuitem: {
            borderRadius: 4,
            marginTop: "0.5em",
            marginBottom: "0.5em",
            "&$selected": {
                backgroundColor: "#3E5270"
            }
        },
        menulist: {
            padding: 24
        }
    }));
function $9ea341b30b1c53fb$export$2e2bcd8739ae039() {
    const [isDesktop, setDesktop] = $acw62.useState(window.innerWidth < 600);
    const [open, setOpen] = $acw62.useState(true);
    const handleClick = ()=>{
        setOpen(!open);
    };
    const updateMedia = ()=>{
        setDesktop(window.innerWidth < 600);
    };
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("resize", updateMedia);
        return ()=>window.removeEventListener("resize", updateMedia);
    });
    const [mobileOpen, setMobileOpen] = $acw62.useState(false);
    const classes = $9ea341b30b1c53fb$var$useStyles();
    const theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    const isMobile = window.screen.width < 600;
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [path, setPath] = $acw62.useState("");
    let location = (0, $ebf4c3fe5600f7ed$export$45d76561a5302f2b)();
    (0, $acw62.useEffect)(()=>{
        setPath(location.pathname);
    }, [
        location,
        setPath
    ]);
    const activeRoute = (route)=>{
        //return route === path;
        if (route != "/") return path.includes(route);
        else return route === path;
    };
    function handleDrawerToggle() {
        setMobileOpen(!mobileOpen);
    }
    const auth = (0, $fa8bb1513e386061$export$650ce9f0b4df82fd)();
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    const drawer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            "height": "100%"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4ac22d2e9f100406$export$2e2bcd8739ae039), {
                className: classes.menulist,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                        to: "/Dashboard",
                        style: {
                            color: "#92929F",
                            textDecoration: "none"
                        },
                        activeStyle: {
                            color: "#E5E5E5",
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c1d5fff205df0ecf$export$2e2bcd8739ae039), {
                            button: true,
                            selected: activeRoute("/Dashboard") || activeRoute("/"),
                            classes: {
                                root: classes.menuitem,
                                selected: classes.selected
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbb0437a81b1cf36$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85ce8be979e9ca01$exports))), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79c3e69139ae2ded$export$2e2bcd8739ae039), {
                                    primary: "Dashboard"
                                })
                            ]
                        }, "Dashboard")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                        to: "/past_races/1",
                        style: {
                            color: "#92929F",
                            textDecoration: "none"
                        },
                        activeStyle: {
                            color: "#E5E5E5",
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c1d5fff205df0ecf$export$2e2bcd8739ae039), {
                            button: true,
                            selected: activeRoute("/past_races"),
                            classes: {
                                root: classes.menuitem,
                                selected: classes.selected
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbb0437a81b1cf36$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b6be5b039ddc691$exports))), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79c3e69139ae2ded$export$2e2bcd8739ae039), {
                                    primary: "Games feed"
                                })
                            ]
                        }, "Games feed")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                        to: "/leaderboards",
                        style: {
                            color: "#92929F",
                            textDecoration: "none"
                        },
                        activeStyle: {
                            color: "#E5E5E5",
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c1d5fff205df0ecf$export$2e2bcd8739ae039), {
                            button: true,
                            selected: activeRoute("/leaderboards"),
                            classes: {
                                root: classes.menuitem,
                                selected: classes.selected
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbb0437a81b1cf36$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4e2ef09b80570ea4$exports))), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79c3e69139ae2ded$export$2e2bcd8739ae039), {
                                    primary: "Leaderboards"
                                })
                            ]
                        }, "Leaderboards")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ff509fc6b8312a4$export$2e2bcd8739ae039), {
                variant: "middle"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4ac22d2e9f100406$export$2e2bcd8739ae039), {
                className: classes.menulist,
                children: [
                    user.userData?.amax_account ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                        to: "/how_to_play",
                        style: {
                            color: "#92929F",
                            textDecoration: "none"
                        },
                        activeStyle: {
                            color: "#E5E5E5",
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c1d5fff205df0ecf$export$2e2bcd8739ae039), {
                            button: true,
                            selected: activeRoute("/how_to_play"),
                            classes: {
                                root: classes.menuitem,
                                selected: classes.selected
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbb0437a81b1cf36$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8bb90ec0b9262cf8$exports))), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79c3e69139ae2ded$export$2e2bcd8739ae039), {
                                    primary: "How to play"
                                })
                            ]
                        }, "howtoplay")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                        to: "/news",
                        style: {
                            color: "#92929F",
                            textDecoration: "none"
                        },
                        activeStyle: {
                            color: "#E5E5E5",
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c1d5fff205df0ecf$export$2e2bcd8739ae039), {
                            button: true,
                            selected: activeRoute("/news"),
                            classes: {
                                root: classes.menuitem,
                                selected: classes.selected
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbb0437a81b1cf36$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3c91c779725be378$exports))), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79c3e69139ae2ded$export$2e2bcd8739ae039), {
                                    primary: "News"
                                })
                            ]
                        }, "news")
                    }),
                    user.userData?.amax_account ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                        to: "/profile/" + user.userData?.amax_player_data.stats.playerName,
                        style: {
                            color: "#92929F",
                            textDecoration: "none"
                        },
                        activeStyle: {
                            color: "#E5E5E5",
                            textDecoration: "none"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c1d5fff205df0ecf$export$2e2bcd8739ae039), {
                            button: true,
                            selected: activeRoute("/profile/" + user.userData?.amax_player_data.stats.playerName),
                            classes: {
                                root: classes.menuitem,
                                selected: classes.selected
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbb0437a81b1cf36$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adeefef78011838f$exports))), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79c3e69139ae2ded$export$2e2bcd8739ae039), {
                                    primary: "Profile"
                                })
                            ]
                        }, "profile")
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ff509fc6b8312a4$export$2e2bcd8739ae039), {
                variant: "middle"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4ac22d2e9f100406$export$2e2bcd8739ae039), {
                className: classes.menulist,
                style: {
                    "display": "grid",
                    "flexDirection": "column",
                    "height": "calc(100vh - 29rem)",
                    "justifyItems": "center"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        style: {
                            textDecoration: "none",
                            color: "inherit"
                        },
                        href: "https://discord.gg/pbt6DzQPGY",
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c1d5fff205df0ecf$export$2e2bcd8739ae039), {
                            button: true,
                            style: {
                                "backgroundColor": "#7289DA",
                                "borderRadius": "4px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbb0437a81b1cf36$export$2e2bcd8739ae039), {
                                    style: {
                                        "minWidth": "0",
                                        "marginRight": "15px"
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da84ea47bfe68d62$export$de73dc4d201c5f29), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79c3e69139ae2ded$export$2e2bcd8739ae039), {
                                    primary: "Discord server"
                                })
                            ]
                        }, "discord")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1d5fff205df0ecf$export$2e2bcd8739ae039), {
                        style: {
                            "alignSelf": "flex-end"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $faece5106a10733c$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
    const PlayerStatsWidget = ()=>{
        if (user.userData?.amax_account !== undefined) {
            if (user.userData?.amax_account === true) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e9a4321ef8b6908$export$2e2bcd8739ae039), {
                user_level: user.userData.amax_player_data.leveling.level + 1,
                user_legend: user.userData.amax_player_data.leveling.legend,
                user_exp: user.userData.amax_player_data.leveling.fans,
                user_exp_percent: user.userData.amax_player_data.leveling.fans_levelup_percent,
                user_name: user.userData.amax_player_data.stats.playerName
            });
            else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
        } else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb625d82dd03aa71$export$2e2bcd8739ae039), {}),
            isDesktop ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968e2cc4493acf64$export$2e2bcd8739ae039), {
                position: "fixed",
                className: classes.appBar,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0f40b360697eae63$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50480f2bcbf21ff1$export$2e2bcd8739ae039), {
                            color: "inherit",
                            "aria-label": "Open drawer",
                            edge: "start",
                            onClick: handleDrawerToggle,
                            className: classes.menuButton,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6401342929e4b3e7$exports))), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            className: classes.logoImageMobile,
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($d5416ad5d5dbe012$exports)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a7ccac4c2d57ea1$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c62f6909a663b6c0$export$2e2bcd8739ae039), {})
                    ]
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da84ea47bfe68d62$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                className: classes.drawer,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68c66e314f33238c$export$2e2bcd8739ae039), {
                        smUp: true,
                        implementation: "css",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b609827a6d58632$export$2e2bcd8739ae039), {
                            variant: "temporary",
                            anchor: theme.direction === "rtl" ? "right" : "left",
                            open: mobileOpen,
                            onClose: handleDrawerToggle,
                            classes: {
                                paper: classes.drawerPaper
                            },
                            ModalProps: {
                                keepMounted: true
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50480f2bcbf21ff1$export$2e2bcd8739ae039), {
                                    onClick: handleDrawerToggle,
                                    className: classes.closeMenuButton,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d132c99d3d4b75f3$exports))), {})
                                }),
                                drawer
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68c66e314f33238c$export$2e2bcd8739ae039), {
                        xsDown: true,
                        implementation: "css",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b609827a6d58632$export$2e2bcd8739ae039), {
                            className: classes.drawer,
                            variant: "permanent",
                            classes: {
                                paper: classes.drawerPaper
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: classes.toolbar,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: classes.logo,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                                            to: "/",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                className: classes.logo,
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d5416ad5d5dbe012$exports)))
                                            })
                                        })
                                    })
                                }),
                                drawer
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: classes.content,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: classes.toolbar
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





const $1826d868b59c435c$var$AMAX_API_URL = "https://amax-emu.com/api";
const $1826d868b59c435c$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            flexGrow: 1,
            alignItems: "flex-end",
            // minWidth: 400,
            width: "100%"
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "50%",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        }
    }));
function $1826d868b59c435c$export$2e2bcd8739ae039() {
    const classes = $1826d868b59c435c$var$useStyles();
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    let [session_data, setData] = $acw62.useState(undefined);
    let [dataRequested, setRequestStatus] = $acw62.useState(false);
    const RenderSessions = ()=>{
        if (dataRequested) return session_data.data.map((session_data)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e01dc1b8dd3a027a$export$2e2bcd8739ae039), {
                data: session_data
            }, session_data.sessionId));
        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: classes.spinner,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a36c7122d0aec5cd$export$2e2bcd8739ae039), {})
        });
    };
    // Lucas:
    // Functions passed to useEffect cannot be async.
    $acw62.useEffect(()=>{
        async function getSessionsData() {
            const resp = await fetch($1826d868b59c435c$var$AMAX_API_URL + "/sessions", {
                method: "GET",
                headers: {
                    "content-type": "application/json;charset=UTF-8"
                }
            });
            setData(await resp.json());
            setRequestStatus(true);
        }
        getSessionsData().catch(()=>{});
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: "session_item_name",
                    children: t("sessions_widget_header")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: classes.root,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RenderSessions, {})
                })
            ]
        })
    });
}



parcelRequire("acw62");


var $cb86c601af6e089e$exports = {};
var $f0bde60858cc80ba$exports = {};

$f0bde60858cc80ba$exports = new URL((parcelRequire("27Lyk")).resolve("eMmWy"), import.meta.url).toString();


var $c476d0d7c7475cd3$exports = {};

$c476d0d7c7475cd3$exports = new URL((parcelRequire("27Lyk")).resolve("7rMJA"), import.meta.url).toString();


var $2c1faf3482cafcff$exports = {};

$2c1faf3482cafcff$exports = new URL((parcelRequire("27Lyk")).resolve("kWdeZ"), import.meta.url).toString();


var $a99bead6146b0b0f$exports = {};

$a99bead6146b0b0f$exports = new URL((parcelRequire("27Lyk")).resolve("ap0kK"), import.meta.url).toString();


$cb86c601af6e089e$exports = {
    "amax_client_files": $f0bde60858cc80ba$exports,
    "amax_emu_files": $c476d0d7c7475cd3$exports,
    "blur_update_files": $2c1faf3482cafcff$exports,
    "files_guide2": $a99bead6146b0b0f$exports
};



parcelRequire("acw62");


const $ef211fdc43fcfcba$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)({
    root: {
        flexGrow: 1,
        maxWidth: "25em",
        width: "100%",
        height: "auto",
        border: "4px dashed #3E5270",
        boxSizing: "border-box",
        borderRadius: "8px",
        margin: "1em"
    },
    label: {
        fontFamily: "Ubuntu",
        fontStyle: "italic",
        fontWeight: "normal",
        fontSize: "24px",
        lineHeight: "155%",
        color: "#92929F"
    },
    label_size: {
        fontFamily: "Ubuntu",
        fontStyle: "italic",
        fontWeight: "normal",
        marginLeft: "1em",
        fontSize: "15px",
        lineHeight: "155%",
        color: "#92929F"
    }
});
function $ef211fdc43fcfcba$export$2e2bcd8739ae039({ filename: filename , size: size , link: link  }) {
    const classes = $ef211fdc43fcfcba$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                margin: "1em"
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ecaaa74876358dcf$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                className: classes.label,
                                children: filename
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                className: classes.label_size,
                                children: size
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        variant: "contained",
                        color: "primary",
                        href: link,
                        target: "_blank",
                        children: "Download file"
                    })
                ]
            })
        })
    });
}




const $c2d6b39f66b06862$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            padding: "1em"
        },
        DiscordButton: {
            backgroundColor: "#7289DA"
        },
        DiscordIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 12 12"
        },
        stepHeader: {
            marginBottom: "0.1em"
        },
        listItem: {
            marginBottom: "4em"
        },
        list_container: {
            paddingLeft: "0",
            marginLeft: "15px",
            marginRight: "15px",
            listStylePosition: "outside",
            listStyleType: "decimal"
        },
        imgdiv: {
            maxWidth: "400px",
            height: "auto",
            position: "relative"
        },
        image_wrapper: {
            maxWidth: "100%",
            maxHeight: "100%"
        }
    }));
function $c2d6b39f66b06862$export$2e2bcd8739ae039() {
    const classes = $c2d6b39f66b06862$var$useStyles();
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64d9a99297a346fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca4ada9c808bb355$export$2e2bcd8739ae039), {
            className: classes.root,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        children: [
                            t("how_to_play.header"),
                            " | Final steps"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                        className: classes.list_container,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: classes.stepHeader,
                                        children: t("how_to_play.blur_download_step_header")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        children: t("how_to_play.blur_download_step_text")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: classes.stepHeader,
                                        children: t("how_to_play.patch_step_header")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        children: [
                                            t("how_to_play.patch_step_text1"),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: t("how_to_play.patch_step_text2")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef211fdc43fcfcba$export$2e2bcd8739ae039), {
                                            filename: "Blur_12.zip",
                                            size: "26M",
                                            link: "https://cs.amax-emu.com/blur_12.zip"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        children: t("how_to_play.patch_step_text3")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: classes.imgdiv,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                className: classes.image_wrapper,
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cb86c601af6e089e$exports)))["blur_update_files"],
                                                alt: "blur_update_files"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: classes.stepHeader,
                                        children: t("how_to_play.amax_emu_step_header")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        children: t("how_to_play.amax_emu_step_text")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef211fdc43fcfcba$export$2e2bcd8739ae039), {
                                            filename: "amax_client_files.zip",
                                            size: "1.4M",
                                            link: "https://cs.amax-emu.com/amax_client_files.zip"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: classes.imgdiv,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                className: classes.image_wrapper,
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($cb86c601af6e089e$exports)))["amax_client_files"],
                                                alt: "amax_emu_files_prev"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: classes.stepHeader,
                                        children: t("how_to_play.play_step_header")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        children: t("how_to_play.play_step_text")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}





var $acw62 = parcelRequire("acw62");




var $8DzwJ = parcelRequire("8DzwJ");


var $45fvw = parcelRequire("45fvw");

const $d557fad28d4cae81$var$AMAX_API_URL = "https://amax-emu.com/api";
const $d557fad28d4cae81$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            margin: 15,
            width: 570,
            height: 636,
            /* Blue/700 (2 L) */ background: "#304254",
            /* Blue/600 */ border: "1px solid #3E5270",
            boxSizing: "border-box",
            borderRadius: 8
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        },
        CustomIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24"
        },
        sswidget_container: {
            display: "inline-flex",
            flex: "0 1 auto",
            flexBasis: "33.33%",
            flexDirection: "column",
            flexWrap: "wrap",
            width: "33%",
            fontFamily: "Ubuntu",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "16px",
            lineHeight: "155%",
            marginTop: "1em",
            marginBottom: "1em",
            /* identical to box height, or 25px */ /* Blue / 50 */ color: "#92929F"
        },
        sswidget_icon_value: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            fontWeight: "bold",
            color: "#E6E6E6"
        },
        sswidgets_container: {
            display: "flex",
            maxWidth: "600px",
            maxHeight: "180px",
            flexWrap: "wrap",
            flexDirection: "column",
            margin: "1em"
        }
    }));
function $d557fad28d4cae81$var$DiscordIcon() {
    const classes = $d557fad28d4cae81$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8DzwJ.default), {
        className: classes.CustomIcon,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M23.5888 5.10296L19.3257 10.6287L19.3118 10.6247L19.2978 10.6208L19.2838 10.6169L19.2697 10.613L19.2557 10.6091L19.2417 10.6053L19.2279 10.6016L19.2142 10.5979L19.2006 10.5942L19.1874 10.5907V10.5926L19.1192 10.578L19.0514 10.5652L18.9838 10.554L18.9166 10.5443L18.8496 10.5363L18.783 10.5297L18.7169 10.5248L18.6511 10.5212L18.5859 10.5191L18.5211 10.5184L18.2112 10.5376L17.9174 10.5824L17.6394 10.65L17.3774 10.7375L17.1311 10.8419L16.9004 10.9604L16.6854 11.0899L16.4857 11.2276L16.3015 11.3706L16.1325 11.516L15.9637 11.3706L15.7797 11.2277L15.5803 11.0899L15.3655 10.9604L15.135 10.8419L14.8889 10.7375L14.6271 10.65L14.3495 10.5824L14.0558 10.5376L13.7462 10.5184L13.6811 10.5191L13.6157 10.5212L13.5498 10.5248L13.4835 10.5298L13.4169 10.5363L13.3498 10.5443L13.2824 10.554L13.2147 10.5652L13.1466 10.578L13.0783 10.5926L12.8768 10.644L12.6675 10.7097L12.4518 10.79L12.2313 10.8854L12.0073 10.9961L11.7813 11.1225L11.5549 11.265L11.3294 11.4241L11.1064 11.5999L10.8872 11.793L10.6763 12.0028L10.475 12.2329L10.2861 12.483L10.1128 12.7525L9.95797 13.041L9.82475 13.348L9.71607 13.673L9.63504 14.0156L9.58453 14.3752L9.56765 14.7515L9.60317 15.2713L9.70044 15.8061L9.86298 16.3565L10.0946 16.9233L10.399 17.507L10.7799 18.1085L11.241 18.7283L11.7861 19.3674L12.4188 20.0262L13.1429 20.7055H8.18275L7.73525 20.669L7.3151 20.5632L6.92764 20.3941L6.57834 20.1675L6.27266 19.8892L6.01606 19.5651L5.81406 19.201L5.672 18.8028L5.59539 18.3763L5.58972 17.9273L5.96246 12.5168L5.9625 12.5134L5.9627 12.51L5.96298 12.5067L5.96334 12.5035L5.96371 12.5002L5.96411 12.497L5.96455 12.4938L5.96491 12.4906L5.96524 12.4873L5.96553 12.484L5.92516 12.4513L5.88529 12.4178L5.84602 12.3832L5.80743 12.3476L5.76946 12.3109L5.73235 12.2729L5.69614 12.2337L5.66085 12.1932L5.62666 12.1513L5.59356 12.108L0.382898 5.00324L0.219416 4.7398L0.101615 4.46277L0.0286759 4.17738L0 3.88911L0.0147703 3.60316L0.0723383 3.325L0.172032 3.05993L0.313082 2.8133L0.494768 2.59045L0.716442 2.39676L0.967921 2.24324L1.23523 2.13682L1.51293 2.07645L1.79575 2.06122L2.07838 2.09013L2.35551 2.16221L2.62181 2.27648L2.87196 2.43196L3.10063 2.62768L3.30256 2.86268L8.38564 9.79755L8.43714 9.78751L8.48884 9.77848L8.5407 9.77034L8.59272 9.76318L8.64483 9.75701L8.69714 9.75182L8.74955 9.74764L8.80209 9.74447L8.85471 9.74236L8.90748 9.74125L8.65033 9.48648L8.41437 9.21188L8.20093 8.91861L8.01142 8.6081L7.84719 8.28159L7.70972 7.94048L7.60035 7.58609L7.52049 7.21972L7.47157 6.84268L7.45495 6.45635L7.51324 5.73356L7.68205 5.04793L7.95214 4.40856L8.31444 3.82464L8.75963 3.30536L9.27868 2.85992L9.86233 2.49748L10.5014 2.22722L11.1869 2.05831L11.9094 2L12.6321 2.05831L13.3178 2.22722L13.9571 2.49748L14.541 2.85994L15.0602 3.30536L15.5055 3.82462L15.8679 4.40854L16.1382 5.04791L16.307 5.73359L16.3653 6.45635L16.3486 6.84268L16.2997 7.21974L16.2198 7.58611L16.1103 7.94051L15.9727 8.28159L15.8084 8.60805L15.6188 8.91859L15.4052 9.21185L15.1692 9.48651L14.912 9.74125L14.9615 9.74233L15.011 9.74445L15.0603 9.7475L15.1095 9.75153L15.1584 9.75638L15.2073 9.7621L15.256 9.76863L15.3045 9.77588L15.3527 9.78388L15.4008 9.79255L20.7237 2.89227L20.9313 2.66212L21.1649 2.47202L21.4189 2.32274L21.688 2.21509L21.9668 2.14991L22.2501 2.12803L22.5325 2.15025L22.8086 2.2174L23.0731 2.3303L23.3206 2.48975L23.5376 2.68865L23.7139 2.91585L23.8488 3.16575L23.9419 3.43312L23.9925 3.71256L24 3.99872L23.964 4.2862L23.8838 4.56964L23.7589 4.84367L23.5888 5.10296Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M13.842 19.5545L16.1578 21.2704L18.4734 19.5545L20.0712 18.0159L21.0498 16.6527L21.5081 15.4631L21.5448 14.4451L21.2587 13.597L20.7485 12.9168L20.1131 12.4027L19.4512 12.0528L18.8615 11.8653L18.8132 11.8559L18.7654 11.8477L18.7177 11.8405L18.6705 11.8343L18.6235 11.829L18.5768 11.8248L18.5305 11.8216L18.4845 11.8193L18.4388 11.8179L18.3935 11.8174L18.0778 11.8394L17.7799 11.9009L17.5006 11.995L17.2411 12.1151L17.0025 12.2543L16.7857 12.4058L16.5917 12.5629L16.4218 12.7188L16.2768 12.8668L16.1578 13L16.0387 12.8668L15.8936 12.7189L15.7236 12.5629L15.5297 12.4058L15.3129 12.2543L15.0743 12.1151L14.8149 11.995L14.5357 11.9009L14.2378 11.8394L13.9222 11.8174L13.8768 11.8179L13.8311 11.8193L13.7851 11.8216L13.7388 11.8248L13.6921 11.829L13.6451 11.8343L13.5977 11.8405L13.5499 11.8477L13.5018 11.856L13.4534 11.8653L12.8639 12.0528L12.2021 12.4027L11.5668 12.9168L11.0566 13.597L10.7705 14.4451L10.8072 15.4631L11.2655 16.6527L12.2442 18.0159L13.842 19.5545ZM17.3334 19.1797L16.1578 20.0484L14.9822 19.1797L14.0315 18.3817L13.283 17.6541L12.7137 16.9971L12.3006 16.4106L12.0211 15.8945L11.8522 15.4488L11.771 15.0735L11.7546 14.7684L11.7803 14.5336L11.8668 14.2451L12.0022 13.9832L12.1765 13.7479L12.3799 13.5394L12.6025 13.3578L12.8344 13.2033L13.0657 13.076L13.2865 12.976L13.4869 12.9034L13.657 12.8584L13.6837 12.8531L13.7105 12.8484L13.7372 12.8442L13.7639 12.8405L13.7904 12.8373L13.817 12.8347L13.8434 12.8327L13.8698 12.8312L13.896 12.8303L13.9222 12.83L14.1237 12.8464L14.3168 12.8922L14.5001 12.9618L14.6722 13.0498L14.8316 13.1507L14.9769 13.259L15.1066 13.3694L15.2192 13.4764L15.3134 13.5744L15.3878 13.6581L16.1578 14.5603L16.9279 13.6581L17.0021 13.5744L17.0963 13.4764L17.2089 13.3694L17.3386 13.259L17.4837 13.1507L17.6431 13.0498L17.8152 12.9618L17.9986 12.8922L18.1918 12.8465L18.3935 12.83L18.4196 12.8303L18.4458 12.8312L18.472 12.8326L18.4984 12.8347L18.5248 12.8373L18.5513 12.8405L18.5779 12.8442L18.6045 12.8484L18.6311 12.8531L18.6579 12.8584L18.8282 12.9034L19.0288 12.976L19.2497 13.076L19.4811 13.2033L19.7131 13.3578L19.9357 13.5394L20.1391 13.7479L20.3135 13.9832L20.4489 14.2452L20.5354 14.5336L20.561 14.7684L20.5446 15.0735L20.4634 15.4488L20.2946 15.8945L20.015 16.4106L19.602 16.9971L19.0327 17.6541L18.2841 18.3816L17.3334 19.1797Z",
                fill: "white"
            })
        ]
    });
}
function $d557fad28d4cae81$var$GetIcon({ statName: statName  }) {
    switch(statName){
        case "statRaces":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$77afd8b5a8f1e556), {});
        case "statLevel":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$77afd8b5a8f1e556), {});
        case "statFans":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$919f9e6aad25b3cc), {});
        case "statRaceTime":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$7e95adcf912503e3), {});
        case "statDriverScore":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$5a540ecc9c1f0346), {});
        case "statTop3":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$77afd8b5a8f1e556), {});
        case "statFirst":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$77afd8b5a8f1e556), {});
        case "statHits":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$77afd8b5a8f1e556), {});
        case "statFired":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$77afd8b5a8f1e556), {});
        case "statWrecked":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$77afd8b5a8f1e556), {});
        case "statLegend":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$77afd8b5a8f1e556), {});
    }
}
const $d557fad28d4cae81$var$statNames = {
    statRaces: "general_values_names.total_race",
    statLevel: "general_values_names.level"
};
function $d557fad28d4cae81$var$GetStatName(statName) {
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return t($d557fad28d4cae81$var$statNames[statName]);
}
function $d557fad28d4cae81$var$SingleStatWidget({ statName: statName , value: value  }) {
    const classes = $d557fad28d4cae81$var$useStyles();
    let value2 = value;
    if (statName === "statRaceTime") value2 = $45fvw.utc($45fvw.duration(value, "seconds").asMilliseconds()).format("HH:mm:ss");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: classes.sswidget_container,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: classes.sswidget_icon_value,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d557fad28d4cae81$var$GetIcon, {
                        statName: statName
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        style: {
                            marginLeft: "0.3em"
                        },
                        children: value2
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                children: $d557fad28d4cae81$var$GetStatName(statName)
            })
        ]
    });
}
function $d557fad28d4cae81$export$2e2bcd8739ae039() {
    let { profileName: profileName  } = (0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)();
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    const classes = $d557fad28d4cae81$var$useStyles();
    const [targetPlayerData, settargetPlayerData] = $acw62.useState(undefined);
    const [severDataFlag, setseverDataFlag] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        async function getServerData() {
            const resp = await fetch($d557fad28d4cae81$var$AMAX_API_URL + "/players/name/" + user.userData.amax_player_data.stats.playerName, {
                method: "GET",
                headers: {
                    "content-type": "application/json;charset=UTF-8"
                }
            });
            settargetPlayerData(await resp.json());
            setseverDataFlag(true);
        }
        getServerData().catch(()=>{});
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: severDataFlag ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de708537bc6d55c6$export$2e2bcd8739ae039), {
                    playerName: profileName,
                    playerCurrentExp: targetPlayerData.data.amaxPlayerData.amaxLevelingData.fansCurrent,
                    playerLevel: targetPlayerData.data.amaxPlayerData.amaxLevelingData.level + 1,
                    playerLegend: targetPlayerData.data.amaxPlayerData.amaxLevelingData.legend,
                    playerLevelupExp: targetPlayerData.data.amaxPlayerData.amaxLevelingData.fansNeeded,
                    playerPfpUrl: targetPlayerData.data.amaxPfpUrl,
                    playerAccountType: targetPlayerData.data.accountType
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: classes.sswidgets_container,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d557fad28d4cae81$var$SingleStatWidget, {
                            statName: "statFans",
                            value: targetPlayerData.data.amaxPlayerData.amaxStatsData.statFans
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d557fad28d4cae81$var$SingleStatWidget, {
                            statName: "statDriverScore",
                            value: targetPlayerData.data.amaxPlayerData.amaxStatsData.statDriverScore
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d557fad28d4cae81$var$SingleStatWidget, {
                            statName: "statRaces",
                            value: targetPlayerData.data.amaxPlayerData.amaxStatsData.statRaces
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d557fad28d4cae81$var$SingleStatWidget, {
                            statName: "statFirst",
                            value: targetPlayerData.data.amaxPlayerData.amaxStatsData.statFirst
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d557fad28d4cae81$var$SingleStatWidget, {
                            statName: "statTop3",
                            value: targetPlayerData.data.amaxPlayerData.amaxStatsData.statTop3
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d557fad28d4cae81$var$SingleStatWidget, {
                            statName: "statFired",
                            value: targetPlayerData.data.amaxPlayerData.amaxStatsData.statFired
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d557fad28d4cae81$var$SingleStatWidget, {
                            statName: "statWrecked",
                            value: targetPlayerData.data.amaxPlayerData.amaxStatsData.statWrecked
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d557fad28d4cae81$var$SingleStatWidget, {
                            statName: "statRaceTime",
                            value: targetPlayerData.data.amaxPlayerData.amaxStatsData.statRaceTime
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
            children: "Loading"
        })
    });
}





var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");











parcelRequire("acw62");
const $6ddb4fe876e23ea5$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)({
    table: {
        minWidth: 650
    },
    PlayerTable: {
        minWidth: 650
    }
});
function $6ddb4fe876e23ea5$var$GetFinalStateName(StateId) {
    switch(StateId){
        case 1:
            return "Unknown";
        case 2:
            return "Finished";
        case 3:
            return "DNF";
        case 4:
            return "Disconnected";
        default:
            return "Test";
    }
}
function $6ddb4fe876e23ea5$export$2e2bcd8739ae039({ tableData: tableData  }) {
    const classes = $6ddb4fe876e23ea5$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b289f7d30c9e5e15$export$2e2bcd8739ae039), {
        component: (0, $ca4ada9c808bb355$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e06e485673548dbd$export$2e2bcd8739ae039), {
            className: classes.PlayerTable,
            size: "small",
            "aria-label": "a dense table",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3d6bc8b29873e89$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $58a81d8428d1c8f8$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                align: "left",
                                children: "Pos."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                align: "left",
                                children: "Player"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                align: "left",
                                children: "Car"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                align: "left",
                                children: "Mods"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                align: "left",
                                children: "Fans"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                align: "left",
                                children: "Status"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ffd6f30eceff04f$export$2e2bcd8739ae039), {
                    children: Object.keys(tableData).map((key, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $58a81d8428d1c8f8$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                    component: "th",
                                    scope: "row",
                                    children: key
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                    component: "th",
                                    scope: "row",
                                    align: "left",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d0539293769f9ac$export$2e2bcd8739ae039), {
                                        player_name: tableData[key].player_name,
                                        place: tableData[key].finish_pos,
                                        level: tableData[key].player_level,
                                        legend: tableData[key].player_legend,
                                        is_bot: tableData[key].is_bot
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                    align: "left",
                                    children: tableData[key].player_car_name
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            width: "120px"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa47401a2d50c587$export$2e2bcd8739ae039), {
                                            mod1: tableData[key].mod_1_id,
                                            mod2: tableData[key].mod_2_id,
                                            mod3: tableData[key].mod_3_id,
                                            mod1_name: tableData[key].mod_1_name,
                                            mod2_name: tableData[key].mod_2_name,
                                            mod3_name: tableData[key].mod_3_name
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                    align: "left",
                                    children: tableData[key].total_fans
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                    align: "left",
                                    children: $6ddb4fe876e23ea5$var$GetFinalStateName(tableData[key].final_state_id)
                                })
                            ]
                        }, key + 1))
                })
            ]
        })
    });
}


var $0c0f710e39f57136$exports = {};
var $bf878c73165c860b$exports = {};

$bf878c73165c860b$exports = new URL((parcelRequire("27Lyk")).resolve("9KeNU"), import.meta.url).toString();


var $7d49f5051a9a95bf$exports = {};

$7d49f5051a9a95bf$exports = new URL((parcelRequire("27Lyk")).resolve("9QhDq"), import.meta.url).toString();


var $f2dfdf71c9800fb3$exports = {};

$f2dfdf71c9800fb3$exports = new URL((parcelRequire("27Lyk")).resolve("1cxcr"), import.meta.url).toString();


var $6dcf42082e7e7de4$exports = {};

$6dcf42082e7e7de4$exports = new URL((parcelRequire("27Lyk")).resolve("7uU8O"), import.meta.url).toString();


var $c2cd3d1ca562f8c1$exports = {};

$c2cd3d1ca562f8c1$exports = new URL((parcelRequire("27Lyk")).resolve("go8IQ"), import.meta.url).toString();


var $adfbc32c1c484dd6$exports = {};

$adfbc32c1c484dd6$exports = new URL((parcelRequire("27Lyk")).resolve("iWllo"), import.meta.url).toString();


var $460080690ac02de2$exports = {};

$460080690ac02de2$exports = new URL((parcelRequire("27Lyk")).resolve("fwOXS"), import.meta.url).toString();


var $8308cc5241506c6d$exports = {};

$8308cc5241506c6d$exports = new URL((parcelRequire("27Lyk")).resolve("f43hj"), import.meta.url).toString();


var $c42967979976f646$exports = {};

$c42967979976f646$exports = new URL((parcelRequire("27Lyk")).resolve("5p3s7"), import.meta.url).toString();


var $ee94051643816551$exports = {};

$ee94051643816551$exports = new URL((parcelRequire("27Lyk")).resolve("2P9KQ"), import.meta.url).toString();


var $8b654bdefc5410e2$exports = {};

$8b654bdefc5410e2$exports = new URL((parcelRequire("27Lyk")).resolve("dW50I"), import.meta.url).toString();


var $490c35674b063300$exports = {};

$490c35674b063300$exports = new URL((parcelRequire("27Lyk")).resolve("84QbO"), import.meta.url).toString();


var $a4a050f1f834a4b3$exports = {};

$a4a050f1f834a4b3$exports = new URL((parcelRequire("27Lyk")).resolve("7Rh4i"), import.meta.url).toString();


var $50f0127c05ebe8a0$exports = {};

$50f0127c05ebe8a0$exports = new URL((parcelRequire("27Lyk")).resolve("kMBGj"), import.meta.url).toString();


var $809ca0fd70f8c6d0$exports = {};

$809ca0fd70f8c6d0$exports = new URL((parcelRequire("27Lyk")).resolve("1RRml"), import.meta.url).toString();


$0c0f710e39f57136$exports = {
    "amboy": $bf878c73165c860b$exports,
    "barcelona": $7d49f5051a9a95bf$exports,
    "brighton": $f2dfdf71c9800fb3$exports,
    "double_question_mark": $6dcf42082e7e7de4$exports,
    "dumbo": $c2cd3d1ca562f8c1$exports,
    "hackney": $adfbc32c1c484dd6$exports,
    "japan_shutoko": $460080690ac02de2$exports,
    "la_docks": $8308cc5241506c6d$exports,
    "la_downtown": $c42967979976f646$exports,
    "la_observatory": $ee94051643816551$exports,
    "la_river": $8b654bdefc5410e2$exports,
    "mount_haruna": $490c35674b063300$exports,
    "oval": $a4a050f1f834a4b3$exports,
    "russian_hill": $50f0127c05ebe8a0$exports,
    "san_francisco": $809ca0fd70f8c6d0$exports
};


var $55d3b3103828cede$exports = {};
var $c6d62e99f4207311$exports = {};

$c6d62e99f4207311$exports = new URL((parcelRequire("27Lyk")).resolve("bED8a"), import.meta.url).toString();


var $bb69e070e8f194c8$exports = {};

$bb69e070e8f194c8$exports = new URL((parcelRequire("27Lyk")).resolve("kJu6D"), import.meta.url).toString();


var $aebdb4682fe21524$exports = {};

$aebdb4682fe21524$exports = new URL((parcelRequire("27Lyk")).resolve("3xeS7"), import.meta.url).toString();


var $039bbfb5d26d96eb$exports = {};

$039bbfb5d26d96eb$exports = new URL((parcelRequire("27Lyk")).resolve("gpYtz"), import.meta.url).toString();


var $700687f262bb1ed6$exports = {};

$700687f262bb1ed6$exports = new URL((parcelRequire("27Lyk")).resolve("lue1A"), import.meta.url).toString();


var $8b4a3d839c1d633a$exports = {};

$8b4a3d839c1d633a$exports = new URL((parcelRequire("27Lyk")).resolve("gt5l9"), import.meta.url).toString();


var $46008e4a98855036$exports = {};

$46008e4a98855036$exports = new URL((parcelRequire("27Lyk")).resolve("834kH"), import.meta.url).toString();


var $e1660b590d239d9a$exports = {};

$e1660b590d239d9a$exports = new URL((parcelRequire("27Lyk")).resolve("ILBWa"), import.meta.url).toString();


var $4e63ee336001dd86$exports = {};

$4e63ee336001dd86$exports = new URL((parcelRequire("27Lyk")).resolve("2R2Si"), import.meta.url).toString();


var $5c3e3abc14291327$exports = {};

$5c3e3abc14291327$exports = new URL((parcelRequire("27Lyk")).resolve("dU4gB"), import.meta.url).toString();


var $7941f56e6340cd99$exports = {};

$7941f56e6340cd99$exports = new URL((parcelRequire("27Lyk")).resolve("32ZcN"), import.meta.url).toString();


var $fdc6196ea38bcd50$exports = {};

$fdc6196ea38bcd50$exports = new URL((parcelRequire("27Lyk")).resolve("7fsuX"), import.meta.url).toString();


var $45d78db18815fb3e$exports = {};

$45d78db18815fb3e$exports = new URL((parcelRequire("27Lyk")).resolve("6XwlA"), import.meta.url).toString();


var $1c142a0d77c5967c$exports = {};

$1c142a0d77c5967c$exports = new URL((parcelRequire("27Lyk")).resolve("PBNZW"), import.meta.url).toString();


var $9a9900e17e256543$exports = {};

$9a9900e17e256543$exports = new URL((parcelRequire("27Lyk")).resolve("2VPHq"), import.meta.url).toString();


var $876849043cb14e86$exports = {};

$876849043cb14e86$exports = new URL((parcelRequire("27Lyk")).resolve("3Fbnu"), import.meta.url).toString();


var $91d2883951f8fae7$exports = {};

$91d2883951f8fae7$exports = new URL((parcelRequire("27Lyk")).resolve("fJKqz"), import.meta.url).toString();


var $564f75b1aadad6e9$exports = {};

$564f75b1aadad6e9$exports = new URL((parcelRequire("27Lyk")).resolve("9PfmG"), import.meta.url).toString();


var $95c73ea8d5010f61$exports = {};

$95c73ea8d5010f61$exports = new URL((parcelRequire("27Lyk")).resolve("ikP5m"), import.meta.url).toString();


var $7b4838904969bdfa$exports = {};

$7b4838904969bdfa$exports = new URL((parcelRequire("27Lyk")).resolve("lWm0Z"), import.meta.url).toString();


var $742e0740c66172d9$exports = {};

$742e0740c66172d9$exports = new URL((parcelRequire("27Lyk")).resolve("5ILnS"), import.meta.url).toString();


var $c285e013178995b4$exports = {};

$c285e013178995b4$exports = new URL((parcelRequire("27Lyk")).resolve("3hb5W"), import.meta.url).toString();


var $73792e31d7d938f6$exports = {};

$73792e31d7d938f6$exports = new URL((parcelRequire("27Lyk")).resolve("2olKx"), import.meta.url).toString();


var $e788a4d5d627a4a2$exports = {};

$e788a4d5d627a4a2$exports = new URL((parcelRequire("27Lyk")).resolve("3kjZX"), import.meta.url).toString();


var $b3e0cfa170428ae1$exports = {};

$b3e0cfa170428ae1$exports = new URL((parcelRequire("27Lyk")).resolve("8bK7N"), import.meta.url).toString();


var $c76c2488c15654cc$exports = {};

$c76c2488c15654cc$exports = new URL((parcelRequire("27Lyk")).resolve("45s6l"), import.meta.url).toString();


var $2016a5dd0f0ca639$exports = {};

$2016a5dd0f0ca639$exports = new URL((parcelRequire("27Lyk")).resolve("25GvA"), import.meta.url).toString();


var $a3c76333a7164b86$exports = {};

$a3c76333a7164b86$exports = new URL((parcelRequire("27Lyk")).resolve("6MAXW"), import.meta.url).toString();


var $caa126daab4dff11$exports = {};

$caa126daab4dff11$exports = new URL((parcelRequire("27Lyk")).resolve("jo0hu"), import.meta.url).toString();


var $9d86a1217c866503$exports = {};

$9d86a1217c866503$exports = new URL((parcelRequire("27Lyk")).resolve("khJkA"), import.meta.url).toString();


var $f955ec116846f732$exports = {};

$f955ec116846f732$exports = new URL((parcelRequire("27Lyk")).resolve("6z5P9"), import.meta.url).toString();


var $9aa43363e61eca15$exports = {};

$9aa43363e61eca15$exports = new URL((parcelRequire("27Lyk")).resolve("eneth"), import.meta.url).toString();


var $b4b31f5af0da880d$exports = {};

$b4b31f5af0da880d$exports = new URL((parcelRequire("27Lyk")).resolve("d5xaj"), import.meta.url).toString();


var $55572c8388ea32e3$exports = {};

$55572c8388ea32e3$exports = new URL((parcelRequire("27Lyk")).resolve("3YHx3"), import.meta.url).toString();


var $aaef82d97baef103$exports = {};

$aaef82d97baef103$exports = new URL((parcelRequire("27Lyk")).resolve("4ZiQQ"), import.meta.url).toString();


var $f1bdd09495bcb59b$exports = {};

$f1bdd09495bcb59b$exports = new URL((parcelRequire("27Lyk")).resolve("74Bjs"), import.meta.url).toString();


var $6e3746c450411da2$exports = {};

$6e3746c450411da2$exports = new URL((parcelRequire("27Lyk")).resolve("j67g9"), import.meta.url).toString();


$55d3b3103828cede$exports = {
    "jpn_mharuna_1": $c6d62e99f4207311$exports,
    "jpn_tokyo_shutoko_2": $bb69e070e8f194c8$exports,
    "jpn_tokyo_shutoko_4": $aebdb4682fe21524$exports,
    "location_header": $039bbfb5d26d96eb$exports,
    "spa_barcelona_bowl_multiplayer": $700687f262bb1ed6$exports,
    "spa_barcelona_gracia_1": $8b4a3d839c1d633a$exports,
    "spa_barcelona_gracia_2": $46008e4a98855036$exports,
    "spa_barcelona_gracia_5": $e1660b590d239d9a$exports,
    "spa_barcelona_oval_1": $4e63ee336001dd86$exports,
    "spa_barcelona_oval_2": $5c3e3abc14291327$exports,
    "uk_brighton_1": $7941f56e6340cd99$exports,
    "uk_brighton_2": $fdc6196ea38bcd50$exports,
    "uk_brighton_3": $45d78db18815fb3e$exports,
    "uk_brighton_multiplayer": $1c142a0d77c5967c$exports,
    "uk_london_hackney_1": $9a9900e17e256543$exports,
    "uk_london_hackney_2": $876849043cb14e86$exports,
    "uk_london_hackney_4": $91d2883951f8fae7$exports,
    "usa_amboy_1": $564f75b1aadad6e9$exports,
    "usa_amboy_3": $95c73ea8d5010f61$exports,
    "usa_amboy_bowl": $7b4838904969bdfa$exports,
    "usa_la_downtown_1": $742e0740c66172d9$exports,
    "usa_la_downtown_4": $c285e013178995b4$exports,
    "usa_la_downtown_6": $73792e31d7d938f6$exports,
    "usa_la_downtown_figureof8": $e788a4d5d627a4a2$exports,
    "usa_la_longbeach_multiplayer_1": $b3e0cfa170428ae1$exports,
    "usa_la_longbeachdocks_2": $c76c2488c15654cc$exports,
    "usa_la_longbeachdocks_3": $2016a5dd0f0ca639$exports,
    "usa_la_multiplayer_highrise": $a3c76333a7164b86$exports,
    "usa_la_observatory_1": $caa126daab4dff11$exports,
    "usa_la_observatory_2": $9d86a1217c866503$exports,
    "usa_la_river_3": $f955ec116846f732$exports,
    "usa_la_river_6": $9aa43363e61eca15$exports,
    "usa_ny_dumbo_2": $b4b31f5af0da880d$exports,
    "usa_ny_dumbo_3": $55572c8388ea32e3$exports,
    "usa_sanfran_russianhill_1": $aaef82d97baef103$exports,
    "usa_sanfran_sausalito_1": $f1bdd09495bcb59b$exports,
    "usa_sanfran_sausalito_2": $6e3746c450411da2$exports
};


function $82845726a106878c$var$get_location_icon(location_id) {
    let location_icon = "";
    switch(location_id){
        case 1:
            location_icon = "oval";
            break;
        case 2:
            location_icon = "barcelona";
            break;
        case 3:
            location_icon = "brighton";
            break;
        case 4:
            location_icon = "barcelona";
            break;
        case 5:
            location_icon = "hackney";
            break;
        case 6:
            location_icon = "la_observatory" //hollywood_hills
            ;
            break;
        case 7:
            location_icon = "amboy";
            break;
        case 8:
            location_icon = "la_downtown";
            break;
        case 9:
            location_icon = "amboy";
            break;
        case 10:
            location_icon = "la_docks";
            break;
        case 11:
            location_icon = "la_downtown";
            break;
        case 12:
            location_icon = "la_downtown";
            break;
        case 13:
            location_icon = "la_river";
            break;
        case 14:
            location_icon = "mount_haruna";
            break;
        case 15:
            location_icon = "dumbo";
            break;
        case 16:
            location_icon = "russian_hill";
            break;
        case 17:
            location_icon = "san_francisco";
            break;
        case 18:
            location_icon = "japan_shutoko" //tokyo
            ;
            break;
        default:
            location_icon = "double_question_mark";
    }
    return location_icon;
}
function $82845726a106878c$var$get_track_name(track_internal_name) {
    let track_name = "";
    switch(track_internal_name){
        case "Barcelona Oval 0":
            track_name = "Circus Minimus";
            break;
        case "Barcelona Oval 1":
            track_name = "City Breach";
            break;
        case "Barcelona Bowl Multiplayer":
            track_name = "Ocean Pier";
            break;
        case "Brighton 0":
            track_name = "Brighton 0";
            break;
        case "Brighton 3":
            track_name = "Coastal Cruise";
            break;
        case "Brighton 1":
            track_name = "Promenade Loop" //hollywood_hills
            ;
            break;
        case "Brighton 2":
            track_name = "Seafront Strip";
            break;
        case "Barcelona Gracia 0":
            track_name = "Passeig de Gracia";
            break;
        case "Barcelona Gracia 5":
            track_name = "Catalon Climb";
            break;
        case "Barcelona Gracia 2":
            track_name = "El Carmel Heights";
            break;
        case "Barcelona Gracia 1":
            track_name = "Passeig de Gracia";
            break;
        case "Hackney 0":
            track_name = "Hackney 0";
            break;
        case "Hackney 4":
            track_name = "Central Sprint";
            break;
        case "Hackney 1":
            track_name = "Shoreditch Sweep";
            break;
        case "Hackney 2":
            track_name = "Urban Belt";
            break;
        case "Hollywood Hills 0":
            track_name = "Hollywood Rift";
            break;
        case "Hollywood Hills 2":
            track_name = "Downtown Vista";
            break;
        case "Hollywood Hills 1":
            track_name = "Hollywood Rift" //tokyo
            ;
            break;
        case "Amboy 0":
            track_name = "Amboy 0";
            break;
        case "Amboy 3":
            track_name = "Tumbleweed Alley";
            break;
        case "Amboy 1":
            track_name = "Route 66";
            break;
        case "LA Downtown 0":
            track_name = "Angel Angles";
            break;
        case "LA Downtown 1":
            track_name = "The Money Run";
            break;
        case "LA Downtown 4":
            track_name = "Highrise Ring";
            break;
        case "LA Downtown 6":
            track_name = "Harbor Freeway";
            break;
        case "Amboy Bowl Multiplayer":
            track_name = "Amboy Little Bowl";
            break;
        case "LA Docks 0":
            track_name = "Container Island";
            break;
        case "LA Docks 3":
            track_name = "Cargo Run";
            break;
        case "LA Docks 2":
            track_name = "Pacific Reach";
            break;
        case "LA Downtown Highrise Multiplayer":
            track_name = "LA Heights";
            break;
        case "LA Downtown FigureOf8 Multiplayer":
            track_name = "Figure of 8";
            break;
        case "LA River 0":
            track_name = "Stormdrain Surge";
            break;
        case "LA River 3":
            track_name = "Concrete Basin";
            break;
        case "Mount Haruna 0":
            track_name = "Assent";
            break;
        case "Mount Haruna 1":
            track_name = "Descent";
            break;
        case "NY Dumbo 0":
            track_name = "Fulton Loop";
            break;
        case "NY Dumbo 3":
            track_name = "Brooklyn Tour";
            break;
        case "NY Dumbo 2":
            track_name = "Manhattan View";
            break;
        case "SanFran Russian Hill 0":
            track_name = "Cable Car Chase";
            break;
        case "SanFran Russian Hill 1":
            track_name = "Russian Steppes";
            break;
        case "SanFran Sausalito 0":
            track_name = "la_docks";
            break;
        case "SanFran Sausalito 2":
            track_name = "Bay Area Tour";
            break;
        case "SanFran Sausalito 1":
            track_name = "Golden Gate Rush";
            break;
        case "Tokyo Shutoko 0":
            track_name = "la_docks";
            break;
        case "Tokyo Shutoko 2":
            track_name = "Bayshore Route";
            break;
        case "Tokyo Shutoko 4":
            track_name = "Wangan-sen";
            break;
        default:
            track_name = track_internal_name;
    }
    return track_name;
}
function $82845726a106878c$var$get_header_name(track_internal_name) {
    let track_name = "";
    switch(track_internal_name){
        case "Barcelona Oval 0":
            track_name = "spa_barcelona_oval_1";
            break;
        case "Barcelona Oval 1":
            track_name = "spa_barcelona_oval_1";
            break;
        case "Barcelona Oval 2":
            track_name = "spa_barcelona_oval_2";
            break;
        case "Barcelona Bowl Multiplayer":
            track_name = "spa_barcelona_bowl_multiplayer";
            break;
        case "Brighton 0":
            track_name = "uk_brighton_1";
            break;
        case "Brighton 3":
            track_name = "uk_brighton_3";
            break;
        case "Brighton 1":
            track_name = "uk_brighton_1" //hollywood_hills
            ;
            break;
        case "Brighton 2":
            track_name = "uk_brighton_2";
            break;
        case "Barcelona Gracia 0":
            track_name = "spa_barcelona_gracia_1";
            break;
        case "Barcelona Gracia 5":
            track_name = "spa_barcelona_gracia_5";
            break;
        case "Barcelona Gracia 2":
            track_name = "spa_barcelona_gracia_2";
            break;
        case "Barcelona Gracia 1":
            track_name = "spa_barcelona_gracia_1";
            break;
        case "Hackney 0":
            track_name = "uk_london_hackney_1";
            break;
        case "Hackney 4":
            track_name = "uk_london_hackney_4";
            break;
        case "Hackney 1":
            track_name = "uk_london_hackney_1";
            break;
        case "Hackney 2":
            track_name = "uk_london_hackney_2";
            break;
        case "Hollywood Hills 0":
            track_name = "usa_la_observatory_1";
            break;
        case "Hollywood Hills 2":
            track_name = "usa_la_observatory_2";
            break;
        case "Hollywood Hills 1":
            track_name = "usa_la_observatory_1" //tokyo
            ;
            break;
        case "Amboy 0":
            track_name = "usa_amboy_1";
            break;
        case "Amboy 3":
            track_name = "usa_amboy_3";
            break;
        case "Amboy 1":
            track_name = "usa_amboy_1";
            break;
        case "LA Downtown 0":
            track_name = "location_header";
            break;
        case "LA Downtown 1":
            track_name = "usa_la_downtown_1";
            break;
        case "LA Downtown 4":
            track_name = "usa_la_downtown_4";
            break;
        case "LA Downtown 6":
            track_name = "usa_la_downtown_6";
            break;
        case "Amboy Bowl Multiplayer":
            track_name = "usa_amboy_bowl";
            break;
        case "LA Docks 0":
            track_name = "usa_la_longbeachdocks_3";
            break;
        case "LA Docks 3":
            track_name = "usa_la_longbeachdocks_3";
            break;
        case "LA Docks 2":
            track_name = "usa_la_longbeachdocks_2";
            break;
        case "LA Downtown Highrise Multiplayer":
            track_name = "usa_la_multiplayer_highrise";
            break;
        case "LA Downtown FigureOf8 Multiplayer":
            track_name = "usa_la_downtown_figureof8";
            break;
        case "LA River 0":
            track_name = "usa_la_river_6";
            break;
        case "LA River 3":
            track_name = "usa_la_river_3";
            break;
        case "Mount Haruna 0":
            track_name = "jpn_mharuna_1";
            break;
        case "Mount Haruna 1":
            track_name = "jpn_mharuna_1";
            break;
        case "NY Dumbo 0":
            track_name = "usa_ny_dumbo_2";
            break;
        case "NY Dumbo 3":
            track_name = "usa_ny_dumbo_3";
            break;
        case "NY Dumbo 2":
            track_name = "usa_ny_dumbo_2";
            break;
        case "SanFran Russian Hill 0":
            track_name = "usa_sanfran_russianhill_1";
            break;
        case "SanFran Russian Hill 1":
            track_name = "usa_sanfran_russianhill_1";
            break;
        case "SanFran Sausalito 0":
            track_name = "usa_sanfran_sausalito_1";
            break;
        case "SanFran Sausalito 2":
            track_name = "usa_sanfran_sausalito_2";
            break;
        case "SanFran Sausalito 1":
            track_name = "usa_sanfran_sausalito_1";
            break;
        case "Tokyo Shutoko 0":
            track_name = "jpn_tokyo_shutoko_2";
            break;
        case "Tokyo Shutoko 2":
            track_name = "jpn_tokyo_shutoko_2";
            break;
        case "Tokyo Shutoko 4":
            track_name = "jpn_tokyo_shutoko_4";
            break;
        default:
            track_name = "missing!";
    }
    return track_name;
}
const $82845726a106878c$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            margin: 15
        },
        race_data_container: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            alignItems: "center",
            borderRadius: "6px 6px 0px 0px",
            position: "relative",
            overflow: "hidden"
        },
        map_image_header: {
            backgroundPosition: "right",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            position: "absolute",
            right: "0px",
            top: "0px",
            height: "100%",
            width: "100%",
            zIndex: 1
        },
        map_gradient_header: {
            background: "linear-gradient(90deg, rgba(44,56,69,1) 30%, rgba(0,0,0,0) 100%)",
            position: "absolute",
            left: "0px",
            top: "0px",
            height: "100%",
            width: "70%",
            zIndex: 2
        },
        map_name: {
            fontSize: "25px",
            fontWeight: "bold"
        },
        game_data: {
            padding: "0.4em",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "column",
            zIndex: 3
        },
        game_data_stats: {
            lineHeight: "5px"
        },
        location_icon: {
            maxWidth: "100%",
            maxHeight: "100%",
            margin: "5px"
        },
        map_icon_container: {
            width: "70px",
            height: "70px",
            marginLeft: "15px",
            marginRight: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 3
        }
    }));
function $82845726a106878c$export$2e2bcd8739ae039({ data: data  }) {
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $82845726a106878c$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ca4ada9c808bb355$export$2e2bcd8739ae039), {
        elevation: 3,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: classes.race_data_container,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: classes.map_icon_container,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($0c0f710e39f57136$exports)))[$82845726a106878c$var$get_location_icon(data.location_id)],
                            className: classes.location_icon,
                            alt: "logo"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: classes.game_data,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: classes.map_name,
                                children: $82845726a106878c$var$get_track_name(data.map_name)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: classes.game_data_stats,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            "Laps: ",
                                            data.laps
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            "Racers: ",
                                            data.number_of_racers
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: $45fvw(data.timestamp).local().format("M/D/YYYY- h:mm A z")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: classes.map_gradient_header
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: classes.map_image_header,
                        style: {
                            backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($55d3b3103828cede$exports)))[$82845726a106878c$var$get_header_name(data.map_name)]})`
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ddb4fe876e23ea5$export$2e2bcd8739ae039), {
                    tableData: data.racers_info
                })
            })
        ]
    });
}





var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $kQaj4 = parcelRequire("kQaj4");

var $8nd05 = parcelRequire("8nd05");

var $kbxxf = parcelRequire("kbxxf");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

function $7da8bb4b37cc88f8$export$2e2bcd8739ae039() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // keep default values in sync with @default tags in Pagination.propTypes
    var _props$boundaryCount = props.boundaryCount, boundaryCount = _props$boundaryCount === void 0 ? 1 : _props$boundaryCount, _props$componentName = props.componentName, componentName = _props$componentName === void 0 ? "usePagination" : _props$componentName, _props$count = props.count, count = _props$count === void 0 ? 1 : _props$count, _props$defaultPage = props.defaultPage, defaultPage = _props$defaultPage === void 0 ? 1 : _props$defaultPage, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$hideNextButton = props.hideNextButton, hideNextButton = _props$hideNextButton === void 0 ? false : _props$hideNextButton, _props$hidePrevButton = props.hidePrevButton, hidePrevButton = _props$hidePrevButton === void 0 ? false : _props$hidePrevButton, handleChange = props.onChange, pageProp = props.page, _props$showFirstButto = props.showFirstButton, showFirstButton = _props$showFirstButto === void 0 ? false : _props$showFirstButto, _props$showLastButton = props.showLastButton, showLastButton = _props$showLastButton === void 0 ? false : _props$showLastButton, _props$siblingCount = props.siblingCount, siblingCount = _props$siblingCount === void 0 ? 1 : _props$siblingCount, other = (0, $9X7IJ.default)(props, [
        "boundaryCount",
        "componentName",
        "count",
        "defaultPage",
        "disabled",
        "hideNextButton",
        "hidePrevButton",
        "onChange",
        "page",
        "showFirstButton",
        "showLastButton",
        "siblingCount"
    ]);
    var _useControlled = (0, $09c3426c3fc3fc28$export$2e2bcd8739ae039)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: "page"
    }), _useControlled2 = (0, $eUqlC.default)(_useControlled, 2), page = _useControlled2[0], setPageState = _useControlled2[1];
    var handleClick = function handleClick(event, value) {
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    }; // https://dev.to/namirsab/comment/2050
    var range = function range(start, end) {
        var length = end - start + 1;
        return Array.from({
            length: length
        }, function(_, i) {
            return start + i;
        });
    };
    var startPages = range(1, Math.min(boundaryCount, count));
    var endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    var siblingsStart = Math.max(Math.min(page - siblingCount, count - boundaryCount - siblingCount * 2 - 1), boundaryCount + 2);
    var siblingsEnd = Math.min(Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2), endPages[0] - 2); // Basic list of items to render
    // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    var itemList = [].concat((0, $kbxxf.default)(showFirstButton ? [
        "first"
    ] : []), (0, $kbxxf.default)(hidePrevButton ? [] : [
        "previous"
    ]), (0, $kbxxf.default)(startPages), (0, $kbxxf.default)(siblingsStart > boundaryCount + 2 ? [
        "start-ellipsis"
    ] : boundaryCount + 1 < count - boundaryCount ? [
        boundaryCount + 1
    ] : []), (0, $kbxxf.default)(range(siblingsStart, siblingsEnd)), (0, $kbxxf.default)(siblingsEnd < count - boundaryCount - 1 ? [
        "end-ellipsis"
    ] : count - boundaryCount > boundaryCount ? [
        count - boundaryCount
    ] : []), (0, $kbxxf.default)(endPages), (0, $kbxxf.default)(hideNextButton ? [] : [
        "next"
    ]), (0, $kbxxf.default)(showLastButton ? [
        "last"
    ] : [])); // Map the button type to its page number
    var buttonPage = function buttonPage(type) {
        switch(type){
            case "first":
                return 1;
            case "previous":
                return page - 1;
            case "next":
                return page + 1;
            case "last":
                return count;
            default:
                return null;
        }
    }; // Convert the basic item list to PaginationItem props objects
    var items = itemList.map(function(item) {
        return typeof item === "number" ? {
            onClick: function onClick(event) {
                handleClick(event, item);
            },
            type: "page",
            page: item,
            selected: item === page,
            disabled: disabled,
            "aria-current": item === page ? "true" : undefined
        } : {
            onClick: function onClick(event) {
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf("ellipsis") === -1 && (item === "next" || item === "last" ? page >= count : page <= 1)
        };
    });
    return (0, $8nd05.default)({
        items: items
    }, other);
}



var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");

var $9GbWv = parcelRequire("9GbWv");
var $kQaj4 = parcelRequire("kQaj4");


var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $0fad356282c32f9a$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");



var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $8d5e3cc058c226df$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");



var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $bc39a99687471606$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");



var $acw62 = parcelRequire("acw62");

var $dOKmX = parcelRequire("dOKmX");
var /**
 * @ignore - internal component.
 */ $067c4bf610e93d98$export$2e2bcd8739ae039 = (0, $dOKmX.default)(/*#__PURE__*/ $acw62.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");



var $f9tk6 = parcelRequire("f9tk6");
var $2718107cc2429857$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $8nd05.default)({}, theme.typography.body2, {
            borderRadius: 16,
            textAlign: "center",
            boxSizing: "border-box",
            minWidth: 32,
            height: 32,
            padding: "0 6px",
            margin: "0 3px",
            color: theme.palette.text.primary
        }),
        /* Styles applied to the root element if `type="page"`. */ page: {
            transition: theme.transitions.create([
                "color",
                "background-color"
            ], {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$focusVisible": {
                backgroundColor: theme.palette.action.focus
            },
            "&$selected": {
                backgroundColor: theme.palette.action.selected,
                "&:hover, &$focusVisible": {
                    backgroundColor: (0, $9GbWv.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: theme.palette.action.selected
                    }
                },
                "&$disabled": {
                    opacity: 1,
                    color: theme.palette.action.disabled,
                    backgroundColor: theme.palette.action.selected
                }
            },
            "&$disabled": {
                opacity: theme.palette.action.disabledOpacity
            }
        },
        /* Styles applied applied to the root element if `size="small"`. */ sizeSmall: {
            minWidth: 26,
            height: 26,
            borderRadius: 13,
            margin: "0 1px",
            padding: "0 4px",
            "& $icon": {
                fontSize: theme.typography.pxToRem(18)
            }
        },
        /* Styles applied applied to the root element if `size="large"`. */ sizeLarge: {
            minWidth: 40,
            height: 40,
            borderRadius: 20,
            padding: "0 10px",
            fontSize: theme.typography.pxToRem(15),
            "& $icon": {
                fontSize: theme.typography.pxToRem(22)
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            "&$selected": {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.main,
                "&:hover, &$focusVisible": {
                    backgroundColor: theme.palette.primary.dark,
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: theme.palette.primary.main
                    }
                },
                "&$disabled": {
                    color: theme.palette.action.disabled
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            "&$selected": {
                color: theme.palette.secondary.contrastText,
                backgroundColor: theme.palette.secondary.main,
                "&:hover, &$focusVisible": {
                    backgroundColor: theme.palette.secondary.dark,
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: theme.palette.secondary.main
                    }
                },
                "&$disabled": {
                    color: theme.palette.action.disabled
                }
            }
        },
        /* Styles applied to the root element if `outlined="true"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
            "&$selected": {
                "&$disabled": {
                    border: "1px solid ".concat(theme.palette.action.disabledBackground)
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            "&$selected": {
                color: theme.palette.primary.main,
                border: "1px solid ".concat((0, $9GbWv.alpha)(theme.palette.primary.main, 0.5)),
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                "&:hover, &$focusVisible": {
                    backgroundColor: (0, $9GbWv.alpha)(theme.palette.primary.main, theme.palette.action.activatedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                },
                "&$disabled": {
                    color: theme.palette.action.disabled
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            "&$selected": {
                color: theme.palette.secondary.main,
                border: "1px solid ".concat((0, $9GbWv.alpha)(theme.palette.secondary.main, 0.5)),
                backgroundColor: (0, $9GbWv.alpha)(theme.palette.secondary.main, theme.palette.action.activatedOpacity),
                "&:hover, &$focusVisible": {
                    backgroundColor: (0, $9GbWv.alpha)(theme.palette.secondary.main, theme.palette.action.activatedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: "transparent"
                    }
                },
                "&$disabled": {
                    color: theme.palette.action.disabled
                }
            }
        },
        /* Styles applied to the root element if `rounded="true"`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `type="start-ellipsis"` or `type="end-ellipsis"`. */ ellipsis: {
            height: "auto",
            "&$disabled": {
                opacity: theme.palette.action.disabledOpacity
            }
        },
        /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the icon element. */ icon: {
            fontSize: theme.typography.pxToRem(20),
            margin: "0 -8px"
        }
    };
};
var $2718107cc2429857$var$PaginationItem = /*#__PURE__*/ $acw62.forwardRef(function PaginationItem(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "standard" : _props$color, component = props.component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, page = props.page, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, _props$shape = props.shape, shape = _props$shape === void 0 ? "round" : _props$shape, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$type = props.type, type = _props$type === void 0 ? "page" : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "page",
        "selected",
        "shape",
        "size",
        "type",
        "variant"
    ]);
    var theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    var normalizedIcons = theme.direction === "rtl" ? {
        previous: (0, $067c4bf610e93d98$export$2e2bcd8739ae039),
        next: (0, $bc39a99687471606$export$2e2bcd8739ae039),
        last: (0, $0fad356282c32f9a$export$2e2bcd8739ae039),
        first: (0, $8d5e3cc058c226df$export$2e2bcd8739ae039)
    } : {
        previous: (0, $bc39a99687471606$export$2e2bcd8739ae039),
        next: (0, $067c4bf610e93d98$export$2e2bcd8739ae039),
        first: (0, $0fad356282c32f9a$export$2e2bcd8739ae039),
        last: (0, $8d5e3cc058c226df$export$2e2bcd8739ae039)
    };
    var Icon = normalizedIcons[type];
    return type === "start-ellipsis" || type === "end-ellipsis" ? /*#__PURE__*/ $acw62.createElement("div", {
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, classes.ellipsis, disabled && classes.disabled, size !== "medium" && classes["size".concat((0, $f9tk6.default)(size))])
    }, "…") : /*#__PURE__*/ $acw62.createElement((0, $ac65ba7da5d490c4$export$2e2bcd8739ae039), (0, $8nd05.default)({
        ref: ref,
        component: component,
        disabled: disabled,
        focusVisibleClassName: classes.focusVisible,
        className: (0, $1SA7b.default)(classes.root, classes.page, classes[variant], classes[shape], className, color !== "standard" && classes["".concat(variant).concat((0, $f9tk6.default)(color))], disabled && classes.disabled, selected && classes.selected, size !== "medium" && classes["size".concat((0, $f9tk6.default)(size))])
    }, other), type === "page" && page, Icon ? /*#__PURE__*/ $acw62.createElement(Icon, {
        className: classes.icon
    }) : null);
});
var $2718107cc2429857$export$2e2bcd8739ae039 = (0, $kQaj4.default)($2718107cc2429857$export$9dd6ff9ea0189349, {
    name: "MuiPaginationItem"
})($2718107cc2429857$var$PaginationItem);


var $66c4a2f3f26c1685$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the ul element. */ ul: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        padding: 0,
        margin: 0,
        listStyle: "none"
    }
};
function $66c4a2f3f26c1685$var$defaultGetAriaLabel(type, page, selected) {
    if (type === "page") return "".concat(selected ? "" : "Go to ", "page ").concat(page);
    return "Go to ".concat(type, " page");
}
var $66c4a2f3f26c1685$var$Pagination = /*#__PURE__*/ $acw62.forwardRef(function Pagination(props, ref) {
    var boundaryCount = props.boundaryCount, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "standard" : _props$color, count = props.count, defaultPage = props.defaultPage, disabled = props.disabled, _props$getItemAriaLab = props.getItemAriaLabel, getItemAriaLabel = _props$getItemAriaLab === void 0 ? $66c4a2f3f26c1685$var$defaultGetAriaLabel : _props$getItemAriaLab, hideNextButton = props.hideNextButton, hidePrevButton = props.hidePrevButton, onChange = props.onChange, page = props.page, _props$renderItem = props.renderItem, renderItem = _props$renderItem === void 0 ? function(item) {
        return /*#__PURE__*/ $acw62.createElement((0, $2718107cc2429857$export$2e2bcd8739ae039), item);
    } : _props$renderItem, _props$shape = props.shape, shape = _props$shape === void 0 ? "round" : _props$shape, showFirstButton = props.showFirstButton, showLastButton = props.showLastButton, siblingCount = props.siblingCount, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, other = (0, $9X7IJ.default)(props, [
        "boundaryCount",
        "classes",
        "className",
        "color",
        "count",
        "defaultPage",
        "disabled",
        "getItemAriaLabel",
        "hideNextButton",
        "hidePrevButton",
        "onChange",
        "page",
        "renderItem",
        "shape",
        "showFirstButton",
        "showLastButton",
        "siblingCount",
        "size",
        "variant"
    ]);
    var _usePagination = (0, $7da8bb4b37cc88f8$export$2e2bcd8739ae039)((0, $8nd05.default)({}, props, {
        componentName: "Pagination"
    })), items = _usePagination.items;
    return /*#__PURE__*/ $acw62.createElement("nav", (0, $8nd05.default)({
        "aria-label": "pagination navigation",
        className: (0, $1SA7b.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $acw62.createElement("ul", {
        className: classes.ul
    }, items.map(function(item, index) {
        return /*#__PURE__*/ $acw62.createElement("li", {
            key: index
        }, renderItem((0, $8nd05.default)({}, item, {
            color: color,
            "aria-label": getItemAriaLabel(item.type, item.page, item.selected),
            shape: shape,
            size: size,
            variant: variant
        })));
    })));
}); // @default tags synced with default values from usePagination
var $66c4a2f3f26c1685$export$2e2bcd8739ae039 = (0, $kQaj4.default)($66c4a2f3f26c1685$export$9dd6ff9ea0189349, {
    name: "MuiPagination"
})($66c4a2f3f26c1685$var$Pagination);


const $d8e2136178c21777$var$AMAX_API_URL = "https://amax-emu.com/api";
const $d8e2136178c21777$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            margin: 15,
            width: 570,
            height: 636,
            /* Blue/700 (2 L) */ background: "#304254",
            /* Blue/600 */ border: "1px solid #3E5270",
            boxSizing: "border-box",
            borderRadius: 8
        },
        menuButton: {
            marginRight: theme.spacing(2)
        },
        title: {
            flexGrow: 1
        },
        spinner: {
            display: "flex",
            marginLeft: "calc(50% - 25px)",
            marginTop: "20px",
            "& > * + *": {
                marginLeft: theme.spacing(2)
            }
        },
        CustomIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24"
        },
        sswidget_container: {
            display: "inline-flex",
            flex: "0 1 auto",
            flexBasis: "33.33%",
            flexDirection: "column",
            flexWrap: "wrap",
            width: "33%",
            fontFamily: "Ubuntu",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "16px",
            lineHeight: "155%",
            marginTop: "1em",
            marginBottom: "1em",
            /* identical to box height, or 25px */ /* Blue / 50 */ color: "#92929F"
        },
        sswidget_icon_value: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            fontWeight: "bold",
            color: "#E6E6E6"
        },
        sswidgets_container: {
            display: "flex",
            maxWidth: "600px",
            maxHeight: "180px",
            flexWrap: "wrap",
            flexDirection: "column",
            margin: "1em"
        },
        pagination: {
            "& > *": {
                marginTop: theme.spacing(2)
            }
        }
    }));
function $d8e2136178c21777$export$2e2bcd8739ae039() {
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $d8e2136178c21777$var$useStyles();
    let history = (0, $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c)();
    const [pastRaceData, setPestRaceData] = $acw62.useState(undefined);
    const [gotDataFlag, setgotDataFlag] = $acw62.useState(false);
    const [NumOfRaces, SetNumOfRaces] = $acw62.useState(0);
    const [page, setPage] = $acw62.useState(Number((0, $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef)().pageNumber));
    const auth2 = async (page_value)=>{
        let additional_params = "?offset=" + (page_value - 1) * 10;
        const resp = await fetch($d8e2136178c21777$var$AMAX_API_URL + "/data/pastraces" + additional_params, {
            method: "GET",
            headers: {
                "content-type": "application/json;charset=UTF-8"
            }
        });
        setPestRaceData(await resp.json());
        setgotDataFlag(true);
    };
    const handleChange = (event, value)=>{
        setPage(value);
        handleChangeStep2(value);
    };
    function handleChangeStep2(page_value) {
        setgotDataFlag(false);
        history.push(`/past_races/${page_value}`);
        auth2(page_value).then(()=>{});
    }
    const RenderSessions = ()=>{
        if (gotDataFlag) return pastRaceData.data.map((session_data)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82845726a106878c$export$2e2bcd8739ae039), {
                data: session_data
            }));
        else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: classes.spinner,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a36c7122d0aec5cd$export$2e2bcd8739ae039), {})
        });
    };
    $acw62.useEffect(()=>{
        async function getServerData() {
            let additional_params = "?offset=" + (page - 1) * 10;
            const resp = await fetch($d8e2136178c21777$var$AMAX_API_URL + "/data/pastraces" + additional_params, {
                method: "GET",
                headers: {
                    "content-type": "application/json;charset=UTF-8"
                }
            });
            setPestRaceData(await resp.json());
            setgotDataFlag(true);
        }
        getServerData().catch(()=>{});
        async function getServerDataPages() {
            const resp = await fetch($d8e2136178c21777$var$AMAX_API_URL + "/data/total_races", {
                method: "GET",
                headers: {
                    "content-type": "application/json;charset=UTF-8"
                }
            });
            const r = await resp.json();
            SetNumOfRaces(r.data);
        }
        getServerDataPages().catch(()=>{});
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64d9a99297a346fe$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RenderSessions, {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: classes.pagination,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66c4a2f3f26c1685$export$2e2bcd8739ae039), {
                        count: Number((NumOfRaces / 10).toFixed()),
                        page: Number(page),
                        onChange: handleChange
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");















function $468bed3990f9253c$var$TabPanel(props) {
    const { children: children , value: value , index: index , ...other } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "tabpanel",
        hidden: value !== index,
        id: `full-width-tabpanel-${index}`,
        "aria-labelledby": `full-width-tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f71923faed635e4f$export$2e2bcd8739ae039), {
            p: 3,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                children: children
            })
        })
    });
}
function $468bed3990f9253c$var$a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`
    };
}
const $468bed3990f9253c$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>({
        root: {
            backgroundColor: "#304254",
            borderRadius: 8,
            margin: "13px 0px 15px 0px"
        },
        top: {
            borderRadius: "8px 8px 0px 0px"
        },
        tableHeader: {
            width: "100%"
        },
        container: {
            maxHeight: 440
        },
        widgetName: {
            alignSelf: "flex-start",
            fontStyle: "normal",
            fontWeight: "bold",
            fontSize: 32,
            lineHeight: "122%",
            color: "#E6E6E6"
        },
        CustomIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24"
        }
    }));
function $468bed3990f9253c$export$2e2bcd8739ae039() {
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const classes = $468bed3990f9253c$var$useStyles();
    const theme = (0, $8d81b008787777c3$export$2e2bcd8739ae039)();
    const [value, setValue] = $acw62.useState(0);
    const handleChange = (event, newValue)=>{
        setValue(newValue);
    };
    const handleChangeIndex = (index)=>{
        setValue(index);
    };
    const LeaderboardsFansContent = ()=>{};
    const columns = [
        {
            id: "pos",
            label: t("leaderboard_widget.position"),
            minWidth: 10,
            align: "left"
        },
        {
            id: "playername",
            label: t("leaderboard_widget.player"),
            minWidth: 100,
            align: "left"
        },
        {
            id: "value",
            label: t("leaderboard_widget.value"),
            minWidth: 10,
            align: "right"
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: classes.widgetName,
                    children: t("leaderboard_widget.header")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: classes.root,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $968e2cc4493acf64$export$2e2bcd8739ae039), {
                            className: classes.top,
                            position: "static",
                            color: "default",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6e5c13c2d64ec58c$export$2e2bcd8739ae039), {
                                    value: value,
                                    onChange: handleChange,
                                    indicatorColor: "primary",
                                    textColor: "primary",
                                    variant: "fullWidth",
                                    "aria-label": "full width tabs example",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0edc8e5721a6e65$export$2e2bcd8739ae039), {
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$919f9e6aad25b3cc), {}),
                                            label: t("leaderboard_widget.fans"),
                                            ...$468bed3990f9253c$var$a11yProps(0)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0edc8e5721a6e65$export$2e2bcd8739ae039), {
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$5a540ecc9c1f0346), {}),
                                            label: t("leaderboard_widget.driving_score"),
                                            ...$468bed3990f9253c$var$a11yProps(1)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0edc8e5721a6e65$export$2e2bcd8739ae039), {
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdd862b2a5201b09$export$d3e24e2ed1fd2185), {}),
                                            label: t("leaderboard_widget.legend"),
                                            ...$468bed3990f9253c$var$a11yProps(2)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b289f7d30c9e5e15$export$2e2bcd8739ae039), {
                                    className: classes.container,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e06e485673548dbd$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3d6bc8b29873e89$export$2e2bcd8739ae039), {
                                            className: classes.tableHeader,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $58a81d8428d1c8f8$export$2e2bcd8739ae039), {
                                                children: columns.map((column)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61094b1ba82ad225$export$2e2bcd8739ae039), {
                                                        align: column.align,
                                                        style: {
                                                            minWidth: column.minWidth
                                                        },
                                                        children: column.label
                                                    }, column.id))
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($468bed3990f9253c$var$TabPanel, {
                            value: value,
                            index: 0,
                            dir: theme.direction,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7e950fa58312d2$export$2e2bcd8739ae039), {
                                sortType: "statFans"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($468bed3990f9253c$var$TabPanel, {
                            value: value,
                            index: 1,
                            dir: theme.direction,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7e950fa58312d2$export$2e2bcd8739ae039), {
                                sortType: "statDriverScore"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($468bed3990f9253c$var$TabPanel, {
                            value: value,
                            index: 2,
                            dir: theme.direction,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d7e950fa58312d2$export$2e2bcd8739ae039), {
                                sortType: "statLegend"
                            })
                        })
                    ]
                })
            ]
        })
    });
}



parcelRequire("acw62");



parcelRequire("acw62");


var $f9f5dc634e34026a$exports = {};

$f9f5dc634e34026a$exports = new URL((parcelRequire("27Lyk")).resolve("bJzuT"), import.meta.url).toString();



const $139b1f126582e6d5$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>({
        logindiv: {
            maxWidth: "400px",
            height: "auto",
            position: "relative"
        },
        login_image: {
            maxWidth: "100%",
            maxHeight: "100%"
        }
    }));
function $139b1f126582e6d5$export$2e2bcd8739ae039() {
    const classes = $139b1f126582e6d5$var$useStyles();
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: classes.logindiv,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "typewriter_name",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    children: user?.userData?.amax_player_data?.stats?.playerName !== undefined ? user.userData?.amax_player_data.stats.playerName : "Login"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "typewriter_pass",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    children: "********"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: classes.login_image,
                src: (0, (/*@__PURE__*/$parcel$interopDefault($f9f5dc634e34026a$exports))),
                alt: "login window"
            })
        ]
    });
}



var $3554bd119fc561c0$exports = {};




$3554bd119fc561c0$exports = {
    "amax_client_files": $f0bde60858cc80ba$exports,
    "amax_emu_files": $c476d0d7c7475cd3$exports,
    "blur_update_files": $2c1faf3482cafcff$exports,
    "files_guide2": $a99bead6146b0b0f$exports
};







const $b6e5d701e5396e52$var$AMAX_API_URL = "https://amax-emu.com/api";
const $b6e5d701e5396e52$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>(0, $5dbed217b9b82c10$export$2e2bcd8739ae039)({
        root: {
            padding: "1em"
        },
        DiscordButton: {
            backgroundColor: "#7289DA"
        },
        DiscordIcon: {
            width: "24px",
            height: "24px",
            viewBox: "0 0 12 12"
        },
        stepHeader: {
            marginBottom: "0.1em"
        },
        listItem: {
            marginBottom: "4em"
        },
        list_container: {
            paddingLeft: "0",
            marginLeft: "15px",
            marginRight: "15px",
            listStylePosition: "outside",
            listStyleType: "decimal"
        },
        imgdiv: {
            maxWidth: "500px",
            height: "auto",
            position: "relative"
        },
        image_wrapper: {
            maxWidth: "100%",
            maxHeight: "100%"
        }
    }));
function $b6e5d701e5396e52$export$2e2bcd8739ae039() {
    const classes = $b6e5d701e5396e52$var$useStyles();
    const { t: t , i18n: i18n  } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64d9a99297a346fe$export$2e2bcd8739ae039), {
        style: {
            "marginBottom": "4em"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca4ada9c808bb355$export$2e2bcd8739ae039), {
            className: classes.root,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f763543f732472dc$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: t("how_to_play.header")
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                        className: classes.list_container,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: classes.stepHeader,
                                        children: t("how_to_play.login_step_header")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        children: t("how_to_play.login_step_text")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                                        href: $b6e5d701e5396e52$var$AMAX_API_URL + "/auth/login",
                                        className: classes.DiscordButton,
                                        disableElevation: true,
                                        endIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da84ea47bfe68d62$export$de73dc4d201c5f29), {}),
                                        children: t("appbar.login_discord")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: classes.stepHeader,
                                        children: t("how_to_play.create_amax_account_header")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        children: t("how_to_play.create_amax_account_text")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$b0d92dbee9b5b60d), {
                                        to: "/register",
                                        style: {
                                            color: "#92929F",
                                            textDecoration: "none"
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5212fe45b57eccf6$export$2e2bcd8739ae039), {
                                            color: "primary",
                                            variant: "contained",
                                            children: t("appbar.create_amax_account")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: classes.stepHeader,
                                        children: t("how_to_play.blur_download_step_header")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        children: t("how_to_play.blur_download_step_text")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: classes.stepHeader,
                                        children: t("how_to_play.patch_step_header")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        children: [
                                            t("how_to_play.patch_step_text1"),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: t("how_to_play.patch_step_text2")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef211fdc43fcfcba$export$2e2bcd8739ae039), {
                                            filename: "Blur_12.zip",
                                            size: "26M",
                                            link: "https://cs.amax-emu.com/blur_12.zip"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        children: t("how_to_play.patch_step_text3")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: classes.imgdiv,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                className: classes.image_wrapper,
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3554bd119fc561c0$exports)))["blur_update_files"],
                                                alt: "blur_update_files"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: classes.stepHeader,
                                        children: t("how_to_play.amax_emu_step_header")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        children: t("how_to_play.amax_emu_step_text")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef211fdc43fcfcba$export$2e2bcd8739ae039), {
                                            filename: "amax_client_files.zip",
                                            size: "1.4M",
                                            link: "https://cs.amax-emu.com/amax_client_files.zip"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: classes.imgdiv,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                className: classes.image_wrapper,
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3554bd119fc561c0$exports)))["amax_client_files"],
                                                alt: "amax_emu_files_prev"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: classes.stepHeader,
                                        children: t("how_to_play.amax_emu_login_step_header")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        children: t("how_to_play.amax_emu_login_step_text")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $139b1f126582e6d5$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: classes.stepHeader,
                                        children: t("how_to_play.play_step_header")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        children: t("how_to_play.play_step_text")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");







function $837556bdf75d281f$export$24c1f8f60cbac79e(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)("MuiTypography", slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $837556bdf75d281f$export$2e2bcd8739ae039 = $837556bdf75d281f$var$typographyClasses;



const $2531239e3a525689$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align , gutterBottom: gutterBottom , noWrap: noWrap , paragraph: paragraph , variant: variant , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $e7b578196486f177$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $837556bdf75d281f$export$24c1f8f60cbac79e), classes);
};
const $2531239e3a525689$export$140e2f5526d3cad8 = (0, $0277c5e26ff0d56c$export$2e2bcd8739ae039)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $e7b578196486f177$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $8nd05.default)({
        margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $2531239e3a525689$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $2531239e3a525689$var$transformDeprecatedColors = (color)=>{
    return $2531239e3a525689$var$colorTransformations[color] || color;
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $2531239e3a525689$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $c85eb76b78f8a14c$export$2e2bcd8739ae039)((0, $8nd05.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit" , className: className , component: component , gutterBottom: gutterBottom = false , noWrap: noWrap = false , paragraph: paragraph = false , variant: variant = "body1" , variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping  } = props, other = (0, $1En50.default)(props, $2531239e3a525689$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || "span";
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2531239e3a525689$export$140e2f5526d3cad8, (0, $8nd05.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $1SA7b.default)(classes.root, className)
    }, other));
});
var $2531239e3a525689$export$2e2bcd8739ae039 = $2531239e3a525689$var$Typography;



function $34475495d0f67324$export$2e2bcd8739ae039() {
    const auth = (0, $fa8bb1513e386061$export$650ce9f0b4df82fd)();
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    const history = (0, $2756f79476f0245f$export$719fc203c4e16dee)({
        forceRefresh: true
    });
    user.clearData();
    auth.signOut();
    //history.push("/Dashboard");
    $acw62.useEffect(()=>{
        setTimeout(()=>{
            history.push("/Dashboard");
        }, 1000);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                    children: "Successfully loged out!"
                })
            })
        })
    });
}


const $6840e8b44f75a905$var$AMAX_API_URL = "https://amax-emu.com/api";
const $6840e8b44f75a905$var$useStyles = (0, $682e8c99752ec43b$export$2e2bcd8739ae039)((theme)=>({
        root: {
            marginLeft: 0,
            [theme.breakpoints.up("sm")]: {
                marginLeft: 240,
                flexShrink: 0
            }
        }
    }));
function $6840e8b44f75a905$export$86fbec116b87613f() {
    const classes = $6840e8b44f75a905$var$useStyles();
    const auth = (0, $fa8bb1513e386061$export$650ce9f0b4df82fd)();
    const user = (0, $e0668e8a5168414a$export$f1ca3e4aa5b73d6d)();
    $acw62.useEffect(()=>{
        const auth2 = async ()=>{
            await auth.signIn();
        };
        const userdata2 = async ()=>{
            await user.getData();
        };
        auth2().then(()=>{});
        userdata2().then(()=>{});
    }, []);
    const theme = (0, $eOWQz.default)({
        palette: {
            type: "dark",
            background: {
                default: "#202A34",
                paper: "#2C3845"
            },
            primary: {
                main: "#3E5270"
            },
            secondary: {
                main: "#f44336"
            }
        }
    });
    // You cannot access hooks before initialization iirc
    // //
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4d79f8f47db109a9$export$2e2bcd8739ae039), {
        theme: theme,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb625d82dd03aa71$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3189c83282a9a1c6$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ea341b30b1c53fb$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: classes.root,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64d9a99297a346fe$export$2e2bcd8739ae039), {
                                disableGutters: true,
                                maxWidth: "xl",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/",
                                            component: (0, $65c9201c81d680dd$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/user",
                                            component: (0, $4f0ef7a7899ea494$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/log_out",
                                            component: (0, $34475495d0f67324$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/discord",
                                            component: (0, $bdbc953dcbe2c506$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/discord_auth",
                                            component: (0, $bdbc953dcbe2c506$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/sessions",
                                            component: (0, $1826d868b59c435c$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/status_test",
                                            component: (0, $2a981844268212c5$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/leaderboards",
                                            component: (0, $468bed3990f9253c$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/Dashboard",
                                            component: (0, $65c9201c81d680dd$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/news",
                                            component: (0, $1b998fd34bcc6954$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/register",
                                            component: (0, $36a30b5161d9a218$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/final_steps",
                                            component: (0, $c2d6b39f66b06862$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            path: "/how_to_play",
                                            component: (0, $b6e5d701e5396e52$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/profile/:profileName",
                                            component: (0, $5638eaa31046f90d$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/profile",
                                            component: (0, $d557fad28d4cae81$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/past_races",
                                            component: (0, $d8e2136178c21777$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6), {
                                            exact: true,
                                            path: "/past_races/:pageNumber",
                                            component: (0, $d8e2136178c21777$export$2e2bcd8739ae039)
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}


(0, $11492dca620dcaa5$exports.render)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6840e8b44f75a905$export$86fbec116b87613f), {}), document.getElementById("root"));


//# sourceMappingURL=index.03e8d1b4.js.map
